/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 56);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(59);
} else {
  module.exports = require('./cjs/react.development.js');
}


/***/ }),
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process, module) {/* unused harmony export createGlobalStyle */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return css; });
/* unused harmony export isStyledComponent */
/* unused harmony export keyframes */
/* unused harmony export ServerStyleSheet */
/* unused harmony export StyleSheetConsumer */
/* unused harmony export StyleSheetContext */
/* unused harmony export StyleSheetManager */
/* unused harmony export ThemeConsumer */
/* unused harmony export ThemeContext */
/* unused harmony export ThemeProvider */
/* unused harmony export withTheme */
/* unused harmony export __DO_NOT_USE_OR_YOU_WILL_BE_HAUNTED_BY_SPOOKY_GHOSTS */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_stylis_stylis_min__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_stylis_stylis_min___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_stylis_stylis_min__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_stylis_rule_sheet__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_stylis_rule_sheet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_stylis_rule_sheet__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__emotion_unitless__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_is__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_is___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_is__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_memoize_one__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__emotion_is_prop_valid__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_merge_anything__ = __webpack_require__(110);










// 

var interleave = (function (strings, interpolations) {
  var result = [strings[0]];

  for (var i = 0, len = interpolations.length; i < len; i += 1) {
    result.push(interpolations[i], strings[i + 1]);
  }

  return result;
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};

var objectWithoutProperties = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

// 
var isPlainObject = (function (x) {
  return (typeof x === 'undefined' ? 'undefined' : _typeof(x)) === 'object' && x.constructor === Object;
});

// 
var EMPTY_ARRAY = Object.freeze([]);
var EMPTY_OBJECT = Object.freeze({});

// 
function isFunction(test) {
  return typeof test === 'function';
}

// 

function getComponentName(target) {
  return ( false ? typeof target === 'string' && target : false) || target.displayName || target.name || 'Component';
}

// 
function isStatelessFunction(test) {
  return typeof test === 'function' && !(test.prototype && test.prototype.isReactComponent);
}

// 
function isStyledComponent(target) {
  return target && typeof target.styledComponentId === 'string';
}

// 

var SC_ATTR = typeof process !== 'undefined' && (Object({"NODE_ENV":"production","PUBLIC_URL":""}).REACT_APP_SC_ATTR || Object({"NODE_ENV":"production","PUBLIC_URL":""}).SC_ATTR) || 'data-styled';

var SC_VERSION_ATTR = 'data-styled-version';

var SC_STREAM_ATTR = 'data-styled-streamed';

var IS_BROWSER = typeof window !== 'undefined' && 'HTMLElement' in window;

var DISABLE_SPEEDY = typeof SC_DISABLE_SPEEDY === 'boolean' && SC_DISABLE_SPEEDY || typeof process !== 'undefined' && (Object({"NODE_ENV":"production","PUBLIC_URL":""}).REACT_APP_SC_DISABLE_SPEEDY || Object({"NODE_ENV":"production","PUBLIC_URL":""}).SC_DISABLE_SPEEDY) || "production" !== 'production';

// Shared empty execution context when generating static styles
var STATIC_EXECUTION_CONTEXT = {};

// 


/**
 * Parse errors.md and turn it into a simple hash of code: message
 */
var ERRORS =  false ? {
  "1": "Cannot create styled-component for component: %s.\n\n",
  "2": "Can't collect styles once you've consumed a `ServerStyleSheet`'s styles! `ServerStyleSheet` is a one off instance for each server-side render cycle.\n\n- Are you trying to reuse it across renders?\n- Are you accidentally calling collectStyles twice?\n\n",
  "3": "Streaming SSR is only supported in a Node.js environment; Please do not try to call this method in the browser.\n\n",
  "4": "The `StyleSheetManager` expects a valid target or sheet prop!\n\n- Does this error occur on the client and is your target falsy?\n- Does this error occur on the server and is the sheet falsy?\n\n",
  "5": "The clone method cannot be used on the client!\n\n- Are you running in a client-like environment on the server?\n- Are you trying to run SSR on the client?\n\n",
  "6": "Trying to insert a new style tag, but the given Node is unmounted!\n\n- Are you using a custom target that isn't mounted?\n- Does your document not have a valid head element?\n- Have you accidentally removed a style tag manually?\n\n",
  "7": "ThemeProvider: Please return an object from your \"theme\" prop function, e.g.\n\n```js\ntheme={() => ({})}\n```\n\n",
  "8": "ThemeProvider: Please make your \"theme\" prop an object.\n\n",
  "9": "Missing document `<head>`\n\n",
  "10": "Cannot find a StyleSheet instance. Usually this happens if there are multiple copies of styled-components loaded at once. Check out this issue for how to troubleshoot and fix the common cases where this situation can happen: https://github.com/styled-components/styled-components/issues/1941#issuecomment-417862021\n\n",
  "11": "_This error was replaced with a dev-time warning, it will be deleted for v4 final._ [createGlobalStyle] received children which will not be rendered. Please use the component without passing children elements.\n\n",
  "12": "It seems you are interpolating a keyframe declaration (%s) into an untagged string. This was supported in styled-components v3, but is not longer supported in v4 as keyframes are now injected on-demand. Please wrap your string in the css\\`\\` helper (see https://www.styled-components.com/docs/api#css), which ensures the styles are injected correctly.\n\n",
  "13": "%s is not a styled component and cannot be referred to via component selector. See https://www.styled-components.com/docs/advanced#referring-to-other-components for more details.\n"
} : {};

/**
 * super basic version of sprintf
 */
function format() {
  var a = arguments.length <= 0 ? undefined : arguments[0];
  var b = [];

  for (var c = 1, len = arguments.length; c < len; c += 1) {
    b.push(arguments.length <= c ? undefined : arguments[c]);
  }

  b.forEach(function (d) {
    a = a.replace(/%[a-z]/, d);
  });

  return a;
}

/**
 * Create an error file out of errors.md for development and a simple web link to the full errors
 * in production mode.
 */

var StyledComponentsError = function (_Error) {
  inherits(StyledComponentsError, _Error);

  function StyledComponentsError(code) {
    classCallCheck(this, StyledComponentsError);

    for (var _len = arguments.length, interpolations = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      interpolations[_key - 1] = arguments[_key];
    }

    if (true) {
      var _this = possibleConstructorReturn(this, _Error.call(this, 'An error occurred. See https://github.com/styled-components/styled-components/blob/master/packages/styled-components/src/utils/errors.md#' + code + ' for more information.' + (interpolations.length > 0 ? ' Additional arguments: ' + interpolations.join(', ') : '')));
    } else {
      var _this = possibleConstructorReturn(this, _Error.call(this, format.apply(undefined, [ERRORS[code]].concat(interpolations)).trim()));
    }
    return possibleConstructorReturn(_this);
  }

  return StyledComponentsError;
}(Error);

// 
var SC_COMPONENT_ID = /^[^\S\n]*?\/\* sc-component-id:\s*(\S+)\s+\*\//gm;

var extractComps = (function (maybeCSS) {
  var css = '' + (maybeCSS || ''); // Definitely a string, and a clone
  var existingComponents = [];
  css.replace(SC_COMPONENT_ID, function (match, componentId, matchIndex) {
    existingComponents.push({ componentId: componentId, matchIndex: matchIndex });
    return match;
  });
  return existingComponents.map(function (_ref, i) {
    var componentId = _ref.componentId,
        matchIndex = _ref.matchIndex;

    var nextComp = existingComponents[i + 1];
    var cssFromDOM = nextComp ? css.slice(matchIndex, nextComp.matchIndex) : css.slice(matchIndex);
    return { componentId: componentId, cssFromDOM: cssFromDOM };
  });
});

// 

var COMMENT_REGEX = /^\s*\/\/.*$/gm;

// NOTE: This stylis instance is only used to split rules from SSR'd style tags
var stylisSplitter = new __WEBPACK_IMPORTED_MODULE_0_stylis_stylis_min___default.a({
  global: false,
  cascade: true,
  keyframe: false,
  prefix: false,
  compress: false,
  semicolon: true
});

var stylis = new __WEBPACK_IMPORTED_MODULE_0_stylis_stylis_min___default.a({
  global: false,
  cascade: true,
  keyframe: false,
  prefix: true,
  compress: false,
  semicolon: false // NOTE: This means "autocomplete missing semicolons"
});

// Wrap `insertRulePlugin to build a list of rules,
// and then make our own plugin to return the rules. This
// makes it easier to hook into the existing SSR architecture

var parsingRules = [];

// eslint-disable-next-line consistent-return
var returnRulesPlugin = function returnRulesPlugin(context) {
  if (context === -2) {
    var parsedRules = parsingRules;
    parsingRules = [];
    return parsedRules;
  }
};

var parseRulesPlugin = __WEBPACK_IMPORTED_MODULE_1_stylis_rule_sheet___default()(function (rule) {
  parsingRules.push(rule);
});

var _componentId = void 0;
var _selector = void 0;
var _selectorRegexp = void 0;

var selfReferenceReplacer = function selfReferenceReplacer(match, offset, string) {
  if (
  // the first self-ref is always untouched
  offset > 0 &&
  // there should be at least two self-refs to do a replacement (.b > .b)
  string.slice(0, offset).indexOf(_selector) !== -1 &&
  // no consecutive self refs (.b.b); that is a precedence boost and treated differently
  string.slice(offset - _selector.length, offset) !== _selector) {
    return '.' + _componentId;
  }

  return match;
};

/**
 * When writing a style like
 *
 * & + & {
 *   color: red;
 * }
 *
 * The second ampersand should be a reference to the static component class. stylis
 * has no knowledge of static class so we have to intelligently replace the base selector.
 */
var selfReferenceReplacementPlugin = function selfReferenceReplacementPlugin(context, _, selectors) {
  if (context === 2 && selectors.length && selectors[0].lastIndexOf(_selector) > 0) {
    // eslint-disable-next-line no-param-reassign
    selectors[0] = selectors[0].replace(_selectorRegexp, selfReferenceReplacer);
  }
};

stylis.use([selfReferenceReplacementPlugin, parseRulesPlugin, returnRulesPlugin]);
stylisSplitter.use([parseRulesPlugin, returnRulesPlugin]);

var splitByRules = function splitByRules(css) {
  return stylisSplitter('', css);
};

function stringifyRules(rules, selector, prefix) {
  var componentId = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '&';

  var flatCSS = rules.join('').replace(COMMENT_REGEX, ''); // replace JS comments

  var cssStr = selector && prefix ? prefix + ' ' + selector + ' { ' + flatCSS + ' }' : flatCSS;

  // stylis has no concept of state to be passed to plugins
  // but since JS is single=threaded, we can rely on that to ensure
  // these properties stay in sync with the current stylis run
  _componentId = componentId;
  _selector = selector;
  _selectorRegexp = new RegExp('\\' + _selector + '\\b', 'g');

  return stylis(prefix || !selector ? '' : selector, cssStr);
}

// 
/* eslint-disable camelcase, no-undef */

var getNonce = (function () {
  return  true ? __webpack_require__.nc : null;
});

// 
/* These are helpers for the StyleTags to keep track of the injected
 * rule names for each (component) ID that they're keeping track of.
 * They're crucial for detecting whether a name has already been
 * injected.
 * (This excludes rehydrated names) */

/* adds a new ID:name pairing to a names dictionary */
var addNameForId = function addNameForId(names, id, name) {
  if (name) {
    // eslint-disable-next-line no-param-reassign
    var namesForId = names[id] || (names[id] = Object.create(null));
    namesForId[name] = true;
  }
};

/* resets an ID entirely by overwriting it in the dictionary */
var resetIdNames = function resetIdNames(names, id) {
  // eslint-disable-next-line no-param-reassign
  names[id] = Object.create(null);
};

/* factory for a names dictionary checking the existance of an ID:name pairing */
var hasNameForId = function hasNameForId(names) {
  return function (id, name) {
    return names[id] !== undefined && names[id][name];
  };
};

/* stringifies names for the html/element output */
var stringifyNames = function stringifyNames(names) {
  var str = '';
  // eslint-disable-next-line guard-for-in
  for (var id in names) {
    str += Object.keys(names[id]).join(' ') + ' ';
  }
  return str.trim();
};

/* clones the nested names dictionary */
var cloneNames = function cloneNames(names) {
  var clone = Object.create(null);
  // eslint-disable-next-line guard-for-in
  for (var id in names) {
    clone[id] = _extends({}, names[id]);
  }
  return clone;
};

// 

/* These are helpers that deal with the insertRule (aka speedy) API
 * They are used in the StyleTags and specifically the speedy tag
 */

/* retrieve a sheet for a given style tag */
var sheetForTag = function sheetForTag(tag) {
  // $FlowFixMe
  if (tag.sheet) return tag.sheet;

  /* Firefox quirk requires us to step through all stylesheets to find one owned by the given tag */
  var size = document.styleSheets.length;
  for (var i = 0; i < size; i += 1) {
    var sheet = document.styleSheets[i];
    // $FlowFixMe
    if (sheet.ownerNode === tag) return sheet;
  }

  /* we should always be able to find a tag */
  throw new StyledComponentsError(10);
};

/* insert a rule safely and return whether it was actually injected */
var safeInsertRule = function safeInsertRule(sheet, cssRule, index) {
  /* abort early if cssRule string is falsy */
  if (!cssRule) return false;

  var maxIndex = sheet.cssRules.length;

  try {
    /* use insertRule and cap passed index with maxIndex (no of cssRules) */
    sheet.insertRule(cssRule, index <= maxIndex ? index : maxIndex);
  } catch (err) {
    /* any error indicates an invalid rule */
    return false;
  }

  return true;
};

/* deletes `size` rules starting from `removalIndex` */
var deleteRules = function deleteRules(sheet, removalIndex, size) {
  var lowerBound = removalIndex - size;
  for (var i = removalIndex; i > lowerBound; i -= 1) {
    sheet.deleteRule(i);
  }
};

// 

/* this marker separates component styles and is important for rehydration */
var makeTextMarker = function makeTextMarker(id) {
  return '\n/* sc-component-id: ' + id + ' */\n';
};

/* add up all numbers in array up until and including the index */
var addUpUntilIndex = function addUpUntilIndex(sizes, index) {
  var totalUpToIndex = 0;
  for (var i = 0; i <= index; i += 1) {
    totalUpToIndex += sizes[i];
  }

  return totalUpToIndex;
};

/* create a new style tag after lastEl */
var makeStyleTag = function makeStyleTag(target, tagEl, insertBefore) {
  var el = document.createElement('style');
  el.setAttribute(SC_ATTR, '');
  el.setAttribute(SC_VERSION_ATTR, "4.3.2");

  var nonce = getNonce();
  if (nonce) {
    el.setAttribute('nonce', nonce);
  }

  /* Work around insertRule quirk in EdgeHTML */
  el.appendChild(document.createTextNode(''));

  if (target && !tagEl) {
    /* Append to target when no previous element was passed */
    target.appendChild(el);
  } else {
    if (!tagEl || !target || !tagEl.parentNode) {
      throw new StyledComponentsError(6);
    }

    /* Insert new style tag after the previous one */
    tagEl.parentNode.insertBefore(el, insertBefore ? tagEl : tagEl.nextSibling);
  }

  return el;
};

/* takes a css factory function and outputs an html styled tag factory */
var wrapAsHtmlTag = function wrapAsHtmlTag(css, names) {
  return function (additionalAttrs) {
    var nonce = getNonce();
    var attrs = [nonce && 'nonce="' + nonce + '"', SC_ATTR + '="' + stringifyNames(names) + '"', SC_VERSION_ATTR + '="' + "4.3.2" + '"', additionalAttrs];

    var htmlAttr = attrs.filter(Boolean).join(' ');
    return '<style ' + htmlAttr + '>' + css() + '</style>';
  };
};

/* takes a css factory function and outputs an element factory */
var wrapAsElement = function wrapAsElement(css, names) {
  return function () {
    var _props;

    var props = (_props = {}, _props[SC_ATTR] = stringifyNames(names), _props[SC_VERSION_ATTR] = "4.3.2", _props);

    var nonce = getNonce();
    if (nonce) {
      // $FlowFixMe
      props.nonce = nonce;
    }

    // eslint-disable-next-line react/no-danger
    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('style', _extends({}, props, { dangerouslySetInnerHTML: { __html: css() } }));
  };
};

var getIdsFromMarkersFactory = function getIdsFromMarkersFactory(markers) {
  return function () {
    return Object.keys(markers);
  };
};

/* speedy tags utilise insertRule */
var makeSpeedyTag = function makeSpeedyTag(el, getImportRuleTag) {
  var names = Object.create(null);
  var markers = Object.create(null);
  var sizes = [];

  var extractImport = getImportRuleTag !== undefined;
  /* indicates whether getImportRuleTag was called */
  var usedImportRuleTag = false;

  var insertMarker = function insertMarker(id) {
    var prev = markers[id];
    if (prev !== undefined) {
      return prev;
    }

    markers[id] = sizes.length;
    sizes.push(0);
    resetIdNames(names, id);

    return markers[id];
  };

  var insertRules = function insertRules(id, cssRules, name) {
    var marker = insertMarker(id);
    var sheet = sheetForTag(el);
    var insertIndex = addUpUntilIndex(sizes, marker);

    var injectedRules = 0;
    var importRules = [];
    var cssRulesSize = cssRules.length;

    for (var i = 0; i < cssRulesSize; i += 1) {
      var cssRule = cssRules[i];
      var mayHaveImport = extractImport; /* @import rules are reordered to appear first */
      if (mayHaveImport && cssRule.indexOf('@import') !== -1) {
        importRules.push(cssRule);
      } else if (safeInsertRule(sheet, cssRule, insertIndex + injectedRules)) {
        mayHaveImport = false;
        injectedRules += 1;
      }
    }

    if (extractImport && importRules.length > 0) {
      usedImportRuleTag = true;
      // $FlowFixMe
      getImportRuleTag().insertRules(id + '-import', importRules);
    }

    sizes[marker] += injectedRules; /* add up no of injected rules */
    addNameForId(names, id, name);
  };

  var removeRules = function removeRules(id) {
    var marker = markers[id];
    if (marker === undefined) return;

    var size = sizes[marker];
    var sheet = sheetForTag(el);
    var removalIndex = addUpUntilIndex(sizes, marker) - 1;
    deleteRules(sheet, removalIndex, size);
    sizes[marker] = 0;
    resetIdNames(names, id);

    if (extractImport && usedImportRuleTag) {
      // $FlowFixMe
      getImportRuleTag().removeRules(id + '-import');
    }
  };

  var css = function css() {
    var _sheetForTag = sheetForTag(el),
        cssRules = _sheetForTag.cssRules;

    var str = '';

    // eslint-disable-next-line guard-for-in
    for (var id in markers) {
      str += makeTextMarker(id);
      var marker = markers[id];
      var end = addUpUntilIndex(sizes, marker);
      var size = sizes[marker];
      for (var i = end - size; i < end; i += 1) {
        var rule = cssRules[i];
        if (rule !== undefined) {
          str += rule.cssText;
        }
      }
    }

    return str;
  };

  return {
    clone: function clone() {
      throw new StyledComponentsError(5);
    },

    css: css,
    getIds: getIdsFromMarkersFactory(markers),
    hasNameForId: hasNameForId(names),
    insertMarker: insertMarker,
    insertRules: insertRules,
    removeRules: removeRules,
    sealed: false,
    styleTag: el,
    toElement: wrapAsElement(css, names),
    toHTML: wrapAsHtmlTag(css, names)
  };
};

var makeTextNode = function makeTextNode(id) {
  return document.createTextNode(makeTextMarker(id));
};

var makeBrowserTag = function makeBrowserTag(el, getImportRuleTag) {
  var names = Object.create(null);
  var markers = Object.create(null);

  var extractImport = getImportRuleTag !== undefined;

  /* indicates whether getImportRuleTag was called */
  var usedImportRuleTag = false;

  var insertMarker = function insertMarker(id) {
    var prev = markers[id];
    if (prev !== undefined) {
      return prev;
    }

    markers[id] = makeTextNode(id);
    el.appendChild(markers[id]);
    names[id] = Object.create(null);

    return markers[id];
  };

  var insertRules = function insertRules(id, cssRules, name) {
    var marker = insertMarker(id);
    var importRules = [];
    var cssRulesSize = cssRules.length;

    for (var i = 0; i < cssRulesSize; i += 1) {
      var rule = cssRules[i];
      var mayHaveImport = extractImport;
      if (mayHaveImport && rule.indexOf('@import') !== -1) {
        importRules.push(rule);
      } else {
        mayHaveImport = false;
        var separator = i === cssRulesSize - 1 ? '' : ' ';
        marker.appendData('' + rule + separator);
      }
    }

    addNameForId(names, id, name);

    if (extractImport && importRules.length > 0) {
      usedImportRuleTag = true;
      // $FlowFixMe
      getImportRuleTag().insertRules(id + '-import', importRules);
    }
  };

  var removeRules = function removeRules(id) {
    var marker = markers[id];
    if (marker === undefined) return;

    /* create new empty text node and replace the current one */
    var newMarker = makeTextNode(id);
    el.replaceChild(newMarker, marker);
    markers[id] = newMarker;
    resetIdNames(names, id);

    if (extractImport && usedImportRuleTag) {
      // $FlowFixMe
      getImportRuleTag().removeRules(id + '-import');
    }
  };

  var css = function css() {
    var str = '';

    // eslint-disable-next-line guard-for-in
    for (var id in markers) {
      str += markers[id].data;
    }

    return str;
  };

  return {
    clone: function clone() {
      throw new StyledComponentsError(5);
    },

    css: css,
    getIds: getIdsFromMarkersFactory(markers),
    hasNameForId: hasNameForId(names),
    insertMarker: insertMarker,
    insertRules: insertRules,
    removeRules: removeRules,
    sealed: false,
    styleTag: el,
    toElement: wrapAsElement(css, names),
    toHTML: wrapAsHtmlTag(css, names)
  };
};

var makeServerTag = function makeServerTag(namesArg, markersArg) {
  var names = namesArg === undefined ? Object.create(null) : namesArg;
  var markers = markersArg === undefined ? Object.create(null) : markersArg;

  var insertMarker = function insertMarker(id) {
    var prev = markers[id];
    if (prev !== undefined) {
      return prev;
    }

    return markers[id] = [''];
  };

  var insertRules = function insertRules(id, cssRules, name) {
    var marker = insertMarker(id);
    marker[0] += cssRules.join(' ');
    addNameForId(names, id, name);
  };

  var removeRules = function removeRules(id) {
    var marker = markers[id];
    if (marker === undefined) return;
    marker[0] = '';
    resetIdNames(names, id);
  };

  var css = function css() {
    var str = '';
    // eslint-disable-next-line guard-for-in
    for (var id in markers) {
      var cssForId = markers[id][0];
      if (cssForId) {
        str += makeTextMarker(id) + cssForId;
      }
    }
    return str;
  };

  var clone = function clone() {
    var namesClone = cloneNames(names);
    var markersClone = Object.create(null);

    // eslint-disable-next-line guard-for-in
    for (var id in markers) {
      markersClone[id] = [markers[id][0]];
    }

    return makeServerTag(namesClone, markersClone);
  };

  var tag = {
    clone: clone,
    css: css,
    getIds: getIdsFromMarkersFactory(markers),
    hasNameForId: hasNameForId(names),
    insertMarker: insertMarker,
    insertRules: insertRules,
    removeRules: removeRules,
    sealed: false,
    styleTag: null,
    toElement: wrapAsElement(css, names),
    toHTML: wrapAsHtmlTag(css, names)
  };

  return tag;
};

var makeTag = function makeTag(target, tagEl, forceServer, insertBefore, getImportRuleTag) {
  if (IS_BROWSER && !forceServer) {
    var el = makeStyleTag(target, tagEl, insertBefore);

    if (DISABLE_SPEEDY) {
      return makeBrowserTag(el, getImportRuleTag);
    } else {
      return makeSpeedyTag(el, getImportRuleTag);
    }
  }

  return makeServerTag();
};

var rehydrate = function rehydrate(tag, els, extracted) {
  /* add all extracted components to the new tag */
  for (var i = 0, len = extracted.length; i < len; i += 1) {
    var _extracted$i = extracted[i],
        componentId = _extracted$i.componentId,
        cssFromDOM = _extracted$i.cssFromDOM;

    var cssRules = splitByRules(cssFromDOM);
    tag.insertRules(componentId, cssRules);
  }

  /* remove old HTMLStyleElements, since they have been rehydrated */
  for (var _i = 0, _len = els.length; _i < _len; _i += 1) {
    var el = els[_i];
    if (el.parentNode) {
      el.parentNode.removeChild(el);
    }
  }
};

// 

var SPLIT_REGEX = /\s+/;

/* determine the maximum number of components before tags are sharded */
var MAX_SIZE = void 0;
if (IS_BROWSER) {
  /* in speedy mode we can keep a lot more rules in a sheet before a slowdown can be expected */
  MAX_SIZE = DISABLE_SPEEDY ? 40 : 1000;
} else {
  /* for servers we do not need to shard at all */
  MAX_SIZE = -1;
}

var sheetRunningId = 0;
var master = void 0;

var StyleSheet = function () {

  /* a map from ids to tags */

  /* deferred rules for a given id */

  /* this is used for not reinjecting rules via hasNameForId() */

  /* when rules for an id are removed using remove() we have to ignore rehydratedNames for it */

  /* a list of tags belonging to this StyleSheet */

  /* a tag for import rules */

  /* current capacity until a new tag must be created */

  /* children (aka clones) of this StyleSheet inheriting all and future injections */

  function StyleSheet() {
    var _this = this;

    var target = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : IS_BROWSER ? document.head : null;
    var forceServer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    classCallCheck(this, StyleSheet);

    this.getImportRuleTag = function () {
      var importRuleTag = _this.importRuleTag;

      if (importRuleTag !== undefined) {
        return importRuleTag;
      }

      var firstTag = _this.tags[0];
      var insertBefore = true;

      return _this.importRuleTag = makeTag(_this.target, firstTag ? firstTag.styleTag : null, _this.forceServer, insertBefore);
    };

    sheetRunningId += 1;
    this.id = sheetRunningId;
    this.forceServer = forceServer;
    this.target = forceServer ? null : target;
    this.tagMap = {};
    this.deferred = {};
    this.rehydratedNames = {};
    this.ignoreRehydratedNames = {};
    this.tags = [];
    this.capacity = 1;
    this.clones = [];
  }

  /* rehydrate all SSR'd style tags */


  StyleSheet.prototype.rehydrate = function rehydrate$$1() {
    if (!IS_BROWSER || this.forceServer) return this;

    var els = [];
    var extracted = [];
    var isStreamed = false;

    /* retrieve all of our SSR style elements from the DOM */
    var nodes = document.querySelectorAll('style[' + SC_ATTR + '][' + SC_VERSION_ATTR + '="' + "4.3.2" + '"]');

    var nodesSize = nodes.length;

    /* abort rehydration if no previous style tags were found */
    if (!nodesSize) return this;

    for (var i = 0; i < nodesSize; i += 1) {
      var el = nodes[i];

      /* check if style tag is a streamed tag */
      if (!isStreamed) isStreamed = !!el.getAttribute(SC_STREAM_ATTR);

      /* retrieve all component names */
      var elNames = (el.getAttribute(SC_ATTR) || '').trim().split(SPLIT_REGEX);
      var elNamesSize = elNames.length;
      for (var j = 0, name; j < elNamesSize; j += 1) {
        name = elNames[j];
        /* add rehydrated name to sheet to avoid re-adding styles */
        this.rehydratedNames[name] = true;
      }

      /* extract all components and their CSS */
      extracted.push.apply(extracted, extractComps(el.textContent));

      /* store original HTMLStyleElement */
      els.push(el);
    }

    /* abort rehydration if nothing was extracted */
    var extractedSize = extracted.length;
    if (!extractedSize) return this;

    /* create a tag to be used for rehydration */
    var tag = this.makeTag(null);

    rehydrate(tag, els, extracted);

    /* reset capacity and adjust MAX_SIZE by the initial size of the rehydration */
    this.capacity = Math.max(1, MAX_SIZE - extractedSize);
    this.tags.push(tag);

    /* retrieve all component ids */
    for (var _j = 0; _j < extractedSize; _j += 1) {
      this.tagMap[extracted[_j].componentId] = tag;
    }

    return this;
  };

  /* retrieve a "master" instance of StyleSheet which is typically used when no other is available
   * The master StyleSheet is targeted by createGlobalStyle, keyframes, and components outside of any
    * StyleSheetManager's context */


  /* reset the internal "master" instance */
  StyleSheet.reset = function reset() {
    var forceServer = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    master = new StyleSheet(undefined, forceServer).rehydrate();
  };

  /* adds "children" to the StyleSheet that inherit all of the parents' rules
   * while their own rules do not affect the parent */


  StyleSheet.prototype.clone = function clone() {
    var sheet = new StyleSheet(this.target, this.forceServer);

    /* add to clone array */
    this.clones.push(sheet);

    /* clone all tags */
    sheet.tags = this.tags.map(function (tag) {
      var ids = tag.getIds();
      var newTag = tag.clone();

      /* reconstruct tagMap */
      for (var i = 0; i < ids.length; i += 1) {
        sheet.tagMap[ids[i]] = newTag;
      }

      return newTag;
    });

    /* clone other maps */
    sheet.rehydratedNames = _extends({}, this.rehydratedNames);
    sheet.deferred = _extends({}, this.deferred);

    return sheet;
  };

  /* force StyleSheet to create a new tag on the next injection */


  StyleSheet.prototype.sealAllTags = function sealAllTags() {
    this.capacity = 1;

    this.tags.forEach(function (tag) {
      // eslint-disable-next-line no-param-reassign
      tag.sealed = true;
    });
  };

  StyleSheet.prototype.makeTag = function makeTag$$1(tag) {
    var lastEl = tag ? tag.styleTag : null;
    var insertBefore = false;

    return makeTag(this.target, lastEl, this.forceServer, insertBefore, this.getImportRuleTag);
  };

  /* get a tag for a given componentId, assign the componentId to one, or shard */
  StyleSheet.prototype.getTagForId = function getTagForId(id) {
    /* simply return a tag, when the componentId was already assigned one */
    var prev = this.tagMap[id];
    if (prev !== undefined && !prev.sealed) {
      return prev;
    }

    var tag = this.tags[this.tags.length - 1];

    /* shard (create a new tag) if the tag is exhausted (See MAX_SIZE) */
    this.capacity -= 1;

    if (this.capacity === 0) {
      this.capacity = MAX_SIZE;
      tag = this.makeTag(tag);
      this.tags.push(tag);
    }

    return this.tagMap[id] = tag;
  };

  /* mainly for createGlobalStyle to check for its id */


  StyleSheet.prototype.hasId = function hasId(id) {
    return this.tagMap[id] !== undefined;
  };

  /* caching layer checking id+name to already have a corresponding tag and injected rules */


  StyleSheet.prototype.hasNameForId = function hasNameForId(id, name) {
    /* exception for rehydrated names which are checked separately */
    if (this.ignoreRehydratedNames[id] === undefined && this.rehydratedNames[name]) {
      return true;
    }

    var tag = this.tagMap[id];
    return tag !== undefined && tag.hasNameForId(id, name);
  };

  /* registers a componentId and registers it on its tag */


  StyleSheet.prototype.deferredInject = function deferredInject(id, cssRules) {
    /* don't inject when the id is already registered */
    if (this.tagMap[id] !== undefined) return;

    var clones = this.clones;

    for (var i = 0; i < clones.length; i += 1) {
      clones[i].deferredInject(id, cssRules);
    }

    this.getTagForId(id).insertMarker(id);
    this.deferred[id] = cssRules;
  };

  /* injects rules for a given id with a name that will need to be cached */


  StyleSheet.prototype.inject = function inject(id, cssRules, name) {
    var clones = this.clones;


    for (var i = 0; i < clones.length; i += 1) {
      clones[i].inject(id, cssRules, name);
    }

    var tag = this.getTagForId(id);

    /* add deferred rules for component */
    if (this.deferred[id] !== undefined) {
      // Combine passed cssRules with previously deferred CSS rules
      // NOTE: We cannot mutate the deferred array itself as all clones
      // do the same (see clones[i].inject)
      var rules = this.deferred[id].concat(cssRules);
      tag.insertRules(id, rules, name);

      this.deferred[id] = undefined;
    } else {
      tag.insertRules(id, cssRules, name);
    }
  };

  /* removes all rules for a given id, which doesn't remove its marker but resets it */


  StyleSheet.prototype.remove = function remove(id) {
    var tag = this.tagMap[id];
    if (tag === undefined) return;

    var clones = this.clones;

    for (var i = 0; i < clones.length; i += 1) {
      clones[i].remove(id);
    }

    /* remove all rules from the tag */
    tag.removeRules(id);

    /* ignore possible rehydrated names */
    this.ignoreRehydratedNames[id] = true;

    /* delete possible deferred rules */
    this.deferred[id] = undefined;
  };

  StyleSheet.prototype.toHTML = function toHTML() {
    return this.tags.map(function (tag) {
      return tag.toHTML();
    }).join('');
  };

  StyleSheet.prototype.toReactElements = function toReactElements() {
    var id = this.id;


    return this.tags.map(function (tag, i) {
      var key = 'sc-' + id + '-' + i;
      return Object(__WEBPACK_IMPORTED_MODULE_2_react__["cloneElement"])(tag.toElement(), { key: key });
    });
  };

  createClass(StyleSheet, null, [{
    key: 'master',
    get: function get$$1() {
      return master || (master = new StyleSheet().rehydrate());
    }

    /* NOTE: This is just for backwards-compatibility with jest-styled-components */

  }, {
    key: 'instance',
    get: function get$$1() {
      return StyleSheet.master;
    }
  }]);
  return StyleSheet;
}();

// 

var Keyframes = function () {
  function Keyframes(name, rules) {
    var _this = this;

    classCallCheck(this, Keyframes);

    this.inject = function (styleSheet) {
      if (!styleSheet.hasNameForId(_this.id, _this.name)) {
        styleSheet.inject(_this.id, _this.rules, _this.name);
      }
    };

    this.toString = function () {
      throw new StyledComponentsError(12, String(_this.name));
    };

    this.name = name;
    this.rules = rules;

    this.id = 'sc-keyframes-' + name;
  }

  Keyframes.prototype.getName = function getName() {
    return this.name;
  };

  return Keyframes;
}();

// 

/**
 * inlined version of
 * https://github.com/facebook/fbjs/blob/master/packages/fbjs/src/core/hyphenateStyleName.js
 */

var uppercasePattern = /([A-Z])/g;
var msPattern = /^ms-/;

/**
 * Hyphenates a camelcased CSS property name, for example:
 *
 *   > hyphenateStyleName('backgroundColor')
 *   < "background-color"
 *   > hyphenateStyleName('MozTransition')
 *   < "-moz-transition"
 *   > hyphenateStyleName('msTransition')
 *   < "-ms-transition"
 *
 * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
 * is converted to `-ms-`.
 *
 * @param {string} string
 * @return {string}
 */
function hyphenateStyleName(string) {
  return string.replace(uppercasePattern, '-$1').toLowerCase().replace(msPattern, '-ms-');
}

// 

// Taken from https://github.com/facebook/react/blob/b87aabdfe1b7461e7331abb3601d9e6bb27544bc/packages/react-dom/src/shared/dangerousStyleValue.js
function addUnitIfNeeded(name, value) {
  // https://github.com/amilajack/eslint-plugin-flowtype-errors/issues/133
  // $FlowFixMe
  if (value == null || typeof value === 'boolean' || value === '') {
    return '';
  }

  if (typeof value === 'number' && value !== 0 && !(name in __WEBPACK_IMPORTED_MODULE_3__emotion_unitless__["a" /* default */])) {
    return value + 'px'; // Presumes implicit 'px' suffix for unitless numbers
  }

  return String(value).trim();
}

// 

/**
 * It's falsish not falsy because 0 is allowed.
 */
var isFalsish = function isFalsish(chunk) {
  return chunk === undefined || chunk === null || chunk === false || chunk === '';
};

var objToCssArray = function objToCssArray(obj, prevKey) {
  var rules = [];
  var keys = Object.keys(obj);

  keys.forEach(function (key) {
    if (!isFalsish(obj[key])) {
      if (isPlainObject(obj[key])) {
        rules.push.apply(rules, objToCssArray(obj[key], key));

        return rules;
      } else if (isFunction(obj[key])) {
        rules.push(hyphenateStyleName(key) + ':', obj[key], ';');

        return rules;
      }
      rules.push(hyphenateStyleName(key) + ': ' + addUnitIfNeeded(key, obj[key]) + ';');
    }
    return rules;
  });

  return prevKey ? [prevKey + ' {'].concat(rules, ['}']) : rules;
};

function flatten(chunk, executionContext, styleSheet) {
  if (Array.isArray(chunk)) {
    var ruleSet = [];

    for (var i = 0, len = chunk.length, result; i < len; i += 1) {
      result = flatten(chunk[i], executionContext, styleSheet);

      if (result === null) continue;else if (Array.isArray(result)) ruleSet.push.apply(ruleSet, result);else ruleSet.push(result);
    }

    return ruleSet;
  }

  if (isFalsish(chunk)) {
    return null;
  }

  /* Handle other components */
  if (isStyledComponent(chunk)) {
    return '.' + chunk.styledComponentId;
  }

  /* Either execute or defer the function */
  if (isFunction(chunk)) {
    if (isStatelessFunction(chunk) && executionContext) {
      var _result = chunk(executionContext);

      if (false) {
        // eslint-disable-next-line no-console
        console.warn(getComponentName(chunk) + ' is not a styled component and cannot be referred to via component selector. See https://www.styled-components.com/docs/advanced#referring-to-other-components for more details.');
      }

      return flatten(_result, executionContext, styleSheet);
    } else return chunk;
  }

  if (chunk instanceof Keyframes) {
    if (styleSheet) {
      chunk.inject(styleSheet);
      return chunk.getName();
    } else return chunk;
  }

  /* Handle objects */
  return isPlainObject(chunk) ? objToCssArray(chunk) : chunk.toString();
}

// 

function css(styles) {
  for (var _len = arguments.length, interpolations = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    interpolations[_key - 1] = arguments[_key];
  }

  if (isFunction(styles) || isPlainObject(styles)) {
    // $FlowFixMe
    return flatten(interleave(EMPTY_ARRAY, [styles].concat(interpolations)));
  }

  // $FlowFixMe
  return flatten(interleave(styles, interpolations));
}

// 

function constructWithOptions(componentConstructor, tag) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : EMPTY_OBJECT;

  if (!Object(__WEBPACK_IMPORTED_MODULE_4_react_is__["isValidElementType"])(tag)) {
    throw new StyledComponentsError(1, String(tag));
  }

  /* This is callable directly as a template function */
  // $FlowFixMe: Not typed to avoid destructuring arguments
  var templateFunction = function templateFunction() {
    return componentConstructor(tag, options, css.apply(undefined, arguments));
  };

  /* If config methods are called, wrap up a new template function and merge options */
  templateFunction.withConfig = function (config) {
    return constructWithOptions(componentConstructor, tag, _extends({}, options, config));
  };

  /* Modify/inject new props at runtime */
  templateFunction.attrs = function (attrs) {
    return constructWithOptions(componentConstructor, tag, _extends({}, options, {
      attrs: Array.prototype.concat(options.attrs, attrs).filter(Boolean)
    }));
  };

  return templateFunction;
}

// 
// Source: https://github.com/garycourt/murmurhash-js/blob/master/murmurhash2_gc.js
function murmurhash(c) {
  for (var e = c.length | 0, a = e | 0, d = 0, b; e >= 4;) {
    b = c.charCodeAt(d) & 255 | (c.charCodeAt(++d) & 255) << 8 | (c.charCodeAt(++d) & 255) << 16 | (c.charCodeAt(++d) & 255) << 24, b = 1540483477 * (b & 65535) + ((1540483477 * (b >>> 16) & 65535) << 16), b ^= b >>> 24, b = 1540483477 * (b & 65535) + ((1540483477 * (b >>> 16) & 65535) << 16), a = 1540483477 * (a & 65535) + ((1540483477 * (a >>> 16) & 65535) << 16) ^ b, e -= 4, ++d;
  }
  switch (e) {
    case 3:
      a ^= (c.charCodeAt(d + 2) & 255) << 16;
    case 2:
      a ^= (c.charCodeAt(d + 1) & 255) << 8;
    case 1:
      a ^= c.charCodeAt(d) & 255, a = 1540483477 * (a & 65535) + ((1540483477 * (a >>> 16) & 65535) << 16);
  }
  a ^= a >>> 13;
  a = 1540483477 * (a & 65535) + ((1540483477 * (a >>> 16) & 65535) << 16);
  return (a ^ a >>> 15) >>> 0;
}

// 
/* eslint-disable no-bitwise */

/* This is the "capacity" of our alphabet i.e. 2x26 for all letters plus their capitalised
 * counterparts */
var charsLength = 52;

/* start at 75 for 'a' until 'z' (25) and then start at 65 for capitalised letters */
var getAlphabeticChar = function getAlphabeticChar(code) {
  return String.fromCharCode(code + (code > 25 ? 39 : 97));
};

/* input a number, usually a hash and convert it to base-52 */
function generateAlphabeticName(code) {
  var name = '';
  var x = void 0;

  /* get a char and divide by alphabet-length */
  for (x = code; x > charsLength; x = Math.floor(x / charsLength)) {
    name = getAlphabeticChar(x % charsLength) + name;
  }

  return getAlphabeticChar(x % charsLength) + name;
}

// 

function hasFunctionObjectKey(obj) {
  // eslint-disable-next-line guard-for-in, no-restricted-syntax
  for (var key in obj) {
    if (isFunction(obj[key])) {
      return true;
    }
  }

  return false;
}

function isStaticRules(rules, attrs) {
  for (var i = 0; i < rules.length; i += 1) {
    var rule = rules[i];

    // recursive case
    if (Array.isArray(rule) && !isStaticRules(rule, attrs)) {
      return false;
    } else if (isFunction(rule) && !isStyledComponent(rule)) {
      // functions are allowed to be static if they're just being
      // used to get the classname of a nested styled component
      return false;
    }
  }

  if (attrs.some(function (x) {
    return isFunction(x) || hasFunctionObjectKey(x);
  })) return false;

  return true;
}

// 

var isHMREnabled = "production" !== 'production' && typeof module !== 'undefined' && module.hot;

/* combines hashStr (murmurhash) and nameGenerator for convenience */
var hasher = function hasher(str) {
  return generateAlphabeticName(murmurhash(str));
};

/*
 ComponentStyle is all the CSS-specific stuff, not
 the React-specific stuff.
 */

var ComponentStyle = function () {
  function ComponentStyle(rules, attrs, componentId) {
    classCallCheck(this, ComponentStyle);

    this.rules = rules;
    this.isStatic = !isHMREnabled && isStaticRules(rules, attrs);
    this.componentId = componentId;

    if (!StyleSheet.master.hasId(componentId)) {
      StyleSheet.master.deferredInject(componentId, []);
    }
  }

  /*
     * Flattens a rule set into valid CSS
     * Hashes it, wraps the whole chunk in a .hash1234 {}
     * Returns the hash to be injected on render()
     * */


  ComponentStyle.prototype.generateAndInjectStyles = function generateAndInjectStyles(executionContext, styleSheet) {
    var isStatic = this.isStatic,
        componentId = this.componentId,
        lastClassName = this.lastClassName;

    if (IS_BROWSER && isStatic && typeof lastClassName === 'string' && styleSheet.hasNameForId(componentId, lastClassName)) {
      return lastClassName;
    }

    var flatCSS = flatten(this.rules, executionContext, styleSheet);
    var name = hasher(this.componentId + flatCSS.join(''));
    if (!styleSheet.hasNameForId(componentId, name)) {
      styleSheet.inject(this.componentId, stringifyRules(flatCSS, '.' + name, undefined, componentId), name);
    }

    this.lastClassName = name;
    return name;
  };

  ComponentStyle.generateName = function generateName(str) {
    return hasher(str);
  };

  return ComponentStyle;
}();

// 

var LIMIT = 200;

var createWarnTooManyClasses = (function (displayName) {
  var generatedClasses = {};
  var warningSeen = false;

  return function (className) {
    if (!warningSeen) {
      generatedClasses[className] = true;
      if (Object.keys(generatedClasses).length >= LIMIT) {
        // Unable to find latestRule in test environment.
        /* eslint-disable no-console, prefer-template */
        console.warn('Over ' + LIMIT + ' classes were generated for component ' + displayName + '. \n' + 'Consider using the attrs method, together with a style object for frequently changed styles.\n' + 'Example:\n' + '  const Component = styled.div.attrs({\n' + '    style: ({ background }) => ({\n' + '      background,\n' + '    }),\n' + '  })`width: 100%;`\n\n' + '  <Component />');
        warningSeen = true;
        generatedClasses = {};
      }
    }
  };
});

// 

var determineTheme = (function (props, fallbackTheme) {
  var defaultProps = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : EMPTY_OBJECT;

  // Props should take precedence over ThemeProvider, which should take precedence over
  // defaultProps, but React automatically puts defaultProps on props.

  /* eslint-disable react/prop-types, flowtype-errors/show-errors */
  var isDefaultTheme = defaultProps ? props.theme === defaultProps.theme : false;
  var theme = props.theme && !isDefaultTheme ? props.theme : fallbackTheme || defaultProps.theme;
  /* eslint-enable */

  return theme;
});

// 
var escapeRegex = /[[\].#*$><+~=|^:(),"'`-]+/g;
var dashesAtEnds = /(^-|-$)/g;

/**
 * TODO: Explore using CSS.escape when it becomes more available
 * in evergreen browsers.
 */
function escape(str) {
  return str
  // Replace all possible CSS selectors
  .replace(escapeRegex, '-')

  // Remove extraneous hyphens at the start and end
  .replace(dashesAtEnds, '');
}

// 

function isTag(target) {
  return typeof target === 'string' && ( false ? target.charAt(0) === target.charAt(0).toLowerCase() : true);
}

// 

function generateDisplayName(target) {
  // $FlowFixMe
  return isTag(target) ? 'styled.' + target : 'Styled(' + getComponentName(target) + ')';
}

var _TYPE_STATICS;

var REACT_STATICS = {
  childContextTypes: true,
  contextTypes: true,
  defaultProps: true,
  displayName: true,
  getDerivedStateFromProps: true,
  propTypes: true,
  type: true
};

var KNOWN_STATICS = {
  name: true,
  length: true,
  prototype: true,
  caller: true,
  callee: true,
  arguments: true,
  arity: true
};

var TYPE_STATICS = (_TYPE_STATICS = {}, _TYPE_STATICS[__WEBPACK_IMPORTED_MODULE_4_react_is__["ForwardRef"]] = {
  $$typeof: true,
  render: true
}, _TYPE_STATICS);

var defineProperty$1 = Object.defineProperty,
    getOwnPropertyNames = Object.getOwnPropertyNames,
    _Object$getOwnPropert = Object.getOwnPropertySymbols,
    getOwnPropertySymbols = _Object$getOwnPropert === undefined ? function () {
  return [];
} : _Object$getOwnPropert,
    getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor,
    getPrototypeOf = Object.getPrototypeOf,
    objectPrototype = Object.prototype;
var arrayPrototype = Array.prototype;


function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
  if (typeof sourceComponent !== 'string') {
    // don't hoist over string (html) components

    var inheritedComponent = getPrototypeOf(sourceComponent);

    if (inheritedComponent && inheritedComponent !== objectPrototype) {
      hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
    }

    var keys = arrayPrototype.concat(getOwnPropertyNames(sourceComponent),
    // $FlowFixMe
    getOwnPropertySymbols(sourceComponent));

    var targetStatics = TYPE_STATICS[targetComponent.$$typeof] || REACT_STATICS;

    var sourceStatics = TYPE_STATICS[sourceComponent.$$typeof] || REACT_STATICS;

    var i = keys.length;
    var descriptor = void 0;
    var key = void 0;

    // eslint-disable-next-line no-plusplus
    while (i--) {
      key = keys[i];

      if (
      // $FlowFixMe
      !KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) &&
      // $FlowFixMe
      !(targetStatics && targetStatics[key])) {
        descriptor = getOwnPropertyDescriptor(sourceComponent, key);

        if (descriptor) {
          try {
            // Avoid failures from read-only properties
            defineProperty$1(targetComponent, key, descriptor);
          } catch (e) {
            /* fail silently */
          }
        }
      }
    }

    return targetComponent;
  }

  return targetComponent;
}

// 
function isDerivedReactComponent(fn) {
  return !!(fn && fn.prototype && fn.prototype.isReactComponent);
}

// 
// Helper to call a given function, only once
var once = (function (cb) {
  var called = false;

  return function () {
    if (!called) {
      called = true;
      cb.apply(undefined, arguments);
    }
  };
});

// 

var ThemeContext = Object(__WEBPACK_IMPORTED_MODULE_2_react__["createContext"])();

var ThemeConsumer = ThemeContext.Consumer;

/**
 * Provide a theme to an entire react component tree via context
 */

var ThemeProvider = function (_Component) {
  inherits(ThemeProvider, _Component);

  function ThemeProvider(props) {
    classCallCheck(this, ThemeProvider);

    var _this = possibleConstructorReturn(this, _Component.call(this, props));

    _this.getContext = Object(__WEBPACK_IMPORTED_MODULE_5_memoize_one__["a" /* default */])(_this.getContext.bind(_this));
    _this.renderInner = _this.renderInner.bind(_this);
    return _this;
  }

  ThemeProvider.prototype.render = function render() {
    if (!this.props.children) return null;

    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
      ThemeContext.Consumer,
      null,
      this.renderInner
    );
  };

  ThemeProvider.prototype.renderInner = function renderInner(outerTheme) {
    var context = this.getContext(this.props.theme, outerTheme);

    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
      ThemeContext.Provider,
      { value: context },
      __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.only(this.props.children)
    );
  };

  /**
   * Get the theme from the props, supporting both (outerTheme) => {}
   * as well as object notation
   */


  ThemeProvider.prototype.getTheme = function getTheme(theme, outerTheme) {
    if (isFunction(theme)) {
      var mergedTheme = theme(outerTheme);

      if (false) {
        throw new StyledComponentsError(7);
      }

      return mergedTheme;
    }

    if (theme === null || Array.isArray(theme) || (typeof theme === 'undefined' ? 'undefined' : _typeof(theme)) !== 'object') {
      throw new StyledComponentsError(8);
    }

    return _extends({}, outerTheme, theme);
  };

  ThemeProvider.prototype.getContext = function getContext(theme, outerTheme) {
    return this.getTheme(theme, outerTheme);
  };

  return ThemeProvider;
}(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);

// 

var CLOSING_TAG_R = /^\s*<\/[a-z]/i;

var ServerStyleSheet = function () {
  function ServerStyleSheet() {
    classCallCheck(this, ServerStyleSheet);

    /* The master sheet might be reset, so keep a reference here */
    this.masterSheet = StyleSheet.master;
    this.instance = this.masterSheet.clone();
    this.sealed = false;
  }

  /**
   * Mark the ServerStyleSheet as being fully emitted and manually GC it from the
   * StyleSheet singleton.
   */


  ServerStyleSheet.prototype.seal = function seal() {
    if (!this.sealed) {
      /* Remove sealed StyleSheets from the master sheet */
      var index = this.masterSheet.clones.indexOf(this.instance);
      this.masterSheet.clones.splice(index, 1);
      this.sealed = true;
    }
  };

  ServerStyleSheet.prototype.collectStyles = function collectStyles(children) {
    if (this.sealed) {
      throw new StyledComponentsError(2);
    }

    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
      StyleSheetManager,
      { sheet: this.instance },
      children
    );
  };

  ServerStyleSheet.prototype.getStyleTags = function getStyleTags() {
    this.seal();
    return this.instance.toHTML();
  };

  ServerStyleSheet.prototype.getStyleElement = function getStyleElement() {
    this.seal();
    return this.instance.toReactElements();
  };

  ServerStyleSheet.prototype.interleaveWithNodeStream = function interleaveWithNodeStream(readableStream) {
    var _this = this;

    {
      throw new StyledComponentsError(3);
    }

    /* the tag index keeps track of which tags have already been emitted */
    var instance = this.instance;

    var instanceTagIndex = 0;

    var streamAttr = SC_STREAM_ATTR + '="true"';

    var transformer = new stream.Transform({
      transform: function appendStyleChunks(chunk, /* encoding */_, callback) {
        var tags = instance.tags;

        var html = '';

        /* retrieve html for each new style tag */
        for (; instanceTagIndex < tags.length; instanceTagIndex += 1) {
          var tag = tags[instanceTagIndex];
          html += tag.toHTML(streamAttr);
        }

        /* force our StyleSheets to emit entirely new tags */
        instance.sealAllTags();

        var renderedHtml = chunk.toString();

        /* prepend style html to chunk, unless the start of the chunk is a closing tag in which case append right after that */
        if (CLOSING_TAG_R.test(renderedHtml)) {
          var endOfClosingTag = renderedHtml.indexOf('>');

          this.push(renderedHtml.slice(0, endOfClosingTag + 1) + html + renderedHtml.slice(endOfClosingTag + 1));
        } else this.push(html + renderedHtml);

        callback();
      }
    });

    readableStream.on('end', function () {
      return _this.seal();
    });

    readableStream.on('error', function (err) {
      _this.seal();

      // forward the error to the transform stream
      transformer.emit('error', err);
    });

    return readableStream.pipe(transformer);
  };

  return ServerStyleSheet;
}();

// 

var StyleSheetContext = Object(__WEBPACK_IMPORTED_MODULE_2_react__["createContext"])();
var StyleSheetConsumer = StyleSheetContext.Consumer;

var StyleSheetManager = function (_Component) {
  inherits(StyleSheetManager, _Component);

  function StyleSheetManager(props) {
    classCallCheck(this, StyleSheetManager);

    var _this = possibleConstructorReturn(this, _Component.call(this, props));

    _this.getContext = Object(__WEBPACK_IMPORTED_MODULE_5_memoize_one__["a" /* default */])(_this.getContext);
    return _this;
  }

  StyleSheetManager.prototype.getContext = function getContext(sheet, target) {
    if (sheet) {
      return sheet;
    } else if (target) {
      return new StyleSheet(target);
    } else {
      throw new StyledComponentsError(4);
    }
  };

  StyleSheetManager.prototype.render = function render() {
    var _props = this.props,
        children = _props.children,
        sheet = _props.sheet,
        target = _props.target;


    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
      StyleSheetContext.Provider,
      { value: this.getContext(sheet, target) },
       false ? React.Children.only(children) : children
    );
  };

  return StyleSheetManager;
}(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);
 false ? StyleSheetManager.propTypes = {
  sheet: PropTypes.oneOfType([PropTypes.instanceOf(StyleSheet), PropTypes.instanceOf(ServerStyleSheet)]),

  target: PropTypes.shape({
    appendChild: PropTypes.func.isRequired
  })
} : void 0;

// 

var identifiers = {};

/* We depend on components having unique IDs */
function generateId(_ComponentStyle, _displayName, parentComponentId) {
  var displayName = typeof _displayName !== 'string' ? 'sc' : escape(_displayName);

  /**
   * This ensures uniqueness if two components happen to share
   * the same displayName.
   */
  var nr = (identifiers[displayName] || 0) + 1;
  identifiers[displayName] = nr;

  var componentId = displayName + '-' + _ComponentStyle.generateName(displayName + nr);

  return parentComponentId ? parentComponentId + '-' + componentId : componentId;
}

// $FlowFixMe

var StyledComponent = function (_Component) {
  inherits(StyledComponent, _Component);

  function StyledComponent() {
    classCallCheck(this, StyledComponent);

    var _this = possibleConstructorReturn(this, _Component.call(this));

    _this.attrs = {};

    _this.renderOuter = _this.renderOuter.bind(_this);
    _this.renderInner = _this.renderInner.bind(_this);

    if (false) {
      _this.warnInnerRef = once(function (displayName) {
        return (
          // eslint-disable-next-line no-console
          console.warn('The "innerRef" API has been removed in styled-components v4 in favor of React 16 ref forwarding, use "ref" instead like a typical component. "innerRef" was detected on component "' + displayName + '".')
        );
      });

      _this.warnAttrsFnObjectKeyDeprecated = once(function (key, displayName) {
        return (
          // eslint-disable-next-line no-console
          console.warn('Functions as object-form attrs({}) keys are now deprecated and will be removed in a future version of styled-components. Switch to the new attrs(props => ({})) syntax instead for easier and more powerful composition. The attrs key in question is "' + key + '" on component "' + displayName + '".', '\n ' + new Error().stack)
        );
      });

      _this.warnNonStyledComponentAttrsObjectKey = once(function (key, displayName) {
        return (
          // eslint-disable-next-line no-console
          console.warn('It looks like you\'ve used a non styled-component as the value for the "' + key + '" prop in an object-form attrs constructor of "' + displayName + '".\n' + 'You should use the new function-form attrs constructor which avoids this issue: attrs(props => ({ yourStuff }))\n' + "To continue using the deprecated object syntax, you'll need to wrap your component prop in a function to make it available inside the styled component (you'll still get the deprecation warning though.)\n" + ('For example, { ' + key + ': () => InnerComponent } instead of { ' + key + ': InnerComponent }'))
        );
      });
    }
    return _this;
  }

  StyledComponent.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
      StyleSheetConsumer,
      null,
      this.renderOuter
    );
  };

  StyledComponent.prototype.renderOuter = function renderOuter() {
    var styleSheet = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : StyleSheet.master;

    this.styleSheet = styleSheet;

    // No need to subscribe a static component to theme changes, it won't change anything
    if (this.props.forwardedComponent.componentStyle.isStatic) return this.renderInner();

    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
      ThemeConsumer,
      null,
      this.renderInner
    );
  };

  StyledComponent.prototype.renderInner = function renderInner(theme) {
    var _props$forwardedCompo = this.props.forwardedComponent,
        componentStyle = _props$forwardedCompo.componentStyle,
        defaultProps = _props$forwardedCompo.defaultProps,
        displayName = _props$forwardedCompo.displayName,
        foldedComponentIds = _props$forwardedCompo.foldedComponentIds,
        styledComponentId = _props$forwardedCompo.styledComponentId,
        target = _props$forwardedCompo.target;


    var generatedClassName = void 0;
    if (componentStyle.isStatic) {
      generatedClassName = this.generateAndInjectStyles(EMPTY_OBJECT, this.props);
    } else {
      generatedClassName = this.generateAndInjectStyles(determineTheme(this.props, theme, defaultProps) || EMPTY_OBJECT, this.props);
    }

    var elementToBeCreated = this.props.as || this.attrs.as || target;
    var isTargetTag = isTag(elementToBeCreated);

    var propsForElement = {};
    var computedProps = _extends({}, this.attrs, this.props);

    var key = void 0;
    // eslint-disable-next-line guard-for-in
    for (key in computedProps) {
      if (false) {
        this.warnInnerRef(displayName);
      }

      if (key === 'forwardedComponent' || key === 'as') {
        continue;
      } else if (key === 'forwardedRef') propsForElement.ref = computedProps[key];else if (key === 'forwardedAs') propsForElement.as = computedProps[key];else if (!isTargetTag || Object(__WEBPACK_IMPORTED_MODULE_7__emotion_is_prop_valid__["a" /* default */])(key)) {
        // Don't pass through non HTML tags through to HTML elements
        propsForElement[key] = computedProps[key];
      }
    }

    if (this.props.style && this.attrs.style) {
      propsForElement.style = _extends({}, this.attrs.style, this.props.style);
    }

    propsForElement.className = Array.prototype.concat(foldedComponentIds, this.props.className, styledComponentId, this.attrs.className, generatedClassName).filter(Boolean).join(' ');

    return Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])(elementToBeCreated, propsForElement);
  };

  StyledComponent.prototype.buildExecutionContext = function buildExecutionContext(theme, props, attrs) {
    var _this2 = this;

    var context = _extends({}, props, { theme: theme });

    if (!attrs.length) return context;

    this.attrs = {};

    attrs.forEach(function (attrDef) {
      var resolvedAttrDef = attrDef;
      var attrDefWasFn = false;
      var attr = void 0;
      var key = void 0;

      if (isFunction(resolvedAttrDef)) {
        // $FlowFixMe
        resolvedAttrDef = resolvedAttrDef(context);
        attrDefWasFn = true;
      }

      /* eslint-disable guard-for-in */
      // $FlowFixMe
      for (key in resolvedAttrDef) {
        attr = resolvedAttrDef[key];

        if (!attrDefWasFn) {
          if (isFunction(attr) && !isDerivedReactComponent(attr) && !isStyledComponent(attr)) {
            if (false) {
              _this2.warnAttrsFnObjectKeyDeprecated(key, props.forwardedComponent.displayName);
            }

            attr = attr(context);

            if (false) {
              _this2.warnNonStyledComponentAttrsObjectKey(key, props.forwardedComponent.displayName);
            }
          }
        }

        _this2.attrs[key] = attr;
        context[key] = attr;
      }
      /* eslint-enable */
    });

    return context;
  };

  StyledComponent.prototype.generateAndInjectStyles = function generateAndInjectStyles(theme, props) {
    var _props$forwardedCompo2 = props.forwardedComponent,
        attrs = _props$forwardedCompo2.attrs,
        componentStyle = _props$forwardedCompo2.componentStyle,
        warnTooManyClasses = _props$forwardedCompo2.warnTooManyClasses;

    // statically styled-components don't need to build an execution context object,
    // and shouldn't be increasing the number of class names

    if (componentStyle.isStatic && !attrs.length) {
      return componentStyle.generateAndInjectStyles(EMPTY_OBJECT, this.styleSheet);
    }

    var className = componentStyle.generateAndInjectStyles(this.buildExecutionContext(theme, props, attrs), this.styleSheet);

    if (false) warnTooManyClasses(className);

    return className;
  };

  return StyledComponent;
}(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);

function createStyledComponent(target, options, rules) {
  var isTargetStyledComp = isStyledComponent(target);
  var isClass = !isTag(target);

  var _options$displayName = options.displayName,
      displayName = _options$displayName === undefined ? generateDisplayName(target) : _options$displayName,
      _options$componentId = options.componentId,
      componentId = _options$componentId === undefined ? generateId(ComponentStyle, options.displayName, options.parentComponentId) : _options$componentId,
      _options$ParentCompon = options.ParentComponent,
      ParentComponent = _options$ParentCompon === undefined ? StyledComponent : _options$ParentCompon,
      _options$attrs = options.attrs,
      attrs = _options$attrs === undefined ? EMPTY_ARRAY : _options$attrs;


  var styledComponentId = options.displayName && options.componentId ? escape(options.displayName) + '-' + options.componentId : options.componentId || componentId;

  // fold the underlying StyledComponent attrs up (implicit extend)
  var finalAttrs =
  // $FlowFixMe
  isTargetStyledComp && target.attrs ? Array.prototype.concat(target.attrs, attrs).filter(Boolean) : attrs;

  var componentStyle = new ComponentStyle(isTargetStyledComp ? // fold the underlying StyledComponent rules up (implicit extend)
  // $FlowFixMe
  target.componentStyle.rules.concat(rules) : rules, finalAttrs, styledComponentId);

  /**
   * forwardRef creates a new interim component, which we'll take advantage of
   * instead of extending ParentComponent to create _another_ interim class
   */
  var WrappedStyledComponent = void 0;
  var forwardRef = function forwardRef(props, ref) {
    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(ParentComponent, _extends({}, props, { forwardedComponent: WrappedStyledComponent, forwardedRef: ref }));
  };
  forwardRef.displayName = displayName;
  WrappedStyledComponent = __WEBPACK_IMPORTED_MODULE_2_react___default.a.forwardRef(forwardRef);
  WrappedStyledComponent.displayName = displayName;

  // $FlowFixMe
  WrappedStyledComponent.attrs = finalAttrs;
  // $FlowFixMe
  WrappedStyledComponent.componentStyle = componentStyle;

  // $FlowFixMe
  WrappedStyledComponent.foldedComponentIds = isTargetStyledComp ? // $FlowFixMe
  Array.prototype.concat(target.foldedComponentIds, target.styledComponentId) : EMPTY_ARRAY;

  // $FlowFixMe
  WrappedStyledComponent.styledComponentId = styledComponentId;

  // fold the underlying StyledComponent target up since we folded the styles
  // $FlowFixMe
  WrappedStyledComponent.target = isTargetStyledComp ? target.target : target;

  // $FlowFixMe
  WrappedStyledComponent.withComponent = function withComponent(tag) {
    var previousComponentId = options.componentId,
        optionsToCopy = objectWithoutProperties(options, ['componentId']);


    var newComponentId = previousComponentId && previousComponentId + '-' + (isTag(tag) ? tag : escape(getComponentName(tag)));

    var newOptions = _extends({}, optionsToCopy, {
      attrs: finalAttrs,
      componentId: newComponentId,
      ParentComponent: ParentComponent
    });

    return createStyledComponent(tag, newOptions, rules);
  };

  // $FlowFixMe
  Object.defineProperty(WrappedStyledComponent, 'defaultProps', {
    get: function get$$1() {
      return this._foldedDefaultProps;
    },
    set: function set$$1(obj) {
      // $FlowFixMe
      this._foldedDefaultProps = isTargetStyledComp ? Object(__WEBPACK_IMPORTED_MODULE_8_merge_anything__["a" /* default */])(target.defaultProps, obj) : obj;
    }
  });

  if (false) {
    // $FlowFixMe
    WrappedStyledComponent.warnTooManyClasses = createWarnTooManyClasses(displayName);
  }

  // $FlowFixMe
  WrappedStyledComponent.toString = function () {
    return '.' + WrappedStyledComponent.styledComponentId;
  };

  if (isClass) {
    hoistNonReactStatics(WrappedStyledComponent, target, {
      // all SC-specific things should not be hoisted
      attrs: true,
      componentStyle: true,
      displayName: true,
      foldedComponentIds: true,
      styledComponentId: true,
      target: true,
      withComponent: true
    });
  }

  return WrappedStyledComponent;
}

// 
// Thanks to ReactDOMFactories for this handy list!

var domElements = ['a', 'abbr', 'address', 'area', 'article', 'aside', 'audio', 'b', 'base', 'bdi', 'bdo', 'big', 'blockquote', 'body', 'br', 'button', 'canvas', 'caption', 'cite', 'code', 'col', 'colgroup', 'data', 'datalist', 'dd', 'del', 'details', 'dfn', 'dialog', 'div', 'dl', 'dt', 'em', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'i', 'iframe', 'img', 'input', 'ins', 'kbd', 'keygen', 'label', 'legend', 'li', 'link', 'main', 'map', 'mark', 'marquee', 'menu', 'menuitem', 'meta', 'meter', 'nav', 'noscript', 'object', 'ol', 'optgroup', 'option', 'output', 'p', 'param', 'picture', 'pre', 'progress', 'q', 'rp', 'rt', 'ruby', 's', 'samp', 'script', 'section', 'select', 'small', 'source', 'span', 'strong', 'style', 'sub', 'summary', 'sup', 'table', 'tbody', 'td', 'textarea', 'tfoot', 'th', 'thead', 'time', 'title', 'tr', 'track', 'u', 'ul', 'var', 'video', 'wbr',

// SVG
'circle', 'clipPath', 'defs', 'ellipse', 'foreignObject', 'g', 'image', 'line', 'linearGradient', 'marker', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'svg', 'text', 'tspan'];

// 

var styled = function styled(tag) {
  return constructWithOptions(createStyledComponent, tag);
};

// Shorthands for all valid HTML Elements
domElements.forEach(function (domElement) {
  styled[domElement] = styled(domElement);
});

// 

var GlobalStyle = function () {
  function GlobalStyle(rules, componentId) {
    classCallCheck(this, GlobalStyle);

    this.rules = rules;
    this.componentId = componentId;
    this.isStatic = isStaticRules(rules, EMPTY_ARRAY);

    if (!StyleSheet.master.hasId(componentId)) {
      StyleSheet.master.deferredInject(componentId, []);
    }
  }

  GlobalStyle.prototype.createStyles = function createStyles(executionContext, styleSheet) {
    var flatCSS = flatten(this.rules, executionContext, styleSheet);
    var css = stringifyRules(flatCSS, '');

    styleSheet.inject(this.componentId, css);
  };

  GlobalStyle.prototype.removeStyles = function removeStyles(styleSheet) {
    var componentId = this.componentId;

    if (styleSheet.hasId(componentId)) {
      styleSheet.remove(componentId);
    }
  };

  // TODO: overwrite in-place instead of remove+create?


  GlobalStyle.prototype.renderStyles = function renderStyles(executionContext, styleSheet) {
    this.removeStyles(styleSheet);
    this.createStyles(executionContext, styleSheet);
  };

  return GlobalStyle;
}();

// 

// place our cache into shared context so it'll persist between HMRs
if (IS_BROWSER) {
  window.scCGSHMRCache = {};
}

function createGlobalStyle(strings) {
  for (var _len = arguments.length, interpolations = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    interpolations[_key - 1] = arguments[_key];
  }

  var rules = css.apply(undefined, [strings].concat(interpolations));
  var id = 'sc-global-' + murmurhash(JSON.stringify(rules));
  var style = new GlobalStyle(rules, id);

  var GlobalStyleComponent = function (_React$Component) {
    inherits(GlobalStyleComponent, _React$Component);

    function GlobalStyleComponent(props) {
      classCallCheck(this, GlobalStyleComponent);

      var _this = possibleConstructorReturn(this, _React$Component.call(this, props));

      var _this$constructor = _this.constructor,
          globalStyle = _this$constructor.globalStyle,
          styledComponentId = _this$constructor.styledComponentId;


      if (IS_BROWSER) {
        window.scCGSHMRCache[styledComponentId] = (window.scCGSHMRCache[styledComponentId] || 0) + 1;
      }

      /**
       * This fixes HMR compatibility. Don't ask me why, but this combination of
       * caching the closure variables via statics and then persisting the statics in
       * state works across HMR where no other combination did. ¯\_(ツ)_/¯
       */
      _this.state = {
        globalStyle: globalStyle,
        styledComponentId: styledComponentId
      };
      return _this;
    }

    GlobalStyleComponent.prototype.componentWillUnmount = function componentWillUnmount() {
      if (window.scCGSHMRCache[this.state.styledComponentId]) {
        window.scCGSHMRCache[this.state.styledComponentId] -= 1;
      }
      /**
       * Depending on the order "render" is called this can cause the styles to be lost
       * until the next render pass of the remaining instance, which may
       * not be immediate.
       */
      if (window.scCGSHMRCache[this.state.styledComponentId] === 0) {
        this.state.globalStyle.removeStyles(this.styleSheet);
      }
    };

    GlobalStyleComponent.prototype.render = function render() {
      var _this2 = this;

      if (false) {
        // eslint-disable-next-line no-console
        console.warn('The global style component ' + this.state.styledComponentId + ' was given child JSX. createGlobalStyle does not render children.');
      }

      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        StyleSheetConsumer,
        null,
        function (styleSheet) {
          _this2.styleSheet = styleSheet || StyleSheet.master;

          var globalStyle = _this2.state.globalStyle;


          if (globalStyle.isStatic) {
            globalStyle.renderStyles(STATIC_EXECUTION_CONTEXT, _this2.styleSheet);

            return null;
          } else {
            return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
              ThemeConsumer,
              null,
              function (theme) {
                // $FlowFixMe
                var defaultProps = _this2.constructor.defaultProps;


                var context = _extends({}, _this2.props);

                if (typeof theme !== 'undefined') {
                  context.theme = determineTheme(_this2.props, theme, defaultProps);
                }

                globalStyle.renderStyles(context, _this2.styleSheet);

                return null;
              }
            );
          }
        }
      );
    };

    return GlobalStyleComponent;
  }(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

  GlobalStyleComponent.globalStyle = style;
  GlobalStyleComponent.styledComponentId = id;


  return GlobalStyleComponent;
}

// 

var replaceWhitespace = function replaceWhitespace(str) {
  return str.replace(/\s|\\n/g, '');
};

function keyframes(strings) {
  /* Warning if you've used keyframes on React Native */
  if (false) {
    // eslint-disable-next-line no-console
    console.warn('`keyframes` cannot be used on ReactNative, only on the web. To do animation in ReactNative please use Animated.');
  }

  for (var _len = arguments.length, interpolations = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    interpolations[_key - 1] = arguments[_key];
  }

  var rules = css.apply(undefined, [strings].concat(interpolations));

  var name = generateAlphabeticName(murmurhash(replaceWhitespace(JSON.stringify(rules))));

  return new Keyframes(name, stringifyRules(rules, name, '@keyframes'));
}

// 

var withTheme = (function (Component$$1) {
  var WithTheme = __WEBPACK_IMPORTED_MODULE_2_react___default.a.forwardRef(function (props, ref) {
    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
      ThemeConsumer,
      null,
      function (theme) {
        // $FlowFixMe
        var defaultProps = Component$$1.defaultProps;

        var themeProp = determineTheme(props, theme, defaultProps);

        if (false) {
          // eslint-disable-next-line no-console
          console.warn('[withTheme] You are not using a ThemeProvider nor passing a theme prop or a theme in defaultProps in component class "' + getComponentName(Component$$1) + '"');
        }

        return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Component$$1, _extends({}, props, { theme: themeProp, ref: ref }));
      }
    );
  });

  hoistNonReactStatics(WithTheme, Component$$1);

  WithTheme.displayName = 'WithTheme(' + getComponentName(Component$$1) + ')';

  return WithTheme;
});

// 

/* eslint-disable */
var __DO_NOT_USE_OR_YOU_WILL_BE_HAUNTED_BY_SPOOKY_GHOSTS = {
  StyleSheet: StyleSheet
};

// 

/* Warning if you've imported this file on React Native */
if (false) {
  // eslint-disable-next-line no-console
  console.warn("It looks like you've imported 'styled-components' on React Native.\n" + "Perhaps you're looking to import 'styled-components/native'?\n" + 'Read more about this at https://www.styled-components.com/docs/basics#react-native');
}

/* Warning if there are several instances of styled-components */
if (false) {
  window['__styled-components-init__'] = window['__styled-components-init__'] || 0;

  if (window['__styled-components-init__'] === 1) {
    // eslint-disable-next-line no-console
    console.warn("It looks like there are several instances of 'styled-components' initialized in this application. " + 'This may cause dynamic styles not rendering properly, errors happening during rehydration process ' + 'and makes your application bigger without a good reason.\n\n' + 'See https://s-c.sh/2BAXzed for more info.');
  }

  window['__styled-components-init__'] += 1;
}

//

/* harmony default export */ __webpack_exports__["b"] = (styled);

//# sourceMappingURL=styled-components.browser.esm.js.map

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(11), __webpack_require__(101)(module)))

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var ReactIs = require('react-is');

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(70)();
}


/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(1);
var _templateObject=_taggedTemplateLiteral(['\n    @media (max-width: ','em) {\n      ','\n    }\n  '],['\n    @media (max-width: ','em) {\n      ','\n    }\n  ']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var sizes={desktop:992,tablet:768,phone:415,smphone:320};var media=Object.keys(sizes).reduce(function(acc,label){acc[label]=function(){return Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["a" /* css */])(_templateObject,sizes[label]/16,__WEBPACK_IMPORTED_MODULE_0_styled_components__["a" /* css */].apply(undefined,arguments));};return acc;},{});/* harmony default export */ __webpack_exports__["a"] = (media);

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.translate = exports.I18n = undefined;

var _i18n = __webpack_require__(82);

var _i18n2 = _interopRequireDefault(_i18n);

var _translate = __webpack_require__(98);

var _translate2 = _interopRequireDefault(_translate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.I18n = _i18n2.default;
exports.translate = _translate2.default;

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



module.exports = __webpack_require__(69);


/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var __DEV__ = "production" !== 'production';

var warning = function() {};

if (__DEV__) {
  var printWarning = function printWarning(format, args) {
    var len = arguments.length;
    args = new Array(len > 1 ? len - 1 : 0);
    for (var key = 1; key < len; key++) {
      args[key - 1] = arguments[key];
    }
    var argIndex = 0;
    var message = 'Warning: ' +
      format.replace(/%s/g, function() {
        return args[argIndex++];
      });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  }

  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
          '`warning(condition, format, ...args)` requires a warning ' +
          'message argument'
      );
    }
    if (!condition) {
      printWarning.apply(null, [format].concat(args));
    }
  };
}

module.exports = warning;


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/*
 * JavaScript Load Image
 * https://github.com/blueimp/JavaScript-Load-Image
 *
 * Copyright 2011, Sebastian Tschan
 * https://blueimp.net
 *
 * Licensed under the MIT license:
 * https://opensource.org/licenses/MIT
 */

/* global define, webkitURL, module */

;(function($) {
  'use strict'

  /**
   * Loads an image for a given File object.
   * Invokes the callback with an img or optional canvas element
   * (if supported by the browser) as parameter:.
   *
   * @param {File|Blob|string} file File or Blob object or image URL
   * @param {Function} [callback] Image load event callback
   * @param {object} [options] Options object
   * @returns {HTMLImageElement|HTMLCanvasElement|FileReader} image object
   */
  function loadImage(file, callback, options) {
    var img = document.createElement('img')
    var url
    img.onerror = function(event) {
      return loadImage.onerror(img, event, file, callback, options)
    }
    img.onload = function(event) {
      return loadImage.onload(img, event, file, callback, options)
    }
    if (typeof file === 'string') {
      loadImage.fetchBlob(
        file,
        function(blob) {
          if (blob) {
            // eslint-disable-next-line no-param-reassign
            file = blob
            url = loadImage.createObjectURL(file)
          } else {
            url = file
            if (options && options.crossOrigin) {
              img.crossOrigin = options.crossOrigin
            }
          }
          img.src = url
        },
        options
      )
      return img
    } else if (
      loadImage.isInstanceOf('Blob', file) ||
      // Files are also Blob instances, but some browsers
      // (Firefox 3.6) support the File API but not Blobs:
      loadImage.isInstanceOf('File', file)
    ) {
      url = img._objectURL = loadImage.createObjectURL(file)
      if (url) {
        img.src = url
        return img
      }
      return loadImage.readFile(file, function(e) {
        var target = e.target
        if (target && target.result) {
          img.src = target.result
        } else if (callback) {
          callback(e)
        }
      })
    }
  }
  // The check for URL.revokeObjectURL fixes an issue with Opera 12,
  // which provides URL.createObjectURL but doesn't properly implement it:
  var urlAPI =
    ($.createObjectURL && $) ||
    ($.URL && URL.revokeObjectURL && URL) ||
    ($.webkitURL && webkitURL)

  /**
   * Helper function to revoke an object URL
   *
   * @param {HTMLImageElement} img Image element
   * @param {object} [options] Options object
   */
  function revokeHelper(img, options) {
    if (img._objectURL && !(options && options.noRevoke)) {
      loadImage.revokeObjectURL(img._objectURL)
      delete img._objectURL
    }
  }

  // If the callback given to this function returns a blob, it is used as image
  // source instead of the original url and overrides the file argument used in
  // the onload and onerror event callbacks:
  loadImage.fetchBlob = function(url, callback) {
    callback()
  }

  loadImage.isInstanceOf = function(type, obj) {
    // Cross-frame instanceof check
    return Object.prototype.toString.call(obj) === '[object ' + type + ']'
  }

  loadImage.transform = function(img, options, callback, file, data) {
    callback(img, data)
  }

  loadImage.onerror = function(img, event, file, callback, options) {
    revokeHelper(img, options)
    if (callback) {
      callback.call(img, event)
    }
  }

  loadImage.onload = function(img, event, file, callback, options) {
    revokeHelper(img, options)
    if (callback) {
      loadImage.transform(img, options, callback, file, {
        originalWidth: img.naturalWidth || img.width,
        originalHeight: img.naturalHeight || img.height
      })
    }
  }

  loadImage.createObjectURL = function(file) {
    return urlAPI ? urlAPI.createObjectURL(file) : false
  }

  loadImage.revokeObjectURL = function(url) {
    return urlAPI ? urlAPI.revokeObjectURL(url) : false
  }

  // Loads a given File object via FileReader interface,
  // invokes the callback with the event object (load or error).
  // The result can be read via event.target.result:
  loadImage.readFile = function(file, callback, method) {
    if ($.FileReader) {
      var fileReader = new FileReader()
      fileReader.onload = fileReader.onerror = callback
      // eslint-disable-next-line no-param-reassign
      method = method || 'readAsDataURL'
      if (fileReader[method]) {
        fileReader[method](file)
        return fileReader
      }
    }
    return false
  }

  if (true) {
    !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
      return loadImage
    }.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
  } else if (typeof module === 'object' && module.exports) {
    module.exports = loadImage
  } else {
    $.loadImage = loadImage
  }
})((typeof window !== 'undefined' && window) || this)


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var invariant = function(condition, format, a, b, c, d, e, f) {
  if (false) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  }

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error(
        'Minified exception occurred; use the non-minified dev environment ' +
        'for the full error message and additional helpful warnings.'
      );
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(
        format.replace(/%s/g, function() { return args[argIndex++]; })
      );
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
};

module.exports = invariant;


/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createBrowserHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return createHashHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return createMemoryHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return createLocation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return locationsAreEqual; });
/* unused harmony export parsePath */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return createPath; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_resolve_pathname__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_value_equal__ = __webpack_require__(209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_tiny_warning__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_tiny_invariant__ = __webpack_require__(211);






function addLeadingSlash(path) {
  return path.charAt(0) === '/' ? path : '/' + path;
}
function stripLeadingSlash(path) {
  return path.charAt(0) === '/' ? path.substr(1) : path;
}
function hasBasename(path, prefix) {
  return new RegExp('^' + prefix + '(\\/|\\?|#|$)', 'i').test(path);
}
function stripBasename(path, prefix) {
  return hasBasename(path, prefix) ? path.substr(prefix.length) : path;
}
function stripTrailingSlash(path) {
  return path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
}
function parsePath(path) {
  var pathname = path || '/';
  var search = '';
  var hash = '';
  var hashIndex = pathname.indexOf('#');

  if (hashIndex !== -1) {
    hash = pathname.substr(hashIndex);
    pathname = pathname.substr(0, hashIndex);
  }

  var searchIndex = pathname.indexOf('?');

  if (searchIndex !== -1) {
    search = pathname.substr(searchIndex);
    pathname = pathname.substr(0, searchIndex);
  }

  return {
    pathname: pathname,
    search: search === '?' ? '' : search,
    hash: hash === '#' ? '' : hash
  };
}
function createPath(location) {
  var pathname = location.pathname,
      search = location.search,
      hash = location.hash;
  var path = pathname || '/';
  if (search && search !== '?') path += search.charAt(0) === '?' ? search : "?" + search;
  if (hash && hash !== '#') path += hash.charAt(0) === '#' ? hash : "#" + hash;
  return path;
}

function createLocation(path, state, key, currentLocation) {
  var location;

  if (typeof path === 'string') {
    // Two-arg form: push(path, state)
    location = parsePath(path);
    location.state = state;
  } else {
    // One-arg form: push(location)
    location = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, path);
    if (location.pathname === undefined) location.pathname = '';

    if (location.search) {
      if (location.search.charAt(0) !== '?') location.search = '?' + location.search;
    } else {
      location.search = '';
    }

    if (location.hash) {
      if (location.hash.charAt(0) !== '#') location.hash = '#' + location.hash;
    } else {
      location.hash = '';
    }

    if (state !== undefined && location.state === undefined) location.state = state;
  }

  try {
    location.pathname = decodeURI(location.pathname);
  } catch (e) {
    if (e instanceof URIError) {
      throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + 'This is likely caused by an invalid percent-encoding.');
    } else {
      throw e;
    }
  }

  if (key) location.key = key;

  if (currentLocation) {
    // Resolve incomplete/relative pathname relative to current location.
    if (!location.pathname) {
      location.pathname = currentLocation.pathname;
    } else if (location.pathname.charAt(0) !== '/') {
      location.pathname = Object(__WEBPACK_IMPORTED_MODULE_1_resolve_pathname__["a" /* default */])(location.pathname, currentLocation.pathname);
    }
  } else {
    // When there is no prior location and pathname is empty, set it to /
    if (!location.pathname) {
      location.pathname = '/';
    }
  }

  return location;
}
function locationsAreEqual(a, b) {
  return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && Object(__WEBPACK_IMPORTED_MODULE_2_value_equal__["a" /* default */])(a.state, b.state);
}

function createTransitionManager() {
  var prompt = null;

  function setPrompt(nextPrompt) {
     false ? warning(prompt == null, 'A history supports only one prompt at a time') : void 0;
    prompt = nextPrompt;
    return function () {
      if (prompt === nextPrompt) prompt = null;
    };
  }

  function confirmTransitionTo(location, action, getUserConfirmation, callback) {
    // TODO: If another transition starts while we're still confirming
    // the previous one, we may end up in a weird state. Figure out the
    // best way to handle this.
    if (prompt != null) {
      var result = typeof prompt === 'function' ? prompt(location, action) : prompt;

      if (typeof result === 'string') {
        if (typeof getUserConfirmation === 'function') {
          getUserConfirmation(result, callback);
        } else {
           false ? warning(false, 'A history needs a getUserConfirmation function in order to use a prompt message') : void 0;
          callback(true);
        }
      } else {
        // Return false from a transition hook to cancel the transition.
        callback(result !== false);
      }
    } else {
      callback(true);
    }
  }

  var listeners = [];

  function appendListener(fn) {
    var isActive = true;

    function listener() {
      if (isActive) fn.apply(void 0, arguments);
    }

    listeners.push(listener);
    return function () {
      isActive = false;
      listeners = listeners.filter(function (item) {
        return item !== listener;
      });
    };
  }

  function notifyListeners() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    listeners.forEach(function (listener) {
      return listener.apply(void 0, args);
    });
  }

  return {
    setPrompt: setPrompt,
    confirmTransitionTo: confirmTransitionTo,
    appendListener: appendListener,
    notifyListeners: notifyListeners
  };
}

var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
function getConfirmation(message, callback) {
  callback(window.confirm(message)); // eslint-disable-line no-alert
}
/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */

function supportsHistory() {
  var ua = window.navigator.userAgent;
  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;
  return window.history && 'pushState' in window.history;
}
/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */

function supportsPopStateOnHashChange() {
  return window.navigator.userAgent.indexOf('Trident') === -1;
}
/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */

function supportsGoWithoutReloadUsingHash() {
  return window.navigator.userAgent.indexOf('Firefox') === -1;
}
/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */

function isExtraneousPopstateEvent(event) {
  event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
}

var PopStateEvent = 'popstate';
var HashChangeEvent = 'hashchange';

function getHistoryState() {
  try {
    return window.history.state || {};
  } catch (e) {
    // IE 11 sometimes throws when accessing window.history.state
    // See https://github.com/ReactTraining/history/pull/289
    return {};
  }
}
/**
 * Creates a history object that uses the HTML5 history API including
 * pushState, replaceState, and the popstate event.
 */


function createBrowserHistory(props) {
  if (props === void 0) {
    props = {};
  }

  !canUseDOM ?  false ? invariant(false, 'Browser history needs a DOM') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
  var globalHistory = window.history;
  var canUseHistory = supportsHistory();
  var needsHashChangeListener = !supportsPopStateOnHashChange();
  var _props = props,
      _props$forceRefresh = _props.forceRefresh,
      forceRefresh = _props$forceRefresh === void 0 ? false : _props$forceRefresh,
      _props$getUserConfirm = _props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === void 0 ? getConfirmation : _props$getUserConfirm,
      _props$keyLength = _props.keyLength,
      keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
  var basename = props.basename ? stripTrailingSlash(addLeadingSlash(props.basename)) : '';

  function getDOMLocation(historyState) {
    var _ref = historyState || {},
        key = _ref.key,
        state = _ref.state;

    var _window$location = window.location,
        pathname = _window$location.pathname,
        search = _window$location.search,
        hash = _window$location.hash;
    var path = pathname + search + hash;
     false ? warning(!basename || hasBasename(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".') : void 0;
    if (basename) path = stripBasename(path, basename);
    return createLocation(path, state, key);
  }

  function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  }

  var transitionManager = createTransitionManager();

  function setState(nextState) {
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])(history, nextState);

    history.length = globalHistory.length;
    transitionManager.notifyListeners(history.location, history.action);
  }

  function handlePopState(event) {
    // Ignore extraneous popstate events in WebKit.
    if (isExtraneousPopstateEvent(event)) return;
    handlePop(getDOMLocation(event.state));
  }

  function handleHashChange() {
    handlePop(getDOMLocation(getHistoryState()));
  }

  var forceNextPop = false;

  function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';
      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({
            action: action,
            location: location
          });
        } else {
          revertPop(location);
        }
      });
    }
  }

  function revertPop(fromLocation) {
    var toLocation = history.location; // TODO: We could probably make this more reliable by
    // keeping a list of keys we've seen in sessionStorage.
    // Instead, we just default to 0 for keys we don't know.

    var toIndex = allKeys.indexOf(toLocation.key);
    if (toIndex === -1) toIndex = 0;
    var fromIndex = allKeys.indexOf(fromLocation.key);
    if (fromIndex === -1) fromIndex = 0;
    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  }

  var initialLocation = getDOMLocation(getHistoryState());
  var allKeys = [initialLocation.key]; // Public interface

  function createHref(location) {
    return basename + createPath(location);
  }

  function push(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'PUSH';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var href = createHref(location);
      var key = location.key,
          state = location.state;

      if (canUseHistory) {
        globalHistory.pushState({
          key: key,
          state: state
        }, null, href);

        if (forceRefresh) {
          window.location.href = href;
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);
          var nextKeys = allKeys.slice(0, prevIndex === -1 ? 0 : prevIndex + 1);
          nextKeys.push(location.key);
          allKeys = nextKeys;
          setState({
            action: action,
            location: location
          });
        }
      } else {
         false ? warning(state === undefined, 'Browser history cannot push state in browsers that do not support HTML5 history') : void 0;
        window.location.href = href;
      }
    });
  }

  function replace(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'REPLACE';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var href = createHref(location);
      var key = location.key,
          state = location.state;

      if (canUseHistory) {
        globalHistory.replaceState({
          key: key,
          state: state
        }, null, href);

        if (forceRefresh) {
          window.location.replace(href);
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);
          if (prevIndex !== -1) allKeys[prevIndex] = location.key;
          setState({
            action: action,
            location: location
          });
        }
      } else {
         false ? warning(state === undefined, 'Browser history cannot replace state in browsers that do not support HTML5 history') : void 0;
        window.location.replace(href);
      }
    });
  }

  function go(n) {
    globalHistory.go(n);
  }

  function goBack() {
    go(-1);
  }

  function goForward() {
    go(1);
  }

  var listenerCount = 0;

  function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1 && delta === 1) {
      window.addEventListener(PopStateEvent, handlePopState);
      if (needsHashChangeListener) window.addEventListener(HashChangeEvent, handleHashChange);
    } else if (listenerCount === 0) {
      window.removeEventListener(PopStateEvent, handlePopState);
      if (needsHashChangeListener) window.removeEventListener(HashChangeEvent, handleHashChange);
    }
  }

  var isBlocked = false;

  function block(prompt) {
    if (prompt === void 0) {
      prompt = false;
    }

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  }

  function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);
    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  }

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };
  return history;
}

var HashChangeEvent$1 = 'hashchange';
var HashPathCoders = {
  hashbang: {
    encodePath: function encodePath(path) {
      return path.charAt(0) === '!' ? path : '!/' + stripLeadingSlash(path);
    },
    decodePath: function decodePath(path) {
      return path.charAt(0) === '!' ? path.substr(1) : path;
    }
  },
  noslash: {
    encodePath: stripLeadingSlash,
    decodePath: addLeadingSlash
  },
  slash: {
    encodePath: addLeadingSlash,
    decodePath: addLeadingSlash
  }
};

function getHashPath() {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var hashIndex = href.indexOf('#');
  return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
}

function pushHashPath(path) {
  window.location.hash = path;
}

function replaceHashPath(path) {
  var hashIndex = window.location.href.indexOf('#');
  window.location.replace(window.location.href.slice(0, hashIndex >= 0 ? hashIndex : 0) + '#' + path);
}

function createHashHistory(props) {
  if (props === void 0) {
    props = {};
  }

  !canUseDOM ?  false ? invariant(false, 'Hash history needs a DOM') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
  var globalHistory = window.history;
  var canGoWithoutReload = supportsGoWithoutReloadUsingHash();
  var _props = props,
      _props$getUserConfirm = _props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === void 0 ? getConfirmation : _props$getUserConfirm,
      _props$hashType = _props.hashType,
      hashType = _props$hashType === void 0 ? 'slash' : _props$hashType;
  var basename = props.basename ? stripTrailingSlash(addLeadingSlash(props.basename)) : '';
  var _HashPathCoders$hashT = HashPathCoders[hashType],
      encodePath = _HashPathCoders$hashT.encodePath,
      decodePath = _HashPathCoders$hashT.decodePath;

  function getDOMLocation() {
    var path = decodePath(getHashPath());
     false ? warning(!basename || hasBasename(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".') : void 0;
    if (basename) path = stripBasename(path, basename);
    return createLocation(path);
  }

  var transitionManager = createTransitionManager();

  function setState(nextState) {
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])(history, nextState);

    history.length = globalHistory.length;
    transitionManager.notifyListeners(history.location, history.action);
  }

  var forceNextPop = false;
  var ignorePath = null;

  function handleHashChange() {
    var path = getHashPath();
    var encodedPath = encodePath(path);

    if (path !== encodedPath) {
      // Ensure we always have a properly-encoded hash.
      replaceHashPath(encodedPath);
    } else {
      var location = getDOMLocation();
      var prevLocation = history.location;
      if (!forceNextPop && locationsAreEqual(prevLocation, location)) return; // A hashchange doesn't always == location change.

      if (ignorePath === createPath(location)) return; // Ignore this change; we already setState in push/replace.

      ignorePath = null;
      handlePop(location);
    }
  }

  function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';
      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({
            action: action,
            location: location
          });
        } else {
          revertPop(location);
        }
      });
    }
  }

  function revertPop(fromLocation) {
    var toLocation = history.location; // TODO: We could probably make this more reliable by
    // keeping a list of paths we've seen in sessionStorage.
    // Instead, we just default to 0 for paths we don't know.

    var toIndex = allPaths.lastIndexOf(createPath(toLocation));
    if (toIndex === -1) toIndex = 0;
    var fromIndex = allPaths.lastIndexOf(createPath(fromLocation));
    if (fromIndex === -1) fromIndex = 0;
    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  } // Ensure the hash is encoded properly before doing anything else.


  var path = getHashPath();
  var encodedPath = encodePath(path);
  if (path !== encodedPath) replaceHashPath(encodedPath);
  var initialLocation = getDOMLocation();
  var allPaths = [createPath(initialLocation)]; // Public interface

  function createHref(location) {
    return '#' + encodePath(basename + createPath(location));
  }

  function push(path, state) {
     false ? warning(state === undefined, 'Hash history cannot push state; it is ignored') : void 0;
    var action = 'PUSH';
    var location = createLocation(path, undefined, undefined, history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var path = createPath(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a PUSH, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        pushHashPath(encodedPath);
        var prevIndex = allPaths.lastIndexOf(createPath(history.location));
        var nextPaths = allPaths.slice(0, prevIndex === -1 ? 0 : prevIndex + 1);
        nextPaths.push(path);
        allPaths = nextPaths;
        setState({
          action: action,
          location: location
        });
      } else {
         false ? warning(false, 'Hash history cannot PUSH the same path; a new entry will not be added to the history stack') : void 0;
        setState();
      }
    });
  }

  function replace(path, state) {
     false ? warning(state === undefined, 'Hash history cannot replace state; it is ignored') : void 0;
    var action = 'REPLACE';
    var location = createLocation(path, undefined, undefined, history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var path = createPath(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a REPLACE, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        replaceHashPath(encodedPath);
      }

      var prevIndex = allPaths.indexOf(createPath(history.location));
      if (prevIndex !== -1) allPaths[prevIndex] = path;
      setState({
        action: action,
        location: location
      });
    });
  }

  function go(n) {
     false ? warning(canGoWithoutReload, 'Hash history go(n) causes a full page reload in this browser') : void 0;
    globalHistory.go(n);
  }

  function goBack() {
    go(-1);
  }

  function goForward() {
    go(1);
  }

  var listenerCount = 0;

  function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1 && delta === 1) {
      window.addEventListener(HashChangeEvent$1, handleHashChange);
    } else if (listenerCount === 0) {
      window.removeEventListener(HashChangeEvent$1, handleHashChange);
    }
  }

  var isBlocked = false;

  function block(prompt) {
    if (prompt === void 0) {
      prompt = false;
    }

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  }

  function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);
    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  }

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };
  return history;
}

function clamp(n, lowerBound, upperBound) {
  return Math.min(Math.max(n, lowerBound), upperBound);
}
/**
 * Creates a history object that stores locations in memory.
 */


function createMemoryHistory(props) {
  if (props === void 0) {
    props = {};
  }

  var _props = props,
      getUserConfirmation = _props.getUserConfirmation,
      _props$initialEntries = _props.initialEntries,
      initialEntries = _props$initialEntries === void 0 ? ['/'] : _props$initialEntries,
      _props$initialIndex = _props.initialIndex,
      initialIndex = _props$initialIndex === void 0 ? 0 : _props$initialIndex,
      _props$keyLength = _props.keyLength,
      keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
  var transitionManager = createTransitionManager();

  function setState(nextState) {
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])(history, nextState);

    history.length = history.entries.length;
    transitionManager.notifyListeners(history.location, history.action);
  }

  function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  }

  var index = clamp(initialIndex, 0, initialEntries.length - 1);
  var entries = initialEntries.map(function (entry) {
    return typeof entry === 'string' ? createLocation(entry, undefined, createKey()) : createLocation(entry, undefined, entry.key || createKey());
  }); // Public interface

  var createHref = createPath;

  function push(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'PUSH';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var prevIndex = history.index;
      var nextIndex = prevIndex + 1;
      var nextEntries = history.entries.slice(0);

      if (nextEntries.length > nextIndex) {
        nextEntries.splice(nextIndex, nextEntries.length - nextIndex, location);
      } else {
        nextEntries.push(location);
      }

      setState({
        action: action,
        location: location,
        index: nextIndex,
        entries: nextEntries
      });
    });
  }

  function replace(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'REPLACE';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      history.entries[history.index] = location;
      setState({
        action: action,
        location: location
      });
    });
  }

  function go(n) {
    var nextIndex = clamp(history.index + n, 0, history.entries.length - 1);
    var action = 'POP';
    var location = history.entries[nextIndex];
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (ok) {
        setState({
          action: action,
          location: location,
          index: nextIndex
        });
      } else {
        // Mimic the behavior of DOM histories by
        // causing a render after a cancelled POP.
        setState();
      }
    });
  }

  function goBack() {
    go(-1);
  }

  function goForward() {
    go(1);
  }

  function canGo(n) {
    var nextIndex = history.index + n;
    return nextIndex >= 0 && nextIndex < history.entries.length;
  }

  function block(prompt) {
    if (prompt === void 0) {
      prompt = false;
    }

    return transitionManager.setPrompt(prompt);
  }

  function listen(listener) {
    return transitionManager.appendListener(listener);
  }

  var history = {
    length: entries.length,
    action: 'POP',
    location: entries[index],
    index: index,
    entries: entries,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    canGo: canGo,
    block: block,
    listen: listen
  };
  return history;
}




/***/ }),
/* 10 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 11 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*
 * JavaScript Load Image Meta
 * https://github.com/blueimp/JavaScript-Load-Image
 *
 * Copyright 2013, Sebastian Tschan
 * https://blueimp.net
 *
 * Image meta data handling implementation
 * based on the help and contribution of
 * Achim Stöhr.
 *
 * Licensed under the MIT license:
 * https://opensource.org/licenses/MIT
 */

/* global define, module, require, DataView, Uint8Array */

;(function(factory) {
  'use strict'
  if (true) {
    // Register as an anonymous AMD module:
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(7)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
  } else if (typeof module === 'object' && module.exports) {
    factory(require('./load-image'))
  } else {
    // Browser globals:
    factory(window.loadImage)
  }
})(function(loadImage) {
  'use strict'

  var hasblobSlice =
    typeof Blob !== 'undefined' &&
    (Blob.prototype.slice ||
      Blob.prototype.webkitSlice ||
      Blob.prototype.mozSlice)

  loadImage.blobSlice =
    hasblobSlice &&
    function() {
      var slice = this.slice || this.webkitSlice || this.mozSlice
      return slice.apply(this, arguments)
    }

  loadImage.metaDataParsers = {
    jpeg: {
      0xffe1: [], // APP1 marker
      0xffed: [] // APP13 marker
    }
  }

  // Parses image meta data and calls the callback with an object argument
  // with the following properties:
  // * imageHead: The complete image head as ArrayBuffer (Uint8Array for IE10)
  // The options argument accepts an object and supports the following
  // properties:
  // * maxMetaDataSize: Defines the maximum number of bytes to parse.
  // * disableImageHead: Disables creating the imageHead property.
  loadImage.parseMetaData = function(file, callback, options, data) {
    // eslint-disable-next-line no-param-reassign
    options = options || {}
    // eslint-disable-next-line no-param-reassign
    data = data || {}
    var that = this
    // 256 KiB should contain all EXIF/ICC/IPTC segments:
    var maxMetaDataSize = options.maxMetaDataSize || 262144
    var noMetaData = !(
      typeof DataView !== 'undefined' &&
      file &&
      file.size >= 12 &&
      file.type === 'image/jpeg' &&
      loadImage.blobSlice
    )
    if (
      noMetaData ||
      !loadImage.readFile(
        loadImage.blobSlice.call(file, 0, maxMetaDataSize),
        function(e) {
          if (e.target.error) {
            // FileReader error
            // eslint-disable-next-line no-console
            console.log(e.target.error)
            callback(data)
            return
          }
          // Note on endianness:
          // Since the marker and length bytes in JPEG files are always
          // stored in big endian order, we can leave the endian parameter
          // of the DataView methods undefined, defaulting to big endian.
          var buffer = e.target.result
          var dataView = new DataView(buffer)
          var offset = 2
          var maxOffset = dataView.byteLength - 4
          var headLength = offset
          var markerBytes
          var markerLength
          var parsers
          var i
          // Check for the JPEG marker (0xffd8):
          if (dataView.getUint16(0) === 0xffd8) {
            while (offset < maxOffset) {
              markerBytes = dataView.getUint16(offset)
              // Search for APPn (0xffeN) and COM (0xfffe) markers,
              // which contain application-specific meta-data like
              // Exif, ICC and IPTC data and text comments:
              if (
                (markerBytes >= 0xffe0 && markerBytes <= 0xffef) ||
                markerBytes === 0xfffe
              ) {
                // The marker bytes (2) are always followed by
                // the length bytes (2), indicating the length of the
                // marker segment, which includes the length bytes,
                // but not the marker bytes, so we add 2:
                markerLength = dataView.getUint16(offset + 2) + 2
                if (offset + markerLength > dataView.byteLength) {
                  // eslint-disable-next-line no-console
                  console.log('Invalid meta data: Invalid segment size.')
                  break
                }
                parsers = loadImage.metaDataParsers.jpeg[markerBytes]
                if (parsers) {
                  for (i = 0; i < parsers.length; i += 1) {
                    parsers[i].call(
                      that,
                      dataView,
                      offset,
                      markerLength,
                      data,
                      options
                    )
                  }
                }
                offset += markerLength
                headLength = offset
              } else {
                // Not an APPn or COM marker, probably safe to
                // assume that this is the end of the meta data
                break
              }
            }
            // Meta length must be longer than JPEG marker (2)
            // plus APPn marker (2), followed by length bytes (2):
            if (!options.disableImageHead && headLength > 6) {
              if (buffer.slice) {
                data.imageHead = buffer.slice(0, headLength)
              } else {
                // Workaround for IE10, which does not yet
                // support ArrayBuffer.slice:
                data.imageHead = new Uint8Array(buffer).subarray(0, headLength)
              }
            }
          } else {
            // eslint-disable-next-line no-console
            console.log('Invalid JPEG file: Missing JPEG marker.')
          }
          callback(data)
        },
        'readAsArrayBuffer'
      )
    ) {
      callback(data)
    }
  }

  // Determines if meta data should be loaded automatically:
  loadImage.hasMetaOption = function(options) {
    return options && options.meta
  }

  var originalTransform = loadImage.transform
  loadImage.transform = function(img, options, callback, file, data) {
    if (loadImage.hasMetaOption(options)) {
      loadImage.parseMetaData(
        file,
        function(data) {
          originalTransform.call(loadImage, img, options, callback, file, data)
        },
        options,
        data
      )
    } else {
      originalTransform.apply(loadImage, arguments)
    }
  }
})


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// turn {x: {val: 1, stiffness: 1, damping: 2}, y: 2} generated by
// `{x: spring(1, {stiffness: 1, damping: 2}), y: 2}` into {x: 1, y: 2}



exports.__esModule = true;
exports['default'] = stripStyle;

function stripStyle(style) {
  var ret = {};
  for (var key in style) {
    if (!Object.prototype.hasOwnProperty.call(style, key)) {
      continue;
    }
    ret[key] = typeof style[key] === 'number' ? style[key] : style[key].val;
  }
  return ret;
}

module.exports = exports['default'];

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var asap = __webpack_require__(15)

module.exports = Promise;
function Promise(fn) {
  if (typeof this !== 'object') throw new TypeError('Promises must be constructed via new')
  if (typeof fn !== 'function') throw new TypeError('not a function')
  var state = null
  var value = null
  var deferreds = []
  var self = this

  this.then = function(onFulfilled, onRejected) {
    return new self.constructor(function(resolve, reject) {
      handle(new Handler(onFulfilled, onRejected, resolve, reject))
    })
  }

  function handle(deferred) {
    if (state === null) {
      deferreds.push(deferred)
      return
    }
    asap(function() {
      var cb = state ? deferred.onFulfilled : deferred.onRejected
      if (cb === null) {
        (state ? deferred.resolve : deferred.reject)(value)
        return
      }
      var ret
      try {
        ret = cb(value)
      }
      catch (e) {
        deferred.reject(e)
        return
      }
      deferred.resolve(ret)
    })
  }

  function resolve(newValue) {
    try { //Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
      if (newValue === self) throw new TypeError('A promise cannot be resolved with itself.')
      if (newValue && (typeof newValue === 'object' || typeof newValue === 'function')) {
        var then = newValue.then
        if (typeof then === 'function') {
          doResolve(then.bind(newValue), resolve, reject)
          return
        }
      }
      state = true
      value = newValue
      finale()
    } catch (e) { reject(e) }
  }

  function reject(newValue) {
    state = false
    value = newValue
    finale()
  }

  function finale() {
    for (var i = 0, len = deferreds.length; i < len; i++)
      handle(deferreds[i])
    deferreds = null
  }

  doResolve(fn, resolve, reject)
}


function Handler(onFulfilled, onRejected, resolve, reject){
  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null
  this.onRejected = typeof onRejected === 'function' ? onRejected : null
  this.resolve = resolve
  this.reject = reject
}

/**
 * Take a potentially misbehaving resolver function and make sure
 * onFulfilled and onRejected are only called once.
 *
 * Makes no guarantees about asynchrony.
 */
function doResolve(fn, onFulfilled, onRejected) {
  var done = false;
  try {
    fn(function (value) {
      if (done) return
      done = true
      onFulfilled(value)
    }, function (reason) {
      if (done) return
      done = true
      onRejected(reason)
    })
  } catch (ex) {
    if (done) return
    done = true
    onRejected(ex)
  }
}


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process, setImmediate) {
// Use the fastest possible means to execute a task in a future turn
// of the event loop.

// linked list of tasks (single, with head node)
var head = {task: void 0, next: null};
var tail = head;
var flushing = false;
var requestFlush = void 0;
var isNodeJS = false;

function flush() {
    /* jshint loopfunc: true */

    while (head.next) {
        head = head.next;
        var task = head.task;
        head.task = void 0;
        var domain = head.domain;

        if (domain) {
            head.domain = void 0;
            domain.enter();
        }

        try {
            task();

        } catch (e) {
            if (isNodeJS) {
                // In node, uncaught exceptions are considered fatal errors.
                // Re-throw them synchronously to interrupt flushing!

                // Ensure continuation if the uncaught exception is suppressed
                // listening "uncaughtException" events (as domains does).
                // Continue in next event to avoid tick recursion.
                if (domain) {
                    domain.exit();
                }
                setTimeout(flush, 0);
                if (domain) {
                    domain.enter();
                }

                throw e;

            } else {
                // In browsers, uncaught exceptions are not fatal.
                // Re-throw them asynchronously to avoid slow-downs.
                setTimeout(function() {
                   throw e;
                }, 0);
            }
        }

        if (domain) {
            domain.exit();
        }
    }

    flushing = false;
}

if (typeof process !== "undefined" && process.nextTick) {
    // Node.js before 0.9. Note that some fake-Node environments, like the
    // Mocha test runner, introduce a `process` global without a `nextTick`.
    isNodeJS = true;

    requestFlush = function () {
        process.nextTick(flush);
    };

} else if (typeof setImmediate === "function") {
    // In IE10, Node.js 0.9+, or https://github.com/NobleJS/setImmediate
    if (typeof window !== "undefined") {
        requestFlush = setImmediate.bind(window, flush);
    } else {
        requestFlush = function () {
            setImmediate(flush);
        };
    }

} else if (typeof MessageChannel !== "undefined") {
    // modern browsers
    // http://www.nonblocking.io/2011/06/windownexttick.html
    var channel = new MessageChannel();
    channel.port1.onmessage = flush;
    requestFlush = function () {
        channel.port2.postMessage(0);
    };

} else {
    // old browsers
    requestFlush = function () {
        setTimeout(flush, 0);
    };
}

function asap(task) {
    tail = tail.next = {
        task: task,
        domain: isNodeJS && process.domain,
        next: null
    };

    if (!flushing) {
        flushing = true;
        requestFlush();
    }
};

module.exports = asap;


/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(11), __webpack_require__(141).setImmediate))

/***/ }),
/* 16 */
/***/ (function(module, exports) {

(function(self) {
  'use strict';

  if (self.fetch) {
    return
  }

  var support = {
    searchParams: 'URLSearchParams' in self,
    iterable: 'Symbol' in self && 'iterator' in Symbol,
    blob: 'FileReader' in self && 'Blob' in self && (function() {
      try {
        new Blob()
        return true
      } catch(e) {
        return false
      }
    })(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]'
    ]

    var isDataView = function(obj) {
      return obj && DataView.prototype.isPrototypeOf(obj)
    }

    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
    }
  }

  function normalizeName(name) {
    if (typeof name !== 'string') {
      name = String(name)
    }
    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value) {
    if (typeof value !== 'string') {
      value = String(value)
    }
    return value
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items) {
    var iterator = {
      next: function() {
        var value = items.shift()
        return {done: value === undefined, value: value}
      }
    }

    if (support.iterable) {
      iterator[Symbol.iterator] = function() {
        return iterator
      }
    }

    return iterator
  }

  function Headers(headers) {
    this.map = {}

    if (headers instanceof Headers) {
      headers.forEach(function(value, name) {
        this.append(name, value)
      }, this)
    } else if (Array.isArray(headers)) {
      headers.forEach(function(header) {
        this.append(header[0], header[1])
      }, this)
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name])
      }, this)
    }
  }

  Headers.prototype.append = function(name, value) {
    name = normalizeName(name)
    value = normalizeValue(value)
    var oldValue = this.map[name]
    this.map[name] = oldValue ? oldValue+','+value : value
  }

  Headers.prototype['delete'] = function(name) {
    delete this.map[normalizeName(name)]
  }

  Headers.prototype.get = function(name) {
    name = normalizeName(name)
    return this.has(name) ? this.map[name] : null
  }

  Headers.prototype.has = function(name) {
    return this.map.hasOwnProperty(normalizeName(name))
  }

  Headers.prototype.set = function(name, value) {
    this.map[normalizeName(name)] = normalizeValue(value)
  }

  Headers.prototype.forEach = function(callback, thisArg) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this)
      }
    }
  }

  Headers.prototype.keys = function() {
    var items = []
    this.forEach(function(value, name) { items.push(name) })
    return iteratorFor(items)
  }

  Headers.prototype.values = function() {
    var items = []
    this.forEach(function(value) { items.push(value) })
    return iteratorFor(items)
  }

  Headers.prototype.entries = function() {
    var items = []
    this.forEach(function(value, name) { items.push([name, value]) })
    return iteratorFor(items)
  }

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
  }

  function consumed(body) {
    if (body.bodyUsed) {
      return Promise.reject(new TypeError('Already read'))
    }
    body.bodyUsed = true
  }

  function fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
      reader.onload = function() {
        resolve(reader.result)
      }
      reader.onerror = function() {
        reject(reader.error)
      }
    })
  }

  function readBlobAsArrayBuffer(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsArrayBuffer(blob)
    return promise
  }

  function readBlobAsText(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsText(blob)
    return promise
  }

  function readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf)
    var chars = new Array(view.length)

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i])
    }
    return chars.join('')
  }

  function bufferClone(buf) {
    if (buf.slice) {
      return buf.slice(0)
    } else {
      var view = new Uint8Array(buf.byteLength)
      view.set(new Uint8Array(buf))
      return view.buffer
    }
  }

  function Body() {
    this.bodyUsed = false

    this._initBody = function(body) {
      this._bodyInit = body
      if (!body) {
        this._bodyText = ''
      } else if (typeof body === 'string') {
        this._bodyText = body
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString()
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer)
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer])
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body)
      } else {
        throw new Error('unsupported BodyInit type')
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8')
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type)
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
        }
      }
    }

    if (support.blob) {
      this.blob = function() {
        var rejected = consumed(this)
        if (rejected) {
          return rejected
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob)
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob')
        } else {
          return Promise.resolve(new Blob([this._bodyText]))
        }
      }

      this.arrayBuffer = function() {
        if (this._bodyArrayBuffer) {
          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
        } else {
          return this.blob().then(readBlobAsArrayBuffer)
        }
      }
    }

    this.text = function() {
      var rejected = consumed(this)
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text')
      } else {
        return Promise.resolve(this._bodyText)
      }
    }

    if (support.formData) {
      this.formData = function() {
        return this.text().then(decode)
      }
    }

    this.json = function() {
      return this.text().then(JSON.parse)
    }

    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']

  function normalizeMethod(method) {
    var upcased = method.toUpperCase()
    return (methods.indexOf(upcased) > -1) ? upcased : method
  }

  function Request(input, options) {
    options = options || {}
    var body = options.body

    if (input instanceof Request) {
      if (input.bodyUsed) {
        throw new TypeError('Already read')
      }
      this.url = input.url
      this.credentials = input.credentials
      if (!options.headers) {
        this.headers = new Headers(input.headers)
      }
      this.method = input.method
      this.mode = input.mode
      if (!body && input._bodyInit != null) {
        body = input._bodyInit
        input.bodyUsed = true
      }
    } else {
      this.url = String(input)
    }

    this.credentials = options.credentials || this.credentials || 'omit'
    if (options.headers || !this.headers) {
      this.headers = new Headers(options.headers)
    }
    this.method = normalizeMethod(options.method || this.method || 'GET')
    this.mode = options.mode || this.mode || null
    this.referrer = null

    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    this._initBody(body)
  }

  Request.prototype.clone = function() {
    return new Request(this, { body: this._bodyInit })
  }

  function decode(body) {
    var form = new FormData()
    body.trim().split('&').forEach(function(bytes) {
      if (bytes) {
        var split = bytes.split('=')
        var name = split.shift().replace(/\+/g, ' ')
        var value = split.join('=').replace(/\+/g, ' ')
        form.append(decodeURIComponent(name), decodeURIComponent(value))
      }
    })
    return form
  }

  function parseHeaders(rawHeaders) {
    var headers = new Headers()
    rawHeaders.split(/\r?\n/).forEach(function(line) {
      var parts = line.split(':')
      var key = parts.shift().trim()
      if (key) {
        var value = parts.join(':').trim()
        headers.append(key, value)
      }
    })
    return headers
  }

  Body.call(Request.prototype)

  function Response(bodyInit, options) {
    if (!options) {
      options = {}
    }

    this.type = 'default'
    this.status = 'status' in options ? options.status : 200
    this.ok = this.status >= 200 && this.status < 300
    this.statusText = 'statusText' in options ? options.statusText : 'OK'
    this.headers = new Headers(options.headers)
    this.url = options.url || ''
    this._initBody(bodyInit)
  }

  Body.call(Response.prototype)

  Response.prototype.clone = function() {
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      headers: new Headers(this.headers),
      url: this.url
    })
  }

  Response.error = function() {
    var response = new Response(null, {status: 0, statusText: ''})
    response.type = 'error'
    return response
  }

  var redirectStatuses = [301, 302, 303, 307, 308]

  Response.redirect = function(url, status) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    return new Response(null, {status: status, headers: {location: url}})
  }

  self.Headers = Headers
  self.Request = Request
  self.Response = Response

  self.fetch = function(input, init) {
    return new Promise(function(resolve, reject) {
      var request = new Request(input, init)
      var xhr = new XMLHttpRequest()

      xhr.onload = function() {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        }
        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
        var body = 'response' in xhr ? xhr.response : xhr.responseText
        resolve(new Response(body, options))
      }

      xhr.onerror = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.ontimeout = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.open(request.method, request.url, true)

      if (request.credentials === 'include') {
        xhr.withCredentials = true
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob'
      }

      request.headers.forEach(function(value, name) {
        xhr.setRequestHeader(name, value)
      })

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
    })
  }
  self.fetch.polyfill = true
})(typeof self !== 'undefined' ? self : this);


/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 18 */
/***/ (function(module, exports) {

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

module.exports = _interopRequireDefault;

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var fnToStr = Function.prototype.toString;

var constructorRegex = /^\s*class\b/;
var isES6ClassFn = function isES6ClassFunction(value) {
	try {
		var fnStr = fnToStr.call(value);
		return constructorRegex.test(fnStr);
	} catch (e) {
		return false; // not a function
	}
};

var tryFunctionObject = function tryFunctionToStr(value) {
	try {
		if (isES6ClassFn(value)) { return false; }
		fnToStr.call(value);
		return true;
	} catch (e) {
		return false;
	}
};
var toStr = Object.prototype.toString;
var fnClass = '[object Function]';
var genClass = '[object GeneratorFunction]';
var hasToStringTag = typeof Symbol === 'function' && typeof Symbol.toStringTag === 'symbol';

module.exports = function isCallable(value) {
	if (!value) { return false; }
	if (typeof value !== 'function' && typeof value !== 'object') { return false; }
	if (typeof value === 'function' && !value.prototype) { return true; }
	if (hasToStringTag) { return tryFunctionObject(value); }
	if (isES6ClassFn(value)) { return false; }
	var strClass = toStr.call(value);
	return strClass === fnClass || strClass === genClass;
};


/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(21);

module.exports = bind.call(Function.call, Object.prototype.hasOwnProperty);


/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var implementation = __webpack_require__(85);

module.exports = Function.prototype.bind || implementation;


/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// currently used to initiate the velocity style object to 0


exports.__esModule = true;
exports['default'] = mapToZero;

function mapToZero(obj) {
  var ret = {};
  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      ret[key] = 0;
    }
  }
  return ret;
}

module.exports = exports['default'];

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// stepper is used a lot. Saves allocation to return the same array wrapper.
// This is fine and danger-free against mutations because the callsite
// immediately destructures it and gets the numbers inside without passing the


exports.__esModule = true;
exports["default"] = stepper;

var reusedTuple = [0, 0];

function stepper(secondPerFrame, x, v, destX, k, b, precision) {
  // Spring stiffness, in kg / s^2

  // for animations, destX is really spring length (spring at rest). initial
  // position is considered as the stretched/compressed position of a spring
  var Fspring = -k * (x - destX);

  // Damping, in kg / s
  var Fdamper = -b * v;

  // usually we put mass here, but for animation purposes, specifying mass is a
  // bit redundant. you could simply adjust k and b accordingly
  // let a = (Fspring + Fdamper) / mass;
  var a = Fspring + Fdamper;

  var newV = v + a * secondPerFrame;
  var newX = x + newV * secondPerFrame;

  if (Math.abs(newV) < precision && Math.abs(newX - destX) < precision) {
    reusedTuple[0] = destX;
    reusedTuple[1] = 0;
    return reusedTuple;
  }

  reusedTuple[0] = newX;
  reusedTuple[1] = newV;
  return reusedTuple;
}

module.exports = exports["default"];
// array reference around.

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {// Generated by CoffeeScript 1.7.1
(function() {
  var getNanoSeconds, hrtime, loadTime;

  if ((typeof performance !== "undefined" && performance !== null) && performance.now) {
    module.exports = function() {
      return performance.now();
    };
  } else if ((typeof process !== "undefined" && process !== null) && process.hrtime) {
    module.exports = function() {
      return (getNanoSeconds() - loadTime) / 1e6;
    };
    hrtime = process.hrtime;
    getNanoSeconds = function() {
      var hr;
      hr = hrtime();
      return hr[0] * 1e9 + hr[1];
    };
    loadTime = getNanoSeconds();
  } else if (Date.now) {
    module.exports = function() {
      return Date.now() - loadTime;
    };
    loadTime = Date.now();
  } else {
    module.exports = function() {
      return new Date().getTime() - loadTime;
    };
    loadTime = new Date().getTime();
  }

}).call(this);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(11)))

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var now = __webpack_require__(114)
  , root = typeof window === 'undefined' ? global : window
  , vendors = ['moz', 'webkit']
  , suffix = 'AnimationFrame'
  , raf = root['request' + suffix]
  , caf = root['cancel' + suffix] || root['cancelRequest' + suffix]

for(var i = 0; !raf && i < vendors.length; i++) {
  raf = root[vendors[i] + 'Request' + suffix]
  caf = root[vendors[i] + 'Cancel' + suffix]
      || root[vendors[i] + 'CancelRequest' + suffix]
}

// Some versions of FF have rAF but not cAF
if(!raf || !caf) {
  var last = 0
    , id = 0
    , queue = []
    , frameDuration = 1000 / 60

  raf = function(callback) {
    if(queue.length === 0) {
      var _now = now()
        , next = Math.max(0, frameDuration - (_now - last))
      last = next + _now
      setTimeout(function() {
        var cp = queue.slice(0)
        // Clear queue here to prevent
        // callbacks from appending listeners
        // to the current frame's queue
        queue.length = 0
        for(var i = 0; i < cp.length; i++) {
          if(!cp[i].cancelled) {
            try{
              cp[i].callback(last)
            } catch(e) {
              setTimeout(function() { throw e }, 0)
            }
          }
        }
      }, Math.round(next))
    }
    queue.push({
      handle: ++id,
      callback: callback,
      cancelled: false
    })
    return id
  }

  caf = function(handle) {
    for(var i = 0; i < queue.length; i++) {
      if(queue[i].handle === handle) {
        queue[i].cancelled = true
      }
    }
  }
}

module.exports = function(fn) {
  // Wrap in a new function to prevent
  // `cancel` potentially being assigned
  // to the native rAF function
  return raf.call(root, fn)
}
module.exports.cancel = function() {
  caf.apply(root, arguments)
}
module.exports.polyfill = function(object) {
  if (!object) {
    object = root;
  }
  object.requestAnimationFrame = raf
  object.cancelAnimationFrame = caf
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(10)))

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// usage assumption: currentStyle values have already been rendered but it says
// nothing of whether currentStyle is stale (see unreadPropStyle)


exports.__esModule = true;
exports['default'] = shouldStopAnimation;

function shouldStopAnimation(currentStyle, style, currentVelocity) {
  for (var key in style) {
    if (!Object.prototype.hasOwnProperty.call(style, key)) {
      continue;
    }

    if (currentVelocity[key] !== 0) {
      return false;
    }

    var styleValue = typeof style[key] === 'number' ? style[key] : style[key].val;
    // stepper will have already taken care of rounding precision errors, so
    // won't have such thing as 0.9999 !=== 1
    if (currentStyle[key] !== styleValue) {
      return false;
    }
  }

  return true;
}

module.exports = exports['default'];

/***/ }),
/* 27 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export tresholds */
/* unused harmony export getLevelForValue */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return findSkintypeFromFilters; });
/* harmony export (immutable) */ __webpack_exports__["i"] = sumMeasures;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return inStoreIconSetup; });
/* harmony export (immutable) */ __webpack_exports__["h"] = rgbToHex;
/* harmony export (immutable) */ __webpack_exports__["b"] = converProductColorToRGB;
/* harmony export (immutable) */ __webpack_exports__["e"] = getFinishFromProduct;
/* harmony export (immutable) */ __webpack_exports__["d"] = getCoverageFromProduct;
/* unused harmony export isObject */
/* harmony export (immutable) */ __webpack_exports__["g"] = mergeDeep;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return camelize; });
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}// low med high
var tresholds={eyebag:[0.3,0.6],eyebags:[0.3,0.6],dark_circle:[0.3,0.6],'dark circles':[0.3,0.6],wrinkle:[0.3,0.5],wrinkles:[0.3,0.5],redness:[0.3,0.6],hyperpigmentation:[0.3,0.6],default:[0.3,0.6]};var getLevelForValue=function getLevelForValue(type,value){if(!tresholds.hasOwnProperty(type)){type='default';}var level='low';if(value>tresholds[type][0]){level='med';}if(value>tresholds[type][1]){level='high';}return level;};var findSkintypeFromFilters=function findSkintypeFromFilters(filters){for(var key in filters){if(filters.hasOwnProperty(key)){var value=filters[key];if(key.endsWith('_skin_ui')&&value>0){return key;}}}return null;};function sumMeasures(data){var o={};data.map(function(result){if(Array.isArray(result.sum_measures)&&result.sum_measures.length<=0){var total=0;result.measurement_locations.map(function(loc){total+=loc.value;return true;});var avg=total/result.measurement_locations.length;result.sum_measures.push({description:result.description,value:avg});}o[result.description]=result;return true;});return o;}var inStoreIconSetup={'Face shape':{key:'Makeup',requestKey:'face_shape_cv',withDescription:'Face shape',icon:'shape',label:'icon_shape',order:1,enum:{'1':'Diamond','2':'Heart','3':'Long','4':'Oval','5':'Round','6':'Square'},sdkMethod:'highlightFaceShape',zoom:true},'Eye color':{key:'Makeup',requestKey:'eye_color_cv',withDescription:'Eye color',icon:'eyecolor',label:'icon_eyecolor',order:2,enum:{'1':'Brown','2':'Blue','3':'Green'},sdkMethod:'highlightEyeColor',zoom:true},Undertone:{key:'Makeup',requestKey:'undertone_cv',withDescription:'Skin undertone',icon:'undertone',label:'icon_undertone',order:3,enum:{'-1':'Cool','0':'Neutral','1':'Warm'},sdkMethod:'highlightSkinUndertone',zoom:true},Foundation:{key:'Makeup',requestKey:'skintone_color_cv',withDescription:'Skin foundation RGB',icon:'skintoneColor',label:'icon_skintoneColor',order:4,type:'skintoneColor',sdkMethod:'highlightSkinFoundation',zoom:true},Skintone:{key:'sdkMethod',requestKey:'skintone',withDescription:'',icon:'undertone',label:'icon_skintone',order:5,type:'skintone',enum:{'1':'Light','2':'Fair','3':'Medium','4':'Olive','5':'Brown','6':'Dark brown'},sdkMethod:'highlightCheekArea',zoom:true},'Dark circles':{key:'eyes',requestKey:'dark_circles_cv',withDescription:'dark circles',icon:'darkcircles',label:'icon_darkcircles',order:6,sdkMethod:'highlightDarkcircles',zoom:true,range:{none:{min:0,max:0.05,color:'gray'},low:{min:0.05,max:0.3,color:'#4cfc66'},medium:{min:0.3,max:0.6,color:'#fcd44c'},high:{min:0.6,max:1,color:'#fc4c4c'}}},'Wrinkles & Lines':{key:'wrinkles',requestKey:'wrinkles_cv',withDescription:'wrinkles',icon:'wrinkleslines',label:'icon_wrinkleslines',order:7,sdkMethod:'highlightWrinkles',zoom:true,range:{none:{min:0,max:0.05,color:'gray'},low:{min:0.05,max:0.3,color:'#4cfc66'},medium:{min:0.3,max:0.6,color:'#fcd44c'},high:{min:0.6,max:1,color:'#fc4c4c'}}},'Wrinkles Individually':{key:'wrinkles',requestKey:'wrinkles_cv',withDescription:'wrinkles',icon:'wrinkleslines',label:'icon_wrinkleslines',order:7,sdkMethod:'highlightWrinklesIndividually',zoom:false,range:{none:{min:0,max:0.05,color:'gray'},low:{min:0.05,max:0.3,color:'#4cfc66'},medium:{min:0.3,max:0.6,color:'#fcd44c'},high:{min:0.6,max:1,color:'#fc4c4c'}}},'Pigment Variation':{key:'hyperpigmentation',requestKey:'hyperpigmentation_cv',withDescription:'hyperpigmentation',icon:'pigmentvariation',label:'icon_pigmentvariation',order:8,sdkMethod:'highlightHyperpigmentation',zoom:true,range:{none:{min:0,max:0.05,color:'gray'},low:{min:0.05,max:0.3,color:'#4cfc66'},medium:{min:0.3,max:0.6,color:'#fcd44c'},high:{min:0.6,max:1,color:'#fc4c4c'}}},'Pigment Variation Individually':{key:'hyperpigmentation',requestKey:'hyperpigmentation_cv',withDescription:'hyperpigmentation',icon:'pigmentvariation',label:'icon_pigmentvariation',order:8,sdkMethod:'highlightHyperpigmentationIndividually',zoom:false,range:{none:{min:0,max:0.05,color:'gray'},low:{min:0.05,max:0.3,color:'#4cfc66'},medium:{min:0.3,max:0.6,color:'#fcd44c'},high:{min:0.6,max:1,color:'#fc4c4c'}}},'Eye bags':{key:'eyes',requestKey:'eyebags_cv',withDescription:'eyebags',icon:'eyebags',label:'icon_eyebags',order:9,sdkMethod:'highlightEyebags',zoom:true,range:{none:{min:0,max:0.05,color:'gray'},low:{min:0.05,max:0.3,color:'#4cfc66'},medium:{min:0.3,max:0.6,color:'#fcd44c'},high:{min:0.6,max:1,color:'#fc4c4c'}}},Redness:{key:'redness',requestKey:'redness_cv',withDescription:'redness',icon:'redness',label:'icon_redness',order:10,sdkMethod:'highlightRedness',zoom:true,range:{none:{min:0,max:0.05,color:'gray'},low:{min:0.05,max:0.3,color:'#4cfc66'},medium:{min:0.3,max:0.6,color:'#fcd44c'},high:{min:0.6,max:1,color:'#fc4c4c'}}},Texture:{key:'texture',requestKey:'texture_cv',withDescription:'texture',icon:'texture',label:'icon_texture',order:11,sdkMethod:'highlightTexture',zoom:true,range:{none:{min:0,max:0.05,color:'gray'},low:{min:0.05,max:0.3,color:'#4cfc66'},medium:{min:0.3,max:0.6,color:'#fcd44c'},high:{min:0.6,max:1,color:'#fc4c4c'}}},Radiance:{key:'smoothness',requestKey:'smoothness_cv',withDescription:'smoothness',icon:'radiance',label:'icon_radiance',order:12,sdkMethod:'highlightSmoothness',zoom:true,range:{none:{min:0,max:0.05,color:'gray'},low:{min:0.05,max:0.3,color:'#4cfc66'},medium:{min:0.3,max:0.6,color:'#fcd44c'},high:{min:0.6,max:1,color:'#fc4c4c'}}},'Skin Shine':{key:'Skin shine',requestKey:'skin_shine_cv',withDescription:'Skin shine',icon:'skinShine',label:'icon_skin_shine',order:13,sdkMethod:'highlightSkinShine',zoom:false,range:{none:{min:0,max:0.05,color:'gray'},low:{min:0.05,max:0.3,color:'#4cfc66'},medium:{min:0.3,max:0.6,color:'#fcd44c'},high:{min:0.6,max:1,color:'#fc4c4c'}}},Acne:{key:'acne',requestKey:'acne_cv',withDescription:'acne',icon:'acne',label:'icon_acne',order:14,sdkMethod:'highlightAcneIndividually',zoom:false,range:{none:{min:0,max:0.05,color:'gray'},low:{min:0.05,max:0.3,color:'#4cfc66'},medium:{min:0.3,max:0.6,color:'#fcd44c'},high:{min:0.6,max:1,color:'#fc4c4c'}}}};function rgbToHex(rgb){if(!rgb||rgb.length<=0){return null;}var hexValue='#';var _iteratorNormalCompletion=true;var _didIteratorError=false;var _iteratorError=undefined;try{for(var _iterator=rgb[Symbol.iterator](),_step;!(_iteratorNormalCompletion=(_step=_iterator.next()).done);_iteratorNormalCompletion=true){var rgbValue=_step.value;hexValue+=rgbValueToHex(rgbValue).toUpperCase();}}catch(err){_didIteratorError=true;_iteratorError=err;}finally{try{if(!_iteratorNormalCompletion&&_iterator.return){_iterator.return();}}finally{if(_didIteratorError){throw _iteratorError;}}}return hexValue;}function rgbValueToHex(rgb){var hex=Number(rgb).toString(16);if(hex.length<2){hex='0'+hex;}return hex;}function hexToRgb(_ref){var hex=_ref.hex;var bigint=parseInt(hex,16);var r=bigint>>16&255;var g=bigint>>8&255;var b=bigint&255;return[r,g,b];}function converProductColorToRGB(_ref2){var product=_ref2.product;var colorExpression='color_hex_';var hex=product.filter_match.find(function(filterMatch){return filterMatch.indexOf(colorExpression)===0;});if(!hex){return null;}hex=hex.replace(colorExpression,'');hex=hex.replace('#','');hex=hex.replace('0x','');return hexToRgb({hex:hex});}var sdkFinishReference={matte:'matte',sheer:'gloss',satin:'natural'};function getFinishFromProduct(_ref3){var product=_ref3.product;var finishExpression='lipstick_finish_matte_ui';var finish=product.filter_match.find(function(filterMatch){return filterMatch.indexOf(finishExpression)===0;});if(!finish){return null;}finish=finish.replace('lipstick_finish_','');finish=finish.replace('_ui','');return sdkFinishReference[finish]||'natural';}var coverageValues={AR:{full:1,medium:0.8,light:0.6},liveAR:{full:1,medium:0.8,light:0.6}};function getCoverageFromProduct(_ref4){var product=_ref4.product,filters=_ref4.filters,mode=_ref4.mode;var coverageString='coverage_ui';var coverage='full';//default value
var productCoverage=product.filter_match.find(function(filterMatch){return filterMatch.indexOf(coverageString)>=0;});if(productCoverage){//we have found coverage info for product
coverage=productCoverage.replace('_'+coverageString,'');}else{//No product information . We need to find if user has set prefered foundation coverage in questions
var filterCoverage=Object.keys(filters).filter(function(filterKey){return filterKey.indexOf(coverageString)>=0;}).find(function(filterKey){return filters[filterKey]===1;});if(filterCoverage){coverage=filterCoverage.replace('_'+coverageString,'');}}return coverageValues[mode][coverage]||0.8;}function isObject(item){return item&&(typeof item==='undefined'?'undefined':_typeof(item))==='object'&&!Array.isArray(item);}function mergeDeep(target){for(var _len=arguments.length,sources=Array(_len>1?_len-1:0),_key=1;_key<_len;_key++){sources[_key-1]=arguments[_key];}if(!sources.length)return target;var source=sources.shift();if(isObject(target)&&isObject(source)){for(var key in source){if(isObject(source[key])){if(!target[key])Object.assign(target,_defineProperty({},key,{}));mergeDeep(target[key],source[key]);}else{Object.assign(target,_defineProperty({},key,source[key]));}}}return mergeDeep.apply(undefined,[target].concat(sources));}var camelize=function camelize(str){return str.replace(/(?:^\w|[A-Z]|\b\w|\s+)/g,function(match,index){if(+match===0)return'';// or if (/\s+/.test(match)) for white spaces
return index===0?match.toLowerCase():match.toUpperCase();});};

/***/ }),
/* 28 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return api_host; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return default_environment; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return user_id; });
var api_host={test:'https://partner-test.revieve.com',prod:'https://partner.revieve.com',cn:'https://partner.revieve.cn'};var default_environment='test';var user_id='instoreuser';

/***/ }),
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Router__ = __webpack_require__(30);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Router__["a" /* default */]);

/***/ }),
/* 30 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






/**
 * The public API for putting history on context.
 */

var Router = function (_React$Component) {
  _inherits(Router, _React$Component);

  function Router() {
    var _temp, _this, _ret;

    _classCallCheck(this, Router);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      match: _this.computeMatch(_this.props.history.location.pathname)
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Router.prototype.getChildContext = function getChildContext() {
    return {
      router: _extends({}, this.context.router, {
        history: this.props.history,
        route: {
          location: this.props.history.location,
          match: this.state.match
        }
      })
    };
  };

  Router.prototype.computeMatch = function computeMatch(pathname) {
    return {
      path: "/",
      url: "/",
      params: {},
      isExact: pathname === "/"
    };
  };

  Router.prototype.componentWillMount = function componentWillMount() {
    var _this2 = this;

    var _props = this.props,
        children = _props.children,
        history = _props.history;


    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(children == null || __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.count(children) === 1, "A <Router> may have only one child element");

    // Do this here so we can setState when a <Redirect> changes the
    // location in componentWillMount. This happens e.g. when doing
    // server rendering using a <StaticRouter>.
    this.unlisten = history.listen(function () {
      _this2.setState({
        match: _this2.computeMatch(history.location.pathname)
      });
    });
  };

  Router.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(this.props.history === nextProps.history, "You cannot change <Router history>");
  };

  Router.prototype.componentWillUnmount = function componentWillUnmount() {
    this.unlisten();
  };

  Router.prototype.render = function render() {
    var children = this.props.children;

    return children ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.only(children) : null;
  };

  return Router;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

Router.propTypes = {
  history: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node
};
Router.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
Router.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Router);

/***/ }),
/* 31 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_path_to_regexp__);


var patternCache = {};
var cacheLimit = 10000;
var cacheCount = 0;

var compilePath = function compilePath(pattern, options) {
  var cacheKey = "" + options.end + options.strict + options.sensitive;
  var cache = patternCache[cacheKey] || (patternCache[cacheKey] = {});

  if (cache[pattern]) return cache[pattern];

  var keys = [];
  var re = __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default()(pattern, keys, options);
  var compiledPattern = { re: re, keys: keys };

  if (cacheCount < cacheLimit) {
    cache[pattern] = compiledPattern;
    cacheCount++;
  }

  return compiledPattern;
};

/**
 * Public API for matching a URL pathname to a path pattern.
 */
var matchPath = function matchPath(pathname) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var parent = arguments[2];

  if (typeof options === "string") options = { path: options };

  var _options = options,
      path = _options.path,
      _options$exact = _options.exact,
      exact = _options$exact === undefined ? false : _options$exact,
      _options$strict = _options.strict,
      strict = _options$strict === undefined ? false : _options$strict,
      _options$sensitive = _options.sensitive,
      sensitive = _options$sensitive === undefined ? false : _options$sensitive;


  if (path == null) return parent;

  var _compilePath = compilePath(path, { end: exact, strict: strict, sensitive: sensitive }),
      re = _compilePath.re,
      keys = _compilePath.keys;

  var match = re.exec(pathname);

  if (!match) return null;

  var url = match[0],
      values = match.slice(1);

  var isExact = pathname === url;

  if (exact && !isExact) return null;

  return {
    path: path, // the path pattern used to match
    url: path === "/" && url === "" ? "/" : url, // the matched portion of the URL
    isExact: isExact, // whether or not we matched exactly
    params: keys.reduce(function (memo, key, index) {
      memo[key.name] = values[index];
      return memo;
    }, {})
  };
};

/* harmony default export */ __webpack_exports__["a"] = (matchPath);

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function checkDCE() {
  /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */
  if (
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' ||
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function'
  ) {
    return;
  }
  if (false) {
    // This branch is unreachable because this function is only called
    // in production, but the condition is true only in development.
    // Therefore if the branch is still here, dead code elimination wasn't
    // properly applied.
    // Don't change the message. React DevTools relies on it. Also make sure
    // this message doesn't occur elsewhere in this function, or it will cause
    // a false positive.
    throw new Error('^_^');
  }
  try {
    // Verify that the code above has been dead code eliminated (DCE'd).
    __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
  } catch (err) {
    // DevTools shouldn't crash React, no matter what.
    // We should still report in case we break this code.
    console.error(err);
  }
}

if (true) {
  // DCE check should happen before ReactDOM bundle executes so that
  // DevTools can report bad minification during injection.
  checkDCE();
  module.exports = __webpack_require__(60);
} else {
  module.exports = require('./cjs/react-dom.development.js');
}


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

var _default = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.nameShape = undefined;
exports.transitionTimeout = transitionTimeout;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function transitionTimeout(transitionType) {
  var timeoutPropName = 'transition' + transitionType + 'Timeout';
  var enabledPropName = 'transition' + transitionType;

  return function (props) {
    // If the transition is enabled
    if (props[enabledPropName]) {
      // If no timeout duration is provided
      if (props[timeoutPropName] == null) {
        return new Error(timeoutPropName + ' wasn\'t supplied to CSSTransitionGroup: ' + 'this can cause unreliable animations and won\'t be supported in ' + 'a future version of React. See ' + 'https://fb.me/react-animation-transition-group-timeout for more ' + 'information.');

        // If the duration isn't a number
      } else if (typeof props[timeoutPropName] !== 'number') {
        return new Error(timeoutPropName + ' must be a number (in milliseconds)');
      }
    }

    return null;
  };
}

var nameShape = exports.nameShape = _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
  enter: _propTypes2.default.string,
  leave: _propTypes2.default.string,
  active: _propTypes2.default.string
}), _propTypes2.default.shape({
  enter: _propTypes2.default.string,
  enterActive: _propTypes2.default.string,
  leave: _propTypes2.default.string,
  leaveActive: _propTypes2.default.string,
  appear: _propTypes2.default.string,
  appearActive: _propTypes2.default.string
})]);

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var keys = __webpack_require__(87);
var hasSymbols = typeof Symbol === 'function' && typeof Symbol('foo') === 'symbol';

var toStr = Object.prototype.toString;
var concat = Array.prototype.concat;
var origDefineProperty = Object.defineProperty;

var isFunction = function (fn) {
	return typeof fn === 'function' && toStr.call(fn) === '[object Function]';
};

var arePropertyDescriptorsSupported = function () {
	var obj = {};
	try {
		origDefineProperty(obj, 'x', { enumerable: false, value: obj });
		// eslint-disable-next-line no-unused-vars, no-restricted-syntax
		for (var _ in obj) { // jscs:ignore disallowUnusedVariables
			return false;
		}
		return obj.x === obj;
	} catch (e) { /* this is IE 8. */
		return false;
	}
};
var supportsDescriptors = origDefineProperty && arePropertyDescriptorsSupported();

var defineProperty = function (object, name, value, predicate) {
	if (name in object && (!isFunction(predicate) || !predicate())) {
		return;
	}
	if (supportsDescriptors) {
		origDefineProperty(object, name, {
			configurable: true,
			enumerable: false,
			value: value,
			writable: true
		});
	} else {
		object[name] = value;
	}
};

var defineProperties = function (object, map) {
	var predicates = arguments.length > 2 ? arguments[2] : {};
	var props = keys(map);
	if (hasSymbols) {
		props = concat.call(props, Object.getOwnPropertySymbols(map));
	}
	for (var i = 0; i < props.length; i += 1) {
		defineProperty(object, props[i], map[props[i]], predicates[props[i]]);
	}
};

defineProperties.supportsDescriptors = !!supportsDescriptors;

module.exports = defineProperties;


/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var toStr = Object.prototype.toString;

module.exports = function isArguments(value) {
	var str = toStr.call(value);
	var isArgs = str === '[object Arguments]';
	if (!isArgs) {
		isArgs = str !== '[object Array]' &&
			value !== null &&
			typeof value === 'object' &&
			typeof value.length === 'number' &&
			value.length >= 0 &&
			toStr.call(value.callee) === '[object Function]';
	}
	return isArgs;
};


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(21);
var ES = __webpack_require__(89);
var replace = bind.call(Function.call, String.prototype.replace);

/* eslint-disable no-control-regex */
var leftWhitespace = /^[\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF]+/;
var rightWhitespace = /[\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF]+$/;
/* eslint-enable no-control-regex */

module.exports = function trim() {
	var S = ES.ToString(ES.CheckObjectCoercible(this));
	return replace(replace(S, leftWhitespace, ''), rightWhitespace, '');
};


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* globals
	Set,
	Map,
	WeakSet,
	WeakMap,

	Promise,

	Symbol,
	Proxy,

	Atomics,
	SharedArrayBuffer,

	ArrayBuffer,
	DataView,
	Uint8Array,
	Float32Array,
	Float64Array,
	Int8Array,
	Int16Array,
	Int32Array,
	Uint8ClampedArray,
	Uint16Array,
	Uint32Array,
*/

var undefined; // eslint-disable-line no-shadow-restricted-names

var ThrowTypeError = Object.getOwnPropertyDescriptor
	? (function () { return Object.getOwnPropertyDescriptor(arguments, 'callee').get; }())
	: function () { throw new TypeError(); };

var hasSymbols = typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol';

var getProto = Object.getPrototypeOf || function (x) { return x.__proto__; }; // eslint-disable-line no-proto

var generator; // = function * () {};
var generatorFunction = generator ? getProto(generator) : undefined;
var asyncFn; // async function() {};
var asyncFunction = asyncFn ? asyncFn.constructor : undefined;
var asyncGen; // async function * () {};
var asyncGenFunction = asyncGen ? getProto(asyncGen) : undefined;
var asyncGenIterator = asyncGen ? asyncGen() : undefined;

var TypedArray = typeof Uint8Array === 'undefined' ? undefined : getProto(Uint8Array);

var INTRINSICS = {
	'$ %Array%': Array,
	'$ %ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined : ArrayBuffer,
	'$ %ArrayBufferPrototype%': typeof ArrayBuffer === 'undefined' ? undefined : ArrayBuffer.prototype,
	'$ %ArrayIteratorPrototype%': hasSymbols ? getProto([][Symbol.iterator]()) : undefined,
	'$ %ArrayPrototype%': Array.prototype,
	'$ %ArrayProto_entries%': Array.prototype.entries,
	'$ %ArrayProto_forEach%': Array.prototype.forEach,
	'$ %ArrayProto_keys%': Array.prototype.keys,
	'$ %ArrayProto_values%': Array.prototype.values,
	'$ %AsyncFromSyncIteratorPrototype%': undefined,
	'$ %AsyncFunction%': asyncFunction,
	'$ %AsyncFunctionPrototype%': asyncFunction ? asyncFunction.prototype : undefined,
	'$ %AsyncGenerator%': asyncGen ? getProto(asyncGenIterator) : undefined,
	'$ %AsyncGeneratorFunction%': asyncGenFunction,
	'$ %AsyncGeneratorPrototype%': asyncGenFunction ? asyncGenFunction.prototype : undefined,
	'$ %AsyncIteratorPrototype%': asyncGenIterator && hasSymbols && Symbol.asyncIterator ? asyncGenIterator[Symbol.asyncIterator]() : undefined,
	'$ %Atomics%': typeof Atomics === 'undefined' ? undefined : Atomics,
	'$ %Boolean%': Boolean,
	'$ %BooleanPrototype%': Boolean.prototype,
	'$ %DataView%': typeof DataView === 'undefined' ? undefined : DataView,
	'$ %DataViewPrototype%': typeof DataView === 'undefined' ? undefined : DataView.prototype,
	'$ %Date%': Date,
	'$ %DatePrototype%': Date.prototype,
	'$ %decodeURI%': decodeURI,
	'$ %decodeURIComponent%': decodeURIComponent,
	'$ %encodeURI%': encodeURI,
	'$ %encodeURIComponent%': encodeURIComponent,
	'$ %Error%': Error,
	'$ %ErrorPrototype%': Error.prototype,
	'$ %eval%': eval, // eslint-disable-line no-eval
	'$ %EvalError%': EvalError,
	'$ %EvalErrorPrototype%': EvalError.prototype,
	'$ %Float32Array%': typeof Float32Array === 'undefined' ? undefined : Float32Array,
	'$ %Float32ArrayPrototype%': typeof Float32Array === 'undefined' ? undefined : Float32Array.prototype,
	'$ %Float64Array%': typeof Float64Array === 'undefined' ? undefined : Float64Array,
	'$ %Float64ArrayPrototype%': typeof Float64Array === 'undefined' ? undefined : Float64Array.prototype,
	'$ %Function%': Function,
	'$ %FunctionPrototype%': Function.prototype,
	'$ %Generator%': generator ? getProto(generator()) : undefined,
	'$ %GeneratorFunction%': generatorFunction,
	'$ %GeneratorPrototype%': generatorFunction ? generatorFunction.prototype : undefined,
	'$ %Int8Array%': typeof Int8Array === 'undefined' ? undefined : Int8Array,
	'$ %Int8ArrayPrototype%': typeof Int8Array === 'undefined' ? undefined : Int8Array.prototype,
	'$ %Int16Array%': typeof Int16Array === 'undefined' ? undefined : Int16Array,
	'$ %Int16ArrayPrototype%': typeof Int16Array === 'undefined' ? undefined : Int8Array.prototype,
	'$ %Int32Array%': typeof Int32Array === 'undefined' ? undefined : Int32Array,
	'$ %Int32ArrayPrototype%': typeof Int32Array === 'undefined' ? undefined : Int32Array.prototype,
	'$ %isFinite%': isFinite,
	'$ %isNaN%': isNaN,
	'$ %IteratorPrototype%': hasSymbols ? getProto(getProto([][Symbol.iterator]())) : undefined,
	'$ %JSON%': JSON,
	'$ %JSONParse%': JSON.parse,
	'$ %Map%': typeof Map === 'undefined' ? undefined : Map,
	'$ %MapIteratorPrototype%': typeof Map === 'undefined' || !hasSymbols ? undefined : getProto(new Map()[Symbol.iterator]()),
	'$ %MapPrototype%': typeof Map === 'undefined' ? undefined : Map.prototype,
	'$ %Math%': Math,
	'$ %Number%': Number,
	'$ %NumberPrototype%': Number.prototype,
	'$ %Object%': Object,
	'$ %ObjectPrototype%': Object.prototype,
	'$ %ObjProto_toString%': Object.prototype.toString,
	'$ %ObjProto_valueOf%': Object.prototype.valueOf,
	'$ %parseFloat%': parseFloat,
	'$ %parseInt%': parseInt,
	'$ %Promise%': typeof Promise === 'undefined' ? undefined : Promise,
	'$ %PromisePrototype%': typeof Promise === 'undefined' ? undefined : Promise.prototype,
	'$ %PromiseProto_then%': typeof Promise === 'undefined' ? undefined : Promise.prototype.then,
	'$ %Promise_all%': typeof Promise === 'undefined' ? undefined : Promise.all,
	'$ %Promise_reject%': typeof Promise === 'undefined' ? undefined : Promise.reject,
	'$ %Promise_resolve%': typeof Promise === 'undefined' ? undefined : Promise.resolve,
	'$ %Proxy%': typeof Proxy === 'undefined' ? undefined : Proxy,
	'$ %RangeError%': RangeError,
	'$ %RangeErrorPrototype%': RangeError.prototype,
	'$ %ReferenceError%': ReferenceError,
	'$ %ReferenceErrorPrototype%': ReferenceError.prototype,
	'$ %Reflect%': typeof Reflect === 'undefined' ? undefined : Reflect,
	'$ %RegExp%': RegExp,
	'$ %RegExpPrototype%': RegExp.prototype,
	'$ %Set%': typeof Set === 'undefined' ? undefined : Set,
	'$ %SetIteratorPrototype%': typeof Set === 'undefined' || !hasSymbols ? undefined : getProto(new Set()[Symbol.iterator]()),
	'$ %SetPrototype%': typeof Set === 'undefined' ? undefined : Set.prototype,
	'$ %SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined : SharedArrayBuffer,
	'$ %SharedArrayBufferPrototype%': typeof SharedArrayBuffer === 'undefined' ? undefined : SharedArrayBuffer.prototype,
	'$ %String%': String,
	'$ %StringIteratorPrototype%': hasSymbols ? getProto(''[Symbol.iterator]()) : undefined,
	'$ %StringPrototype%': String.prototype,
	'$ %Symbol%': hasSymbols ? Symbol : undefined,
	'$ %SymbolPrototype%': hasSymbols ? Symbol.prototype : undefined,
	'$ %SyntaxError%': SyntaxError,
	'$ %SyntaxErrorPrototype%': SyntaxError.prototype,
	'$ %ThrowTypeError%': ThrowTypeError,
	'$ %TypedArray%': TypedArray,
	'$ %TypedArrayPrototype%': TypedArray ? TypedArray.prototype : undefined,
	'$ %TypeError%': TypeError,
	'$ %TypeErrorPrototype%': TypeError.prototype,
	'$ %Uint8Array%': typeof Uint8Array === 'undefined' ? undefined : Uint8Array,
	'$ %Uint8ArrayPrototype%': typeof Uint8Array === 'undefined' ? undefined : Uint8Array.prototype,
	'$ %Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined : Uint8ClampedArray,
	'$ %Uint8ClampedArrayPrototype%': typeof Uint8ClampedArray === 'undefined' ? undefined : Uint8ClampedArray.prototype,
	'$ %Uint16Array%': typeof Uint16Array === 'undefined' ? undefined : Uint16Array,
	'$ %Uint16ArrayPrototype%': typeof Uint16Array === 'undefined' ? undefined : Uint16Array.prototype,
	'$ %Uint32Array%': typeof Uint32Array === 'undefined' ? undefined : Uint32Array,
	'$ %Uint32ArrayPrototype%': typeof Uint32Array === 'undefined' ? undefined : Uint32Array.prototype,
	'$ %URIError%': URIError,
	'$ %URIErrorPrototype%': URIError.prototype,
	'$ %WeakMap%': typeof WeakMap === 'undefined' ? undefined : WeakMap,
	'$ %WeakMapPrototype%': typeof WeakMap === 'undefined' ? undefined : WeakMap.prototype,
	'$ %WeakSet%': typeof WeakSet === 'undefined' ? undefined : WeakSet,
	'$ %WeakSetPrototype%': typeof WeakSet === 'undefined' ? undefined : WeakSet.prototype
};

module.exports = function GetIntrinsic(name, allowMissing) {
	if (arguments.length > 1 && typeof allowMissing !== 'boolean') {
		throw new TypeError('"allowMissing" argument must be a boolean');
	}

	var key = '$ ' + name;
	if (!(key in INTRINSICS)) {
		throw new SyntaxError('intrinsic ' + name + ' does not exist!');
	}

	// istanbul ignore if // hopefully this is impossible to test :-)
	if (typeof INTRINSICS[key] === 'undefined' && !allowMissing) {
		throw new TypeError('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
	}
	return INTRINSICS[key];
};


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var implementation = __webpack_require__(37);

var zeroWidthSpace = '\u200b';

module.exports = function getPolyfill() {
	if (String.prototype.trim && zeroWidthSpace.trim() === zeroWidthSpace) {
		return String.prototype.trim;
	}
	return implementation;
};


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var I18nContext = _react2.default.createContext();

exports.default = I18nContext;

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
    childContextTypes: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};

var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = getPrototypeOf && getPrototypeOf(Object);

function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components

        if (objectPrototype) {
            var inheritedComponent = getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== objectPrototype) {
                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
            }
        }

        var keys = getOwnPropertyNames(sourceComponent);

        if (getOwnPropertySymbols) {
            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
        }

        for (var i = 0; i < keys.length; ++i) {
            var key = keys[i];
            if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                try { // Avoid failures from read-only properties
                    defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }

        return targetComponent;
    }

    return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports["default"] = {
  noWobble: { stiffness: 170, damping: 26 }, // the default, if nothing provided
  gentle: { stiffness: 120, damping: 14 },
  wobbly: { stiffness: 180, damping: 12 },
  stiff: { stiffness: 210, damping: 20 }
};
module.exports = exports["default"];

/***/ }),
/* 43 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MainButton_style__ = __webpack_require__(44);
var _jsx=function(){var REACT_ELEMENT_TYPE=typeof Symbol==="function"&&Symbol.for&&Symbol.for("react.element")||0xeac7;return function createRawReactElement(type,props,key,children){var defaultProps=type&&type.defaultProps;var childrenLength=arguments.length-3;if(!props&&childrenLength!==0){props={};}if(props&&defaultProps){for(var propName in defaultProps){if(props[propName]===void 0){props[propName]=defaultProps[propName];}}}else if(!props){props=defaultProps||{};}if(childrenLength===1){props.children=children;}else if(childrenLength>1){var childArray=Array(childrenLength);for(var i=0;i<childrenLength;i++){childArray[i]=arguments[i+3];}props.children=childArray;}return{$$typeof:REACT_ELEMENT_TYPE,type:type,key:key===undefined?null:''+key,ref:null,props:props,_owner:null};};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var alignMap={'center':'center','left':'flex-start','right':'flex-end'};var MainButton=function(_Component){_inherits(MainButton,_Component);function MainButton(){var _ref;var _temp,_this,_ret;_classCallCheck(this,MainButton);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=MainButton.__proto__||Object.getPrototypeOf(MainButton)).call.apply(_ref,[this].concat(args))),_this),_this.render=function(){var icon=_this.props.icon;var iconClass=void 0;if(icon&&icon.color){iconClass='tone colorIcon_'+icon.color;}// If we wanted to send image icons instead of simple colors
// we could handle it here
if(icon&&icon.image){iconClass='imageIcon_'+icon.image;}return _jsx(__WEBPACK_IMPORTED_MODULE_2__MainButton_style__["a" /* default */],{selected:_this.props.selected,align:alignMap[_this.props.align],onClick:_this.props.onClick},void 0,iconClass?_jsx('div',{className:iconClass}):null,_this.props.children);},_temp),_possibleConstructorReturn(_this,_ret);}return MainButton;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);MainButton.propTypes={onClick:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,children:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,align:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['center','left','right']),icon:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({color:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string}),__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({image:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string})])};/* harmony default export */ __webpack_exports__["a"] = (MainButton);

/***/ }),
/* 44 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MediaQueries__ = __webpack_require__(3);
var _templateObject=_taggedTemplateLiteral(['\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  width: 200px;\n  height: 60px;\n  border-radius: 4px;\n  background-color: white;\n  margin-bottom: 3vh;\n  color: black;\n  font-size: 14px;\n  font-weight: 400;\n  box-shadow: 0 4px 12px rgba(0,0,0,.12);\n  transition: transform .35s cubic-bezier(.5,0,0,1),\n              border .35s cubic-bezier(.5,0,0,1);\n\n  transform: ',';\n  border: ',';\n  justify-content: ',';\n\n  ','\n\n  ','\n\n  .tone {\n    height: 24px;\n    width: 24px;\n    border-radius: 50%;\n    border: 2px solid #FBFBFB;\n    margin: 0 16px 0 20px;\n    ','\n    ','\n  }\n\n  .colorIcon_light {\n    background-color: #EFD2B5;\n  }\n\n  .colorIcon_fair {\n    background-color: #DFB594;\n  }\n\n  .colorIcon_medium {\n    background-color: #CAA081;\n  }\n\n  .colorIcon_olive {\n    background-color: #B17A57;\n  }\n\n  .colorIcon_brown {\n    background-color: #9B6037;\n  }\n\n  .colorIcon_darkbrown {\n    background-color: #39221E;\n  }\n'],['\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  width: 200px;\n  height: 60px;\n  border-radius: 4px;\n  background-color: white;\n  margin-bottom: 3vh;\n  color: black;\n  font-size: 14px;\n  font-weight: 400;\n  box-shadow: 0 4px 12px rgba(0,0,0,.12);\n  transition: transform .35s cubic-bezier(.5,0,0,1),\n              border .35s cubic-bezier(.5,0,0,1);\n\n  transform: ',';\n  border: ',';\n  justify-content: ',';\n\n  ','\n\n  ','\n\n  .tone {\n    height: 24px;\n    width: 24px;\n    border-radius: 50%;\n    border: 2px solid #FBFBFB;\n    margin: 0 16px 0 20px;\n    ','\n    ','\n  }\n\n  .colorIcon_light {\n    background-color: #EFD2B5;\n  }\n\n  .colorIcon_fair {\n    background-color: #DFB594;\n  }\n\n  .colorIcon_medium {\n    background-color: #CAA081;\n  }\n\n  .colorIcon_olive {\n    background-color: #B17A57;\n  }\n\n  .colorIcon_brown {\n    background-color: #9B6037;\n  }\n\n  .colorIcon_darkbrown {\n    background-color: #39221E;\n  }\n']),_templateObject2=_taggedTemplateLiteral(['\n    flex: 1 1 auto;\n    max-width: 45%;\n    height: 60px;\n    margin: 0 5px 15px 5px;\n  '],['\n    flex: 1 1 auto;\n    max-width: 45%;\n    height: 60px;\n    margin: 0 5px 15px 5px;\n  ']),_templateObject3=_taggedTemplateLiteral(['\n    font-size: 12px;\n    font-weight: 500;\n  '],['\n    font-size: 12px;\n    font-weight: 500;\n  ']),_templateObject4=_taggedTemplateLiteral(['\n      margin: 0 10px 0 10px;\n    '],['\n      margin: 0 10px 0 10px;\n    ']),_templateObject5=_taggedTemplateLiteral(['\n      height: 16px;\n      width: 16px;\n    '],['\n      height: 16px;\n      width: 16px;\n    ']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var StyledButton=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* default */].button(_templateObject,function(props){return props.selected?'scale3d(1.1, 1.1, 1.0)':'scale3d(1.0, 1.0, 1.0)';},function(props){return props.selected?'3px solid #FFAA5F':'3px solid transparent';},function(props){return props.align?props.align:'center';},__WEBPACK_IMPORTED_MODULE_1__MediaQueries__["a" /* default */].phone(_templateObject2),__WEBPACK_IMPORTED_MODULE_1__MediaQueries__["a" /* default */].smphone(_templateObject3),__WEBPACK_IMPORTED_MODULE_1__MediaQueries__["a" /* default */].phone(_templateObject4),__WEBPACK_IMPORTED_MODULE_1__MediaQueries__["a" /* default */].smphone(_templateObject5));/* harmony default export */ __webpack_exports__["a"] = (StyledButton);

/***/ }),
/* 45 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var SkinAnalysisIcons={darkcircles:'darkcircles',eyebags:'eyebags',eyecolor:'eyecolor',pigmentvariation:'pigmentvariation',radiance:'radiance',shape:'shape',undertone:'undertone',wrinkleslines:'wrinkleslines',skintoneColor:'skintoneColor',acne:'acne',skinShine:'skinShine',redness:'redness',texture:'texture'};/* harmony default export */ __webpack_exports__["a"] = (SkinAnalysisIcons);

/***/ }),
/* 46 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MainButton__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_polyglot__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_polyglot___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_polyglot__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__MediaQueries__ = __webpack_require__(3);
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};var _jsx=function(){var REACT_ELEMENT_TYPE=typeof Symbol==="function"&&Symbol.for&&Symbol.for("react.element")||0xeac7;return function createRawReactElement(type,props,key,children){var defaultProps=type&&type.defaultProps;var childrenLength=arguments.length-3;if(!props&&childrenLength!==0){props={};}if(props&&defaultProps){for(var propName in defaultProps){if(props[propName]===void 0){props[propName]=defaultProps[propName];}}}else if(!props){props=defaultProps||{};}if(childrenLength===1){props.children=children;}else if(childrenLength>1){var childArray=Array(childrenLength);for(var i=0;i<childrenLength;i++){childArray[i]=arguments[i+3];}props.children=childArray;}return{$$typeof:REACT_ELEMENT_TYPE,type:type,key:key===undefined?null:''+key,ref:null,props:props,_owner:null};};}();var _templateObject=_taggedTemplateLiteral(['\n  position: absolute;\n  right: 0; left: 0;\n  top: 0;\n  bottom: 0;\n  margin: auto;\n  display: flex;\n  flex-direction: column;\n  max-width: 440px;\n  width: 100%;\n  max-height: 400px;\n\n  ','\n\n  .title {\n    color: white;\n    font-size: 36px;\n    font-weight: 100;\n\n    ','\n  }\n\n  .buttonsContainer {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: space-between;\n    margin-top: 3vh;\n  }\n'],['\n  position: absolute;\n  right: 0; left: 0;\n  top: 0;\n  bottom: 0;\n  margin: auto;\n  display: flex;\n  flex-direction: column;\n  max-width: 440px;\n  width: 100%;\n  max-height: 400px;\n\n  ','\n\n  .title {\n    color: white;\n    font-size: 36px;\n    font-weight: 100;\n\n    ','\n  }\n\n  .buttonsContainer {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: space-between;\n    margin-top: 3vh;\n  }\n']),_templateObject2=_taggedTemplateLiteral(['\n    max-width: auto;\n    max-height: auto;\n    padding: 0 30px;\n    top: 10%;\n    bottom: auto;\n  '],['\n    max-width: auto;\n    max-height: auto;\n    padding: 0 30px;\n    top: 10%;\n    bottom: auto;\n  ']),_templateObject3=_taggedTemplateLiteral(['\n      font-size: 24px;\n      font-weight: 300;\n    '],['\n      font-size: 24px;\n      font-weight: 300;\n    ']);function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var StyledQuestions=__WEBPACK_IMPORTED_MODULE_3_styled_components__["b" /* default */].div(_templateObject,__WEBPACK_IMPORTED_MODULE_5__MediaQueries__["a" /* default */].phone(_templateObject2),__WEBPACK_IMPORTED_MODULE_5__MediaQueries__["a" /* default */].phone(_templateObject3));var Questions=function(_Component){_inherits(Questions,_Component);function Questions(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Questions);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Questions.__proto__||Object.getPrototypeOf(Questions)).call.apply(_ref,[this].concat(args))),_this),_this.render=function(){var _this$props$options=_this.props.options,title=_this$props$options.title,choices=_this$props$options.choices,multiSelect=_this$props$options.multiSelect,iconColors=_this$props$options.iconColors,buttonTextAlign=_this$props$options.buttonTextAlign,autoAdvance=_this$props$options.autoAdvance,inRequestProperty=_this$props$options.inRequestProperty;// from backend
var _this$props=_this.props,t=_this$props.t,filters=_this$props.filters,toggleFilter=_this$props.toggleFilter,nextPage=_this$props.nextPage;// internal
return _jsx(StyledQuestions,{className:'questions'},void 0,_jsx('h2',{className:'title'},void 0,title),_jsx('div',{className:'buttonsContainer'},void 0,choices.map(function(oKey,i){var key=void 0,value=void 0,label=void 0;// Find out of this choice is selected or not
var selected=false;// if the choice is object, it means key shall be key in filter
// and choise object value will act as the value of filter.
if((typeof oKey==='undefined'?'undefined':_typeof(oKey))==='object'){key=Object.keys(oKey)[0];value=oKey[key];label=t(value.replace('_ui',''));}else{// if the choise is a string, the key will key and 
// value will be 1. Simple 'boolean' API filter.
key=oKey;value=1;label=t(key.replace('_ui',''));}// This allows to insert the value into a different root of the
// request object.
if(inRequestProperty){if(filters.hasOwnProperty(inRequestProperty)){selected=filters[inRequestProperty][key]===value;}}else{selected=filters[key]===value;}var icon=void 0;if(iconColors&&iconColors.length>i){icon={color:iconColors[i]};}return _jsx(__WEBPACK_IMPORTED_MODULE_2__MainButton__["a" /* default */],{selected:selected,onClick:function onClick(){toggleFilter(key,selected?0:value,choices,multiSelect,autoAdvance,nextPage,inRequestProperty);},align:buttonTextAlign,icon:icon},key+'/'+i,label);})));},_temp),_possibleConstructorReturn(_this,_ret);}return Questions;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);Questions.propTypes={options:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({name:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,title:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,choices:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,buttonTextAlign:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,autoAdvance:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool})};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4_react_polyglot__["translate"])()(Questions));

/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*
 * JavaScript Load Image Scaling
 * https://github.com/blueimp/JavaScript-Load-Image
 *
 * Copyright 2011, Sebastian Tschan
 * https://blueimp.net
 *
 * Licensed under the MIT license:
 * https://opensource.org/licenses/MIT
 */

/* global define, module, require */

;(function(factory) {
  'use strict'
  if (true) {
    // Register as an anonymous AMD module:
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(7)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
  } else if (typeof module === 'object' && module.exports) {
    factory(require('./load-image'))
  } else {
    // Browser globals:
    factory(window.loadImage)
  }
})(function(loadImage) {
  'use strict'

  var originalTransform = loadImage.transform

  loadImage.transform = function(img, options, callback, file, data) {
    originalTransform.call(
      loadImage,
      loadImage.scale(img, options, data),
      options,
      callback,
      file,
      data
    )
  }

  // Transform image coordinates, allows to override e.g.
  // the canvas orientation based on the orientation option,
  // gets canvas, options passed as arguments:
  loadImage.transformCoordinates = function() {}

  // Returns transformed options, allows to override e.g.
  // maxWidth, maxHeight and crop options based on the aspectRatio.
  // gets img, options passed as arguments:
  loadImage.getTransformedOptions = function(img, options) {
    var aspectRatio = options.aspectRatio
    var newOptions
    var i
    var width
    var height
    if (!aspectRatio) {
      return options
    }
    newOptions = {}
    for (i in options) {
      if (Object.prototype.hasOwnProperty.call(options, i)) {
        newOptions[i] = options[i]
      }
    }
    newOptions.crop = true
    width = img.naturalWidth || img.width
    height = img.naturalHeight || img.height
    if (width / height > aspectRatio) {
      newOptions.maxWidth = height * aspectRatio
      newOptions.maxHeight = height
    } else {
      newOptions.maxWidth = width
      newOptions.maxHeight = width / aspectRatio
    }
    return newOptions
  }

  // Canvas render method, allows to implement a different rendering algorithm:
  loadImage.renderImageToCanvas = function(
    canvas,
    img,
    sourceX,
    sourceY,
    sourceWidth,
    sourceHeight,
    destX,
    destY,
    destWidth,
    destHeight
  ) {
    canvas
      .getContext('2d')
      .drawImage(
        img,
        sourceX,
        sourceY,
        sourceWidth,
        sourceHeight,
        destX,
        destY,
        destWidth,
        destHeight
      )
    return canvas
  }

  // Determines if the target image should be a canvas element:
  loadImage.hasCanvasOption = function(options) {
    return options.canvas || options.crop || !!options.aspectRatio
  }

  // Scales and/or crops the given image (img or canvas HTML element)
  // using the given options.
  // Returns a canvas object if the browser supports canvas
  // and the hasCanvasOption method returns true or a canvas
  // object is passed as image, else the scaled image:
  loadImage.scale = function(img, options, data) {
    // eslint-disable-next-line no-param-reassign
    options = options || {}
    var canvas = document.createElement('canvas')
    var useCanvas =
      img.getContext ||
      (loadImage.hasCanvasOption(options) && canvas.getContext)
    var width = img.naturalWidth || img.width
    var height = img.naturalHeight || img.height
    var destWidth = width
    var destHeight = height
    var maxWidth
    var maxHeight
    var minWidth
    var minHeight
    var sourceWidth
    var sourceHeight
    var sourceX
    var sourceY
    var pixelRatio
    var downsamplingRatio
    var tmp
    /**
     * Scales up image dimensions
     */
    function scaleUp() {
      var scale = Math.max(
        (minWidth || destWidth) / destWidth,
        (minHeight || destHeight) / destHeight
      )
      if (scale > 1) {
        destWidth *= scale
        destHeight *= scale
      }
    }
    /**
     * Scales down image dimensions
     */
    function scaleDown() {
      var scale = Math.min(
        (maxWidth || destWidth) / destWidth,
        (maxHeight || destHeight) / destHeight
      )
      if (scale < 1) {
        destWidth *= scale
        destHeight *= scale
      }
    }
    if (useCanvas) {
      // eslint-disable-next-line no-param-reassign
      options = loadImage.getTransformedOptions(img, options, data)
      sourceX = options.left || 0
      sourceY = options.top || 0
      if (options.sourceWidth) {
        sourceWidth = options.sourceWidth
        if (options.right !== undefined && options.left === undefined) {
          sourceX = width - sourceWidth - options.right
        }
      } else {
        sourceWidth = width - sourceX - (options.right || 0)
      }
      if (options.sourceHeight) {
        sourceHeight = options.sourceHeight
        if (options.bottom !== undefined && options.top === undefined) {
          sourceY = height - sourceHeight - options.bottom
        }
      } else {
        sourceHeight = height - sourceY - (options.bottom || 0)
      }
      destWidth = sourceWidth
      destHeight = sourceHeight
    }
    maxWidth = options.maxWidth
    maxHeight = options.maxHeight
    minWidth = options.minWidth
    minHeight = options.minHeight
    if (useCanvas && maxWidth && maxHeight && options.crop) {
      destWidth = maxWidth
      destHeight = maxHeight
      tmp = sourceWidth / sourceHeight - maxWidth / maxHeight
      if (tmp < 0) {
        sourceHeight = (maxHeight * sourceWidth) / maxWidth
        if (options.top === undefined && options.bottom === undefined) {
          sourceY = (height - sourceHeight) / 2
        }
      } else if (tmp > 0) {
        sourceWidth = (maxWidth * sourceHeight) / maxHeight
        if (options.left === undefined && options.right === undefined) {
          sourceX = (width - sourceWidth) / 2
        }
      }
    } else {
      if (options.contain || options.cover) {
        minWidth = maxWidth = maxWidth || minWidth
        minHeight = maxHeight = maxHeight || minHeight
      }
      if (options.cover) {
        scaleDown()
        scaleUp()
      } else {
        scaleUp()
        scaleDown()
      }
    }
    if (useCanvas) {
      pixelRatio = options.pixelRatio
      if (pixelRatio > 1) {
        canvas.style.width = destWidth + 'px'
        canvas.style.height = destHeight + 'px'
        destWidth *= pixelRatio
        destHeight *= pixelRatio
        canvas.getContext('2d').scale(pixelRatio, pixelRatio)
      }
      downsamplingRatio = options.downsamplingRatio
      if (
        downsamplingRatio > 0 &&
        downsamplingRatio < 1 &&
        destWidth < sourceWidth &&
        destHeight < sourceHeight
      ) {
        while (sourceWidth * downsamplingRatio > destWidth) {
          canvas.width = sourceWidth * downsamplingRatio
          canvas.height = sourceHeight * downsamplingRatio
          loadImage.renderImageToCanvas(
            canvas,
            img,
            sourceX,
            sourceY,
            sourceWidth,
            sourceHeight,
            0,
            0,
            canvas.width,
            canvas.height
          )
          sourceX = 0
          sourceY = 0
          sourceWidth = canvas.width
          sourceHeight = canvas.height
          // eslint-disable-next-line no-param-reassign
          img = document.createElement('canvas')
          img.width = sourceWidth
          img.height = sourceHeight
          loadImage.renderImageToCanvas(
            img,
            canvas,
            0,
            0,
            sourceWidth,
            sourceHeight,
            0,
            0,
            sourceWidth,
            sourceHeight
          )
        }
      }
      canvas.width = destWidth
      canvas.height = destHeight
      loadImage.transformCoordinates(canvas, options)
      return loadImage.renderImageToCanvas(
        canvas,
        img,
        sourceX,
        sourceY,
        sourceWidth,
        sourceHeight,
        0,
        0,
        destWidth,
        destHeight
      )
    }
    img.width = destWidth
    img.height = destHeight
    return img
  }
})


/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*
 * JavaScript Load Image Exif Parser
 * https://github.com/blueimp/JavaScript-Load-Image
 *
 * Copyright 2013, Sebastian Tschan
 * https://blueimp.net
 *
 * Licensed under the MIT license:
 * https://opensource.org/licenses/MIT
 */

/* global define, module, require */

/* eslint-disable no-console */

;(function(factory) {
  'use strict'
  if (true) {
    // Register as an anonymous AMD module:
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(7), __webpack_require__(12)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
  } else if (typeof module === 'object' && module.exports) {
    factory(require('./load-image'), require('./load-image-meta'))
  } else {
    // Browser globals:
    factory(window.loadImage)
  }
})(function(loadImage) {
  'use strict'

  loadImage.ExifMap = function() {
    return this
  }

  loadImage.ExifMap.prototype.map = {
    Orientation: 0x0112
  }

  loadImage.ExifMap.prototype.get = function(id) {
    return this[id] || this[this.map[id]]
  }

  loadImage.getExifThumbnail = function(dataView, offset, length) {
    if (!length || offset + length > dataView.byteLength) {
      console.log('Invalid Exif data: Invalid thumbnail data.')
      return
    }
    return loadImage.createObjectURL(
      new Blob([dataView.buffer.slice(offset, offset + length)])
    )
  }

  loadImage.exifTagTypes = {
    // byte, 8-bit unsigned int:
    1: {
      getValue: function(dataView, dataOffset) {
        return dataView.getUint8(dataOffset)
      },
      size: 1
    },
    // ascii, 8-bit byte:
    2: {
      getValue: function(dataView, dataOffset) {
        return String.fromCharCode(dataView.getUint8(dataOffset))
      },
      size: 1,
      ascii: true
    },
    // short, 16 bit int:
    3: {
      getValue: function(dataView, dataOffset, littleEndian) {
        return dataView.getUint16(dataOffset, littleEndian)
      },
      size: 2
    },
    // long, 32 bit int:
    4: {
      getValue: function(dataView, dataOffset, littleEndian) {
        return dataView.getUint32(dataOffset, littleEndian)
      },
      size: 4
    },
    // rational = two long values, first is numerator, second is denominator:
    5: {
      getValue: function(dataView, dataOffset, littleEndian) {
        return (
          dataView.getUint32(dataOffset, littleEndian) /
          dataView.getUint32(dataOffset + 4, littleEndian)
        )
      },
      size: 8
    },
    // slong, 32 bit signed int:
    9: {
      getValue: function(dataView, dataOffset, littleEndian) {
        return dataView.getInt32(dataOffset, littleEndian)
      },
      size: 4
    },
    // srational, two slongs, first is numerator, second is denominator:
    10: {
      getValue: function(dataView, dataOffset, littleEndian) {
        return (
          dataView.getInt32(dataOffset, littleEndian) /
          dataView.getInt32(dataOffset + 4, littleEndian)
        )
      },
      size: 8
    }
  }
  // undefined, 8-bit byte, value depending on field:
  loadImage.exifTagTypes[7] = loadImage.exifTagTypes[1]

  loadImage.getExifValue = function(
    dataView,
    tiffOffset,
    offset,
    type,
    length,
    littleEndian
  ) {
    var tagType = loadImage.exifTagTypes[type]
    var tagSize
    var dataOffset
    var values
    var i
    var str
    var c
    if (!tagType) {
      console.log('Invalid Exif data: Invalid tag type.')
      return
    }
    tagSize = tagType.size * length
    // Determine if the value is contained in the dataOffset bytes,
    // or if the value at the dataOffset is a pointer to the actual data:
    dataOffset =
      tagSize > 4
        ? tiffOffset + dataView.getUint32(offset + 8, littleEndian)
        : offset + 8
    if (dataOffset + tagSize > dataView.byteLength) {
      console.log('Invalid Exif data: Invalid data offset.')
      return
    }
    if (length === 1) {
      return tagType.getValue(dataView, dataOffset, littleEndian)
    }
    values = []
    for (i = 0; i < length; i += 1) {
      values[i] = tagType.getValue(
        dataView,
        dataOffset + i * tagType.size,
        littleEndian
      )
    }
    if (tagType.ascii) {
      str = ''
      // Concatenate the chars:
      for (i = 0; i < values.length; i += 1) {
        c = values[i]
        // Ignore the terminating NULL byte(s):
        if (c === '\u0000') {
          break
        }
        str += c
      }
      return str
    }
    return values
  }

  loadImage.parseExifTag = function(
    dataView,
    tiffOffset,
    offset,
    littleEndian,
    data
  ) {
    var tag = dataView.getUint16(offset, littleEndian)
    data.exif[tag] = loadImage.getExifValue(
      dataView,
      tiffOffset,
      offset,
      dataView.getUint16(offset + 2, littleEndian), // tag type
      dataView.getUint32(offset + 4, littleEndian), // tag length
      littleEndian
    )
  }

  loadImage.parseExifTags = function(
    dataView,
    tiffOffset,
    dirOffset,
    littleEndian,
    data
  ) {
    var tagsNumber, dirEndOffset, i
    if (dirOffset + 6 > dataView.byteLength) {
      console.log('Invalid Exif data: Invalid directory offset.')
      return
    }
    tagsNumber = dataView.getUint16(dirOffset, littleEndian)
    dirEndOffset = dirOffset + 2 + 12 * tagsNumber
    if (dirEndOffset + 4 > dataView.byteLength) {
      console.log('Invalid Exif data: Invalid directory size.')
      return
    }
    for (i = 0; i < tagsNumber; i += 1) {
      this.parseExifTag(
        dataView,
        tiffOffset,
        dirOffset + 2 + 12 * i, // tag offset
        littleEndian,
        data
      )
    }
    // Return the offset to the next directory:
    return dataView.getUint32(dirEndOffset, littleEndian)
  }

  loadImage.parseExifData = function(dataView, offset, length, data, options) {
    if (options.disableExif) {
      return
    }
    var tiffOffset = offset + 10
    var littleEndian
    var dirOffset
    var thumbnailData
    // Check for the ASCII code for "Exif" (0x45786966):
    if (dataView.getUint32(offset + 4) !== 0x45786966) {
      // No Exif data, might be XMP data instead
      return
    }
    if (tiffOffset + 8 > dataView.byteLength) {
      console.log('Invalid Exif data: Invalid segment size.')
      return
    }
    // Check for the two null bytes:
    if (dataView.getUint16(offset + 8) !== 0x0000) {
      console.log('Invalid Exif data: Missing byte alignment offset.')
      return
    }
    // Check the byte alignment:
    switch (dataView.getUint16(tiffOffset)) {
      case 0x4949:
        littleEndian = true
        break
      case 0x4d4d:
        littleEndian = false
        break
      default:
        console.log('Invalid Exif data: Invalid byte alignment marker.')
        return
    }
    // Check for the TIFF tag marker (0x002A):
    if (dataView.getUint16(tiffOffset + 2, littleEndian) !== 0x002a) {
      console.log('Invalid Exif data: Missing TIFF marker.')
      return
    }
    // Retrieve the directory offset bytes, usually 0x00000008 or 8 decimal:
    dirOffset = dataView.getUint32(tiffOffset + 4, littleEndian)
    // Create the exif object to store the tags:
    data.exif = new loadImage.ExifMap()
    // Parse the tags of the main image directory and retrieve the
    // offset to the next directory, usually the thumbnail directory:
    dirOffset = loadImage.parseExifTags(
      dataView,
      tiffOffset,
      tiffOffset + dirOffset,
      littleEndian,
      data
    )
    if (dirOffset && !options.disableExifThumbnail) {
      thumbnailData = { exif: {} }
      dirOffset = loadImage.parseExifTags(
        dataView,
        tiffOffset,
        tiffOffset + dirOffset,
        littleEndian,
        thumbnailData
      )
      // Check for JPEG Thumbnail offset:
      if (thumbnailData.exif[0x0201]) {
        data.exif.Thumbnail = loadImage.getExifThumbnail(
          dataView,
          tiffOffset + thumbnailData.exif[0x0201],
          thumbnailData.exif[0x0202] // Thumbnail data length
        )
      }
    }
    // Check for Exif Sub IFD Pointer:
    if (data.exif[0x8769] && !options.disableExifSub) {
      loadImage.parseExifTags(
        dataView,
        tiffOffset,
        tiffOffset + data.exif[0x8769], // directory offset
        littleEndian,
        data
      )
    }
    // Check for GPS Info IFD Pointer:
    if (data.exif[0x8825] && !options.disableExifGps) {
      loadImage.parseExifTags(
        dataView,
        tiffOffset,
        tiffOffset + data.exif[0x8825], // directory offset
        littleEndian,
        data
      )
    }
  }

  // Registers the Exif parser for the APP1 JPEG meta data segment:
  loadImage.metaDataParsers.jpeg[0xffe1].push(loadImage.parseExifData)

  // Adds the following properties to the parseMetaData callback data:
  // * exif: The exif tags, parsed by the parseExifData method

  // Adds the following options to the parseMetaData method:
  // * disableExif: Disables Exif parsing.
  // * disableExifThumbnail: Disables parsing of the Exif Thumbnail.
  // * disableExifSub: Disables parsing of the Exif Sub IFD.
  // * disableExifGps: Disables parsing of the Exif GPS Info IFD.
})


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*
 * JavaScript Load Image IPTC Parser
 * https://github.com/blueimp/JavaScript-Load-Image
 *
 * Copyright 2013, Sebastian Tschan
 * Copyright 2018, Dave Bevan
 * https://blueimp.net
 *
 * Licensed under the MIT license:
 * https://opensource.org/licenses/MIT
 */

/* global define, module, require, Buffer */

;(function(factory) {
  'use strict'
  if (true) {
    // Register as an anonymous AMD module:
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(7), __webpack_require__(12)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
  } else if (typeof module === 'object' && module.exports) {
    factory(require('./load-image'), require('./load-image-meta'))
  } else {
    // Browser globals:
    factory(window.loadImage)
  }
})(function(loadImage) {
  'use strict'

  loadImage.IptcMap = function() {
    return this
  }

  loadImage.IptcMap.prototype.map = {
    ObjectName: 0x5
  }

  loadImage.IptcMap.prototype.get = function(id) {
    return this[id] || this[this.map[id]]
  }

  loadImage.parseIptcTags = function(
    dataView,
    startOffset,
    sectionLength,
    data
  ) {
    /**
     * Retrieves string for the given Buffer and range
     *
     * @param {Buffer} buffer IPTC buffer
     * @param {number} start Range start
     * @param {number} length Range length
     * @returns {string} String value
     */
    function getStringFromDB(buffer, start, length) {
      var outstr = ''
      for (var n = start; n < start + length; n++) {
        outstr += String.fromCharCode(buffer.getUint8(n))
      }
      return outstr
    }
    var fieldValue, dataSize, segmentType
    var segmentStartPos = startOffset
    while (segmentStartPos < startOffset + sectionLength) {
      // we currently handle the 2: class of iptc tag
      if (
        dataView.getUint8(segmentStartPos) === 0x1c &&
        dataView.getUint8(segmentStartPos + 1) === 0x02
      ) {
        segmentType = dataView.getUint8(segmentStartPos + 2)
        // only store data for known tags
        if (segmentType in data.iptc.tags) {
          dataSize = dataView.getInt16(segmentStartPos + 3)
          fieldValue = getStringFromDB(dataView, segmentStartPos + 5, dataSize)
          // Check if we already stored a value with this name
          if (Object.prototype.hasOwnProperty.call(data.iptc, segmentType)) {
            // Value already stored with this name, create multivalue field
            if (data.iptc[segmentType] instanceof Array) {
              data.iptc[segmentType].push(fieldValue)
            } else {
              data.iptc[segmentType] = [data.iptc[segmentType], fieldValue]
            }
          } else {
            data.iptc[segmentType] = fieldValue
          }
        }
      }
      segmentStartPos++
    }
  }

  loadImage.parseIptcData = function(dataView, offset, length, data, options) {
    if (options.disableIptc) {
      return
    }
    var markerLength = offset + length
    // Found '8BIM<EOT><EOT>' ?
    var isFieldSegmentStart = function(dataView, offset) {
      return (
        dataView.getUint32(offset) === 0x3842494d &&
        dataView.getUint16(offset + 4) === 0x0404
      )
    }
    // Hunt forward, looking for the correct IPTC block signature:
    // Reference: https://metacpan.org/pod/distribution/Image-MetaData-JPEG/lib/Image/MetaData/JPEG/Structures.pod#Structure-of-a-Photoshop-style-APP13-segment
    // From https://github.com/exif-js/exif-js/blob/master/exif.js ~ line 474 on
    while (offset + 8 < markerLength) {
      if (isFieldSegmentStart(dataView, offset)) {
        var nameHeaderLength = dataView.getUint8(offset + 7)
        if (nameHeaderLength % 2 !== 0) nameHeaderLength += 1
        // Check for pre photoshop 6 format
        if (nameHeaderLength === 0) {
          // Always 4
          nameHeaderLength = 4
        }
        var startOffset = offset + 8 + nameHeaderLength
        if (startOffset > markerLength) {
          // eslint-disable-next-line no-console
          console.log('Invalid IPTC data: Invalid segment offset.')
          break
        }
        var sectionLength = dataView.getUint16(offset + 6 + nameHeaderLength)
        if (offset + sectionLength > markerLength) {
          // eslint-disable-next-line no-console
          console.log('Invalid IPTC data: Invalid segment size.')
          break
        }
        // Create the iptc object to store the tags:
        data.iptc = new loadImage.IptcMap()
        // Parse the tags
        return loadImage.parseIptcTags(
          dataView,
          startOffset,
          sectionLength,
          data
        )
      }
      // eslint-disable-next-line no-param-reassign
      offset++
    }
    // eslint-disable-next-line no-console
    console.log('No IPTC data at this offset - could be XMP')
  }

  // Registers this IPTC parser for the APP13 JPEG meta data segment:
  loadImage.metaDataParsers.jpeg[0xffed].push(loadImage.parseIptcData)

  // Adds the following properties to the parseMetaData callback data:
  // * iptc: The iptc tags, parsed by the parseIptcData method

  // Adds the following options to the parseMetaData method:
  // * disableIptc: Disables IPTC parsing.
})


/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MediaQueries__ = __webpack_require__(3);
var _jsx=function(){var REACT_ELEMENT_TYPE=typeof Symbol==="function"&&Symbol.for&&Symbol.for("react.element")||0xeac7;return function createRawReactElement(type,props,key,children){var defaultProps=type&&type.defaultProps;var childrenLength=arguments.length-3;if(!props&&childrenLength!==0){props={};}if(props&&defaultProps){for(var propName in defaultProps){if(props[propName]===void 0){props[propName]=defaultProps[propName];}}}else if(!props){props=defaultProps||{};}if(childrenLength===1){props.children=children;}else if(childrenLength>1){var childArray=Array(childrenLength);for(var i=0;i<childrenLength;i++){childArray[i]=arguments[i+3];}props.children=childArray;}return{$$typeof:REACT_ELEMENT_TYPE,type:type,key:key===undefined?null:''+key,ref:null,props:props,_owner:null};};}();var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n  position: absolute;\n  top: 0; right: 0; bottom: 0; left: 0; margin: auto;\n  display: flex;\n  flex-direction: column;\n  width: 50%;\n  height: 80px;\n  ','\n  justify-content: space-between;\n    h4.textHint {\n      width: 100%;\n      text-align: center;\n      font-weight: 300;\n      font-size: 18px;\n      color: white;\n      ','      \n    }\n    .processing {\n    --size: 16px;\n    ','\n    list-style: none;\n    display: flex;\n    width: 100%;\n    justify-content: space-between;\n    height: var(--size);\n    @keyframes processingPulse {\n      0% { box-shadow: 0 0 0 0 white; }\n      70% { box-shadow: 0 0 0 20px white; }\n      100% { box-shadow: 0 0 0 0 white; }\n    }\n    @keyframes processingOp {\n      0% { opacity: .5 }\n      70% { opacity: 0 }\n      100% { opacity: 0}\n    }\n    li {\n      width: var(--size); height: var(--size);\n      border-radius: 50%;\n      background: white;\n      position: relative;\n      &:before {\n        position: absolute;\n        content: \'\';\n        width: var(--size); height: var(--size);\n        left: 0; top: 0;\n        border-radius: 50%;\n        animation: processingPulse 2s infinite, processingOp 2s infinite;\n      }\n    }\n    li:nth-child(1):before {\n      animation-delay: 200ms;\n    }\n    li:nth-child(2):before {\n      animation-delay: 400ms;\n    }\n    li:nth-child(3):before {\n      animation-delay: 600ms;\n    }\n    li:nth-child(4):before {\n      animation-delay: 800ms;\n    }\n    li:nth-child(5):before {\n      animation-delay: 1000ms;\n    }\n  }\n'],['\n  position: absolute;\n  top: 0; right: 0; bottom: 0; left: 0; margin: auto;\n  display: flex;\n  flex-direction: column;\n  width: 50%;\n  height: 80px;\n  ','\n  justify-content: space-between;\n    h4.textHint {\n      width: 100%;\n      text-align: center;\n      font-weight: 300;\n      font-size: 18px;\n      color: white;\n      ','      \n    }\n    .processing {\n    --size: 16px;\n    ','\n    list-style: none;\n    display: flex;\n    width: 100%;\n    justify-content: space-between;\n    height: var(--size);\n    @keyframes processingPulse {\n      0% { box-shadow: 0 0 0 0 white; }\n      70% { box-shadow: 0 0 0 20px white; }\n      100% { box-shadow: 0 0 0 0 white; }\n    }\n    @keyframes processingOp {\n      0% { opacity: .5 }\n      70% { opacity: 0 }\n      100% { opacity: 0}\n    }\n    li {\n      width: var(--size); height: var(--size);\n      border-radius: 50%;\n      background: white;\n      position: relative;\n      &:before {\n        position: absolute;\n        content: \'\';\n        width: var(--size); height: var(--size);\n        left: 0; top: 0;\n        border-radius: 50%;\n        animation: processingPulse 2s infinite, processingOp 2s infinite;\n      }\n    }\n    li:nth-child(1):before {\n      animation-delay: 200ms;\n    }\n    li:nth-child(2):before {\n      animation-delay: 400ms;\n    }\n    li:nth-child(3):before {\n      animation-delay: 600ms;\n    }\n    li:nth-child(4):before {\n      animation-delay: 800ms;\n    }\n    li:nth-child(5):before {\n      animation-delay: 1000ms;\n    }\n  }\n']),_templateObject2=_taggedTemplateLiteral(['\n    height: 60px; \n  '],['\n    height: 60px; \n  ']),_templateObject3=_taggedTemplateLiteral(['\n        font-size: 16px;\n        margin-top: 18px;\n      '],['\n        font-size: 16px;\n        margin-top: 18px;\n      ']),_templateObject4=_taggedTemplateLiteral(['\n      --size: 9px;\n    '],['\n      --size: 9px;\n    ']);function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var StyledProcessing=__WEBPACK_IMPORTED_MODULE_1_styled_components__["b" /* default */].div(_templateObject,__WEBPACK_IMPORTED_MODULE_2__MediaQueries__["a" /* default */].phone(_templateObject2),__WEBPACK_IMPORTED_MODULE_2__MediaQueries__["a" /* default */].phone(_templateObject3),__WEBPACK_IMPORTED_MODULE_2__MediaQueries__["a" /* default */].phone(_templateObject4));var Processing=function(_Component){_inherits(Processing,_Component);function Processing(){_classCallCheck(this,Processing);return _possibleConstructorReturn(this,(Processing.__proto__||Object.getPrototypeOf(Processing)).apply(this,arguments));}_createClass(Processing,[{key:'render',value:function render(){return _jsx(StyledProcessing,{},void 0,_jsx('ul',{className:'processing'},void 0,_jsx('li',{}),_jsx('li',{}),_jsx('li',{}),_jsx('li',{}),_jsx('li',{})),_jsx('h4',{className:'textHint'},void 0,this.props.label));}}]);return Processing;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Processing);

/***/ }),
/* 51 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(9);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var isModifiedEvent = function isModifiedEvent(event) {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
};

/**
 * The public API for rendering a history-aware <a>.
 */

var Link = function (_React$Component) {
  _inherits(Link, _React$Component);

  function Link() {
    var _temp, _this, _ret;

    _classCallCheck(this, Link);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.handleClick = function (event) {
      if (_this.props.onClick) _this.props.onClick(event);

      if (!event.defaultPrevented && // onClick prevented default
      event.button === 0 && // ignore everything but left clicks
      !_this.props.target && // let browser handle "target=_blank" etc.
      !isModifiedEvent(event) // ignore clicks with modifier keys
      ) {
          event.preventDefault();

          var history = _this.context.router.history;
          var _this$props = _this.props,
              replace = _this$props.replace,
              to = _this$props.to;


          if (replace) {
            history.replace(to);
          } else {
            history.push(to);
          }
        }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Link.prototype.render = function render() {
    var _props = this.props,
        replace = _props.replace,
        to = _props.to,
        innerRef = _props.innerRef,
        props = _objectWithoutProperties(_props, ["replace", "to", "innerRef"]); // eslint-disable-line no-unused-vars

    __WEBPACK_IMPORTED_MODULE_2_invariant___default()(this.context.router, "You should not use <Link> outside a <Router>");

    __WEBPACK_IMPORTED_MODULE_2_invariant___default()(to !== undefined, 'You must specify the "to" property');

    var history = this.context.router.history;

    var location = typeof to === "string" ? Object(__WEBPACK_IMPORTED_MODULE_3_history__["c" /* createLocation */])(to, null, null, history.location) : to;

    var href = history.createHref(location);
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", _extends({}, props, { onClick: this.handleClick, href: href, ref: innerRef }));
  };

  return Link;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Link.propTypes = {
  onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  target: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  to: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object]).isRequired,
  innerRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func])
};
Link.defaultProps = {
  replace: false
};
Link.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      createHref: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Link);

/***/ }),
/* 52 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Route__ = __webpack_require__(53);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Route__["a" /* default */]);

/***/ }),
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__matchPath__ = __webpack_require__(31);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var isEmptyChildren = function isEmptyChildren(children) {
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.count(children) === 0;
};

/**
 * The public API for matching a single path and rendering.
 */

var Route = function (_React$Component) {
  _inherits(Route, _React$Component);

  function Route() {
    var _temp, _this, _ret;

    _classCallCheck(this, Route);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      match: _this.computeMatch(_this.props, _this.context.router)
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Route.prototype.getChildContext = function getChildContext() {
    return {
      router: _extends({}, this.context.router, {
        route: {
          location: this.props.location || this.context.router.route.location,
          match: this.state.match
        }
      })
    };
  };

  Route.prototype.computeMatch = function computeMatch(_ref, router) {
    var computedMatch = _ref.computedMatch,
        location = _ref.location,
        path = _ref.path,
        strict = _ref.strict,
        exact = _ref.exact,
        sensitive = _ref.sensitive;

    if (computedMatch) return computedMatch; // <Switch> already computed the match for us

    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(router, "You should not use <Route> or withRouter() outside a <Router>");

    var route = router.route;

    var pathname = (location || route.location).pathname;

    return Object(__WEBPACK_IMPORTED_MODULE_4__matchPath__["a" /* default */])(pathname, { path: path, strict: strict, exact: exact, sensitive: sensitive }, route.match);
  };

  Route.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.component && this.props.render), "You should not use <Route component> and <Route render> in the same route; <Route render> will be ignored");

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.component && this.props.children && !isEmptyChildren(this.props.children)), "You should not use <Route component> and <Route children> in the same route; <Route children> will be ignored");

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.render && this.props.children && !isEmptyChildren(this.props.children)), "You should not use <Route render> and <Route children> in the same route; <Route children> will be ignored");
  };

  Route.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps, nextContext) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(nextProps.location && !this.props.location), '<Route> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(!nextProps.location && this.props.location), '<Route> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');

    this.setState({
      match: this.computeMatch(nextProps, nextContext.router)
    });
  };

  Route.prototype.render = function render() {
    var match = this.state.match;
    var _props = this.props,
        children = _props.children,
        component = _props.component,
        render = _props.render;
    var _context$router = this.context.router,
        history = _context$router.history,
        route = _context$router.route,
        staticContext = _context$router.staticContext;

    var location = this.props.location || route.location;
    var props = { match: match, location: location, history: history, staticContext: staticContext };

    if (component) return match ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(component, props) : null;

    if (render) return match ? render(props) : null;

    if (typeof children === "function") return children(props);

    if (children && !isEmptyChildren(children)) return __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.only(children);

    return null;
  };

  return Route;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

Route.propTypes = {
  computedMatch: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object, // private, from <Switch>
  path: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  exact: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  strict: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  sensitive: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  component: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  render: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node]),
  location: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
Route.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
    route: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
    staticContext: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
  })
};
Route.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Route);

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

var isarray = __webpack_require__(216)

/**
 * Expose `pathToRegexp`.
 */
module.exports = pathToRegexp
module.exports.parse = parse
module.exports.compile = compile
module.exports.tokensToFunction = tokensToFunction
module.exports.tokensToRegExp = tokensToRegExp

/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */
var PATH_REGEXP = new RegExp([
  // Match escaped characters that would otherwise appear in future matches.
  // This allows the user to escape special characters that won't transform.
  '(\\\\.)',
  // Match Express-style parameters and un-named parameters with a prefix
  // and optional suffixes. Matches appear as:
  //
  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
].join('|'), 'g')

/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */
function parse (str, options) {
  var tokens = []
  var key = 0
  var index = 0
  var path = ''
  var defaultDelimiter = options && options.delimiter || '/'
  var res

  while ((res = PATH_REGEXP.exec(str)) != null) {
    var m = res[0]
    var escaped = res[1]
    var offset = res.index
    path += str.slice(index, offset)
    index = offset + m.length

    // Ignore already escaped sequences.
    if (escaped) {
      path += escaped[1]
      continue
    }

    var next = str[index]
    var prefix = res[2]
    var name = res[3]
    var capture = res[4]
    var group = res[5]
    var modifier = res[6]
    var asterisk = res[7]

    // Push the current path onto the tokens.
    if (path) {
      tokens.push(path)
      path = ''
    }

    var partial = prefix != null && next != null && next !== prefix
    var repeat = modifier === '+' || modifier === '*'
    var optional = modifier === '?' || modifier === '*'
    var delimiter = res[2] || defaultDelimiter
    var pattern = capture || group

    tokens.push({
      name: name || key++,
      prefix: prefix || '',
      delimiter: delimiter,
      optional: optional,
      repeat: repeat,
      partial: partial,
      asterisk: !!asterisk,
      pattern: pattern ? escapeGroup(pattern) : (asterisk ? '.*' : '[^' + escapeString(delimiter) + ']+?')
    })
  }

  // Match any characters still remaining.
  if (index < str.length) {
    path += str.substr(index)
  }

  // If the path exists, push it onto the end.
  if (path) {
    tokens.push(path)
  }

  return tokens
}

/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */
function compile (str, options) {
  return tokensToFunction(parse(str, options))
}

/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */
function encodeURIComponentPretty (str) {
  return encodeURI(str).replace(/[\/?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */
function encodeAsterisk (str) {
  return encodeURI(str).replace(/[?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Expose a method for transforming tokens into the path function.
 */
function tokensToFunction (tokens) {
  // Compile all the tokens into regexps.
  var matches = new Array(tokens.length)

  // Compile all the patterns before compilation.
  for (var i = 0; i < tokens.length; i++) {
    if (typeof tokens[i] === 'object') {
      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$')
    }
  }

  return function (obj, opts) {
    var path = ''
    var data = obj || {}
    var options = opts || {}
    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent

    for (var i = 0; i < tokens.length; i++) {
      var token = tokens[i]

      if (typeof token === 'string') {
        path += token

        continue
      }

      var value = data[token.name]
      var segment

      if (value == null) {
        if (token.optional) {
          // Prepend partial segment prefixes.
          if (token.partial) {
            path += token.prefix
          }

          continue
        } else {
          throw new TypeError('Expected "' + token.name + '" to be defined')
        }
      }

      if (isarray(value)) {
        if (!token.repeat) {
          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`')
        }

        if (value.length === 0) {
          if (token.optional) {
            continue
          } else {
            throw new TypeError('Expected "' + token.name + '" to not be empty')
          }
        }

        for (var j = 0; j < value.length; j++) {
          segment = encode(value[j])

          if (!matches[i].test(segment)) {
            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`')
          }

          path += (j === 0 ? token.prefix : token.delimiter) + segment
        }

        continue
      }

      segment = token.asterisk ? encodeAsterisk(value) : encode(value)

      if (!matches[i].test(segment)) {
        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
      }

      path += token.prefix + segment
    }

    return path
  }
}

/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */
function escapeString (str) {
  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1')
}

/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */
function escapeGroup (group) {
  return group.replace(/([=!:$\/()])/g, '\\$1')
}

/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */
function attachKeys (re, keys) {
  re.keys = keys
  return re
}

/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */
function flags (options) {
  return options.sensitive ? '' : 'i'
}

/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */
function regexpToRegexp (path, keys) {
  // Use a negative lookahead to match only capturing groups.
  var groups = path.source.match(/\((?!\?)/g)

  if (groups) {
    for (var i = 0; i < groups.length; i++) {
      keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
      })
    }
  }

  return attachKeys(path, keys)
}

/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function arrayToRegexp (path, keys, options) {
  var parts = []

  for (var i = 0; i < path.length; i++) {
    parts.push(pathToRegexp(path[i], keys, options).source)
  }

  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options))

  return attachKeys(regexp, keys)
}

/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function stringToRegexp (path, keys, options) {
  return tokensToRegExp(parse(path, options), keys, options)
}

/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */
function tokensToRegExp (tokens, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options)
    keys = []
  }

  options = options || {}

  var strict = options.strict
  var end = options.end !== false
  var route = ''

  // Iterate over the tokens and create our regexp string.
  for (var i = 0; i < tokens.length; i++) {
    var token = tokens[i]

    if (typeof token === 'string') {
      route += escapeString(token)
    } else {
      var prefix = escapeString(token.prefix)
      var capture = '(?:' + token.pattern + ')'

      keys.push(token)

      if (token.repeat) {
        capture += '(?:' + prefix + capture + ')*'
      }

      if (token.optional) {
        if (!token.partial) {
          capture = '(?:' + prefix + '(' + capture + '))?'
        } else {
          capture = prefix + '(' + capture + ')?'
        }
      } else {
        capture = prefix + '(' + capture + ')'
      }

      route += capture
    }
  }

  var delimiter = escapeString(options.delimiter || '/')
  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter

  // In non-strict mode we allow a slash at the end of match. If the path to
  // match already ends with a slash, we remove it for consistency. The slash
  // is valid at the end of a path match, not in the middle. This is important
  // in non-ending mode, where "/test/" shouldn't match "/test//route".
  if (!strict) {
    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?'
  }

  if (end) {
    route += '$'
  } else {
    // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)'
  }

  return attachKeys(new RegExp('^' + route, flags(options)), keys)
}

/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */
function pathToRegexp (path, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options)
    keys = []
  }

  options = options || {}

  if (path instanceof RegExp) {
    return regexpToRegexp(path, /** @type {!Array} */ (keys))
  }

  if (isarray(path)) {
    return arrayToRegexp(/** @type {!Array} */ (path), /** @type {!Array} */ (keys), options)
  }

  return stringToRegexp(/** @type {string} */ (path), /** @type {!Array} */ (keys), options)
}


/***/ }),
/* 55 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_path_to_regexp__);


var patternCache = {};
var cacheLimit = 10000;
var cacheCount = 0;

var compileGenerator = function compileGenerator(pattern) {
  var cacheKey = pattern;
  var cache = patternCache[cacheKey] || (patternCache[cacheKey] = {});

  if (cache[pattern]) return cache[pattern];

  var compiledGenerator = __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default.a.compile(pattern);

  if (cacheCount < cacheLimit) {
    cache[pattern] = compiledGenerator;
    cacheCount++;
  }

  return compiledGenerator;
};

/**
 * Public API for generating a URL pathname from a pattern and parameters.
 */
var generatePath = function generatePath() {
  var pattern = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "/";
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (pattern === "/") {
    return pattern;
  }
  var generator = compileGenerator(pattern);
  return generator(params, { pretty: true });
};

/* harmony default export */ __webpack_exports__["a"] = (generatePath);

/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(57);
module.exports = __webpack_require__(58);


/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (typeof Promise === 'undefined') {
  // Rejection tracking prevents a common issue where React gets into an
  // inconsistent state due to an error, but it gets swallowed by a Promise,
  // and the user has no idea what causes React's erratic future behavior.
  //require('promise/lib/rejection-tracking').enable();
  //window.Promise = require('promise/lib/es6-extensions.js');
}

// fetch() polyfill for making API calls.
__webpack_require__(16);

// Object.assign() is commonly used with React.
// It will use the native implementation if it's present and isn't buggy.
Object.assign = __webpack_require__(17);

// In tests, polyfill requestAnimationFrame since jsdom doesn't provide it yet.
// We don't polyfill it in the browser--this is user's responsibility.
if (false) {
  require('raf').polyfill(global);
}


/***/ }),
/* 58 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__index_css__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__registerServiceWorker__ = __webpack_require__(231);
var _jsx=function(){var REACT_ELEMENT_TYPE=typeof Symbol==="function"&&Symbol.for&&Symbol.for("react.element")||0xeac7;return function createRawReactElement(type,props,key,children){var defaultProps=type&&type.defaultProps;var childrenLength=arguments.length-3;if(!props&&childrenLength!==0){props={};}if(props&&defaultProps){for(var propName in defaultProps){if(props[propName]===void 0){props[propName]=defaultProps[propName];}}}else if(!props){props=defaultProps||{};}if(childrenLength===1){props.children=children;}else if(childrenLength>1){var childArray=Array(childrenLength);for(var i=0;i<childrenLength;i++){childArray[i]=arguments[i+3];}props.children=childArray;}return{$$typeof:REACT_ELEMENT_TYPE,type:type,key:key===undefined?null:''+key,ref:null,props:props,_owner:null};};}();__WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.render(_jsx(__WEBPACK_IMPORTED_MODULE_3__App__["a" /* default */],{revieveConfig:window.revieveConfig}),document.getElementById('revieve-root'));Object(__WEBPACK_IMPORTED_MODULE_4__registerServiceWorker__["a" /* default */])();

/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.8.6
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var k=__webpack_require__(17),n="function"===typeof Symbol&&Symbol.for,p=n?Symbol.for("react.element"):60103,q=n?Symbol.for("react.portal"):60106,r=n?Symbol.for("react.fragment"):60107,t=n?Symbol.for("react.strict_mode"):60108,u=n?Symbol.for("react.profiler"):60114,v=n?Symbol.for("react.provider"):60109,w=n?Symbol.for("react.context"):60110,x=n?Symbol.for("react.concurrent_mode"):60111,y=n?Symbol.for("react.forward_ref"):60112,z=n?Symbol.for("react.suspense"):60113,aa=n?Symbol.for("react.memo"):
60115,ba=n?Symbol.for("react.lazy"):60116,A="function"===typeof Symbol&&Symbol.iterator;function ca(a,b,d,c,e,g,h,f){if(!a){a=void 0;if(void 0===b)a=Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");else{var l=[d,c,e,g,h,f],m=0;a=Error(b.replace(/%s/g,function(){return l[m++]}));a.name="Invariant Violation"}a.framesToPop=1;throw a;}}
function B(a){for(var b=arguments.length-1,d="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=0;c<b;c++)d+="&args[]="+encodeURIComponent(arguments[c+1]);ca(!1,"Minified React error #"+a+"; visit %s for the full message or use the non-minified dev environment for full errors and additional helpful warnings. ",d)}var C={isMounted:function(){return!1},enqueueForceUpdate:function(){},enqueueReplaceState:function(){},enqueueSetState:function(){}},D={};
function E(a,b,d){this.props=a;this.context=b;this.refs=D;this.updater=d||C}E.prototype.isReactComponent={};E.prototype.setState=function(a,b){"object"!==typeof a&&"function"!==typeof a&&null!=a?B("85"):void 0;this.updater.enqueueSetState(this,a,b,"setState")};E.prototype.forceUpdate=function(a){this.updater.enqueueForceUpdate(this,a,"forceUpdate")};function F(){}F.prototype=E.prototype;function G(a,b,d){this.props=a;this.context=b;this.refs=D;this.updater=d||C}var H=G.prototype=new F;
H.constructor=G;k(H,E.prototype);H.isPureReactComponent=!0;var I={current:null},J={current:null},K=Object.prototype.hasOwnProperty,L={key:!0,ref:!0,__self:!0,__source:!0};
function M(a,b,d){var c=void 0,e={},g=null,h=null;if(null!=b)for(c in void 0!==b.ref&&(h=b.ref),void 0!==b.key&&(g=""+b.key),b)K.call(b,c)&&!L.hasOwnProperty(c)&&(e[c]=b[c]);var f=arguments.length-2;if(1===f)e.children=d;else if(1<f){for(var l=Array(f),m=0;m<f;m++)l[m]=arguments[m+2];e.children=l}if(a&&a.defaultProps)for(c in f=a.defaultProps,f)void 0===e[c]&&(e[c]=f[c]);return{$$typeof:p,type:a,key:g,ref:h,props:e,_owner:J.current}}
function da(a,b){return{$$typeof:p,type:a.type,key:b,ref:a.ref,props:a.props,_owner:a._owner}}function N(a){return"object"===typeof a&&null!==a&&a.$$typeof===p}function escape(a){var b={"=":"=0",":":"=2"};return"$"+(""+a).replace(/[=:]/g,function(a){return b[a]})}var O=/\/+/g,P=[];function Q(a,b,d,c){if(P.length){var e=P.pop();e.result=a;e.keyPrefix=b;e.func=d;e.context=c;e.count=0;return e}return{result:a,keyPrefix:b,func:d,context:c,count:0}}
function R(a){a.result=null;a.keyPrefix=null;a.func=null;a.context=null;a.count=0;10>P.length&&P.push(a)}
function S(a,b,d,c){var e=typeof a;if("undefined"===e||"boolean"===e)a=null;var g=!1;if(null===a)g=!0;else switch(e){case "string":case "number":g=!0;break;case "object":switch(a.$$typeof){case p:case q:g=!0}}if(g)return d(c,a,""===b?"."+T(a,0):b),1;g=0;b=""===b?".":b+":";if(Array.isArray(a))for(var h=0;h<a.length;h++){e=a[h];var f=b+T(e,h);g+=S(e,f,d,c)}else if(null===a||"object"!==typeof a?f=null:(f=A&&a[A]||a["@@iterator"],f="function"===typeof f?f:null),"function"===typeof f)for(a=f.call(a),h=
0;!(e=a.next()).done;)e=e.value,f=b+T(e,h++),g+=S(e,f,d,c);else"object"===e&&(d=""+a,B("31","[object Object]"===d?"object with keys {"+Object.keys(a).join(", ")+"}":d,""));return g}function U(a,b,d){return null==a?0:S(a,"",b,d)}function T(a,b){return"object"===typeof a&&null!==a&&null!=a.key?escape(a.key):b.toString(36)}function ea(a,b){a.func.call(a.context,b,a.count++)}
function fa(a,b,d){var c=a.result,e=a.keyPrefix;a=a.func.call(a.context,b,a.count++);Array.isArray(a)?V(a,c,d,function(a){return a}):null!=a&&(N(a)&&(a=da(a,e+(!a.key||b&&b.key===a.key?"":(""+a.key).replace(O,"$&/")+"/")+d)),c.push(a))}function V(a,b,d,c,e){var g="";null!=d&&(g=(""+d).replace(O,"$&/")+"/");b=Q(b,g,c,e);U(a,fa,b);R(b)}function W(){var a=I.current;null===a?B("321"):void 0;return a}
var X={Children:{map:function(a,b,d){if(null==a)return a;var c=[];V(a,c,null,b,d);return c},forEach:function(a,b,d){if(null==a)return a;b=Q(null,null,b,d);U(a,ea,b);R(b)},count:function(a){return U(a,function(){return null},null)},toArray:function(a){var b=[];V(a,b,null,function(a){return a});return b},only:function(a){N(a)?void 0:B("143");return a}},createRef:function(){return{current:null}},Component:E,PureComponent:G,createContext:function(a,b){void 0===b&&(b=null);a={$$typeof:w,_calculateChangedBits:b,
_currentValue:a,_currentValue2:a,_threadCount:0,Provider:null,Consumer:null};a.Provider={$$typeof:v,_context:a};return a.Consumer=a},forwardRef:function(a){return{$$typeof:y,render:a}},lazy:function(a){return{$$typeof:ba,_ctor:a,_status:-1,_result:null}},memo:function(a,b){return{$$typeof:aa,type:a,compare:void 0===b?null:b}},useCallback:function(a,b){return W().useCallback(a,b)},useContext:function(a,b){return W().useContext(a,b)},useEffect:function(a,b){return W().useEffect(a,b)},useImperativeHandle:function(a,
b,d){return W().useImperativeHandle(a,b,d)},useDebugValue:function(){},useLayoutEffect:function(a,b){return W().useLayoutEffect(a,b)},useMemo:function(a,b){return W().useMemo(a,b)},useReducer:function(a,b,d){return W().useReducer(a,b,d)},useRef:function(a){return W().useRef(a)},useState:function(a){return W().useState(a)},Fragment:r,StrictMode:t,Suspense:z,createElement:M,cloneElement:function(a,b,d){null===a||void 0===a?B("267",a):void 0;var c=void 0,e=k({},a.props),g=a.key,h=a.ref,f=a._owner;if(null!=
b){void 0!==b.ref&&(h=b.ref,f=J.current);void 0!==b.key&&(g=""+b.key);var l=void 0;a.type&&a.type.defaultProps&&(l=a.type.defaultProps);for(c in b)K.call(b,c)&&!L.hasOwnProperty(c)&&(e[c]=void 0===b[c]&&void 0!==l?l[c]:b[c])}c=arguments.length-2;if(1===c)e.children=d;else if(1<c){l=Array(c);for(var m=0;m<c;m++)l[m]=arguments[m+2];e.children=l}return{$$typeof:p,type:a.type,key:g,ref:h,props:e,_owner:f}},createFactory:function(a){var b=M.bind(null,a);b.type=a;return b},isValidElement:N,version:"16.8.6",
unstable_ConcurrentMode:x,unstable_Profiler:u,__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{ReactCurrentDispatcher:I,ReactCurrentOwner:J,assign:k}},Y={default:X},Z=Y&&X||Y;module.exports=Z.default||Z;


/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.8.6
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

/*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/
var aa=__webpack_require__(0),n=__webpack_require__(17),r=__webpack_require__(61);function ba(a,b,c,d,e,f,g,h){if(!a){a=void 0;if(void 0===b)a=Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");else{var l=[c,d,e,f,g,h],k=0;a=Error(b.replace(/%s/g,function(){return l[k++]}));a.name="Invariant Violation"}a.framesToPop=1;throw a;}}
function x(a){for(var b=arguments.length-1,c="https://reactjs.org/docs/error-decoder.html?invariant="+a,d=0;d<b;d++)c+="&args[]="+encodeURIComponent(arguments[d+1]);ba(!1,"Minified React error #"+a+"; visit %s for the full message or use the non-minified dev environment for full errors and additional helpful warnings. ",c)}aa?void 0:x("227");function ca(a,b,c,d,e,f,g,h,l){var k=Array.prototype.slice.call(arguments,3);try{b.apply(c,k)}catch(m){this.onError(m)}}
var da=!1,ea=null,fa=!1,ha=null,ia={onError:function(a){da=!0;ea=a}};function ja(a,b,c,d,e,f,g,h,l){da=!1;ea=null;ca.apply(ia,arguments)}function ka(a,b,c,d,e,f,g,h,l){ja.apply(this,arguments);if(da){if(da){var k=ea;da=!1;ea=null}else x("198"),k=void 0;fa||(fa=!0,ha=k)}}var la=null,ma={};
function na(){if(la)for(var a in ma){var b=ma[a],c=la.indexOf(a);-1<c?void 0:x("96",a);if(!oa[c]){b.extractEvents?void 0:x("97",a);oa[c]=b;c=b.eventTypes;for(var d in c){var e=void 0;var f=c[d],g=b,h=d;pa.hasOwnProperty(h)?x("99",h):void 0;pa[h]=f;var l=f.phasedRegistrationNames;if(l){for(e in l)l.hasOwnProperty(e)&&qa(l[e],g,h);e=!0}else f.registrationName?(qa(f.registrationName,g,h),e=!0):e=!1;e?void 0:x("98",d,a)}}}}
function qa(a,b,c){ra[a]?x("100",a):void 0;ra[a]=b;sa[a]=b.eventTypes[c].dependencies}var oa=[],pa={},ra={},sa={},ta=null,ua=null,va=null;function wa(a,b,c){var d=a.type||"unknown-event";a.currentTarget=va(c);ka(d,b,void 0,a);a.currentTarget=null}function xa(a,b){null==b?x("30"):void 0;if(null==a)return b;if(Array.isArray(a)){if(Array.isArray(b))return a.push.apply(a,b),a;a.push(b);return a}return Array.isArray(b)?[a].concat(b):[a,b]}
function ya(a,b,c){Array.isArray(a)?a.forEach(b,c):a&&b.call(c,a)}var za=null;function Aa(a){if(a){var b=a._dispatchListeners,c=a._dispatchInstances;if(Array.isArray(b))for(var d=0;d<b.length&&!a.isPropagationStopped();d++)wa(a,b[d],c[d]);else b&&wa(a,b,c);a._dispatchListeners=null;a._dispatchInstances=null;a.isPersistent()||a.constructor.release(a)}}
var Ba={injectEventPluginOrder:function(a){la?x("101"):void 0;la=Array.prototype.slice.call(a);na()},injectEventPluginsByName:function(a){var b=!1,c;for(c in a)if(a.hasOwnProperty(c)){var d=a[c];ma.hasOwnProperty(c)&&ma[c]===d||(ma[c]?x("102",c):void 0,ma[c]=d,b=!0)}b&&na()}};
function Ca(a,b){var c=a.stateNode;if(!c)return null;var d=ta(c);if(!d)return null;c=d[b];a:switch(b){case "onClick":case "onClickCapture":case "onDoubleClick":case "onDoubleClickCapture":case "onMouseDown":case "onMouseDownCapture":case "onMouseMove":case "onMouseMoveCapture":case "onMouseUp":case "onMouseUpCapture":(d=!d.disabled)||(a=a.type,d=!("button"===a||"input"===a||"select"===a||"textarea"===a));a=!d;break a;default:a=!1}if(a)return null;c&&"function"!==typeof c?x("231",b,typeof c):void 0;
return c}function Da(a){null!==a&&(za=xa(za,a));a=za;za=null;if(a&&(ya(a,Aa),za?x("95"):void 0,fa))throw a=ha,fa=!1,ha=null,a;}var Ea=Math.random().toString(36).slice(2),Fa="__reactInternalInstance$"+Ea,Ga="__reactEventHandlers$"+Ea;function Ha(a){if(a[Fa])return a[Fa];for(;!a[Fa];)if(a.parentNode)a=a.parentNode;else return null;a=a[Fa];return 5===a.tag||6===a.tag?a:null}function Ia(a){a=a[Fa];return!a||5!==a.tag&&6!==a.tag?null:a}
function Ja(a){if(5===a.tag||6===a.tag)return a.stateNode;x("33")}function Ka(a){return a[Ga]||null}function La(a){do a=a.return;while(a&&5!==a.tag);return a?a:null}function Ma(a,b,c){if(b=Ca(a,c.dispatchConfig.phasedRegistrationNames[b]))c._dispatchListeners=xa(c._dispatchListeners,b),c._dispatchInstances=xa(c._dispatchInstances,a)}
function Na(a){if(a&&a.dispatchConfig.phasedRegistrationNames){for(var b=a._targetInst,c=[];b;)c.push(b),b=La(b);for(b=c.length;0<b--;)Ma(c[b],"captured",a);for(b=0;b<c.length;b++)Ma(c[b],"bubbled",a)}}function Oa(a,b,c){a&&c&&c.dispatchConfig.registrationName&&(b=Ca(a,c.dispatchConfig.registrationName))&&(c._dispatchListeners=xa(c._dispatchListeners,b),c._dispatchInstances=xa(c._dispatchInstances,a))}function Pa(a){a&&a.dispatchConfig.registrationName&&Oa(a._targetInst,null,a)}
function Qa(a){ya(a,Na)}var Ra=!("undefined"===typeof window||!window.document||!window.document.createElement);function Sa(a,b){var c={};c[a.toLowerCase()]=b.toLowerCase();c["Webkit"+a]="webkit"+b;c["Moz"+a]="moz"+b;return c}var Ta={animationend:Sa("Animation","AnimationEnd"),animationiteration:Sa("Animation","AnimationIteration"),animationstart:Sa("Animation","AnimationStart"),transitionend:Sa("Transition","TransitionEnd")},Ua={},Va={};
Ra&&(Va=document.createElement("div").style,"AnimationEvent"in window||(delete Ta.animationend.animation,delete Ta.animationiteration.animation,delete Ta.animationstart.animation),"TransitionEvent"in window||delete Ta.transitionend.transition);function Wa(a){if(Ua[a])return Ua[a];if(!Ta[a])return a;var b=Ta[a],c;for(c in b)if(b.hasOwnProperty(c)&&c in Va)return Ua[a]=b[c];return a}
var Xa=Wa("animationend"),Ya=Wa("animationiteration"),Za=Wa("animationstart"),$a=Wa("transitionend"),ab="abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" "),bb=null,cb=null,db=null;
function eb(){if(db)return db;var a,b=cb,c=b.length,d,e="value"in bb?bb.value:bb.textContent,f=e.length;for(a=0;a<c&&b[a]===e[a];a++);var g=c-a;for(d=1;d<=g&&b[c-d]===e[f-d];d++);return db=e.slice(a,1<d?1-d:void 0)}function fb(){return!0}function gb(){return!1}
function y(a,b,c,d){this.dispatchConfig=a;this._targetInst=b;this.nativeEvent=c;a=this.constructor.Interface;for(var e in a)a.hasOwnProperty(e)&&((b=a[e])?this[e]=b(c):"target"===e?this.target=d:this[e]=c[e]);this.isDefaultPrevented=(null!=c.defaultPrevented?c.defaultPrevented:!1===c.returnValue)?fb:gb;this.isPropagationStopped=gb;return this}
n(y.prototype,{preventDefault:function(){this.defaultPrevented=!0;var a=this.nativeEvent;a&&(a.preventDefault?a.preventDefault():"unknown"!==typeof a.returnValue&&(a.returnValue=!1),this.isDefaultPrevented=fb)},stopPropagation:function(){var a=this.nativeEvent;a&&(a.stopPropagation?a.stopPropagation():"unknown"!==typeof a.cancelBubble&&(a.cancelBubble=!0),this.isPropagationStopped=fb)},persist:function(){this.isPersistent=fb},isPersistent:gb,destructor:function(){var a=this.constructor.Interface,
b;for(b in a)this[b]=null;this.nativeEvent=this._targetInst=this.dispatchConfig=null;this.isPropagationStopped=this.isDefaultPrevented=gb;this._dispatchInstances=this._dispatchListeners=null}});y.Interface={type:null,target:null,currentTarget:function(){return null},eventPhase:null,bubbles:null,cancelable:null,timeStamp:function(a){return a.timeStamp||Date.now()},defaultPrevented:null,isTrusted:null};
y.extend=function(a){function b(){}function c(){return d.apply(this,arguments)}var d=this;b.prototype=d.prototype;var e=new b;n(e,c.prototype);c.prototype=e;c.prototype.constructor=c;c.Interface=n({},d.Interface,a);c.extend=d.extend;hb(c);return c};hb(y);function ib(a,b,c,d){if(this.eventPool.length){var e=this.eventPool.pop();this.call(e,a,b,c,d);return e}return new this(a,b,c,d)}function jb(a){a instanceof this?void 0:x("279");a.destructor();10>this.eventPool.length&&this.eventPool.push(a)}
function hb(a){a.eventPool=[];a.getPooled=ib;a.release=jb}var kb=y.extend({data:null}),lb=y.extend({data:null}),mb=[9,13,27,32],nb=Ra&&"CompositionEvent"in window,ob=null;Ra&&"documentMode"in document&&(ob=document.documentMode);
var pb=Ra&&"TextEvent"in window&&!ob,qb=Ra&&(!nb||ob&&8<ob&&11>=ob),rb=String.fromCharCode(32),sb={beforeInput:{phasedRegistrationNames:{bubbled:"onBeforeInput",captured:"onBeforeInputCapture"},dependencies:["compositionend","keypress","textInput","paste"]},compositionEnd:{phasedRegistrationNames:{bubbled:"onCompositionEnd",captured:"onCompositionEndCapture"},dependencies:"blur compositionend keydown keypress keyup mousedown".split(" ")},compositionStart:{phasedRegistrationNames:{bubbled:"onCompositionStart",
captured:"onCompositionStartCapture"},dependencies:"blur compositionstart keydown keypress keyup mousedown".split(" ")},compositionUpdate:{phasedRegistrationNames:{bubbled:"onCompositionUpdate",captured:"onCompositionUpdateCapture"},dependencies:"blur compositionupdate keydown keypress keyup mousedown".split(" ")}},tb=!1;
function ub(a,b){switch(a){case "keyup":return-1!==mb.indexOf(b.keyCode);case "keydown":return 229!==b.keyCode;case "keypress":case "mousedown":case "blur":return!0;default:return!1}}function vb(a){a=a.detail;return"object"===typeof a&&"data"in a?a.data:null}var wb=!1;function xb(a,b){switch(a){case "compositionend":return vb(b);case "keypress":if(32!==b.which)return null;tb=!0;return rb;case "textInput":return a=b.data,a===rb&&tb?null:a;default:return null}}
function yb(a,b){if(wb)return"compositionend"===a||!nb&&ub(a,b)?(a=eb(),db=cb=bb=null,wb=!1,a):null;switch(a){case "paste":return null;case "keypress":if(!(b.ctrlKey||b.altKey||b.metaKey)||b.ctrlKey&&b.altKey){if(b.char&&1<b.char.length)return b.char;if(b.which)return String.fromCharCode(b.which)}return null;case "compositionend":return qb&&"ko"!==b.locale?null:b.data;default:return null}}
var zb={eventTypes:sb,extractEvents:function(a,b,c,d){var e=void 0;var f=void 0;if(nb)b:{switch(a){case "compositionstart":e=sb.compositionStart;break b;case "compositionend":e=sb.compositionEnd;break b;case "compositionupdate":e=sb.compositionUpdate;break b}e=void 0}else wb?ub(a,c)&&(e=sb.compositionEnd):"keydown"===a&&229===c.keyCode&&(e=sb.compositionStart);e?(qb&&"ko"!==c.locale&&(wb||e!==sb.compositionStart?e===sb.compositionEnd&&wb&&(f=eb()):(bb=d,cb="value"in bb?bb.value:bb.textContent,wb=
!0)),e=kb.getPooled(e,b,c,d),f?e.data=f:(f=vb(c),null!==f&&(e.data=f)),Qa(e),f=e):f=null;(a=pb?xb(a,c):yb(a,c))?(b=lb.getPooled(sb.beforeInput,b,c,d),b.data=a,Qa(b)):b=null;return null===f?b:null===b?f:[f,b]}},Ab=null,Bb=null,Cb=null;function Db(a){if(a=ua(a)){"function"!==typeof Ab?x("280"):void 0;var b=ta(a.stateNode);Ab(a.stateNode,a.type,b)}}function Eb(a){Bb?Cb?Cb.push(a):Cb=[a]:Bb=a}function Fb(){if(Bb){var a=Bb,b=Cb;Cb=Bb=null;Db(a);if(b)for(a=0;a<b.length;a++)Db(b[a])}}
function Gb(a,b){return a(b)}function Hb(a,b,c){return a(b,c)}function Ib(){}var Jb=!1;function Kb(a,b){if(Jb)return a(b);Jb=!0;try{return Gb(a,b)}finally{if(Jb=!1,null!==Bb||null!==Cb)Ib(),Fb()}}var Lb={color:!0,date:!0,datetime:!0,"datetime-local":!0,email:!0,month:!0,number:!0,password:!0,range:!0,search:!0,tel:!0,text:!0,time:!0,url:!0,week:!0};function Mb(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return"input"===b?!!Lb[a.type]:"textarea"===b?!0:!1}
function Nb(a){a=a.target||a.srcElement||window;a.correspondingUseElement&&(a=a.correspondingUseElement);return 3===a.nodeType?a.parentNode:a}function Ob(a){if(!Ra)return!1;a="on"+a;var b=a in document;b||(b=document.createElement("div"),b.setAttribute(a,"return;"),b="function"===typeof b[a]);return b}function Pb(a){var b=a.type;return(a=a.nodeName)&&"input"===a.toLowerCase()&&("checkbox"===b||"radio"===b)}
function Qb(a){var b=Pb(a)?"checked":"value",c=Object.getOwnPropertyDescriptor(a.constructor.prototype,b),d=""+a[b];if(!a.hasOwnProperty(b)&&"undefined"!==typeof c&&"function"===typeof c.get&&"function"===typeof c.set){var e=c.get,f=c.set;Object.defineProperty(a,b,{configurable:!0,get:function(){return e.call(this)},set:function(a){d=""+a;f.call(this,a)}});Object.defineProperty(a,b,{enumerable:c.enumerable});return{getValue:function(){return d},setValue:function(a){d=""+a},stopTracking:function(){a._valueTracker=
null;delete a[b]}}}}function Rb(a){a._valueTracker||(a._valueTracker=Qb(a))}function Sb(a){if(!a)return!1;var b=a._valueTracker;if(!b)return!0;var c=b.getValue();var d="";a&&(d=Pb(a)?a.checked?"true":"false":a.value);a=d;return a!==c?(b.setValue(a),!0):!1}var Tb=aa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;Tb.hasOwnProperty("ReactCurrentDispatcher")||(Tb.ReactCurrentDispatcher={current:null});
var Ub=/^(.*)[\\\/]/,z="function"===typeof Symbol&&Symbol.for,Vb=z?Symbol.for("react.element"):60103,Wb=z?Symbol.for("react.portal"):60106,Xb=z?Symbol.for("react.fragment"):60107,Yb=z?Symbol.for("react.strict_mode"):60108,Zb=z?Symbol.for("react.profiler"):60114,$b=z?Symbol.for("react.provider"):60109,ac=z?Symbol.for("react.context"):60110,bc=z?Symbol.for("react.concurrent_mode"):60111,cc=z?Symbol.for("react.forward_ref"):60112,dc=z?Symbol.for("react.suspense"):60113,ec=z?Symbol.for("react.memo"):
60115,fc=z?Symbol.for("react.lazy"):60116,gc="function"===typeof Symbol&&Symbol.iterator;function hc(a){if(null===a||"object"!==typeof a)return null;a=gc&&a[gc]||a["@@iterator"];return"function"===typeof a?a:null}
function ic(a){if(null==a)return null;if("function"===typeof a)return a.displayName||a.name||null;if("string"===typeof a)return a;switch(a){case bc:return"ConcurrentMode";case Xb:return"Fragment";case Wb:return"Portal";case Zb:return"Profiler";case Yb:return"StrictMode";case dc:return"Suspense"}if("object"===typeof a)switch(a.$$typeof){case ac:return"Context.Consumer";case $b:return"Context.Provider";case cc:var b=a.render;b=b.displayName||b.name||"";return a.displayName||(""!==b?"ForwardRef("+b+
")":"ForwardRef");case ec:return ic(a.type);case fc:if(a=1===a._status?a._result:null)return ic(a)}return null}function jc(a){var b="";do{a:switch(a.tag){case 3:case 4:case 6:case 7:case 10:case 9:var c="";break a;default:var d=a._debugOwner,e=a._debugSource,f=ic(a.type);c=null;d&&(c=ic(d.type));d=f;f="";e?f=" (at "+e.fileName.replace(Ub,"")+":"+e.lineNumber+")":c&&(f=" (created by "+c+")");c="\n    in "+(d||"Unknown")+f}b+=c;a=a.return}while(a);return b}
var kc=/^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,lc=Object.prototype.hasOwnProperty,mc={},nc={};
function oc(a){if(lc.call(nc,a))return!0;if(lc.call(mc,a))return!1;if(kc.test(a))return nc[a]=!0;mc[a]=!0;return!1}function pc(a,b,c,d){if(null!==c&&0===c.type)return!1;switch(typeof b){case "function":case "symbol":return!0;case "boolean":if(d)return!1;if(null!==c)return!c.acceptsBooleans;a=a.toLowerCase().slice(0,5);return"data-"!==a&&"aria-"!==a;default:return!1}}
function qc(a,b,c,d){if(null===b||"undefined"===typeof b||pc(a,b,c,d))return!0;if(d)return!1;if(null!==c)switch(c.type){case 3:return!b;case 4:return!1===b;case 5:return isNaN(b);case 6:return isNaN(b)||1>b}return!1}function C(a,b,c,d,e){this.acceptsBooleans=2===b||3===b||4===b;this.attributeName=d;this.attributeNamespace=e;this.mustUseProperty=c;this.propertyName=a;this.type=b}var D={};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a){D[a]=new C(a,0,!1,a,null)});[["acceptCharset","accept-charset"],["className","class"],["htmlFor","for"],["httpEquiv","http-equiv"]].forEach(function(a){var b=a[0];D[b]=new C(b,1,!1,a[1],null)});["contentEditable","draggable","spellCheck","value"].forEach(function(a){D[a]=new C(a,2,!1,a.toLowerCase(),null)});
["autoReverse","externalResourcesRequired","focusable","preserveAlpha"].forEach(function(a){D[a]=new C(a,2,!1,a,null)});"allowFullScreen async autoFocus autoPlay controls default defer disabled formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a){D[a]=new C(a,3,!1,a.toLowerCase(),null)});["checked","multiple","muted","selected"].forEach(function(a){D[a]=new C(a,3,!0,a,null)});
["capture","download"].forEach(function(a){D[a]=new C(a,4,!1,a,null)});["cols","rows","size","span"].forEach(function(a){D[a]=new C(a,6,!1,a,null)});["rowSpan","start"].forEach(function(a){D[a]=new C(a,5,!1,a.toLowerCase(),null)});var rc=/[\-:]([a-z])/g;function sc(a){return a[1].toUpperCase()}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a){var b=a.replace(rc,
sc);D[b]=new C(b,1,!1,a,null)});"xlink:actuate xlink:arcrole xlink:href xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a){var b=a.replace(rc,sc);D[b]=new C(b,1,!1,a,"http://www.w3.org/1999/xlink")});["xml:base","xml:lang","xml:space"].forEach(function(a){var b=a.replace(rc,sc);D[b]=new C(b,1,!1,a,"http://www.w3.org/XML/1998/namespace")});["tabIndex","crossOrigin"].forEach(function(a){D[a]=new C(a,1,!1,a.toLowerCase(),null)});
function tc(a,b,c,d){var e=D.hasOwnProperty(b)?D[b]:null;var f=null!==e?0===e.type:d?!1:!(2<b.length)||"o"!==b[0]&&"O"!==b[0]||"n"!==b[1]&&"N"!==b[1]?!1:!0;f||(qc(b,c,e,d)&&(c=null),d||null===e?oc(b)&&(null===c?a.removeAttribute(b):a.setAttribute(b,""+c)):e.mustUseProperty?a[e.propertyName]=null===c?3===e.type?!1:"":c:(b=e.attributeName,d=e.attributeNamespace,null===c?a.removeAttribute(b):(e=e.type,c=3===e||4===e&&!0===c?"":""+c,d?a.setAttributeNS(d,b,c):a.setAttribute(b,c))))}
function uc(a){switch(typeof a){case "boolean":case "number":case "object":case "string":case "undefined":return a;default:return""}}function vc(a,b){var c=b.checked;return n({},b,{defaultChecked:void 0,defaultValue:void 0,value:void 0,checked:null!=c?c:a._wrapperState.initialChecked})}
function wc(a,b){var c=null==b.defaultValue?"":b.defaultValue,d=null!=b.checked?b.checked:b.defaultChecked;c=uc(null!=b.value?b.value:c);a._wrapperState={initialChecked:d,initialValue:c,controlled:"checkbox"===b.type||"radio"===b.type?null!=b.checked:null!=b.value}}function xc(a,b){b=b.checked;null!=b&&tc(a,"checked",b,!1)}
function yc(a,b){xc(a,b);var c=uc(b.value),d=b.type;if(null!=c)if("number"===d){if(0===c&&""===a.value||a.value!=c)a.value=""+c}else a.value!==""+c&&(a.value=""+c);else if("submit"===d||"reset"===d){a.removeAttribute("value");return}b.hasOwnProperty("value")?zc(a,b.type,c):b.hasOwnProperty("defaultValue")&&zc(a,b.type,uc(b.defaultValue));null==b.checked&&null!=b.defaultChecked&&(a.defaultChecked=!!b.defaultChecked)}
function Ac(a,b,c){if(b.hasOwnProperty("value")||b.hasOwnProperty("defaultValue")){var d=b.type;if(!("submit"!==d&&"reset"!==d||void 0!==b.value&&null!==b.value))return;b=""+a._wrapperState.initialValue;c||b===a.value||(a.value=b);a.defaultValue=b}c=a.name;""!==c&&(a.name="");a.defaultChecked=!a.defaultChecked;a.defaultChecked=!!a._wrapperState.initialChecked;""!==c&&(a.name=c)}
function zc(a,b,c){if("number"!==b||a.ownerDocument.activeElement!==a)null==c?a.defaultValue=""+a._wrapperState.initialValue:a.defaultValue!==""+c&&(a.defaultValue=""+c)}var Bc={change:{phasedRegistrationNames:{bubbled:"onChange",captured:"onChangeCapture"},dependencies:"blur change click focus input keydown keyup selectionchange".split(" ")}};function Cc(a,b,c){a=y.getPooled(Bc.change,a,b,c);a.type="change";Eb(c);Qa(a);return a}var Dc=null,Ec=null;function Fc(a){Da(a)}
function Gc(a){var b=Ja(a);if(Sb(b))return a}function Hc(a,b){if("change"===a)return b}var Ic=!1;Ra&&(Ic=Ob("input")&&(!document.documentMode||9<document.documentMode));function Jc(){Dc&&(Dc.detachEvent("onpropertychange",Kc),Ec=Dc=null)}function Kc(a){"value"===a.propertyName&&Gc(Ec)&&(a=Cc(Ec,a,Nb(a)),Kb(Fc,a))}function Lc(a,b,c){"focus"===a?(Jc(),Dc=b,Ec=c,Dc.attachEvent("onpropertychange",Kc)):"blur"===a&&Jc()}function Mc(a){if("selectionchange"===a||"keyup"===a||"keydown"===a)return Gc(Ec)}
function Nc(a,b){if("click"===a)return Gc(b)}function Oc(a,b){if("input"===a||"change"===a)return Gc(b)}
var Pc={eventTypes:Bc,_isInputEventSupported:Ic,extractEvents:function(a,b,c,d){var e=b?Ja(b):window,f=void 0,g=void 0,h=e.nodeName&&e.nodeName.toLowerCase();"select"===h||"input"===h&&"file"===e.type?f=Hc:Mb(e)?Ic?f=Oc:(f=Mc,g=Lc):(h=e.nodeName)&&"input"===h.toLowerCase()&&("checkbox"===e.type||"radio"===e.type)&&(f=Nc);if(f&&(f=f(a,b)))return Cc(f,c,d);g&&g(a,e,b);"blur"===a&&(a=e._wrapperState)&&a.controlled&&"number"===e.type&&zc(e,"number",e.value)}},Qc=y.extend({view:null,detail:null}),Rc={Alt:"altKey",
Control:"ctrlKey",Meta:"metaKey",Shift:"shiftKey"};function Sc(a){var b=this.nativeEvent;return b.getModifierState?b.getModifierState(a):(a=Rc[a])?!!b[a]:!1}function Tc(){return Sc}
var Uc=0,Vc=0,Wc=!1,Xc=!1,Yc=Qc.extend({screenX:null,screenY:null,clientX:null,clientY:null,pageX:null,pageY:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,getModifierState:Tc,button:null,buttons:null,relatedTarget:function(a){return a.relatedTarget||(a.fromElement===a.srcElement?a.toElement:a.fromElement)},movementX:function(a){if("movementX"in a)return a.movementX;var b=Uc;Uc=a.screenX;return Wc?"mousemove"===a.type?a.screenX-b:0:(Wc=!0,0)},movementY:function(a){if("movementY"in a)return a.movementY;
var b=Vc;Vc=a.screenY;return Xc?"mousemove"===a.type?a.screenY-b:0:(Xc=!0,0)}}),Zc=Yc.extend({pointerId:null,width:null,height:null,pressure:null,tangentialPressure:null,tiltX:null,tiltY:null,twist:null,pointerType:null,isPrimary:null}),$c={mouseEnter:{registrationName:"onMouseEnter",dependencies:["mouseout","mouseover"]},mouseLeave:{registrationName:"onMouseLeave",dependencies:["mouseout","mouseover"]},pointerEnter:{registrationName:"onPointerEnter",dependencies:["pointerout","pointerover"]},pointerLeave:{registrationName:"onPointerLeave",
dependencies:["pointerout","pointerover"]}},ad={eventTypes:$c,extractEvents:function(a,b,c,d){var e="mouseover"===a||"pointerover"===a,f="mouseout"===a||"pointerout"===a;if(e&&(c.relatedTarget||c.fromElement)||!f&&!e)return null;e=d.window===d?d:(e=d.ownerDocument)?e.defaultView||e.parentWindow:window;f?(f=b,b=(b=c.relatedTarget||c.toElement)?Ha(b):null):f=null;if(f===b)return null;var g=void 0,h=void 0,l=void 0,k=void 0;if("mouseout"===a||"mouseover"===a)g=Yc,h=$c.mouseLeave,l=$c.mouseEnter,k="mouse";
else if("pointerout"===a||"pointerover"===a)g=Zc,h=$c.pointerLeave,l=$c.pointerEnter,k="pointer";var m=null==f?e:Ja(f);e=null==b?e:Ja(b);a=g.getPooled(h,f,c,d);a.type=k+"leave";a.target=m;a.relatedTarget=e;c=g.getPooled(l,b,c,d);c.type=k+"enter";c.target=e;c.relatedTarget=m;d=b;if(f&&d)a:{b=f;e=d;k=0;for(g=b;g;g=La(g))k++;g=0;for(l=e;l;l=La(l))g++;for(;0<k-g;)b=La(b),k--;for(;0<g-k;)e=La(e),g--;for(;k--;){if(b===e||b===e.alternate)break a;b=La(b);e=La(e)}b=null}else b=null;e=b;for(b=[];f&&f!==e;){k=
f.alternate;if(null!==k&&k===e)break;b.push(f);f=La(f)}for(f=[];d&&d!==e;){k=d.alternate;if(null!==k&&k===e)break;f.push(d);d=La(d)}for(d=0;d<b.length;d++)Oa(b[d],"bubbled",a);for(d=f.length;0<d--;)Oa(f[d],"captured",c);return[a,c]}};function bd(a,b){return a===b&&(0!==a||1/a===1/b)||a!==a&&b!==b}var cd=Object.prototype.hasOwnProperty;
function dd(a,b){if(bd(a,b))return!0;if("object"!==typeof a||null===a||"object"!==typeof b||null===b)return!1;var c=Object.keys(a),d=Object.keys(b);if(c.length!==d.length)return!1;for(d=0;d<c.length;d++)if(!cd.call(b,c[d])||!bd(a[c[d]],b[c[d]]))return!1;return!0}function ed(a){var b=a;if(a.alternate)for(;b.return;)b=b.return;else{if(0!==(b.effectTag&2))return 1;for(;b.return;)if(b=b.return,0!==(b.effectTag&2))return 1}return 3===b.tag?2:3}function fd(a){2!==ed(a)?x("188"):void 0}
function gd(a){var b=a.alternate;if(!b)return b=ed(a),3===b?x("188"):void 0,1===b?null:a;for(var c=a,d=b;;){var e=c.return,f=e?e.alternate:null;if(!e||!f)break;if(e.child===f.child){for(var g=e.child;g;){if(g===c)return fd(e),a;if(g===d)return fd(e),b;g=g.sibling}x("188")}if(c.return!==d.return)c=e,d=f;else{g=!1;for(var h=e.child;h;){if(h===c){g=!0;c=e;d=f;break}if(h===d){g=!0;d=e;c=f;break}h=h.sibling}if(!g){for(h=f.child;h;){if(h===c){g=!0;c=f;d=e;break}if(h===d){g=!0;d=f;c=e;break}h=h.sibling}g?
void 0:x("189")}}c.alternate!==d?x("190"):void 0}3!==c.tag?x("188"):void 0;return c.stateNode.current===c?a:b}function hd(a){a=gd(a);if(!a)return null;for(var b=a;;){if(5===b.tag||6===b.tag)return b;if(b.child)b.child.return=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}}return null}
var id=y.extend({animationName:null,elapsedTime:null,pseudoElement:null}),jd=y.extend({clipboardData:function(a){return"clipboardData"in a?a.clipboardData:window.clipboardData}}),kd=Qc.extend({relatedTarget:null});function ld(a){var b=a.keyCode;"charCode"in a?(a=a.charCode,0===a&&13===b&&(a=13)):a=b;10===a&&(a=13);return 32<=a||13===a?a:0}
var md={Esc:"Escape",Spacebar:" ",Left:"ArrowLeft",Up:"ArrowUp",Right:"ArrowRight",Down:"ArrowDown",Del:"Delete",Win:"OS",Menu:"ContextMenu",Apps:"ContextMenu",Scroll:"ScrollLock",MozPrintableKey:"Unidentified"},nd={8:"Backspace",9:"Tab",12:"Clear",13:"Enter",16:"Shift",17:"Control",18:"Alt",19:"Pause",20:"CapsLock",27:"Escape",32:" ",33:"PageUp",34:"PageDown",35:"End",36:"Home",37:"ArrowLeft",38:"ArrowUp",39:"ArrowRight",40:"ArrowDown",45:"Insert",46:"Delete",112:"F1",113:"F2",114:"F3",115:"F4",
116:"F5",117:"F6",118:"F7",119:"F8",120:"F9",121:"F10",122:"F11",123:"F12",144:"NumLock",145:"ScrollLock",224:"Meta"},od=Qc.extend({key:function(a){if(a.key){var b=md[a.key]||a.key;if("Unidentified"!==b)return b}return"keypress"===a.type?(a=ld(a),13===a?"Enter":String.fromCharCode(a)):"keydown"===a.type||"keyup"===a.type?nd[a.keyCode]||"Unidentified":""},location:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,repeat:null,locale:null,getModifierState:Tc,charCode:function(a){return"keypress"===
a.type?ld(a):0},keyCode:function(a){return"keydown"===a.type||"keyup"===a.type?a.keyCode:0},which:function(a){return"keypress"===a.type?ld(a):"keydown"===a.type||"keyup"===a.type?a.keyCode:0}}),pd=Yc.extend({dataTransfer:null}),qd=Qc.extend({touches:null,targetTouches:null,changedTouches:null,altKey:null,metaKey:null,ctrlKey:null,shiftKey:null,getModifierState:Tc}),rd=y.extend({propertyName:null,elapsedTime:null,pseudoElement:null}),sd=Yc.extend({deltaX:function(a){return"deltaX"in a?a.deltaX:"wheelDeltaX"in
a?-a.wheelDeltaX:0},deltaY:function(a){return"deltaY"in a?a.deltaY:"wheelDeltaY"in a?-a.wheelDeltaY:"wheelDelta"in a?-a.wheelDelta:0},deltaZ:null,deltaMode:null}),td=[["abort","abort"],[Xa,"animationEnd"],[Ya,"animationIteration"],[Za,"animationStart"],["canplay","canPlay"],["canplaythrough","canPlayThrough"],["drag","drag"],["dragenter","dragEnter"],["dragexit","dragExit"],["dragleave","dragLeave"],["dragover","dragOver"],["durationchange","durationChange"],["emptied","emptied"],["encrypted","encrypted"],
["ended","ended"],["error","error"],["gotpointercapture","gotPointerCapture"],["load","load"],["loadeddata","loadedData"],["loadedmetadata","loadedMetadata"],["loadstart","loadStart"],["lostpointercapture","lostPointerCapture"],["mousemove","mouseMove"],["mouseout","mouseOut"],["mouseover","mouseOver"],["playing","playing"],["pointermove","pointerMove"],["pointerout","pointerOut"],["pointerover","pointerOver"],["progress","progress"],["scroll","scroll"],["seeking","seeking"],["stalled","stalled"],
["suspend","suspend"],["timeupdate","timeUpdate"],["toggle","toggle"],["touchmove","touchMove"],[$a,"transitionEnd"],["waiting","waiting"],["wheel","wheel"]],ud={},vd={};function wd(a,b){var c=a[0];a=a[1];var d="on"+(a[0].toUpperCase()+a.slice(1));b={phasedRegistrationNames:{bubbled:d,captured:d+"Capture"},dependencies:[c],isInteractive:b};ud[a]=b;vd[c]=b}
[["blur","blur"],["cancel","cancel"],["click","click"],["close","close"],["contextmenu","contextMenu"],["copy","copy"],["cut","cut"],["auxclick","auxClick"],["dblclick","doubleClick"],["dragend","dragEnd"],["dragstart","dragStart"],["drop","drop"],["focus","focus"],["input","input"],["invalid","invalid"],["keydown","keyDown"],["keypress","keyPress"],["keyup","keyUp"],["mousedown","mouseDown"],["mouseup","mouseUp"],["paste","paste"],["pause","pause"],["play","play"],["pointercancel","pointerCancel"],
["pointerdown","pointerDown"],["pointerup","pointerUp"],["ratechange","rateChange"],["reset","reset"],["seeked","seeked"],["submit","submit"],["touchcancel","touchCancel"],["touchend","touchEnd"],["touchstart","touchStart"],["volumechange","volumeChange"]].forEach(function(a){wd(a,!0)});td.forEach(function(a){wd(a,!1)});
var xd={eventTypes:ud,isInteractiveTopLevelEventType:function(a){a=vd[a];return void 0!==a&&!0===a.isInteractive},extractEvents:function(a,b,c,d){var e=vd[a];if(!e)return null;switch(a){case "keypress":if(0===ld(c))return null;case "keydown":case "keyup":a=od;break;case "blur":case "focus":a=kd;break;case "click":if(2===c.button)return null;case "auxclick":case "dblclick":case "mousedown":case "mousemove":case "mouseup":case "mouseout":case "mouseover":case "contextmenu":a=Yc;break;case "drag":case "dragend":case "dragenter":case "dragexit":case "dragleave":case "dragover":case "dragstart":case "drop":a=
pd;break;case "touchcancel":case "touchend":case "touchmove":case "touchstart":a=qd;break;case Xa:case Ya:case Za:a=id;break;case $a:a=rd;break;case "scroll":a=Qc;break;case "wheel":a=sd;break;case "copy":case "cut":case "paste":a=jd;break;case "gotpointercapture":case "lostpointercapture":case "pointercancel":case "pointerdown":case "pointermove":case "pointerout":case "pointerover":case "pointerup":a=Zc;break;default:a=y}b=a.getPooled(e,b,c,d);Qa(b);return b}},yd=xd.isInteractiveTopLevelEventType,
zd=[];function Ad(a){var b=a.targetInst,c=b;do{if(!c){a.ancestors.push(c);break}var d;for(d=c;d.return;)d=d.return;d=3!==d.tag?null:d.stateNode.containerInfo;if(!d)break;a.ancestors.push(c);c=Ha(d)}while(c);for(c=0;c<a.ancestors.length;c++){b=a.ancestors[c];var e=Nb(a.nativeEvent);d=a.topLevelType;for(var f=a.nativeEvent,g=null,h=0;h<oa.length;h++){var l=oa[h];l&&(l=l.extractEvents(d,b,f,e))&&(g=xa(g,l))}Da(g)}}var Bd=!0;
function E(a,b){if(!b)return null;var c=(yd(a)?Cd:Dd).bind(null,a);b.addEventListener(a,c,!1)}function Ed(a,b){if(!b)return null;var c=(yd(a)?Cd:Dd).bind(null,a);b.addEventListener(a,c,!0)}function Cd(a,b){Hb(Dd,a,b)}
function Dd(a,b){if(Bd){var c=Nb(b);c=Ha(c);null===c||"number"!==typeof c.tag||2===ed(c)||(c=null);if(zd.length){var d=zd.pop();d.topLevelType=a;d.nativeEvent=b;d.targetInst=c;a=d}else a={topLevelType:a,nativeEvent:b,targetInst:c,ancestors:[]};try{Kb(Ad,a)}finally{a.topLevelType=null,a.nativeEvent=null,a.targetInst=null,a.ancestors.length=0,10>zd.length&&zd.push(a)}}}var Fd={},Gd=0,Hd="_reactListenersID"+(""+Math.random()).slice(2);
function Id(a){Object.prototype.hasOwnProperty.call(a,Hd)||(a[Hd]=Gd++,Fd[a[Hd]]={});return Fd[a[Hd]]}function Jd(a){a=a||("undefined"!==typeof document?document:void 0);if("undefined"===typeof a)return null;try{return a.activeElement||a.body}catch(b){return a.body}}function Kd(a){for(;a&&a.firstChild;)a=a.firstChild;return a}
function Ld(a,b){var c=Kd(a);a=0;for(var d;c;){if(3===c.nodeType){d=a+c.textContent.length;if(a<=b&&d>=b)return{node:c,offset:b-a};a=d}a:{for(;c;){if(c.nextSibling){c=c.nextSibling;break a}c=c.parentNode}c=void 0}c=Kd(c)}}function Md(a,b){return a&&b?a===b?!0:a&&3===a.nodeType?!1:b&&3===b.nodeType?Md(a,b.parentNode):"contains"in a?a.contains(b):a.compareDocumentPosition?!!(a.compareDocumentPosition(b)&16):!1:!1}
function Nd(){for(var a=window,b=Jd();b instanceof a.HTMLIFrameElement;){try{var c="string"===typeof b.contentWindow.location.href}catch(d){c=!1}if(c)a=b.contentWindow;else break;b=Jd(a.document)}return b}function Od(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return b&&("input"===b&&("text"===a.type||"search"===a.type||"tel"===a.type||"url"===a.type||"password"===a.type)||"textarea"===b||"true"===a.contentEditable)}
function Pd(){var a=Nd();if(Od(a)){if("selectionStart"in a)var b={start:a.selectionStart,end:a.selectionEnd};else a:{b=(b=a.ownerDocument)&&b.defaultView||window;var c=b.getSelection&&b.getSelection();if(c&&0!==c.rangeCount){b=c.anchorNode;var d=c.anchorOffset,e=c.focusNode;c=c.focusOffset;try{b.nodeType,e.nodeType}catch(A){b=null;break a}var f=0,g=-1,h=-1,l=0,k=0,m=a,p=null;b:for(;;){for(var t;;){m!==b||0!==d&&3!==m.nodeType||(g=f+d);m!==e||0!==c&&3!==m.nodeType||(h=f+c);3===m.nodeType&&(f+=m.nodeValue.length);
if(null===(t=m.firstChild))break;p=m;m=t}for(;;){if(m===a)break b;p===b&&++l===d&&(g=f);p===e&&++k===c&&(h=f);if(null!==(t=m.nextSibling))break;m=p;p=m.parentNode}m=t}b=-1===g||-1===h?null:{start:g,end:h}}else b=null}b=b||{start:0,end:0}}else b=null;return{focusedElem:a,selectionRange:b}}
function Qd(a){var b=Nd(),c=a.focusedElem,d=a.selectionRange;if(b!==c&&c&&c.ownerDocument&&Md(c.ownerDocument.documentElement,c)){if(null!==d&&Od(c))if(b=d.start,a=d.end,void 0===a&&(a=b),"selectionStart"in c)c.selectionStart=b,c.selectionEnd=Math.min(a,c.value.length);else if(a=(b=c.ownerDocument||document)&&b.defaultView||window,a.getSelection){a=a.getSelection();var e=c.textContent.length,f=Math.min(d.start,e);d=void 0===d.end?f:Math.min(d.end,e);!a.extend&&f>d&&(e=d,d=f,f=e);e=Ld(c,f);var g=Ld(c,
d);e&&g&&(1!==a.rangeCount||a.anchorNode!==e.node||a.anchorOffset!==e.offset||a.focusNode!==g.node||a.focusOffset!==g.offset)&&(b=b.createRange(),b.setStart(e.node,e.offset),a.removeAllRanges(),f>d?(a.addRange(b),a.extend(g.node,g.offset)):(b.setEnd(g.node,g.offset),a.addRange(b)))}b=[];for(a=c;a=a.parentNode;)1===a.nodeType&&b.push({element:a,left:a.scrollLeft,top:a.scrollTop});"function"===typeof c.focus&&c.focus();for(c=0;c<b.length;c++)a=b[c],a.element.scrollLeft=a.left,a.element.scrollTop=a.top}}
var Rd=Ra&&"documentMode"in document&&11>=document.documentMode,Sd={select:{phasedRegistrationNames:{bubbled:"onSelect",captured:"onSelectCapture"},dependencies:"blur contextmenu dragend focus keydown keyup mousedown mouseup selectionchange".split(" ")}},Td=null,Ud=null,Vd=null,Wd=!1;
function Xd(a,b){var c=b.window===b?b.document:9===b.nodeType?b:b.ownerDocument;if(Wd||null==Td||Td!==Jd(c))return null;c=Td;"selectionStart"in c&&Od(c)?c={start:c.selectionStart,end:c.selectionEnd}:(c=(c.ownerDocument&&c.ownerDocument.defaultView||window).getSelection(),c={anchorNode:c.anchorNode,anchorOffset:c.anchorOffset,focusNode:c.focusNode,focusOffset:c.focusOffset});return Vd&&dd(Vd,c)?null:(Vd=c,a=y.getPooled(Sd.select,Ud,a,b),a.type="select",a.target=Td,Qa(a),a)}
var Yd={eventTypes:Sd,extractEvents:function(a,b,c,d){var e=d.window===d?d.document:9===d.nodeType?d:d.ownerDocument,f;if(!(f=!e)){a:{e=Id(e);f=sa.onSelect;for(var g=0;g<f.length;g++){var h=f[g];if(!e.hasOwnProperty(h)||!e[h]){e=!1;break a}}e=!0}f=!e}if(f)return null;e=b?Ja(b):window;switch(a){case "focus":if(Mb(e)||"true"===e.contentEditable)Td=e,Ud=b,Vd=null;break;case "blur":Vd=Ud=Td=null;break;case "mousedown":Wd=!0;break;case "contextmenu":case "mouseup":case "dragend":return Wd=!1,Xd(c,d);case "selectionchange":if(Rd)break;
case "keydown":case "keyup":return Xd(c,d)}return null}};Ba.injectEventPluginOrder("ResponderEventPlugin SimpleEventPlugin EnterLeaveEventPlugin ChangeEventPlugin SelectEventPlugin BeforeInputEventPlugin".split(" "));ta=Ka;ua=Ia;va=Ja;Ba.injectEventPluginsByName({SimpleEventPlugin:xd,EnterLeaveEventPlugin:ad,ChangeEventPlugin:Pc,SelectEventPlugin:Yd,BeforeInputEventPlugin:zb});function Zd(a){var b="";aa.Children.forEach(a,function(a){null!=a&&(b+=a)});return b}
function $d(a,b){a=n({children:void 0},b);if(b=Zd(b.children))a.children=b;return a}function ae(a,b,c,d){a=a.options;if(b){b={};for(var e=0;e<c.length;e++)b["$"+c[e]]=!0;for(c=0;c<a.length;c++)e=b.hasOwnProperty("$"+a[c].value),a[c].selected!==e&&(a[c].selected=e),e&&d&&(a[c].defaultSelected=!0)}else{c=""+uc(c);b=null;for(e=0;e<a.length;e++){if(a[e].value===c){a[e].selected=!0;d&&(a[e].defaultSelected=!0);return}null!==b||a[e].disabled||(b=a[e])}null!==b&&(b.selected=!0)}}
function be(a,b){null!=b.dangerouslySetInnerHTML?x("91"):void 0;return n({},b,{value:void 0,defaultValue:void 0,children:""+a._wrapperState.initialValue})}function ce(a,b){var c=b.value;null==c&&(c=b.defaultValue,b=b.children,null!=b&&(null!=c?x("92"):void 0,Array.isArray(b)&&(1>=b.length?void 0:x("93"),b=b[0]),c=b),null==c&&(c=""));a._wrapperState={initialValue:uc(c)}}
function de(a,b){var c=uc(b.value),d=uc(b.defaultValue);null!=c&&(c=""+c,c!==a.value&&(a.value=c),null==b.defaultValue&&a.defaultValue!==c&&(a.defaultValue=c));null!=d&&(a.defaultValue=""+d)}function ee(a){var b=a.textContent;b===a._wrapperState.initialValue&&(a.value=b)}var fe={html:"http://www.w3.org/1999/xhtml",mathml:"http://www.w3.org/1998/Math/MathML",svg:"http://www.w3.org/2000/svg"};
function ge(a){switch(a){case "svg":return"http://www.w3.org/2000/svg";case "math":return"http://www.w3.org/1998/Math/MathML";default:return"http://www.w3.org/1999/xhtml"}}function he(a,b){return null==a||"http://www.w3.org/1999/xhtml"===a?ge(b):"http://www.w3.org/2000/svg"===a&&"foreignObject"===b?"http://www.w3.org/1999/xhtml":a}
var ie=void 0,je=function(a){return"undefined"!==typeof MSApp&&MSApp.execUnsafeLocalFunction?function(b,c,d,e){MSApp.execUnsafeLocalFunction(function(){return a(b,c,d,e)})}:a}(function(a,b){if(a.namespaceURI!==fe.svg||"innerHTML"in a)a.innerHTML=b;else{ie=ie||document.createElement("div");ie.innerHTML="<svg>"+b+"</svg>";for(b=ie.firstChild;a.firstChild;)a.removeChild(a.firstChild);for(;b.firstChild;)a.appendChild(b.firstChild)}});
function ke(a,b){if(b){var c=a.firstChild;if(c&&c===a.lastChild&&3===c.nodeType){c.nodeValue=b;return}}a.textContent=b}
var le={animationIterationCount:!0,borderImageOutset:!0,borderImageSlice:!0,borderImageWidth:!0,boxFlex:!0,boxFlexGroup:!0,boxOrdinalGroup:!0,columnCount:!0,columns:!0,flex:!0,flexGrow:!0,flexPositive:!0,flexShrink:!0,flexNegative:!0,flexOrder:!0,gridArea:!0,gridRow:!0,gridRowEnd:!0,gridRowSpan:!0,gridRowStart:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnSpan:!0,gridColumnStart:!0,fontWeight:!0,lineClamp:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,tabSize:!0,widows:!0,zIndex:!0,zoom:!0,fillOpacity:!0,
floodOpacity:!0,stopOpacity:!0,strokeDasharray:!0,strokeDashoffset:!0,strokeMiterlimit:!0,strokeOpacity:!0,strokeWidth:!0},me=["Webkit","ms","Moz","O"];Object.keys(le).forEach(function(a){me.forEach(function(b){b=b+a.charAt(0).toUpperCase()+a.substring(1);le[b]=le[a]})});function ne(a,b,c){return null==b||"boolean"===typeof b||""===b?"":c||"number"!==typeof b||0===b||le.hasOwnProperty(a)&&le[a]?(""+b).trim():b+"px"}
function oe(a,b){a=a.style;for(var c in b)if(b.hasOwnProperty(c)){var d=0===c.indexOf("--"),e=ne(c,b[c],d);"float"===c&&(c="cssFloat");d?a.setProperty(c,e):a[c]=e}}var pe=n({menuitem:!0},{area:!0,base:!0,br:!0,col:!0,embed:!0,hr:!0,img:!0,input:!0,keygen:!0,link:!0,meta:!0,param:!0,source:!0,track:!0,wbr:!0});
function qe(a,b){b&&(pe[a]&&(null!=b.children||null!=b.dangerouslySetInnerHTML?x("137",a,""):void 0),null!=b.dangerouslySetInnerHTML&&(null!=b.children?x("60"):void 0,"object"===typeof b.dangerouslySetInnerHTML&&"__html"in b.dangerouslySetInnerHTML?void 0:x("61")),null!=b.style&&"object"!==typeof b.style?x("62",""):void 0)}
function re(a,b){if(-1===a.indexOf("-"))return"string"===typeof b.is;switch(a){case "annotation-xml":case "color-profile":case "font-face":case "font-face-src":case "font-face-uri":case "font-face-format":case "font-face-name":case "missing-glyph":return!1;default:return!0}}
function se(a,b){a=9===a.nodeType||11===a.nodeType?a:a.ownerDocument;var c=Id(a);b=sa[b];for(var d=0;d<b.length;d++){var e=b[d];if(!c.hasOwnProperty(e)||!c[e]){switch(e){case "scroll":Ed("scroll",a);break;case "focus":case "blur":Ed("focus",a);Ed("blur",a);c.blur=!0;c.focus=!0;break;case "cancel":case "close":Ob(e)&&Ed(e,a);break;case "invalid":case "submit":case "reset":break;default:-1===ab.indexOf(e)&&E(e,a)}c[e]=!0}}}function te(){}var ue=null,ve=null;
function we(a,b){switch(a){case "button":case "input":case "select":case "textarea":return!!b.autoFocus}return!1}function xe(a,b){return"textarea"===a||"option"===a||"noscript"===a||"string"===typeof b.children||"number"===typeof b.children||"object"===typeof b.dangerouslySetInnerHTML&&null!==b.dangerouslySetInnerHTML&&null!=b.dangerouslySetInnerHTML.__html}
var ye="function"===typeof setTimeout?setTimeout:void 0,ze="function"===typeof clearTimeout?clearTimeout:void 0,Ae=r.unstable_scheduleCallback,Be=r.unstable_cancelCallback;
function Ce(a,b,c,d,e){a[Ga]=e;"input"===c&&"radio"===e.type&&null!=e.name&&xc(a,e);re(c,d);d=re(c,e);for(var f=0;f<b.length;f+=2){var g=b[f],h=b[f+1];"style"===g?oe(a,h):"dangerouslySetInnerHTML"===g?je(a,h):"children"===g?ke(a,h):tc(a,g,h,d)}switch(c){case "input":yc(a,e);break;case "textarea":de(a,e);break;case "select":b=a._wrapperState.wasMultiple,a._wrapperState.wasMultiple=!!e.multiple,c=e.value,null!=c?ae(a,!!e.multiple,c,!1):b!==!!e.multiple&&(null!=e.defaultValue?ae(a,!!e.multiple,e.defaultValue,
!0):ae(a,!!e.multiple,e.multiple?[]:"",!1))}}function De(a){for(a=a.nextSibling;a&&1!==a.nodeType&&3!==a.nodeType;)a=a.nextSibling;return a}function Ee(a){for(a=a.firstChild;a&&1!==a.nodeType&&3!==a.nodeType;)a=a.nextSibling;return a}new Set;var Fe=[],Ge=-1;function F(a){0>Ge||(a.current=Fe[Ge],Fe[Ge]=null,Ge--)}function G(a,b){Ge++;Fe[Ge]=a.current;a.current=b}var He={},H={current:He},I={current:!1},Ie=He;
function Je(a,b){var c=a.type.contextTypes;if(!c)return He;var d=a.stateNode;if(d&&d.__reactInternalMemoizedUnmaskedChildContext===b)return d.__reactInternalMemoizedMaskedChildContext;var e={},f;for(f in c)e[f]=b[f];d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=b,a.__reactInternalMemoizedMaskedChildContext=e);return e}function J(a){a=a.childContextTypes;return null!==a&&void 0!==a}function Ke(a){F(I,a);F(H,a)}function Le(a){F(I,a);F(H,a)}
function Me(a,b,c){H.current!==He?x("168"):void 0;G(H,b,a);G(I,c,a)}function Ne(a,b,c){var d=a.stateNode;a=b.childContextTypes;if("function"!==typeof d.getChildContext)return c;d=d.getChildContext();for(var e in d)e in a?void 0:x("108",ic(b)||"Unknown",e);return n({},c,d)}function Oe(a){var b=a.stateNode;b=b&&b.__reactInternalMemoizedMergedChildContext||He;Ie=H.current;G(H,b,a);G(I,I.current,a);return!0}
function Pe(a,b,c){var d=a.stateNode;d?void 0:x("169");c?(b=Ne(a,b,Ie),d.__reactInternalMemoizedMergedChildContext=b,F(I,a),F(H,a),G(H,b,a)):F(I,a);G(I,c,a)}var Qe=null,Re=null;function Se(a){return function(b){try{return a(b)}catch(c){}}}
function Te(a){if("undefined"===typeof __REACT_DEVTOOLS_GLOBAL_HOOK__)return!1;var b=__REACT_DEVTOOLS_GLOBAL_HOOK__;if(b.isDisabled||!b.supportsFiber)return!0;try{var c=b.inject(a);Qe=Se(function(a){return b.onCommitFiberRoot(c,a)});Re=Se(function(a){return b.onCommitFiberUnmount(c,a)})}catch(d){}return!0}
function Ue(a,b,c,d){this.tag=a;this.key=c;this.sibling=this.child=this.return=this.stateNode=this.type=this.elementType=null;this.index=0;this.ref=null;this.pendingProps=b;this.contextDependencies=this.memoizedState=this.updateQueue=this.memoizedProps=null;this.mode=d;this.effectTag=0;this.lastEffect=this.firstEffect=this.nextEffect=null;this.childExpirationTime=this.expirationTime=0;this.alternate=null}function K(a,b,c,d){return new Ue(a,b,c,d)}
function Ve(a){a=a.prototype;return!(!a||!a.isReactComponent)}function We(a){if("function"===typeof a)return Ve(a)?1:0;if(void 0!==a&&null!==a){a=a.$$typeof;if(a===cc)return 11;if(a===ec)return 14}return 2}
function Xe(a,b){var c=a.alternate;null===c?(c=K(a.tag,b,a.key,a.mode),c.elementType=a.elementType,c.type=a.type,c.stateNode=a.stateNode,c.alternate=a,a.alternate=c):(c.pendingProps=b,c.effectTag=0,c.nextEffect=null,c.firstEffect=null,c.lastEffect=null);c.childExpirationTime=a.childExpirationTime;c.expirationTime=a.expirationTime;c.child=a.child;c.memoizedProps=a.memoizedProps;c.memoizedState=a.memoizedState;c.updateQueue=a.updateQueue;c.contextDependencies=a.contextDependencies;c.sibling=a.sibling;
c.index=a.index;c.ref=a.ref;return c}
function Ye(a,b,c,d,e,f){var g=2;d=a;if("function"===typeof a)Ve(a)&&(g=1);else if("string"===typeof a)g=5;else a:switch(a){case Xb:return Ze(c.children,e,f,b);case bc:return $e(c,e|3,f,b);case Yb:return $e(c,e|2,f,b);case Zb:return a=K(12,c,b,e|4),a.elementType=Zb,a.type=Zb,a.expirationTime=f,a;case dc:return a=K(13,c,b,e),a.elementType=dc,a.type=dc,a.expirationTime=f,a;default:if("object"===typeof a&&null!==a)switch(a.$$typeof){case $b:g=10;break a;case ac:g=9;break a;case cc:g=11;break a;case ec:g=
14;break a;case fc:g=16;d=null;break a}x("130",null==a?a:typeof a,"")}b=K(g,c,b,e);b.elementType=a;b.type=d;b.expirationTime=f;return b}function Ze(a,b,c,d){a=K(7,a,d,b);a.expirationTime=c;return a}function $e(a,b,c,d){a=K(8,a,d,b);b=0===(b&1)?Yb:bc;a.elementType=b;a.type=b;a.expirationTime=c;return a}function af(a,b,c){a=K(6,a,null,b);a.expirationTime=c;return a}
function bf(a,b,c){b=K(4,null!==a.children?a.children:[],a.key,b);b.expirationTime=c;b.stateNode={containerInfo:a.containerInfo,pendingChildren:null,implementation:a.implementation};return b}function cf(a,b){a.didError=!1;var c=a.earliestPendingTime;0===c?a.earliestPendingTime=a.latestPendingTime=b:c<b?a.earliestPendingTime=b:a.latestPendingTime>b&&(a.latestPendingTime=b);df(b,a)}
function ef(a,b){a.didError=!1;if(0===b)a.earliestPendingTime=0,a.latestPendingTime=0,a.earliestSuspendedTime=0,a.latestSuspendedTime=0,a.latestPingedTime=0;else{b<a.latestPingedTime&&(a.latestPingedTime=0);var c=a.latestPendingTime;0!==c&&(c>b?a.earliestPendingTime=a.latestPendingTime=0:a.earliestPendingTime>b&&(a.earliestPendingTime=a.latestPendingTime));c=a.earliestSuspendedTime;0===c?cf(a,b):b<a.latestSuspendedTime?(a.earliestSuspendedTime=0,a.latestSuspendedTime=0,a.latestPingedTime=0,cf(a,b)):
b>c&&cf(a,b)}df(0,a)}function ff(a,b){a.didError=!1;a.latestPingedTime>=b&&(a.latestPingedTime=0);var c=a.earliestPendingTime,d=a.latestPendingTime;c===b?a.earliestPendingTime=d===b?a.latestPendingTime=0:d:d===b&&(a.latestPendingTime=c);c=a.earliestSuspendedTime;d=a.latestSuspendedTime;0===c?a.earliestSuspendedTime=a.latestSuspendedTime=b:c<b?a.earliestSuspendedTime=b:d>b&&(a.latestSuspendedTime=b);df(b,a)}
function gf(a,b){var c=a.earliestPendingTime;a=a.earliestSuspendedTime;c>b&&(b=c);a>b&&(b=a);return b}function df(a,b){var c=b.earliestSuspendedTime,d=b.latestSuspendedTime,e=b.earliestPendingTime,f=b.latestPingedTime;e=0!==e?e:f;0===e&&(0===a||d<a)&&(e=d);a=e;0!==a&&c>a&&(a=c);b.nextExpirationTimeToWorkOn=e;b.expirationTime=a}function L(a,b){if(a&&a.defaultProps){b=n({},b);a=a.defaultProps;for(var c in a)void 0===b[c]&&(b[c]=a[c])}return b}
function hf(a){var b=a._result;switch(a._status){case 1:return b;case 2:throw b;case 0:throw b;default:a._status=0;b=a._ctor;b=b();b.then(function(b){0===a._status&&(b=b.default,a._status=1,a._result=b)},function(b){0===a._status&&(a._status=2,a._result=b)});switch(a._status){case 1:return a._result;case 2:throw a._result;}a._result=b;throw b;}}var jf=(new aa.Component).refs;
function kf(a,b,c,d){b=a.memoizedState;c=c(d,b);c=null===c||void 0===c?b:n({},b,c);a.memoizedState=c;d=a.updateQueue;null!==d&&0===a.expirationTime&&(d.baseState=c)}
var tf={isMounted:function(a){return(a=a._reactInternalFiber)?2===ed(a):!1},enqueueSetState:function(a,b,c){a=a._reactInternalFiber;var d=lf();d=mf(d,a);var e=nf(d);e.payload=b;void 0!==c&&null!==c&&(e.callback=c);of();pf(a,e);qf(a,d)},enqueueReplaceState:function(a,b,c){a=a._reactInternalFiber;var d=lf();d=mf(d,a);var e=nf(d);e.tag=rf;e.payload=b;void 0!==c&&null!==c&&(e.callback=c);of();pf(a,e);qf(a,d)},enqueueForceUpdate:function(a,b){a=a._reactInternalFiber;var c=lf();c=mf(c,a);var d=nf(c);d.tag=
sf;void 0!==b&&null!==b&&(d.callback=b);of();pf(a,d);qf(a,c)}};function uf(a,b,c,d,e,f,g){a=a.stateNode;return"function"===typeof a.shouldComponentUpdate?a.shouldComponentUpdate(d,f,g):b.prototype&&b.prototype.isPureReactComponent?!dd(c,d)||!dd(e,f):!0}
function vf(a,b,c){var d=!1,e=He;var f=b.contextType;"object"===typeof f&&null!==f?f=M(f):(e=J(b)?Ie:H.current,d=b.contextTypes,f=(d=null!==d&&void 0!==d)?Je(a,e):He);b=new b(c,f);a.memoizedState=null!==b.state&&void 0!==b.state?b.state:null;b.updater=tf;a.stateNode=b;b._reactInternalFiber=a;d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=e,a.__reactInternalMemoizedMaskedChildContext=f);return b}
function wf(a,b,c,d){a=b.state;"function"===typeof b.componentWillReceiveProps&&b.componentWillReceiveProps(c,d);"function"===typeof b.UNSAFE_componentWillReceiveProps&&b.UNSAFE_componentWillReceiveProps(c,d);b.state!==a&&tf.enqueueReplaceState(b,b.state,null)}
function xf(a,b,c,d){var e=a.stateNode;e.props=c;e.state=a.memoizedState;e.refs=jf;var f=b.contextType;"object"===typeof f&&null!==f?e.context=M(f):(f=J(b)?Ie:H.current,e.context=Je(a,f));f=a.updateQueue;null!==f&&(yf(a,f,c,e,d),e.state=a.memoizedState);f=b.getDerivedStateFromProps;"function"===typeof f&&(kf(a,b,f,c),e.state=a.memoizedState);"function"===typeof b.getDerivedStateFromProps||"function"===typeof e.getSnapshotBeforeUpdate||"function"!==typeof e.UNSAFE_componentWillMount&&"function"!==
typeof e.componentWillMount||(b=e.state,"function"===typeof e.componentWillMount&&e.componentWillMount(),"function"===typeof e.UNSAFE_componentWillMount&&e.UNSAFE_componentWillMount(),b!==e.state&&tf.enqueueReplaceState(e,e.state,null),f=a.updateQueue,null!==f&&(yf(a,f,c,e,d),e.state=a.memoizedState));"function"===typeof e.componentDidMount&&(a.effectTag|=4)}var zf=Array.isArray;
function Af(a,b,c){a=c.ref;if(null!==a&&"function"!==typeof a&&"object"!==typeof a){if(c._owner){c=c._owner;var d=void 0;c&&(1!==c.tag?x("309"):void 0,d=c.stateNode);d?void 0:x("147",a);var e=""+a;if(null!==b&&null!==b.ref&&"function"===typeof b.ref&&b.ref._stringRef===e)return b.ref;b=function(a){var b=d.refs;b===jf&&(b=d.refs={});null===a?delete b[e]:b[e]=a};b._stringRef=e;return b}"string"!==typeof a?x("284"):void 0;c._owner?void 0:x("290",a)}return a}
function Bf(a,b){"textarea"!==a.type&&x("31","[object Object]"===Object.prototype.toString.call(b)?"object with keys {"+Object.keys(b).join(", ")+"}":b,"")}
function Cf(a){function b(b,c){if(a){var d=b.lastEffect;null!==d?(d.nextEffect=c,b.lastEffect=c):b.firstEffect=b.lastEffect=c;c.nextEffect=null;c.effectTag=8}}function c(c,d){if(!a)return null;for(;null!==d;)b(c,d),d=d.sibling;return null}function d(a,b){for(a=new Map;null!==b;)null!==b.key?a.set(b.key,b):a.set(b.index,b),b=b.sibling;return a}function e(a,b,c){a=Xe(a,b,c);a.index=0;a.sibling=null;return a}function f(b,c,d){b.index=d;if(!a)return c;d=b.alternate;if(null!==d)return d=d.index,d<c?(b.effectTag=
2,c):d;b.effectTag=2;return c}function g(b){a&&null===b.alternate&&(b.effectTag=2);return b}function h(a,b,c,d){if(null===b||6!==b.tag)return b=af(c,a.mode,d),b.return=a,b;b=e(b,c,d);b.return=a;return b}function l(a,b,c,d){if(null!==b&&b.elementType===c.type)return d=e(b,c.props,d),d.ref=Af(a,b,c),d.return=a,d;d=Ye(c.type,c.key,c.props,null,a.mode,d);d.ref=Af(a,b,c);d.return=a;return d}function k(a,b,c,d){if(null===b||4!==b.tag||b.stateNode.containerInfo!==c.containerInfo||b.stateNode.implementation!==
c.implementation)return b=bf(c,a.mode,d),b.return=a,b;b=e(b,c.children||[],d);b.return=a;return b}function m(a,b,c,d,f){if(null===b||7!==b.tag)return b=Ze(c,a.mode,d,f),b.return=a,b;b=e(b,c,d);b.return=a;return b}function p(a,b,c){if("string"===typeof b||"number"===typeof b)return b=af(""+b,a.mode,c),b.return=a,b;if("object"===typeof b&&null!==b){switch(b.$$typeof){case Vb:return c=Ye(b.type,b.key,b.props,null,a.mode,c),c.ref=Af(a,null,b),c.return=a,c;case Wb:return b=bf(b,a.mode,c),b.return=a,b}if(zf(b)||
hc(b))return b=Ze(b,a.mode,c,null),b.return=a,b;Bf(a,b)}return null}function t(a,b,c,d){var e=null!==b?b.key:null;if("string"===typeof c||"number"===typeof c)return null!==e?null:h(a,b,""+c,d);if("object"===typeof c&&null!==c){switch(c.$$typeof){case Vb:return c.key===e?c.type===Xb?m(a,b,c.props.children,d,e):l(a,b,c,d):null;case Wb:return c.key===e?k(a,b,c,d):null}if(zf(c)||hc(c))return null!==e?null:m(a,b,c,d,null);Bf(a,c)}return null}function A(a,b,c,d,e){if("string"===typeof d||"number"===typeof d)return a=
a.get(c)||null,h(b,a,""+d,e);if("object"===typeof d&&null!==d){switch(d.$$typeof){case Vb:return a=a.get(null===d.key?c:d.key)||null,d.type===Xb?m(b,a,d.props.children,e,d.key):l(b,a,d,e);case Wb:return a=a.get(null===d.key?c:d.key)||null,k(b,a,d,e)}if(zf(d)||hc(d))return a=a.get(c)||null,m(b,a,d,e,null);Bf(b,d)}return null}function v(e,g,h,k){for(var l=null,m=null,q=g,u=g=0,B=null;null!==q&&u<h.length;u++){q.index>u?(B=q,q=null):B=q.sibling;var w=t(e,q,h[u],k);if(null===w){null===q&&(q=B);break}a&&
q&&null===w.alternate&&b(e,q);g=f(w,g,u);null===m?l=w:m.sibling=w;m=w;q=B}if(u===h.length)return c(e,q),l;if(null===q){for(;u<h.length;u++)if(q=p(e,h[u],k))g=f(q,g,u),null===m?l=q:m.sibling=q,m=q;return l}for(q=d(e,q);u<h.length;u++)if(B=A(q,e,u,h[u],k))a&&null!==B.alternate&&q.delete(null===B.key?u:B.key),g=f(B,g,u),null===m?l=B:m.sibling=B,m=B;a&&q.forEach(function(a){return b(e,a)});return l}function R(e,g,h,k){var l=hc(h);"function"!==typeof l?x("150"):void 0;h=l.call(h);null==h?x("151"):void 0;
for(var m=l=null,q=g,u=g=0,B=null,w=h.next();null!==q&&!w.done;u++,w=h.next()){q.index>u?(B=q,q=null):B=q.sibling;var v=t(e,q,w.value,k);if(null===v){q||(q=B);break}a&&q&&null===v.alternate&&b(e,q);g=f(v,g,u);null===m?l=v:m.sibling=v;m=v;q=B}if(w.done)return c(e,q),l;if(null===q){for(;!w.done;u++,w=h.next())w=p(e,w.value,k),null!==w&&(g=f(w,g,u),null===m?l=w:m.sibling=w,m=w);return l}for(q=d(e,q);!w.done;u++,w=h.next())w=A(q,e,u,w.value,k),null!==w&&(a&&null!==w.alternate&&q.delete(null===w.key?u:
w.key),g=f(w,g,u),null===m?l=w:m.sibling=w,m=w);a&&q.forEach(function(a){return b(e,a)});return l}return function(a,d,f,h){var k="object"===typeof f&&null!==f&&f.type===Xb&&null===f.key;k&&(f=f.props.children);var l="object"===typeof f&&null!==f;if(l)switch(f.$$typeof){case Vb:a:{l=f.key;for(k=d;null!==k;){if(k.key===l)if(7===k.tag?f.type===Xb:k.elementType===f.type){c(a,k.sibling);d=e(k,f.type===Xb?f.props.children:f.props,h);d.ref=Af(a,k,f);d.return=a;a=d;break a}else{c(a,k);break}else b(a,k);k=
k.sibling}f.type===Xb?(d=Ze(f.props.children,a.mode,h,f.key),d.return=a,a=d):(h=Ye(f.type,f.key,f.props,null,a.mode,h),h.ref=Af(a,d,f),h.return=a,a=h)}return g(a);case Wb:a:{for(k=f.key;null!==d;){if(d.key===k)if(4===d.tag&&d.stateNode.containerInfo===f.containerInfo&&d.stateNode.implementation===f.implementation){c(a,d.sibling);d=e(d,f.children||[],h);d.return=a;a=d;break a}else{c(a,d);break}else b(a,d);d=d.sibling}d=bf(f,a.mode,h);d.return=a;a=d}return g(a)}if("string"===typeof f||"number"===typeof f)return f=
""+f,null!==d&&6===d.tag?(c(a,d.sibling),d=e(d,f,h),d.return=a,a=d):(c(a,d),d=af(f,a.mode,h),d.return=a,a=d),g(a);if(zf(f))return v(a,d,f,h);if(hc(f))return R(a,d,f,h);l&&Bf(a,f);if("undefined"===typeof f&&!k)switch(a.tag){case 1:case 0:h=a.type,x("152",h.displayName||h.name||"Component")}return c(a,d)}}var Df=Cf(!0),Ef=Cf(!1),Ff={},N={current:Ff},Gf={current:Ff},Hf={current:Ff};function If(a){a===Ff?x("174"):void 0;return a}
function Jf(a,b){G(Hf,b,a);G(Gf,a,a);G(N,Ff,a);var c=b.nodeType;switch(c){case 9:case 11:b=(b=b.documentElement)?b.namespaceURI:he(null,"");break;default:c=8===c?b.parentNode:b,b=c.namespaceURI||null,c=c.tagName,b=he(b,c)}F(N,a);G(N,b,a)}function Kf(a){F(N,a);F(Gf,a);F(Hf,a)}function Lf(a){If(Hf.current);var b=If(N.current);var c=he(b,a.type);b!==c&&(G(Gf,a,a),G(N,c,a))}function Mf(a){Gf.current===a&&(F(N,a),F(Gf,a))}
var Nf=0,Of=2,Pf=4,Qf=8,Rf=16,Sf=32,Tf=64,Uf=128,Vf=Tb.ReactCurrentDispatcher,Wf=0,Xf=null,O=null,P=null,Yf=null,Q=null,Zf=null,$f=0,ag=null,bg=0,cg=!1,dg=null,eg=0;function fg(){x("321")}function gg(a,b){if(null===b)return!1;for(var c=0;c<b.length&&c<a.length;c++)if(!bd(a[c],b[c]))return!1;return!0}
function hg(a,b,c,d,e,f){Wf=f;Xf=b;P=null!==a?a.memoizedState:null;Vf.current=null===P?ig:jg;b=c(d,e);if(cg){do cg=!1,eg+=1,P=null!==a?a.memoizedState:null,Zf=Yf,ag=Q=O=null,Vf.current=jg,b=c(d,e);while(cg);dg=null;eg=0}Vf.current=kg;a=Xf;a.memoizedState=Yf;a.expirationTime=$f;a.updateQueue=ag;a.effectTag|=bg;a=null!==O&&null!==O.next;Wf=0;Zf=Q=Yf=P=O=Xf=null;$f=0;ag=null;bg=0;a?x("300"):void 0;return b}function lg(){Vf.current=kg;Wf=0;Zf=Q=Yf=P=O=Xf=null;$f=0;ag=null;bg=0;cg=!1;dg=null;eg=0}
function mg(){var a={memoizedState:null,baseState:null,queue:null,baseUpdate:null,next:null};null===Q?Yf=Q=a:Q=Q.next=a;return Q}function ng(){if(null!==Zf)Q=Zf,Zf=Q.next,O=P,P=null!==O?O.next:null;else{null===P?x("310"):void 0;O=P;var a={memoizedState:O.memoizedState,baseState:O.baseState,queue:O.queue,baseUpdate:O.baseUpdate,next:null};Q=null===Q?Yf=a:Q.next=a;P=O.next}return Q}function og(a,b){return"function"===typeof b?b(a):b}
function pg(a){var b=ng(),c=b.queue;null===c?x("311"):void 0;c.lastRenderedReducer=a;if(0<eg){var d=c.dispatch;if(null!==dg){var e=dg.get(c);if(void 0!==e){dg.delete(c);var f=b.memoizedState;do f=a(f,e.action),e=e.next;while(null!==e);bd(f,b.memoizedState)||(qg=!0);b.memoizedState=f;b.baseUpdate===c.last&&(b.baseState=f);c.lastRenderedState=f;return[f,d]}}return[b.memoizedState,d]}d=c.last;var g=b.baseUpdate;f=b.baseState;null!==g?(null!==d&&(d.next=null),d=g.next):d=null!==d?d.next:null;if(null!==
d){var h=e=null,l=d,k=!1;do{var m=l.expirationTime;m<Wf?(k||(k=!0,h=g,e=f),m>$f&&($f=m)):f=l.eagerReducer===a?l.eagerState:a(f,l.action);g=l;l=l.next}while(null!==l&&l!==d);k||(h=g,e=f);bd(f,b.memoizedState)||(qg=!0);b.memoizedState=f;b.baseUpdate=h;b.baseState=e;c.lastRenderedState=f}return[b.memoizedState,c.dispatch]}
function rg(a,b,c,d){a={tag:a,create:b,destroy:c,deps:d,next:null};null===ag?(ag={lastEffect:null},ag.lastEffect=a.next=a):(b=ag.lastEffect,null===b?ag.lastEffect=a.next=a:(c=b.next,b.next=a,a.next=c,ag.lastEffect=a));return a}function sg(a,b,c,d){var e=mg();bg|=a;e.memoizedState=rg(b,c,void 0,void 0===d?null:d)}
function tg(a,b,c,d){var e=ng();d=void 0===d?null:d;var f=void 0;if(null!==O){var g=O.memoizedState;f=g.destroy;if(null!==d&&gg(d,g.deps)){rg(Nf,c,f,d);return}}bg|=a;e.memoizedState=rg(b,c,f,d)}function ug(a,b){if("function"===typeof b)return a=a(),b(a),function(){b(null)};if(null!==b&&void 0!==b)return a=a(),b.current=a,function(){b.current=null}}function vg(){}
function wg(a,b,c){25>eg?void 0:x("301");var d=a.alternate;if(a===Xf||null!==d&&d===Xf)if(cg=!0,a={expirationTime:Wf,action:c,eagerReducer:null,eagerState:null,next:null},null===dg&&(dg=new Map),c=dg.get(b),void 0===c)dg.set(b,a);else{for(b=c;null!==b.next;)b=b.next;b.next=a}else{of();var e=lf();e=mf(e,a);var f={expirationTime:e,action:c,eagerReducer:null,eagerState:null,next:null},g=b.last;if(null===g)f.next=f;else{var h=g.next;null!==h&&(f.next=h);g.next=f}b.last=f;if(0===a.expirationTime&&(null===
d||0===d.expirationTime)&&(d=b.lastRenderedReducer,null!==d))try{var l=b.lastRenderedState,k=d(l,c);f.eagerReducer=d;f.eagerState=k;if(bd(k,l))return}catch(m){}finally{}qf(a,e)}}
var kg={readContext:M,useCallback:fg,useContext:fg,useEffect:fg,useImperativeHandle:fg,useLayoutEffect:fg,useMemo:fg,useReducer:fg,useRef:fg,useState:fg,useDebugValue:fg},ig={readContext:M,useCallback:function(a,b){mg().memoizedState=[a,void 0===b?null:b];return a},useContext:M,useEffect:function(a,b){return sg(516,Uf|Tf,a,b)},useImperativeHandle:function(a,b,c){c=null!==c&&void 0!==c?c.concat([a]):null;return sg(4,Pf|Sf,ug.bind(null,b,a),c)},useLayoutEffect:function(a,b){return sg(4,Pf|Sf,a,b)},
useMemo:function(a,b){var c=mg();b=void 0===b?null:b;a=a();c.memoizedState=[a,b];return a},useReducer:function(a,b,c){var d=mg();b=void 0!==c?c(b):b;d.memoizedState=d.baseState=b;a=d.queue={last:null,dispatch:null,lastRenderedReducer:a,lastRenderedState:b};a=a.dispatch=wg.bind(null,Xf,a);return[d.memoizedState,a]},useRef:function(a){var b=mg();a={current:a};return b.memoizedState=a},useState:function(a){var b=mg();"function"===typeof a&&(a=a());b.memoizedState=b.baseState=a;a=b.queue={last:null,dispatch:null,
lastRenderedReducer:og,lastRenderedState:a};a=a.dispatch=wg.bind(null,Xf,a);return[b.memoizedState,a]},useDebugValue:vg},jg={readContext:M,useCallback:function(a,b){var c=ng();b=void 0===b?null:b;var d=c.memoizedState;if(null!==d&&null!==b&&gg(b,d[1]))return d[0];c.memoizedState=[a,b];return a},useContext:M,useEffect:function(a,b){return tg(516,Uf|Tf,a,b)},useImperativeHandle:function(a,b,c){c=null!==c&&void 0!==c?c.concat([a]):null;return tg(4,Pf|Sf,ug.bind(null,b,a),c)},useLayoutEffect:function(a,
b){return tg(4,Pf|Sf,a,b)},useMemo:function(a,b){var c=ng();b=void 0===b?null:b;var d=c.memoizedState;if(null!==d&&null!==b&&gg(b,d[1]))return d[0];a=a();c.memoizedState=[a,b];return a},useReducer:pg,useRef:function(){return ng().memoizedState},useState:function(a){return pg(og,a)},useDebugValue:vg},xg=null,yg=null,zg=!1;
function Ag(a,b){var c=K(5,null,null,0);c.elementType="DELETED";c.type="DELETED";c.stateNode=b;c.return=a;c.effectTag=8;null!==a.lastEffect?(a.lastEffect.nextEffect=c,a.lastEffect=c):a.firstEffect=a.lastEffect=c}function Bg(a,b){switch(a.tag){case 5:var c=a.type;b=1!==b.nodeType||c.toLowerCase()!==b.nodeName.toLowerCase()?null:b;return null!==b?(a.stateNode=b,!0):!1;case 6:return b=""===a.pendingProps||3!==b.nodeType?null:b,null!==b?(a.stateNode=b,!0):!1;case 13:return!1;default:return!1}}
function Cg(a){if(zg){var b=yg;if(b){var c=b;if(!Bg(a,b)){b=De(c);if(!b||!Bg(a,b)){a.effectTag|=2;zg=!1;xg=a;return}Ag(xg,c)}xg=a;yg=Ee(b)}else a.effectTag|=2,zg=!1,xg=a}}function Dg(a){for(a=a.return;null!==a&&5!==a.tag&&3!==a.tag&&18!==a.tag;)a=a.return;xg=a}function Eg(a){if(a!==xg)return!1;if(!zg)return Dg(a),zg=!0,!1;var b=a.type;if(5!==a.tag||"head"!==b&&"body"!==b&&!xe(b,a.memoizedProps))for(b=yg;b;)Ag(a,b),b=De(b);Dg(a);yg=xg?De(a.stateNode):null;return!0}function Fg(){yg=xg=null;zg=!1}
var Gg=Tb.ReactCurrentOwner,qg=!1;function S(a,b,c,d){b.child=null===a?Ef(b,null,c,d):Df(b,a.child,c,d)}function Hg(a,b,c,d,e){c=c.render;var f=b.ref;Ig(b,e);d=hg(a,b,c,d,f,e);if(null!==a&&!qg)return b.updateQueue=a.updateQueue,b.effectTag&=-517,a.expirationTime<=e&&(a.expirationTime=0),Jg(a,b,e);b.effectTag|=1;S(a,b,d,e);return b.child}
function Kg(a,b,c,d,e,f){if(null===a){var g=c.type;if("function"===typeof g&&!Ve(g)&&void 0===g.defaultProps&&null===c.compare&&void 0===c.defaultProps)return b.tag=15,b.type=g,Lg(a,b,g,d,e,f);a=Ye(c.type,null,d,null,b.mode,f);a.ref=b.ref;a.return=b;return b.child=a}g=a.child;if(e<f&&(e=g.memoizedProps,c=c.compare,c=null!==c?c:dd,c(e,d)&&a.ref===b.ref))return Jg(a,b,f);b.effectTag|=1;a=Xe(g,d,f);a.ref=b.ref;a.return=b;return b.child=a}
function Lg(a,b,c,d,e,f){return null!==a&&dd(a.memoizedProps,d)&&a.ref===b.ref&&(qg=!1,e<f)?Jg(a,b,f):Mg(a,b,c,d,f)}function Ng(a,b){var c=b.ref;if(null===a&&null!==c||null!==a&&a.ref!==c)b.effectTag|=128}function Mg(a,b,c,d,e){var f=J(c)?Ie:H.current;f=Je(b,f);Ig(b,e);c=hg(a,b,c,d,f,e);if(null!==a&&!qg)return b.updateQueue=a.updateQueue,b.effectTag&=-517,a.expirationTime<=e&&(a.expirationTime=0),Jg(a,b,e);b.effectTag|=1;S(a,b,c,e);return b.child}
function Og(a,b,c,d,e){if(J(c)){var f=!0;Oe(b)}else f=!1;Ig(b,e);if(null===b.stateNode)null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2),vf(b,c,d,e),xf(b,c,d,e),d=!0;else if(null===a){var g=b.stateNode,h=b.memoizedProps;g.props=h;var l=g.context,k=c.contextType;"object"===typeof k&&null!==k?k=M(k):(k=J(c)?Ie:H.current,k=Je(b,k));var m=c.getDerivedStateFromProps,p="function"===typeof m||"function"===typeof g.getSnapshotBeforeUpdate;p||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&
"function"!==typeof g.componentWillReceiveProps||(h!==d||l!==k)&&wf(b,g,d,k);Pg=!1;var t=b.memoizedState;l=g.state=t;var A=b.updateQueue;null!==A&&(yf(b,A,d,g,e),l=b.memoizedState);h!==d||t!==l||I.current||Pg?("function"===typeof m&&(kf(b,c,m,d),l=b.memoizedState),(h=Pg||uf(b,c,h,d,t,l,k))?(p||"function"!==typeof g.UNSAFE_componentWillMount&&"function"!==typeof g.componentWillMount||("function"===typeof g.componentWillMount&&g.componentWillMount(),"function"===typeof g.UNSAFE_componentWillMount&&
g.UNSAFE_componentWillMount()),"function"===typeof g.componentDidMount&&(b.effectTag|=4)):("function"===typeof g.componentDidMount&&(b.effectTag|=4),b.memoizedProps=d,b.memoizedState=l),g.props=d,g.state=l,g.context=k,d=h):("function"===typeof g.componentDidMount&&(b.effectTag|=4),d=!1)}else g=b.stateNode,h=b.memoizedProps,g.props=b.type===b.elementType?h:L(b.type,h),l=g.context,k=c.contextType,"object"===typeof k&&null!==k?k=M(k):(k=J(c)?Ie:H.current,k=Je(b,k)),m=c.getDerivedStateFromProps,(p="function"===
typeof m||"function"===typeof g.getSnapshotBeforeUpdate)||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&"function"!==typeof g.componentWillReceiveProps||(h!==d||l!==k)&&wf(b,g,d,k),Pg=!1,l=b.memoizedState,t=g.state=l,A=b.updateQueue,null!==A&&(yf(b,A,d,g,e),t=b.memoizedState),h!==d||l!==t||I.current||Pg?("function"===typeof m&&(kf(b,c,m,d),t=b.memoizedState),(m=Pg||uf(b,c,h,d,l,t,k))?(p||"function"!==typeof g.UNSAFE_componentWillUpdate&&"function"!==typeof g.componentWillUpdate||("function"===
typeof g.componentWillUpdate&&g.componentWillUpdate(d,t,k),"function"===typeof g.UNSAFE_componentWillUpdate&&g.UNSAFE_componentWillUpdate(d,t,k)),"function"===typeof g.componentDidUpdate&&(b.effectTag|=4),"function"===typeof g.getSnapshotBeforeUpdate&&(b.effectTag|=256)):("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&l===a.memoizedState||(b.effectTag|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&l===a.memoizedState||(b.effectTag|=256),b.memoizedProps=d,b.memoizedState=
t),g.props=d,g.state=t,g.context=k,d=m):("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&l===a.memoizedState||(b.effectTag|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&l===a.memoizedState||(b.effectTag|=256),d=!1);return Qg(a,b,c,d,f,e)}
function Qg(a,b,c,d,e,f){Ng(a,b);var g=0!==(b.effectTag&64);if(!d&&!g)return e&&Pe(b,c,!1),Jg(a,b,f);d=b.stateNode;Gg.current=b;var h=g&&"function"!==typeof c.getDerivedStateFromError?null:d.render();b.effectTag|=1;null!==a&&g?(b.child=Df(b,a.child,null,f),b.child=Df(b,null,h,f)):S(a,b,h,f);b.memoizedState=d.state;e&&Pe(b,c,!0);return b.child}function Rg(a){var b=a.stateNode;b.pendingContext?Me(a,b.pendingContext,b.pendingContext!==b.context):b.context&&Me(a,b.context,!1);Jf(a,b.containerInfo)}
function Sg(a,b,c){var d=b.mode,e=b.pendingProps,f=b.memoizedState;if(0===(b.effectTag&64)){f=null;var g=!1}else f={timedOutAt:null!==f?f.timedOutAt:0},g=!0,b.effectTag&=-65;if(null===a)if(g){var h=e.fallback;a=Ze(null,d,0,null);0===(b.mode&1)&&(a.child=null!==b.memoizedState?b.child.child:b.child);d=Ze(h,d,c,null);a.sibling=d;c=a;c.return=d.return=b}else c=d=Ef(b,null,e.children,c);else null!==a.memoizedState?(d=a.child,h=d.sibling,g?(c=e.fallback,e=Xe(d,d.pendingProps,0),0===(b.mode&1)&&(g=null!==
b.memoizedState?b.child.child:b.child,g!==d.child&&(e.child=g)),d=e.sibling=Xe(h,c,h.expirationTime),c=e,e.childExpirationTime=0,c.return=d.return=b):c=d=Df(b,d.child,e.children,c)):(h=a.child,g?(g=e.fallback,e=Ze(null,d,0,null),e.child=h,0===(b.mode&1)&&(e.child=null!==b.memoizedState?b.child.child:b.child),d=e.sibling=Ze(g,d,c,null),d.effectTag|=2,c=e,e.childExpirationTime=0,c.return=d.return=b):d=c=Df(b,h,e.children,c)),b.stateNode=a.stateNode;b.memoizedState=f;b.child=c;return d}
function Jg(a,b,c){null!==a&&(b.contextDependencies=a.contextDependencies);if(b.childExpirationTime<c)return null;null!==a&&b.child!==a.child?x("153"):void 0;if(null!==b.child){a=b.child;c=Xe(a,a.pendingProps,a.expirationTime);b.child=c;for(c.return=b;null!==a.sibling;)a=a.sibling,c=c.sibling=Xe(a,a.pendingProps,a.expirationTime),c.return=b;c.sibling=null}return b.child}
function Tg(a,b,c){var d=b.expirationTime;if(null!==a)if(a.memoizedProps!==b.pendingProps||I.current)qg=!0;else{if(d<c){qg=!1;switch(b.tag){case 3:Rg(b);Fg();break;case 5:Lf(b);break;case 1:J(b.type)&&Oe(b);break;case 4:Jf(b,b.stateNode.containerInfo);break;case 10:Ug(b,b.memoizedProps.value);break;case 13:if(null!==b.memoizedState){d=b.child.childExpirationTime;if(0!==d&&d>=c)return Sg(a,b,c);b=Jg(a,b,c);return null!==b?b.sibling:null}}return Jg(a,b,c)}}else qg=!1;b.expirationTime=0;switch(b.tag){case 2:d=
b.elementType;null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2);a=b.pendingProps;var e=Je(b,H.current);Ig(b,c);e=hg(null,b,d,a,e,c);b.effectTag|=1;if("object"===typeof e&&null!==e&&"function"===typeof e.render&&void 0===e.$$typeof){b.tag=1;lg();if(J(d)){var f=!0;Oe(b)}else f=!1;b.memoizedState=null!==e.state&&void 0!==e.state?e.state:null;var g=d.getDerivedStateFromProps;"function"===typeof g&&kf(b,d,g,a);e.updater=tf;b.stateNode=e;e._reactInternalFiber=b;xf(b,d,a,c);b=Qg(null,b,d,!0,f,
c)}else b.tag=0,S(null,b,e,c),b=b.child;return b;case 16:e=b.elementType;null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2);f=b.pendingProps;a=hf(e);b.type=a;e=b.tag=We(a);f=L(a,f);g=void 0;switch(e){case 0:g=Mg(null,b,a,f,c);break;case 1:g=Og(null,b,a,f,c);break;case 11:g=Hg(null,b,a,f,c);break;case 14:g=Kg(null,b,a,L(a.type,f),d,c);break;default:x("306",a,"")}return g;case 0:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:L(d,e),Mg(a,b,d,e,c);case 1:return d=b.type,e=b.pendingProps,
e=b.elementType===d?e:L(d,e),Og(a,b,d,e,c);case 3:Rg(b);d=b.updateQueue;null===d?x("282"):void 0;e=b.memoizedState;e=null!==e?e.element:null;yf(b,d,b.pendingProps,null,c);d=b.memoizedState.element;if(d===e)Fg(),b=Jg(a,b,c);else{e=b.stateNode;if(e=(null===a||null===a.child)&&e.hydrate)yg=Ee(b.stateNode.containerInfo),xg=b,e=zg=!0;e?(b.effectTag|=2,b.child=Ef(b,null,d,c)):(S(a,b,d,c),Fg());b=b.child}return b;case 5:return Lf(b),null===a&&Cg(b),d=b.type,e=b.pendingProps,f=null!==a?a.memoizedProps:null,
g=e.children,xe(d,e)?g=null:null!==f&&xe(d,f)&&(b.effectTag|=16),Ng(a,b),1!==c&&b.mode&1&&e.hidden?(b.expirationTime=b.childExpirationTime=1,b=null):(S(a,b,g,c),b=b.child),b;case 6:return null===a&&Cg(b),null;case 13:return Sg(a,b,c);case 4:return Jf(b,b.stateNode.containerInfo),d=b.pendingProps,null===a?b.child=Df(b,null,d,c):S(a,b,d,c),b.child;case 11:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:L(d,e),Hg(a,b,d,e,c);case 7:return S(a,b,b.pendingProps,c),b.child;case 8:return S(a,b,b.pendingProps.children,
c),b.child;case 12:return S(a,b,b.pendingProps.children,c),b.child;case 10:a:{d=b.type._context;e=b.pendingProps;g=b.memoizedProps;f=e.value;Ug(b,f);if(null!==g){var h=g.value;f=bd(h,f)?0:("function"===typeof d._calculateChangedBits?d._calculateChangedBits(h,f):1073741823)|0;if(0===f){if(g.children===e.children&&!I.current){b=Jg(a,b,c);break a}}else for(h=b.child,null!==h&&(h.return=b);null!==h;){var l=h.contextDependencies;if(null!==l){g=h.child;for(var k=l.first;null!==k;){if(k.context===d&&0!==
(k.observedBits&f)){1===h.tag&&(k=nf(c),k.tag=sf,pf(h,k));h.expirationTime<c&&(h.expirationTime=c);k=h.alternate;null!==k&&k.expirationTime<c&&(k.expirationTime=c);k=c;for(var m=h.return;null!==m;){var p=m.alternate;if(m.childExpirationTime<k)m.childExpirationTime=k,null!==p&&p.childExpirationTime<k&&(p.childExpirationTime=k);else if(null!==p&&p.childExpirationTime<k)p.childExpirationTime=k;else break;m=m.return}l.expirationTime<c&&(l.expirationTime=c);break}k=k.next}}else g=10===h.tag?h.type===b.type?
null:h.child:h.child;if(null!==g)g.return=h;else for(g=h;null!==g;){if(g===b){g=null;break}h=g.sibling;if(null!==h){h.return=g.return;g=h;break}g=g.return}h=g}}S(a,b,e.children,c);b=b.child}return b;case 9:return e=b.type,f=b.pendingProps,d=f.children,Ig(b,c),e=M(e,f.unstable_observedBits),d=d(e),b.effectTag|=1,S(a,b,d,c),b.child;case 14:return e=b.type,f=L(e,b.pendingProps),f=L(e.type,f),Kg(a,b,e,f,d,c);case 15:return Lg(a,b,b.type,b.pendingProps,d,c);case 17:return d=b.type,e=b.pendingProps,e=b.elementType===
d?e:L(d,e),null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2),b.tag=1,J(d)?(a=!0,Oe(b)):a=!1,Ig(b,c),vf(b,d,e,c),xf(b,d,e,c),Qg(null,b,d,!0,a,c)}x("156")}var Vg={current:null},Wg=null,Xg=null,Yg=null;function Ug(a,b){var c=a.type._context;G(Vg,c._currentValue,a);c._currentValue=b}function Zg(a){var b=Vg.current;F(Vg,a);a.type._context._currentValue=b}function Ig(a,b){Wg=a;Yg=Xg=null;var c=a.contextDependencies;null!==c&&c.expirationTime>=b&&(qg=!0);a.contextDependencies=null}
function M(a,b){if(Yg!==a&&!1!==b&&0!==b){if("number"!==typeof b||1073741823===b)Yg=a,b=1073741823;b={context:a,observedBits:b,next:null};null===Xg?(null===Wg?x("308"):void 0,Xg=b,Wg.contextDependencies={first:b,expirationTime:0}):Xg=Xg.next=b}return a._currentValue}var $g=0,rf=1,sf=2,ah=3,Pg=!1;function bh(a){return{baseState:a,firstUpdate:null,lastUpdate:null,firstCapturedUpdate:null,lastCapturedUpdate:null,firstEffect:null,lastEffect:null,firstCapturedEffect:null,lastCapturedEffect:null}}
function ch(a){return{baseState:a.baseState,firstUpdate:a.firstUpdate,lastUpdate:a.lastUpdate,firstCapturedUpdate:null,lastCapturedUpdate:null,firstEffect:null,lastEffect:null,firstCapturedEffect:null,lastCapturedEffect:null}}function nf(a){return{expirationTime:a,tag:$g,payload:null,callback:null,next:null,nextEffect:null}}function dh(a,b){null===a.lastUpdate?a.firstUpdate=a.lastUpdate=b:(a.lastUpdate.next=b,a.lastUpdate=b)}
function pf(a,b){var c=a.alternate;if(null===c){var d=a.updateQueue;var e=null;null===d&&(d=a.updateQueue=bh(a.memoizedState))}else d=a.updateQueue,e=c.updateQueue,null===d?null===e?(d=a.updateQueue=bh(a.memoizedState),e=c.updateQueue=bh(c.memoizedState)):d=a.updateQueue=ch(e):null===e&&(e=c.updateQueue=ch(d));null===e||d===e?dh(d,b):null===d.lastUpdate||null===e.lastUpdate?(dh(d,b),dh(e,b)):(dh(d,b),e.lastUpdate=b)}
function eh(a,b){var c=a.updateQueue;c=null===c?a.updateQueue=bh(a.memoizedState):fh(a,c);null===c.lastCapturedUpdate?c.firstCapturedUpdate=c.lastCapturedUpdate=b:(c.lastCapturedUpdate.next=b,c.lastCapturedUpdate=b)}function fh(a,b){var c=a.alternate;null!==c&&b===c.updateQueue&&(b=a.updateQueue=ch(b));return b}
function gh(a,b,c,d,e,f){switch(c.tag){case rf:return a=c.payload,"function"===typeof a?a.call(f,d,e):a;case ah:a.effectTag=a.effectTag&-2049|64;case $g:a=c.payload;e="function"===typeof a?a.call(f,d,e):a;if(null===e||void 0===e)break;return n({},d,e);case sf:Pg=!0}return d}
function yf(a,b,c,d,e){Pg=!1;b=fh(a,b);for(var f=b.baseState,g=null,h=0,l=b.firstUpdate,k=f;null!==l;){var m=l.expirationTime;m<e?(null===g&&(g=l,f=k),h<m&&(h=m)):(k=gh(a,b,l,k,c,d),null!==l.callback&&(a.effectTag|=32,l.nextEffect=null,null===b.lastEffect?b.firstEffect=b.lastEffect=l:(b.lastEffect.nextEffect=l,b.lastEffect=l)));l=l.next}m=null;for(l=b.firstCapturedUpdate;null!==l;){var p=l.expirationTime;p<e?(null===m&&(m=l,null===g&&(f=k)),h<p&&(h=p)):(k=gh(a,b,l,k,c,d),null!==l.callback&&(a.effectTag|=
32,l.nextEffect=null,null===b.lastCapturedEffect?b.firstCapturedEffect=b.lastCapturedEffect=l:(b.lastCapturedEffect.nextEffect=l,b.lastCapturedEffect=l)));l=l.next}null===g&&(b.lastUpdate=null);null===m?b.lastCapturedUpdate=null:a.effectTag|=32;null===g&&null===m&&(f=k);b.baseState=f;b.firstUpdate=g;b.firstCapturedUpdate=m;a.expirationTime=h;a.memoizedState=k}
function hh(a,b,c){null!==b.firstCapturedUpdate&&(null!==b.lastUpdate&&(b.lastUpdate.next=b.firstCapturedUpdate,b.lastUpdate=b.lastCapturedUpdate),b.firstCapturedUpdate=b.lastCapturedUpdate=null);ih(b.firstEffect,c);b.firstEffect=b.lastEffect=null;ih(b.firstCapturedEffect,c);b.firstCapturedEffect=b.lastCapturedEffect=null}function ih(a,b){for(;null!==a;){var c=a.callback;if(null!==c){a.callback=null;var d=b;"function"!==typeof c?x("191",c):void 0;c.call(d)}a=a.nextEffect}}
function jh(a,b){return{value:a,source:b,stack:jc(b)}}function kh(a){a.effectTag|=4}var lh=void 0,mh=void 0,nh=void 0,oh=void 0;lh=function(a,b){for(var c=b.child;null!==c;){if(5===c.tag||6===c.tag)a.appendChild(c.stateNode);else if(4!==c.tag&&null!==c.child){c.child.return=c;c=c.child;continue}if(c===b)break;for(;null===c.sibling;){if(null===c.return||c.return===b)return;c=c.return}c.sibling.return=c.return;c=c.sibling}};mh=function(){};
nh=function(a,b,c,d,e){var f=a.memoizedProps;if(f!==d){var g=b.stateNode;If(N.current);a=null;switch(c){case "input":f=vc(g,f);d=vc(g,d);a=[];break;case "option":f=$d(g,f);d=$d(g,d);a=[];break;case "select":f=n({},f,{value:void 0});d=n({},d,{value:void 0});a=[];break;case "textarea":f=be(g,f);d=be(g,d);a=[];break;default:"function"!==typeof f.onClick&&"function"===typeof d.onClick&&(g.onclick=te)}qe(c,d);g=c=void 0;var h=null;for(c in f)if(!d.hasOwnProperty(c)&&f.hasOwnProperty(c)&&null!=f[c])if("style"===
c){var l=f[c];for(g in l)l.hasOwnProperty(g)&&(h||(h={}),h[g]="")}else"dangerouslySetInnerHTML"!==c&&"children"!==c&&"suppressContentEditableWarning"!==c&&"suppressHydrationWarning"!==c&&"autoFocus"!==c&&(ra.hasOwnProperty(c)?a||(a=[]):(a=a||[]).push(c,null));for(c in d){var k=d[c];l=null!=f?f[c]:void 0;if(d.hasOwnProperty(c)&&k!==l&&(null!=k||null!=l))if("style"===c)if(l){for(g in l)!l.hasOwnProperty(g)||k&&k.hasOwnProperty(g)||(h||(h={}),h[g]="");for(g in k)k.hasOwnProperty(g)&&l[g]!==k[g]&&(h||
(h={}),h[g]=k[g])}else h||(a||(a=[]),a.push(c,h)),h=k;else"dangerouslySetInnerHTML"===c?(k=k?k.__html:void 0,l=l?l.__html:void 0,null!=k&&l!==k&&(a=a||[]).push(c,""+k)):"children"===c?l===k||"string"!==typeof k&&"number"!==typeof k||(a=a||[]).push(c,""+k):"suppressContentEditableWarning"!==c&&"suppressHydrationWarning"!==c&&(ra.hasOwnProperty(c)?(null!=k&&se(e,c),a||l===k||(a=[])):(a=a||[]).push(c,k))}h&&(a=a||[]).push("style",h);e=a;(b.updateQueue=e)&&kh(b)}};oh=function(a,b,c,d){c!==d&&kh(b)};
var ph="function"===typeof WeakSet?WeakSet:Set;function qh(a,b){var c=b.source,d=b.stack;null===d&&null!==c&&(d=jc(c));null!==c&&ic(c.type);b=b.value;null!==a&&1===a.tag&&ic(a.type);try{console.error(b)}catch(e){setTimeout(function(){throw e;})}}function rh(a){var b=a.ref;if(null!==b)if("function"===typeof b)try{b(null)}catch(c){sh(a,c)}else b.current=null}
function th(a,b,c){c=c.updateQueue;c=null!==c?c.lastEffect:null;if(null!==c){var d=c=c.next;do{if((d.tag&a)!==Nf){var e=d.destroy;d.destroy=void 0;void 0!==e&&e()}(d.tag&b)!==Nf&&(e=d.create,d.destroy=e());d=d.next}while(d!==c)}}
function uh(a,b){for(var c=a;;){if(5===c.tag){var d=c.stateNode;if(b)d.style.display="none";else{d=c.stateNode;var e=c.memoizedProps.style;e=void 0!==e&&null!==e&&e.hasOwnProperty("display")?e.display:null;d.style.display=ne("display",e)}}else if(6===c.tag)c.stateNode.nodeValue=b?"":c.memoizedProps;else if(13===c.tag&&null!==c.memoizedState){d=c.child.sibling;d.return=c;c=d;continue}else if(null!==c.child){c.child.return=c;c=c.child;continue}if(c===a)break;for(;null===c.sibling;){if(null===c.return||
c.return===a)return;c=c.return}c.sibling.return=c.return;c=c.sibling}}
function vh(a){"function"===typeof Re&&Re(a);switch(a.tag){case 0:case 11:case 14:case 15:var b=a.updateQueue;if(null!==b&&(b=b.lastEffect,null!==b)){var c=b=b.next;do{var d=c.destroy;if(void 0!==d){var e=a;try{d()}catch(f){sh(e,f)}}c=c.next}while(c!==b)}break;case 1:rh(a);b=a.stateNode;if("function"===typeof b.componentWillUnmount)try{b.props=a.memoizedProps,b.state=a.memoizedState,b.componentWillUnmount()}catch(f){sh(a,f)}break;case 5:rh(a);break;case 4:wh(a)}}
function xh(a){return 5===a.tag||3===a.tag||4===a.tag}
function yh(a){a:{for(var b=a.return;null!==b;){if(xh(b)){var c=b;break a}b=b.return}x("160");c=void 0}var d=b=void 0;switch(c.tag){case 5:b=c.stateNode;d=!1;break;case 3:b=c.stateNode.containerInfo;d=!0;break;case 4:b=c.stateNode.containerInfo;d=!0;break;default:x("161")}c.effectTag&16&&(ke(b,""),c.effectTag&=-17);a:b:for(c=a;;){for(;null===c.sibling;){if(null===c.return||xh(c.return)){c=null;break a}c=c.return}c.sibling.return=c.return;for(c=c.sibling;5!==c.tag&&6!==c.tag&&18!==c.tag;){if(c.effectTag&
2)continue b;if(null===c.child||4===c.tag)continue b;else c.child.return=c,c=c.child}if(!(c.effectTag&2)){c=c.stateNode;break a}}for(var e=a;;){if(5===e.tag||6===e.tag)if(c)if(d){var f=b,g=e.stateNode,h=c;8===f.nodeType?f.parentNode.insertBefore(g,h):f.insertBefore(g,h)}else b.insertBefore(e.stateNode,c);else d?(g=b,h=e.stateNode,8===g.nodeType?(f=g.parentNode,f.insertBefore(h,g)):(f=g,f.appendChild(h)),g=g._reactRootContainer,null!==g&&void 0!==g||null!==f.onclick||(f.onclick=te)):b.appendChild(e.stateNode);
else if(4!==e.tag&&null!==e.child){e.child.return=e;e=e.child;continue}if(e===a)break;for(;null===e.sibling;){if(null===e.return||e.return===a)return;e=e.return}e.sibling.return=e.return;e=e.sibling}}
function wh(a){for(var b=a,c=!1,d=void 0,e=void 0;;){if(!c){c=b.return;a:for(;;){null===c?x("160"):void 0;switch(c.tag){case 5:d=c.stateNode;e=!1;break a;case 3:d=c.stateNode.containerInfo;e=!0;break a;case 4:d=c.stateNode.containerInfo;e=!0;break a}c=c.return}c=!0}if(5===b.tag||6===b.tag){a:for(var f=b,g=f;;)if(vh(g),null!==g.child&&4!==g.tag)g.child.return=g,g=g.child;else{if(g===f)break;for(;null===g.sibling;){if(null===g.return||g.return===f)break a;g=g.return}g.sibling.return=g.return;g=g.sibling}e?
(f=d,g=b.stateNode,8===f.nodeType?f.parentNode.removeChild(g):f.removeChild(g)):d.removeChild(b.stateNode)}else if(4===b.tag){if(null!==b.child){d=b.stateNode.containerInfo;e=!0;b.child.return=b;b=b.child;continue}}else if(vh(b),null!==b.child){b.child.return=b;b=b.child;continue}if(b===a)break;for(;null===b.sibling;){if(null===b.return||b.return===a)return;b=b.return;4===b.tag&&(c=!1)}b.sibling.return=b.return;b=b.sibling}}
function zh(a,b){switch(b.tag){case 0:case 11:case 14:case 15:th(Pf,Qf,b);break;case 1:break;case 5:var c=b.stateNode;if(null!=c){var d=b.memoizedProps;a=null!==a?a.memoizedProps:d;var e=b.type,f=b.updateQueue;b.updateQueue=null;null!==f&&Ce(c,f,e,a,d,b)}break;case 6:null===b.stateNode?x("162"):void 0;b.stateNode.nodeValue=b.memoizedProps;break;case 3:break;case 12:break;case 13:c=b.memoizedState;d=void 0;a=b;null===c?d=!1:(d=!0,a=b.child,0===c.timedOutAt&&(c.timedOutAt=lf()));null!==a&&uh(a,d);c=
b.updateQueue;if(null!==c){b.updateQueue=null;var g=b.stateNode;null===g&&(g=b.stateNode=new ph);c.forEach(function(a){var c=Ah.bind(null,b,a);g.has(a)||(g.add(a),a.then(c,c))})}break;case 17:break;default:x("163")}}var Bh="function"===typeof WeakMap?WeakMap:Map;function Ch(a,b,c){c=nf(c);c.tag=ah;c.payload={element:null};var d=b.value;c.callback=function(){Dh(d);qh(a,b)};return c}
function Eh(a,b,c){c=nf(c);c.tag=ah;var d=a.type.getDerivedStateFromError;if("function"===typeof d){var e=b.value;c.payload=function(){return d(e)}}var f=a.stateNode;null!==f&&"function"===typeof f.componentDidCatch&&(c.callback=function(){"function"!==typeof d&&(null===Fh?Fh=new Set([this]):Fh.add(this));var c=b.value,e=b.stack;qh(a,b);this.componentDidCatch(c,{componentStack:null!==e?e:""})});return c}
function Gh(a){switch(a.tag){case 1:J(a.type)&&Ke(a);var b=a.effectTag;return b&2048?(a.effectTag=b&-2049|64,a):null;case 3:return Kf(a),Le(a),b=a.effectTag,0!==(b&64)?x("285"):void 0,a.effectTag=b&-2049|64,a;case 5:return Mf(a),null;case 13:return b=a.effectTag,b&2048?(a.effectTag=b&-2049|64,a):null;case 18:return null;case 4:return Kf(a),null;case 10:return Zg(a),null;default:return null}}
var Hh=Tb.ReactCurrentDispatcher,Ih=Tb.ReactCurrentOwner,Jh=1073741822,Kh=!1,T=null,Lh=null,U=0,Mh=-1,Nh=!1,V=null,Oh=!1,Ph=null,Qh=null,Rh=null,Fh=null;function Sh(){if(null!==T)for(var a=T.return;null!==a;){var b=a;switch(b.tag){case 1:var c=b.type.childContextTypes;null!==c&&void 0!==c&&Ke(b);break;case 3:Kf(b);Le(b);break;case 5:Mf(b);break;case 4:Kf(b);break;case 10:Zg(b)}a=a.return}Lh=null;U=0;Mh=-1;Nh=!1;T=null}
function Th(){for(;null!==V;){var a=V.effectTag;a&16&&ke(V.stateNode,"");if(a&128){var b=V.alternate;null!==b&&(b=b.ref,null!==b&&("function"===typeof b?b(null):b.current=null))}switch(a&14){case 2:yh(V);V.effectTag&=-3;break;case 6:yh(V);V.effectTag&=-3;zh(V.alternate,V);break;case 4:zh(V.alternate,V);break;case 8:a=V,wh(a),a.return=null,a.child=null,a.memoizedState=null,a.updateQueue=null,a=a.alternate,null!==a&&(a.return=null,a.child=null,a.memoizedState=null,a.updateQueue=null)}V=V.nextEffect}}
function Uh(){for(;null!==V;){if(V.effectTag&256)a:{var a=V.alternate,b=V;switch(b.tag){case 0:case 11:case 15:th(Of,Nf,b);break a;case 1:if(b.effectTag&256&&null!==a){var c=a.memoizedProps,d=a.memoizedState;a=b.stateNode;b=a.getSnapshotBeforeUpdate(b.elementType===b.type?c:L(b.type,c),d);a.__reactInternalSnapshotBeforeUpdate=b}break a;case 3:case 5:case 6:case 4:case 17:break a;default:x("163")}}V=V.nextEffect}}
function Vh(a,b){for(;null!==V;){var c=V.effectTag;if(c&36){var d=V.alternate,e=V,f=b;switch(e.tag){case 0:case 11:case 15:th(Rf,Sf,e);break;case 1:var g=e.stateNode;if(e.effectTag&4)if(null===d)g.componentDidMount();else{var h=e.elementType===e.type?d.memoizedProps:L(e.type,d.memoizedProps);g.componentDidUpdate(h,d.memoizedState,g.__reactInternalSnapshotBeforeUpdate)}d=e.updateQueue;null!==d&&hh(e,d,g,f);break;case 3:d=e.updateQueue;if(null!==d){g=null;if(null!==e.child)switch(e.child.tag){case 5:g=
e.child.stateNode;break;case 1:g=e.child.stateNode}hh(e,d,g,f)}break;case 5:f=e.stateNode;null===d&&e.effectTag&4&&we(e.type,e.memoizedProps)&&f.focus();break;case 6:break;case 4:break;case 12:break;case 13:break;case 17:break;default:x("163")}}c&128&&(e=V.ref,null!==e&&(f=V.stateNode,"function"===typeof e?e(f):e.current=f));c&512&&(Ph=a);V=V.nextEffect}}
function Wh(a,b){Rh=Qh=Ph=null;var c=W;W=!0;do{if(b.effectTag&512){var d=!1,e=void 0;try{var f=b;th(Uf,Nf,f);th(Nf,Tf,f)}catch(g){d=!0,e=g}d&&sh(b,e)}b=b.nextEffect}while(null!==b);W=c;c=a.expirationTime;0!==c&&Xh(a,c);X||W||Yh(1073741823,!1)}function of(){null!==Qh&&Be(Qh);null!==Rh&&Rh()}
function Zh(a,b){Oh=Kh=!0;a.current===b?x("177"):void 0;var c=a.pendingCommitExpirationTime;0===c?x("261"):void 0;a.pendingCommitExpirationTime=0;var d=b.expirationTime,e=b.childExpirationTime;ef(a,e>d?e:d);Ih.current=null;d=void 0;1<b.effectTag?null!==b.lastEffect?(b.lastEffect.nextEffect=b,d=b.firstEffect):d=b:d=b.firstEffect;ue=Bd;ve=Pd();Bd=!1;for(V=d;null!==V;){e=!1;var f=void 0;try{Uh()}catch(h){e=!0,f=h}e&&(null===V?x("178"):void 0,sh(V,f),null!==V&&(V=V.nextEffect))}for(V=d;null!==V;){e=!1;
f=void 0;try{Th()}catch(h){e=!0,f=h}e&&(null===V?x("178"):void 0,sh(V,f),null!==V&&(V=V.nextEffect))}Qd(ve);ve=null;Bd=!!ue;ue=null;a.current=b;for(V=d;null!==V;){e=!1;f=void 0;try{Vh(a,c)}catch(h){e=!0,f=h}e&&(null===V?x("178"):void 0,sh(V,f),null!==V&&(V=V.nextEffect))}if(null!==d&&null!==Ph){var g=Wh.bind(null,a,d);Qh=r.unstable_runWithPriority(r.unstable_NormalPriority,function(){return Ae(g)});Rh=g}Kh=Oh=!1;"function"===typeof Qe&&Qe(b.stateNode);c=b.expirationTime;b=b.childExpirationTime;b=
b>c?b:c;0===b&&(Fh=null);$h(a,b)}
function ai(a){for(;;){var b=a.alternate,c=a.return,d=a.sibling;if(0===(a.effectTag&1024)){T=a;a:{var e=b;b=a;var f=U;var g=b.pendingProps;switch(b.tag){case 2:break;case 16:break;case 15:case 0:break;case 1:J(b.type)&&Ke(b);break;case 3:Kf(b);Le(b);g=b.stateNode;g.pendingContext&&(g.context=g.pendingContext,g.pendingContext=null);if(null===e||null===e.child)Eg(b),b.effectTag&=-3;mh(b);break;case 5:Mf(b);var h=If(Hf.current);f=b.type;if(null!==e&&null!=b.stateNode)nh(e,b,f,g,h),e.ref!==b.ref&&(b.effectTag|=
128);else if(g){var l=If(N.current);if(Eg(b)){g=b;e=g.stateNode;var k=g.type,m=g.memoizedProps,p=h;e[Fa]=g;e[Ga]=m;f=void 0;h=k;switch(h){case "iframe":case "object":E("load",e);break;case "video":case "audio":for(k=0;k<ab.length;k++)E(ab[k],e);break;case "source":E("error",e);break;case "img":case "image":case "link":E("error",e);E("load",e);break;case "form":E("reset",e);E("submit",e);break;case "details":E("toggle",e);break;case "input":wc(e,m);E("invalid",e);se(p,"onChange");break;case "select":e._wrapperState=
{wasMultiple:!!m.multiple};E("invalid",e);se(p,"onChange");break;case "textarea":ce(e,m),E("invalid",e),se(p,"onChange")}qe(h,m);k=null;for(f in m)m.hasOwnProperty(f)&&(l=m[f],"children"===f?"string"===typeof l?e.textContent!==l&&(k=["children",l]):"number"===typeof l&&e.textContent!==""+l&&(k=["children",""+l]):ra.hasOwnProperty(f)&&null!=l&&se(p,f));switch(h){case "input":Rb(e);Ac(e,m,!0);break;case "textarea":Rb(e);ee(e,m);break;case "select":case "option":break;default:"function"===typeof m.onClick&&
(e.onclick=te)}f=k;g.updateQueue=f;g=null!==f?!0:!1;g&&kh(b)}else{m=b;p=f;e=g;k=9===h.nodeType?h:h.ownerDocument;l===fe.html&&(l=ge(p));l===fe.html?"script"===p?(e=k.createElement("div"),e.innerHTML="<script>\x3c/script>",k=e.removeChild(e.firstChild)):"string"===typeof e.is?k=k.createElement(p,{is:e.is}):(k=k.createElement(p),"select"===p&&(p=k,e.multiple?p.multiple=!0:e.size&&(p.size=e.size))):k=k.createElementNS(l,p);e=k;e[Fa]=m;e[Ga]=g;lh(e,b,!1,!1);p=e;k=f;m=g;var t=h,A=re(k,m);switch(k){case "iframe":case "object":E("load",
p);h=m;break;case "video":case "audio":for(h=0;h<ab.length;h++)E(ab[h],p);h=m;break;case "source":E("error",p);h=m;break;case "img":case "image":case "link":E("error",p);E("load",p);h=m;break;case "form":E("reset",p);E("submit",p);h=m;break;case "details":E("toggle",p);h=m;break;case "input":wc(p,m);h=vc(p,m);E("invalid",p);se(t,"onChange");break;case "option":h=$d(p,m);break;case "select":p._wrapperState={wasMultiple:!!m.multiple};h=n({},m,{value:void 0});E("invalid",p);se(t,"onChange");break;case "textarea":ce(p,
m);h=be(p,m);E("invalid",p);se(t,"onChange");break;default:h=m}qe(k,h);l=void 0;var v=k,R=p,u=h;for(l in u)if(u.hasOwnProperty(l)){var q=u[l];"style"===l?oe(R,q):"dangerouslySetInnerHTML"===l?(q=q?q.__html:void 0,null!=q&&je(R,q)):"children"===l?"string"===typeof q?("textarea"!==v||""!==q)&&ke(R,q):"number"===typeof q&&ke(R,""+q):"suppressContentEditableWarning"!==l&&"suppressHydrationWarning"!==l&&"autoFocus"!==l&&(ra.hasOwnProperty(l)?null!=q&&se(t,l):null!=q&&tc(R,l,q,A))}switch(k){case "input":Rb(p);
Ac(p,m,!1);break;case "textarea":Rb(p);ee(p,m);break;case "option":null!=m.value&&p.setAttribute("value",""+uc(m.value));break;case "select":h=p;h.multiple=!!m.multiple;p=m.value;null!=p?ae(h,!!m.multiple,p,!1):null!=m.defaultValue&&ae(h,!!m.multiple,m.defaultValue,!0);break;default:"function"===typeof h.onClick&&(p.onclick=te)}(g=we(f,g))&&kh(b);b.stateNode=e}null!==b.ref&&(b.effectTag|=128)}else null===b.stateNode?x("166"):void 0;break;case 6:e&&null!=b.stateNode?oh(e,b,e.memoizedProps,g):("string"!==
typeof g&&(null===b.stateNode?x("166"):void 0),e=If(Hf.current),If(N.current),Eg(b)?(g=b,f=g.stateNode,e=g.memoizedProps,f[Fa]=g,(g=f.nodeValue!==e)&&kh(b)):(f=b,g=(9===e.nodeType?e:e.ownerDocument).createTextNode(g),g[Fa]=b,f.stateNode=g));break;case 11:break;case 13:g=b.memoizedState;if(0!==(b.effectTag&64)){b.expirationTime=f;T=b;break a}g=null!==g;f=null!==e&&null!==e.memoizedState;null!==e&&!g&&f&&(e=e.child.sibling,null!==e&&(h=b.firstEffect,null!==h?(b.firstEffect=e,e.nextEffect=h):(b.firstEffect=
b.lastEffect=e,e.nextEffect=null),e.effectTag=8));if(g||f)b.effectTag|=4;break;case 7:break;case 8:break;case 12:break;case 4:Kf(b);mh(b);break;case 10:Zg(b);break;case 9:break;case 14:break;case 17:J(b.type)&&Ke(b);break;case 18:break;default:x("156")}T=null}b=a;if(1===U||1!==b.childExpirationTime){g=0;for(f=b.child;null!==f;)e=f.expirationTime,h=f.childExpirationTime,e>g&&(g=e),h>g&&(g=h),f=f.sibling;b.childExpirationTime=g}if(null!==T)return T;null!==c&&0===(c.effectTag&1024)&&(null===c.firstEffect&&
(c.firstEffect=a.firstEffect),null!==a.lastEffect&&(null!==c.lastEffect&&(c.lastEffect.nextEffect=a.firstEffect),c.lastEffect=a.lastEffect),1<a.effectTag&&(null!==c.lastEffect?c.lastEffect.nextEffect=a:c.firstEffect=a,c.lastEffect=a))}else{a=Gh(a,U);if(null!==a)return a.effectTag&=1023,a;null!==c&&(c.firstEffect=c.lastEffect=null,c.effectTag|=1024)}if(null!==d)return d;if(null!==c)a=c;else break}return null}
function bi(a){var b=Tg(a.alternate,a,U);a.memoizedProps=a.pendingProps;null===b&&(b=ai(a));Ih.current=null;return b}
function ci(a,b){Kh?x("243"):void 0;of();Kh=!0;var c=Hh.current;Hh.current=kg;var d=a.nextExpirationTimeToWorkOn;if(d!==U||a!==Lh||null===T)Sh(),Lh=a,U=d,T=Xe(Lh.current,null,U),a.pendingCommitExpirationTime=0;var e=!1;do{try{if(b)for(;null!==T&&!di();)T=bi(T);else for(;null!==T;)T=bi(T)}catch(u){if(Yg=Xg=Wg=null,lg(),null===T)e=!0,Dh(u);else{null===T?x("271"):void 0;var f=T,g=f.return;if(null===g)e=!0,Dh(u);else{a:{var h=a,l=g,k=f,m=u;g=U;k.effectTag|=1024;k.firstEffect=k.lastEffect=null;if(null!==
m&&"object"===typeof m&&"function"===typeof m.then){var p=m;m=l;var t=-1,A=-1;do{if(13===m.tag){var v=m.alternate;if(null!==v&&(v=v.memoizedState,null!==v)){A=10*(1073741822-v.timedOutAt);break}v=m.pendingProps.maxDuration;if("number"===typeof v)if(0>=v)t=0;else if(-1===t||v<t)t=v}m=m.return}while(null!==m);m=l;do{if(v=13===m.tag)v=void 0===m.memoizedProps.fallback?!1:null===m.memoizedState;if(v){l=m.updateQueue;null===l?(l=new Set,l.add(p),m.updateQueue=l):l.add(p);if(0===(m.mode&1)){m.effectTag|=
64;k.effectTag&=-1957;1===k.tag&&(null===k.alternate?k.tag=17:(g=nf(1073741823),g.tag=sf,pf(k,g)));k.expirationTime=1073741823;break a}k=h;l=g;var R=k.pingCache;null===R?(R=k.pingCache=new Bh,v=new Set,R.set(p,v)):(v=R.get(p),void 0===v&&(v=new Set,R.set(p,v)));v.has(l)||(v.add(l),k=ei.bind(null,k,p,l),p.then(k,k));-1===t?h=1073741823:(-1===A&&(A=10*(1073741822-gf(h,g))-5E3),h=A+t);0<=h&&Mh<h&&(Mh=h);m.effectTag|=2048;m.expirationTime=g;break a}m=m.return}while(null!==m);m=Error((ic(k.type)||"A React component")+
" suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display."+jc(k))}Nh=!0;m=jh(m,k);h=l;do{switch(h.tag){case 3:h.effectTag|=2048;h.expirationTime=g;g=Ch(h,m,g);eh(h,g);break a;case 1:if(t=m,A=h.type,k=h.stateNode,0===(h.effectTag&64)&&("function"===typeof A.getDerivedStateFromError||null!==k&&"function"===typeof k.componentDidCatch&&(null===Fh||!Fh.has(k)))){h.effectTag|=2048;
h.expirationTime=g;g=Eh(h,t,g);eh(h,g);break a}}h=h.return}while(null!==h)}T=ai(f);continue}}}break}while(1);Kh=!1;Hh.current=c;Yg=Xg=Wg=null;lg();if(e)Lh=null,a.finishedWork=null;else if(null!==T)a.finishedWork=null;else{c=a.current.alternate;null===c?x("281"):void 0;Lh=null;if(Nh){e=a.latestPendingTime;f=a.latestSuspendedTime;g=a.latestPingedTime;if(0!==e&&e<d||0!==f&&f<d||0!==g&&g<d){ff(a,d);fi(a,c,d,a.expirationTime,-1);return}if(!a.didError&&b){a.didError=!0;d=a.nextExpirationTimeToWorkOn=d;
b=a.expirationTime=1073741823;fi(a,c,d,b,-1);return}}b&&-1!==Mh?(ff(a,d),b=10*(1073741822-gf(a,d)),b<Mh&&(Mh=b),b=10*(1073741822-lf()),b=Mh-b,fi(a,c,d,a.expirationTime,0>b?0:b)):(a.pendingCommitExpirationTime=d,a.finishedWork=c)}}
function sh(a,b){for(var c=a.return;null!==c;){switch(c.tag){case 1:var d=c.stateNode;if("function"===typeof c.type.getDerivedStateFromError||"function"===typeof d.componentDidCatch&&(null===Fh||!Fh.has(d))){a=jh(b,a);a=Eh(c,a,1073741823);pf(c,a);qf(c,1073741823);return}break;case 3:a=jh(b,a);a=Ch(c,a,1073741823);pf(c,a);qf(c,1073741823);return}c=c.return}3===a.tag&&(c=jh(b,a),c=Ch(a,c,1073741823),pf(a,c),qf(a,1073741823))}
function mf(a,b){var c=r.unstable_getCurrentPriorityLevel(),d=void 0;if(0===(b.mode&1))d=1073741823;else if(Kh&&!Oh)d=U;else{switch(c){case r.unstable_ImmediatePriority:d=1073741823;break;case r.unstable_UserBlockingPriority:d=1073741822-10*(((1073741822-a+15)/10|0)+1);break;case r.unstable_NormalPriority:d=1073741822-25*(((1073741822-a+500)/25|0)+1);break;case r.unstable_LowPriority:case r.unstable_IdlePriority:d=1;break;default:x("313")}null!==Lh&&d===U&&--d}c===r.unstable_UserBlockingPriority&&
(0===gi||d<gi)&&(gi=d);return d}function ei(a,b,c){var d=a.pingCache;null!==d&&d.delete(b);if(null!==Lh&&U===c)Lh=null;else if(b=a.earliestSuspendedTime,d=a.latestSuspendedTime,0!==b&&c<=b&&c>=d){a.didError=!1;b=a.latestPingedTime;if(0===b||b>c)a.latestPingedTime=c;df(c,a);c=a.expirationTime;0!==c&&Xh(a,c)}}function Ah(a,b){var c=a.stateNode;null!==c&&c.delete(b);b=lf();b=mf(b,a);a=hi(a,b);null!==a&&(cf(a,b),b=a.expirationTime,0!==b&&Xh(a,b))}
function hi(a,b){a.expirationTime<b&&(a.expirationTime=b);var c=a.alternate;null!==c&&c.expirationTime<b&&(c.expirationTime=b);var d=a.return,e=null;if(null===d&&3===a.tag)e=a.stateNode;else for(;null!==d;){c=d.alternate;d.childExpirationTime<b&&(d.childExpirationTime=b);null!==c&&c.childExpirationTime<b&&(c.childExpirationTime=b);if(null===d.return&&3===d.tag){e=d.stateNode;break}d=d.return}return e}
function qf(a,b){a=hi(a,b);null!==a&&(!Kh&&0!==U&&b>U&&Sh(),cf(a,b),Kh&&!Oh&&Lh===a||Xh(a,a.expirationTime),ii>ji&&(ii=0,x("185")))}function ki(a,b,c,d,e){return r.unstable_runWithPriority(r.unstable_ImmediatePriority,function(){return a(b,c,d,e)})}var li=null,Y=null,mi=0,ni=void 0,W=!1,oi=null,Z=0,gi=0,pi=!1,qi=null,X=!1,ri=!1,si=null,ti=r.unstable_now(),ui=1073741822-(ti/10|0),vi=ui,ji=50,ii=0,wi=null;function xi(){ui=1073741822-((r.unstable_now()-ti)/10|0)}
function yi(a,b){if(0!==mi){if(b<mi)return;null!==ni&&r.unstable_cancelCallback(ni)}mi=b;a=r.unstable_now()-ti;ni=r.unstable_scheduleCallback(zi,{timeout:10*(1073741822-b)-a})}function fi(a,b,c,d,e){a.expirationTime=d;0!==e||di()?0<e&&(a.timeoutHandle=ye(Ai.bind(null,a,b,c),e)):(a.pendingCommitExpirationTime=c,a.finishedWork=b)}function Ai(a,b,c){a.pendingCommitExpirationTime=c;a.finishedWork=b;xi();vi=ui;Bi(a,c)}function $h(a,b){a.expirationTime=b;a.finishedWork=null}
function lf(){if(W)return vi;Ci();if(0===Z||1===Z)xi(),vi=ui;return vi}function Xh(a,b){null===a.nextScheduledRoot?(a.expirationTime=b,null===Y?(li=Y=a,a.nextScheduledRoot=a):(Y=Y.nextScheduledRoot=a,Y.nextScheduledRoot=li)):b>a.expirationTime&&(a.expirationTime=b);W||(X?ri&&(oi=a,Z=1073741823,Di(a,1073741823,!1)):1073741823===b?Yh(1073741823,!1):yi(a,b))}
function Ci(){var a=0,b=null;if(null!==Y)for(var c=Y,d=li;null!==d;){var e=d.expirationTime;if(0===e){null===c||null===Y?x("244"):void 0;if(d===d.nextScheduledRoot){li=Y=d.nextScheduledRoot=null;break}else if(d===li)li=e=d.nextScheduledRoot,Y.nextScheduledRoot=e,d.nextScheduledRoot=null;else if(d===Y){Y=c;Y.nextScheduledRoot=li;d.nextScheduledRoot=null;break}else c.nextScheduledRoot=d.nextScheduledRoot,d.nextScheduledRoot=null;d=c.nextScheduledRoot}else{e>a&&(a=e,b=d);if(d===Y)break;if(1073741823===
a)break;c=d;d=d.nextScheduledRoot}}oi=b;Z=a}var Ei=!1;function di(){return Ei?!0:r.unstable_shouldYield()?Ei=!0:!1}function zi(){try{if(!di()&&null!==li){xi();var a=li;do{var b=a.expirationTime;0!==b&&ui<=b&&(a.nextExpirationTimeToWorkOn=ui);a=a.nextScheduledRoot}while(a!==li)}Yh(0,!0)}finally{Ei=!1}}
function Yh(a,b){Ci();if(b)for(xi(),vi=ui;null!==oi&&0!==Z&&a<=Z&&!(Ei&&ui>Z);)Di(oi,Z,ui>Z),Ci(),xi(),vi=ui;else for(;null!==oi&&0!==Z&&a<=Z;)Di(oi,Z,!1),Ci();b&&(mi=0,ni=null);0!==Z&&yi(oi,Z);ii=0;wi=null;if(null!==si)for(a=si,si=null,b=0;b<a.length;b++){var c=a[b];try{c._onComplete()}catch(d){pi||(pi=!0,qi=d)}}if(pi)throw a=qi,qi=null,pi=!1,a;}function Bi(a,b){W?x("253"):void 0;oi=a;Z=b;Di(a,b,!1);Yh(1073741823,!1)}
function Di(a,b,c){W?x("245"):void 0;W=!0;if(c){var d=a.finishedWork;null!==d?Fi(a,d,b):(a.finishedWork=null,d=a.timeoutHandle,-1!==d&&(a.timeoutHandle=-1,ze(d)),ci(a,c),d=a.finishedWork,null!==d&&(di()?a.finishedWork=d:Fi(a,d,b)))}else d=a.finishedWork,null!==d?Fi(a,d,b):(a.finishedWork=null,d=a.timeoutHandle,-1!==d&&(a.timeoutHandle=-1,ze(d)),ci(a,c),d=a.finishedWork,null!==d&&Fi(a,d,b));W=!1}
function Fi(a,b,c){var d=a.firstBatch;if(null!==d&&d._expirationTime>=c&&(null===si?si=[d]:si.push(d),d._defer)){a.finishedWork=b;a.expirationTime=0;return}a.finishedWork=null;a===wi?ii++:(wi=a,ii=0);r.unstable_runWithPriority(r.unstable_ImmediatePriority,function(){Zh(a,b)})}function Dh(a){null===oi?x("246"):void 0;oi.expirationTime=0;pi||(pi=!0,qi=a)}function Gi(a,b){var c=X;X=!0;try{return a(b)}finally{(X=c)||W||Yh(1073741823,!1)}}
function Hi(a,b){if(X&&!ri){ri=!0;try{return a(b)}finally{ri=!1}}return a(b)}function Ii(a,b,c){X||W||0===gi||(Yh(gi,!1),gi=0);var d=X;X=!0;try{return r.unstable_runWithPriority(r.unstable_UserBlockingPriority,function(){return a(b,c)})}finally{(X=d)||W||Yh(1073741823,!1)}}
function Ji(a,b,c,d,e){var f=b.current;a:if(c){c=c._reactInternalFiber;b:{2===ed(c)&&1===c.tag?void 0:x("170");var g=c;do{switch(g.tag){case 3:g=g.stateNode.context;break b;case 1:if(J(g.type)){g=g.stateNode.__reactInternalMemoizedMergedChildContext;break b}}g=g.return}while(null!==g);x("171");g=void 0}if(1===c.tag){var h=c.type;if(J(h)){c=Ne(c,h,g);break a}}c=g}else c=He;null===b.context?b.context=c:b.pendingContext=c;b=e;e=nf(d);e.payload={element:a};b=void 0===b?null:b;null!==b&&(e.callback=b);
of();pf(f,e);qf(f,d);return d}function Ki(a,b,c,d){var e=b.current,f=lf();e=mf(f,e);return Ji(a,b,c,e,d)}function Li(a){a=a.current;if(!a.child)return null;switch(a.child.tag){case 5:return a.child.stateNode;default:return a.child.stateNode}}function Mi(a,b,c){var d=3<arguments.length&&void 0!==arguments[3]?arguments[3]:null;return{$$typeof:Wb,key:null==d?null:""+d,children:a,containerInfo:b,implementation:c}}
Ab=function(a,b,c){switch(b){case "input":yc(a,c);b=c.name;if("radio"===c.type&&null!=b){for(c=a;c.parentNode;)c=c.parentNode;c=c.querySelectorAll("input[name="+JSON.stringify(""+b)+'][type="radio"]');for(b=0;b<c.length;b++){var d=c[b];if(d!==a&&d.form===a.form){var e=Ka(d);e?void 0:x("90");Sb(d);yc(d,e)}}}break;case "textarea":de(a,c);break;case "select":b=c.value,null!=b&&ae(a,!!c.multiple,b,!1)}};
function Ni(a){var b=1073741822-25*(((1073741822-lf()+500)/25|0)+1);b>=Jh&&(b=Jh-1);this._expirationTime=Jh=b;this._root=a;this._callbacks=this._next=null;this._hasChildren=this._didComplete=!1;this._children=null;this._defer=!0}Ni.prototype.render=function(a){this._defer?void 0:x("250");this._hasChildren=!0;this._children=a;var b=this._root._internalRoot,c=this._expirationTime,d=new Oi;Ji(a,b,null,c,d._onCommit);return d};
Ni.prototype.then=function(a){if(this._didComplete)a();else{var b=this._callbacks;null===b&&(b=this._callbacks=[]);b.push(a)}};
Ni.prototype.commit=function(){var a=this._root._internalRoot,b=a.firstBatch;this._defer&&null!==b?void 0:x("251");if(this._hasChildren){var c=this._expirationTime;if(b!==this){this._hasChildren&&(c=this._expirationTime=b._expirationTime,this.render(this._children));for(var d=null,e=b;e!==this;)d=e,e=e._next;null===d?x("251"):void 0;d._next=e._next;this._next=b;a.firstBatch=this}this._defer=!1;Bi(a,c);b=this._next;this._next=null;b=a.firstBatch=b;null!==b&&b._hasChildren&&b.render(b._children)}else this._next=
null,this._defer=!1};Ni.prototype._onComplete=function(){if(!this._didComplete){this._didComplete=!0;var a=this._callbacks;if(null!==a)for(var b=0;b<a.length;b++)(0,a[b])()}};function Oi(){this._callbacks=null;this._didCommit=!1;this._onCommit=this._onCommit.bind(this)}Oi.prototype.then=function(a){if(this._didCommit)a();else{var b=this._callbacks;null===b&&(b=this._callbacks=[]);b.push(a)}};
Oi.prototype._onCommit=function(){if(!this._didCommit){this._didCommit=!0;var a=this._callbacks;if(null!==a)for(var b=0;b<a.length;b++){var c=a[b];"function"!==typeof c?x("191",c):void 0;c()}}};
function Pi(a,b,c){b=K(3,null,null,b?3:0);a={current:b,containerInfo:a,pendingChildren:null,pingCache:null,earliestPendingTime:0,latestPendingTime:0,earliestSuspendedTime:0,latestSuspendedTime:0,latestPingedTime:0,didError:!1,pendingCommitExpirationTime:0,finishedWork:null,timeoutHandle:-1,context:null,pendingContext:null,hydrate:c,nextExpirationTimeToWorkOn:0,expirationTime:0,firstBatch:null,nextScheduledRoot:null};this._internalRoot=b.stateNode=a}
Pi.prototype.render=function(a,b){var c=this._internalRoot,d=new Oi;b=void 0===b?null:b;null!==b&&d.then(b);Ki(a,c,null,d._onCommit);return d};Pi.prototype.unmount=function(a){var b=this._internalRoot,c=new Oi;a=void 0===a?null:a;null!==a&&c.then(a);Ki(null,b,null,c._onCommit);return c};Pi.prototype.legacy_renderSubtreeIntoContainer=function(a,b,c){var d=this._internalRoot,e=new Oi;c=void 0===c?null:c;null!==c&&e.then(c);Ki(b,d,a,e._onCommit);return e};
Pi.prototype.createBatch=function(){var a=new Ni(this),b=a._expirationTime,c=this._internalRoot,d=c.firstBatch;if(null===d)c.firstBatch=a,a._next=null;else{for(c=null;null!==d&&d._expirationTime>=b;)c=d,d=d._next;a._next=d;null!==c&&(c._next=a)}return a};function Qi(a){return!(!a||1!==a.nodeType&&9!==a.nodeType&&11!==a.nodeType&&(8!==a.nodeType||" react-mount-point-unstable "!==a.nodeValue))}Gb=Gi;Hb=Ii;Ib=function(){W||0===gi||(Yh(gi,!1),gi=0)};
function Ri(a,b){b||(b=a?9===a.nodeType?a.documentElement:a.firstChild:null,b=!(!b||1!==b.nodeType||!b.hasAttribute("data-reactroot")));if(!b)for(var c;c=a.lastChild;)a.removeChild(c);return new Pi(a,!1,b)}
function Si(a,b,c,d,e){var f=c._reactRootContainer;if(f){if("function"===typeof e){var g=e;e=function(){var a=Li(f._internalRoot);g.call(a)}}null!=a?f.legacy_renderSubtreeIntoContainer(a,b,e):f.render(b,e)}else{f=c._reactRootContainer=Ri(c,d);if("function"===typeof e){var h=e;e=function(){var a=Li(f._internalRoot);h.call(a)}}Hi(function(){null!=a?f.legacy_renderSubtreeIntoContainer(a,b,e):f.render(b,e)})}return Li(f._internalRoot)}
function Ti(a,b){var c=2<arguments.length&&void 0!==arguments[2]?arguments[2]:null;Qi(b)?void 0:x("200");return Mi(a,b,null,c)}
var Vi={createPortal:Ti,findDOMNode:function(a){if(null==a)return null;if(1===a.nodeType)return a;var b=a._reactInternalFiber;void 0===b&&("function"===typeof a.render?x("188"):x("268",Object.keys(a)));a=hd(b);a=null===a?null:a.stateNode;return a},hydrate:function(a,b,c){Qi(b)?void 0:x("200");return Si(null,a,b,!0,c)},render:function(a,b,c){Qi(b)?void 0:x("200");return Si(null,a,b,!1,c)},unstable_renderSubtreeIntoContainer:function(a,b,c,d){Qi(c)?void 0:x("200");null==a||void 0===a._reactInternalFiber?
x("38"):void 0;return Si(a,b,c,!1,d)},unmountComponentAtNode:function(a){Qi(a)?void 0:x("40");return a._reactRootContainer?(Hi(function(){Si(null,null,a,!1,function(){a._reactRootContainer=null})}),!0):!1},unstable_createPortal:function(){return Ti.apply(void 0,arguments)},unstable_batchedUpdates:Gi,unstable_interactiveUpdates:Ii,flushSync:function(a,b){W?x("187"):void 0;var c=X;X=!0;try{return ki(a,b)}finally{X=c,Yh(1073741823,!1)}},unstable_createRoot:Ui,unstable_flushControlled:function(a){var b=
X;X=!0;try{ki(a)}finally{(X=b)||W||Yh(1073741823,!1)}},__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{Events:[Ia,Ja,Ka,Ba.injectEventPluginsByName,pa,Qa,function(a){ya(a,Pa)},Eb,Fb,Dd,Da]}};function Ui(a,b){Qi(a)?void 0:x("299","unstable_createRoot");return new Pi(a,!0,null!=b&&!0===b.hydrate)}
(function(a){var b=a.findFiberByHostInstance;return Te(n({},a,{overrideProps:null,currentDispatcherRef:Tb.ReactCurrentDispatcher,findHostInstanceByFiber:function(a){a=hd(a);return null===a?null:a.stateNode},findFiberByHostInstance:function(a){return b?b(a):null}}))})({findFiberByHostInstance:Ha,bundleType:0,version:"16.8.6",rendererPackageName:"react-dom"});var Wi={default:Vi},Xi=Wi&&Vi||Wi;module.exports=Xi.default||Xi;


/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(62);
} else {
  module.exports = require('./cjs/scheduler.development.js');
}


/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/** @license React v0.13.6
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

Object.defineProperty(exports,"__esModule",{value:!0});var d=null,e=!1,g=3,k=-1,l=-1,m=!1,n=!1;function p(){if(!m){var a=d.expirationTime;n?q():n=!0;r(t,a)}}
function u(){var a=d,b=d.next;if(d===b)d=null;else{var c=d.previous;d=c.next=b;b.previous=c}a.next=a.previous=null;c=a.callback;b=a.expirationTime;a=a.priorityLevel;var f=g,Q=l;g=a;l=b;try{var h=c()}finally{g=f,l=Q}if("function"===typeof h)if(h={callback:h,priorityLevel:a,expirationTime:b,next:null,previous:null},null===d)d=h.next=h.previous=h;else{c=null;a=d;do{if(a.expirationTime>=b){c=a;break}a=a.next}while(a!==d);null===c?c=d:c===d&&(d=h,p());b=c.previous;b.next=c.previous=h;h.next=c;h.previous=
b}}function v(){if(-1===k&&null!==d&&1===d.priorityLevel){m=!0;try{do u();while(null!==d&&1===d.priorityLevel)}finally{m=!1,null!==d?p():n=!1}}}function t(a){m=!0;var b=e;e=a;try{if(a)for(;null!==d;){var c=exports.unstable_now();if(d.expirationTime<=c){do u();while(null!==d&&d.expirationTime<=c)}else break}else if(null!==d){do u();while(null!==d&&!w())}}finally{m=!1,e=b,null!==d?p():n=!1,v()}}
var x=Date,y="function"===typeof setTimeout?setTimeout:void 0,z="function"===typeof clearTimeout?clearTimeout:void 0,A="function"===typeof requestAnimationFrame?requestAnimationFrame:void 0,B="function"===typeof cancelAnimationFrame?cancelAnimationFrame:void 0,C,D;function E(a){C=A(function(b){z(D);a(b)});D=y(function(){B(C);a(exports.unstable_now())},100)}
if("object"===typeof performance&&"function"===typeof performance.now){var F=performance;exports.unstable_now=function(){return F.now()}}else exports.unstable_now=function(){return x.now()};var r,q,w,G=null;"undefined"!==typeof window?G=window:"undefined"!==typeof global&&(G=global);
if(G&&G._schedMock){var H=G._schedMock;r=H[0];q=H[1];w=H[2];exports.unstable_now=H[3]}else if("undefined"===typeof window||"function"!==typeof MessageChannel){var I=null,J=function(a){if(null!==I)try{I(a)}finally{I=null}};r=function(a){null!==I?setTimeout(r,0,a):(I=a,setTimeout(J,0,!1))};q=function(){I=null};w=function(){return!1}}else{"undefined"!==typeof console&&("function"!==typeof A&&console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills"),
"function"!==typeof B&&console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills"));var K=null,L=!1,M=-1,N=!1,O=!1,P=0,R=33,S=33;w=function(){return P<=exports.unstable_now()};var T=new MessageChannel,U=T.port2;T.port1.onmessage=function(){L=!1;var a=K,b=M;K=null;M=-1;var c=exports.unstable_now(),f=!1;if(0>=P-c)if(-1!==b&&b<=c)f=!0;else{N||(N=!0,E(V));K=a;M=b;return}if(null!==a){O=!0;try{a(f)}finally{O=!1}}};
var V=function(a){if(null!==K){E(V);var b=a-P+S;b<S&&R<S?(8>b&&(b=8),S=b<R?R:b):R=b;P=a+S;L||(L=!0,U.postMessage(void 0))}else N=!1};r=function(a,b){K=a;M=b;O||0>b?U.postMessage(void 0):N||(N=!0,E(V))};q=function(){K=null;L=!1;M=-1}}exports.unstable_ImmediatePriority=1;exports.unstable_UserBlockingPriority=2;exports.unstable_NormalPriority=3;exports.unstable_IdlePriority=5;exports.unstable_LowPriority=4;
exports.unstable_runWithPriority=function(a,b){switch(a){case 1:case 2:case 3:case 4:case 5:break;default:a=3}var c=g,f=k;g=a;k=exports.unstable_now();try{return b()}finally{g=c,k=f,v()}};exports.unstable_next=function(a){switch(g){case 1:case 2:case 3:var b=3;break;default:b=g}var c=g,f=k;g=b;k=exports.unstable_now();try{return a()}finally{g=c,k=f,v()}};
exports.unstable_scheduleCallback=function(a,b){var c=-1!==k?k:exports.unstable_now();if("object"===typeof b&&null!==b&&"number"===typeof b.timeout)b=c+b.timeout;else switch(g){case 1:b=c+-1;break;case 2:b=c+250;break;case 5:b=c+1073741823;break;case 4:b=c+1E4;break;default:b=c+5E3}a={callback:a,priorityLevel:g,expirationTime:b,next:null,previous:null};if(null===d)d=a.next=a.previous=a,p();else{c=null;var f=d;do{if(f.expirationTime>b){c=f;break}f=f.next}while(f!==d);null===c?c=d:c===d&&(d=a,p());
b=c.previous;b.next=c.previous=a;a.next=c;a.previous=b}return a};exports.unstable_cancelCallback=function(a){var b=a.next;if(null!==b){if(b===a)d=null;else{a===d&&(d=b);var c=a.previous;c.next=b;b.previous=c}a.next=a.previous=null}};exports.unstable_wrapCallback=function(a){var b=g;return function(){var c=g,f=k;g=b;k=exports.unstable_now();try{return a.apply(this,arguments)}finally{g=c,k=f,v()}}};exports.unstable_getCurrentPriorityLevel=function(){return g};
exports.unstable_shouldYield=function(){return!e&&(null!==d&&d.expirationTime<l||w())};exports.unstable_continueExecution=function(){null!==d&&p()};exports.unstable_pauseExecution=function(){};exports.unstable_getFirstCallbackNode=function(){return d};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(10)))

/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(64);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(66)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../node_modules/css-loader/index.js??ref--1-oneOf-2-1!../node_modules/postcss-loader/lib/index.js??postcss!./index.css", function() {
			var newContent = require("!!../node_modules/css-loader/index.js??ref--1-oneOf-2-1!../node_modules/postcss-loader/lib/index.js??postcss!./index.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(65)(undefined);
// imports
exports.push([module.i, "@import url(https://fonts.googleapis.com/css?family=Lato:100,300,400,500,700);", ""]);

// module
exports.push([module.i, "/* body {\n  margin: 0;\n  padding: 0;\n  font-family: sans-serif;\n} */\n\nhtml {\n  overflow: hidden;\n}\n\nbody {\n  overflow-x: hidden;\n  position: static !important;\n}\n\n* {\n  margin: 0;\n  padding: 0;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n}\n\n#revieve-root {\n  font-family: 'Lato', sans-serif;\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n}\n\n#revieve-root .rootWrapper {\n  position: absolute;\n  max-width: 992px;\n  left: 0;\n  right: 0;\n  top: 0;\n  bottom: 0;\n  margin: auto;\n  overflow: hidden;\n}\n\n.footerSlide-enter {\n  -webkit-transform: translate3d(0px, 100vh, 0px);\n          transform: translate3d(0px, 100vh, 0px);\n  -webkit-transition: all 500ms cubic-bezier(0.5, 0, 0, 1.2);\n  -o-transition: all 500ms cubic-bezier(0.5, 0, 0, 1.2);\n  transition: all 500ms cubic-bezier(0.5, 0, 0, 1.2);\n}\n\n.footerSlide-enter.footerSlide-enter-active {\n  -webkit-transform: translate3d(0px, 0px, 0px);\n          transform: translate3d(0px, 0px, 0px);\n  -webkit-transition: all 500ms cubic-bezier(0.5, 0, 0, 1.2);\n  -o-transition: all 500ms cubic-bezier(0.5, 0, 0, 1.2);\n  transition: all 500ms cubic-bezier(0.5, 0, 0, 1.2);\n}\n\n.footerSlide-leave {\n  -webkit-transform: translate3d(0px, 0px, 0px);\n          transform: translate3d(0px, 0px, 0px);\n  -webkit-transition: all 500ms cubic-bezier(0.5, 0, 0, 1.2);\n  -o-transition: all 500ms cubic-bezier(0.5, 0, 0, 1.2);\n  transition: all 500ms cubic-bezier(0.5, 0, 0, 1.2);\n}\n\n.footerSlide-leave.footerSlide-leave-active {\n  -webkit-transform: translate3d(0px, 100vh, 0px);\n          transform: translate3d(0px, 100vh, 0px);\n  -webkit-transition: all 500ms cubic-bezier(0.5, 0, 0, 1.2);\n  -o-transition: all 500ms cubic-bezier(0.5, 0, 0, 1.2);\n  transition: all 500ms cubic-bezier(0.5, 0, 0, 1.2);\n}\n\n.footerSlide-appear {\n  -webkit-transform: translate3d(0px, 100vh, 0px);\n          transform: translate3d(0px, 100vh, 0px);\n  -webkit-transition: all 500ms cubic-bezier(0.5, 0, 0, 1.2);\n  -o-transition: all 500ms cubic-bezier(0.5, 0, 0, 1.2);\n  transition: all 500ms cubic-bezier(0.5, 0, 0, 1.2);\n}\n\n.footerSlide-appear.footerSlide-appear-active {\n  -webkit-transform: translate3d(0px, 0px, 0px);\n          transform: translate3d(0px, 0px, 0px);\n  -webkit-transition: all 500ms cubic-bezier(0.5, 0, 0, 1.2);\n  -o-transition: all 500ms cubic-bezier(0.5, 0, 0, 1.2);\n  transition: all 500ms cubic-bezier(0.5, 0, 0, 1.2);\n}\n\n/* Header */\n.headerSlide-enter {\n  -webkit-transform: translate3d(0px, -200px, 0px);\n          transform: translate3d(0px, -200px, 0px);\n  -webkit-transition: all 500ms cubic-bezier(0.5, 0, 0, 1.2);\n  -o-transition: all 500ms cubic-bezier(0.5, 0, 0, 1.2);\n  transition: all 500ms cubic-bezier(0.5, 0, 0, 1.2);\n}\n\n.headerSlide-enter.headerSlide-enter-active {\n  -webkit-transform: translate3d(0px, 0px, 0px);\n          transform: translate3d(0px, 0px, 0px);\n  -webkit-transition: all 500ms cubic-bezier(0.5, 0, 0, 1.2);\n  -o-transition: all 500ms cubic-bezier(0.5, 0, 0, 1.2);\n  transition: all 500ms cubic-bezier(0.5, 0, 0, 1.2);\n}\n\n.headerSlide-leave {\n  -webkit-transform: translate3d(0px, 0px, 0px);\n          transform: translate3d(0px, 0px, 0px);\n  -webkit-transition: all 500ms cubic-bezier(0.5, 0, 0, 1.2);\n  -o-transition: all 500ms cubic-bezier(0.5, 0, 0, 1.2);\n  transition: all 500ms cubic-bezier(0.5, 0, 0, 1.2);\n}\n\n.headerSlide-leave.headerSlide-leave-active {\n  -webkit-transform: translate3d(0px, -200px, 0px);\n          transform: translate3d(0px, -200px, 0px);\n  -webkit-transition: all 500ms cubic-bezier(0.5, 0, 0, 1.2);\n  -o-transition: all 500ms cubic-bezier(0.5, 0, 0, 1.2);\n  transition: all 500ms cubic-bezier(0.5, 0, 0, 1.2);\n}\n\n.headerSlide-appear {\n  -webkit-transform: translate3d(0px, -200px, 0px);\n          transform: translate3d(0px, -200px, 0px);\n  -webkit-transition: all 500ms cubic-bezier(0.5, 0, 0, 1.2);\n  -o-transition: all 500ms cubic-bezier(0.5, 0, 0, 1.2);\n  transition: all 500ms cubic-bezier(0.5, 0, 0, 1.2);\n}\n\n.headerSlide-appear.headerSlide-appear-active {\n  -webkit-transform: translate3d(0px, 0px, 0px);\n          transform: translate3d(0px, 0px, 0px);\n  -webkit-transition: all 500ms cubic-bezier(0.5, 0, 0, 1.2);\n  -o-transition: all 500ms cubic-bezier(0.5, 0, 0, 1.2);\n  transition: all 500ms cubic-bezier(0.5, 0, 0, 1.2);\n}\n\n/* Content */\n\n.contentSlide-enter {\n  opacity: 0.01;\n  -webkit-transform: translate3d(20px, 0px, 0px);\n          transform: translate3d(20px, 0px, 0px);\n}\n\n.contentSlide-enter.contentSlide-enter-active {\n  opacity: 1;\n  -webkit-transform: translate3d(0px, 0px, 0px);\n          transform: translate3d(0px, 0px, 0px);\n  -webkit-transition: opacity 300ms ease-in, -webkit-transform 300ms ease-in;\n  transition: opacity 300ms ease-in, -webkit-transform 300ms ease-in;\n  -o-transition: opacity 300ms ease-in, transform 300ms ease-in;\n  transition: opacity 300ms ease-in, transform 300ms ease-in;\n  transition: opacity 300ms ease-in, transform 300ms ease-in, -webkit-transform 300ms ease-in;\n}\n\n.contentSlide-leave {\n  opacity: 1;\n  -webkit-transform: translate3d(0px, 0px, 0px);\n          transform: translate3d(0px, 0px, 0px);\n}\n\n.contentSlide-leave.contentSlide-leave-active {\n  opacity: 0.01;\n  -webkit-transform: translate3d(-20px, 0px, 0px);\n          transform: translate3d(-20px, 0px, 0px);\n  -webkit-transition: opacity 300ms ease-in, -webkit-transform 300ms ease-in;\n  transition: opacity 300ms ease-in, -webkit-transform 300ms ease-in;\n  -o-transition: opacity 300ms ease-in, transform 300ms ease-in;\n  transition: opacity 300ms ease-in, transform 300ms ease-in;\n  transition: opacity 300ms ease-in, transform 300ms ease-in, -webkit-transform 300ms ease-in;\n}\n\n.contentSlide-appear {\n  opacity: 0.01;\n  -webkit-transform: translate3d(20px, 0px, 0px);\n          transform: translate3d(20px, 0px, 0px);\n  -webkit-transition: opacity 300ms ease-in, -webkit-transform 300ms ease-in;\n  transition: opacity 300ms ease-in, -webkit-transform 300ms ease-in;\n  -o-transition: opacity 300ms ease-in, transform 300ms ease-in;\n  transition: opacity 300ms ease-in, transform 300ms ease-in;\n  transition: opacity 300ms ease-in, transform 300ms ease-in, -webkit-transform 300ms ease-in;\n}\n\n.contentSlide-appear.contentSlide-appear-active {\n  opacity: 1;\n  -webkit-transform: translate3d(0px, 0px, 0px);\n          transform: translate3d(0px, 0px, 0px);\n  -webkit-transition: opacity 300ms ease-in, -webkit-transform 300ms ease-in;\n  transition: opacity 300ms ease-in, -webkit-transform 300ms ease-in;\n  -o-transition: opacity 300ms ease-in, transform 300ms ease-in;\n  transition: opacity 300ms ease-in, transform 300ms ease-in;\n  transition: opacity 300ms ease-in, transform 300ms ease-in, -webkit-transform 300ms ease-in;\n}\n\n/* right side */\n\n.rightSide-enter {\n  opacity: 0.01;\n  -webkit-transform: translate3d(20px, 0px, 0px);\n          transform: translate3d(20px, 0px, 0px);\n}\n\n.rightSide-enter.rightSide-enter-active {\n  opacity: 1;\n  -webkit-transform: translate3d(0px, 0px, 0px);\n          transform: translate3d(0px, 0px, 0px);\n  -webkit-transition: opacity 300ms ease-in, -webkit-transform 300ms ease-in;\n  transition: opacity 300ms ease-in, -webkit-transform 300ms ease-in;\n  -o-transition: opacity 300ms ease-in, transform 300ms ease-in;\n  transition: opacity 300ms ease-in, transform 300ms ease-in;\n  transition: opacity 300ms ease-in, transform 300ms ease-in, -webkit-transform 300ms ease-in;\n}\n\n.rightSide-leave {\n  opacity: 1;\n  -webkit-transform: translate3d(0px, 0px, 0px);\n          transform: translate3d(0px, 0px, 0px);\n}\n\n.rightSide-leave.rightSide-leave-active {\n  opacity: 0.01;\n  -webkit-transform: translate3d(20px, 0px, 0px);\n          transform: translate3d(20px, 0px, 0px);\n  -webkit-transition: opacity 300ms ease-in, -webkit-transform 300ms ease-in;\n  transition: opacity 300ms ease-in, -webkit-transform 300ms ease-in;\n  -o-transition: opacity 300ms ease-in, transform 300ms ease-in;\n  transition: opacity 300ms ease-in, transform 300ms ease-in;\n  transition: opacity 300ms ease-in, transform 300ms ease-in, -webkit-transform 300ms ease-in;\n}\n\n.rightSide-appear {\n  opacity: 0.01;\n  -webkit-transform: translate3d(20px, 0px, 0px);\n          transform: translate3d(20px, 0px, 0px);\n  -webkit-transition: opacity 300ms ease-in, -webkit-transform 300ms ease-in;\n  transition: opacity 300ms ease-in, -webkit-transform 300ms ease-in;\n  -o-transition: opacity 300ms ease-in, transform 300ms ease-in;\n  transition: opacity 300ms ease-in, transform 300ms ease-in;\n  transition: opacity 300ms ease-in, transform 300ms ease-in, -webkit-transform 300ms ease-in;\n}\n\n.rightSide-appear.rightSide-appear-active {\n  opacity: 1;\n  -webkit-transform: translate3d(0px, 0px, 0px);\n          transform: translate3d(0px, 0px, 0px);\n  -webkit-transition: opacity 300ms ease-in, -webkit-transform 300ms ease-in;\n  transition: opacity 300ms ease-in, -webkit-transform 300ms ease-in;\n  -o-transition: opacity 300ms ease-in, transform 300ms ease-in;\n  transition: opacity 300ms ease-in, transform 300ms ease-in;\n  transition: opacity 300ms ease-in, transform 300ms ease-in, -webkit-transform 300ms ease-in;\n}\n\n/* Swipe Gesture */\n\n.swipeGesture-enter {\n  -webkit-transform: translate3d(0px, 0px, 0px);\n          transform: translate3d(0px, 0px, 0px);\n  -webkit-transition: all 500ms ease-in;\n  -o-transition: all 500ms ease-in;\n  transition: all 500ms ease-in;\n  opacity: 0;\n}\n\n.swipeGesture-enter.swipeGesture-enter-active {\n  -webkit-transform: translate3d(0px, 0px, 0px);\n          transform: translate3d(0px, 0px, 0px);\n  -webkit-transition: all 500ms ease-in;\n  -o-transition: all 500ms ease-in;\n  transition: all 500ms ease-in;\n  opacity: 1;\n}\n\n.swipeGesture-leave {\n  -webkit-transform: translate3d(0px, 0px, 0px);\n          transform: translate3d(0px, 0px, 0px);\n  -webkit-transition: all 500ms ease-out;\n  -o-transition: all 500ms ease-out;\n  transition: all 500ms ease-out;\n  opacity: 1;\n}\n\n.swipeGesture-leave.swipeGesture-leave-active {\n  -webkit-transform: translate3d(0px, 0px, 0px);\n          transform: translate3d(0px, 0px, 0px);\n  -webkit-transition: all 500ms ease-out;\n  -o-transition: all 500ms ease-out;\n  transition: all 500ms ease-out;\n  opacity: 0;\n}\n\n.swipeGesture-appear {\n  -webkit-transform: translate3d(0px, 0px, 0px);\n          transform: translate3d(0px, 0px, 0px);\n  -webkit-transition: all 500ms ease-in;\n  -o-transition: all 500ms ease-in;\n  transition: all 500ms ease-in;\n}\n\n.swipeGesture-appear.swipeGesture-appear-active {\n  -webkit-transform: translate3d(100px, 0px, 0px);\n          transform: translate3d(100px, 0px, 0px);\n  -webkit-transition: all 500ms ease-in;\n  -o-transition: all 500ms ease-in;\n  transition: all 500ms ease-in;\n}\n\n.tryon:disabled {\n  color: #eee !important;\n  border-color: #eee !important;\n}\n", ""]);

// exports


/***/ }),
/* 65 */
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function(useSourceMap) {
	var list = [];

	// return the list of modules as css string
	list.toString = function toString() {
		return this.map(function (item) {
			var content = cssWithMappingToString(item, useSourceMap);
			if(item[2]) {
				return "@media " + item[2] + "{" + content + "}";
			} else {
				return content;
			}
		}).join("");
	};

	// import a list of modules into the list
	list.i = function(modules, mediaQuery) {
		if(typeof modules === "string")
			modules = [[null, modules, ""]];
		var alreadyImportedModules = {};
		for(var i = 0; i < this.length; i++) {
			var id = this[i][0];
			if(typeof id === "number")
				alreadyImportedModules[id] = true;
		}
		for(i = 0; i < modules.length; i++) {
			var item = modules[i];
			// skip already imported module
			// this implementation is not 100% perfect for weird media query combinations
			//  when a module is imported multiple times with different media queries.
			//  I hope this will never occur (Hey this way we have smaller bundles)
			if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
				if(mediaQuery && !item[2]) {
					item[2] = mediaQuery;
				} else if(mediaQuery) {
					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
				}
				list.push(item);
			}
		}
	};
	return list;
};

function cssWithMappingToString(item, useSourceMap) {
	var content = item[1] || '';
	var cssMapping = item[3];
	if (!cssMapping) {
		return content;
	}

	if (useSourceMap && typeof btoa === 'function') {
		var sourceMapping = toComment(cssMapping);
		var sourceURLs = cssMapping.sources.map(function (source) {
			return '/*# sourceURL=' + cssMapping.sourceRoot + source + ' */'
		});

		return [content].concat(sourceURLs).concat([sourceMapping]).join('\n');
	}

	return [content].join('\n');
}

// Adapted from convert-source-map (MIT)
function toComment(sourceMap) {
	// eslint-disable-next-line no-undef
	var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap))));
	var data = 'sourceMappingURL=data:application/json;charset=utf-8;base64,' + base64;

	return '/*# ' + data + ' */';
}


/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/

var stylesInDom = {};

var	memoize = function (fn) {
	var memo;

	return function () {
		if (typeof memo === "undefined") memo = fn.apply(this, arguments);
		return memo;
	};
};

var isOldIE = memoize(function () {
	// Test for IE <= 9 as proposed by Browserhacks
	// @see http://browserhacks.com/#hack-e71d8692f65334173fee715c222cb805
	// Tests for existence of standard globals is to allow style-loader
	// to operate correctly into non-standard environments
	// @see https://github.com/webpack-contrib/style-loader/issues/177
	return window && document && document.all && !window.atob;
});

var getElement = (function (fn) {
	var memo = {};

	return function(selector) {
		if (typeof memo[selector] === "undefined") {
			var styleTarget = fn.call(this, selector);
			// Special case to return head of iframe instead of iframe itself
			if (styleTarget instanceof window.HTMLIFrameElement) {
				try {
					// This will throw an exception if access to iframe is blocked
					// due to cross-origin restrictions
					styleTarget = styleTarget.contentDocument.head;
				} catch(e) {
					styleTarget = null;
				}
			}
			memo[selector] = styleTarget;
		}
		return memo[selector]
	};
})(function (target) {
	return document.querySelector(target)
});

var singleton = null;
var	singletonCounter = 0;
var	stylesInsertedAtTop = [];

var	fixUrls = __webpack_require__(67);

module.exports = function(list, options) {
	if (typeof DEBUG !== "undefined" && DEBUG) {
		if (typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
	}

	options = options || {};

	options.attrs = typeof options.attrs === "object" ? options.attrs : {};

	// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
	// tags it will allow on a page
	if (!options.singleton) options.singleton = isOldIE();

	// By default, add <style> tags to the <head> element
	if (!options.insertInto) options.insertInto = "head";

	// By default, add <style> tags to the bottom of the target
	if (!options.insertAt) options.insertAt = "bottom";

	var styles = listToStyles(list, options);

	addStylesToDom(styles, options);

	return function update (newList) {
		var mayRemove = [];

		for (var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];

			domStyle.refs--;
			mayRemove.push(domStyle);
		}

		if(newList) {
			var newStyles = listToStyles(newList, options);
			addStylesToDom(newStyles, options);
		}

		for (var i = 0; i < mayRemove.length; i++) {
			var domStyle = mayRemove[i];

			if(domStyle.refs === 0) {
				for (var j = 0; j < domStyle.parts.length; j++) domStyle.parts[j]();

				delete stylesInDom[domStyle.id];
			}
		}
	};
};

function addStylesToDom (styles, options) {
	for (var i = 0; i < styles.length; i++) {
		var item = styles[i];
		var domStyle = stylesInDom[item.id];

		if(domStyle) {
			domStyle.refs++;

			for(var j = 0; j < domStyle.parts.length; j++) {
				domStyle.parts[j](item.parts[j]);
			}

			for(; j < item.parts.length; j++) {
				domStyle.parts.push(addStyle(item.parts[j], options));
			}
		} else {
			var parts = [];

			for(var j = 0; j < item.parts.length; j++) {
				parts.push(addStyle(item.parts[j], options));
			}

			stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
		}
	}
}

function listToStyles (list, options) {
	var styles = [];
	var newStyles = {};

	for (var i = 0; i < list.length; i++) {
		var item = list[i];
		var id = options.base ? item[0] + options.base : item[0];
		var css = item[1];
		var media = item[2];
		var sourceMap = item[3];
		var part = {css: css, media: media, sourceMap: sourceMap};

		if(!newStyles[id]) styles.push(newStyles[id] = {id: id, parts: [part]});
		else newStyles[id].parts.push(part);
	}

	return styles;
}

function insertStyleElement (options, style) {
	var target = getElement(options.insertInto)

	if (!target) {
		throw new Error("Couldn't find a style target. This probably means that the value for the 'insertInto' parameter is invalid.");
	}

	var lastStyleElementInsertedAtTop = stylesInsertedAtTop[stylesInsertedAtTop.length - 1];

	if (options.insertAt === "top") {
		if (!lastStyleElementInsertedAtTop) {
			target.insertBefore(style, target.firstChild);
		} else if (lastStyleElementInsertedAtTop.nextSibling) {
			target.insertBefore(style, lastStyleElementInsertedAtTop.nextSibling);
		} else {
			target.appendChild(style);
		}
		stylesInsertedAtTop.push(style);
	} else if (options.insertAt === "bottom") {
		target.appendChild(style);
	} else if (typeof options.insertAt === "object" && options.insertAt.before) {
		var nextSibling = getElement(options.insertInto + " " + options.insertAt.before);
		target.insertBefore(style, nextSibling);
	} else {
		throw new Error("[Style Loader]\n\n Invalid value for parameter 'insertAt' ('options.insertAt') found.\n Must be 'top', 'bottom', or Object.\n (https://github.com/webpack-contrib/style-loader#insertat)\n");
	}
}

function removeStyleElement (style) {
	if (style.parentNode === null) return false;
	style.parentNode.removeChild(style);

	var idx = stylesInsertedAtTop.indexOf(style);
	if(idx >= 0) {
		stylesInsertedAtTop.splice(idx, 1);
	}
}

function createStyleElement (options) {
	var style = document.createElement("style");

	options.attrs.type = "text/css";

	addAttrs(style, options.attrs);
	insertStyleElement(options, style);

	return style;
}

function createLinkElement (options) {
	var link = document.createElement("link");

	options.attrs.type = "text/css";
	options.attrs.rel = "stylesheet";

	addAttrs(link, options.attrs);
	insertStyleElement(options, link);

	return link;
}

function addAttrs (el, attrs) {
	Object.keys(attrs).forEach(function (key) {
		el.setAttribute(key, attrs[key]);
	});
}

function addStyle (obj, options) {
	var style, update, remove, result;

	// If a transform function was defined, run it on the css
	if (options.transform && obj.css) {
	    result = options.transform(obj.css);

	    if (result) {
	    	// If transform returns a value, use that instead of the original css.
	    	// This allows running runtime transformations on the css.
	    	obj.css = result;
	    } else {
	    	// If the transform function returns a falsy value, don't add this css.
	    	// This allows conditional loading of css
	    	return function() {
	    		// noop
	    	};
	    }
	}

	if (options.singleton) {
		var styleIndex = singletonCounter++;

		style = singleton || (singleton = createStyleElement(options));

		update = applyToSingletonTag.bind(null, style, styleIndex, false);
		remove = applyToSingletonTag.bind(null, style, styleIndex, true);

	} else if (
		obj.sourceMap &&
		typeof URL === "function" &&
		typeof URL.createObjectURL === "function" &&
		typeof URL.revokeObjectURL === "function" &&
		typeof Blob === "function" &&
		typeof btoa === "function"
	) {
		style = createLinkElement(options);
		update = updateLink.bind(null, style, options);
		remove = function () {
			removeStyleElement(style);

			if(style.href) URL.revokeObjectURL(style.href);
		};
	} else {
		style = createStyleElement(options);
		update = applyToTag.bind(null, style);
		remove = function () {
			removeStyleElement(style);
		};
	}

	update(obj);

	return function updateStyle (newObj) {
		if (newObj) {
			if (
				newObj.css === obj.css &&
				newObj.media === obj.media &&
				newObj.sourceMap === obj.sourceMap
			) {
				return;
			}

			update(obj = newObj);
		} else {
			remove();
		}
	};
}

var replaceText = (function () {
	var textStore = [];

	return function (index, replacement) {
		textStore[index] = replacement;

		return textStore.filter(Boolean).join('\n');
	};
})();

function applyToSingletonTag (style, index, remove, obj) {
	var css = remove ? "" : obj.css;

	if (style.styleSheet) {
		style.styleSheet.cssText = replaceText(index, css);
	} else {
		var cssNode = document.createTextNode(css);
		var childNodes = style.childNodes;

		if (childNodes[index]) style.removeChild(childNodes[index]);

		if (childNodes.length) {
			style.insertBefore(cssNode, childNodes[index]);
		} else {
			style.appendChild(cssNode);
		}
	}
}

function applyToTag (style, obj) {
	var css = obj.css;
	var media = obj.media;

	if(media) {
		style.setAttribute("media", media)
	}

	if(style.styleSheet) {
		style.styleSheet.cssText = css;
	} else {
		while(style.firstChild) {
			style.removeChild(style.firstChild);
		}

		style.appendChild(document.createTextNode(css));
	}
}

function updateLink (link, options, obj) {
	var css = obj.css;
	var sourceMap = obj.sourceMap;

	/*
		If convertToAbsoluteUrls isn't defined, but sourcemaps are enabled
		and there is no publicPath defined then lets turn convertToAbsoluteUrls
		on by default.  Otherwise default to the convertToAbsoluteUrls option
		directly
	*/
	var autoFixUrls = options.convertToAbsoluteUrls === undefined && sourceMap;

	if (options.convertToAbsoluteUrls || autoFixUrls) {
		css = fixUrls(css);
	}

	if (sourceMap) {
		// http://stackoverflow.com/a/26603875
		css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
	}

	var blob = new Blob([css], { type: "text/css" });

	var oldSrc = link.href;

	link.href = URL.createObjectURL(blob);

	if(oldSrc) URL.revokeObjectURL(oldSrc);
}


/***/ }),
/* 67 */
/***/ (function(module, exports) {


/**
 * When source maps are enabled, `style-loader` uses a link element with a data-uri to
 * embed the css on the page. This breaks all relative urls because now they are relative to a
 * bundle instead of the current page.
 *
 * One solution is to only use full urls, but that may be impossible.
 *
 * Instead, this function "fixes" the relative urls to be absolute according to the current page location.
 *
 * A rudimentary test suite is located at `test/fixUrls.js` and can be run via the `npm test` command.
 *
 */

module.exports = function (css) {
  // get current location
  var location = typeof window !== "undefined" && window.location;

  if (!location) {
    throw new Error("fixUrls requires window.location");
  }

	// blank or null?
	if (!css || typeof css !== "string") {
	  return css;
  }

  var baseUrl = location.protocol + "//" + location.host;
  var currentDir = baseUrl + location.pathname.replace(/\/[^\/]*$/, "/");

	// convert each url(...)
	/*
	This regular expression is just a way to recursively match brackets within
	a string.

	 /url\s*\(  = Match on the word "url" with any whitespace after it and then a parens
	   (  = Start a capturing group
	     (?:  = Start a non-capturing group
	         [^)(]  = Match anything that isn't a parentheses
	         |  = OR
	         \(  = Match a start parentheses
	             (?:  = Start another non-capturing groups
	                 [^)(]+  = Match anything that isn't a parentheses
	                 |  = OR
	                 \(  = Match a start parentheses
	                     [^)(]*  = Match anything that isn't a parentheses
	                 \)  = Match a end parentheses
	             )  = End Group
              *\) = Match anything and then a close parens
          )  = Close non-capturing group
          *  = Match anything
       )  = Close capturing group
	 \)  = Match a close parens

	 /gi  = Get all matches, not the first.  Be case insensitive.
	 */
	var fixedCss = css.replace(/url\s*\(((?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*)\)/gi, function(fullMatch, origUrl) {
		// strip quotes (if they exist)
		var unquotedOrigUrl = origUrl
			.trim()
			.replace(/^"(.*)"$/, function(o, $1){ return $1; })
			.replace(/^'(.*)'$/, function(o, $1){ return $1; });

		// already a full url? no change
		if (/^(#|data:|http:\/\/|https:\/\/|file:\/\/\/)/i.test(unquotedOrigUrl)) {
		  return fullMatch;
		}

		// convert the url to a full url
		var newUrl;

		if (unquotedOrigUrl.indexOf("//") === 0) {
		  	//TODO: should we add protocol?
			newUrl = unquotedOrigUrl;
		} else if (unquotedOrigUrl.indexOf("/") === 0) {
			// path should be relative to the base url
			newUrl = baseUrl + unquotedOrigUrl; // already starts with '/'
		} else {
			// path should be relative to current directory
			newUrl = currentDir + unquotedOrigUrl.replace(/^\.\//, ""); // Strip leading './'
		}

		// send back the fixed url(...)
		return "url(" + JSON.stringify(newUrl) + ")";
	});

	// send back the fixed css
	return fixedCss;
};


/***/ }),
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_addons_css_transition_group__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_addons_css_transition_group___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_addons_css_transition_group__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_polyglot__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_polyglot___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_polyglot__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__translations__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_instore_Footer__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_instore_Header__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_instore_Page__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_instore_MainButton__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_instore_Introduction__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_instore_WeatherWidget__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_instore_SkinAnalysisWidget__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_instore_NextPageButton__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_instore_DarkButton__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_instore_Questions__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_instore_QuestionGender__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_instore_SelfieInstructions__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_instore_Selfie__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_instore_SdkRenderContainer__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_instore_Progressbar__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_instore_Products__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_instore_SecondaryNav__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_instore_ProductDetails__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_instore_ProductFilterButtons__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_instore_SwipeGesture__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_instore_ProductFilters__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_instore_ShareButton__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_instore_SkinAnalysisWarningsWidget__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_instore_LiveAR__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__components_instore_ActionsWidget__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__AppConf__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__utils__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_react_router_dom__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__revieve_sdk__ = __webpack_require__(229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__revieve_sdk___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32__revieve_sdk__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__services_ApiCom__ = __webpack_require__(230);
var _jsx=function(){var REACT_ELEMENT_TYPE=typeof Symbol==="function"&&Symbol.for&&Symbol.for("react.element")||0xeac7;return function createRawReactElement(type,props,key,children){var defaultProps=type&&type.defaultProps;var childrenLength=arguments.length-3;if(!props&&childrenLength!==0){props={};}if(props&&defaultProps){for(var propName in defaultProps){if(props[propName]===void 0){props[propName]=defaultProps[propName];}}}else if(!props){props=defaultProps||{};}if(childrenLength===1){props.children=children;}else if(childrenLength>1){var childArray=Array(childrenLength);for(var i=0;i<childrenLength;i++){childArray[i]=arguments[i+3];}props.children=childArray;}return{$$typeof:REACT_ELEMENT_TYPE,type:type,key:key===undefined?null:''+key,ref:null,props:props,_owner:null};};}();var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// Mapping of component name strings (used in the backend conf) to real
// react components
var ISComponentMapping={is_mainbutton:__WEBPACK_IMPORTED_MODULE_7__components_instore_MainButton__["a" /* default */],is_introduction:__WEBPACK_IMPORTED_MODULE_8__components_instore_Introduction__["a" /* default */],is_nextpagebutton:__WEBPACK_IMPORTED_MODULE_11__components_instore_NextPageButton__["a" /* default */],is_darkbutton:__WEBPACK_IMPORTED_MODULE_12__components_instore_DarkButton__["a" /* default */],is_selfie_intructions:__WEBPACK_IMPORTED_MODULE_15__components_instore_SelfieInstructions__["a" /* default */],is_selfie:__WEBPACK_IMPORTED_MODULE_16__components_instore_Selfie__["a" /* default */],is_questions:__WEBPACK_IMPORTED_MODULE_13__components_instore_Questions__["a" /* default */],is_questiongender:__WEBPACK_IMPORTED_MODULE_14__components_instore_QuestionGender__["a" /* default */],is_analysis:__WEBPACK_IMPORTED_MODULE_17__components_instore_SdkRenderContainer__["b" /* SdkRenderContainerForAnalysis */],is_arview:__WEBPACK_IMPORTED_MODULE_17__components_instore_SdkRenderContainer__["a" /* SdkRenderContainer */],is_productdetails:__WEBPACK_IMPORTED_MODULE_21__components_instore_ProductDetails__["a" /* default */],isw_weather:__WEBPACK_IMPORTED_MODULE_9__components_instore_WeatherWidget__["a" /* default */],isw_skinanalysis:__WEBPACK_IMPORTED_MODULE_10__components_instore_SkinAnalysisWidget__["a" /* default */],isw_skinanalysiswarnings:__WEBPACK_IMPORTED_MODULE_26__components_instore_SkinAnalysisWarningsWidget__["a" /* default */],isw_progress:__WEBPACK_IMPORTED_MODULE_18__components_instore_Progressbar__["a" /* default */],isw_products:__WEBPACK_IMPORTED_MODULE_19__components_instore_Products__["a" /* default */],isw_actions:__WEBPACK_IMPORTED_MODULE_28__components_instore_ActionsWidget__["a" /* default */],is_filterbuttons:__WEBPACK_IMPORTED_MODULE_22__components_instore_ProductFilterButtons__["a" /* default */],is_secondnav:__WEBPACK_IMPORTED_MODULE_20__components_instore_SecondaryNav__["a" /* default */],is_swipegestureicon:__WEBPACK_IMPORTED_MODULE_23__components_instore_SwipeGesture__["a" /* default */],is_productfilters:__WEBPACK_IMPORTED_MODULE_24__components_instore_ProductFilters__["a" /* default */],is_sharebutton:__WEBPACK_IMPORTED_MODULE_25__components_instore_ShareButton__["a" /* default */]};var App=function(_Component){_inherits(App,_Component);function App(props){_classCallCheck(this,App);var _this=_possibleConstructorReturn(this,(App.__proto__||Object.getPrototypeOf(App)).call(this,props));_this.componentWillMount=function(){_this.initializeSDK();};_this.initializeSDK=function(){var _this$state=_this.state,apiCom=_this$state.apiCom,revieveConfig=_this$state.revieveConfig;apiCom.getPluginConfig(revieveConfig.partnerId,revieveConfig.environment).then(function(config){var revieveSDK=void 0;if(!revieveConfig.environment){revieveSDK=new __WEBPACK_IMPORTED_MODULE_32__revieve_sdk___default.a(revieveConfig.partnerId);}else{revieveSDK=new __WEBPACK_IMPORTED_MODULE_32__revieve_sdk___default.a(revieveConfig.partnerId,false,revieveConfig.environment);}revieveSDK.setUserId(__WEBPACK_IMPORTED_MODULE_29__AppConf__["c" /* user_id */]);revieveSDK.setApiVersion(''+config.results.cvApiVersion);var components=['eyes','wrinkles','redness','hyperpigmentation','texture','smoothness','makeup','masks','wrinkles_visualization','hyperpigmentation_visualization','shine','shine_visualization','acne','acne_visualization'];revieveSDK.setConfiguration({components:components});revieveSDK.setMatchToSkintoneCategories(['Foundation','Concealer']);var mergedMessages=Object(__WEBPACK_IMPORTED_MODULE_30__utils__["g" /* mergeDeep */])({},__WEBPACK_IMPORTED_MODULE_3__translations__["a" /* default */],config.translation);var locale=mergedMessages.hasOwnProperty(revieveConfig.locale)?revieveConfig.locale:'en';_this.setState({config:config,sdk:revieveSDK,translatedMessages:mergedMessages[locale],pricegroup:_this.getLastPriceGroupElement({config:config})});}).catch(function(error){console.error(error);});};_this.triggerCallback=function(_ref){var callback=_ref.callback,payload=_ref.payload;var _this$state$revieveCo=_this.state.revieveConfig,onPageChange=_this$state$revieveCo.onPageChange,onRetakeSelfie=_this$state$revieveCo.onRetakeSelfie,onDisplayProducts=_this$state$revieveCo.onDisplayProducts,onImageAnalysisFinished=_this$state$revieveCo.onImageAnalysisFinished,onFetchProducts=_this$state$revieveCo.onFetchProducts,onChangePriceGroup=_this$state$revieveCo.onChangePriceGroup,onAction=_this$state$revieveCo.onAction,onChangeFilter=_this$state$revieveCo.onChangeFilter;switch(callback){case'pageChange':if(onPageChange&&typeof onPageChange==='function')onPageChange(payload.index,payload.name,payload.url);break;case'retakeSelfie':if(onRetakeSelfie&&typeof onRetakeSelfie==='function')onRetakeSelfie();break;case'displayProducts':if(onDisplayProducts&&typeof onDisplayProducts==='function')onDisplayProducts(payload);break;case'imageAnalysisFinished':if(onImageAnalysisFinished&&typeof onImageAnalysisFinished==='function')onImageAnalysisFinished(payload);break;case'fetchProducts':if(onFetchProducts&&typeof onFetchProducts==='function')onFetchProducts(payload);break;case'changePriceGroup':if(onChangePriceGroup&&typeof onChangePriceGroup==='function')onChangePriceGroup(payload);break;case'action':if(onAction&&typeof onAction==='function')onAction(payload);break;case'changeFilter':if(onChangeFilter&&typeof onChangeFilter==='function')onChangeFilter(payload);break;default:break;}};_this.getLastPriceGroupElement=function(_ref2){var config=_ref2.config;var priceGroups=Object.keys(config.results&&config.results.priceGroups&&config.results.priceGroups.default||{});return priceGroups[priceGroups.length-1];};_this.setPriceGroup=function(pricegroup){_this.triggerCallback({callback:'changePriceGroup',payload:pricegroup});_this.setState({pricegroup:pricegroup,footerMinimized:false});};_this.focusOnSkinFinding=function(focusOn,data,ranges){var containerId=_this.state.containerId;if(!containerId)return;var focusOnConfiguration=__WEBPACK_IMPORTED_MODULE_30__utils__["f" /* inStoreIconSetup */][focusOn];if(!_this.state.dragging&&containerId&&focusOnConfiguration&&focusOnConfiguration.sdkMethod||focusOn==='reset'||_this.state.firstTimeSkinAnalysisPage){if(focusOn===_this.state.skinanalysis.focusOn||focusOn==='reset'){_this.state.sdk.AR.dehighlightAll().then(function(animation){_this.setState({ARAnimation:animation.out});});}else{_this.state.sdk.AR.dehighlightAll().then(function(){_this.state.sdk.AR[focusOnConfiguration.sdkMethod](ranges).then(function(animation){if(focusOnConfiguration.zoom){_this.setState({ARAnimation:animation.in});}else{_this.setState({ARAnimation:{transform:'rotate(0deg) translate3d(0px, 0px, 0px) scale(1)',transformOrigin:'center center',transition:'all 1s ease-in-out'}});}});});}}if(!_this.state.dragging||focusOn==='reset'||_this.state.firstTimeSkinAnalysisPage){if(focusOn==='reset'||focusOn===_this.state.skinanalysis.focusOn){_this.setState({skinanalysis:{focusOn:null,data:{}}});}else{_this.setState({skinanalysis:{focusOn:focusOn,data:data}});}}else{console.log('dragging!!');}};_this.setDrag=function(boolean){if(_this.state.dragging===boolean){return;}_this.setState({dragging:boolean,footerMinimized:false});};_this.setFooterVisible=function(visible){return _this.setState({footerVisible:visible});};_this.showProductDetails=function(product){if(_this.state.footerMinimized){_this.setState({footerMinimized:false});}else{if(!_this.state.dragging){_this.setState({selectedProduct:product});}}};_this.showTryOn=function(product){var _this$state2=_this.state,sdk=_this$state2.sdk,filters=_this$state2.filters;var takeOff=false;if(!_this.state.dragging){var selectedProductsForTryOn=Object.assign({},_this.state.selectedProductsForTryOn);if(selectedProductsForTryOn.hasOwnProperty(product.category)){if(selectedProductsForTryOn[product.category].id===product.id){// toggle
delete selectedProductsForTryOn[product.category];takeOff=true;}else{//  switch product for this category
selectedProductsForTryOn[product.category]=product;}}else{// set product for this category
selectedProductsForTryOn[product.category]=product;}if(takeOff){if(sdk.liveAR.mounted){var effectConfiguration={};effectConfiguration[product.category.toLowerCase()]={enabled:false};sdk.liveAR.changeEffects(effectConfiguration);}else{sdk.AR.visualizeProduct(product,0);}}else{if(sdk.liveAR.mounted){var _effectConfiguration={};_effectConfiguration[product.category.toLowerCase()]={enabled:true,color:Object(__WEBPACK_IMPORTED_MODULE_30__utils__["b" /* converProductColorToRGB */])({product:product}),finish:Object(__WEBPACK_IMPORTED_MODULE_30__utils__["e" /* getFinishFromProduct */])({product:product})};if(product.category==='Foundation'){_effectConfiguration[product.category.toLowerCase()].coverage=Object(__WEBPACK_IMPORTED_MODULE_30__utils__["d" /* getCoverageFromProduct */])({product:product,filters:filters,mode:'liveAR'});}sdk.liveAR.changeEffects(_effectConfiguration);}else{if(product.category==='Foundation'){sdk.AR.visualizeProduct(product,Object(__WEBPACK_IMPORTED_MODULE_30__utils__["d" /* getCoverageFromProduct */])({product:product,filters:filters,mode:'AR'}));}else{sdk.AR.visualizeProduct(product);}}}_this.setState({selectedProductsForTryOn:selectedProductsForTryOn,footerMinimized:!takeOff});}};_this.closeProductDetails=function(){_this.setState({selectedProduct:null});};_this.fetchProducts=function(){// we need to set all the filters value to the sdk
var _this$state3=_this.state,filters=_this$state3.filters,sdk=_this$state3.sdk;var filtersMergedWithOptions=filters;if(_this.state.config.results.filters){filtersMergedWithOptions=_extends({},filters,_this.state.config.results.filters);}// Regimen management
var regimen=void 0;if(_this.state.config.categories.hasOwnProperty('regimen')){var skinType=Object(__WEBPACK_IMPORTED_MODULE_30__utils__["c" /* findSkintypeFromFilters */])(_this.state.filters);if(skinType){regimen=_this.state.config.categories.regimen[skinType.replace('_skin_ui','_skin')];}}// Set filter values to SDK and fetch products
var categoriesSettedByRegimen=false;for(var filter in filtersMergedWithOptions){if(filtersMergedWithOptions.hasOwnProperty(filter)){var value=filtersMergedWithOptions[filter];if(filter==='requiredTags'){for(var requiredTagKey in value){if(value.hasOwnProperty(requiredTagKey)){var requiredTagValue=value[requiredTagKey];sdk.setCustomAttribute(requiredTagKey,requiredTagValue>0?true:false,true);}}}else{sdk.setCustomAttribute(filter,value);}// regimen categories are more imporntant than general categories
if(regimen&&filter==='requiredTags'){for(var _requiredTagKey in value){if(value.hasOwnProperty(_requiredTagKey)){var _requiredTagValue=value[_requiredTagKey];if(_requiredTagValue>0){sdk.setCategories(regimen[_requiredTagKey]);}}}}else if(regimen&&regimen[filter]&&value>0){sdk.setCategories(regimen[filter]);categoriesSettedByRegimen=true;}else if(!categoriesSettedByRegimen&&_this.state.config.categories&&_this.state.config.categories[value]){sdk.setCategories(_this.state.config.categories[value]);}}}if(_this.state.config.results.priceGroups){sdk.setCustomAttribute('priceGroups',_this.state.config.results.priceGroups);}_this.setState({products:{},loadingProducts:true,footerMinimized:false});_this.triggerCallback({callback:'fetchProducts',payload:sdk.getConfiguration()});try{sdk.PR.getRecommendedProducts().then(function(products){_this.setState({products:products,loadingProducts:false,regimen:regimen});}).catch(function(error){console.log(error);});//RevieveActions.fetchResults(true);
}catch(e){console.log(e);}};_this.analyzeImage=function(image,skintone){var sdk=_this.state.sdk;sdk.setSkintone(skintone);sdk.CV.setImage(image).then(function(){sdk.CV.analyzeImage().then(function(){_this.setState({sdkCVState:sdk.CV.getState()});_this.triggerCallback({callback:'imageAnalysisFinished',payload:sdk.CV.getResults()});}).catch(function(){console.error('Error processing image');_this.setState({sdkCVState:sdk.CV.getState()});_this.triggerCallback({callback:'imageAnalysisFinished',payload:sdk.CV.getResults()});});});};_this.setContainer=function(containerId){var sdk=_this.state.sdk;sdk.AR.setContainer(containerId);_this.setState({containerId:containerId});};_this.renderInitialImage=function(containerId){var sdk=_this.state.sdk;sdk.AR.setContainer(containerId);_this.setState({containerId:containerId});sdk.AR.reset();// we need to apply an initial effect to render image in container
sdk.AR.reduceEyebags(0).catch(function(){});};_this.getSdkSkintone=function(){var sdk=_this.state.sdk;return sdk.getSkintone();};_this.canVisualizeProduct=function(product){var sdk=_this.state.sdk;return sdk.AR.canVisualizeProduct(product);};_this.nextPage=function(currentIndex,history){if(currentIndex+1>=_this.state.config.pages.length){console.warn('already on the last page.');}else{_this.triggerCallback({callback:'pageChange',payload:{index:currentIndex+1,name:_this.state.config.pages[currentIndex+1].name,url:_this.state.config.pages[currentIndex+1].url}});if(_this.state.config.pages[currentIndex+1].url==='/recommendations'&&_this.state.skinanalysis.focusOn){// if we hava a finding highlight we need to dehighlight before continue
_this.state.sdk.AR.dehighlightAll().then(function(animation){_this.setState({ARAnimation:animation.out,skinanalysis:{focusOn:null,data:{}},footerMinimized:false,footerVisible:true},function(){var url=_this.state.config.pages[(currentIndex+1)%_this.state.config.pages.length].url;setTimeout(function(){return history.push(url);},1000);});});}else{var url=_this.state.config.pages[(currentIndex+1)%_this.state.config.pages.length].url;_this.setState({footerMinimized:false});history.push(url);}}};_this.toggleFilter=function(key,value,componentFilters,multiSelect,autoAdvance,nextPageFn,root){var getProducts=arguments.length>7&&arguments[7]!==undefined?arguments[7]:false;var sdk=_this.state.sdk;var filters=void 0;if(root){filters=Object.assign({},_this.state.filters[root]);}else{filters=Object.assign({},_this.state.filters);}// If the component is not multiselect, go through filters and remove all
// componentFilters from previously set filters
if(!multiSelect){var _iteratorNormalCompletion=true;var _didIteratorError=false;var _iteratorError=undefined;try{for(var _iterator=componentFilters[Symbol.iterator](),_step;!(_iteratorNormalCompletion=(_step=_iterator.next()).done);_iteratorNormalCompletion=true){var f=_step.value;if(f===key){continue;}if((typeof f==='undefined'?'undefined':_typeof(f))!=='object')filters[f]=0;}}catch(err){_didIteratorError=true;_iteratorError=err;}finally{try{if(!_iteratorNormalCompletion&&_iterator.return){_iterator.return();}}finally{if(_didIteratorError){throw _iteratorError;}}}}if(key==='gender_ui'){sdk.setGender(value);}filters[key]=value;if(filters.hasOwnProperty(key)&&autoAdvance&&nextPageFn){setTimeout(function(){nextPageFn();},400);}if(root){var rootfilters=Object.assign({},_this.state.filters);rootfilters[root]=filters;_this.setState({filters:rootfilters},function(){if(getProducts){_this.fetchProducts();}});}else{_this.setState({filters:filters},function(){if(getProducts){_this.fetchProducts();}});}};_this.hasMapping=function(componentSpec){var hasMapping=void 0;if((typeof componentSpec==='undefined'?'undefined':_typeof(componentSpec))==='object'){hasMapping=ISComponentMapping.hasOwnProperty(componentSpec.name);}else{hasMapping=ISComponentMapping.hasOwnProperty(componentSpec);}if(!hasMapping){console.warn('Not a Revieve component type: '+JSON.stringify(componentSpec));}return hasMapping;};_this.setSkinAnalysisPageRendered=function(){_this.setState({firstTimeSkinAnalysisPage:false});};_this.getComponent=function(componentSpec){var reactComponent=void 0;if((typeof componentSpec==='undefined'?'undefined':_typeof(componentSpec))==='object'){reactComponent=ISComponentMapping[componentSpec.name];}else{reactComponent=ISComponentMapping[componentSpec];}return reactComponent;};_this.findPageConfig=function(location){if(_this.state.config&&_this.state.config.pages){return _this.state.config.pages.findIndex(function(page){return page.url===location.pathname;});}};_this.createProgressWidget=function(page,index){if(page.footer&&page.footer.progress&&_this.hasMapping(page.footer.progress)){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(_this.getComponent(page.footer.progress),{key:'progress',activePage:index-1,pageCount:_this.state.config.pages.length});}else{return null;}};_this.createFooterWidgets=function(page,index){// widgets
var footerWidgets=void 0;if(page.footer&&page.footer.widgets){var availableWidgets=page.footer.widgets.filter(function(widget){return _this.hasMapping(widget);});footerWidgets=availableWidgets.map(function(widget,wi){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(_this.getComponent(widget),{key:wi,activePage:index-1,pageCount:_this.state.config.pages.length,showProductDetails:_this.showProductDetails,selectedProductsForTryOn:_this.state.selectedProductsForTryOn,showTryOn:_this.showTryOn,cvResults:_this.state.sdkCVState,focusOnSkinFinding:_this.focusOnSkinFinding,focusedOnSkinFinding:_this.state.skinanalysis.focusOn,setSkinAnalysisPageRendered:_this.setSkinAnalysisPageRendered,filters:_this.state.filters,products:_this.state.products,loadingProducts:_this.state.loadingProducts,pricegroup:_this.state.pricegroup,currency:_this.state.config.currency,options:widget,configOptions:_this.state.config,revieveConfig:_this.state.revieveConfig,setLat:function setLat(lat){return _this.state.sdk.setLat(lat);},setLon:function setLon(lon){return _this.state.sdk.setLon(lon);},ARMethods:{canVisualizeProduct:_this.canVisualizeProduct,visualizeProduct:_this.visualizeProduct,getSdkSkintone:_this.getSdkSkintone},defaultLocation:_this.props.revieveConfig.defaultLocation,triggerCallback:_this.triggerCallback});});}return footerWidgets;};_this.doINeedCameraBackgroud=function(pageConfig){return pageConfig.background&&pageConfig.background==='camera';};_this.render=function(){return _jsx('div',{},void 0,_this.state.translatedMessages&&_jsx(__WEBPACK_IMPORTED_MODULE_2_react_polyglot__["I18n"],{locale:_this.state.revieveConfig.locale||'en',messages:_this.state.translatedMessages},void 0,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_31_react_router_dom__["a" /* HashRouter */],{history:_this.props.history,ref:function ref(router){return _this.router=router;}},_jsx(__WEBPACK_IMPORTED_MODULE_31_react_router_dom__["b" /* Route */],{path:'/',onChange:_this.onNavigate,render:function render(_ref3){var location=_ref3.location;var pageIndex=_this.findPageConfig(location);var pageConfig=_this.state.config?_this.state.config.pages[pageIndex]:null;var headerConfig=_this.state.config&&_this.state.config.header?_this.state.config.header:null;return _jsx('div',{className:'rootWrapper'},void 0,_this.state.config&&_jsx('div',{},void 0,_this.doINeedCameraBackgroud(pageConfig)&&_jsx(__WEBPACK_IMPORTED_MODULE_16__components_instore_Selfie__["a" /* default */],{isBackground:true}),pageConfig.liveARMode&&_jsx(__WEBPACK_IMPORTED_MODULE_27__components_instore_LiveAR__["a" /* default */],{sdk:_this.state.sdk}),_jsx(__WEBPACK_IMPORTED_MODULE_1_react_addons_css_transition_group___default.a,{transitionName:'headerSlide',transitionAppear:false,transitionEnter:true,transitionLeave:true,transitionAppearTimeout:900,transitionLeaveTimeout:900,transitionEnterTimeout:900},void 0,pageConfig.header?_jsx(__WEBPACK_IMPORTED_MODULE_5__components_instore_Header__["a" /* default */],{pageIndex:pageIndex,headerConfig:headerConfig,navigation:pageConfig.header.navigation,navigationText:pageConfig.header.navigationText,startOver:function startOver(){_this.startOver(_this.history);},prevPage:function prevPage(){_this.prevPage(pageIndex,_this.history);}},'header'):null),_jsx(__WEBPACK_IMPORTED_MODULE_31_react_router_dom__["c" /* Switch */],{location:location},void 0,_this.state.config.pages.map(function(page,i){return _this.buildPage(page,i);})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_instore_Footer__["a" /* default */],_extends({setDrag:_this.setDrag,visible:pageConfig.footer&&!_this.state.selectedProduct&&_this.state.footerVisible,minimized:_this.state.footerMinimized,pageIndex:pageIndex,rootElement:_this.props.root,key:'footer',filters:_this.state.filters,pricegroup:_this.state.pricegroup},Object.assign({},pageConfig.footer,{widgets:_this.createFooterWidgets(pageConfig,pageIndex)},{progress:_this.createProgressWidget(pageConfig,pageIndex)})))));}}))));};_this.state={skinanalysis:{focusOn:null,data:{}},filters:{},apiCom:new __WEBPACK_IMPORTED_MODULE_33__services_ApiCom__["a" /* default */](),revieveConfig:props.revieveConfig,firstTimeSkinAnalysisPage:true,currentPageIndex:null,footerMinimized:false,footerVisible:true};return _this;}// navigate to next page
_createClass(App,[{key:'prevPage',// navigate to previous page
value:function prevPage(currentIndex,history){this.triggerCallback({callback:'pageChange',payload:{index:currentIndex-1,name:this.state.config.pages[currentIndex-1].name,url:this.state.config.pages[currentIndex-1].url}});var currentPageConfig=this.state.config?this.state.config.pages[currentIndex]:null;var prevPageConfig=this.state.config?this.state.config.pages[currentIndex-1]:null;var cleanSelectedProductsForTryOn=!currentPageConfig.liveARMode||!prevPageConfig.liveARMode;if(cleanSelectedProductsForTryOn){this.setState({selectedProductsForTryOn:{},footerMinimized:false,footerVisible:true});}else{this.setState({footerMinimized:false,footerVisible:true});}history.push(this.state.config.pages[(currentIndex-1)%this.state.config.pages.length].url);}},{key:'startOver',value:function startOver(history){this.triggerCallback({callback:'pageChange',payload:{index:0,name:'start page',url:'/'}});this.setState({filters:[],selectedProductsForTryOn:{},sdkCVState:null,ARAnimation:null,firstTimeSkinAnalysisPage:true,footerVisible:true});this.initializeSDK();//RevieveActions.clearUI();
history.push(this.state.config.pages[0].url);}},{key:'buildPage',// builds a page and it's route from page config
value:function buildPage(page,i){var _this2=this;// Only try to render components that have a mapping
var availableComponents=page.components.filter(function(component){return _this2.hasMapping(component);});// widgets
var footerWidgets=void 0;if(page.footer&&page.footer.widgets){var availableWidgets=page.footer.widgets.filter(function(widget){return _this2.hasMapping(widget);});footerWidgets=availableWidgets.map(function(widget,wi){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(_this2.getComponent(widget),{key:wi});});}return _jsx(__WEBPACK_IMPORTED_MODULE_31_react_router_dom__["b" /* Route */],{exact:true,path:page.url,render:function render(props){return _jsx(__WEBPACK_IMPORTED_MODULE_6__components_instore_Page__["a" /* default */],{nextPage:function nextPage(){_this2.nextPage(i,props.history);},prevPage:function prevPage(){_this2.prevPage(i,props.history);},startOver:function startOver(){_this2.startOver(props.history);},header:page.header,footer:Object.assign({},page.footer,{widgets:footerWidgets}),name:page.name,style:page.style,cameraBackground:_this2.doINeedCameraBackgroud(page),liveARMode:page.liveARMode,imageBackground:page.imageBackground,components:availableComponents.map(function(component,ci){// This one maps the component name strings into actual React
// classes using the ISComponentMapping
var reactComponent=_this2.getComponent(component);// NEXT LINE IS A MEGAHACK, TOO TIRED TO WRESTLE MORE TODAY.
// The Header gets wrong history unless we save it here to InStoreApp
// It baffles my mind to no end.
_this2.history=props.history;// Here we instantiate them as React elements so
// Page can just render the whole array.
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(reactComponent,{key:ci,selectedProduct:_this2.state.selectedProduct,closeProductDetails:_this2.closeProductDetails,selectedProductsForTryOn:_this2.state.selectedProductsForTryOn,cvResults:_this2.state.sdkCVState,routeProps:props,nextPage:function nextPage(){_this2.nextPage(i,props.history);},prevPage:function prevPage(){_this2.prevPage(i,props.history);},startOver:function startOver(){_this2.startOver(props.history);},filters:_this2.state.filters,toggleFilter:_this2.toggleFilter,options:(typeof component==='undefined'?'undefined':_typeof(component))==='object'?component:null,configOptions:_this2.state.config,focusedOnSkinFinding:_this2.state.skinanalysis.focusOn,focusOnSkinFinding:_this2.focusOnSkinFinding,setPriceGroup:_this2.setPriceGroup,pricegroup:_this2.state.pricegroup,products:_this2.state.products,regimen:_this2.state.regimen,fetchProducts:_this2.fetchProducts,analyzeImage:_this2.analyzeImage,ARAnimation:_this2.state.ARAnimation,ARMethods:{renderInitialImage:_this2.renderInitialImage},selfieInstructions:_this2.props.revieveConfig.selfieInstructions,setFooterVisible:_this2.setFooterVisible,sdk:_this2.state.sdk,triggerCallback:_this2.triggerCallback});})});}},i);}/* eslint react/display-name: "off" */}]);return App;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (App);

/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _TransitionGroup = __webpack_require__(72);

var _TransitionGroup2 = _interopRequireDefault(_TransitionGroup);

var _CSSTransitionGroupChild = __webpack_require__(76);

var _CSSTransitionGroupChild2 = _interopRequireDefault(_CSSTransitionGroupChild);

var _PropTypes = __webpack_require__(34);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var propTypes = {
  transitionName: _PropTypes.nameShape.isRequired,

  transitionAppear: _propTypes2.default.bool,
  transitionEnter: _propTypes2.default.bool,
  transitionLeave: _propTypes2.default.bool,
  transitionAppearTimeout: (0, _PropTypes.transitionTimeout)('Appear'),
  transitionEnterTimeout: (0, _PropTypes.transitionTimeout)('Enter'),
  transitionLeaveTimeout: (0, _PropTypes.transitionTimeout)('Leave')
};

var defaultProps = {
  transitionAppear: false,
  transitionEnter: true,
  transitionLeave: true
};

var CSSTransitionGroup = function (_React$Component) {
  _inherits(CSSTransitionGroup, _React$Component);

  function CSSTransitionGroup() {
    var _temp, _this, _ret;

    _classCallCheck(this, CSSTransitionGroup);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this._wrapChild = function (child) {
      return _react2.default.createElement(_CSSTransitionGroupChild2.default, {
        name: _this.props.transitionName,
        appear: _this.props.transitionAppear,
        enter: _this.props.transitionEnter,
        leave: _this.props.transitionLeave,
        appearTimeout: _this.props.transitionAppearTimeout,
        enterTimeout: _this.props.transitionEnterTimeout,
        leaveTimeout: _this.props.transitionLeaveTimeout
      }, child);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  // We need to provide this childFactory so that
  // ReactCSSTransitionGroupChild can receive updates to name, enter, and
  // leave while it is leaving.


  CSSTransitionGroup.prototype.render = function render() {
    return _react2.default.createElement(_TransitionGroup2.default, _extends({}, this.props, { childFactory: this._wrapChild }));
  };

  return CSSTransitionGroup;
}(_react2.default.Component);

CSSTransitionGroup.displayName = 'CSSTransitionGroup';


CSSTransitionGroup.propTypes =  false ? propTypes : {};
CSSTransitionGroup.defaultProps = defaultProps;

exports.default = CSSTransitionGroup;
module.exports = exports['default'];

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(71);

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _chainFunction = __webpack_require__(73);

var _chainFunction2 = _interopRequireDefault(_chainFunction);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _warning = __webpack_require__(74);

var _warning2 = _interopRequireDefault(_warning);

var _ChildMapping = __webpack_require__(75);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var propTypes = {
  component: _propTypes2.default.any,
  childFactory: _propTypes2.default.func,
  children: _propTypes2.default.node
};

var defaultProps = {
  component: 'span',
  childFactory: function childFactory(child) {
    return child;
  }
};

var TransitionGroup = function (_React$Component) {
  _inherits(TransitionGroup, _React$Component);

  function TransitionGroup(props, context) {
    _classCallCheck(this, TransitionGroup);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));

    _this.performAppear = function (key, component) {
      _this.currentlyTransitioningKeys[key] = true;

      if (component.componentWillAppear) {
        component.componentWillAppear(_this._handleDoneAppearing.bind(_this, key, component));
      } else {
        _this._handleDoneAppearing(key, component);
      }
    };

    _this._handleDoneAppearing = function (key, component) {
      if (component.componentDidAppear) {
        component.componentDidAppear();
      }

      delete _this.currentlyTransitioningKeys[key];

      var currentChildMapping = (0, _ChildMapping.getChildMapping)(_this.props.children);

      if (!currentChildMapping || !currentChildMapping.hasOwnProperty(key)) {
        // This was removed before it had fully appeared. Remove it.
        _this.performLeave(key, component);
      }
    };

    _this.performEnter = function (key, component) {
      _this.currentlyTransitioningKeys[key] = true;

      if (component.componentWillEnter) {
        component.componentWillEnter(_this._handleDoneEntering.bind(_this, key, component));
      } else {
        _this._handleDoneEntering(key, component);
      }
    };

    _this._handleDoneEntering = function (key, component) {
      if (component.componentDidEnter) {
        component.componentDidEnter();
      }

      delete _this.currentlyTransitioningKeys[key];

      var currentChildMapping = (0, _ChildMapping.getChildMapping)(_this.props.children);

      if (!currentChildMapping || !currentChildMapping.hasOwnProperty(key)) {
        // This was removed before it had fully entered. Remove it.
        _this.performLeave(key, component);
      }
    };

    _this.performLeave = function (key, component) {
      _this.currentlyTransitioningKeys[key] = true;

      if (component.componentWillLeave) {
        component.componentWillLeave(_this._handleDoneLeaving.bind(_this, key, component));
      } else {
        // Note that this is somewhat dangerous b/c it calls setState()
        // again, effectively mutating the component before all the work
        // is done.
        _this._handleDoneLeaving(key, component);
      }
    };

    _this._handleDoneLeaving = function (key, component) {
      if (component.componentDidLeave) {
        component.componentDidLeave();
      }

      delete _this.currentlyTransitioningKeys[key];

      var currentChildMapping = (0, _ChildMapping.getChildMapping)(_this.props.children);

      if (currentChildMapping && currentChildMapping.hasOwnProperty(key)) {
        // This entered again before it fully left. Add it again.
        _this.keysToEnter.push(key);
      } else {
        _this.setState(function (state) {
          var newChildren = _extends({}, state.children);
          delete newChildren[key];
          return { children: newChildren };
        });
      }
    };

    _this.childRefs = Object.create(null);

    _this.state = {
      children: (0, _ChildMapping.getChildMapping)(props.children)
    };
    return _this;
  }

  TransitionGroup.prototype.componentWillMount = function componentWillMount() {
    this.currentlyTransitioningKeys = {};
    this.keysToEnter = [];
    this.keysToLeave = [];
  };

  TransitionGroup.prototype.componentDidMount = function componentDidMount() {
    var initialChildMapping = this.state.children;
    for (var key in initialChildMapping) {
      if (initialChildMapping[key]) {
        this.performAppear(key, this.childRefs[key]);
      }
    }
  };

  TransitionGroup.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var nextChildMapping = (0, _ChildMapping.getChildMapping)(nextProps.children);
    var prevChildMapping = this.state.children;

    this.setState({
      children: (0, _ChildMapping.mergeChildMappings)(prevChildMapping, nextChildMapping)
    });

    for (var key in nextChildMapping) {
      var hasPrev = prevChildMapping && prevChildMapping.hasOwnProperty(key);
      if (nextChildMapping[key] && !hasPrev && !this.currentlyTransitioningKeys[key]) {
        this.keysToEnter.push(key);
      }
    }

    for (var _key in prevChildMapping) {
      var hasNext = nextChildMapping && nextChildMapping.hasOwnProperty(_key);
      if (prevChildMapping[_key] && !hasNext && !this.currentlyTransitioningKeys[_key]) {
        this.keysToLeave.push(_key);
      }
    }

    // If we want to someday check for reordering, we could do it here.
  };

  TransitionGroup.prototype.componentDidUpdate = function componentDidUpdate() {
    var _this2 = this;

    var keysToEnter = this.keysToEnter;
    this.keysToEnter = [];
    keysToEnter.forEach(function (key) {
      return _this2.performEnter(key, _this2.childRefs[key]);
    });

    var keysToLeave = this.keysToLeave;
    this.keysToLeave = [];
    keysToLeave.forEach(function (key) {
      return _this2.performLeave(key, _this2.childRefs[key]);
    });
  };

  TransitionGroup.prototype.render = function render() {
    var _this3 = this;

    // TODO: we could get rid of the need for the wrapper node
    // by cloning a single child
    var childrenToRender = [];

    var _loop = function _loop(key) {
      var child = _this3.state.children[key];
      if (child) {
        var isCallbackRef = typeof child.ref !== 'string';
        var factoryChild = _this3.props.childFactory(child);
        var ref = function ref(r) {
          _this3.childRefs[key] = r;
        };

         false ? (0, _warning2.default)(isCallbackRef, 'string refs are not supported on children of TransitionGroup and will be ignored. ' + 'Please use a callback ref instead: https://facebook.github.io/react/docs/refs-and-the-dom.html#the-ref-callback-attribute') : void 0;

        // Always chaining the refs leads to problems when the childFactory
        // wraps the child. The child ref callback gets called twice with the
        // wrapper and the child. So we only need to chain the ref if the
        // factoryChild is not different from child.
        if (factoryChild === child && isCallbackRef) {
          ref = (0, _chainFunction2.default)(child.ref, ref);
        }

        // You may need to apply reactive updates to a child as it is leaving.
        // The normal React way to do it won't work since the child will have
        // already been removed. In case you need this behavior you can provide
        // a childFactory function to wrap every child, even the ones that are
        // leaving.
        childrenToRender.push(_react2.default.cloneElement(factoryChild, {
          key: key,
          ref: ref
        }));
      }
    };

    for (var key in this.state.children) {
      _loop(key);
    }

    // Do not forward TransitionGroup props to primitive DOM nodes
    var props = _extends({}, this.props);
    delete props.transitionLeave;
    delete props.transitionName;
    delete props.transitionAppear;
    delete props.transitionEnter;
    delete props.childFactory;
    delete props.transitionLeaveTimeout;
    delete props.transitionEnterTimeout;
    delete props.transitionAppearTimeout;
    delete props.component;

    return _react2.default.createElement(this.props.component, props, childrenToRender);
  };

  return TransitionGroup;
}(_react2.default.Component);

TransitionGroup.displayName = 'TransitionGroup';


TransitionGroup.propTypes =  false ? propTypes : {};
TransitionGroup.defaultProps = defaultProps;

exports.default = TransitionGroup;
module.exports = exports['default'];

/***/ }),
/* 73 */
/***/ (function(module, exports) {


module.exports = function chain(){
  var len = arguments.length
  var args = [];

  for (var i = 0; i < len; i++)
    args[i] = arguments[i]

  args = args.filter(function(fn){ return fn != null })

  if (args.length === 0) return undefined
  if (args.length === 1) return args[0]

  return args.reduce(function(current, next){
    return function chainedFunction() {
      current.apply(this, arguments);
      next.apply(this, arguments);
    };
  })
}


/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = function() {};

if (false) {
  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
        '`warning(condition, format, ...args)` requires a warning ' +
        'message argument'
      );
    }

    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
      throw new Error(
        'The warning format should be able to uniquely identify this ' +
        'warning. Please, use a more descriptive format than: ' + format
      );
    }

    if (!condition) {
      var argIndex = 0;
      var message = 'Warning: ' +
        format.replace(/%s/g, function() {
          return args[argIndex++];
        });
      if (typeof console !== 'undefined') {
        console.error(message);
      }
      try {
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch(x) {}
    }
  };
}

module.exports = warning;


/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.getChildMapping = getChildMapping;
exports.mergeChildMappings = mergeChildMappings;

var _react = __webpack_require__(0);

/**
 * Given `this.props.children`, return an object mapping key to child.
 *
 * @param {*} children `this.props.children`
 * @return {object} Mapping of key to child
 */
function getChildMapping(children) {
  if (!children) {
    return children;
  }
  var result = {};
  _react.Children.map(children, function (child) {
    return child;
  }).forEach(function (child) {
    result[child.key] = child;
  });
  return result;
}

/**
 * When you're adding or removing children some may be added or removed in the
 * same render pass. We want to show *both* since we want to simultaneously
 * animate elements in and out. This function takes a previous set of keys
 * and a new set of keys and merges them with its best guess of the correct
 * ordering. In the future we may expose some of the utilities in
 * ReactMultiChild to make this easy, but for now React itself does not
 * directly have this concept of the union of prevChildren and nextChildren
 * so we implement it here.
 *
 * @param {object} prev prev children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @param {object} next next children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @return {object} a key set that contains all keys in `prev` and all keys
 * in `next` in a reasonable order.
 */
function mergeChildMappings(prev, next) {
  prev = prev || {};
  next = next || {};

  function getValueForKey(key) {
    if (next.hasOwnProperty(key)) {
      return next[key];
    }

    return prev[key];
  }

  // For each key of `next`, the list of keys to insert before that key in
  // the combined list
  var nextKeysPending = {};

  var pendingKeys = [];
  for (var prevKey in prev) {
    if (next.hasOwnProperty(prevKey)) {
      if (pendingKeys.length) {
        nextKeysPending[prevKey] = pendingKeys;
        pendingKeys = [];
      }
    } else {
      pendingKeys.push(prevKey);
    }
  }

  var i = void 0;
  var childMapping = {};
  for (var nextKey in next) {
    if (nextKeysPending.hasOwnProperty(nextKey)) {
      for (i = 0; i < nextKeysPending[nextKey].length; i++) {
        var pendingNextKey = nextKeysPending[nextKey][i];
        childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
      }
    }
    childMapping[nextKey] = getValueForKey(nextKey);
  }

  // Finally, add the keys which didn't appear before any key in `next`
  for (i = 0; i < pendingKeys.length; i++) {
    childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
  }

  return childMapping;
}

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _addClass = __webpack_require__(77);

var _addClass2 = _interopRequireDefault(_addClass);

var _removeClass = __webpack_require__(79);

var _removeClass2 = _interopRequireDefault(_removeClass);

var _requestAnimationFrame = __webpack_require__(80);

var _requestAnimationFrame2 = _interopRequireDefault(_requestAnimationFrame);

var _properties = __webpack_require__(81);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__(32);

var _PropTypes = __webpack_require__(34);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var events = [];
if (_properties.transitionEnd) events.push(_properties.transitionEnd);
if (_properties.animationEnd) events.push(_properties.animationEnd);

function addEndListener(node, listener) {
  if (events.length) {
    events.forEach(function (e) {
      return node.addEventListener(e, listener, false);
    });
  } else {
    setTimeout(listener, 0);
  }

  return function () {
    if (!events.length) return;
    events.forEach(function (e) {
      return node.removeEventListener(e, listener, false);
    });
  };
}

var propTypes = {
  children: _propTypes2.default.node,
  name: _PropTypes.nameShape.isRequired,

  // Once we require timeouts to be specified, we can remove the
  // boolean flags (appear etc.) and just accept a number
  // or a bool for the timeout flags (appearTimeout etc.)
  appear: _propTypes2.default.bool,
  enter: _propTypes2.default.bool,
  leave: _propTypes2.default.bool,
  appearTimeout: _propTypes2.default.number,
  enterTimeout: _propTypes2.default.number,
  leaveTimeout: _propTypes2.default.number
};

var CSSTransitionGroupChild = function (_React$Component) {
  _inherits(CSSTransitionGroupChild, _React$Component);

  function CSSTransitionGroupChild() {
    var _temp, _this, _ret;

    _classCallCheck(this, CSSTransitionGroupChild);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.componentWillAppear = function (done) {
      if (_this.props.appear) {
        _this.transition('appear', done, _this.props.appearTimeout);
      } else {
        done();
      }
    }, _this.componentWillEnter = function (done) {
      if (_this.props.enter) {
        _this.transition('enter', done, _this.props.enterTimeout);
      } else {
        done();
      }
    }, _this.componentWillLeave = function (done) {
      if (_this.props.leave) {
        _this.transition('leave', done, _this.props.leaveTimeout);
      } else {
        done();
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  CSSTransitionGroupChild.prototype.componentWillMount = function componentWillMount() {
    this.classNameAndNodeQueue = [];
    this.transitionTimeouts = [];
  };

  CSSTransitionGroupChild.prototype.componentWillUnmount = function componentWillUnmount() {
    this.unmounted = true;

    if (this.timeout) {
      clearTimeout(this.timeout);
    }
    this.transitionTimeouts.forEach(function (timeout) {
      clearTimeout(timeout);
    });

    this.classNameAndNodeQueue.length = 0;
  };

  CSSTransitionGroupChild.prototype.transition = function transition(animationType, finishCallback, timeout) {
    var node = (0, _reactDom.findDOMNode)(this);

    if (!node) {
      if (finishCallback) {
        finishCallback();
      }
      return;
    }

    var className = this.props.name[animationType] || this.props.name + '-' + animationType;
    var activeClassName = this.props.name[animationType + 'Active'] || className + '-active';
    var timer = null;
    var removeListeners = void 0;

    (0, _addClass2.default)(node, className);

    // Need to do this to actually trigger a transition.
    this.queueClassAndNode(activeClassName, node);

    // Clean-up the animation after the specified delay
    var finish = function finish(e) {
      if (e && e.target !== node) {
        return;
      }

      clearTimeout(timer);
      if (removeListeners) removeListeners();

      (0, _removeClass2.default)(node, className);
      (0, _removeClass2.default)(node, activeClassName);

      if (removeListeners) removeListeners();

      // Usually this optional callback is used for informing an owner of
      // a leave animation and telling it to remove the child.
      if (finishCallback) {
        finishCallback();
      }
    };

    if (timeout) {
      timer = setTimeout(finish, timeout);
      this.transitionTimeouts.push(timer);
    } else if (_properties.transitionEnd) {
      removeListeners = addEndListener(node, finish);
    }
  };

  CSSTransitionGroupChild.prototype.queueClassAndNode = function queueClassAndNode(className, node) {
    var _this2 = this;

    this.classNameAndNodeQueue.push({
      className: className,
      node: node
    });

    if (!this.rafHandle) {
      this.rafHandle = (0, _requestAnimationFrame2.default)(function () {
        return _this2.flushClassNameAndNodeQueue();
      });
    }
  };

  CSSTransitionGroupChild.prototype.flushClassNameAndNodeQueue = function flushClassNameAndNodeQueue() {
    if (!this.unmounted) {
      this.classNameAndNodeQueue.forEach(function (obj) {
        // This is for to force a repaint,
        // which is necessary in order to transition styles when adding a class name.
        /* eslint-disable no-unused-expressions */
        obj.node.scrollTop;
        /* eslint-enable no-unused-expressions */
        (0, _addClass2.default)(obj.node, obj.className);
      });
    }
    this.classNameAndNodeQueue.length = 0;
    this.rafHandle = null;
  };

  CSSTransitionGroupChild.prototype.render = function render() {
    var props = _extends({}, this.props);
    delete props.name;
    delete props.appear;
    delete props.enter;
    delete props.leave;
    delete props.appearTimeout;
    delete props.enterTimeout;
    delete props.leaveTimeout;
    delete props.children;
    return _react2.default.cloneElement(_react2.default.Children.only(this.props.children), props);
  };

  return CSSTransitionGroupChild;
}(_react2.default.Component);

CSSTransitionGroupChild.displayName = 'CSSTransitionGroupChild';


CSSTransitionGroupChild.propTypes =  false ? propTypes : {};

exports.default = CSSTransitionGroupChild;
module.exports = exports['default'];

/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(18);

exports.__esModule = true;
exports.default = addClass;

var _hasClass = _interopRequireDefault(__webpack_require__(78));

function addClass(element, className) {
  if (element.classList) element.classList.add(className);else if (!(0, _hasClass.default)(element, className)) if (typeof element.className === 'string') element.className = element.className + ' ' + className;else element.setAttribute('class', (element.className && element.className.baseVal || '') + ' ' + className);
}

module.exports = exports["default"];

/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = hasClass;

function hasClass(element, className) {
  if (element.classList) return !!className && element.classList.contains(className);else return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}

module.exports = exports["default"];

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function replaceClassName(origClass, classToRemove) {
  return origClass.replace(new RegExp('(^|\\s)' + classToRemove + '(?:\\s|$)', 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
}

module.exports = function removeClass(element, className) {
  if (element.classList) element.classList.remove(className);else if (typeof element.className === 'string') element.className = replaceClassName(element.className, className);else element.setAttribute('class', replaceClassName(element.className && element.className.baseVal || '', className));
};

/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(18);

exports.__esModule = true;
exports.default = void 0;

var _inDOM = _interopRequireDefault(__webpack_require__(33));

var vendors = ['', 'webkit', 'moz', 'o', 'ms'];
var cancel = 'clearTimeout';
var raf = fallback;
var compatRaf;

var getKey = function getKey(vendor, k) {
  return vendor + (!vendor ? k : k[0].toUpperCase() + k.substr(1)) + 'AnimationFrame';
};

if (_inDOM.default) {
  vendors.some(function (vendor) {
    var rafKey = getKey(vendor, 'request');

    if (rafKey in window) {
      cancel = getKey(vendor, 'cancel');
      return raf = function raf(cb) {
        return window[rafKey](cb);
      };
    }
  });
}
/* https://github.com/component/raf */


var prev = new Date().getTime();

function fallback(fn) {
  var curr = new Date().getTime(),
      ms = Math.max(0, 16 - (curr - prev)),
      req = setTimeout(fn, ms);
  prev = curr;
  return req;
}

compatRaf = function compatRaf(cb) {
  return raf(cb);
};

compatRaf.cancel = function (id) {
  window[cancel] && typeof window[cancel] === 'function' && window[cancel](id);
};

var _default = compatRaf;
exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(18);

exports.__esModule = true;
exports.default = exports.animationEnd = exports.animationDelay = exports.animationTiming = exports.animationDuration = exports.animationName = exports.transitionEnd = exports.transitionDuration = exports.transitionDelay = exports.transitionTiming = exports.transitionProperty = exports.transform = void 0;

var _inDOM = _interopRequireDefault(__webpack_require__(33));

var transform = 'transform';
exports.transform = transform;
var prefix, transitionEnd, animationEnd;
exports.animationEnd = animationEnd;
exports.transitionEnd = transitionEnd;
var transitionProperty, transitionDuration, transitionTiming, transitionDelay;
exports.transitionDelay = transitionDelay;
exports.transitionTiming = transitionTiming;
exports.transitionDuration = transitionDuration;
exports.transitionProperty = transitionProperty;
var animationName, animationDuration, animationTiming, animationDelay;
exports.animationDelay = animationDelay;
exports.animationTiming = animationTiming;
exports.animationDuration = animationDuration;
exports.animationName = animationName;

if (_inDOM.default) {
  var _getTransitionPropert = getTransitionProperties();

  prefix = _getTransitionPropert.prefix;
  exports.transitionEnd = transitionEnd = _getTransitionPropert.transitionEnd;
  exports.animationEnd = animationEnd = _getTransitionPropert.animationEnd;
  exports.transform = transform = prefix + "-" + transform;
  exports.transitionProperty = transitionProperty = prefix + "-transition-property";
  exports.transitionDuration = transitionDuration = prefix + "-transition-duration";
  exports.transitionDelay = transitionDelay = prefix + "-transition-delay";
  exports.transitionTiming = transitionTiming = prefix + "-transition-timing-function";
  exports.animationName = animationName = prefix + "-animation-name";
  exports.animationDuration = animationDuration = prefix + "-animation-duration";
  exports.animationTiming = animationTiming = prefix + "-animation-delay";
  exports.animationDelay = animationDelay = prefix + "-animation-timing-function";
}

var _default = {
  transform: transform,
  end: transitionEnd,
  property: transitionProperty,
  timing: transitionTiming,
  delay: transitionDelay,
  duration: transitionDuration
};
exports.default = _default;

function getTransitionProperties() {
  var style = document.createElement('div').style;
  var vendorMap = {
    O: function O(e) {
      return "o" + e.toLowerCase();
    },
    Moz: function Moz(e) {
      return e.toLowerCase();
    },
    Webkit: function Webkit(e) {
      return "webkit" + e;
    },
    ms: function ms(e) {
      return "MS" + e;
    }
  };
  var vendors = Object.keys(vendorMap);
  var transitionEnd, animationEnd;
  var prefix = '';

  for (var i = 0; i < vendors.length; i++) {
    var vendor = vendors[i];

    if (vendor + "TransitionProperty" in style) {
      prefix = "-" + vendor.toLowerCase();
      transitionEnd = vendorMap[vendor]('TransitionEnd');
      animationEnd = vendorMap[vendor]('AnimationEnd');
      break;
    }
  }

  if (!transitionEnd && 'transitionProperty' in style) transitionEnd = 'transitionend';
  if (!animationEnd && 'animationName' in style) animationEnd = 'animationend';
  style = null;
  return {
    animationEnd: animationEnd,
    transitionEnd: transitionEnd,
    prefix: prefix
  };
}

/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _nodePolyglot = __webpack_require__(83);

var _nodePolyglot2 = _interopRequireDefault(_nodePolyglot);

var _i18nContext = __webpack_require__(40);

var _i18nContext2 = _interopRequireDefault(_i18nContext);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// Provider root component
var I18n = function (_React$Component) {
  _inherits(I18n, _React$Component);

  function I18n(props) {
    _classCallCheck(this, I18n);

    var _this = _possibleConstructorReturn(this, (I18n.__proto__ || Object.getPrototypeOf(I18n)).call(this, props));

    _this._polyglot = new _nodePolyglot2.default({
      locale: props.locale,
      phrases: props.messages
    });
    return _this;
  }

  _createClass(I18n, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(newProps) {
      if (newProps.locale !== this.props.locale) {
        this._polyglot.locale(newProps.locale);
      }

      if (newProps.messages !== this.props.messages) {
        this._polyglot.replace(newProps.messages);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var children = this.props.children;


      return _react2.default.createElement(
        _i18nContext2.default.Provider,
        { value: this._polyglot.t.bind(this._polyglot) },
        _react2.default.Children.only(children)
      );
    }
  }]);

  return I18n;
}(_react2.default.Component);

exports.default = I18n;


I18n.propTypes = {
  locale: _propTypes2.default.string.isRequired,
  messages: _propTypes2.default.object.isRequired,
  children: _propTypes2.default.element.isRequired
};

/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
//     (c) 2012-2018 Airbnb, Inc.
//
//     polyglot.js may be freely distributed under the terms of the BSD
//     license. For all licensing information, details, and documention:
//     http://airbnb.github.com/polyglot.js
//
//
// Polyglot.js is an I18n helper library written in JavaScript, made to
// work both in the browser and in Node. It provides a simple solution for
// interpolation and pluralization, based off of Airbnb's
// experience adding I18n functionality to its Backbone.js and Node apps.
//
// Polylglot is agnostic to your translation backend. It doesn't perform any
// translation; it simply gives you a way to manage translated phrases from
// your client- or server-side JavaScript application.
//



var forEach = __webpack_require__(84);
var warning = __webpack_require__(6);
var has = __webpack_require__(20);
var trim = __webpack_require__(86);

var warn = function warn(message) {
  warning(false, message);
};

var replace = String.prototype.replace;
var split = String.prototype.split;

// #### Pluralization methods
// The string that separates the different phrase possibilities.
var delimiter = '||||';

var russianPluralGroups = function (n) {
  var lastTwo = n % 100;
  var end = lastTwo % 10;
  if (lastTwo !== 11 && end === 1) {
    return 0;
  }
  if (2 <= end && end <= 4 && !(lastTwo >= 12 && lastTwo <= 14)) {
    return 1;
  }
  return 2;
};

// Mapping from pluralization group plural logic.
var pluralTypes = {
  arabic: function (n) {
    // http://www.arabeyes.org/Plural_Forms
    if (n < 3) { return n; }
    var lastTwo = n % 100;
    if (lastTwo >= 3 && lastTwo <= 10) return 3;
    return lastTwo >= 11 ? 4 : 5;
  },
  bosnian_serbian: russianPluralGroups,
  chinese: function () { return 0; },
  croatian: russianPluralGroups,
  french: function (n) { return n > 1 ? 1 : 0; },
  german: function (n) { return n !== 1 ? 1 : 0; },
  russian: russianPluralGroups,
  lithuanian: function (n) {
    if (n % 10 === 1 && n % 100 !== 11) { return 0; }
    return n % 10 >= 2 && n % 10 <= 9 && (n % 100 < 11 || n % 100 > 19) ? 1 : 2;
  },
  czech: function (n) {
    if (n === 1) { return 0; }
    return (n >= 2 && n <= 4) ? 1 : 2;
  },
  polish: function (n) {
    if (n === 1) { return 0; }
    var end = n % 10;
    return 2 <= end && end <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2;
  },
  icelandic: function (n) { return (n % 10 !== 1 || n % 100 === 11) ? 1 : 0; },
  slovenian: function (n) {
    var lastTwo = n % 100;
    if (lastTwo === 1) {
      return 0;
    }
    if (lastTwo === 2) {
      return 1;
    }
    if (lastTwo === 3 || lastTwo === 4) {
      return 2;
    }
    return 3;
  }
};


// Mapping from pluralization group to individual language codes/locales.
// Will look up based on exact match, if not found and it's a locale will parse the locale
// for language code, and if that does not exist will default to 'en'
var pluralTypeToLanguages = {
  arabic: ['ar'],
  bosnian_serbian: ['bs-Latn-BA', 'bs-Cyrl-BA', 'srl-RS', 'sr-RS'],
  chinese: ['id', 'id-ID', 'ja', 'ko', 'ko-KR', 'lo', 'ms', 'th', 'th-TH', 'zh'],
  croatian: ['hr', 'hr-HR'],
  german: ['fa', 'da', 'de', 'en', 'es', 'fi', 'el', 'he', 'hi-IN', 'hu', 'hu-HU', 'it', 'nl', 'no', 'pt', 'sv', 'tr'],
  french: ['fr', 'tl', 'pt-br'],
  russian: ['ru', 'ru-RU'],
  lithuanian: ['lt'],
  czech: ['cs', 'cs-CZ', 'sk'],
  polish: ['pl'],
  icelandic: ['is'],
  slovenian: ['sl-SL']
};

function langToTypeMap(mapping) {
  var ret = {};
  forEach(mapping, function (langs, type) {
    forEach(langs, function (lang) {
      ret[lang] = type;
    });
  });
  return ret;
}

function pluralTypeName(locale) {
  var langToPluralType = langToTypeMap(pluralTypeToLanguages);
  return langToPluralType[locale]
    || langToPluralType[split.call(locale, /-/, 1)[0]]
    || langToPluralType.en;
}

function pluralTypeIndex(locale, count) {
  return pluralTypes[pluralTypeName(locale)](count);
}

function escape(token) {
  return token.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

function constructTokenRegex(opts) {
  var prefix = (opts && opts.prefix) || '%{';
  var suffix = (opts && opts.suffix) || '}';

  if (prefix === delimiter || suffix === delimiter) {
    throw new RangeError('"' + delimiter + '" token is reserved for pluralization');
  }

  return new RegExp(escape(prefix) + '(.*?)' + escape(suffix), 'g');
}

var defaultTokenRegex = /%\{(.*?)\}/g;

// ### transformPhrase(phrase, substitutions, locale)
//
// Takes a phrase string and transforms it by choosing the correct
// plural form and interpolating it.
//
//     transformPhrase('Hello, %{name}!', {name: 'Spike'});
//     // "Hello, Spike!"
//
// The correct plural form is selected if substitutions.smart_count
// is set. You can pass in a number instead of an Object as `substitutions`
// as a shortcut for `smart_count`.
//
//     transformPhrase('%{smart_count} new messages |||| 1 new message', {smart_count: 1}, 'en');
//     // "1 new message"
//
//     transformPhrase('%{smart_count} new messages |||| 1 new message', {smart_count: 2}, 'en');
//     // "2 new messages"
//
//     transformPhrase('%{smart_count} new messages |||| 1 new message', 5, 'en');
//     // "5 new messages"
//
// You should pass in a third argument, the locale, to specify the correct plural type.
// It defaults to `'en'` with 2 plural forms.
function transformPhrase(phrase, substitutions, locale, tokenRegex) {
  if (typeof phrase !== 'string') {
    throw new TypeError('Polyglot.transformPhrase expects argument #1 to be string');
  }

  if (substitutions == null) {
    return phrase;
  }

  var result = phrase;
  var interpolationRegex = tokenRegex || defaultTokenRegex;

  // allow number as a pluralization shortcut
  var options = typeof substitutions === 'number' ? { smart_count: substitutions } : substitutions;

  // Select plural form: based on a phrase text that contains `n`
  // plural forms separated by `delimiter`, a `locale`, and a `substitutions.smart_count`,
  // choose the correct plural form. This is only done if `count` is set.
  if (options.smart_count != null && result) {
    var texts = split.call(result, delimiter);
    result = trim(texts[pluralTypeIndex(locale || 'en', options.smart_count)] || texts[0]);
  }

  // Interpolate: Creates a `RegExp` object for each interpolation placeholder.
  result = replace.call(result, interpolationRegex, function (expression, argument) {
    if (!has(options, argument) || options[argument] == null) { return expression; }
    return options[argument];
  });

  return result;
}

// ### Polyglot class constructor
function Polyglot(options) {
  var opts = options || {};
  this.phrases = {};
  this.extend(opts.phrases || {});
  this.currentLocale = opts.locale || 'en';
  var allowMissing = opts.allowMissing ? transformPhrase : null;
  this.onMissingKey = typeof opts.onMissingKey === 'function' ? opts.onMissingKey : allowMissing;
  this.warn = opts.warn || warn;
  this.tokenRegex = constructTokenRegex(opts.interpolation);
}

// ### polyglot.locale([locale])
//
// Get or set locale. Internally, Polyglot only uses locale for pluralization.
Polyglot.prototype.locale = function (newLocale) {
  if (newLocale) this.currentLocale = newLocale;
  return this.currentLocale;
};

// ### polyglot.extend(phrases)
//
// Use `extend` to tell Polyglot how to translate a given key.
//
//     polyglot.extend({
//       "hello": "Hello",
//       "hello_name": "Hello, %{name}"
//     });
//
// The key can be any string.  Feel free to call `extend` multiple times;
// it will override any phrases with the same key, but leave existing phrases
// untouched.
//
// It is also possible to pass nested phrase objects, which get flattened
// into an object with the nested keys concatenated using dot notation.
//
//     polyglot.extend({
//       "nav": {
//         "hello": "Hello",
//         "hello_name": "Hello, %{name}",
//         "sidebar": {
//           "welcome": "Welcome"
//         }
//       }
//     });
//
//     console.log(polyglot.phrases);
//     // {
//     //   'nav.hello': 'Hello',
//     //   'nav.hello_name': 'Hello, %{name}',
//     //   'nav.sidebar.welcome': 'Welcome'
//     // }
//
// `extend` accepts an optional second argument, `prefix`, which can be used
// to prefix every key in the phrases object with some string, using dot
// notation.
//
//     polyglot.extend({
//       "hello": "Hello",
//       "hello_name": "Hello, %{name}"
//     }, "nav");
//
//     console.log(polyglot.phrases);
//     // {
//     //   'nav.hello': 'Hello',
//     //   'nav.hello_name': 'Hello, %{name}'
//     // }
//
// This feature is used internally to support nested phrase objects.
Polyglot.prototype.extend = function (morePhrases, prefix) {
  forEach(morePhrases, function (phrase, key) {
    var prefixedKey = prefix ? prefix + '.' + key : key;
    if (typeof phrase === 'object') {
      this.extend(phrase, prefixedKey);
    } else {
      this.phrases[prefixedKey] = phrase;
    }
  }, this);
};

// ### polyglot.unset(phrases)
// Use `unset` to selectively remove keys from a polyglot instance.
//
//     polyglot.unset("some_key");
//     polyglot.unset({
//       "hello": "Hello",
//       "hello_name": "Hello, %{name}"
//     });
//
// The unset method can take either a string (for the key), or an object hash with
// the keys that you would like to unset.
Polyglot.prototype.unset = function (morePhrases, prefix) {
  if (typeof morePhrases === 'string') {
    delete this.phrases[morePhrases];
  } else {
    forEach(morePhrases, function (phrase, key) {
      var prefixedKey = prefix ? prefix + '.' + key : key;
      if (typeof phrase === 'object') {
        this.unset(phrase, prefixedKey);
      } else {
        delete this.phrases[prefixedKey];
      }
    }, this);
  }
};

// ### polyglot.clear()
//
// Clears all phrases. Useful for special cases, such as freeing
// up memory if you have lots of phrases but no longer need to
// perform any translation. Also used internally by `replace`.
Polyglot.prototype.clear = function () {
  this.phrases = {};
};

// ### polyglot.replace(phrases)
//
// Completely replace the existing phrases with a new set of phrases.
// Normally, just use `extend` to add more phrases, but under certain
// circumstances, you may want to make sure no old phrases are lying around.
Polyglot.prototype.replace = function (newPhrases) {
  this.clear();
  this.extend(newPhrases);
};


// ### polyglot.t(key, options)
//
// The most-used method. Provide a key, and `t` will return the
// phrase.
//
//     polyglot.t("hello");
//     => "Hello"
//
// The phrase value is provided first by a call to `polyglot.extend()` or
// `polyglot.replace()`.
//
// Pass in an object as the second argument to perform interpolation.
//
//     polyglot.t("hello_name", {name: "Spike"});
//     => "Hello, Spike"
//
// If you like, you can provide a default value in case the phrase is missing.
// Use the special option key "_" to specify a default.
//
//     polyglot.t("i_like_to_write_in_language", {
//       _: "I like to write in %{language}.",
//       language: "JavaScript"
//     });
//     => "I like to write in JavaScript."
//
Polyglot.prototype.t = function (key, options) {
  var phrase, result;
  var opts = options == null ? {} : options;
  if (typeof this.phrases[key] === 'string') {
    phrase = this.phrases[key];
  } else if (typeof opts._ === 'string') {
    phrase = opts._;
  } else if (this.onMissingKey) {
    var onMissingKey = this.onMissingKey;
    result = onMissingKey(key, opts, this.currentLocale, this.tokenRegex);
  } else {
    this.warn('Missing translation for key: "' + key + '"');
    result = key;
  }
  if (typeof phrase === 'string') {
    result = transformPhrase(phrase, opts, this.currentLocale, this.tokenRegex);
  }
  return result;
};


// ### polyglot.has(key)
//
// Check if polyglot has a translation for given key
Polyglot.prototype.has = function (key) {
  return has(this.phrases, key);
};

// export transformPhrase
Polyglot.transformPhrase = function transform(phrase, substitutions, locale) {
  return transformPhrase(phrase, substitutions, locale);
};

module.exports = Polyglot;


/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isCallable = __webpack_require__(19);

var toStr = Object.prototype.toString;
var hasOwnProperty = Object.prototype.hasOwnProperty;

var forEachArray = function forEachArray(array, iterator, receiver) {
    for (var i = 0, len = array.length; i < len; i++) {
        if (hasOwnProperty.call(array, i)) {
            if (receiver == null) {
                iterator(array[i], i, array);
            } else {
                iterator.call(receiver, array[i], i, array);
            }
        }
    }
};

var forEachString = function forEachString(string, iterator, receiver) {
    for (var i = 0, len = string.length; i < len; i++) {
        // no such thing as a sparse string.
        if (receiver == null) {
            iterator(string.charAt(i), i, string);
        } else {
            iterator.call(receiver, string.charAt(i), i, string);
        }
    }
};

var forEachObject = function forEachObject(object, iterator, receiver) {
    for (var k in object) {
        if (hasOwnProperty.call(object, k)) {
            if (receiver == null) {
                iterator(object[k], k, object);
            } else {
                iterator.call(receiver, object[k], k, object);
            }
        }
    }
};

var forEach = function forEach(list, iterator, thisArg) {
    if (!isCallable(iterator)) {
        throw new TypeError('iterator must be a function');
    }

    var receiver;
    if (arguments.length >= 3) {
        receiver = thisArg;
    }

    if (toStr.call(list) === '[object Array]') {
        forEachArray(list, iterator, receiver);
    } else if (typeof list === 'string') {
        forEachString(list, iterator, receiver);
    } else {
        forEachObject(list, iterator, receiver);
    }
};

module.exports = forEach;


/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint no-invalid-this: 1 */

var ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
var slice = Array.prototype.slice;
var toStr = Object.prototype.toString;
var funcType = '[object Function]';

module.exports = function bind(that) {
    var target = this;
    if (typeof target !== 'function' || toStr.call(target) !== funcType) {
        throw new TypeError(ERROR_MESSAGE + target);
    }
    var args = slice.call(arguments, 1);

    var bound;
    var binder = function () {
        if (this instanceof bound) {
            var result = target.apply(
                this,
                args.concat(slice.call(arguments))
            );
            if (Object(result) === result) {
                return result;
            }
            return this;
        } else {
            return target.apply(
                that,
                args.concat(slice.call(arguments))
            );
        }
    };

    var boundLength = Math.max(0, target.length - args.length);
    var boundArgs = [];
    for (var i = 0; i < boundLength; i++) {
        boundArgs.push('$' + i);
    }

    bound = Function('binder', 'return function (' + boundArgs.join(',') + '){ return binder.apply(this,arguments); }')(binder);

    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }

    return bound;
};


/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(21);
var define = __webpack_require__(35);

var implementation = __webpack_require__(37);
var getPolyfill = __webpack_require__(39);
var shim = __webpack_require__(97);

var boundTrim = bind.call(Function.call, getPolyfill());

define(boundTrim, {
	getPolyfill: getPolyfill,
	implementation: implementation,
	shim: shim
});

module.exports = boundTrim;


/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var slice = Array.prototype.slice;
var isArgs = __webpack_require__(36);

var origKeys = Object.keys;
var keysShim = origKeys ? function keys(o) { return origKeys(o); } : __webpack_require__(88);

var originalKeys = Object.keys;

keysShim.shim = function shimObjectKeys() {
	if (Object.keys) {
		var keysWorksWithArguments = (function () {
			// Safari 5.0 bug
			var args = Object.keys(arguments);
			return args && args.length === arguments.length;
		}(1, 2));
		if (!keysWorksWithArguments) {
			Object.keys = function keys(object) { // eslint-disable-line func-name-matching
				if (isArgs(object)) {
					return originalKeys(slice.call(object));
				}
				return originalKeys(object);
			};
		}
	} else {
		Object.keys = keysShim;
	}
	return Object.keys || keysShim;
};

module.exports = keysShim;


/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var keysShim;
if (!Object.keys) {
	// modified from https://github.com/es-shims/es5-shim
	var has = Object.prototype.hasOwnProperty;
	var toStr = Object.prototype.toString;
	var isArgs = __webpack_require__(36); // eslint-disable-line global-require
	var isEnumerable = Object.prototype.propertyIsEnumerable;
	var hasDontEnumBug = !isEnumerable.call({ toString: null }, 'toString');
	var hasProtoEnumBug = isEnumerable.call(function () {}, 'prototype');
	var dontEnums = [
		'toString',
		'toLocaleString',
		'valueOf',
		'hasOwnProperty',
		'isPrototypeOf',
		'propertyIsEnumerable',
		'constructor'
	];
	var equalsConstructorPrototype = function (o) {
		var ctor = o.constructor;
		return ctor && ctor.prototype === o;
	};
	var excludedKeys = {
		$applicationCache: true,
		$console: true,
		$external: true,
		$frame: true,
		$frameElement: true,
		$frames: true,
		$innerHeight: true,
		$innerWidth: true,
		$onmozfullscreenchange: true,
		$onmozfullscreenerror: true,
		$outerHeight: true,
		$outerWidth: true,
		$pageXOffset: true,
		$pageYOffset: true,
		$parent: true,
		$scrollLeft: true,
		$scrollTop: true,
		$scrollX: true,
		$scrollY: true,
		$self: true,
		$webkitIndexedDB: true,
		$webkitStorageInfo: true,
		$window: true
	};
	var hasAutomationEqualityBug = (function () {
		/* global window */
		if (typeof window === 'undefined') { return false; }
		for (var k in window) {
			try {
				if (!excludedKeys['$' + k] && has.call(window, k) && window[k] !== null && typeof window[k] === 'object') {
					try {
						equalsConstructorPrototype(window[k]);
					} catch (e) {
						return true;
					}
				}
			} catch (e) {
				return true;
			}
		}
		return false;
	}());
	var equalsConstructorPrototypeIfNotBuggy = function (o) {
		/* global window */
		if (typeof window === 'undefined' || !hasAutomationEqualityBug) {
			return equalsConstructorPrototype(o);
		}
		try {
			return equalsConstructorPrototype(o);
		} catch (e) {
			return false;
		}
	};

	keysShim = function keys(object) {
		var isObject = object !== null && typeof object === 'object';
		var isFunction = toStr.call(object) === '[object Function]';
		var isArguments = isArgs(object);
		var isString = isObject && toStr.call(object) === '[object String]';
		var theKeys = [];

		if (!isObject && !isFunction && !isArguments) {
			throw new TypeError('Object.keys called on a non-object');
		}

		var skipProto = hasProtoEnumBug && isFunction;
		if (isString && object.length > 0 && !has.call(object, 0)) {
			for (var i = 0; i < object.length; ++i) {
				theKeys.push(String(i));
			}
		}

		if (isArguments && object.length > 0) {
			for (var j = 0; j < object.length; ++j) {
				theKeys.push(String(j));
			}
		} else {
			for (var name in object) {
				if (!(skipProto && name === 'prototype') && has.call(object, name)) {
					theKeys.push(String(name));
				}
			}
		}

		if (hasDontEnumBug) {
			var skipConstructor = equalsConstructorPrototypeIfNotBuggy(object);

			for (var k = 0; k < dontEnums.length; ++k) {
				if (!(skipConstructor && dontEnums[k] === 'constructor') && has.call(object, dontEnums[k])) {
					theKeys.push(dontEnums[k]);
				}
			}
		}
		return theKeys;
	};
}
module.exports = keysShim;


/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(38);

var $Object = GetIntrinsic('%Object%');
var $TypeError = GetIntrinsic('%TypeError%');
var $String = GetIntrinsic('%String%');

var assertRecord = __webpack_require__(90);
var $isNaN = __webpack_require__(91);
var $isFinite = __webpack_require__(92);

var sign = __webpack_require__(93);
var mod = __webpack_require__(94);

var IsCallable = __webpack_require__(19);
var toPrimitive = __webpack_require__(95);

var has = __webpack_require__(20);

// https://es5.github.io/#x9
var ES5 = {
	ToPrimitive: toPrimitive,

	ToBoolean: function ToBoolean(value) {
		return !!value;
	},
	ToNumber: function ToNumber(value) {
		return +value; // eslint-disable-line no-implicit-coercion
	},
	ToInteger: function ToInteger(value) {
		var number = this.ToNumber(value);
		if ($isNaN(number)) { return 0; }
		if (number === 0 || !$isFinite(number)) { return number; }
		return sign(number) * Math.floor(Math.abs(number));
	},
	ToInt32: function ToInt32(x) {
		return this.ToNumber(x) >> 0;
	},
	ToUint32: function ToUint32(x) {
		return this.ToNumber(x) >>> 0;
	},
	ToUint16: function ToUint16(value) {
		var number = this.ToNumber(value);
		if ($isNaN(number) || number === 0 || !$isFinite(number)) { return 0; }
		var posInt = sign(number) * Math.floor(Math.abs(number));
		return mod(posInt, 0x10000);
	},
	ToString: function ToString(value) {
		return $String(value);
	},
	ToObject: function ToObject(value) {
		this.CheckObjectCoercible(value);
		return $Object(value);
	},
	CheckObjectCoercible: function CheckObjectCoercible(value, optMessage) {
		/* jshint eqnull:true */
		if (value == null) {
			throw new $TypeError(optMessage || 'Cannot call method on ' + value);
		}
		return value;
	},
	IsCallable: IsCallable,
	SameValue: function SameValue(x, y) {
		if (x === y) { // 0 === -0, but they are not identical.
			if (x === 0) { return 1 / x === 1 / y; }
			return true;
		}
		return $isNaN(x) && $isNaN(y);
	},

	// https://www.ecma-international.org/ecma-262/5.1/#sec-8
	Type: function Type(x) {
		if (x === null) {
			return 'Null';
		}
		if (typeof x === 'undefined') {
			return 'Undefined';
		}
		if (typeof x === 'function' || typeof x === 'object') {
			return 'Object';
		}
		if (typeof x === 'number') {
			return 'Number';
		}
		if (typeof x === 'boolean') {
			return 'Boolean';
		}
		if (typeof x === 'string') {
			return 'String';
		}
	},

	// https://ecma-international.org/ecma-262/6.0/#sec-property-descriptor-specification-type
	IsPropertyDescriptor: function IsPropertyDescriptor(Desc) {
		if (this.Type(Desc) !== 'Object') {
			return false;
		}
		var allowed = {
			'[[Configurable]]': true,
			'[[Enumerable]]': true,
			'[[Get]]': true,
			'[[Set]]': true,
			'[[Value]]': true,
			'[[Writable]]': true
		};

		for (var key in Desc) { // eslint-disable-line
			if (has(Desc, key) && !allowed[key]) {
				return false;
			}
		}

		var isData = has(Desc, '[[Value]]');
		var IsAccessor = has(Desc, '[[Get]]') || has(Desc, '[[Set]]');
		if (isData && IsAccessor) {
			throw new $TypeError('Property Descriptors may not be both accessor and data descriptors');
		}
		return true;
	},

	// https://ecma-international.org/ecma-262/5.1/#sec-8.10.1
	IsAccessorDescriptor: function IsAccessorDescriptor(Desc) {
		if (typeof Desc === 'undefined') {
			return false;
		}

		assertRecord(this, 'Property Descriptor', 'Desc', Desc);

		if (!has(Desc, '[[Get]]') && !has(Desc, '[[Set]]')) {
			return false;
		}

		return true;
	},

	// https://ecma-international.org/ecma-262/5.1/#sec-8.10.2
	IsDataDescriptor: function IsDataDescriptor(Desc) {
		if (typeof Desc === 'undefined') {
			return false;
		}

		assertRecord(this, 'Property Descriptor', 'Desc', Desc);

		if (!has(Desc, '[[Value]]') && !has(Desc, '[[Writable]]')) {
			return false;
		}

		return true;
	},

	// https://ecma-international.org/ecma-262/5.1/#sec-8.10.3
	IsGenericDescriptor: function IsGenericDescriptor(Desc) {
		if (typeof Desc === 'undefined') {
			return false;
		}

		assertRecord(this, 'Property Descriptor', 'Desc', Desc);

		if (!this.IsAccessorDescriptor(Desc) && !this.IsDataDescriptor(Desc)) {
			return true;
		}

		return false;
	},

	// https://ecma-international.org/ecma-262/5.1/#sec-8.10.4
	FromPropertyDescriptor: function FromPropertyDescriptor(Desc) {
		if (typeof Desc === 'undefined') {
			return Desc;
		}

		assertRecord(this, 'Property Descriptor', 'Desc', Desc);

		if (this.IsDataDescriptor(Desc)) {
			return {
				value: Desc['[[Value]]'],
				writable: !!Desc['[[Writable]]'],
				enumerable: !!Desc['[[Enumerable]]'],
				configurable: !!Desc['[[Configurable]]']
			};
		} else if (this.IsAccessorDescriptor(Desc)) {
			return {
				get: Desc['[[Get]]'],
				set: Desc['[[Set]]'],
				enumerable: !!Desc['[[Enumerable]]'],
				configurable: !!Desc['[[Configurable]]']
			};
		} else {
			throw new $TypeError('FromPropertyDescriptor must be called with a fully populated Property Descriptor');
		}
	},

	// https://ecma-international.org/ecma-262/5.1/#sec-8.10.5
	ToPropertyDescriptor: function ToPropertyDescriptor(Obj) {
		if (this.Type(Obj) !== 'Object') {
			throw new $TypeError('ToPropertyDescriptor requires an object');
		}

		var desc = {};
		if (has(Obj, 'enumerable')) {
			desc['[[Enumerable]]'] = this.ToBoolean(Obj.enumerable);
		}
		if (has(Obj, 'configurable')) {
			desc['[[Configurable]]'] = this.ToBoolean(Obj.configurable);
		}
		if (has(Obj, 'value')) {
			desc['[[Value]]'] = Obj.value;
		}
		if (has(Obj, 'writable')) {
			desc['[[Writable]]'] = this.ToBoolean(Obj.writable);
		}
		if (has(Obj, 'get')) {
			var getter = Obj.get;
			if (typeof getter !== 'undefined' && !this.IsCallable(getter)) {
				throw new TypeError('getter must be a function');
			}
			desc['[[Get]]'] = getter;
		}
		if (has(Obj, 'set')) {
			var setter = Obj.set;
			if (typeof setter !== 'undefined' && !this.IsCallable(setter)) {
				throw new $TypeError('setter must be a function');
			}
			desc['[[Set]]'] = setter;
		}

		if ((has(desc, '[[Get]]') || has(desc, '[[Set]]')) && (has(desc, '[[Value]]') || has(desc, '[[Writable]]'))) {
			throw new $TypeError('Invalid property descriptor. Cannot both specify accessors and a value or writable attribute');
		}
		return desc;
	}
};

module.exports = ES5;


/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(38);

var $TypeError = GetIntrinsic('%TypeError%');
var $SyntaxError = GetIntrinsic('%SyntaxError%');

var has = __webpack_require__(20);

var predicates = {
  // https://ecma-international.org/ecma-262/6.0/#sec-property-descriptor-specification-type
  'Property Descriptor': function isPropertyDescriptor(ES, Desc) {
    if (ES.Type(Desc) !== 'Object') {
      return false;
    }
    var allowed = {
      '[[Configurable]]': true,
      '[[Enumerable]]': true,
      '[[Get]]': true,
      '[[Set]]': true,
      '[[Value]]': true,
      '[[Writable]]': true
    };

    for (var key in Desc) { // eslint-disable-line
      if (has(Desc, key) && !allowed[key]) {
        return false;
      }
    }

    var isData = has(Desc, '[[Value]]');
    var IsAccessor = has(Desc, '[[Get]]') || has(Desc, '[[Set]]');
    if (isData && IsAccessor) {
      throw new $TypeError('Property Descriptors may not be both accessor and data descriptors');
    }
    return true;
  }
};

module.exports = function assertRecord(ES, recordType, argumentName, value) {
  var predicate = predicates[recordType];
  if (typeof predicate !== 'function') {
    throw new $SyntaxError('unknown record type: ' + recordType);
  }
  if (!predicate(ES, value)) {
    throw new $TypeError(argumentName + ' must be a ' + recordType);
  }
  console.log(predicate(ES, value), value);
};


/***/ }),
/* 91 */
/***/ (function(module, exports) {

module.exports = Number.isNaN || function isNaN(a) {
	return a !== a;
};


/***/ }),
/* 92 */
/***/ (function(module, exports) {

var $isNaN = Number.isNaN || function (a) { return a !== a; };

module.exports = Number.isFinite || function (x) { return typeof x === 'number' && !$isNaN(x) && x !== Infinity && x !== -Infinity; };


/***/ }),
/* 93 */
/***/ (function(module, exports) {

module.exports = function sign(number) {
	return number >= 0 ? 1 : -1;
};


/***/ }),
/* 94 */
/***/ (function(module, exports) {

module.exports = function mod(number, modulo) {
	var remain = number % modulo;
	return Math.floor(remain >= 0 ? remain : remain + modulo);
};


/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var toStr = Object.prototype.toString;

var isPrimitive = __webpack_require__(96);

var isCallable = __webpack_require__(19);

// http://ecma-international.org/ecma-262/5.1/#sec-8.12.8
var ES5internalSlots = {
	'[[DefaultValue]]': function (O) {
		var actualHint;
		if (arguments.length > 1) {
			actualHint = arguments[1];
		} else {
			actualHint = toStr.call(O) === '[object Date]' ? String : Number;
		}

		if (actualHint === String || actualHint === Number) {
			var methods = actualHint === String ? ['toString', 'valueOf'] : ['valueOf', 'toString'];
			var value, i;
			for (i = 0; i < methods.length; ++i) {
				if (isCallable(O[methods[i]])) {
					value = O[methods[i]]();
					if (isPrimitive(value)) {
						return value;
					}
				}
			}
			throw new TypeError('No default value');
		}
		throw new TypeError('invalid [[DefaultValue]] hint supplied');
	}
};

// http://ecma-international.org/ecma-262/5.1/#sec-9.1
module.exports = function ToPrimitive(input) {
	if (isPrimitive(input)) {
		return input;
	}
	if (arguments.length > 1) {
		return ES5internalSlots['[[DefaultValue]]'](input, arguments[1]);
	}
	return ES5internalSlots['[[DefaultValue]]'](input);
};


/***/ }),
/* 96 */
/***/ (function(module, exports) {

module.exports = function isPrimitive(value) {
	return value === null || (typeof value !== 'function' && typeof value !== 'object');
};


/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var define = __webpack_require__(35);
var getPolyfill = __webpack_require__(39);

module.exports = function shimStringTrim() {
	var polyfill = getPolyfill();
	define(String.prototype, { trim: polyfill }, {
		trim: function testTrim() {
			return String.prototype.trim !== polyfill;
		}
	});
	return polyfill;
};


/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = translate;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _hoistNonReactStatics = __webpack_require__(41);

var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);

var _i18nContext = __webpack_require__(40);

var _i18nContext2 = _interopRequireDefault(_i18nContext);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// higher order decorator for components that need `t`
function translate() {
  return function (WrappedComponent) {
    var _translate = function _translate(props) {
      return _react2.default.createElement(
        _i18nContext2.default.Consumer,
        null,
        function (t) {
          return _react2.default.createElement(WrappedComponent, _extends({}, props, { t: t }));
        }
      );
    };

    return (0, _hoistNonReactStatics2.default)(_translate, WrappedComponent);
  };
}

/***/ }),
/* 99 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* prettier-ignore */var messages={en:{product_location:'In Stock: Aisle 9, Shelf B2',digital_advisor:'Digital Beauty Advisor',build_skin_profile:'Build Skin Profile',take_selfie:'Take Selfie',see_skin_analysis:'See Skin Analysis',get_personal_advice:'Get Personal Advice',get_product_recommendations:'Get Product Recommendations',start_over:'Start Over',uv_index:'UV Index',humidity:'Humidity',pollution:'Pollution',male:'male',female:'female',remove_glasses:'Remove Glasses',pull_back_hair:'Pull Back Hair',look_at_the_camera:'Look at the Camera',tap_take_picture:'Tap anywhere on the screen to take the picture',cancel:'Cancel',continue:'Continue',uploading_selfie:'Uploading and Analysing',activating_camera:'Activating camera',error_opening_camera:'Error opening camera',back:'Back',icon_darkcircles:'Dark circles',icon_eyebags:'Eye bags',icon_eyecolor:'Eye color',icon_pigmentvariation:'Pigment Variation',icon_radiance:'Radiance',icon_shape:'Face shape',icon_undertone:'Undertone',icon_wrinkleslines:'Wrinkles & Lines',icon_skintoneColor:'Foundation',icon_skintone:'Skintone',icon_redness:'Redness',icon_texture:'Texture',icon_skin_shine:'Skin Shine',icon_acne:'Acne',range_none:'none',range_low:'low',range_medium:'medium',range_high:'high',loading_products:'Loading products',no_products:'No products available',light_tone:'Light',fair_tone:'Fair',medium_tone:'Medium',olive_tone:'Olive',brown_tone:'Brown',dark_brown_tone:'Dark Brown',selfie_instructions_description_error:'Below are some suggestions that could help you improve the selfie and get better results',selfie_quality:'Selfie Quality: ',selfie_quality_ok:'Good',selfie_quality_poor:'Please Retake',retake_selfie:'Retake',capture_selfie:'capture',checkout:'Checkout',location_button:'Your location:',geosuggest_placeholder:'Search places:',tanning:'Tanning',sun_protection:'SPF',vegan:'Vegan',organic:'Organic',fragrance_free:'Fragrance Free',paraben_free:'Paraben Free',anti_age:'Anti-aging',woman:'Women',man:'Men',cuperose:'Couperose',rocasea:'Rosacea',wrinkles:'Wrinkles and fine lines',acne:'Acne',eczema:'Eczema',psoriasis:'Psoriasis',hyperpigmentation:'Hyperpigmentation',dull_tired:'Dull skin',skin_brightening:'Skin brightening',oilyness:'Oiliness',skin_firming:'Skin firming',normal_skin:'Normal',dry_skin:'Dry',oily_skin:'Oily',sensitive_skin:'Sensitive',idontknow_skin:'Not sure',combination_skin:'Combination',processing_image:'Processing...',CV_MESSAGE_OK:'Analysis OK.',CV_MESSAGE_Error:'Unsuitable image.',CV_MESSAGE_Warning:'We were able to make findings from your image, however found that a better image would result in better findings. Here are some quality considerations we found from the image:',CV_MESSAGE_Warning_heading:'Quality considerations',CV_CODE_100:'Oops, this doesn\'t seem to be a color selfie. Please retake your selfie as a color-selfie',CV_CODE_101:'Oops, the resolution of the image was too small for us to analyze. We need an image of at least 600x600 pixels (any regular smartphone camera image will do)',CV_CODE_102:'Wow, now that was a selfie. But it seems that the proportions of the image are a bit distorted so we couldn\'t analyze it. Try taking another one with regular proportions.',CV_CODE_103:'Now that was quite a dark selfie. But not to worry, we’re still able to analyse it. Keep in mind if you’d like a more accurate analysis, you can always ',CV_CODE_104:'Wow, now there\'s some light in that selfie. Unfortunately a bit too much direct light there.',CV_CODE_201:'Hmm. We weren\'t able to find a face from your selfie. Can you try again?',CV_CODE_202:'Multiple faces detected. Only the best fit face is analyzed',CV_CODE_203:'Hmm. We’re not quite sure there was a face in the selfie. But we were able to analyse what we believe to be a face ☺',CV_CODE_204:'There doesn’t seem to be a face in the selfie. Please re-take your selfie',CV_CODE_205:'The picture is taken too close to the camera. As a result, the analysis might be inaccurate. Please take the picture further away from the camera.',CV_CODE_301:'The detected face resolution is too small. Take a photo closer to your face.',CV_CODE_302:'Face is too much tilted to the side. Try again please, but this time face straight to the camera.',CV_CODE_303:'Face is possibly tilted to the side. Try again please, but this time face straight at the camera.',CV_CODE_304:'Face is too much tilted down. Face straight at the camera.',CV_CODE_305:'Face is possibly tilted down. Face straight at the camera.',CV_CODE_306:'Face is possibly tilted up. Face straight at the camera.',CV_CODE_307:'Image too dark at the face area. Increase exposure/light to the face.',CV_CODE_308:'Image is overexposed at the face area. Find more diffuse lighting or reduce exposure.',CV_CODE_309:'The face area blue channel is clipping (overexposed). Reduce exposure or adjust color balance.',CV_CODE_310:'The face area green channel is clipping (overexposed). Reduce exposure or adjust color balance.',CV_CODE_311:'The face area red channel is clipping (overexposed). Reduce exposure or adjust color balance.',CV_CODE_312:'The face has asymmetric exposure to lighting. Find a spot with even lighting conditions',CV_CODE_313:'The face area has hard shadows. Find more diffuse lighting.',CV_CODE_314:'We noticed you might be wearing glasses. For better results, take a selfie without glasses.',CV_CODE_1000:'You didn\'t define your skin tone. Please go back and select your skin tone to continue.',CV_CODE_1101:'Oops. Your eyes seem too closed for us to analyze their color. Please retake your selfie with your eyes open.',CV_CODE_1102:'Oops, it seems that your eyes may be a bit too closed. For better results, remember to keep your eyes open when taking a selfie.',CV_CODE_1111:'There seems to be some shadow directed at your eyes. We\'re not able to analyze your eye color. If you\'d like your eye color analyzed, please retake a selfie with better lighting directed at your eyes.',CV_CODE_1112:'There seems to be some shadow directed at your eyes, making it difficult for us to accurately analyze your eye color. If we we\'re mistaken about your eye color, take a new selfie with better lighting directed at your eyes',CV_CODE_1121:'Oops, your eye whites don\'t appear white in the selfie. We\'re not able to analyze your eye color. If you\'d like your eye color analyzed, please retake a selfie with better lighting directed at your eyes.',CV_CODE_1122:'Oops, your eye whites don\'t appear white in the selfie, making it difficult for us to analyze your eye color. If we we\'re mistaken about your eye color, take a new selfie with better lighting directed at your eyes.',CV_TYPE_eyebag:'Eyebags',CV_TYPE_eyebag_descr_low:'After looking at your selfie, we discovered that eyebags are not a concern for you. We’ll take this into account when finding you the perfect skincare products.',CV_TYPE_eyebag_descr_med:'After looking at your selfie, we discovered that you have some signs of eyebags. We’ll take this into account when finding you the perfect skincare products.',CV_TYPE_eyebag_descr_high:'After looking at your selfie, we discovered that your eyes may appear tired. We’ll take this into account when finding you the perfect skincare products.',CV_TYPE_NEW_eyebag_descr_low:'Eyebags are not a concern for you. We’ll take this into account when finding you the perfect skincare products.',CV_TYPE_NEW_eyebag_descr_med:'You have some signs of eyebags. We’ll take this into account when finding you the perfect skincare products.',CV_TYPE_NEW_eyebag_descr_high:'Your eyes may appear tired. We’ll take this into account when finding you the perfect skincare products.',CV_TYPE_wrinkle:'Facial Lines',CV_TYPE_wrinkle_descr_low:'After looking at your selfie, we discovered that your skin looks young and fresh. We’ll take this into account when finding you the perfect skincare products. A detailed account of any signs of maturity is shown below.',CV_TYPE_wrinkle_descr_med:'After looking at your selfie, we discovered that your skin is showing some signs of maturity. We’ll take this into account when finding you the perfect skincare products. A detailed account of any signs of maturity is shown below.',CV_TYPE_wrinkle_descr_high:'After looking at your selfie, we discovered that your skin is showing signs of maturity. We’ll take this into account when finding you the perfect skincare products. A detailed account of any signs of maturity is shown below.',CV_TYPE_NEW_wrinkle_descr_low:'Your skin looks young and fresh. We’ll take this into account when finding you the perfect skincare products. A detailed account of any signs of maturity is shown below.',CV_TYPE_NEW_wrinkle_descr_med:'Your skin is showing some signs of maturity. We’ll take this into account when finding you the perfect skincare products. A detailed account of any signs of maturity is shown below.',CV_TYPE_NEW_wrinkle_descr_high:'Your skin is showing signs of maturity. We’ll take this into account when finding you the perfect skincare products. A detailed account of any signs of maturity is shown below.',CV_TYPE_redness:'Redness',CV_TYPE_redness_descr_low:'We noticed from your selfie that there is no significant redness on your skin. We will use this finding to find you the perfect skincare routine.',CV_TYPE_redness_descr_med:'We noticed from your selfie that there are some signs of redness on your skin. We will use this finding to find you the perfect skincare routine.',CV_TYPE_redness_descr_high:'We noticed from your selfie that your skin exhibits some redness. We will use this finding to find you the perfect skincare routine.',CV_TYPE_NEW_redness_descr_low:'There is no significant redness on your skin. We will use this finding to find you the perfect skincare routine.',CV_TYPE_NEW_redness_descr_med:'There are some signs of redness on your skin. We will use this finding to find you the perfect skincare routine.',CV_TYPE_NEW_redness_descr_high:'Your skin exhibits some redness. We will use this finding to find you the perfect skincare routine.',CV_TYPE_hyperpigmentation:'Hyperpigmentation',CV_TYPE_NEW_hyperpigmentation_descr_high:'We discovered from your selfie that you have signs of pigment changes on your skin. We will take this into consideration in helping you discover products that will help reduce the impact and visibility of any signs of pigment changes.',CV_TYPE_NEW_hyperpigmentation_descr_med:'We discovered from your selfie that you have some signs of pigment changes on your skin. We will take this into consideration in helping you discover products that will help reduce the impact and visibility of any signs of pigment changes.',CV_TYPE_NEW_hyperpigmentation_descr_low:'We discovered from your selfie that pigment changes on your skin are not a consideration for you',HINTS_hyperpigmentation:'Pigment changes and hyperpigmentation are a common, harmless condition where parts of the skin becomes darker than the surrounding area. Using the proper skincare products meant to combat the effects of hyperpigmentation will help keep your skin nice and even-toned.',CV_TYPE_puffy_eyes:'Puffy Eyes',CV_TYPE_NEW_puffy_eyes_descr_high:'We discovered from your selfie that you have signs of puffiness around your eyes. We will take this into consideration in helping you discover products that will help reduce the impact and visibility of any signs of pigment changes.',CV_TYPE_NEW_puffy_eyes_descr_med:'We discovered from your selfie that you have some signs of puffiness around your eyes. We will take this into consideration in helping you discover products that will help reduce the impact and visibility of any signs of pigment changes.',CV_TYPE_NEW_puffy_eyes_descr_low:'We discovered from your selfie that puffiness around your eyes is not a consideration for you',HINTS_puffy_eyes:'Puffiness around your eyes can be caused by many factors. Bad sleeping and eating habits and allergies can also contribute. Apart from drinking enough water, the right eye-products can reduce the appearance of puffy eyes and make your eyes look fresher.',CV_TYPE_dull_skin:'Dull Skin',CV_TYPE_NEW_dull_skin_descr_high:'We discovered from your selfie that you have signs of dullness on your skin. We will take this into consideration in helping you discover products that will help reduce the impact and visibility of any signs of pigment changes.',CV_TYPE_NEW_dull_skin_descr_med:'We discovered from your selfie that you have some signs of dullness onyour skin. We will take this into consideration in helping you discover products that will help reduce the impact and visibility of any signs of pigment changes.',CV_TYPE_NEW_dull_skin_descr_low:'We discovered from your selfie that dullness of the skin is not a consideration for you',HINTS_dull_skin:'Dullness of the skin can be caused by extrenal influences such as pollution, dead skin cells or stress. A regular, targeted skincare routine will help you clear out dead skin cells and combat the impacts of the environment on your skin, making your skin look brighter.',CV_TYPE_sagging_skin:'Sagging Skin',CV_TYPE_NEW_sagging_skin_descr_high:'We discovered from your selfie that you have signs of looseness on your skin. We will take this into consideration in helping you discover products that will help reduce the impact and visibility of any signs of pigment changes.',CV_TYPE_NEW_sagging_skin_descr_med:'We discovered from your selfie that you have some signs of looseness on your skin. We will take this into consideration in helping you discover products that will help reduce the impact and visibility of any signs of pigment changes.',CV_TYPE_NEW_sagging_skin_descr_low:'We discovered from your selfie that your skin looks firm and does not exhibit signs of looseness',HINTS_sagging_skin:'The most common cause of sagging skin is aging that causes a loss of collagen, making your skin seem looser than before. Although looseness of the skin is perfectly natural, specific skincare products have been developed to sustain collagen and firm the skin.',CV_TYPE_crows_feet:'Crows Feet',CV_TYPE_NEW_crows_feet_descr_high:'We discovered from your selfie that you have signs of crow´s feet around your eyes. We will take this into consideration in helping you discover products that will help reduce the impact and visibility of any signs of pigment changes.',CV_TYPE_NEW_crows_feet_descr_med:'We discovered from your selfie that you have some signs of crow´s feet around your eyes. We will take this into consideration in helping you discover products that will help reduce the impact and visibility of any signs of pigment changes.',CV_TYPE_NEW_crows_feet_descr_low:'We discovered from your selfie that aging around your eyes is not an issue for you',HINTS_crows_feet:'Crow´s feet are a perfectly naturel part of maturing. Often worsened by squinting, crow´s feet can appear as early as in your thirties. Luckily, targeted skincare remedies to reduce the impact of crow´s exist.',CV_TYPE_visible_pores:'Visible Pores',CV_TYPE_NEW_visible_pores_descr_high:'We discovered from your selfie that you have signs of enlarged pores on your skin. We will take this into consideration in helping you discover products that will help reduce the impact and visibility of any signs of pigment changes.',CV_TYPE_NEW_visible_pores_descr_med:'We discovered from your selfie that you have some signs of enlarged pores on your skin. We will take this into consideration in helping you discover products that will help reduce the impact and visibility of any signs of pigment changes.',CV_TYPE_NEW_visible_pores_descr_low:'We discovered from your selfie that enlarged pores on your skin are not a consideration for you',HINTS_visible_pores:'Enlarged pores are caused by excess oil production on your skin. Enlarged pores are likely to get clogged from impurities. Using skincare products to regularly help unclog your pores and reduce excess oil production will help in clearing your skin.',CV_TYPE_dark_circle:'Dark circles',CV_TYPE_NEW_dark_circle_descr_high:'We discovered from your selfie that you have signs of dark circles under your eyes. We will take this into consideration in helping you discover products that will help reduce the impact and visibility of any signs of pigment changes.',CV_TYPE_NEW_dark_circle_descr_med:'We discovered from your selfie that you have some signs of dark circles under your eyes. We will take this into consideration in helping you discover products that will help reduce the impact and visibility of any signs of pigment changes.',CV_TYPE_NEW_dark_circle_descr_low:'We discovered from your selfie that tiredness of the eyes is not a concern for you',HINTS_dark_circle:'Dark circles under your eyes can be caused by a multitude of factors. Allergies, thinning of the skin, eczema or loss of collagen can all be contributing to the dark circles forming under your eyes. Although there is no miracle cure, specifically designed skincare products containing targeted dark circle reducing ingredients such as retinol can dramatically reduce the visibility of dark cirles.',show_cv_results:'Analysis results',attribute_descriptions_anti_age:'Helps your skin look young and rejuvinated',attribute_descriptions_eye_bag_reduction:'Helps revitalize your undereye area ',attribute_descriptions_wrinkle_reduction:'Reduces lines and wrinkles on your face',attribute_descriptions_redness_reduction:'Reduces the redness visible on your skin',attribute_descriptions_sun_protection:'Protects your skin from damage caused by the sun',attribute_descriptions_pollution_protection:'Helps combat the effects of pollution',attribute_descriptions_dark_spot_reduction:'Makes your skin look more even',attribute_descriptions_dry_skin_assist:'Moisturizes your skin and helps prevent dryness',attribute_descriptions_dry_skin:'Ideal for your dry skin',attribute_descriptions_combination_skin:'Ideal for your combination skin',attribute_descriptions_oily_skin:'Ideal for your oily skin',attribute_descriptions_sensitive_skin:'Ideal for sensitive skin like yours',attribute_descriptions_normal_skin:'Works very well for normal skin',attribute_descriptions_anti_acne:'Helps fight signs of acne',attribute_descriptions_anti_eczema:'Helps combat the visible effects of eczema',attribute_descriptions_anti_rosacea:'Keeps rosacea under control',attribute_descriptions_anti_cuperose:'Keeps the symptoms of cuperose at bay',crows_feet_ui:'Crow\'s Feet',visible_pores_ui:'Visible Pores',sagging_skin_ui:'Sagging Skin',wrinkles_ui:'Wrinkles And Fine Lines',puffy_eyes_ui:'Puffy eyes',eyebags_ui:'Eye bags',dark_circles_ui:'Dark Circles Under Eyes',redness_ui:'Redness',rocasea_ui:'Rosacea',coperose_ui:'Couperose',eczema_ui:'Eczema',acne_ui:'Acne',dull_skin_ui:'Dull Skin',hyperpigmentation_ui:'Hyperpigmentation',cuperose_ui:'Couperose'}};/* harmony default export */ __webpack_exports__["a"] = (messages);

/***/ }),
/* 100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MediaQueries__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_motion__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_motion___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_motion__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_addons_css_transition_group__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_addons_css_transition_group___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_addons_css_transition_group__);
var _jsx=function(){var REACT_ELEMENT_TYPE=typeof Symbol==="function"&&Symbol.for&&Symbol.for("react.element")||0xeac7;return function createRawReactElement(type,props,key,children){var defaultProps=type&&type.defaultProps;var childrenLength=arguments.length-3;if(!props&&childrenLength!==0){props={};}if(props&&defaultProps){for(var propName in defaultProps){if(props[propName]===void 0){props[propName]=defaultProps[propName];}}}else if(!props){props=defaultProps||{};}if(childrenLength===1){props.children=children;}else if(childrenLength>1){var childArray=Array(childrenLength);for(var i=0;i<childrenLength;i++){childArray[i]=arguments[i+3];}props.children=childArray;}return{$$typeof:REACT_ELEMENT_TYPE,type:type,key:key===undefined?null:''+key,ref:null,props:props,_owner:null};};}();var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n  position: absolute;\n  bottom: ',';\n  left: 0;\n  right: 0;\n  margin: 0 auto;\n  height: 164px;\n  width: 100%;\n  max-width: 992px;\n  padding: 0 30px;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-around;\n  align-items: center;\n  transition: all 400ms ease-in-out;\n  ','\n'],['\n  position: absolute;\n  bottom: ',';\n  left: 0;\n  right: 0;\n  margin: 0 auto;\n  height: 164px;\n  width: 100%;\n  max-width: 992px;\n  padding: 0 30px;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-around;\n  align-items: center;\n  transition: all 400ms ease-in-out;\n  ','\n']),_templateObject2=_taggedTemplateLiteral(['\n    bottom: 0;\n  '],['\n    bottom: 0;\n  ']),_templateObject3=_taggedTemplateLiteral(['\n  width: 100%;\n  position: relative;\n  height: 134px;\n'],['\n  width: 100%;\n  position: relative;\n  height: 134px;\n']);function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var StyledFooter=__WEBPACK_IMPORTED_MODULE_1_styled_components__["b" /* default */].div(_templateObject,function(props){return props.minimized?'-170px':'0px';},__WEBPACK_IMPORTED_MODULE_2__MediaQueries__["a" /* default */].phone(_templateObject2));var StyledFooterWidgetContainer=__WEBPACK_IMPORTED_MODULE_1_styled_components__["b" /* default */].div(_templateObject3);var springSetting1={stiffness:500,damping:60};var Footer=function(_Component){_inherits(Footer,_Component);function Footer(props){_classCallCheck(this,Footer);var _this=_possibleConstructorReturn(this,(Footer.__proto__||Object.getPrototypeOf(Footer)).call(this,props));_this.handleTouchStart=function(key,pressLocation,e){_this.setDrag(false);_this.handleMouseDown(key,pressLocation,e.touches[0]);};_this.handleTouchMove=function(e){_this.setDrag(true);e.preventDefault();_this.handleMouseMove(e.touches[0]);};_this.handleMouseMove=function(_ref){var pageX=_ref.pageX,pageY=_ref.pageY;var _this$state=_this.state,isPressed=_this$state.isPressed,_this$state$mouseCirc=_slicedToArray(_this$state.mouseCircleDelta,2),dx=_this$state$mouseCirc[0],dy=_this$state$mouseCirc[1];if(isPressed){var mouseXY=[pageX-dx,pageY-dy];_this.setState({mouseXY:mouseXY});_this.setDrag(true);}};_this.handleMouseDown=function(key,_ref2,_ref3){var _ref4=_slicedToArray(_ref2,2),pressX=_ref4[0],pressY=_ref4[1];var pageX=_ref3.pageX,pageY=_ref3.pageY;_this.setDrag(false);_this.setState({lastPress:key,isPressed:true,mouseCircleDelta:[pageX-pressX,pageY-pressY],mouseXY:[pressX,pressY]});};_this.handleMouseUp=function(){_this.setState({isPressed:false,mouseCircleDelta:[0,0]});};_this.render=function(){var _this$props=_this.props,widgets=_this$props.widgets,progress=_this$props.progress,visible=_this$props.visible;var mouseXY=_this.state.mouseXY;/*

    Compare the width of footer to the width of the page
    and decide if the footer can be dragged.

    if (this.footer) {
      console.log(this.footer.offsetWidth);
      console.log(rootElement.offsetWidth);
    }

    */var _mouseXY=_slicedToArray(mouseXY,2),x=_mouseXY[0],y=_mouseXY[1];if(!widgets){return null;}var style={translateX:Object(__WEBPACK_IMPORTED_MODULE_3_react_motion__["spring"])(x,springSetting1)};return _jsx(__WEBPACK_IMPORTED_MODULE_4_react_addons_css_transition_group___default.a,{transitionName:'footerSlide',transitionAppear:false,transitionEnter:true,transitionLeave:true,transitionAppearTimeout:1500,transitionLeaveTimeout:1500,transitionEnterTimeout:1500},void 0,visible?_jsx(StyledFooter,{innerRef:function innerRef(footer){_this.footer=footer;},className:'revieve-footer',onMouseDown:_this.handleMouseDown.bind(null,'footerMotion',[x,y]),onTouchStart:_this.handleTouchStart.bind(null,'footerMotion',[x,y]),minimized:_this.props.minimized},'footer',_jsx(__WEBPACK_IMPORTED_MODULE_3_react_motion__["Motion"],{style:style},'footerMotion',function(_ref5){var translateX=_ref5.translateX;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(StyledFooterWidgetContainer,{ref:function ref(fwc){_this.fwc=fwc;},style:{transform:'translate3d('+translateX+'px, 0px, 0)'}},widgets);}),progress):null);};_this.state=_this.initState();return _this;}_createClass(Footer,[{key:'setDrag',value:function setDrag(boolean){this.props.setDrag(boolean);}},{key:'initState',value:function initState(){return{mouseXY:[0,0],mouseCircleDelta:[0,0],// difference between mouse and circle pos for x + y coords, for dragging
lastPress:null,// key of the last pressed component
isPressed:false};}// TODO: the drag detection makes it hard to click the items sometimes.
// if the finger / mouse moves even 1px while tapping, it will be 'drag' and
// the user selection will be ignored.
},{key:'disableSelect',value:function disableSelect(event){event.preventDefault();}},{key:'componentDidMount',value:function componentDidMount(){window.addEventListener('touchmove',this.handleTouchMove);window.addEventListener('touchend',this.handleMouseUp);window.addEventListener('mousemove',this.handleMouseMove);window.addEventListener('mouseup',this.handleMouseUp);window.addEventListener('selectstart',this.disableSelect);}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(props){// Reset drag position on page switch, when filters has changed or pricegroup has changed
if(props.pageIndex!==this.props.pageIndex||props.filters!==this.props.filters||props.pricegroup!==this.props.pricegroup){this.setState(this.initState());}}}]);return Footer;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Footer);

/***/ }),
/* 101 */
/***/ (function(module, exports) {

module.exports = function(originalModule) {
	if(!originalModule.webpackPolyfill) {
		var module = Object.create(originalModule);
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		Object.defineProperty(module, "exports", {
			enumerable: true,
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

!function(e){ true?module.exports=e(null):"function"==typeof define&&define.amd?define(e(null)):window.stylis=e(null)}(function e(a){"use strict";var r=/^\0+/g,c=/[\0\r\f]/g,s=/: */g,t=/zoo|gra/,i=/([,: ])(transform)/g,f=/,+\s*(?![^(]*[)])/g,n=/ +\s*(?![^(]*[)])/g,l=/ *[\0] */g,o=/,\r+?/g,h=/([\t\r\n ])*\f?&/g,u=/:global\(((?:[^\(\)\[\]]*|\[.*\]|\([^\(\)]*\))*)\)/g,d=/\W+/g,b=/@(k\w+)\s*(\S*)\s*/,p=/::(place)/g,k=/:(read-only)/g,g=/\s+(?=[{\];=:>])/g,A=/([[}=:>])\s+/g,C=/(\{[^{]+?);(?=\})/g,w=/\s{2,}/g,v=/([^\(])(:+) */g,m=/[svh]\w+-[tblr]{2}/,x=/\(\s*(.*)\s*\)/g,$=/([\s\S]*?);/g,y=/-self|flex-/g,O=/[^]*?(:[rp][el]a[\w-]+)[^]*/,j=/stretch|:\s*\w+\-(?:conte|avail)/,z=/([^-])(image-set\()/,N="-webkit-",S="-moz-",F="-ms-",W=59,q=125,B=123,D=40,E=41,G=91,H=93,I=10,J=13,K=9,L=64,M=32,P=38,Q=45,R=95,T=42,U=44,V=58,X=39,Y=34,Z=47,_=62,ee=43,ae=126,re=0,ce=12,se=11,te=107,ie=109,fe=115,ne=112,le=111,oe=105,he=99,ue=100,de=112,be=1,pe=1,ke=0,ge=1,Ae=1,Ce=1,we=0,ve=0,me=0,xe=[],$e=[],ye=0,Oe=null,je=-2,ze=-1,Ne=0,Se=1,Fe=2,We=3,qe=0,Be=1,De="",Ee="",Ge="";function He(e,a,s,t,i){for(var f,n,o=0,h=0,u=0,d=0,g=0,A=0,C=0,w=0,m=0,$=0,y=0,O=0,j=0,z=0,R=0,we=0,$e=0,Oe=0,je=0,ze=s.length,Je=ze-1,Re="",Te="",Ue="",Ve="",Xe="",Ye="";R<ze;){if(C=s.charCodeAt(R),R===Je)if(h+d+u+o!==0){if(0!==h)C=h===Z?I:Z;d=u=o=0,ze++,Je++}if(h+d+u+o===0){if(R===Je){if(we>0)Te=Te.replace(c,"");if(Te.trim().length>0){switch(C){case M:case K:case W:case J:case I:break;default:Te+=s.charAt(R)}C=W}}if(1===$e)switch(C){case B:case q:case W:case Y:case X:case D:case E:case U:$e=0;case K:case J:case I:case M:break;default:for($e=0,je=R,g=C,R--,C=W;je<ze;)switch(s.charCodeAt(je++)){case I:case J:case W:++R,C=g,je=ze;break;case V:if(we>0)++R,C=g;case B:je=ze}}switch(C){case B:for(g=(Te=Te.trim()).charCodeAt(0),y=1,je=++R;R<ze;){switch(C=s.charCodeAt(R)){case B:y++;break;case q:y--;break;case Z:switch(A=s.charCodeAt(R+1)){case T:case Z:R=Qe(A,R,Je,s)}break;case G:C++;case D:C++;case Y:case X:for(;R++<Je&&s.charCodeAt(R)!==C;);}if(0===y)break;R++}if(Ue=s.substring(je,R),g===re)g=(Te=Te.replace(r,"").trim()).charCodeAt(0);switch(g){case L:if(we>0)Te=Te.replace(c,"");switch(A=Te.charCodeAt(1)){case ue:case ie:case fe:case Q:f=a;break;default:f=xe}if(je=(Ue=He(a,f,Ue,A,i+1)).length,me>0&&0===je)je=Te.length;if(ye>0)if(f=Ie(xe,Te,Oe),n=Pe(We,Ue,f,a,pe,be,je,A,i,t),Te=f.join(""),void 0!==n)if(0===(je=(Ue=n.trim()).length))A=0,Ue="";if(je>0)switch(A){case fe:Te=Te.replace(x,Me);case ue:case ie:case Q:Ue=Te+"{"+Ue+"}";break;case te:if(Ue=(Te=Te.replace(b,"$1 $2"+(Be>0?De:"")))+"{"+Ue+"}",1===Ae||2===Ae&&Le("@"+Ue,3))Ue="@"+N+Ue+"@"+Ue;else Ue="@"+Ue;break;default:if(Ue=Te+Ue,t===de)Ve+=Ue,Ue=""}else Ue="";break;default:Ue=He(a,Ie(a,Te,Oe),Ue,t,i+1)}Xe+=Ue,O=0,$e=0,z=0,we=0,Oe=0,j=0,Te="",Ue="",C=s.charCodeAt(++R);break;case q:case W:if((je=(Te=(we>0?Te.replace(c,""):Te).trim()).length)>1){if(0===z)if((g=Te.charCodeAt(0))===Q||g>96&&g<123)je=(Te=Te.replace(" ",":")).length;if(ye>0)if(void 0!==(n=Pe(Se,Te,a,e,pe,be,Ve.length,t,i,t)))if(0===(je=(Te=n.trim()).length))Te="\0\0";switch(g=Te.charCodeAt(0),A=Te.charCodeAt(1),g){case re:break;case L:if(A===oe||A===he){Ye+=Te+s.charAt(R);break}default:if(Te.charCodeAt(je-1)===V)break;Ve+=Ke(Te,g,A,Te.charCodeAt(2))}}O=0,$e=0,z=0,we=0,Oe=0,Te="",C=s.charCodeAt(++R)}}switch(C){case J:case I:if(h+d+u+o+ve===0)switch($){case E:case X:case Y:case L:case ae:case _:case T:case ee:case Z:case Q:case V:case U:case W:case B:case q:break;default:if(z>0)$e=1}if(h===Z)h=0;else if(ge+O===0&&t!==te&&Te.length>0)we=1,Te+="\0";if(ye*qe>0)Pe(Ne,Te,a,e,pe,be,Ve.length,t,i,t);be=1,pe++;break;case W:case q:if(h+d+u+o===0){be++;break}default:switch(be++,Re=s.charAt(R),C){case K:case M:if(d+o+h===0)switch(w){case U:case V:case K:case M:Re="";break;default:if(C!==M)Re=" "}break;case re:Re="\\0";break;case ce:Re="\\f";break;case se:Re="\\v";break;case P:if(d+h+o===0&&ge>0)Oe=1,we=1,Re="\f"+Re;break;case 108:if(d+h+o+ke===0&&z>0)switch(R-z){case 2:if(w===ne&&s.charCodeAt(R-3)===V)ke=w;case 8:if(m===le)ke=m}break;case V:if(d+h+o===0)z=R;break;case U:if(h+u+d+o===0)we=1,Re+="\r";break;case Y:case X:if(0===h)d=d===C?0:0===d?C:d;break;case G:if(d+h+u===0)o++;break;case H:if(d+h+u===0)o--;break;case E:if(d+h+o===0)u--;break;case D:if(d+h+o===0){if(0===O)switch(2*w+3*m){case 533:break;default:y=0,O=1}u++}break;case L:if(h+u+d+o+z+j===0)j=1;break;case T:case Z:if(d+o+u>0)break;switch(h){case 0:switch(2*C+3*s.charCodeAt(R+1)){case 235:h=Z;break;case 220:je=R,h=T}break;case T:if(C===Z&&w===T&&je+2!==R){if(33===s.charCodeAt(je+2))Ve+=s.substring(je,R+1);Re="",h=0}}}if(0===h){if(ge+d+o+j===0&&t!==te&&C!==W)switch(C){case U:case ae:case _:case ee:case E:case D:if(0===O){switch(w){case K:case M:case I:case J:Re+="\0";break;default:Re="\0"+Re+(C===U?"":"\0")}we=1}else switch(C){case D:if(z+7===R&&108===w)z=0;O=++y;break;case E:if(0==(O=--y))we=1,Re+="\0"}break;case K:case M:switch(w){case re:case B:case q:case W:case U:case ce:case K:case M:case I:case J:break;default:if(0===O)we=1,Re+="\0"}}if(Te+=Re,C!==M&&C!==K)$=C}}m=w,w=C,R++}if(je=Ve.length,me>0)if(0===je&&0===Xe.length&&0===a[0].length==false)if(t!==ie||1===a.length&&(ge>0?Ee:Ge)===a[0])je=a.join(",").length+2;if(je>0){if(f=0===ge&&t!==te?function(e){for(var a,r,s=0,t=e.length,i=Array(t);s<t;++s){for(var f=e[s].split(l),n="",o=0,h=0,u=0,d=0,b=f.length;o<b;++o){if(0===(h=(r=f[o]).length)&&b>1)continue;if(u=n.charCodeAt(n.length-1),d=r.charCodeAt(0),a="",0!==o)switch(u){case T:case ae:case _:case ee:case M:case D:break;default:a=" "}switch(d){case P:r=a+Ee;case ae:case _:case ee:case M:case E:case D:break;case G:r=a+r+Ee;break;case V:switch(2*r.charCodeAt(1)+3*r.charCodeAt(2)){case 530:if(Ce>0){r=a+r.substring(8,h-1);break}default:if(o<1||f[o-1].length<1)r=a+Ee+r}break;case U:a="";default:if(h>1&&r.indexOf(":")>0)r=a+r.replace(v,"$1"+Ee+"$2");else r=a+r+Ee}n+=r}i[s]=n.replace(c,"").trim()}return i}(a):a,ye>0)if(void 0!==(n=Pe(Fe,Ve,f,e,pe,be,je,t,i,t))&&0===(Ve=n).length)return Ye+Ve+Xe;if(Ve=f.join(",")+"{"+Ve+"}",Ae*ke!=0){if(2===Ae&&!Le(Ve,2))ke=0;switch(ke){case le:Ve=Ve.replace(k,":"+S+"$1")+Ve;break;case ne:Ve=Ve.replace(p,"::"+N+"input-$1")+Ve.replace(p,"::"+S+"$1")+Ve.replace(p,":"+F+"input-$1")+Ve}ke=0}}return Ye+Ve+Xe}function Ie(e,a,r){var c=a.trim().split(o),s=c,t=c.length,i=e.length;switch(i){case 0:case 1:for(var f=0,n=0===i?"":e[0]+" ";f<t;++f)s[f]=Je(n,s[f],r,i).trim();break;default:f=0;var l=0;for(s=[];f<t;++f)for(var h=0;h<i;++h)s[l++]=Je(e[h]+" ",c[f],r,i).trim()}return s}function Je(e,a,r,c){var s=a,t=s.charCodeAt(0);if(t<33)t=(s=s.trim()).charCodeAt(0);switch(t){case P:switch(ge+c){case 0:case 1:if(0===e.trim().length)break;default:return s.replace(h,"$1"+e.trim())}break;case V:switch(s.charCodeAt(1)){case 103:if(Ce>0&&ge>0)return s.replace(u,"$1").replace(h,"$1"+Ge);break;default:return e.trim()+s.replace(h,"$1"+e.trim())}default:if(r*ge>0&&s.indexOf("\f")>0)return s.replace(h,(e.charCodeAt(0)===V?"":"$1")+e.trim())}return e+s}function Ke(e,a,r,c){var l,o=0,h=e+";",u=2*a+3*r+4*c;if(944===u)return function(e){var a=e.length,r=e.indexOf(":",9)+1,c=e.substring(0,r).trim(),s=e.substring(r,a-1).trim();switch(e.charCodeAt(9)*Be){case 0:break;case Q:if(110!==e.charCodeAt(10))break;default:for(var t=s.split((s="",f)),i=0,r=0,a=t.length;i<a;r=0,++i){for(var l=t[i],o=l.split(n);l=o[r];){var h=l.charCodeAt(0);if(1===Be&&(h>L&&h<90||h>96&&h<123||h===R||h===Q&&l.charCodeAt(1)!==Q))switch(isNaN(parseFloat(l))+(-1!==l.indexOf("("))){case 1:switch(l){case"infinite":case"alternate":case"backwards":case"running":case"normal":case"forwards":case"both":case"none":case"linear":case"ease":case"ease-in":case"ease-out":case"ease-in-out":case"paused":case"reverse":case"alternate-reverse":case"inherit":case"initial":case"unset":case"step-start":case"step-end":break;default:l+=De}}o[r++]=l}s+=(0===i?"":",")+o.join(" ")}}if(s=c+s+";",1===Ae||2===Ae&&Le(s,1))return N+s+s;return s}(h);else if(0===Ae||2===Ae&&!Le(h,1))return h;switch(u){case 1015:return 97===h.charCodeAt(10)?N+h+h:h;case 951:return 116===h.charCodeAt(3)?N+h+h:h;case 963:return 110===h.charCodeAt(5)?N+h+h:h;case 1009:if(100!==h.charCodeAt(4))break;case 969:case 942:return N+h+h;case 978:return N+h+S+h+h;case 1019:case 983:return N+h+S+h+F+h+h;case 883:if(h.charCodeAt(8)===Q)return N+h+h;if(h.indexOf("image-set(",11)>0)return h.replace(z,"$1"+N+"$2")+h;return h;case 932:if(h.charCodeAt(4)===Q)switch(h.charCodeAt(5)){case 103:return N+"box-"+h.replace("-grow","")+N+h+F+h.replace("grow","positive")+h;case 115:return N+h+F+h.replace("shrink","negative")+h;case 98:return N+h+F+h.replace("basis","preferred-size")+h}return N+h+F+h+h;case 964:return N+h+F+"flex-"+h+h;case 1023:if(99!==h.charCodeAt(8))break;return l=h.substring(h.indexOf(":",15)).replace("flex-","").replace("space-between","justify"),N+"box-pack"+l+N+h+F+"flex-pack"+l+h;case 1005:return t.test(h)?h.replace(s,":"+N)+h.replace(s,":"+S)+h:h;case 1e3:switch(o=(l=h.substring(13).trim()).indexOf("-")+1,l.charCodeAt(0)+l.charCodeAt(o)){case 226:l=h.replace(m,"tb");break;case 232:l=h.replace(m,"tb-rl");break;case 220:l=h.replace(m,"lr");break;default:return h}return N+h+F+l+h;case 1017:if(-1===h.indexOf("sticky",9))return h;case 975:switch(o=(h=e).length-10,u=(l=(33===h.charCodeAt(o)?h.substring(0,o):h).substring(e.indexOf(":",7)+1).trim()).charCodeAt(0)+(0|l.charCodeAt(7))){case 203:if(l.charCodeAt(8)<111)break;case 115:h=h.replace(l,N+l)+";"+h;break;case 207:case 102:h=h.replace(l,N+(u>102?"inline-":"")+"box")+";"+h.replace(l,N+l)+";"+h.replace(l,F+l+"box")+";"+h}return h+";";case 938:if(h.charCodeAt(5)===Q)switch(h.charCodeAt(6)){case 105:return l=h.replace("-items",""),N+h+N+"box-"+l+F+"flex-"+l+h;case 115:return N+h+F+"flex-item-"+h.replace(y,"")+h;default:return N+h+F+"flex-line-pack"+h.replace("align-content","").replace(y,"")+h}break;case 973:case 989:if(h.charCodeAt(3)!==Q||122===h.charCodeAt(4))break;case 931:case 953:if(true===j.test(e))if(115===(l=e.substring(e.indexOf(":")+1)).charCodeAt(0))return Ke(e.replace("stretch","fill-available"),a,r,c).replace(":fill-available",":stretch");else return h.replace(l,N+l)+h.replace(l,S+l.replace("fill-",""))+h;break;case 962:if(h=N+h+(102===h.charCodeAt(5)?F+h:"")+h,r+c===211&&105===h.charCodeAt(13)&&h.indexOf("transform",10)>0)return h.substring(0,h.indexOf(";",27)+1).replace(i,"$1"+N+"$2")+h}return h}function Le(e,a){var r=e.indexOf(1===a?":":"{"),c=e.substring(0,3!==a?r:10),s=e.substring(r+1,e.length-1);return Oe(2!==a?c:c.replace(O,"$1"),s,a)}function Me(e,a){var r=Ke(a,a.charCodeAt(0),a.charCodeAt(1),a.charCodeAt(2));return r!==a+";"?r.replace($," or ($1)").substring(4):"("+a+")"}function Pe(e,a,r,c,s,t,i,f,n,l){for(var o,h=0,u=a;h<ye;++h)switch(o=$e[h].call(Te,e,u,r,c,s,t,i,f,n,l)){case void 0:case false:case true:case null:break;default:u=o}if(u!==a)return u}function Qe(e,a,r,c){for(var s=a+1;s<r;++s)switch(c.charCodeAt(s)){case Z:if(e===T)if(c.charCodeAt(s-1)===T&&a+2!==s)return s+1;break;case I:if(e===Z)return s+1}return s}function Re(e){for(var a in e){var r=e[a];switch(a){case"keyframe":Be=0|r;break;case"global":Ce=0|r;break;case"cascade":ge=0|r;break;case"compress":we=0|r;break;case"semicolon":ve=0|r;break;case"preserve":me=0|r;break;case"prefix":if(Oe=null,!r)Ae=0;else if("function"!=typeof r)Ae=1;else Ae=2,Oe=r}}return Re}function Te(a,r){if(void 0!==this&&this.constructor===Te)return e(a);var s=a,t=s.charCodeAt(0);if(t<33)t=(s=s.trim()).charCodeAt(0);if(Be>0)De=s.replace(d,t===G?"":"-");if(t=1,1===ge)Ge=s;else Ee=s;var i,f=[Ge];if(ye>0)if(void 0!==(i=Pe(ze,r,f,f,pe,be,0,0,0,0))&&"string"==typeof i)r=i;var n=He(xe,f,r,0,0);if(ye>0)if(void 0!==(i=Pe(je,n,f,f,pe,be,n.length,0,0,0))&&"string"!=typeof(n=i))t=0;return De="",Ge="",Ee="",ke=0,pe=1,be=1,we*t==0?n:n.replace(c,"").replace(g,"").replace(A,"$1").replace(C,"$1").replace(w," ")}if(Te.use=function e(a){switch(a){case void 0:case null:ye=$e.length=0;break;default:if("function"==typeof a)$e[ye++]=a;else if("object"==typeof a)for(var r=0,c=a.length;r<c;++r)e(a[r]);else qe=0|!!a}return e},Te.set=Re,void 0!==a)Re(a);return Te});
//# sourceMappingURL=stylis.min.js.map

/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

(function (factory) {
	 true ? (module['exports'] = factory()) :
		typeof define === 'function' && define['amd'] ? define(factory()) :
			(window['stylisRuleSheet'] = factory())
}(function () {

	'use strict'

	return function (insertRule) {
		var delimiter = '/*|*/'
		var needle = delimiter+'}'

		function toSheet (block) {
			if (block)
				try {
					insertRule(block + '}')
				} catch (e) {}
		}

		return function ruleSheet (context, content, selectors, parents, line, column, length, ns, depth, at) {
			switch (context) {
				// property
				case 1:
					// @import
					if (depth === 0 && content.charCodeAt(0) === 64)
						return insertRule(content+';'), ''
					break
				// selector
				case 2:
					if (ns === 0)
						return content + delimiter
					break
				// at-rule
				case 3:
					switch (ns) {
						// @font-face, @page
						case 102:
						case 112:
							return insertRule(selectors[0]+content), ''
						default:
							return content + (at === 0 ? delimiter : '')
					}
				case -2:
					content.split(needle).forEach(toSheet)
			}
		}
	}
}))


/***/ }),
/* 104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var unitlessKeys = {
  animationIterationCount: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
};

/* harmony default export */ __webpack_exports__["a"] = (unitlessKeys);


/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(106);
} else {
  module.exports = require('./cjs/react-is.development.js');
}


/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.9.0
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

Object.defineProperty(exports,"__esModule",{value:!0});
var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?Symbol.for("react.suspense_list"):
60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.fundamental"):60117,w=b?Symbol.for("react.responder"):60118;function x(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case h:return a;default:return u}}case t:case r:case d:return u}}}function y(a){return x(a)===m}exports.typeOf=x;exports.AsyncMode=l;
exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;exports.Fragment=e;exports.Lazy=t;exports.Memo=r;exports.Portal=d;exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;
exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===v||a.$$typeof===w)};exports.isAsyncMode=function(a){return y(a)||x(a)===l};exports.isConcurrentMode=y;exports.isContextConsumer=function(a){return x(a)===k};exports.isContextProvider=function(a){return x(a)===h};
exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return x(a)===n};exports.isFragment=function(a){return x(a)===e};exports.isLazy=function(a){return x(a)===t};exports.isMemo=function(a){return x(a)===r};exports.isPortal=function(a){return x(a)===d};exports.isProfiler=function(a){return x(a)===g};exports.isStrictMode=function(a){return x(a)===f};exports.isSuspense=function(a){return x(a)===p};


/***/ }),
/* 107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function areInputsEqual(newInputs, lastInputs) {
  if (newInputs.length !== lastInputs.length) {
    return false;
  }

  for (var i = 0; i < newInputs.length; i++) {
    if (newInputs[i] !== lastInputs[i]) {
      return false;
    }
  }

  return true;
}

function memoizeOne(resultFn, isEqual) {
  if (isEqual === void 0) {
    isEqual = areInputsEqual;
  }

  var lastThis;
  var lastArgs = [];
  var lastResult;
  var calledOnce = false;

  var result = function memoized() {
    for (var _len = arguments.length, newArgs = new Array(_len), _key = 0; _key < _len; _key++) {
      newArgs[_key] = arguments[_key];
    }

    if (calledOnce && lastThis === this && isEqual(newArgs, lastArgs)) {
      return lastResult;
    }

    lastResult = resultFn.apply(this, newArgs);
    calledOnce = true;
    lastThis = this;
    lastArgs = newArgs;
    return lastResult;
  };

  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (memoizeOne);


/***/ }),
/* 108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__emotion_memoize__ = __webpack_require__(109);


var reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|download|draggable|encType|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|itemProp|itemScope|itemType|itemID|itemRef|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23

var index = Object(__WEBPACK_IMPORTED_MODULE_0__emotion_memoize__["a" /* default */])(function (prop) {
  return reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111
  /* o */
  && prop.charCodeAt(1) === 110
  /* n */
  && prop.charCodeAt(2) < 91;
}
/* Z+1 */
);

/* harmony default export */ __webpack_exports__["a"] = (index);


/***/ }),
/* 109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function memoize(fn) {
  var cache = {};
  return function (arg) {
    if (cache[arg] === undefined) cache[arg] = fn(arg);
    return cache[arg];
  };
}

/* harmony default export */ __webpack_exports__["a"] = (memoize);


/***/ }),
/* 110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export merge */
/* unused harmony export concatArrays */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_is_what__ = __webpack_require__(111);


function assignProp(carry, key, newVal, originalObject) {
    var propType = originalObject.propertyIsEnumerable(key)
        ? 'enumerable'
        : 'nonenumerable';
    if (propType === 'enumerable')
        carry[key] = newVal;
    if (propType === 'nonenumerable') {
        Object.defineProperty(carry, key, {
            value: newVal,
            enumerable: false,
            writable: true,
            configurable: true
        });
    }
}
function mergeRecursively(origin, newComer, extensions) {
    // work directly on newComer if its not an object
    if (!Object(__WEBPACK_IMPORTED_MODULE_0_is_what__["b" /* isPlainObject */])(newComer)) {
        // extend merge rules
        if (extensions && Object(__WEBPACK_IMPORTED_MODULE_0_is_what__["a" /* isArray */])(extensions)) {
            extensions.forEach(function (extend) {
                newComer = extend(origin, newComer);
            });
        }
        return newComer;
    }
    // define newObject to merge all values upon
    var newObject = {};
    if (Object(__WEBPACK_IMPORTED_MODULE_0_is_what__["b" /* isPlainObject */])(origin)) {
        var props_1 = Object.getOwnPropertyNames(origin);
        var symbols_1 = Object.getOwnPropertySymbols(origin);
        newObject = props_1.concat(symbols_1).reduce(function (carry, key) {
            // @ts-ignore
            var targetVal = origin[key];
            if ((!Object(__WEBPACK_IMPORTED_MODULE_0_is_what__["c" /* isSymbol */])(key) && !Object.getOwnPropertyNames(newComer).includes(key)) ||
                (Object(__WEBPACK_IMPORTED_MODULE_0_is_what__["c" /* isSymbol */])(key) && !Object.getOwnPropertySymbols(newComer).includes(key))) {
                assignProp(carry, key, targetVal, origin);
            }
            return carry;
        }, {});
    }
    var props = Object.getOwnPropertyNames(newComer);
    var symbols = Object.getOwnPropertySymbols(newComer);
    var result = props.concat(symbols).reduce(function (carry, key) {
        // re-define the origin and newComer as targetVal and newVal
        var newVal = newComer[key];
        var targetVal = (Object(__WEBPACK_IMPORTED_MODULE_0_is_what__["b" /* isPlainObject */])(origin))
            // @ts-ignore
            ? origin[key]
            : undefined;
        // extend merge rules
        if (extensions && Object(__WEBPACK_IMPORTED_MODULE_0_is_what__["a" /* isArray */])(extensions)) {
            extensions.forEach(function (extend) {
                newVal = extend(targetVal, newVal);
            });
        }
        // When newVal is an object do the merge recursively
        if (targetVal !== undefined && Object(__WEBPACK_IMPORTED_MODULE_0_is_what__["b" /* isPlainObject */])(newVal)) {
            newVal = mergeRecursively(targetVal, newVal, extensions);
        }
        assignProp(carry, key, newVal, newComer);
        return carry;
    }, newObject);
    return result;
}
/**
 * Merge anything recursively.
 * Objects get merged, special objects (classes etc.) are re-assigned "as is".
 * Basic types overwrite objects or other basic types.
 *
 * @param {(IConfig | any)} origin
 * @param {...any[]} newComers
 * @returns the result
 */
function merge(origin) {
    var newComers = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        newComers[_i - 1] = arguments[_i];
    }
    var extensions = null;
    var base = origin;
    if (Object(__WEBPACK_IMPORTED_MODULE_0_is_what__["b" /* isPlainObject */])(origin) && origin.extensions && Object.keys(origin).length === 1) {
        base = {};
        extensions = origin.extensions;
    }
    return newComers.reduce(function (result, newComer) {
        return mergeRecursively(result, newComer, extensions);
    }, base);
}

function concatArrays(originVal, newVal) {
    if (Object(__WEBPACK_IMPORTED_MODULE_0_is_what__["a" /* isArray */])(originVal) && Object(__WEBPACK_IMPORTED_MODULE_0_is_what__["a" /* isArray */])(newVal)) {
        // concat logic
        return originVal.concat(newVal);
    }
    return newVal; // always return newVal as fallback!!
}

/* harmony default export */ __webpack_exports__["a"] = (merge);



/***/ }),
/* 111 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getType */
/* unused harmony export isUndefined */
/* unused harmony export isNull */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return isPlainObject; });
/* unused harmony export isObject */
/* unused harmony export isAnyObject */
/* unused harmony export isObjectLike */
/* unused harmony export isFunction */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return isArray; });
/* unused harmony export isString */
/* unused harmony export isFullString */
/* unused harmony export isEmptyString */
/* unused harmony export isNumber */
/* unused harmony export isBoolean */
/* unused harmony export isRegExp */
/* unused harmony export isDate */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return isSymbol; });
/* unused harmony export isPrimitive */
/* unused harmony export isType */
/**
 * Returns the object type of the given payload
 *
 * @param {*} payload
 * @returns {string}
 */
function getType(payload) {
    return Object.prototype.toString.call(payload).slice(8, -1);
}
/**
 * Returns whether the payload is undefined
 *
 * @param {*} payload
 * @returns {payload is undefined}
 */
function isUndefined(payload) {
    return getType(payload) === 'Undefined';
}
/**
 * Returns whether the payload is null
 *
 * @param {*} payload
 * @returns {payload is null}
 */
function isNull(payload) {
    return getType(payload) === 'Null';
}
/**
 * Returns whether the payload is a plain JavaScript object (excluding special classes or objects with other prototypes)
 *
 * @param {*} payload
 * @returns {payload is {[key: string]: any}}
 */
function isPlainObject(payload) {
    if (getType(payload) !== 'Object')
        return false;
    return (payload.constructor === Object && Object.getPrototypeOf(payload) === Object.prototype);
}
/**
 * Returns whether the payload is a plain JavaScript object (excluding special classes or objects with other prototypes)
 *
 * @param {*} payload
 * @returns {payload is {[key: string]: any}}
 */
function isObject(payload) {
    return isPlainObject(payload);
}
/**
 * Returns whether the payload is an any kind of object (including special classes or objects with different prototypes)
 *
 * @param {*} payload
 * @returns {payload is {[key: string]: any}}
 */
function isAnyObject(payload) {
    return getType(payload) === 'Object';
}
/**
 * Returns whether the payload is an object like a type passed in < >
 *
 * Usage: isObjectLike<{id: any}>(payload) // will make sure it's an object and has an `id` prop.
 *
 * @template T this must be passed in < >
 * @param {*} payload
 * @returns {payload is T}
 */
function isObjectLike(payload) {
    return isAnyObject(payload);
}
/**
 * Returns whether the payload is a function
 *
 * @param {*} payload
 * @returns {payload is Function}
 */
function isFunction(payload) {
    return getType(payload) === 'Function';
}
/**
 * Returns whether the payload is an array
 *
 * @param {*} payload
 * @returns {payload is undefined}
 */
function isArray(payload) {
    return getType(payload) === 'Array';
}
/**
 * Returns whether the payload is a string
 *
 * @param {*} payload
 * @returns {payload is string}
 */
function isString(payload) {
    return getType(payload) === 'String';
}
/**
 * Returns whether the payload is a string, BUT returns false for ''
 *
 * @param {*} payload
 * @returns {payload is string}
 */
function isFullString(payload) {
    return isString(payload) && payload !== '';
}
/**
 * Returns whether the payload is ''
 *
 * @param {*} payload
 * @returns {payload is string}
 */
function isEmptyString(payload) {
    return payload === '';
}
/**
 * Returns whether the payload is a number
 *
 * This will return false for NaN
 *
 * @param {*} payload
 * @returns {payload is number}
 */
function isNumber(payload) {
    return (getType(payload) === 'Number' && !isNaN(payload));
}
/**
 * Returns whether the payload is a boolean
 *
 * @param {*} payload
 * @returns {payload is boolean}
 */
function isBoolean(payload) {
    return getType(payload) === 'Boolean';
}
/**
 * Returns whether the payload is a regular expression
 *
 * @param {*} payload
 * @returns {payload is RegExp}
 */
function isRegExp(payload) {
    return getType(payload) === 'RegExp';
}
/**
 * Returns whether the payload is a date, and that the date is Valid
 *
 * @param {*} payload
 * @returns {payload is Date}
 */
function isDate(payload) {
    return (getType(payload) === 'Date' && !isNaN(payload));
}
/**
 * Returns whether the payload is a Symbol
 *
 * @param {*} payload
 * @returns {payload is symbol}
 */
function isSymbol(payload) {
    return (getType(payload) === 'Symbol');
}
/**
 * Returns whether the payload is a primitive type (eg. Boolean | Null | Undefined | Number | String | Symbol)
 *
 * @param {*} payload
 * @returns {(payload is boolean | null | undefined | number | string | symbol)}
 */
function isPrimitive(payload) {
    return (isBoolean(payload) ||
        isNull(payload) ||
        isUndefined(payload) ||
        isNumber(payload) ||
        isString(payload) ||
        isSymbol(payload));
}
/**
 * Does a generic check to check that the given payload is of a given type.
 * In cases like Number, it will return true for NaN as NaN is a Number (thanks javascript!);
 * It will, however, differentiate between object and null
 *
 * @template T
 * @param {*} payload
 * @param {T} type
 * @throws {TypeError} Will throw type error if type is an invalid type
 * @returns {payload is T}
 */
function isType(payload, type) {
    if (!(type instanceof Function)) {
        throw new TypeError('Type must be a function');
    }
    if (!type.hasOwnProperty('prototype')) {
        throw new TypeError('Type is not a class');
    }
    // Classes usually have names (as functions usually have names)
    var name = type.name;
    return (getType(payload) === name) || Boolean(payload && (payload.constructor === type));
}




/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

function _interopRequire(obj) { return obj && obj.__esModule ? obj['default'] : obj; }

var _Motion = __webpack_require__(113);

exports.Motion = _interopRequire(_Motion);

var _StaggeredMotion = __webpack_require__(115);

exports.StaggeredMotion = _interopRequire(_StaggeredMotion);

var _TransitionMotion = __webpack_require__(116);

exports.TransitionMotion = _interopRequire(_TransitionMotion);

var _spring = __webpack_require__(118);

exports.spring = _interopRequire(_spring);

var _presets = __webpack_require__(42);

exports.presets = _interopRequire(_presets);

var _stripStyle = __webpack_require__(13);

exports.stripStyle = _interopRequire(_stripStyle);

// deprecated, dummy warning function

var _reorderKeys = __webpack_require__(119);

exports.reorderKeys = _interopRequire(_reorderKeys);

/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _mapToZero = __webpack_require__(22);

var _mapToZero2 = _interopRequireDefault(_mapToZero);

var _stripStyle = __webpack_require__(13);

var _stripStyle2 = _interopRequireDefault(_stripStyle);

var _stepper3 = __webpack_require__(23);

var _stepper4 = _interopRequireDefault(_stepper3);

var _performanceNow = __webpack_require__(24);

var _performanceNow2 = _interopRequireDefault(_performanceNow);

var _raf = __webpack_require__(25);

var _raf2 = _interopRequireDefault(_raf);

var _shouldStopAnimation = __webpack_require__(26);

var _shouldStopAnimation2 = _interopRequireDefault(_shouldStopAnimation);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var msPerFrame = 1000 / 60;

var Motion = (function (_React$Component) {
  _inherits(Motion, _React$Component);

  _createClass(Motion, null, [{
    key: 'propTypes',
    value: {
      // TOOD: warn against putting a config in here
      defaultStyle: _propTypes2['default'].objectOf(_propTypes2['default'].number),
      style: _propTypes2['default'].objectOf(_propTypes2['default'].oneOfType([_propTypes2['default'].number, _propTypes2['default'].object])).isRequired,
      children: _propTypes2['default'].func.isRequired,
      onRest: _propTypes2['default'].func
    },
    enumerable: true
  }]);

  function Motion(props) {
    var _this = this;

    _classCallCheck(this, Motion);

    _React$Component.call(this, props);
    this.wasAnimating = false;
    this.animationID = null;
    this.prevTime = 0;
    this.accumulatedTime = 0;
    this.unreadPropStyle = null;

    this.clearUnreadPropStyle = function (destStyle) {
      var dirty = false;
      var _state = _this.state;
      var currentStyle = _state.currentStyle;
      var currentVelocity = _state.currentVelocity;
      var lastIdealStyle = _state.lastIdealStyle;
      var lastIdealVelocity = _state.lastIdealVelocity;

      for (var key in destStyle) {
        if (!Object.prototype.hasOwnProperty.call(destStyle, key)) {
          continue;
        }

        var styleValue = destStyle[key];
        if (typeof styleValue === 'number') {
          if (!dirty) {
            dirty = true;
            currentStyle = _extends({}, currentStyle);
            currentVelocity = _extends({}, currentVelocity);
            lastIdealStyle = _extends({}, lastIdealStyle);
            lastIdealVelocity = _extends({}, lastIdealVelocity);
          }

          currentStyle[key] = styleValue;
          currentVelocity[key] = 0;
          lastIdealStyle[key] = styleValue;
          lastIdealVelocity[key] = 0;
        }
      }

      if (dirty) {
        _this.setState({ currentStyle: currentStyle, currentVelocity: currentVelocity, lastIdealStyle: lastIdealStyle, lastIdealVelocity: lastIdealVelocity });
      }
    };

    this.startAnimationIfNecessary = function () {
      // TODO: when config is {a: 10} and dest is {a: 10} do we raf once and
      // call cb? No, otherwise accidental parent rerender causes cb trigger
      _this.animationID = _raf2['default'](function (timestamp) {
        // check if we need to animate in the first place
        var propsStyle = _this.props.style;
        if (_shouldStopAnimation2['default'](_this.state.currentStyle, propsStyle, _this.state.currentVelocity)) {
          if (_this.wasAnimating && _this.props.onRest) {
            _this.props.onRest();
          }

          // no need to cancel animationID here; shouldn't have any in flight
          _this.animationID = null;
          _this.wasAnimating = false;
          _this.accumulatedTime = 0;
          return;
        }

        _this.wasAnimating = true;

        var currentTime = timestamp || _performanceNow2['default']();
        var timeDelta = currentTime - _this.prevTime;
        _this.prevTime = currentTime;
        _this.accumulatedTime = _this.accumulatedTime + timeDelta;
        // more than 10 frames? prolly switched browser tab. Restart
        if (_this.accumulatedTime > msPerFrame * 10) {
          _this.accumulatedTime = 0;
        }

        if (_this.accumulatedTime === 0) {
          // no need to cancel animationID here; shouldn't have any in flight
          _this.animationID = null;
          _this.startAnimationIfNecessary();
          return;
        }

        var currentFrameCompletion = (_this.accumulatedTime - Math.floor(_this.accumulatedTime / msPerFrame) * msPerFrame) / msPerFrame;
        var framesToCatchUp = Math.floor(_this.accumulatedTime / msPerFrame);

        var newLastIdealStyle = {};
        var newLastIdealVelocity = {};
        var newCurrentStyle = {};
        var newCurrentVelocity = {};

        for (var key in propsStyle) {
          if (!Object.prototype.hasOwnProperty.call(propsStyle, key)) {
            continue;
          }

          var styleValue = propsStyle[key];
          if (typeof styleValue === 'number') {
            newCurrentStyle[key] = styleValue;
            newCurrentVelocity[key] = 0;
            newLastIdealStyle[key] = styleValue;
            newLastIdealVelocity[key] = 0;
          } else {
            var newLastIdealStyleValue = _this.state.lastIdealStyle[key];
            var newLastIdealVelocityValue = _this.state.lastIdealVelocity[key];
            for (var i = 0; i < framesToCatchUp; i++) {
              var _stepper = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);

              newLastIdealStyleValue = _stepper[0];
              newLastIdealVelocityValue = _stepper[1];
            }

            var _stepper2 = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);

            var nextIdealX = _stepper2[0];
            var nextIdealV = _stepper2[1];

            newCurrentStyle[key] = newLastIdealStyleValue + (nextIdealX - newLastIdealStyleValue) * currentFrameCompletion;
            newCurrentVelocity[key] = newLastIdealVelocityValue + (nextIdealV - newLastIdealVelocityValue) * currentFrameCompletion;
            newLastIdealStyle[key] = newLastIdealStyleValue;
            newLastIdealVelocity[key] = newLastIdealVelocityValue;
          }
        }

        _this.animationID = null;
        // the amount we're looped over above
        _this.accumulatedTime -= framesToCatchUp * msPerFrame;

        _this.setState({
          currentStyle: newCurrentStyle,
          currentVelocity: newCurrentVelocity,
          lastIdealStyle: newLastIdealStyle,
          lastIdealVelocity: newLastIdealVelocity
        });

        _this.unreadPropStyle = null;

        _this.startAnimationIfNecessary();
      });
    };

    this.state = this.defaultState();
  }

  Motion.prototype.defaultState = function defaultState() {
    var _props = this.props;
    var defaultStyle = _props.defaultStyle;
    var style = _props.style;

    var currentStyle = defaultStyle || _stripStyle2['default'](style);
    var currentVelocity = _mapToZero2['default'](currentStyle);
    return {
      currentStyle: currentStyle,
      currentVelocity: currentVelocity,
      lastIdealStyle: currentStyle,
      lastIdealVelocity: currentVelocity
    };
  };

  // it's possible that currentStyle's value is stale: if props is immediately
  // changed from 0 to 400 to spring(0) again, the async currentStyle is still
  // at 0 (didn't have time to tick and interpolate even once). If we naively
  // compare currentStyle with destVal it'll be 0 === 0 (no animation, stop).
  // In reality currentStyle should be 400

  Motion.prototype.componentDidMount = function componentDidMount() {
    this.prevTime = _performanceNow2['default']();
    this.startAnimationIfNecessary();
  };

  Motion.prototype.componentWillReceiveProps = function componentWillReceiveProps(props) {
    if (this.unreadPropStyle != null) {
      // previous props haven't had the chance to be set yet; set them here
      this.clearUnreadPropStyle(this.unreadPropStyle);
    }

    this.unreadPropStyle = props.style;
    if (this.animationID == null) {
      this.prevTime = _performanceNow2['default']();
      this.startAnimationIfNecessary();
    }
  };

  Motion.prototype.componentWillUnmount = function componentWillUnmount() {
    if (this.animationID != null) {
      _raf2['default'].cancel(this.animationID);
      this.animationID = null;
    }
  };

  Motion.prototype.render = function render() {
    var renderedChildren = this.props.children(this.state.currentStyle);
    return renderedChildren && _react2['default'].Children.only(renderedChildren);
  };

  return Motion;
})(_react2['default'].Component);

exports['default'] = Motion;
module.exports = exports['default'];

// after checking for unreadPropStyle != null, we manually go set the
// non-interpolating values (those that are a number, without a spring
// config)

/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {// Generated by CoffeeScript 1.12.2
(function() {
  var getNanoSeconds, hrtime, loadTime, moduleLoadTime, nodeLoadTime, upTime;

  if ((typeof performance !== "undefined" && performance !== null) && performance.now) {
    module.exports = function() {
      return performance.now();
    };
  } else if ((typeof process !== "undefined" && process !== null) && process.hrtime) {
    module.exports = function() {
      return (getNanoSeconds() - nodeLoadTime) / 1e6;
    };
    hrtime = process.hrtime;
    getNanoSeconds = function() {
      var hr;
      hr = hrtime();
      return hr[0] * 1e9 + hr[1];
    };
    moduleLoadTime = getNanoSeconds();
    upTime = process.uptime() * 1e9;
    nodeLoadTime = moduleLoadTime - upTime;
  } else if (Date.now) {
    module.exports = function() {
      return Date.now() - loadTime;
    };
    loadTime = Date.now();
  } else {
    module.exports = function() {
      return new Date().getTime() - loadTime;
    };
    loadTime = new Date().getTime();
  }

}).call(this);

//# sourceMappingURL=performance-now.js.map

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(11)))

/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _mapToZero = __webpack_require__(22);

var _mapToZero2 = _interopRequireDefault(_mapToZero);

var _stripStyle = __webpack_require__(13);

var _stripStyle2 = _interopRequireDefault(_stripStyle);

var _stepper3 = __webpack_require__(23);

var _stepper4 = _interopRequireDefault(_stepper3);

var _performanceNow = __webpack_require__(24);

var _performanceNow2 = _interopRequireDefault(_performanceNow);

var _raf = __webpack_require__(25);

var _raf2 = _interopRequireDefault(_raf);

var _shouldStopAnimation = __webpack_require__(26);

var _shouldStopAnimation2 = _interopRequireDefault(_shouldStopAnimation);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var msPerFrame = 1000 / 60;

function shouldStopAnimationAll(currentStyles, styles, currentVelocities) {
  for (var i = 0; i < currentStyles.length; i++) {
    if (!_shouldStopAnimation2['default'](currentStyles[i], styles[i], currentVelocities[i])) {
      return false;
    }
  }
  return true;
}

var StaggeredMotion = (function (_React$Component) {
  _inherits(StaggeredMotion, _React$Component);

  _createClass(StaggeredMotion, null, [{
    key: 'propTypes',
    value: {
      // TOOD: warn against putting a config in here
      defaultStyles: _propTypes2['default'].arrayOf(_propTypes2['default'].objectOf(_propTypes2['default'].number)),
      styles: _propTypes2['default'].func.isRequired,
      children: _propTypes2['default'].func.isRequired
    },
    enumerable: true
  }]);

  function StaggeredMotion(props) {
    var _this = this;

    _classCallCheck(this, StaggeredMotion);

    _React$Component.call(this, props);
    this.animationID = null;
    this.prevTime = 0;
    this.accumulatedTime = 0;
    this.unreadPropStyles = null;

    this.clearUnreadPropStyle = function (unreadPropStyles) {
      var _state = _this.state;
      var currentStyles = _state.currentStyles;
      var currentVelocities = _state.currentVelocities;
      var lastIdealStyles = _state.lastIdealStyles;
      var lastIdealVelocities = _state.lastIdealVelocities;

      var someDirty = false;
      for (var i = 0; i < unreadPropStyles.length; i++) {
        var unreadPropStyle = unreadPropStyles[i];
        var dirty = false;

        for (var key in unreadPropStyle) {
          if (!Object.prototype.hasOwnProperty.call(unreadPropStyle, key)) {
            continue;
          }

          var styleValue = unreadPropStyle[key];
          if (typeof styleValue === 'number') {
            if (!dirty) {
              dirty = true;
              someDirty = true;
              currentStyles[i] = _extends({}, currentStyles[i]);
              currentVelocities[i] = _extends({}, currentVelocities[i]);
              lastIdealStyles[i] = _extends({}, lastIdealStyles[i]);
              lastIdealVelocities[i] = _extends({}, lastIdealVelocities[i]);
            }
            currentStyles[i][key] = styleValue;
            currentVelocities[i][key] = 0;
            lastIdealStyles[i][key] = styleValue;
            lastIdealVelocities[i][key] = 0;
          }
        }
      }

      if (someDirty) {
        _this.setState({ currentStyles: currentStyles, currentVelocities: currentVelocities, lastIdealStyles: lastIdealStyles, lastIdealVelocities: lastIdealVelocities });
      }
    };

    this.startAnimationIfNecessary = function () {
      // TODO: when config is {a: 10} and dest is {a: 10} do we raf once and
      // call cb? No, otherwise accidental parent rerender causes cb trigger
      _this.animationID = _raf2['default'](function (timestamp) {
        var destStyles = _this.props.styles(_this.state.lastIdealStyles);

        // check if we need to animate in the first place
        if (shouldStopAnimationAll(_this.state.currentStyles, destStyles, _this.state.currentVelocities)) {
          // no need to cancel animationID here; shouldn't have any in flight
          _this.animationID = null;
          _this.accumulatedTime = 0;
          return;
        }

        var currentTime = timestamp || _performanceNow2['default']();
        var timeDelta = currentTime - _this.prevTime;
        _this.prevTime = currentTime;
        _this.accumulatedTime = _this.accumulatedTime + timeDelta;
        // more than 10 frames? prolly switched browser tab. Restart
        if (_this.accumulatedTime > msPerFrame * 10) {
          _this.accumulatedTime = 0;
        }

        if (_this.accumulatedTime === 0) {
          // no need to cancel animationID here; shouldn't have any in flight
          _this.animationID = null;
          _this.startAnimationIfNecessary();
          return;
        }

        var currentFrameCompletion = (_this.accumulatedTime - Math.floor(_this.accumulatedTime / msPerFrame) * msPerFrame) / msPerFrame;
        var framesToCatchUp = Math.floor(_this.accumulatedTime / msPerFrame);

        var newLastIdealStyles = [];
        var newLastIdealVelocities = [];
        var newCurrentStyles = [];
        var newCurrentVelocities = [];

        for (var i = 0; i < destStyles.length; i++) {
          var destStyle = destStyles[i];
          var newCurrentStyle = {};
          var newCurrentVelocity = {};
          var newLastIdealStyle = {};
          var newLastIdealVelocity = {};

          for (var key in destStyle) {
            if (!Object.prototype.hasOwnProperty.call(destStyle, key)) {
              continue;
            }

            var styleValue = destStyle[key];
            if (typeof styleValue === 'number') {
              newCurrentStyle[key] = styleValue;
              newCurrentVelocity[key] = 0;
              newLastIdealStyle[key] = styleValue;
              newLastIdealVelocity[key] = 0;
            } else {
              var newLastIdealStyleValue = _this.state.lastIdealStyles[i][key];
              var newLastIdealVelocityValue = _this.state.lastIdealVelocities[i][key];
              for (var j = 0; j < framesToCatchUp; j++) {
                var _stepper = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);

                newLastIdealStyleValue = _stepper[0];
                newLastIdealVelocityValue = _stepper[1];
              }

              var _stepper2 = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);

              var nextIdealX = _stepper2[0];
              var nextIdealV = _stepper2[1];

              newCurrentStyle[key] = newLastIdealStyleValue + (nextIdealX - newLastIdealStyleValue) * currentFrameCompletion;
              newCurrentVelocity[key] = newLastIdealVelocityValue + (nextIdealV - newLastIdealVelocityValue) * currentFrameCompletion;
              newLastIdealStyle[key] = newLastIdealStyleValue;
              newLastIdealVelocity[key] = newLastIdealVelocityValue;
            }
          }

          newCurrentStyles[i] = newCurrentStyle;
          newCurrentVelocities[i] = newCurrentVelocity;
          newLastIdealStyles[i] = newLastIdealStyle;
          newLastIdealVelocities[i] = newLastIdealVelocity;
        }

        _this.animationID = null;
        // the amount we're looped over above
        _this.accumulatedTime -= framesToCatchUp * msPerFrame;

        _this.setState({
          currentStyles: newCurrentStyles,
          currentVelocities: newCurrentVelocities,
          lastIdealStyles: newLastIdealStyles,
          lastIdealVelocities: newLastIdealVelocities
        });

        _this.unreadPropStyles = null;

        _this.startAnimationIfNecessary();
      });
    };

    this.state = this.defaultState();
  }

  StaggeredMotion.prototype.defaultState = function defaultState() {
    var _props = this.props;
    var defaultStyles = _props.defaultStyles;
    var styles = _props.styles;

    var currentStyles = defaultStyles || styles().map(_stripStyle2['default']);
    var currentVelocities = currentStyles.map(function (currentStyle) {
      return _mapToZero2['default'](currentStyle);
    });
    return {
      currentStyles: currentStyles,
      currentVelocities: currentVelocities,
      lastIdealStyles: currentStyles,
      lastIdealVelocities: currentVelocities
    };
  };

  StaggeredMotion.prototype.componentDidMount = function componentDidMount() {
    this.prevTime = _performanceNow2['default']();
    this.startAnimationIfNecessary();
  };

  StaggeredMotion.prototype.componentWillReceiveProps = function componentWillReceiveProps(props) {
    if (this.unreadPropStyles != null) {
      // previous props haven't had the chance to be set yet; set them here
      this.clearUnreadPropStyle(this.unreadPropStyles);
    }

    this.unreadPropStyles = props.styles(this.state.lastIdealStyles);
    if (this.animationID == null) {
      this.prevTime = _performanceNow2['default']();
      this.startAnimationIfNecessary();
    }
  };

  StaggeredMotion.prototype.componentWillUnmount = function componentWillUnmount() {
    if (this.animationID != null) {
      _raf2['default'].cancel(this.animationID);
      this.animationID = null;
    }
  };

  StaggeredMotion.prototype.render = function render() {
    var renderedChildren = this.props.children(this.state.currentStyles);
    return renderedChildren && _react2['default'].Children.only(renderedChildren);
  };

  return StaggeredMotion;
})(_react2['default'].Component);

exports['default'] = StaggeredMotion;
module.exports = exports['default'];

// it's possible that currentStyle's value is stale: if props is immediately
// changed from 0 to 400 to spring(0) again, the async currentStyle is still
// at 0 (didn't have time to tick and interpolate even once). If we naively
// compare currentStyle with destVal it'll be 0 === 0 (no animation, stop).
// In reality currentStyle should be 400

// after checking for unreadPropStyles != null, we manually go set the
// non-interpolating values (those that are a number, without a spring
// config)

/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _mapToZero = __webpack_require__(22);

var _mapToZero2 = _interopRequireDefault(_mapToZero);

var _stripStyle = __webpack_require__(13);

var _stripStyle2 = _interopRequireDefault(_stripStyle);

var _stepper3 = __webpack_require__(23);

var _stepper4 = _interopRequireDefault(_stepper3);

var _mergeDiff = __webpack_require__(117);

var _mergeDiff2 = _interopRequireDefault(_mergeDiff);

var _performanceNow = __webpack_require__(24);

var _performanceNow2 = _interopRequireDefault(_performanceNow);

var _raf = __webpack_require__(25);

var _raf2 = _interopRequireDefault(_raf);

var _shouldStopAnimation = __webpack_require__(26);

var _shouldStopAnimation2 = _interopRequireDefault(_shouldStopAnimation);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var msPerFrame = 1000 / 60;

// the children function & (potential) styles function asks as param an
// Array<TransitionPlainStyle>, where each TransitionPlainStyle is of the format
// {key: string, data?: any, style: PlainStyle}. However, the way we keep
// internal states doesn't contain such a data structure (check the state and
// TransitionMotionState). So when children function and others ask for such
// data we need to generate them on the fly by combining mergedPropsStyles and
// currentStyles/lastIdealStyles
function rehydrateStyles(mergedPropsStyles, unreadPropStyles, plainStyles) {
  // Copy the value to a `const` so that Flow understands that the const won't
  // change and will be non-nullable in the callback below.
  var cUnreadPropStyles = unreadPropStyles;
  if (cUnreadPropStyles == null) {
    return mergedPropsStyles.map(function (mergedPropsStyle, i) {
      return {
        key: mergedPropsStyle.key,
        data: mergedPropsStyle.data,
        style: plainStyles[i]
      };
    });
  }
  return mergedPropsStyles.map(function (mergedPropsStyle, i) {
    for (var j = 0; j < cUnreadPropStyles.length; j++) {
      if (cUnreadPropStyles[j].key === mergedPropsStyle.key) {
        return {
          key: cUnreadPropStyles[j].key,
          data: cUnreadPropStyles[j].data,
          style: plainStyles[i]
        };
      }
    }
    return { key: mergedPropsStyle.key, data: mergedPropsStyle.data, style: plainStyles[i] };
  });
}

function shouldStopAnimationAll(currentStyles, destStyles, currentVelocities, mergedPropsStyles) {
  if (mergedPropsStyles.length !== destStyles.length) {
    return false;
  }

  for (var i = 0; i < mergedPropsStyles.length; i++) {
    if (mergedPropsStyles[i].key !== destStyles[i].key) {
      return false;
    }
  }

  // we have the invariant that mergedPropsStyles and
  // currentStyles/currentVelocities/last* are synced in terms of cells, see
  // mergeAndSync comment for more info
  for (var i = 0; i < mergedPropsStyles.length; i++) {
    if (!_shouldStopAnimation2['default'](currentStyles[i], destStyles[i].style, currentVelocities[i])) {
      return false;
    }
  }

  return true;
}

// core key merging logic

// things to do: say previously merged style is {a, b}, dest style (prop) is {b,
// c}, previous current (interpolating) style is {a, b}
// **invariant**: current[i] corresponds to merged[i] in terms of key

// steps:
// turn merged style into {a?, b, c}
//    add c, value of c is destStyles.c
//    maybe remove a, aka call willLeave(a), then merged is either {b, c} or {a, b, c}
// turn current (interpolating) style from {a, b} into {a?, b, c}
//    maybe remove a
//    certainly add c, value of c is willEnter(c)
// loop over merged and construct new current
// dest doesn't change, that's owner's
function mergeAndSync(willEnter, willLeave, didLeave, oldMergedPropsStyles, destStyles, oldCurrentStyles, oldCurrentVelocities, oldLastIdealStyles, oldLastIdealVelocities) {
  var newMergedPropsStyles = _mergeDiff2['default'](oldMergedPropsStyles, destStyles, function (oldIndex, oldMergedPropsStyle) {
    var leavingStyle = willLeave(oldMergedPropsStyle);
    if (leavingStyle == null) {
      didLeave({ key: oldMergedPropsStyle.key, data: oldMergedPropsStyle.data });
      return null;
    }
    if (_shouldStopAnimation2['default'](oldCurrentStyles[oldIndex], leavingStyle, oldCurrentVelocities[oldIndex])) {
      didLeave({ key: oldMergedPropsStyle.key, data: oldMergedPropsStyle.data });
      return null;
    }
    return { key: oldMergedPropsStyle.key, data: oldMergedPropsStyle.data, style: leavingStyle };
  });

  var newCurrentStyles = [];
  var newCurrentVelocities = [];
  var newLastIdealStyles = [];
  var newLastIdealVelocities = [];
  for (var i = 0; i < newMergedPropsStyles.length; i++) {
    var newMergedPropsStyleCell = newMergedPropsStyles[i];
    var foundOldIndex = null;
    for (var j = 0; j < oldMergedPropsStyles.length; j++) {
      if (oldMergedPropsStyles[j].key === newMergedPropsStyleCell.key) {
        foundOldIndex = j;
        break;
      }
    }
    // TODO: key search code
    if (foundOldIndex == null) {
      var plainStyle = willEnter(newMergedPropsStyleCell);
      newCurrentStyles[i] = plainStyle;
      newLastIdealStyles[i] = plainStyle;

      var velocity = _mapToZero2['default'](newMergedPropsStyleCell.style);
      newCurrentVelocities[i] = velocity;
      newLastIdealVelocities[i] = velocity;
    } else {
      newCurrentStyles[i] = oldCurrentStyles[foundOldIndex];
      newLastIdealStyles[i] = oldLastIdealStyles[foundOldIndex];
      newCurrentVelocities[i] = oldCurrentVelocities[foundOldIndex];
      newLastIdealVelocities[i] = oldLastIdealVelocities[foundOldIndex];
    }
  }

  return [newMergedPropsStyles, newCurrentStyles, newCurrentVelocities, newLastIdealStyles, newLastIdealVelocities];
}

var TransitionMotion = (function (_React$Component) {
  _inherits(TransitionMotion, _React$Component);

  _createClass(TransitionMotion, null, [{
    key: 'propTypes',
    value: {
      defaultStyles: _propTypes2['default'].arrayOf(_propTypes2['default'].shape({
        key: _propTypes2['default'].string.isRequired,
        data: _propTypes2['default'].any,
        style: _propTypes2['default'].objectOf(_propTypes2['default'].number).isRequired
      })),
      styles: _propTypes2['default'].oneOfType([_propTypes2['default'].func, _propTypes2['default'].arrayOf(_propTypes2['default'].shape({
        key: _propTypes2['default'].string.isRequired,
        data: _propTypes2['default'].any,
        style: _propTypes2['default'].objectOf(_propTypes2['default'].oneOfType([_propTypes2['default'].number, _propTypes2['default'].object])).isRequired
      }))]).isRequired,
      children: _propTypes2['default'].func.isRequired,
      willEnter: _propTypes2['default'].func,
      willLeave: _propTypes2['default'].func,
      didLeave: _propTypes2['default'].func
    },
    enumerable: true
  }, {
    key: 'defaultProps',
    value: {
      willEnter: function willEnter(styleThatEntered) {
        return _stripStyle2['default'](styleThatEntered.style);
      },
      // recall: returning null makes the current unmounting TransitionStyle
      // disappear immediately
      willLeave: function willLeave() {
        return null;
      },
      didLeave: function didLeave() {}
    },
    enumerable: true
  }]);

  function TransitionMotion(props) {
    var _this = this;

    _classCallCheck(this, TransitionMotion);

    _React$Component.call(this, props);
    this.unmounting = false;
    this.animationID = null;
    this.prevTime = 0;
    this.accumulatedTime = 0;
    this.unreadPropStyles = null;

    this.clearUnreadPropStyle = function (unreadPropStyles) {
      var _mergeAndSync = mergeAndSync(_this.props.willEnter, _this.props.willLeave, _this.props.didLeave, _this.state.mergedPropsStyles, unreadPropStyles, _this.state.currentStyles, _this.state.currentVelocities, _this.state.lastIdealStyles, _this.state.lastIdealVelocities);

      var mergedPropsStyles = _mergeAndSync[0];
      var currentStyles = _mergeAndSync[1];
      var currentVelocities = _mergeAndSync[2];
      var lastIdealStyles = _mergeAndSync[3];
      var lastIdealVelocities = _mergeAndSync[4];

      for (var i = 0; i < unreadPropStyles.length; i++) {
        var unreadPropStyle = unreadPropStyles[i].style;
        var dirty = false;

        for (var key in unreadPropStyle) {
          if (!Object.prototype.hasOwnProperty.call(unreadPropStyle, key)) {
            continue;
          }

          var styleValue = unreadPropStyle[key];
          if (typeof styleValue === 'number') {
            if (!dirty) {
              dirty = true;
              currentStyles[i] = _extends({}, currentStyles[i]);
              currentVelocities[i] = _extends({}, currentVelocities[i]);
              lastIdealStyles[i] = _extends({}, lastIdealStyles[i]);
              lastIdealVelocities[i] = _extends({}, lastIdealVelocities[i]);
              mergedPropsStyles[i] = {
                key: mergedPropsStyles[i].key,
                data: mergedPropsStyles[i].data,
                style: _extends({}, mergedPropsStyles[i].style)
              };
            }
            currentStyles[i][key] = styleValue;
            currentVelocities[i][key] = 0;
            lastIdealStyles[i][key] = styleValue;
            lastIdealVelocities[i][key] = 0;
            mergedPropsStyles[i].style[key] = styleValue;
          }
        }
      }

      // unlike the other 2 components, we can't detect staleness and optionally
      // opt out of setState here. each style object's data might contain new
      // stuff we're not/cannot compare
      _this.setState({
        currentStyles: currentStyles,
        currentVelocities: currentVelocities,
        mergedPropsStyles: mergedPropsStyles,
        lastIdealStyles: lastIdealStyles,
        lastIdealVelocities: lastIdealVelocities
      });
    };

    this.startAnimationIfNecessary = function () {
      if (_this.unmounting) {
        return;
      }

      // TODO: when config is {a: 10} and dest is {a: 10} do we raf once and
      // call cb? No, otherwise accidental parent rerender causes cb trigger
      _this.animationID = _raf2['default'](function (timestamp) {
        // https://github.com/chenglou/react-motion/pull/420
        // > if execution passes the conditional if (this.unmounting), then
        // executes async defaultRaf and after that component unmounts and after
        // that the callback of defaultRaf is called, then setState will be called
        // on unmounted component.
        if (_this.unmounting) {
          return;
        }

        var propStyles = _this.props.styles;
        var destStyles = typeof propStyles === 'function' ? propStyles(rehydrateStyles(_this.state.mergedPropsStyles, _this.unreadPropStyles, _this.state.lastIdealStyles)) : propStyles;

        // check if we need to animate in the first place
        if (shouldStopAnimationAll(_this.state.currentStyles, destStyles, _this.state.currentVelocities, _this.state.mergedPropsStyles)) {
          // no need to cancel animationID here; shouldn't have any in flight
          _this.animationID = null;
          _this.accumulatedTime = 0;
          return;
        }

        var currentTime = timestamp || _performanceNow2['default']();
        var timeDelta = currentTime - _this.prevTime;
        _this.prevTime = currentTime;
        _this.accumulatedTime = _this.accumulatedTime + timeDelta;
        // more than 10 frames? prolly switched browser tab. Restart
        if (_this.accumulatedTime > msPerFrame * 10) {
          _this.accumulatedTime = 0;
        }

        if (_this.accumulatedTime === 0) {
          // no need to cancel animationID here; shouldn't have any in flight
          _this.animationID = null;
          _this.startAnimationIfNecessary();
          return;
        }

        var currentFrameCompletion = (_this.accumulatedTime - Math.floor(_this.accumulatedTime / msPerFrame) * msPerFrame) / msPerFrame;
        var framesToCatchUp = Math.floor(_this.accumulatedTime / msPerFrame);

        var _mergeAndSync2 = mergeAndSync(_this.props.willEnter, _this.props.willLeave, _this.props.didLeave, _this.state.mergedPropsStyles, destStyles, _this.state.currentStyles, _this.state.currentVelocities, _this.state.lastIdealStyles, _this.state.lastIdealVelocities);

        var newMergedPropsStyles = _mergeAndSync2[0];
        var newCurrentStyles = _mergeAndSync2[1];
        var newCurrentVelocities = _mergeAndSync2[2];
        var newLastIdealStyles = _mergeAndSync2[3];
        var newLastIdealVelocities = _mergeAndSync2[4];

        for (var i = 0; i < newMergedPropsStyles.length; i++) {
          var newMergedPropsStyle = newMergedPropsStyles[i].style;
          var newCurrentStyle = {};
          var newCurrentVelocity = {};
          var newLastIdealStyle = {};
          var newLastIdealVelocity = {};

          for (var key in newMergedPropsStyle) {
            if (!Object.prototype.hasOwnProperty.call(newMergedPropsStyle, key)) {
              continue;
            }

            var styleValue = newMergedPropsStyle[key];
            if (typeof styleValue === 'number') {
              newCurrentStyle[key] = styleValue;
              newCurrentVelocity[key] = 0;
              newLastIdealStyle[key] = styleValue;
              newLastIdealVelocity[key] = 0;
            } else {
              var newLastIdealStyleValue = newLastIdealStyles[i][key];
              var newLastIdealVelocityValue = newLastIdealVelocities[i][key];
              for (var j = 0; j < framesToCatchUp; j++) {
                var _stepper = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);

                newLastIdealStyleValue = _stepper[0];
                newLastIdealVelocityValue = _stepper[1];
              }

              var _stepper2 = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);

              var nextIdealX = _stepper2[0];
              var nextIdealV = _stepper2[1];

              newCurrentStyle[key] = newLastIdealStyleValue + (nextIdealX - newLastIdealStyleValue) * currentFrameCompletion;
              newCurrentVelocity[key] = newLastIdealVelocityValue + (nextIdealV - newLastIdealVelocityValue) * currentFrameCompletion;
              newLastIdealStyle[key] = newLastIdealStyleValue;
              newLastIdealVelocity[key] = newLastIdealVelocityValue;
            }
          }

          newLastIdealStyles[i] = newLastIdealStyle;
          newLastIdealVelocities[i] = newLastIdealVelocity;
          newCurrentStyles[i] = newCurrentStyle;
          newCurrentVelocities[i] = newCurrentVelocity;
        }

        _this.animationID = null;
        // the amount we're looped over above
        _this.accumulatedTime -= framesToCatchUp * msPerFrame;

        _this.setState({
          currentStyles: newCurrentStyles,
          currentVelocities: newCurrentVelocities,
          lastIdealStyles: newLastIdealStyles,
          lastIdealVelocities: newLastIdealVelocities,
          mergedPropsStyles: newMergedPropsStyles
        });

        _this.unreadPropStyles = null;

        _this.startAnimationIfNecessary();
      });
    };

    this.state = this.defaultState();
  }

  TransitionMotion.prototype.defaultState = function defaultState() {
    var _props = this.props;
    var defaultStyles = _props.defaultStyles;
    var styles = _props.styles;
    var willEnter = _props.willEnter;
    var willLeave = _props.willLeave;
    var didLeave = _props.didLeave;

    var destStyles = typeof styles === 'function' ? styles(defaultStyles) : styles;

    // this is special. for the first time around, we don't have a comparison
    // between last (no last) and current merged props. we'll compute last so:
    // say default is {a, b} and styles (dest style) is {b, c}, we'll
    // fabricate last as {a, b}
    var oldMergedPropsStyles = undefined;
    if (defaultStyles == null) {
      oldMergedPropsStyles = destStyles;
    } else {
      oldMergedPropsStyles = defaultStyles.map(function (defaultStyleCell) {
        // TODO: key search code
        for (var i = 0; i < destStyles.length; i++) {
          if (destStyles[i].key === defaultStyleCell.key) {
            return destStyles[i];
          }
        }
        return defaultStyleCell;
      });
    }
    var oldCurrentStyles = defaultStyles == null ? destStyles.map(function (s) {
      return _stripStyle2['default'](s.style);
    }) : defaultStyles.map(function (s) {
      return _stripStyle2['default'](s.style);
    });
    var oldCurrentVelocities = defaultStyles == null ? destStyles.map(function (s) {
      return _mapToZero2['default'](s.style);
    }) : defaultStyles.map(function (s) {
      return _mapToZero2['default'](s.style);
    });

    var _mergeAndSync3 = mergeAndSync(
    // Because this is an old-style createReactClass component, Flow doesn't
    // understand that the willEnter and willLeave props have default values
    // and will always be present.
    willEnter, willLeave, didLeave, oldMergedPropsStyles, destStyles, oldCurrentStyles, oldCurrentVelocities, oldCurrentStyles, // oldLastIdealStyles really
    oldCurrentVelocities);

    var mergedPropsStyles = _mergeAndSync3[0];
    var currentStyles = _mergeAndSync3[1];
    var currentVelocities = _mergeAndSync3[2];
    var lastIdealStyles = _mergeAndSync3[3];
    var lastIdealVelocities = _mergeAndSync3[4];
    // oldLastIdealVelocities really

    return {
      currentStyles: currentStyles,
      currentVelocities: currentVelocities,
      lastIdealStyles: lastIdealStyles,
      lastIdealVelocities: lastIdealVelocities,
      mergedPropsStyles: mergedPropsStyles
    };
  };

  // after checking for unreadPropStyles != null, we manually go set the
  // non-interpolating values (those that are a number, without a spring
  // config)

  TransitionMotion.prototype.componentDidMount = function componentDidMount() {
    this.prevTime = _performanceNow2['default']();
    this.startAnimationIfNecessary();
  };

  TransitionMotion.prototype.componentWillReceiveProps = function componentWillReceiveProps(props) {
    if (this.unreadPropStyles) {
      // previous props haven't had the chance to be set yet; set them here
      this.clearUnreadPropStyle(this.unreadPropStyles);
    }

    var styles = props.styles;
    if (typeof styles === 'function') {
      this.unreadPropStyles = styles(rehydrateStyles(this.state.mergedPropsStyles, this.unreadPropStyles, this.state.lastIdealStyles));
    } else {
      this.unreadPropStyles = styles;
    }

    if (this.animationID == null) {
      this.prevTime = _performanceNow2['default']();
      this.startAnimationIfNecessary();
    }
  };

  TransitionMotion.prototype.componentWillUnmount = function componentWillUnmount() {
    this.unmounting = true;
    if (this.animationID != null) {
      _raf2['default'].cancel(this.animationID);
      this.animationID = null;
    }
  };

  TransitionMotion.prototype.render = function render() {
    var hydratedStyles = rehydrateStyles(this.state.mergedPropsStyles, this.unreadPropStyles, this.state.currentStyles);
    var renderedChildren = this.props.children(hydratedStyles);
    return renderedChildren && _react2['default'].Children.only(renderedChildren);
  };

  return TransitionMotion;
})(_react2['default'].Component);

exports['default'] = TransitionMotion;
module.exports = exports['default'];

// list of styles, each containing interpolating values. Part of what's passed
// to children function. Notice that this is
// Array<ActualInterpolatingStyleObject>, without the wrapper that is {key: ...,
// data: ... style: ActualInterpolatingStyleObject}. Only mergedPropsStyles
// contains the key & data info (so that we only have a single source of truth
// for these, and to save space). Check the comment for `rehydrateStyles` to
// see how we regenerate the entirety of what's passed to children function

// the array that keeps track of currently rendered stuff! Including stuff
// that you've unmounted but that's still animating. This is where it lives

// it's possible that currentStyle's value is stale: if props is immediately
// changed from 0 to 400 to spring(0) again, the async currentStyle is still
// at 0 (didn't have time to tick and interpolate even once). If we naively
// compare currentStyle with destVal it'll be 0 === 0 (no animation, stop).
// In reality currentStyle should be 400

/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// core keys merging algorithm. If previous render's keys are [a, b], and the
// next render's [c, b, d], what's the final merged keys and ordering?

// - c and a must both be before b
// - b before d
// - ordering between a and c ambiguous

// this reduces to merging two partially ordered lists (e.g. lists where not
// every item has a definite ordering, like comparing a and c above). For the
// ambiguous ordering we deterministically choose to place the next render's
// item after the previous'; so c after a

// this is called a topological sorting. Except the existing algorithms don't
// work well with js bc of the amount of allocation, and isn't optimized for our
// current use-case bc the runtime is linear in terms of edges (see wiki for
// meaning), which is huge when two lists have many common elements


exports.__esModule = true;
exports['default'] = mergeDiff;

function mergeDiff(prev, next, onRemove) {
  // bookkeeping for easier access of a key's index below. This is 2 allocations +
  // potentially triggering chrome hash map mode for objs (so it might be faster

  var prevKeyIndex = {};
  for (var i = 0; i < prev.length; i++) {
    prevKeyIndex[prev[i].key] = i;
  }
  var nextKeyIndex = {};
  for (var i = 0; i < next.length; i++) {
    nextKeyIndex[next[i].key] = i;
  }

  // first, an overly elaborate way of merging prev and next, eliminating
  // duplicates (in terms of keys). If there's dupe, keep the item in next).
  // This way of writing it saves allocations
  var ret = [];
  for (var i = 0; i < next.length; i++) {
    ret[i] = next[i];
  }
  for (var i = 0; i < prev.length; i++) {
    if (!Object.prototype.hasOwnProperty.call(nextKeyIndex, prev[i].key)) {
      // this is called my TM's `mergeAndSync`, which calls willLeave. We don't
      // merge in keys that the user desires to kill
      var fill = onRemove(i, prev[i]);
      if (fill != null) {
        ret.push(fill);
      }
    }
  }

  // now all the items all present. Core sorting logic to have the right order
  return ret.sort(function (a, b) {
    var nextOrderA = nextKeyIndex[a.key];
    var nextOrderB = nextKeyIndex[b.key];
    var prevOrderA = prevKeyIndex[a.key];
    var prevOrderB = prevKeyIndex[b.key];

    if (nextOrderA != null && nextOrderB != null) {
      // both keys in next
      return nextKeyIndex[a.key] - nextKeyIndex[b.key];
    } else if (prevOrderA != null && prevOrderB != null) {
      // both keys in prev
      return prevKeyIndex[a.key] - prevKeyIndex[b.key];
    } else if (nextOrderA != null) {
      // key a in next, key b in prev

      // how to determine the order between a and b? We find a "pivot" (term
      // abuse), a key present in both prev and next, that is sandwiched between
      // a and b. In the context of our above example, if we're comparing a and
      // d, b's (the only) pivot
      for (var i = 0; i < next.length; i++) {
        var pivot = next[i].key;
        if (!Object.prototype.hasOwnProperty.call(prevKeyIndex, pivot)) {
          continue;
        }

        if (nextOrderA < nextKeyIndex[pivot] && prevOrderB > prevKeyIndex[pivot]) {
          return -1;
        } else if (nextOrderA > nextKeyIndex[pivot] && prevOrderB < prevKeyIndex[pivot]) {
          return 1;
        }
      }
      // pluggable. default to: next bigger than prev
      return 1;
    }
    // prevOrderA, nextOrderB
    for (var i = 0; i < next.length; i++) {
      var pivot = next[i].key;
      if (!Object.prototype.hasOwnProperty.call(prevKeyIndex, pivot)) {
        continue;
      }
      if (nextOrderB < nextKeyIndex[pivot] && prevOrderA > prevKeyIndex[pivot]) {
        return 1;
      } else if (nextOrderB > nextKeyIndex[pivot] && prevOrderA < prevKeyIndex[pivot]) {
        return -1;
      }
    }
    // pluggable. default to: next bigger than prev
    return -1;
  });
}

module.exports = exports['default'];
// to loop through and find a key's index each time), but I no longer care

/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports['default'] = spring;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _presets = __webpack_require__(42);

var _presets2 = _interopRequireDefault(_presets);

var defaultConfig = _extends({}, _presets2['default'].noWobble, {
  precision: 0.01
});

function spring(val, config) {
  return _extends({}, defaultConfig, config, { val: val });
}

module.exports = exports['default'];

/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports['default'] = reorderKeys;

var hasWarned = false;

function reorderKeys() {
  if (false) {
    if (!hasWarned) {
      hasWarned = true;
      console.error('`reorderKeys` has been removed, since it is no longer needed for TransitionMotion\'s new styles array API.');
    }
  }
}

module.exports = exports['default'];

/***/ }),
/* 120 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__images_instore_revieve_logo_svg__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__images_instore_revieve_logo_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__images_instore_revieve_logo_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_addons_css_transition_group__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_addons_css_transition_group___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_addons_css_transition_group__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__MediaQueries__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_polyglot__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_polyglot___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_polyglot__);
var _jsx=function(){var REACT_ELEMENT_TYPE=typeof Symbol==="function"&&Symbol.for&&Symbol.for("react.element")||0xeac7;return function createRawReactElement(type,props,key,children){var defaultProps=type&&type.defaultProps;var childrenLength=arguments.length-3;if(!props&&childrenLength!==0){props={};}if(props&&defaultProps){for(var propName in defaultProps){if(props[propName]===void 0){props[propName]=defaultProps[propName];}}}else if(!props){props=defaultProps||{};}if(childrenLength===1){props.children=children;}else if(childrenLength>1){var childArray=Array(childrenLength);for(var i=0;i<childrenLength;i++){childArray[i]=arguments[i+3];}props.children=childArray;}return{$$typeof:REACT_ELEMENT_TYPE,type:type,key:key===undefined?null:''+key,ref:null,props:props,_owner:null};};}();var _templateObject=_taggedTemplateLiteral(['\n  z-index: 10;\n  width: 100%;\n  max-width: 992px;\n  padding: 0 30px;\n  position: absolute;\n  left: 0;\n  right: 0;\n  margin: 0 auto;\n  color: white;\n  :not(.revieve-header-0) {\n    ','\n  }\n'],['\n  z-index: 10;\n  width: 100%;\n  max-width: 992px;\n  padding: 0 30px;\n  position: absolute;\n  left: 0;\n  right: 0;\n  margin: 0 auto;\n  color: white;\n  :not(.revieve-header-0) {\n    ','\n  }\n']),_templateObject2=_taggedTemplateLiteral(['\n      header {\n        display: none;\n      }\n    '],['\n      header {\n        display: none;\n      }\n    ']),_templateObject3=_taggedTemplateLiteral(['\n  top: 0;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n  height: 60px;\n  .logo {\n    width: 200px;\n    height: 60px;\n    background-image: url(',');\n    background-repeat: no-repeat;\n    background-position: left center;\n    background-size: ',';\n    ','\n  }\n  .secondaryLogo {\n    background-image: url(',');\n    background-repeat: no-repeat;\n    background-position: rigth center;\n    background-size: \'contain\';\n  }\n  h1 {\n    font-size: 18px;\n    font-weight: 400;\n    color: white;\n    text-align: right;\n    ','\n  }\n'],['\n  top: 0;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n  height: 60px;\n  .logo {\n    width: 200px;\n    height: 60px;\n    background-image: url(',');\n    background-repeat: no-repeat;\n    background-position: left center;\n    background-size: ',';\n    ','\n  }\n  .secondaryLogo {\n    background-image: url(',');\n    background-repeat: no-repeat;\n    background-position: rigth center;\n    background-size: \'contain\';\n  }\n  h1 {\n    font-size: 18px;\n    font-weight: 400;\n    color: white;\n    text-align: right;\n    ','\n  }\n']),_templateObject4=_taggedTemplateLiteral(['\n      width: 120px;\n    '],['\n      width: 120px;\n    ']),_templateObject5=_taggedTemplateLiteral(['\n      font-size: 14px;\n      font-weight: 700;\n    '],['\n      font-size: 14px;\n      font-weight: 700;\n    ']),_templateObject6=_taggedTemplateLiteral(['\n  height: 60px;\n  display: flex;\n  width: 100%;\n  justify-content: space-between;\n  align-items: center;\n'],['\n  height: 60px;\n  display: flex;\n  width: 100%;\n  justify-content: space-between;\n  align-items: center;\n']),_templateObject7=_taggedTemplateLiteral(['\n  height: 60px;\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n  &:active {\n    outline: none;\n    border: none;\n    background: none;\n  }\n'],['\n  height: 60px;\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n  &:active {\n    outline: none;\n    border: none;\n    background: none;\n  }\n']),_templateObject8=_taggedTemplateLiteral(['\n  cursor: pointer;\n  width: 140px;\n  height: 44px;\n  background-color: rgba(0, 0, 0, 0.3);\n  border: 1px solid rgba(255, 255, 255, 0.12);\n  border-radius: 4px;\n  color: white;\n  font-size: 16px;\n  font-weight: 500;\n  transition: background-color 0.35s ease-in;\n  @media (min-width: 320px) and (max-width: 736px) {\n    background: none;\n    border: none;\n    text-align: right;\n  }\n  &:active {\n    background-color: rgba(30, 144, 255, 0.3);\n  }\n'],['\n  cursor: pointer;\n  width: 140px;\n  height: 44px;\n  background-color: rgba(0, 0, 0, 0.3);\n  border: 1px solid rgba(255, 255, 255, 0.12);\n  border-radius: 4px;\n  color: white;\n  font-size: 16px;\n  font-weight: 500;\n  transition: background-color 0.35s ease-in;\n  @media (min-width: 320px) and (max-width: 736px) {\n    background: none;\n    border: none;\n    text-align: right;\n  }\n  &:active {\n    background-color: rgba(30, 144, 255, 0.3);\n  }\n']);function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var StyledWrapper=__WEBPACK_IMPORTED_MODULE_1_styled_components__["b" /* default */].div(_templateObject,__WEBPACK_IMPORTED_MODULE_4__MediaQueries__["a" /* default */].phone(_templateObject2));var StyledHeader=__WEBPACK_IMPORTED_MODULE_1_styled_components__["b" /* default */].header(_templateObject3,function(props){return props.logoImg;},function(props){return props.customLogo?'contain':'auto';},__WEBPACK_IMPORTED_MODULE_4__MediaQueries__["a" /* default */].phone(_templateObject4),function(props){return props.secondaryLogoImg;},__WEBPACK_IMPORTED_MODULE_4__MediaQueries__["a" /* default */].phone(_templateObject5));var StyledDiv=__WEBPACK_IMPORTED_MODULE_1_styled_components__["b" /* default */].div(_templateObject6);var StyledBackIcon=__WEBPACK_IMPORTED_MODULE_1_styled_components__["b" /* default */].div(_templateObject7);var StyledResetButton=__WEBPACK_IMPORTED_MODULE_1_styled_components__["b" /* default */].button(_templateObject8);var Header=function(_Component){_inherits(Header,_Component);function Header(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Header);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Header.__proto__||Object.getPrototypeOf(Header)).call.apply(_ref,[this].concat(args))),_this),_this.render=function(){var _this$props=_this.props,navigation=_this$props.navigation,navigationText=_this$props.navigationText,startOver=_this$props.startOver,prevPage=_this$props.prevPage,pageIndex=_this$props.pageIndex,headerConfig=_this$props.headerConfig,t=_this$props.t;return _jsx(StyledWrapper,{className:'revieve-header revieve-header-'+pageIndex},void 0,_jsx(StyledHeader,{logoImg:headerConfig&&headerConfig.logo?headerConfig.logo:__WEBPACK_IMPORTED_MODULE_2__images_instore_revieve_logo_svg___default.a,secondaryLogoImg:headerConfig&&headerConfig.secondaryLogo,customLogo:headerConfig&&headerConfig.logo},void 0,_jsx('div',{className:'logo'}),(!headerConfig||!headerConfig.secondaryLogo)&&_jsx('h1',{},void 0,t('digital_advisor')),headerConfig&&headerConfig.secondaryLogo&&_jsx('h1',{className:'logo secondaryLogo'},void 0,'\xA0')),_jsx(__WEBPACK_IMPORTED_MODULE_3_react_addons_css_transition_group___default.a,{transitionName:'headerSlide',transitionAppear:false,transitionEnter:true,transitionLeave:true,transitionAppearTimeout:1500,transitionLeaveTimeout:1500,transitionEnterTimeout:1500},void 0,navigation?_jsx(StyledDiv,{className:'revieve-backandreset'},void 0,_jsx(StyledBackIcon,{onClick:prevPage},void 0,_jsx('svg',{xmlns:'http://www.w3.org/2000/svg',width:'22',height:'16',viewBox:'0 0 22 16'},void 0,_jsx('path',{fill:'#FFF',d:'M50.4066281,29.1952949 L32.7326226,29.1952949 L38.4835815,23.3906891 C38.6978135,23.1890415 38.7849239,22.8865549 38.7107515,22.6018522 C38.6365791,22.3171496 38.4129487,22.095619 38.127559,22.0241357 C37.8421693,21.9526524 37.5405179,22.0426126 37.3409003,22.2587373 L30.2326723,29.4340241 C29.9224426,29.7475738 29.9224426,30.2524262 30.2326723,30.5659759 L37.3409003,37.7412627 C37.5405179,37.9573874 37.8421693,38.0473476 38.127559,37.9758643 C38.4129487,37.904381 38.6365791,37.6828504 38.7107515,37.3981478 C38.7849239,37.1134451 38.6978135,36.8109585 38.4835815,36.6093109 L32.7326226,30.8047051 L50.4066281,30.8047051 C50.6941215,30.8047051 50.9597764,30.6513292 51.1035231,30.4023525 C51.2472698,30.1533759 51.2472698,29.8466241 51.1035231,29.5976475 C50.9597764,29.3486708 50.6941215,29.1952949 50.4066281,29.1952949 Z',transform:'translate(-30 -22)'})),navigationText&&_jsx('div',{},void 0,' \xA0 ',t(navigationText))),_jsx(StyledResetButton,{className:'revieve-startOver',onClick:startOver},void 0,t('start_over'))):null));},_temp),_possibleConstructorReturn(_this,_ret);}return Header;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5_react_polyglot__["translate"])()(Header));

/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/revieve-logo.0da1ad19.svg";

/***/ }),
/* 122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ContentBody__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__images_instore_main_bg_jpg__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__images_instore_main_bg_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__images_instore_main_bg_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils__ = __webpack_require__(27);
var _jsx=function(){var REACT_ELEMENT_TYPE=typeof Symbol==="function"&&Symbol.for&&Symbol.for("react.element")||0xeac7;return function createRawReactElement(type,props,key,children){var defaultProps=type&&type.defaultProps;var childrenLength=arguments.length-3;if(!props&&childrenLength!==0){props={};}if(props&&defaultProps){for(var propName in defaultProps){if(props[propName]===void 0){props[propName]=defaultProps[propName];}}}else if(!props){props=defaultProps||{};}if(childrenLength===1){props.children=children;}else if(childrenLength>1){var childArray=Array(childrenLength);for(var i=0;i<childrenLength;i++){childArray[i]=arguments[i+3];}props.children=childArray;}return{$$typeof:REACT_ELEMENT_TYPE,type:type,key:key===undefined?null:''+key,ref:null,props:props,_owner:null};};}();var _templateObject=_taggedTemplateLiteral(['\n  background: linear-gradient(to bottom, rgba(0, 0, 0, 0.3) 0%, rgba(0, 0, 0, 0) 100%);\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  margin: auto;\n  width: 100%;\n  height: 100%;\n  max-width: 992px;\n  &:before {\n    z-index: ',';\n    overflow: hidden;\n    position: absolute;\n    top: 0;\n    left: 0;\n    content: \'\';\n    width: 100%;\n    height: 100%;\n    background: ',',\n      ',';\n    background-size: 200% 200%, cover;\n    background-repeat: no-repeat;\n    background-position: center;\n    transition: background-size 0.25s ease-out, filter 0.25s ease-out;\n    filter: ',';\n  }\n'],['\n  background: linear-gradient(to bottom, rgba(0, 0, 0, 0.3) 0%, rgba(0, 0, 0, 0) 100%);\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  margin: auto;\n  width: 100%;\n  height: 100%;\n  max-width: 992px;\n  &:before {\n    z-index: ',';\n    overflow: hidden;\n    position: absolute;\n    top: 0;\n    left: 0;\n    content: \'\';\n    width: 100%;\n    height: 100%;\n    background: ',',\n      ',';\n    background-size: 200% 200%, cover;\n    background-repeat: no-repeat;\n    background-position: center;\n    transition: background-size 0.25s ease-out, filter 0.25s ease-out;\n    filter: ',';\n  }\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var StyledPage=__WEBPACK_IMPORTED_MODULE_3_styled_components__["b" /* default */].div(_templateObject,function(props){return props.cameraBackground?0:-1;},function(props){return props.liveARMode?'':'linear-gradient(to top, rgba(0, 0, 0, 0.8) 0%, rgba(0, 0, 0, 0) 100%)';},function(props){return props.cameraBackground?'url(null)':props.imageBackground?'url('+__webpack_require__(125)("./"+props.imageBackground)+')':'url('+__WEBPACK_IMPORTED_MODULE_4__images_instore_main_bg_jpg___default.a+')';},function(props){return props.rstyle.filter;});var Page=function Page(props){var _props$style=props.style;_props$style=_props$style===undefined?{}:_props$style;var _props$style$content=_props$style.content,content=_props$style$content===undefined?{margins:60}:_props$style$content,_props$style$backgrou=_props$style.background,background=_props$style$backgrou===undefined?{filter:null}:_props$style$backgrou,cameraBackground=props.cameraBackground,imageBackground=props.imageBackground,liveARMode=props.liveARMode,components=props.components,name=props.name;return _jsx(StyledPage,{rstyle:background,liveARMode:liveARMode,cameraBackground:cameraBackground,imageBackground:imageBackground,className:'revieve-page revieve-page-'+Object(__WEBPACK_IMPORTED_MODULE_5__utils__["a" /* camelize */])(name)},'page',_jsx(__WEBPACK_IMPORTED_MODULE_2__ContentBody__["a" /* default */],{rstyle:content,components:components}));};Page.propTypes={header:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,footer:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,components:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.element),name:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,style:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,liveARMode:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool};Page.defaultProps={header:{},footer:{},components:[],name:'Default page',style:{},liveARMode:false};/* harmony default export */ __webpack_exports__["a"] = (Page);

/***/ }),
/* 123 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_addons_css_transition_group__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_addons_css_transition_group___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_addons_css_transition_group__);
var _jsx=function(){var REACT_ELEMENT_TYPE=typeof Symbol==="function"&&Symbol.for&&Symbol.for("react.element")||0xeac7;return function createRawReactElement(type,props,key,children){var defaultProps=type&&type.defaultProps;var childrenLength=arguments.length-3;if(!props&&childrenLength!==0){props={};}if(props&&defaultProps){for(var propName in defaultProps){if(props[propName]===void 0){props[propName]=defaultProps[propName];}}}else if(!props){props=defaultProps||{};}if(childrenLength===1){props.children=children;}else if(childrenLength>1){var childArray=Array(childrenLength);for(var i=0;i<childrenLength;i++){childArray[i]=arguments[i+3];}props.children=childArray;}return{$$typeof:REACT_ELEMENT_TYPE,type:type,key:key===undefined?null:''+key,ref:null,props:props,_owner:null};};}();var _templateObject=_taggedTemplateLiteral(['\n  height: 100%;\n  .wrap {\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    height: 100%;\n    overflow: hidden;\n  }\n'],['\n  height: 100%;\n  .wrap {\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    height: 100%;\n    overflow: hidden;\n  }\n']);function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var StyledDiv=__WEBPACK_IMPORTED_MODULE_2_styled_components__["b" /* default */].div(_templateObject);var ContentBody=function(_Component){_inherits(ContentBody,_Component);function ContentBody(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ContentBody);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ContentBody.__proto__||Object.getPrototypeOf(ContentBody)).call.apply(_ref,[this].concat(args))),_this),_this.render=function(){var _this$props=_this.props,components=_this$props.components,rstyle=_this$props.rstyle;return _jsx(StyledDiv,{style:rstyle},void 0,_jsx(__WEBPACK_IMPORTED_MODULE_3_react_addons_css_transition_group___default.a,{transitionName:'contentSlide',transitionAppear:true,transitionEnter:true,transitionLeave:true,transitionAppearTimeout:900,transitionLeaveTimeout:900,transitionEnterTimeout:900},void 0,_jsx('div',{className:'wrap'},void 0,components)));},_temp),_possibleConstructorReturn(_this,_ret);}return ContentBody;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);ContentBody.propTypes={components:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.element),rstyle:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object};/* harmony default export */ __webpack_exports__["a"] = (ContentBody);

/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/main-bg.f23ce00a.jpg";

/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./esserbella.png": 126,
	"./estee_lauder_bg.jpg": 127,
	"./eucerin.jpg": 128,
	"./ulta.jpg": 129
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 125;

/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/esserbella.6cd44433.png";

/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/estee_lauder_bg.f61a4f80.jpg";

/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/eucerin.6f5ed030.jpg";

/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/ulta.2e897759.jpg";

/***/ }),
/* 130 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MediaQueries__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_polyglot__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_polyglot___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_polyglot__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_addons_css_transition_group__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_addons_css_transition_group___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_addons_css_transition_group__);
var _jsx=function(){var REACT_ELEMENT_TYPE=typeof Symbol==="function"&&Symbol.for&&Symbol.for("react.element")||0xeac7;return function createRawReactElement(type,props,key,children){var defaultProps=type&&type.defaultProps;var childrenLength=arguments.length-3;if(!props&&childrenLength!==0){props={};}if(props&&defaultProps){for(var propName in defaultProps){if(props[propName]===void 0){props[propName]=defaultProps[propName];}}}else if(!props){props=defaultProps||{};}if(childrenLength===1){props.children=children;}else if(childrenLength>1){var childArray=Array(childrenLength);for(var i=0;i<childrenLength;i++){childArray[i]=arguments[i+3];}props.children=childArray;}return{$$typeof:REACT_ELEMENT_TYPE,type:type,key:key===undefined?null:''+key,ref:null,props:props,_owner:null};};}();var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n  ','\n\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  font-size: 30px;\n  font-weight: 300;\n\n  ul,\n  li {\n    list-style: none;\n    z-index: 1;\n  }\n  li {\n    color: white;\n    text-align: center;\n    margin-bottom: 1em;\n  }\n  .buttonStyle {\n    margin-top: 75px;\n  }\n'],['\n  ','\n\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  font-size: 30px;\n  font-weight: 300;\n\n  ul,\n  li {\n    list-style: none;\n    z-index: 1;\n  }\n  li {\n    color: white;\n    text-align: center;\n    margin-bottom: 1em;\n  }\n  .buttonStyle {\n    margin-top: 75px;\n  }\n']),_templateObject2=_taggedTemplateLiteral(['\n    font-size: 20px;\n    font-weight: 400;\n  '],['\n    font-size: 20px;\n    font-weight: 400;\n  ']),_templateObject3=_taggedTemplateLiteral(['\n  font-size: 14px;\n  width: 60%;\n  background-color: rgba(0, 0, 0, 0.5);\n  padding: 20px;\n  border-radius: 8px;\n  position: absolute;\n  left: 35%;\n  top: 120px;\n  color: white;\n  max-height: 344px;\n  overflow: auto;\n  z-index: 1;\n  border-radius: 20px 0px 20px 20px;\n\n  ','\n\n  h1 {\n    font-size: 18px;\n    margin-bottom: 20px;\n    ','\n  }\n\n  li {\n    margin-left: 18px;\n    margin-bottom: 10px;\n  }\n\n  .closeModal {\n    float: right;\n    cursor: pointer;\n    font-weight: bolder;\n    position: absolute;\n    top: 20px;\n    right: 20px;\n    text-align: right;\n    width: 50px;\n    height: 50px;\n  }\n\n  .warningText {\n    margin-bottom: 10px;\n  }\n'],['\n  font-size: 14px;\n  width: 60%;\n  background-color: rgba(0, 0, 0, 0.5);\n  padding: 20px;\n  border-radius: 8px;\n  position: absolute;\n  left: 35%;\n  top: 120px;\n  color: white;\n  max-height: 344px;\n  overflow: auto;\n  z-index: 1;\n  border-radius: 20px 0px 20px 20px;\n\n  ','\n\n  h1 {\n    font-size: 18px;\n    margin-bottom: 20px;\n    ','\n  }\n\n  li {\n    margin-left: 18px;\n    margin-bottom: 10px;\n  }\n\n  .closeModal {\n    float: right;\n    cursor: pointer;\n    font-weight: bolder;\n    position: absolute;\n    top: 20px;\n    right: 20px;\n    text-align: right;\n    width: 50px;\n    height: 50px;\n  }\n\n  .warningText {\n    margin-bottom: 10px;\n  }\n']),_templateObject4=_taggedTemplateLiteral(['\n    width: 79%;\n    left: 15%;\n    top: 120px;\n    padding: 30px 20px;\n    font-size: 12px;\n    border-radius: 0px 20px 20px 20px;\n  '],['\n    width: 79%;\n    left: 15%;\n    top: 120px;\n    padding: 30px 20px;\n    font-size: 12px;\n    border-radius: 0px 20px 20px 20px;\n  ']),_templateObject5=_taggedTemplateLiteral(['\n      font-size: 14px;\n    '],['\n      font-size: 14px;\n    ']);function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var StyledDiv=__WEBPACK_IMPORTED_MODULE_1_styled_components__["b" /* default */].div(_templateObject,__WEBPACK_IMPORTED_MODULE_2__MediaQueries__["a" /* default */].phone(_templateObject2));var StyledAdditionalInfo=__WEBPACK_IMPORTED_MODULE_1_styled_components__["b" /* default */].div(_templateObject3,__WEBPACK_IMPORTED_MODULE_2__MediaQueries__["a" /* default */].phone(_templateObject4),__WEBPACK_IMPORTED_MODULE_2__MediaQueries__["a" /* default */].phone(_templateObject5));var Introduction=function(_Component){_inherits(Introduction,_Component);function Introduction(props){_classCallCheck(this,Introduction);var _this=_possibleConstructorReturn(this,(Introduction.__proto__||Object.getPrototypeOf(Introduction)).call(this,props));_this.state={showAdditionalInfo:true};return _this;}_createClass(Introduction,[{key:'render',value:function render(){var _this2=this;var _props=this.props,options=_props.options,t=_props.t;var showAdditionalInfo=this.state.showAdditionalInfo;var handleOnClick=function handleOnClick(){if(options.additionalInfo){_this2.setState({showAdditionalInfo:!showAdditionalInfo});}};return _jsx('div',{},void 0,_jsx(StyledDiv,{className:'revieve-introductionTexts',onClick:handleOnClick},void 0,options&&options.texts?_jsx('ul',{},void 0,options.texts.map(function(text,i){return _jsx('li',{},'introduction'+i,' ',t(text),' ');})):_jsx('ul',{},void 0,_jsx('li',{},void 0,t('build_skin_profile')),_jsx('li',{},void 0,t('take_selfie')),_jsx('li',{},void 0,t('see_skin_analysis')),_jsx('li',{},void 0,t('get_personal_advice')),_jsx('li',{},void 0,t('get_product_recommendations')))),_jsx(__WEBPACK_IMPORTED_MODULE_4_react_addons_css_transition_group___default.a,{transitionName:'footerSlide',transitionAppear:true,transitionEnter:true,transitionLeave:true,transitionAppearTimeout:900,transitionLeaveTimeout:900,transitionEnterTimeout:900},void 0,options.additionalInfo&&showAdditionalInfo&&_jsx(StyledAdditionalInfo,{className:'revieve-additional-info'},void 0,_jsx('div',{className:'closeModal',onClick:function onClick(e){e.stopPropagation();handleOnClick();}},void 0,'X'),_jsx('ul',{},void 0,options.additionalInfo.map(function(text,i){return _jsx('li',{},'additionalInfo'+i,' ',t(text),' ');})))));}}]);return Introduction;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_polyglot__["translate"])()(Introduction));

/***/ }),
/* 131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__WeatherItem__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_geosuggest__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_polyglot__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_polyglot___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_polyglot__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__MediaQueries__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__services_Weather__ = __webpack_require__(137);
var _jsx=function(){var REACT_ELEMENT_TYPE=typeof Symbol==="function"&&Symbol.for&&Symbol.for("react.element")||0xeac7;return function createRawReactElement(type,props,key,children){var defaultProps=type&&type.defaultProps;var childrenLength=arguments.length-3;if(!props&&childrenLength!==0){props={};}if(props&&defaultProps){for(var propName in defaultProps){if(props[propName]===void 0){props[propName]=defaultProps[propName];}}}else if(!props){props=defaultProps||{};}if(childrenLength===1){props.children=children;}else if(childrenLength>1){var childArray=Array(childrenLength);for(var i=0;i<childrenLength;i++){childArray[i]=arguments[i+3];}props.children=childArray;}return{$$typeof:REACT_ELEMENT_TYPE,type:type,key:key===undefined?null:''+key,ref:null,props:props,_owner:null};};}();var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n  background: rgba(0, 0, 0, 0.7);\n  height: 120px;\n  width: 100%;\n  border-radius: 8px;\n  display: flex;\n  align-items: center;\n\n  ','\n\n  .location {\n    display: flex;\n    flex-direction: column;\n    width: 50%;\n    padding: 0 40px;\n    justify-content: center;\n\n    ','\n\n    input[type="text"] {\n      color: white;\n      background: none;\n      font-size: 20px;\n      font-weight: 400;\n      border: none;\n      outline: none;\n      width: 100%;\n      ','\n\n      ','\n\n      &::placeholder {\n        color: white;\n      }\n      + label {\n        color: white;\n        font-size: 12px;\n        font-weight: 500;\n        margin-top: 17px;\n        text-decoration: underline;\n      }\n    }\n  }\n\n  .weatherStats {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    width: 50%;\n    padding-right: 30px;\n\n    ','\n  }\n\n  .geosuggest {\n    height: 44px;\n    font-size: 14px;\n    font-size: 1rem;\n    position: relative;\n    width: 100%;\n    text-align: left;\n  }\n\n  .geosuggest__input {\n    position: absolute;\n    top: 0;\n    width: 100%;\n    border: none;\n    outline: none;\n    padding: 0.5em 0;\n    ','\n    -webkit-transition: border 200ms, box-shadow 200ms;\n    transition: border 200ms, box-shadow 200ms;\n  }\n  .geosuggest__suggests {\n    position: absolute;\n    top: -250px;\n    left: 0;\n    right: 0;\n    max-height: auto;\n    padding: 0;\n    color: white;\n    background: rgba(0, 0, 0, 0.5);\n    border-radius: 4px;\n    border: 1px solid rgba(255, 255, 255, 0.5);\n    overflow-y: scroll;\n    -webkit-overflow-scrolling: touch;\n    list-style: none;\n    /* z-index: 50000; */\n    -webkit-transition: border 200ms, box-shadow 200ms;\n    transition: border 200ms, box-shadow 200ms;\n\n    ','\n  }\n  .geosuggest__suggests--hidden {\n    max-height: 0;\n    overflow: hidden;\n    border-width: 0;\n  }\n\n  .geosuggest__item {\n    font-size: 14px;\n    padding: 14px;\n    cursor: pointer;\n    margin-bottom: 5px;\n    height: auto;\n  }\n  .geosuggest__item:hover,\n  .geosuggest__item:focus {\n    background: dodgerblue;\n  }\n  .geosuggest__item--active {\n    background: dodgerblue;\n    color: #fff;\n  }\n  .geosuggest__item--active:hover,\n  .geosuggest__item--active:focus {\n    background: dodgerblue;\n  }\n'],['\n  background: rgba(0, 0, 0, 0.7);\n  height: 120px;\n  width: 100%;\n  border-radius: 8px;\n  display: flex;\n  align-items: center;\n\n  ','\n\n  .location {\n    display: flex;\n    flex-direction: column;\n    width: 50%;\n    padding: 0 40px;\n    justify-content: center;\n\n    ','\n\n    input[type="text"] {\n      color: white;\n      background: none;\n      font-size: 20px;\n      font-weight: 400;\n      border: none;\n      outline: none;\n      width: 100%;\n      ','\n\n      ','\n\n      &::placeholder {\n        color: white;\n      }\n      + label {\n        color: white;\n        font-size: 12px;\n        font-weight: 500;\n        margin-top: 17px;\n        text-decoration: underline;\n      }\n    }\n  }\n\n  .weatherStats {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    width: 50%;\n    padding-right: 30px;\n\n    ','\n  }\n\n  .geosuggest {\n    height: 44px;\n    font-size: 14px;\n    font-size: 1rem;\n    position: relative;\n    width: 100%;\n    text-align: left;\n  }\n\n  .geosuggest__input {\n    position: absolute;\n    top: 0;\n    width: 100%;\n    border: none;\n    outline: none;\n    padding: 0.5em 0;\n    ','\n    -webkit-transition: border 200ms, box-shadow 200ms;\n    transition: border 200ms, box-shadow 200ms;\n  }\n  .geosuggest__suggests {\n    position: absolute;\n    top: -250px;\n    left: 0;\n    right: 0;\n    max-height: auto;\n    padding: 0;\n    color: white;\n    background: rgba(0, 0, 0, 0.5);\n    border-radius: 4px;\n    border: 1px solid rgba(255, 255, 255, 0.5);\n    overflow-y: scroll;\n    -webkit-overflow-scrolling: touch;\n    list-style: none;\n    /* z-index: 50000; */\n    -webkit-transition: border 200ms, box-shadow 200ms;\n    transition: border 200ms, box-shadow 200ms;\n\n    ','\n  }\n  .geosuggest__suggests--hidden {\n    max-height: 0;\n    overflow: hidden;\n    border-width: 0;\n  }\n\n  .geosuggest__item {\n    font-size: 14px;\n    padding: 14px;\n    cursor: pointer;\n    margin-bottom: 5px;\n    height: auto;\n  }\n  .geosuggest__item:hover,\n  .geosuggest__item:focus {\n    background: dodgerblue;\n  }\n  .geosuggest__item--active {\n    background: dodgerblue;\n    color: #fff;\n  }\n  .geosuggest__item--active:hover,\n  .geosuggest__item--active:focus {\n    background: dodgerblue;\n  }\n']),_templateObject2=_taggedTemplateLiteral(['\n    flex-direction: column;\n    align-items: space-around;\n    justify-content: center;\n  '],['\n    flex-direction: column;\n    align-items: space-around;\n    justify-content: center;\n  ']),_templateObject3=_taggedTemplateLiteral(['\n      padding: 0;\n      height: 36px;\n      width: 100%;\n    '],['\n      padding: 0;\n      height: 36px;\n      width: 100%;\n    ']),_templateObject4=_taggedTemplateLiteral(['\n        text-align: center;\n      '],['\n        text-align: center;\n      ']),_templateObject5=_taggedTemplateLiteral(['\n        font-size: 16px;\n      '],['\n        font-size: 16px;\n      ']),_templateObject6=_taggedTemplateLiteral(['\n      width: 100%;\n      padding-right: 0;\n      padding: 0 20px;\n    '],['\n      width: 100%;\n      padding-right: 0;\n      padding: 0 20px;\n    ']),_templateObject7=_taggedTemplateLiteral(['\n      text-align: center;\n    '],['\n      text-align: center;\n    ']),_templateObject8=_taggedTemplateLiteral(['\n      top: -140px;\n      width: 100%;\n      background: rgba(0,0,0,1);\n      max-height: 120px;\n    '],['\n      top: -140px;\n      width: 100%;\n      background: rgba(0,0,0,1);\n      max-height: 120px;\n    ']);function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}//import RevieveActions from '../../store/RevieveActions';
var mapsapi=__webpack_require__(138)('AIzaSyDMFjIWuZ4zs9s0RtY3jq9F0vNnBTQ-TBQ',['places']);var StyledWeatherWidget=__WEBPACK_IMPORTED_MODULE_1_styled_components__["b" /* default */].div(_templateObject,__WEBPACK_IMPORTED_MODULE_5__MediaQueries__["a" /* default */].phone(_templateObject2),__WEBPACK_IMPORTED_MODULE_5__MediaQueries__["a" /* default */].phone(_templateObject3),__WEBPACK_IMPORTED_MODULE_5__MediaQueries__["a" /* default */].phone(_templateObject4),__WEBPACK_IMPORTED_MODULE_5__MediaQueries__["a" /* default */].phone(_templateObject5),__WEBPACK_IMPORTED_MODULE_5__MediaQueries__["a" /* default */].phone(_templateObject6),__WEBPACK_IMPORTED_MODULE_5__MediaQueries__["a" /* default */].phone(_templateObject7),__WEBPACK_IMPORTED_MODULE_5__MediaQueries__["a" /* default */].phone(_templateObject8));var WeatherWidget=function(_Component){_inherits(WeatherWidget,_Component);function WeatherWidget(props){_classCallCheck(this,WeatherWidget);var _this=_possibleConstructorReturn(this,(WeatherWidget.__proto__||Object.getPrototypeOf(WeatherWidget)).call(this,props));_this.onSelect=function(e){var _this$props=_this.props,setLat=_this$props.setLat,setLon=_this$props.setLon;var lat=e.location.lat;var lon=e.location.lng;setLat(lat);setLon(lon);var info=e.label.split(', ');_this.state.weatherService.setInfo({city:info[0],display:info[0],area:info[0],country:info[1],lat:lat,lon:lon});_this.state.weatherService.getWeather().then(function(info){_this.setState({info:info,editing:false});});};_this.render=function(){var t=_this.props.t;return _jsx(StyledWeatherWidget,{className:'revieve-weather-widget'},void 0,_jsx('div',{className:'location'},void 0,_this.state.editing?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_geosuggest__["a" /* default */],{key:'field1',placeholder:t('geosuggest_placeholder'),ref:function ref(el){return _this._geoSuggest=el;},googleMaps:_this.state.mapsapi,onSuggestSelect:_this.onSelect,onBlur:function onBlur(){_this.setState({editing:false});}}):_jsx('div',{},void 0,_jsx('input',{type:'text',placeholder:_this.state.info.city||_this.state.info.country||_this.state.info.display||'Loading weather ...',onClick:function onClick(){_this.setState({loading:true});mapsapi().then(function(maps){_this.setState({loading:false,editing:true,mapsapi:maps});_this._geoSuggest.focus();});}}))),_jsx('div',{className:'weatherStats'},void 0,_jsx(__WEBPACK_IMPORTED_MODULE_2__WeatherItem__["a" /* WeatherItem */],{value:_this.state.info.uv_index||'...',icon:__WEBPACK_IMPORTED_MODULE_2__WeatherItem__["b" /* WeatherItemIcons */].uv,label:t('uv_index'),selected:true}),_jsx(__WEBPACK_IMPORTED_MODULE_2__WeatherItem__["a" /* WeatherItem */],{value:_this.state.info.humidity&&_this.state.info.humidity.toFixed(0)+'%'||'...',icon:__WEBPACK_IMPORTED_MODULE_2__WeatherItem__["b" /* WeatherItemIcons */].humidity,label:t('humidity')}),_jsx(__WEBPACK_IMPORTED_MODULE_2__WeatherItem__["a" /* WeatherItem */],{value:_this.state.info.pollution||'...',icon:__WEBPACK_IMPORTED_MODULE_2__WeatherItem__["b" /* WeatherItemIcons */].pollution,label:t('pollution')})));};_this.state={editing:false,loading:false,mapsapi:null,info:{},weatherService:new __WEBPACK_IMPORTED_MODULE_6__services_Weather__["a" /* default */](props.configOptions,props.revieveConfig)};return _this;}_createClass(WeatherWidget,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;var _props=this.props,filters=_props.filters,defaultLocation=_props.defaultLocation;this.state.weatherService.setFilters(filters);if(defaultLocation){var that=this;mapsapi().then(function(maps){var latlng=new maps.LatLng(defaultLocation.lat,defaultLocation.lon);var geocoder=new maps.Geocoder();geocoder.geocode({latLng:latlng},function(results,status){if(status===maps.GeocoderStatus.OK){var geocodification={};geocodification.location={lat:defaultLocation.lat,lng:defaultLocation.lon};var _iteratorNormalCompletion=true;var _didIteratorError=false;var _iteratorError=undefined;try{for(var _iterator=results[Symbol.iterator](),_step;!(_iteratorNormalCompletion=(_step=_iterator.next()).done);_iteratorNormalCompletion=true){var result=_step.value;// we need to find the locality formatted_address element
if(result.types[0]==='locality'){geocodification.label=result.formatted_address;that.onSelect(geocodification);break;}}}catch(err){_didIteratorError=true;_iteratorError=err;}finally{try{if(!_iteratorNormalCompletion&&_iterator.return){_iterator.return();}}finally{if(_didIteratorError){throw _iteratorError;}}}}});});}else{this.state.weatherService.doGeoIP().then(function(){_this2.state.weatherService.getWeather().then(function(info){_this2.setState({info:info});});});}}}]);return WeatherWidget;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4_react_polyglot__["translate"])()(WeatherWidget));

/***/ }),
/* 132 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return WeatherItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return WeatherItemIcons; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MediaQueries__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__images_instore_icons_uv_svg__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__images_instore_icons_uv_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__images_instore_icons_uv_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__images_instore_icons_humidity_svg__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__images_instore_icons_humidity_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__images_instore_icons_humidity_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__images_instore_icons_pollution_svg__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__images_instore_icons_pollution_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__images_instore_icons_pollution_svg__);
var _jsx=function(){var REACT_ELEMENT_TYPE=typeof Symbol==="function"&&Symbol.for&&Symbol.for("react.element")||0xeac7;return function createRawReactElement(type,props,key,children){var defaultProps=type&&type.defaultProps;var childrenLength=arguments.length-3;if(!props&&childrenLength!==0){props={};}if(props&&defaultProps){for(var propName in defaultProps){if(props[propName]===void 0){props[propName]=defaultProps[propName];}}}else if(!props){props=defaultProps||{};}if(childrenLength===1){props.children=children;}else if(childrenLength>1){var childArray=Array(childrenLength);for(var i=0;i<childrenLength;i++){childArray[i]=arguments[i+3];}props.children=childArray;}return{$$typeof:REACT_ELEMENT_TYPE,type:type,key:key===undefined?null:''+key,ref:null,props:props,_owner:null};};}();var _templateObject=_taggedTemplateLiteral(['\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  align-items: center;\n  height: 75px;\n\n  ','\n\n  h3.weatherItemValue, h4.weatherItemLabel {\n    font-size: 14px;\n    font-weight: 400;\n    color: white;\n\n    ','\n\n  }\n  h4.weatherItemLabel {\n    text-transform: capitalize;\n  }\n  .icon {\n    width: 24px;\n    height: 24px;\n    background-repeat: no-repeat;\n    background-position: center center;\n    background-size: 100%;\n\n    ','\n\n  }\n  .uv {\n    background-image: url(',');\n  }\n  .humidity {\n    background-image: url(',');\n  }\n  .pollution {\n    background-image: url(',');\n  }\n'],['\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  align-items: center;\n  height: 75px;\n\n  ','\n\n  h3.weatherItemValue, h4.weatherItemLabel {\n    font-size: 14px;\n    font-weight: 400;\n    color: white;\n\n    ','\n\n  }\n  h4.weatherItemLabel {\n    text-transform: capitalize;\n  }\n  .icon {\n    width: 24px;\n    height: 24px;\n    background-repeat: no-repeat;\n    background-position: center center;\n    background-size: 100%;\n\n    ','\n\n  }\n  .uv {\n    background-image: url(',');\n  }\n  .humidity {\n    background-image: url(',');\n  }\n  .pollution {\n    background-image: url(',');\n  }\n']),_templateObject2=_taggedTemplateLiteral(['\n    height: 60px;\n  '],['\n    height: 60px;\n  ']),_templateObject3=_taggedTemplateLiteral(['\n      font-size: 12px;\n      font-weight: 700;\n    '],['\n      font-size: 12px;\n      font-weight: 700;\n    ']),_templateObject4=_taggedTemplateLiteral(['\n      width: 16px;\n      height: 16px;\n    '],['\n      width: 16px;\n      height: 16px;\n    ']);function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var StyledItem=__WEBPACK_IMPORTED_MODULE_1_styled_components__["b" /* default */].div(_templateObject,__WEBPACK_IMPORTED_MODULE_2__MediaQueries__["a" /* default */].phone(_templateObject2),__WEBPACK_IMPORTED_MODULE_2__MediaQueries__["a" /* default */].phone(_templateObject3),__WEBPACK_IMPORTED_MODULE_2__MediaQueries__["a" /* default */].phone(_templateObject4),__WEBPACK_IMPORTED_MODULE_3__images_instore_icons_uv_svg___default.a,__WEBPACK_IMPORTED_MODULE_4__images_instore_icons_humidity_svg___default.a,__WEBPACK_IMPORTED_MODULE_5__images_instore_icons_pollution_svg___default.a);var WeatherItemIcons={uv:'uv',humidity:'humidity',pollution:'pollution'};var WeatherItem=function(_Component){_inherits(WeatherItem,_Component);function WeatherItem(){var _ref;var _temp,_this,_ret;_classCallCheck(this,WeatherItem);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=WeatherItem.__proto__||Object.getPrototypeOf(WeatherItem)).call.apply(_ref,[this].concat(args))),_this),_this.render=function(){return _jsx(StyledItem,{},void 0,_jsx('h3',{className:'weatherItemValue'},void 0,_this.props.value),_jsx('div',{className:'icon '+_this.props.icon}),_jsx('h4',{className:'weatherItemLabel'},void 0,_this.props.label));},_temp),_possibleConstructorReturn(_this,_ret);}return WeatherItem;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* unused harmony default export */ var _unused_webpack_default_export = (WeatherItem);

/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/uv.8a92468d.svg";

/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/humidity.acaa516f.svg";

/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/pollution.d34f445a.svg";

/***/ }),
/* 136 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);


/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var classnames = createCommonjsModule(function (module) {
/*!
  Copyright (c) 2017 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg) && arg.length) {
				var inner = classNames.apply(null, arg);
				if (inner) {
					classes.push(inner);
				}
			} else if (argType === 'object') {
				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if (module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else {
		window.classNames = classNames;
	}
}());
});

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof commonjsGlobal == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        result = wait - timeSinceLastCall;

    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

var lodash_debounce = debounce;

/* istanbul ignore next */
/* tslint:disable:no-empty */
/**
 * Default values
 */
var defaults = {
    autoActivateFirstSuggest: false,
    disabled: false,
    fixtures: [],
    getSuggestLabel: function (suggest) { return suggest.description; },
    highlightMatch: true,
    ignoreEnter: false,
    ignoreTab: false,
    initialValue: '',
    maxFixtures: 10,
    minLength: 1,
    onKeyDown: function () { },
    onKeyPress: function () { },
    placeholder: 'Search places',
    queryDelay: 250,
    skipSuggest: function () { return false; },
    style: {}
};

/**
 * Attributes allowed on input elements
 */
var allowedAttributes = [
    'autoCapitalize',
    'autoComplete',
    'autoCorrect',
    'autoFocus',
    'disabled',
    'form',
    'formAction',
    'formEncType',
    'formMethod',
    'formNoValidate',
    'formTarget',
    'height',
    'id',
    'inputMode',
    'maxLength',
    'name',
    'onClick',
    'onContextMenu',
    'onCopy',
    'onCut',
    'onDoubleClick',
    'onMouseDown',
    'onMouseEnter',
    'onMouseLeave',
    'onMouseMove',
    'onMouseOut',
    'onMouseOver',
    'onMouseUp',
    'onPaste',
    'pattern',
    'placeholder',
    'readOnly',
    'required',
    'size',
    'spellCheck',
    'tabIndex',
    'title',
    'aria-atomic',
    'aria-busy',
    'aria-controls',
    'aria-current',
    'aria-describedby',
    'aria-details',
    'aria-disabled',
    'aria-dropeffect',
    'aria-errormessage',
    'aria-flowto',
    'aria-grabbed',
    'aria-haspopup',
    'aria-hidden',
    'aria-invalid',
    'aria-keyshortcuts',
    'aria-label',
    'aria-labelledby',
    'aria-live',
    'aria-owns',
    'aria-relevant',
    'aria-roledescription',
    'aria-activedescendant',
    'aria-autocomplete',
    'aria-multiline',
    'aria-placeholder',
    'aria-readonly',
    'aria-required'
];
/**
 * Filter the properties for only allowed input properties
 */
function filterInputAttributes (props) {
    var attributes = {};
    allowedAttributes.forEach(function (allowedAttribute) {
        if (props[allowedAttribute]) {
            attributes[allowedAttribute] = props[allowedAttribute];
        }
    });
    return attributes;
}

/**
 * The input field
 */
var default_1 = /** @class */ (function (_super) {
    __extends(default_1, _super);
    /**
     * The constructor.
     */
    function default_1(props) {
        var _this = _super.call(this, props) || this;
        /* tslint:enable:no-empty */
        /**
         * The reference to the input element
         */
        _this.input = null;
        _this.onChange = _this.onChange.bind(_this);
        _this.onInputKeyDown = _this.onInputKeyDown.bind(_this);
        return _this;
    }
    /**
     * When the input got changed
     */
    default_1.prototype.onChange = function () {
        if (this.input) {
            this.props.onChange(this.input.value);
        }
    };
    /**
     * When a key gets pressed in the input
     */
    default_1.prototype.onInputKeyDown = function (event) {
        // Call props.onKeyDown if defined
        // Gives the developer a little bit more control if needed
        if (this.props.onKeyDown) {
            this.props.onKeyDown(event);
        }
        switch (event.which) {
            case 40: // DOWN
                if (!event.shiftKey) {
                    event.preventDefault();
                    this.props.onNext();
                }
                break;
            case 38: // UP
                if (!event.shiftKey) {
                    event.preventDefault();
                    this.props.onPrev();
                }
                break;
            case 13: // ENTER
                if (this.props.doNotSubmitOnEnter) {
                    event.preventDefault();
                }
                if (!this.props.ignoreEnter) {
                    this.props.onSelect();
                }
                break;
            case 9: // TAB
                if (!this.props.ignoreTab) {
                    this.props.onSelect();
                }
                break;
            case 27: // ESC
                this.props.onEscape();
                break;
            /* istanbul ignore next */
            default:
                break;
        }
    };
    /**
     * Focus the input
     */
    default_1.prototype.focus = function () {
        if (this.input) {
            this.input.focus();
        }
    };
    /**
     * Blur the input
     */
    default_1.prototype.blur = function () {
        if (this.input) {
            this.input.blur();
        }
    };
    /**
     * Render the view
     */
    default_1.prototype.render = function () {
        var _this = this;
        var attributes = filterInputAttributes(this.props);
        var classes = classnames('geosuggest__input', this.props.className);
        return (Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])("input", __assign({ className: classes, ref: function (i) { return (_this.input = i); }, type: "text" }, attributes, { value: this.props.value, style: this.props.style, onKeyDown: this.onInputKeyDown, onChange: this.onChange, onKeyPress: this.props.onKeyPress, onFocus: this.props.onFocus, onBlur: this.props.onBlur })));
    };
    /* tslint:disable:no-empty */
    /**
     * Default values for the properties
     */
    default_1.defaultProps = {
        autoComplete: 'nope',
        className: '',
        onBlur: function () { },
        onChange: function () { },
        onEscape: function () { },
        onFocus: function () { },
        onKeyDown: function () { },
        onKeyPress: function () { },
        onNext: function () { },
        onPrev: function () { },
        onSelect: function () { },
        value: ''
    };
    return default_1;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]));

/**
 * A single Geosuggest item in the list
 */
var default_1$1 = /** @class */ (function (_super) {
    __extends(default_1, _super);
    /**
     * The constructor.
     */
    function default_1(props) {
        var _this = _super.call(this, props) || this;
        /**
         * The reference to the suggest element
         */
        _this.ref = null;
        _this.onClick = _this.onClick.bind(_this);
        return _this;
    }
    /**
     * Makes a text bold
     */
    default_1.prototype.makeBold = function (element, key) {
        return (Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])("b", { className: "geosuggest__item__matched-text", key: key }, element));
    };
    /**
     * Replace matched text with the same in bold
     */
    default_1.prototype.formatMatchedText = function (userInput, suggest) {
        if (!userInput || !suggest.matchedSubstrings) {
            return suggest.label;
        }
        var start = suggest.matchedSubstrings.offset;
        var length = suggest.matchedSubstrings.length;
        var end = start + length;
        var boldPart = this.makeBold(suggest.label.substring(start, end), suggest.label);
        var pre = '';
        var post = '';
        if (start > 0) {
            pre = suggest.label.slice(0, start);
        }
        if (end < suggest.label.length) {
            post = suggest.label.slice(end);
        }
        return (Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])("span", null,
            pre,
            boldPart,
            post));
    };
    /**
     * Checking if item just became active and scrolling if needed.
     */
    default_1.prototype.componentWillReceiveProps = function (nextProps) {
        if (nextProps.isActive && !this.props.isActive) {
            this.scrollIfNeeded();
        }
    };
    /**
     * Scrolling current item to the center of the list if item needs scrolling.
     * Item is scrolled to the center of the list.
     */
    default_1.prototype.scrollIfNeeded = function () {
        var element = this.ref;
        var parent = element && element.parentElement;
        if (!element || !parent) {
            return;
        }
        var overTop = element.offsetTop - parent.offsetTop < parent.scrollTop;
        var overBottom = element.offsetTop - parent.offsetTop + element.clientHeight >
            parent.scrollTop + parent.clientHeight;
        if (overTop || overBottom) {
            parent.scrollTop =
                element.offsetTop -
                    parent.offsetTop -
                    parent.clientHeight / 2 +
                    element.clientHeight / 2;
        }
    };
    /**
     * When the suggest item got clicked
     */
    default_1.prototype.onClick = function (event) {
        event.preventDefault();
        this.props.onSelect(this.props.suggest);
    };
    /**
     * Render the view
     */
    default_1.prototype.render = function () {
        var _this = this;
        var _a;
        var suggest = this.props.suggest;
        var classes = classnames('geosuggest__item', this.props.className, this.props.suggestItemClassName, { 'geosuggest__item--active': this.props.isActive }, (_a = {},
            _a[this.props.activeClassName || ''] = this.props.activeClassName
                ? this.props.isActive
                : null,
            _a));
        var content = suggest.label;
        if (this.props.renderSuggestItem) {
            content = this.props.renderSuggestItem(suggest, this.props.userInput);
        }
        else if (this.props.isHighlightMatch) {
            content = this.formatMatchedText(this.props.userInput, suggest);
        }
        return (Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])("li", { className: classes, ref: function (li) { return (_this.ref = li); }, style: this.props.style, onMouseDown: this.props.onMouseDown, onMouseOut: this.props.onMouseOut, onClick: this.onClick }, content));
    };
    return default_1;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]));

/**
 * The list with suggestions.
 */
var default_1$2 = /** @class */ (function (_super) {
    __extends(default_1, _super);
    function default_1() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Whether or not it is hidden
     */
    default_1.prototype.isHidden = function () {
        return this.props.isHidden || this.props.suggests.length === 0;
    };
    /**
     * There are new properties available for the list
     */
    default_1.prototype.componentWillReceiveProps = function (nextProps) {
        if (nextProps.suggests !== this.props.suggests) {
            if (nextProps.suggests.length === 0) {
                this.props.onSuggestNoResults();
            }
        }
    };
    /**
     * Render the view
     * @return {Function} The React element to render
     */
    default_1.prototype.render = function () {
        var _this = this;
        var _a;
        var classes = classnames('geosuggest__suggests', this.props.suggestsClassName, { 'geosuggest__suggests--hidden': this.isHidden() }, (_a = {},
            _a[this.props.hiddenClassName || ''] = this.props.hiddenClassName
                ? this.isHidden()
                : null,
            _a));
        return (Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])("ul", { className: classes, style: this.props.style }, this.props.suggests.map(function (suggest) {
            var isActive = (_this.props.activeSuggest &&
                suggest.placeId === _this.props.activeSuggest.placeId) ||
                false;
            return (Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(default_1$1, { key: suggest.placeId, className: suggest.className || '', userInput: _this.props.userInput, isHighlightMatch: _this.props.isHighlightMatch, suggest: suggest, style: _this.props.suggestItemStyle, suggestItemClassName: _this.props.suggestItemClassName, isActive: isActive, activeClassName: _this.props.suggestItemActiveClassName, onMouseDown: _this.props.onSuggestMouseDown, onMouseOut: _this.props.onSuggestMouseOut, onSelect: _this.props.onSuggestSelect, renderSuggestItem: _this.props.renderSuggestItem }));
        })));
    };
    return default_1;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]));

/* global window */
// Escapes special characters in user input for regex
function escapeRegExp(str) {
    return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&');
}
/**
 * Entry point for the Geosuggest component
 */
var default_1$3 = /** @class */ (function (_super) {
    __extends(default_1$1, _super);
    /**
     * The constructor. Sets the initial state.
     */
    function default_1$1(props) {
        var _this = _super.call(this, props) || this;
        /**
         * The Google Map instance
         */
        _this.googleMaps = null;
        /**
         * The autocomple service to get suggests
         */
        _this.autocompleteService = null;
        /**
         * The places service to get place details
         */
        _this.placesService = null;
        /**
         * The sessionToken service to use session based monetization
         */
        _this.sessionToken = undefined;
        /**
         * The geocoder to get geocoded results
         */
        _this.geocoder = null;
        /**
         * The input component
         */
        _this.input = null;
        _this.state = {
            activeSuggest: null,
            ignoreBlur: false,
            isLoading: false,
            isSuggestsHidden: true,
            suggests: [],
            userInput: props.initialValue || ''
        };
        _this.onInputChange = _this.onInputChange.bind(_this);
        _this.onAfterInputChange = _this.onAfterInputChange.bind(_this);
        _this.onInputFocus = _this.onInputFocus.bind(_this);
        _this.onInputBlur = _this.onInputBlur.bind(_this);
        _this.onNext = _this.onNext.bind(_this);
        _this.onPrev = _this.onPrev.bind(_this);
        _this.onSelect = _this.onSelect.bind(_this);
        _this.onSuggestMouseDown = _this.onSuggestMouseDown.bind(_this);
        _this.onSuggestMouseOut = _this.onSuggestMouseOut.bind(_this);
        _this.onSuggestNoResults = _this.onSuggestNoResults.bind(_this);
        _this.hideSuggests = _this.hideSuggests.bind(_this);
        _this.selectSuggest = _this.selectSuggest.bind(_this);
        if (props.queryDelay) {
            _this.onAfterInputChange = lodash_debounce(_this.onAfterInputChange, props.queryDelay);
        }
        return _this;
    }
    /**
     * Change inputValue if prop changes
     */
    default_1$1.prototype.componentWillReceiveProps = function (props) {
        if (this.props.initialValue !== props.initialValue) {
            this.setState({ userInput: props.initialValue || '' });
        }
    };
    /**
     * Called on the client side after component is mounted.
     * Google api sdk object will be obtained and cached as a instance property.
     * Necessary objects of google api will also be determined and saved.
     */
    default_1$1.prototype.componentWillMount = function () {
        if (typeof window === 'undefined') {
            return;
        }
        var googleMaps = this.props.googleMaps ||
            (window.google && window.google.maps) ||
            this.googleMaps;
        /* istanbul ignore next */
        if (!googleMaps) {
            if (console) {
                // tslint:disable-next-line:no-console
                console.error('Google maps API was not found in the page.');
            }
            return;
        }
        this.googleMaps = googleMaps;
        this.autocompleteService = new googleMaps.places.AutocompleteService();
        this.placesService = new googleMaps.places.PlacesService(document.createElement('div'));
        this.sessionToken = new googleMaps.places.AutocompleteSessionToken();
        this.geocoder = new googleMaps.Geocoder();
    };
    /**
     * When the component will unmount
     */
    default_1$1.prototype.componentWillUnmount = function () {
        clearTimeout(this.timer);
    };
    /**
     * When the input changed
     */
    default_1$1.prototype.onInputChange = function (userInput) {
        if (!userInput) {
            if (this.props.onSuggestSelect) {
                this.props.onSuggestSelect();
            }
        }
        this.setState({ userInput: userInput }, this.onAfterInputChange);
    };
    /**
     * On After the input got changed
     */
    default_1$1.prototype.onAfterInputChange = function () {
        this.showSuggests();
        if (this.props.onChange) {
            this.props.onChange(this.state.userInput);
        }
    };
    /**
     * When the input gets focused
     */
    default_1$1.prototype.onInputFocus = function () {
        if (this.props.onFocus) {
            this.props.onFocus();
        }
        this.showSuggests();
    };
    /**
     * When the input gets blurred
     */
    default_1$1.prototype.onInputBlur = function () {
        if (!this.state.ignoreBlur) {
            this.hideSuggests();
        }
    };
    default_1$1.prototype.onNext = function () {
        this.activateSuggest('next');
    };
    default_1$1.prototype.onPrev = function () {
        this.activateSuggest('prev');
    };
    default_1$1.prototype.onSelect = function () {
        this.selectSuggest(this.state.activeSuggest);
    };
    default_1$1.prototype.onSuggestMouseDown = function () {
        this.setState({ ignoreBlur: true });
    };
    default_1$1.prototype.onSuggestMouseOut = function () {
        this.setState({ ignoreBlur: false });
    };
    default_1$1.prototype.onSuggestNoResults = function () {
        if (this.props.onSuggestNoResults) {
            this.props.onSuggestNoResults(this.state.userInput);
        }
    };
    /**
     * Focus the input
     */
    default_1$1.prototype.focus = function () {
        if (this.input) {
            this.input.focus();
        }
    };
    /**
     * Blur the input
     */
    default_1$1.prototype.blur = function () {
        if (this.input) {
            this.input.blur();
        }
    };
    /**
     * Update the value of the user input
     */
    default_1$1.prototype.update = function (userInput) {
        this.setState({ userInput: userInput });
        if (this.props.onChange) {
            this.props.onChange(userInput);
        }
    };
    /*
     * Clear the input and close the suggestion pane
     */
    default_1$1.prototype.clear = function () {
        this.setState({ userInput: '' }, this.hideSuggests);
    };
    /**
     * Search for new suggests
     */
    default_1$1.prototype.searchSuggests = function () {
        var _this = this;
        if (!this.state.userInput) {
            this.updateSuggests();
            return;
        }
        var options = {
            input: this.state.userInput,
            sessionToken: this.sessionToken
        };
        var inputLength = this.state.userInput.length;
        var isShorterThanMinLength = this.props.minLength && inputLength < this.props.minLength;
        if (isShorterThanMinLength) {
            return;
        }
        var _a = this.props, location = _a.location, radius = _a.radius, bounds = _a.bounds, types = _a.types, country = _a.country;
        /* tslint:disable:curly */
        if (location)
            options.location = location;
        if (radius)
            options.radius = Number(this.props.radius);
        if (bounds)
            options.bounds = bounds;
        if (types)
            options.types = types;
        if (country)
            options.componentRestrictions = { country: country };
        /* tslint:enable:curly */
        this.setState({ isLoading: true }, function () {
            if (!_this.autocompleteService) {
                _this.setState({ isLoading: false });
                return;
            }
            _this.autocompleteService.getPlacePredictions(options, function (suggestsGoogle) {
                _this.setState({ isLoading: false });
                _this.updateSuggests(suggestsGoogle || [], // can be null
                function () {
                    if (_this.props.autoActivateFirstSuggest &&
                        !_this.state.activeSuggest) {
                        _this.activateSuggest('next');
                    }
                });
            });
        });
    };
    /**
     * Update the suggests
     */
    default_1$1.prototype.updateSuggests = function (suggestsGoogle, 
    // tslint:disable-next-line:no-empty
    callback) {
        var _this = this;
        if (suggestsGoogle === void 0) { suggestsGoogle = []; }
        if (callback === void 0) { callback = function () { }; }
        var suggests = [];
        var userInput = this.state.userInput;
        var _a = this.props, skipSuggest = _a.skipSuggest, maxFixtures = _a.maxFixtures, fixtures = _a.fixtures;
        var regex = new RegExp(escapeRegExp(userInput), 'gim');
        var fixturesSearched = 0;
        var activeSuggest = null;
        if (fixtures) {
            fixtures.forEach(function (fixture) {
                if (maxFixtures && fixturesSearched >= maxFixtures) {
                    return;
                }
                if (skipSuggest &&
                    !skipSuggest(fixture) &&
                    fixture.label.match(regex)) {
                    fixturesSearched++;
                    suggests.push(__assign({}, fixture, { isFixture: true, matchedSubstrings: {
                            length: userInput.length,
                            offset: fixture.label.indexOf(userInput)
                        }, placeId: fixture.placeId || fixture.label }));
                }
            });
        }
        suggestsGoogle.forEach(function (suggest) {
            if (skipSuggest && !skipSuggest(suggest)) {
                suggests.push({
                    description: suggest.description,
                    isFixture: false,
                    label: _this.props.getSuggestLabel
                        ? _this.props.getSuggestLabel(suggest)
                        : '',
                    matchedSubstrings: suggest.matched_substrings[0],
                    placeId: suggest.place_id
                });
            }
        });
        activeSuggest = this.updateActiveSuggest(suggests);
        if (this.props.onUpdateSuggests) {
            this.props.onUpdateSuggests(suggests, activeSuggest);
        }
        this.setState({ suggests: suggests, activeSuggest: activeSuggest }, callback);
    };
    /**
     * Return the new activeSuggest object after suggests have been updated
     */
    default_1$1.prototype.updateActiveSuggest = function (suggests) {
        if (suggests === void 0) { suggests = []; }
        var activeSuggest = this.state.activeSuggest;
        if (activeSuggest) {
            var newSuggest = suggests.filter(function (listedSuggest) {
                return activeSuggest &&
                    activeSuggest.placeId === listedSuggest.placeId &&
                    activeSuggest.isFixture === listedSuggest.isFixture;
            })[0];
            activeSuggest = newSuggest || null;
        }
        return activeSuggest;
    };
    /**
     * Show the suggestions
     */
    default_1$1.prototype.showSuggests = function () {
        this.searchSuggests();
        this.setState({ isSuggestsHidden: false });
    };
    /**
     * Hide the suggestions
     */
    default_1$1.prototype.hideSuggests = function () {
        var _this = this;
        if (this.props.onBlur) {
            this.props.onBlur(this.state.userInput);
        }
        this.timer = window.setTimeout(function () {
            _this.setState({
                activeSuggest: null,
                isSuggestsHidden: true
            });
        }, 100);
    };
    /**
     * Activate a new suggest
     */
    default_1$1.prototype.activateSuggest = function (direction) {
        if (this.state.isSuggestsHidden) {
            this.showSuggests();
            return;
        }
        var suggestsCount = this.state.suggests.length - 1;
        var next = direction === 'next';
        var newActiveSuggest = null;
        var newIndex = 0;
        var i = 0;
        for (i; i <= suggestsCount; i++) {
            if (this.state.suggests[i] === this.state.activeSuggest) {
                newIndex = next ? i + 1 : i - 1;
            }
        }
        if (!this.state.activeSuggest) {
            newIndex = next ? 0 : suggestsCount;
        }
        if (newIndex >= 0 && newIndex <= suggestsCount) {
            newActiveSuggest = this.state.suggests[newIndex];
        }
        if (this.props.onActivateSuggest) {
            this.props.onActivateSuggest(newActiveSuggest);
        }
        this.setState({ activeSuggest: newActiveSuggest });
    };
    /**
     * When an item got selected
     */
    default_1$1.prototype.selectSuggest = function (suggestToSelect) {
        var suggest = suggestToSelect || {
            isFixture: false,
            label: this.state.userInput,
            placeId: this.state.userInput
        };
        if (!suggestToSelect &&
            this.props.autoActivateFirstSuggest &&
            this.state.suggests.length > 0) {
            suggest = this.state.suggests[0];
        }
        this.setState({
            isSuggestsHidden: true,
            userInput: typeof suggest.label !== 'object'
                ? suggest.label
                : suggest.description || ''
        });
        if (suggest.location) {
            this.setState({ ignoreBlur: false });
            if (this.props.onSuggestSelect) {
                this.props.onSuggestSelect(suggest);
            }
            return;
        }
        this.geocodeSuggest(suggest);
    };
    /**
     * Geocode a suggest
     */
    default_1$1.prototype.geocodeSuggest = function (suggestToGeocode) {
        var _this = this;
        if (!this.geocoder) {
            return;
        }
        if (suggestToGeocode.placeId &&
            !suggestToGeocode.isFixture &&
            this.placesService) {
            var options = {
                placeId: suggestToGeocode.placeId,
                sessionToken: this.sessionToken
            };
            if (this.props.placeDetailFields) {
                options.fields = ['geometry'].concat(this.props.placeDetailFields);
            }
            this.placesService.getDetails(options, function (results, status) {
                if (status === _this.googleMaps.places.PlacesServiceStatus.OK) {
                    var gmaps = results;
                    var location_1 = (gmaps.geometry &&
                        gmaps.geometry.location);
                    var suggest = __assign({}, suggestToGeocode, { gmaps: gmaps, location: {
                            lat: location_1.lat(),
                            lng: location_1.lng()
                        } });
                    _this.sessionToken = new google.maps.places.AutocompleteSessionToken();
                    if (_this.props.onSuggestSelect) {
                        _this.props.onSuggestSelect(suggest);
                    }
                }
            });
        }
        else {
            var options = {
                address: suggestToGeocode.label,
                bounds: this.props.bounds,
                componentRestrictions: this.props.country
                    ? { country: this.props.country }
                    : undefined,
                location: this.props.location
            };
            this.geocoder.geocode(options, function (results, status) {
                if (status === _this.googleMaps.GeocoderStatus.OK) {
                    var gmaps = results[0];
                    var location_2 = (gmaps.geometry &&
                        gmaps.geometry.location);
                    var suggest = __assign({}, suggestToGeocode, { gmaps: gmaps, location: {
                            lat: location_2.lat(),
                            lng: location_2.lng()
                        } });
                    if (_this.props.onSuggestSelect) {
                        _this.props.onSuggestSelect(suggest);
                    }
                }
            });
        }
    };
    /**
     * Render the view
     */
    default_1$1.prototype.render = function () {
        var _this = this;
        var attributes = filterInputAttributes(this.props);
        var classes = classnames('geosuggest', this.props.className, {
            'geosuggest--loading': this.state.isLoading
        });
        var shouldRenderLabel = this.props.label && attributes.id;
        var input = (Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(default_1, __assign({ className: this.props.inputClassName, ref: function (i) { return (_this.input = i); }, value: this.state.userInput, doNotSubmitOnEnter: !this.state.isSuggestsHidden, ignoreTab: this.props.ignoreTab, ignoreEnter: this.props.ignoreEnter, style: this.props.style && this.props.style.input, onChange: this.onInputChange, onFocus: this.onInputFocus, onBlur: this.onInputBlur, onKeyDown: this.props.onKeyDown, onKeyPress: this.props.onKeyPress, onNext: this.onNext, onPrev: this.onPrev, onSelect: this.onSelect, onEscape: this.hideSuggests }, attributes)));
        var suggestionsList = (Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(default_1$2, { isHidden: this.state.isSuggestsHidden, style: this.props.style && this.props.style.suggests, suggestItemStyle: this.props.style && this.props.style.suggestItem, userInput: this.state.userInput, isHighlightMatch: Boolean(this.props.highlightMatch), suggestsClassName: this.props.suggestsClassName, suggestItemClassName: this.props.suggestItemClassName, suggests: this.state.suggests, hiddenClassName: this.props.suggestsHiddenClassName, suggestItemActiveClassName: this.props.suggestItemActiveClassName, activeSuggest: this.state.activeSuggest, onSuggestNoResults: this.onSuggestNoResults, onSuggestMouseDown: this.onSuggestMouseDown, onSuggestMouseOut: this.onSuggestMouseOut, onSuggestSelect: this.selectSuggest, renderSuggestItem: this.props.renderSuggestItem }));
        return (Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])("div", { className: classes },
            Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])("div", { className: "geosuggest__input-wrapper" },
                shouldRenderLabel && (Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])("label", { className: "geosuggest__label", htmlFor: attributes.id }, this.props.label)),
                input),
            Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])("div", { className: "geosuggest__suggests-wrapper" }, suggestionsList)));
    };
    /**
     * Default values for the properties
     */
    default_1$1.defaultProps = defaults;
    return default_1$1;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));

/* harmony default export */ __webpack_exports__["a"] = (default_1$3);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(10)))

/***/ }),
/* 137 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AppConf__ = __webpack_require__(28);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}__webpack_require__(16);var WeatherService=function(){function WeatherService(configOptions,revieveConfig){_classCallCheck(this,WeatherService);this.configOptions=configOptions;this.revieveConfig=revieveConfig;this.info={};this.filter={};}_createClass(WeatherService,[{key:'setInfo',value:function setInfo(info){this.info=info;}},{key:'getInfo',value:function getInfo(){return this.info;}},{key:'setFilters',value:function setFilters(filters){this.filters=filters;}},{key:'doGeoIP',value:function doGeoIP(){var _this=this;return new Promise(function(resolve,reject){fetch(__WEBPACK_IMPORTED_MODULE_0__AppConf__["a" /* api_host */][_this.revieveConfig.environment||__WEBPACK_IMPORTED_MODULE_0__AppConf__["b" /* default_environment */]]+'/api/functions/geoIp',{method:'POST',headers:{'Content-Type':'application/json','X-Parse-Application-Id':'Revieve API'},body:JSON.stringify(_this.filters)}).then(function(response){return response.json();}).then(function(body){var defaultDisplay=body.result.city?body.result.city:body.result.country;var display=_this.configOptions.results&&_this.configOptions.results.geoDisplayLevel&&body.result.hasOwnProperty(_this.configOptions.results.geoDisplayLevel)?body.result[_this.configOptions.results.geoDisplayLevel]:defaultDisplay;var obj={city:body.result.city,country:body.result.country,area:body.result.area,display:display};_this.info=obj;resolve(_this.info);}).catch(function(err){console.error(err);reject(err);});});}},{key:'getWeather',value:function getWeather(){var _this2=this;return new Promise(function(resolve,reject){try{fetch(__WEBPACK_IMPORTED_MODULE_0__AppConf__["a" /* api_host */][_this2.revieveConfig.environment||__WEBPACK_IMPORTED_MODULE_0__AppConf__["b" /* default_environment */]]+'/api/functions/weather',{method:'POST',headers:{'Content-Type':'application/json','X-Parse-Application-Id':'Revieve API'},body:JSON.stringify(_this2.info)}).then(function(response){return response.json();}).then(function(body){_this2.info=Object.assign({},_this2.info,body.result);resolve(_this2.info);}).catch(function(err){console.error(err);reject(err);});}catch(e){console.log(e);reject(e);}});}}]);return WeatherService;}();/* harmony default export */ __webpack_exports__["a"] = (WeatherService);

/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

/** @module google-maps-api */

var script = __webpack_require__( 139 ),
  promise = __webpack_require__( 140 );

var maps = null,
  callBacks = [],
  key;

window.$$mapsCB = function() {

  maps = google.maps;

  for( var i = 0, len = callBacks.length; i < len; i++ ) {

    resolve.apply( undefined, callBacks[ i ] );
  }
};

function resolve( onOk, onErr, onComplete, err ) {

  if( !err ) {

    onOk( maps );

    if( onComplete )
      onComplete( undefined, maps );
  } else {

    onErr( err );

    if( onComplete )
      onComplete( err );
  }
}


/**
 * Load a Google Maps API Object asynchronously. This module will return a Promise.
 * Which will on resolved will return the "google.maps" object.
 *
 * Or if you prefer you can simply use the callback instead.
 *
 * @param  {String} apikey Your Google Maps API Key
 * @param  {Function} [onComplete] A callback which will return the google.maps object
 * @return {Promise} When this promise resolves it will return the google.maps object
 *
 * @example using via promise
 *
 * ```javascript
 * var mapsapi = require( 'google-maps-api' )( 'your api key' );
 *
 * mapsapi().then( function( maps ) {
 *
 *  //use the google.maps object as you please
 * });
 * ```
 *
 * @example using via callback
 * ```javascript
 * require( 'google-maps-api' )( 'your api key', function( maps ) {
 *
 *  //use the google.maps object as you please
 * })
 * ```
 */
module.exports = function( apikey, libraries, onComplete ) {

  key = apikey || key;
  if (typeof libraries == 'function') {
    onComplete = libraries;
    libraries = [];
  }

  return function() {

    return new promise( function( onOk, onErr ) {

      if( !key ) {

        resolve( onOk, onErr, onComplete, new Error( 'No API key passed to require(\'google-maps-api\')' ) );
      } else {

        if( maps ) {

          resolve( onOk, onErr, onComplete );
        } else {

          callBacks.push( [ onOk, onErr, onComplete ] );

          if (callBacks.length == 1) {
            var auth = '';
            if (typeof key == 'string') {

              auth = '&key=' + key;
            } else if (typeof key == 'object') {

              auth = '&' + Object.keys(key).map(function (k) {
                return k + '=' + encodeURIComponent(key[k]);
              }).join('&');
            }

            var url = 'https://maps.googleapis.com/maps/api/js?v=3&callback=$$mapsCB' + auth;
            if (Array.isArray(libraries) && libraries.length > 0) {
              url+='&libraries='+libraries.join(',');
            }
            script( url );
          }
        }
      }
    });
  };
};


/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  * $script.js JS loader & dependency manager
  * https://github.com/ded/script.js
  * (c) Dustin Diaz 2014 | License MIT
  */

(function (name, definition) {
  if (typeof module != 'undefined' && module.exports) module.exports = definition()
  else if (true) !(__WEBPACK_AMD_DEFINE_FACTORY__ = (definition),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
  else this[name] = definition()
})('$script', function () {
  var doc = document
    , head = doc.getElementsByTagName('head')[0]
    , s = 'string'
    , f = false
    , push = 'push'
    , readyState = 'readyState'
    , onreadystatechange = 'onreadystatechange'
    , list = {}
    , ids = {}
    , delay = {}
    , scripts = {}
    , scriptpath
    , urlArgs

  function every(ar, fn) {
    for (var i = 0, j = ar.length; i < j; ++i) if (!fn(ar[i])) return f
    return 1
  }
  function each(ar, fn) {
    every(ar, function (el) {
      fn(el)
      return 1
    })
  }

  function $script(paths, idOrDone, optDone) {
    paths = paths[push] ? paths : [paths]
    var idOrDoneIsDone = idOrDone && idOrDone.call
      , done = idOrDoneIsDone ? idOrDone : optDone
      , id = idOrDoneIsDone ? paths.join('') : idOrDone
      , queue = paths.length
    function loopFn(item) {
      return item.call ? item() : list[item]
    }
    function callback() {
      if (!--queue) {
        list[id] = 1
        done && done()
        for (var dset in delay) {
          every(dset.split('|'), loopFn) && !each(delay[dset], loopFn) && (delay[dset] = [])
        }
      }
    }
    setTimeout(function () {
      each(paths, function loading(path, force) {
        if (path === null) return callback()
        
        if (!force && !/^https?:\/\//.test(path) && scriptpath) {
          path = (path.indexOf('.js') === -1) ? scriptpath + path + '.js' : scriptpath + path;
        }
        
        if (scripts[path]) {
          if (id) ids[id] = 1
          return (scripts[path] == 2) ? callback() : setTimeout(function () { loading(path, true) }, 0)
        }

        scripts[path] = 1
        if (id) ids[id] = 1
        create(path, callback)
      })
    }, 0)
    return $script
  }

  function create(path, fn) {
    var el = doc.createElement('script'), loaded
    el.onload = el.onerror = el[onreadystatechange] = function () {
      if ((el[readyState] && !(/^c|loade/.test(el[readyState]))) || loaded) return;
      el.onload = el[onreadystatechange] = null
      loaded = 1
      scripts[path] = 2
      fn()
    }
    el.async = 1
    el.src = urlArgs ? path + (path.indexOf('?') === -1 ? '?' : '&') + urlArgs : path;
    head.insertBefore(el, head.lastChild)
  }

  $script.get = create

  $script.order = function (scripts, id, done) {
    (function callback(s) {
      s = scripts.shift()
      !scripts.length ? $script(s, id, done) : $script(s, callback)
    }())
  }

  $script.path = function (p) {
    scriptpath = p
  }
  $script.urlArgs = function (str) {
    urlArgs = str;
  }
  $script.ready = function (deps, ready, req) {
    deps = deps[push] ? deps : [deps]
    var missing = [];
    !each(deps, function (dep) {
      list[dep] || missing[push](dep);
    }) && every(deps, function (dep) {return list[dep]}) ?
      ready() : !function (key) {
      delay[key] = delay[key] || []
      delay[key][push](ready)
      req && req(missing)
    }(deps.join('|'))
    return $script
  }

  $script.done = function (idOrDone) {
    $script([null], idOrDone)
  }

  return $script
});


/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(14)
__webpack_require__(143)
__webpack_require__(144)
__webpack_require__(145)

/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var scope = (typeof global !== "undefined" && global) ||
            (typeof self !== "undefined" && self) ||
            window;
var apply = Function.prototype.apply;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) {
  if (timeout) {
    timeout.close();
  }
};

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(scope, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// setimmediate attaches itself to the global object
__webpack_require__(142);
// On some exotic environments, it's not clear which object `setimmediate` was
// able to install onto.  Search each possibility in the same order as the
// `setimmediate` library.
exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
                       (typeof global !== "undefined" && global.setImmediate) ||
                       (this && this.setImmediate);
exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
                         (typeof global !== "undefined" && global.clearImmediate) ||
                         (this && this.clearImmediate);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(10)))

/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
      // Callback can either be a function or a string
      if (typeof callback !== "function") {
        callback = new Function("" + callback);
      }
      // Copy function arguments
      var args = new Array(arguments.length - 1);
      for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i + 1];
      }
      // Store and register the task
      var task = { callback: callback, args: args };
      tasksByHandle[nextHandle] = task;
      registerImmediate(nextHandle);
      return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
        case 0:
            callback();
            break;
        case 1:
            callback(args[0]);
            break;
        case 2:
            callback(args[0], args[1]);
            break;
        case 3:
            callback(args[0], args[1], args[2]);
            break;
        default:
            callback.apply(undefined, args);
            break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function(handle) {
            process.nextTick(function () { runIfPresent(handle); });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function() {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function(event) {
            if (event.source === global &&
                typeof event.data === "string" &&
                event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();

    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();

    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();

    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();

    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(10), __webpack_require__(11)))

/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Promise = __webpack_require__(14)
var asap = __webpack_require__(15)

module.exports = Promise
Promise.prototype.done = function (onFulfilled, onRejected) {
  var self = arguments.length ? this.then.apply(this, arguments) : this
  self.then(null, function (err) {
    asap(function () {
      throw err
    })
  })
}

/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//This file contains the ES6 extensions to the core Promises/A+ API

var Promise = __webpack_require__(14)
var asap = __webpack_require__(15)

module.exports = Promise

/* Static Functions */

function ValuePromise(value) {
  this.then = function (onFulfilled) {
    if (typeof onFulfilled !== 'function') return this
    return new Promise(function (resolve, reject) {
      asap(function () {
        try {
          resolve(onFulfilled(value))
        } catch (ex) {
          reject(ex);
        }
      })
    })
  }
}
ValuePromise.prototype = Promise.prototype

var TRUE = new ValuePromise(true)
var FALSE = new ValuePromise(false)
var NULL = new ValuePromise(null)
var UNDEFINED = new ValuePromise(undefined)
var ZERO = new ValuePromise(0)
var EMPTYSTRING = new ValuePromise('')

Promise.resolve = function (value) {
  if (value instanceof Promise) return value

  if (value === null) return NULL
  if (value === undefined) return UNDEFINED
  if (value === true) return TRUE
  if (value === false) return FALSE
  if (value === 0) return ZERO
  if (value === '') return EMPTYSTRING

  if (typeof value === 'object' || typeof value === 'function') {
    try {
      var then = value.then
      if (typeof then === 'function') {
        return new Promise(then.bind(value))
      }
    } catch (ex) {
      return new Promise(function (resolve, reject) {
        reject(ex)
      })
    }
  }

  return new ValuePromise(value)
}

Promise.all = function (arr) {
  var args = Array.prototype.slice.call(arr)

  return new Promise(function (resolve, reject) {
    if (args.length === 0) return resolve([])
    var remaining = args.length
    function res(i, val) {
      try {
        if (val && (typeof val === 'object' || typeof val === 'function')) {
          var then = val.then
          if (typeof then === 'function') {
            then.call(val, function (val) { res(i, val) }, reject)
            return
          }
        }
        args[i] = val
        if (--remaining === 0) {
          resolve(args);
        }
      } catch (ex) {
        reject(ex)
      }
    }
    for (var i = 0; i < args.length; i++) {
      res(i, args[i])
    }
  })
}

Promise.reject = function (value) {
  return new Promise(function (resolve, reject) { 
    reject(value);
  });
}

Promise.race = function (values) {
  return new Promise(function (resolve, reject) { 
    values.forEach(function(value){
      Promise.resolve(value).then(resolve, reject);
    })
  });
}

/* Prototype Methods */

Promise.prototype['catch'] = function (onRejected) {
  return this.then(null, onRejected);
}


/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//This file contains then/promise specific extensions that are only useful for node.js interop

var Promise = __webpack_require__(14)
var asap = __webpack_require__(15)

module.exports = Promise

/* Static Functions */

Promise.denodeify = function (fn, argumentCount) {
  argumentCount = argumentCount || Infinity
  return function () {
    var self = this
    var args = Array.prototype.slice.call(arguments)
    return new Promise(function (resolve, reject) {
      while (args.length && args.length > argumentCount) {
        args.pop()
      }
      args.push(function (err, res) {
        if (err) reject(err)
        else resolve(res)
      })
      var res = fn.apply(self, args)
      if (res && (typeof res === 'object' || typeof res === 'function') && typeof res.then === 'function') {
        resolve(res)
      }
    })
  }
}
Promise.nodeify = function (fn) {
  return function () {
    var args = Array.prototype.slice.call(arguments)
    var callback = typeof args[args.length - 1] === 'function' ? args.pop() : null
    var ctx = this
    try {
      return fn.apply(this, arguments).nodeify(callback, ctx)
    } catch (ex) {
      if (callback === null || typeof callback == 'undefined') {
        return new Promise(function (resolve, reject) { reject(ex) })
      } else {
        asap(function () {
          callback.call(ctx, ex)
        })
      }
    }
  }
}

Promise.prototype.nodeify = function (callback, ctx) {
  if (typeof callback != 'function') return this

  this.then(function (value) {
    asap(function () {
      callback.call(ctx, null, value)
    })
  }, function (err) {
    asap(function () {
      callback.call(ctx, err)
    })
  })
}


/***/ }),
/* 146 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SkinAnalysisItem__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__SkinAnalysisIcons__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_polyglot__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_polyglot___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_polyglot__);
var _jsx=function(){var REACT_ELEMENT_TYPE=typeof Symbol==="function"&&Symbol.for&&Symbol.for("react.element")||0xeac7;return function createRawReactElement(type,props,key,children){var defaultProps=type&&type.defaultProps;var childrenLength=arguments.length-3;if(!props&&childrenLength!==0){props={};}if(props&&defaultProps){for(var propName in defaultProps){if(props[propName]===void 0){props[propName]=defaultProps[propName];}}}else if(!props){props=defaultProps||{};}if(childrenLength===1){props.children=children;}else if(childrenLength>1){var childArray=Array(childrenLength);for(var i=0;i<childrenLength;i++){childArray[i]=arguments[i+3];}props.children=childArray;}return{$$typeof:REACT_ELEMENT_TYPE,type:type,key:key===undefined?null:''+key,ref:null,props:props,_owner:null};};}();var _templateObject=_taggedTemplateLiteral(['\n  background: rgba(0, 0, 0, 0.7);\n  border-radius: 8px;\n  height: 120px;\n  display: flex;\n  align-items: center;\n  position: absolute;\n  /* left: 30px; */\n  min-width: 100%;\n'],['\n  background: rgba(0, 0, 0, 0.7);\n  border-radius: 8px;\n  height: 120px;\n  display: flex;\n  align-items: center;\n  position: absolute;\n  /* left: 30px; */\n  min-width: 100%;\n']),_templateObject2=_taggedTemplateLiteral(['\n  width: 100%;\n  position: absolute;\n  bottom: 140px;\n  padding-left: 18px;\n  color: white;\n  font-size: small;\n'],['\n  width: 100%;\n  position: absolute;\n  bottom: 140px;\n  padding-left: 18px;\n  color: white;\n  font-size: small;\n']);function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var StyledSkinAnalysisWidget=__WEBPACK_IMPORTED_MODULE_1_styled_components__["b" /* default */].div(_templateObject);var StyledInfoText=__WEBPACK_IMPORTED_MODULE_1_styled_components__["b" /* default */].div(_templateObject2);function generateIcons(_ref){var data=_ref.data,iconSetup=_ref.iconSetup,focusOnHandler=_ref.focusOnHandler,focusedFinding=_ref.focusedFinding,showOnly=_ref.showOnly,_ref$showRange=_ref.showRange,showRange=_ref$showRange===undefined?false:_ref$showRange,skintoneValue=_ref.skintoneValue,t=_ref.t,ranges=_ref.ranges;var icons=[];var _loop=function _loop(iconName){if(showOnly&&Array.isArray(showOnly)&&showOnly.indexOf(iconName)<0){return'continue';}var icon=iconSetup[iconName];if(data.hasOwnProperty(icon.key)&&data[icon.key].hasOwnProperty('sum_measures')){var r=data[icon.key].sum_measures.find(function(d){return d.description===icon.withDescription;});var localWarnings=data[icon.key].local_warnings&&data[icon.key].local_warnings.length>0?data[icon.key].local_warnings:null;// let d = data[icon.key].hasOwnProperty('measurement_locations') ? data[icon.key]['measurement_locations'] : null;
var value=void 0;if(icon.key===icon.withDescription){//in case of wrinkles or redness we take the value provided by CV
value=data[icon.key].value;}else{value=r?r.value:'NA';}var rangeColor=null;if(icon.enum&&icon.enum.hasOwnProperty(String(value))){value=icon.enum[value];}else if(showRange&&icon.range){// we need to detect the range for this value
for(var rangeName in icon.range){if(icon.range[rangeName]){var rangeInfo=icon.range[rangeName];if(value>=rangeInfo.min&&value<=rangeInfo.max){value=t('range_'+rangeName).toUpperCase();rangeColor=rangeInfo.color;break;}}}}else if(icon.type==='skintoneColor'){value=Object(__WEBPACK_IMPORTED_MODULE_3__utils__["h" /* rgbToHex */])(value[0]);}else if(isNaN(value)){//value = 'NA';
}else{value=(value*100).toFixed(0)+'%';}icons.push(_jsx(__WEBPACK_IMPORTED_MODULE_2__SkinAnalysisItem__["a" /* default */],{value:value,rangeColor:rangeColor,icon:icon.icon,label:icon.label,selected:iconName===focusedFinding,onClick:function onClick(){if(ranges&&ranges[iconName]){focusOnHandler(iconName,null,ranges[iconName]);}else{focusOnHandler(iconName);}},warnings:localWarnings},iconName));}//Skintone value isn't present in results. We need to get it from SDK
if(icon.type==='skintone'){var _value=skintoneValue;_value=icon.enum[_value];icons.push(_jsx(__WEBPACK_IMPORTED_MODULE_2__SkinAnalysisItem__["a" /* default */],{value:_value,icon:icon.icon,label:iconName,selected:iconName===focusedFinding,onClick:function onClick(){focusOnHandler(iconName);}},iconName));}};var _iteratorNormalCompletion=true;var _didIteratorError=false;var _iteratorError=undefined;try{for(var _iterator=Object.keys(iconSetup)[Symbol.iterator](),_step;!(_iteratorNormalCompletion=(_step=_iterator.next()).done);_iteratorNormalCompletion=true){var iconName=_step.value;var _ret=_loop(iconName);if(_ret==='continue')continue;}}catch(err){_didIteratorError=true;_iteratorError=err;}finally{try{if(!_iteratorNormalCompletion&&_iterator.return){_iterator.return();}}finally{if(_didIteratorError){throw _iteratorError;}}}return icons;}var SkinAnalysisWidget=function(_Component){_inherits(SkinAnalysisWidget,_Component);function SkinAnalysisWidget(){var _ref2;var _temp,_this,_ret2;_classCallCheck(this,SkinAnalysisWidget);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret2=(_temp=(_this=_possibleConstructorReturn(this,(_ref2=SkinAnalysisWidget.__proto__||Object.getPrototypeOf(SkinAnalysisWidget)).call.apply(_ref2,[this].concat(args))),_this),_this.componentDidMount=function(){var _this$props=_this.props,options=_this$props.options,focusOnSkinFinding=_this$props.focusOnSkinFinding,setSkinAnalysisPageRendered=_this$props.setSkinAnalysisPageRendered;if(options.focusOn){setTimeout(function(){if(options.ranges&&options.ranges[options.focusOn]){focusOnSkinFinding(options.focusOn,null,options.ranges[options.focusOn]);}else{focusOnSkinFinding(options.focusOn);}setSkinAnalysisPageRendered();},500);}},_this.render=function(){var _this$props2=_this.props,cvResults=_this$props2.cvResults,focusOnSkinFinding=_this$props2.focusOnSkinFinding,focusedOnSkinFinding=_this$props2.focusedOnSkinFinding,options=_this$props2.options,ARMethods=_this$props2.ARMethods,t=_this$props2.t;if(cvResults&&cvResults.results){var resultSumMeasures=Object(__WEBPACK_IMPORTED_MODULE_3__utils__["i" /* sumMeasures */])(cvResults.results);var icons=generateIcons({data:resultSumMeasures,iconSetup:__WEBPACK_IMPORTED_MODULE_3__utils__["f" /* inStoreIconSetup */],focusOnHandler:focusOnSkinFinding,focusedFinding:focusedOnSkinFinding,showOnly:options.showOnly,showRange:options.showRange,skintoneValue:ARMethods.getSdkSkintone(),t:t,ranges:options.ranges});return _jsx('div',{},void 0,options.infoText&&_jsx(StyledInfoText,{},void 0,' ',options.infoText,' '),_jsx(StyledSkinAnalysisWidget,{className:'revieve-skin-analysis-widget'},void 0,icons));}return _jsx(StyledSkinAnalysisWidget,{className:'revieve-skin-analysis-widget'},void 0,_jsx(__WEBPACK_IMPORTED_MODULE_2__SkinAnalysisItem__["a" /* default */],{value:'Diamond',icon:__WEBPACK_IMPORTED_MODULE_4__SkinAnalysisIcons__["a" /* default */].shape,label:'Test1',selected:'Diamond'===focusedOnSkinFinding,onClick:function onClick(){focusOnSkinFinding('Diamond',{});}}),_jsx(__WEBPACK_IMPORTED_MODULE_2__SkinAnalysisItem__["a" /* default */],{value:'Green',icon:__WEBPACK_IMPORTED_MODULE_4__SkinAnalysisIcons__["a" /* default */].eyecolor,label:'Test2'}),_jsx(__WEBPACK_IMPORTED_MODULE_2__SkinAnalysisItem__["a" /* default */],{value:'21%',icon:__WEBPACK_IMPORTED_MODULE_4__SkinAnalysisIcons__["a" /* default */].darkcircles,label:'Test3'}));},_temp),_possibleConstructorReturn(_this,_ret2);}return SkinAnalysisWidget;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5_react_polyglot__["translate"])()(SkinAnalysisWidget));

/***/ }),
/* 147 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SkinAnalysisIcons__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__images_instore_icons_dark_circles_svg__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__images_instore_icons_dark_circles_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__images_instore_icons_dark_circles_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__images_instore_icons_eyebags_svg__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__images_instore_icons_eyebags_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__images_instore_icons_eyebags_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__images_instore_icons_eyecolor_svg__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__images_instore_icons_eyecolor_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__images_instore_icons_eyecolor_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__images_instore_icons_pigment_variation_svg__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__images_instore_icons_pigment_variation_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__images_instore_icons_pigment_variation_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__images_instore_icons_radiance_svg__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__images_instore_icons_radiance_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__images_instore_icons_radiance_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__images_instore_icons_shape_svg__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__images_instore_icons_shape_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__images_instore_icons_shape_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__images_instore_icons_undertone_svg__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__images_instore_icons_undertone_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__images_instore_icons_undertone_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__images_instore_icons_wrinkles_lines_svg__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__images_instore_icons_wrinkles_lines_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__images_instore_icons_wrinkles_lines_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__images_instore_icons_warning_icon_svg__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__images_instore_icons_warning_icon_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__images_instore_icons_warning_icon_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__images_instore_icons_acne_svg__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__images_instore_icons_acne_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__images_instore_icons_acne_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__images_instore_icons_skin_shine_svg__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__images_instore_icons_skin_shine_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__images_instore_icons_skin_shine_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__images_instore_icons_redness_svg__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__images_instore_icons_redness_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__images_instore_icons_redness_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__images_instore_icons_texture_svg__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__images_instore_icons_texture_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__images_instore_icons_texture_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_react_polyglot__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_react_polyglot___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_react_polyglot__);
var _jsx=function(){var REACT_ELEMENT_TYPE=typeof Symbol==="function"&&Symbol.for&&Symbol.for("react.element")||0xeac7;return function createRawReactElement(type,props,key,children){var defaultProps=type&&type.defaultProps;var childrenLength=arguments.length-3;if(!props&&childrenLength!==0){props={};}if(props&&defaultProps){for(var propName in defaultProps){if(props[propName]===void 0){props[propName]=defaultProps[propName];}}}else if(!props){props=defaultProps||{};}if(childrenLength===1){props.children=children;}else if(childrenLength>1){var childArray=Array(childrenLength);for(var i=0;i<childrenLength;i++){childArray[i]=arguments[i+3];}props.children=childArray;}return{$$typeof:REACT_ELEMENT_TYPE,type:type,key:key===undefined?null:''+key,ref:null,props:props,_owner:null};};}();var _templateObject=_taggedTemplateLiteral(['\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-content: space-between;\n  position: relative;\n  order: ',';\n  width: 100px;\n  height: 100px;\n  color: ',';\n\n  .value,\n  .label {\n    text-align: center;\n    font-size: 12px;\n    font-weight: 600;\n  }\n  .rangeColor {\n    width: 60%;\n    height: 6px;\n    margin: auto;\n    background-color: ',';\n  }\n  .icon {\n    height: 48px;\n    width: 48px;\n    margin: 2px auto;\n    fill: tomato;\n  }\n  .iconSkintoneColor {\n    height: 38px;\n    width: 38px;\n    margin: 2px auto;\n    border-radius: 20px;\n    margin: 6px auto;\n  }\n  .darkcircles {\n    background-image: url(',');\n  }\n  .eyebags {\n    background-image: url(',');\n  }\n  .eyecolor {\n    background-image: url(',');\n  }\n  .pigmentvariation {\n    background-image: url(',');\n  }\n  .radiance {\n    background-image: url(',');\n  }\n  .shape {\n    background-image: url(',');\n  }\n  .undertone {\n    background-image: url(',');\n  }\n  .wrinkleslines {\n    background-image: url(',');\n  }\n  .acne {\n    background-image: url(',');\n  }\n  .skinShine {\n    background-image: url(',');\n  }\n  .texture {\n    background-image: url(',');\n  }\n  .redness {\n    background-image: url(',');\n  }\n  .warning {\n    background-image: url(',');\n    position: absolute;\n    width: 16px;\n    height: 16px;\n    right: 24px;\n    top: 28px;\n  }\n  .tooltip {\n    position: absolute;\n    left: 0;\n    top: -150px;\n    background: rgba(0, 0, 0, 0.5);\n    border-radius: 8px;\n    width: 300px;\n    height: 120px;\n    padding: 20px;\n    color: white;\n    line-height: 1.4;\n    transform: translate3d(0, 20px, 0);\n    opacity: 0;\n    transition: transform 0.5s cubic-bezier(0.5, 0, 0, 1.2);\n    ul {\n      list-style: none;\n      overflow-y: scroll;\n      max-height: 80px;\n      margin-bottom: 10px;\n      z-index: 1;\n      li {\n        margin-bottom: 10px;\n      }\n      &::-webkit-scrollbar {\n        display: none;\n      }\n    }\n    &:after {\n      position: absolute;\n      content: \'\';\n      width: 100%;\n      height: 50%;\n      background: linear-gradient(to top, rgba(0, 0, 0, 1), rgba(0, 0, 0, 0.1));\n      bottom: 0;\n      left: 0;\n      border-bottom-left-radius: 8px;\n      border-bottom-right-radius: 8px;\n      z-index: 2;\n    }\n    &:before {\n      position: absolute;\n      content: \'\';\n      bottom: -10px;\n      left: 40px;\n      height: 10px;\n      width: 20px;\n      background: linear-gradient(-135deg, rgba(0, 0, 0, 1) 50%, transparent 50%),\n        linear-gradient(135deg, rgba(0, 0, 0, 1) 50%, transparent 50%);\n      background-position: 0 0, 10px 0;\n      background-repeat: no-repeat no-repeat;\n      background-size: 10px 10px, 10px 10px;\n    }\n  }\n  .tooltipActive {\n    opacity: 1;\n    transform: translate3d(0, 0, 0);\n  }\n'],['\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-content: space-between;\n  position: relative;\n  order: ',';\n  width: 100px;\n  height: 100px;\n  color: ',';\n\n  .value,\n  .label {\n    text-align: center;\n    font-size: 12px;\n    font-weight: 600;\n  }\n  .rangeColor {\n    width: 60%;\n    height: 6px;\n    margin: auto;\n    background-color: ',';\n  }\n  .icon {\n    height: 48px;\n    width: 48px;\n    margin: 2px auto;\n    fill: tomato;\n  }\n  .iconSkintoneColor {\n    height: 38px;\n    width: 38px;\n    margin: 2px auto;\n    border-radius: 20px;\n    margin: 6px auto;\n  }\n  .darkcircles {\n    background-image: url(',');\n  }\n  .eyebags {\n    background-image: url(',');\n  }\n  .eyecolor {\n    background-image: url(',');\n  }\n  .pigmentvariation {\n    background-image: url(',');\n  }\n  .radiance {\n    background-image: url(',');\n  }\n  .shape {\n    background-image: url(',');\n  }\n  .undertone {\n    background-image: url(',');\n  }\n  .wrinkleslines {\n    background-image: url(',');\n  }\n  .acne {\n    background-image: url(',');\n  }\n  .skinShine {\n    background-image: url(',');\n  }\n  .texture {\n    background-image: url(',');\n  }\n  .redness {\n    background-image: url(',');\n  }\n  .warning {\n    background-image: url(',');\n    position: absolute;\n    width: 16px;\n    height: 16px;\n    right: 24px;\n    top: 28px;\n  }\n  .tooltip {\n    position: absolute;\n    left: 0;\n    top: -150px;\n    background: rgba(0, 0, 0, 0.5);\n    border-radius: 8px;\n    width: 300px;\n    height: 120px;\n    padding: 20px;\n    color: white;\n    line-height: 1.4;\n    transform: translate3d(0, 20px, 0);\n    opacity: 0;\n    transition: transform 0.5s cubic-bezier(0.5, 0, 0, 1.2);\n    ul {\n      list-style: none;\n      overflow-y: scroll;\n      max-height: 80px;\n      margin-bottom: 10px;\n      z-index: 1;\n      li {\n        margin-bottom: 10px;\n      }\n      &::-webkit-scrollbar {\n        display: none;\n      }\n    }\n    &:after {\n      position: absolute;\n      content: \'\';\n      width: 100%;\n      height: 50%;\n      background: linear-gradient(to top, rgba(0, 0, 0, 1), rgba(0, 0, 0, 0.1));\n      bottom: 0;\n      left: 0;\n      border-bottom-left-radius: 8px;\n      border-bottom-right-radius: 8px;\n      z-index: 2;\n    }\n    &:before {\n      position: absolute;\n      content: \'\';\n      bottom: -10px;\n      left: 40px;\n      height: 10px;\n      width: 20px;\n      background: linear-gradient(-135deg, rgba(0, 0, 0, 1) 50%, transparent 50%),\n        linear-gradient(135deg, rgba(0, 0, 0, 1) 50%, transparent 50%);\n      background-position: 0 0, 10px 0;\n      background-repeat: no-repeat no-repeat;\n      background-size: 10px 10px, 10px 10px;\n    }\n  }\n  .tooltipActive {\n    opacity: 1;\n    transform: translate3d(0, 0, 0);\n  }\n']);function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Item=__WEBPACK_IMPORTED_MODULE_1_styled_components__["b" /* default */].div(_templateObject,function(props){return props.order?props.order:100;},function(props){return props.selected?props.rangeColor||'#00FF89':'white';},function(props){return props.rangeColor;},__WEBPACK_IMPORTED_MODULE_4__images_instore_icons_dark_circles_svg___default.a,__WEBPACK_IMPORTED_MODULE_5__images_instore_icons_eyebags_svg___default.a,__WEBPACK_IMPORTED_MODULE_6__images_instore_icons_eyecolor_svg___default.a,__WEBPACK_IMPORTED_MODULE_7__images_instore_icons_pigment_variation_svg___default.a,__WEBPACK_IMPORTED_MODULE_8__images_instore_icons_radiance_svg___default.a,__WEBPACK_IMPORTED_MODULE_9__images_instore_icons_shape_svg___default.a,__WEBPACK_IMPORTED_MODULE_10__images_instore_icons_undertone_svg___default.a,__WEBPACK_IMPORTED_MODULE_11__images_instore_icons_wrinkles_lines_svg___default.a,__WEBPACK_IMPORTED_MODULE_13__images_instore_icons_acne_svg___default.a,__WEBPACK_IMPORTED_MODULE_14__images_instore_icons_skin_shine_svg___default.a,__WEBPACK_IMPORTED_MODULE_16__images_instore_icons_texture_svg___default.a,__WEBPACK_IMPORTED_MODULE_15__images_instore_icons_redness_svg___default.a,__WEBPACK_IMPORTED_MODULE_12__images_instore_icons_warning_icon_svg___default.a);var SkinAnalysisItem=function(_Component){_inherits(SkinAnalysisItem,_Component);function SkinAnalysisItem(){var _ref;var _temp,_this,_ret;_classCallCheck(this,SkinAnalysisItem);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=SkinAnalysisItem.__proto__||Object.getPrototypeOf(SkinAnalysisItem)).call.apply(_ref,[this].concat(args))),_this),_this.render=function(){var _this$props=_this.props,icon=_this$props.icon,label=_this$props.label,value=_this$props.value,rangeColor=_this$props.rangeColor,selected=_this$props.selected,onClick=_this$props.onClick,order=_this$props.order,warnings=_this$props.warnings,t=_this$props.t;return _jsx(Item,{selected:selected,onClick:onClick,order:order,rangeColor:rangeColor},void 0,rangeColor&&_jsx('div',{className:'rangeColor'},void 0,' \xA0 '),_jsx('div',{className:'value'},void 0,value),icon==='skintoneColor'&&_jsx('div',{className:'iconSkintoneColor',style:{backgroundColor:value}}),icon!=='skintoneColor'&&_jsx('div',{className:'icon '+icon}),_jsx('div',{className:'label'},void 0,t(label)),warnings?_jsx('div',{className:'warning'}):null,warnings?_jsx('div',{className:selected?'tooltip tooltipActive':'tooltip'},void 0,_jsx('ul',{},void 0,warnings.map(function(warning,i){return _jsx('li',{},i,t('CV_CODE_'+warning.idx));}))):null);},_temp),_possibleConstructorReturn(_this,_ret);}return SkinAnalysisItem;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);SkinAnalysisItem.propTypes={icon:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOf(Object.keys(__WEBPACK_IMPORTED_MODULE_3__SkinAnalysisIcons__["a" /* default */])),label:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,value:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,selected:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,warnings:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_17_react_polyglot__["translate"])()(SkinAnalysisItem));

/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/dark-circles.5b2759d2.svg";

/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/eyebags.aed94b63.svg";

/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/eyecolor.a90086e4.svg";

/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/pigment-variation.63b0ef87.svg";

/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/radiance.416c8477.svg";

/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/shape.b6ad029d.svg";

/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/undertone.c12a7ece.svg";

/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/wrinkles-lines.1fc4bdcc.svg";

/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/warning-icon.8ed41d8d.svg";

/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/acne.96636657.svg";

/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/skin-shine.4ab04cb4.svg";

/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/redness.6b049c08.svg";

/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/texture.75050445.svg";

/***/ }),
/* 161 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MainButton_style__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MediaQueries__ = __webpack_require__(3);
var _jsx=function(){var REACT_ELEMENT_TYPE=typeof Symbol==="function"&&Symbol.for&&Symbol.for("react.element")||0xeac7;return function createRawReactElement(type,props,key,children){var defaultProps=type&&type.defaultProps;var childrenLength=arguments.length-3;if(!props&&childrenLength!==0){props={};}if(props&&defaultProps){for(var propName in defaultProps){if(props[propName]===void 0){props[propName]=defaultProps[propName];}}}else if(!props){props=defaultProps||{};}if(childrenLength===1){props.children=children;}else if(childrenLength>1){var childArray=Array(childrenLength);for(var i=0;i<childrenLength;i++){childArray[i]=arguments[i+3];}props.children=childArray;}return{$$typeof:REACT_ELEMENT_TYPE,type:type,key:key===undefined?null:''+key,ref:null,props:props,_owner:null};};}();var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n  ','\n\n  &:active {\n    transform: scale3d(1.1, 1.1, 1);\n    border: 3px solid #ffaa5f;\n  }\n'],['\n  ','\n\n  &:active {\n    transform: scale3d(1.1, 1.1, 1);\n    border: 3px solid #ffaa5f;\n  }\n']),_templateObject2=_taggedTemplateLiteral(['\n    margin-bottom: auto;\n    height: 44px;\n  '],['\n    margin-bottom: auto;\n    height: 44px;\n  ']);function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}// override StyledMainButton if needed.
var StyledNextButton=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["b" /* default */])(__WEBPACK_IMPORTED_MODULE_2__MainButton_style__["a" /* default */])(_templateObject,__WEBPACK_IMPORTED_MODULE_3__MediaQueries__["a" /* default */].phone(_templateObject2));var NextPageButton=function(_Component){_inherits(NextPageButton,_Component);function NextPageButton(){_classCallCheck(this,NextPageButton);return _possibleConstructorReturn(this,(NextPageButton.__proto__||Object.getPrototypeOf(NextPageButton)).apply(this,arguments));}_createClass(NextPageButton,[{key:'render',value:function render(){return _jsx(StyledNextButton,{onClick:this.props.nextPage,align:this.props.options.align,style:this.props.options.style,onTouchStart:null,className:this.props.options.className},void 0,this.props.options.title);}}]);return NextPageButton;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (NextPageButton);

/***/ }),
/* 162 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MediaQueries__ = __webpack_require__(3);
var _jsx=function(){var REACT_ELEMENT_TYPE=typeof Symbol==="function"&&Symbol.for&&Symbol.for("react.element")||0xeac7;return function createRawReactElement(type,props,key,children){var defaultProps=type&&type.defaultProps;var childrenLength=arguments.length-3;if(!props&&childrenLength!==0){props={};}if(props&&defaultProps){for(var propName in defaultProps){if(props[propName]===void 0){props[propName]=defaultProps[propName];}}}else if(!props){props=defaultProps||{};}if(childrenLength===1){props.children=children;}else if(childrenLength>1){var childArray=Array(childrenLength);for(var i=0;i<childrenLength;i++){childArray[i]=arguments[i+3];}props.children=childArray;}return{$$typeof:REACT_ELEMENT_TYPE,type:type,key:key===undefined?null:''+key,ref:null,props:props,_owner:null};};}();var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n  cursor: pointer;\n  width: 140px;\n  height: 44px;\n  background-color: rgba(0, 0, 0, 0.3);\n  border: 1px solid rgba(255, 255, 255, 0.12);\n  border-radius: 4px;\n  color: white;\n  font-size: 14px;\n  font-weight: 500;\n  transition: background-color 0.35s ease-in;\n  right: 30px;\n  z-index: 1;\n  &:active {\n    background-color: rgba(30, 144, 255, 0.3);\n  }\n  ','\n'],['\n  cursor: pointer;\n  width: 140px;\n  height: 44px;\n  background-color: rgba(0, 0, 0, 0.3);\n  border: 1px solid rgba(255, 255, 255, 0.12);\n  border-radius: 4px;\n  color: white;\n  font-size: 14px;\n  font-weight: 500;\n  transition: background-color 0.35s ease-in;\n  right: 30px;\n  z-index: 1;\n  &:active {\n    background-color: rgba(30, 144, 255, 0.3);\n  }\n  ','\n']),_templateObject2=_taggedTemplateLiteral(['\n    top: 60px;\n  '],['\n    top: 60px;\n  ']);function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}// override StyledMainButton if needed.
var StyledDarkButton=__WEBPACK_IMPORTED_MODULE_1_styled_components__["b" /* default */].button(_templateObject,__WEBPACK_IMPORTED_MODULE_2__MediaQueries__["a" /* default */].phone(_templateObject2));var DarkButton=function(_Component){_inherits(DarkButton,_Component);function DarkButton(){_classCallCheck(this,DarkButton);return _possibleConstructorReturn(this,(DarkButton.__proto__||Object.getPrototypeOf(DarkButton)).apply(this,arguments));}_createClass(DarkButton,[{key:'render',value:function render(){return _jsx(StyledDarkButton,{onClick:this.props.nextPage,align:this.props.options.align,style:this.props.options.style},void 0,this.props.options.title);}}]);return DarkButton;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (DarkButton);

/***/ }),
/* 163 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Questions__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_polyglot__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_polyglot___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_polyglot__);
var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var QuestionGender=function(_Component){_inherits(QuestionGender,_Component);function QuestionGender(){_classCallCheck(this,QuestionGender);return _possibleConstructorReturn(this,(QuestionGender.__proto__||Object.getPrototypeOf(QuestionGender)).apply(this,arguments));}_createClass(QuestionGender,[{key:'render',value:function render(){var newOptions=Object.assign({},{choices:[{gender_ui:'male'},{gender_ui:'female'}],multiSelect:false},this.props.options);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Questions__["a" /* default */],_extends({},this.props,{options:newOptions}));}}]);return QuestionGender;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_polyglot__["translate"])()(QuestionGender));

/***/ }),
/* 164 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MediaQueries__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_polyglot__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_polyglot___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_polyglot__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__images_instore_icons_good_light_svg__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__images_instore_icons_good_light_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__images_instore_icons_good_light_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__images_instore_icons_pull_back_hair_svg__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__images_instore_icons_pull_back_hair_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__images_instore_icons_pull_back_hair_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__images_instore_icons_no_makeup_svg__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__images_instore_icons_no_makeup_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__images_instore_icons_no_makeup_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__images_instore_icons_neutral_face_svg__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__images_instore_icons_neutral_face_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__images_instore_icons_neutral_face_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__images_instore_icons_glasses_svg__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__images_instore_icons_glasses_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__images_instore_icons_glasses_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__images_instore_icons_face_svg__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__images_instore_icons_face_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__images_instore_icons_face_svg__);
var _jsx=function(){var REACT_ELEMENT_TYPE=typeof Symbol==="function"&&Symbol.for&&Symbol.for("react.element")||0xeac7;return function createRawReactElement(type,props,key,children){var defaultProps=type&&type.defaultProps;var childrenLength=arguments.length-3;if(!props&&childrenLength!==0){props={};}if(props&&defaultProps){for(var propName in defaultProps){if(props[propName]===void 0){props[propName]=defaultProps[propName];}}}else if(!props){props=defaultProps||{};}if(childrenLength===1){props.children=children;}else if(childrenLength>1){var childArray=Array(childrenLength);for(var i=0;i<childrenLength;i++){childArray[i]=arguments[i+3];}props.children=childArray;}return{$$typeof:REACT_ELEMENT_TYPE,type:type,key:key===undefined?null:''+key,ref:null,props:props,_owner:null};};}();var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  align-items: center;\n  font-size: 18px;\n  font-weight: 300;\n  width: 80vw;\n  margin-bottom: 150px;\n  \n  ','\n  \n  h1 {\n    font-size: 18px;\n    font-weight: 300;\n    color: white;\n    margin-bottom: 30px;\n    text-align: center;\n    ','\n  }\n  ul, li {\n    list-style: none;\n    z-index: 1;\n  }\n  ul {\n    width: 55vw;\n    ','\n  }\n  li {\n    color: white;\n    text-align: center;\n    margin-bottom: 2em;\n    width: 100%;\n    padding: 0px 10px;\n    ','\n  }\n  .withIcons{\n    width: 27vw;\n    float: left;\n    ','\n    .icon {\n      display: block;\n      height: 48px;\n      width: 48px;\n      margin: 2px auto;\n      fill: tomato;\n      background-size: contain;\n      background-repeat: no-repeat;\n      margin-bottom: 5px;\n      ','\n    }\n  }\n  .oddAndLastIcon {\n    width: 100%;\n  }\n  \n  .buttonStyle {\n    margin-top: 75px;\n  }\n\n  .icon {\n    display:none;\n  }\n\n  .goodLight {\n    background-image: url(',');\n  }\n  .pullBackHair {\n    background-image: url(',');\n  }\n  .noMakeup {\n    background-image: url(',');\n  }\n  .neutralFace {\n    background-image: url(',');\n  }\n  .glasses {\n    background-image: url(',');\n  }\n  .face {\n    background-image: url(',');\n  }\n'],['\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  align-items: center;\n  font-size: 18px;\n  font-weight: 300;\n  width: 80vw;\n  margin-bottom: 150px;\n  \n  ','\n  \n  h1 {\n    font-size: 18px;\n    font-weight: 300;\n    color: white;\n    margin-bottom: 30px;\n    text-align: center;\n    ','\n  }\n  ul, li {\n    list-style: none;\n    z-index: 1;\n  }\n  ul {\n    width: 55vw;\n    ','\n  }\n  li {\n    color: white;\n    text-align: center;\n    margin-bottom: 2em;\n    width: 100%;\n    padding: 0px 10px;\n    ','\n  }\n  .withIcons{\n    width: 27vw;\n    float: left;\n    ','\n    .icon {\n      display: block;\n      height: 48px;\n      width: 48px;\n      margin: 2px auto;\n      fill: tomato;\n      background-size: contain;\n      background-repeat: no-repeat;\n      margin-bottom: 5px;\n      ','\n    }\n  }\n  .oddAndLastIcon {\n    width: 100%;\n  }\n  \n  .buttonStyle {\n    margin-top: 75px;\n  }\n\n  .icon {\n    display:none;\n  }\n\n  .goodLight {\n    background-image: url(',');\n  }\n  .pullBackHair {\n    background-image: url(',');\n  }\n  .noMakeup {\n    background-image: url(',');\n  }\n  .neutralFace {\n    background-image: url(',');\n  }\n  .glasses {\n    background-image: url(',');\n  }\n  .face {\n    background-image: url(',');\n  }\n']),_templateObject2=_taggedTemplateLiteral(['\n    font-size: 12px;\n  '],['\n    font-size: 12px;\n  ']),_templateObject3=_taggedTemplateLiteral(['\n      font-size: 12px;\n      font-weight: 400;\n      margin-bottom: 10px;\n    '],['\n      font-size: 12px;\n      font-weight: 400;\n      margin-bottom: 10px;\n    ']),_templateObject4=_taggedTemplateLiteral(['\n      width: 90vw;\n    '],['\n      width: 90vw;\n    ']),_templateObject5=_taggedTemplateLiteral([' \n      margin-bottom: 15px;\n    '],[' \n      margin-bottom: 15px;\n    ']),_templateObject6=_taggedTemplateLiteral(['\n      width: 45vw;\n    '],['\n      width: 45vw;\n    ']),_templateObject7=_taggedTemplateLiteral(['\n        height: 32px;\n        width: 32px;\n      '],['\n        height: 32px;\n        width: 32px;\n      ']);function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var StyledDiv=__WEBPACK_IMPORTED_MODULE_1_styled_components__["b" /* default */].div(_templateObject,__WEBPACK_IMPORTED_MODULE_2__MediaQueries__["a" /* default */].phone(_templateObject2),__WEBPACK_IMPORTED_MODULE_2__MediaQueries__["a" /* default */].phone(_templateObject3),__WEBPACK_IMPORTED_MODULE_2__MediaQueries__["a" /* default */].phone(_templateObject4),__WEBPACK_IMPORTED_MODULE_2__MediaQueries__["a" /* default */].phone(_templateObject5),__WEBPACK_IMPORTED_MODULE_2__MediaQueries__["a" /* default */].phone(_templateObject6),__WEBPACK_IMPORTED_MODULE_2__MediaQueries__["a" /* default */].phone(_templateObject7),__WEBPACK_IMPORTED_MODULE_4__images_instore_icons_good_light_svg___default.a,__WEBPACK_IMPORTED_MODULE_5__images_instore_icons_pull_back_hair_svg___default.a,__WEBPACK_IMPORTED_MODULE_6__images_instore_icons_no_makeup_svg___default.a,__WEBPACK_IMPORTED_MODULE_7__images_instore_icons_neutral_face_svg___default.a,__WEBPACK_IMPORTED_MODULE_8__images_instore_icons_glasses_svg___default.a,__WEBPACK_IMPORTED_MODULE_9__images_instore_icons_face_svg___default.a);var TakeSelfie=function(_Component){_inherits(TakeSelfie,_Component);function TakeSelfie(){_classCallCheck(this,TakeSelfie);return _possibleConstructorReturn(this,(TakeSelfie.__proto__||Object.getPrototypeOf(TakeSelfie)).apply(this,arguments));}_createClass(TakeSelfie,[{key:'render',value:function render(){var _props=this.props,t=_props.t,options=_props.options;return _jsx(StyledDiv,{className:'revieve-instore-introduction'},void 0,options&&options.descriptionText&&_jsx('h1',{},void 0,t(options.descriptionText)),_jsx('ul',{},void 0,_jsx('li',{className:options&&options.withIcons?'withIcons':''},void 0,_jsx('div',{className:'icon glasses'},void 0,' \xA0 '),' ',t('remove_glasses'),' '),_jsx('li',{className:options&&options.withIcons?'withIcons':''},void 0,_jsx('div',{className:'icon pullBackHair'},void 0,' \xA0 '),' ',t('pull_back_hair'),' '),_jsx('li',{className:options&&options.withIcons?'withIcons':''},void 0,_jsx('div',{className:'icon noMakeup'},void 0,' \xA0 '),' ',t('Remove your makeup'),' '),_jsx('li',{className:options&&options.withIcons?'withIcons':''},void 0,_jsx('div',{className:'icon goodLight'},void 0,' \xA0 '),' ',t('Ensure a good light'),' '),_jsx('li',{className:options&&options.withIcons?'withIcons':''},void 0,_jsx('div',{className:'icon face'},void 0,' \xA0 '),' ',t('Face directly at camera'),' '),_jsx('li',{className:options&&options.withIcons?'withIcons':''},void 0,_jsx('div',{className:'icon neutralFace'},void 0,' \xA0 '),' ',t('Keep neutral expression'),' ')));}}]);return TakeSelfie;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_polyglot__["translate"])()(TakeSelfie));

/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/good_light.8fc0e9b2.svg";

/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/pull_back_hair.3094b768.svg";

/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/no_makeup.997e676f.svg";

/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/neutral_face.92126eb3.svg";

/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/glasses.8ec63d20.svg";

/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/face.a03f39a9.svg";

/***/ }),
/* 171 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_blueimp_load_image__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_blueimp_load_image___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_blueimp_load_image__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_addons_css_transition_group__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_addons_css_transition_group___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_addons_css_transition_group__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_react_webcam__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Processing__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__MediaQueries__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_polyglot__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_polyglot___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_polyglot__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__shared_urlFunctions__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__images_instore_capture_bg_png__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__images_instore_capture_bg_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__images_instore_capture_bg_png__);
var _jsx=function(){var REACT_ELEMENT_TYPE=typeof Symbol==="function"&&Symbol.for&&Symbol.for("react.element")||0xeac7;return function createRawReactElement(type,props,key,children){var defaultProps=type&&type.defaultProps;var childrenLength=arguments.length-3;if(!props&&childrenLength!==0){props={};}if(props&&defaultProps){for(var propName in defaultProps){if(props[propName]===void 0){props[propName]=defaultProps[propName];}}}else if(!props){props=defaultProps||{};}if(childrenLength===1){props.children=children;}else if(childrenLength>1){var childArray=Array(childrenLength);for(var i=0;i<childrenLength;i++){childArray[i]=arguments[i+3];}props.children=childArray;}return{$$typeof:REACT_ELEMENT_TYPE,type:type,key:key===undefined?null:''+key,ref:null,props:props,_owner:null};};}();var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n  width: 100%;\n  height: 100%;\n  color: white;\n  div.guide,\n  h4.hint,\n  button.cancel {\n    position: absolute;\n    right: 0;\n    left: 0;\n    margin: auto;\n  }\n  div.guide {\n    top: 150px;\n    width: 65%;\n    height: 60%;\n    border: 1px dashed rgba(255, 255, 255, 0.5);\n    border-radius: 30px;\n\n    ','\n  }\n  h4.hint {\n    font-size: 18px;\n    font-weight: 300;\n    bottom: 60px;\n    text-align: center;\n    max-width: 230px;\n    line-height: 1.4;\n    ','\n  }\n\n  div.warning {\n    position: absolute;\n    width: 100%;\n    bottom: 60px;\n    font-size: 18px;\n    text-align: center;\n    line-height: 1.4;\n    font-weight: 300;\n    ul {\n      padding: 0 30px;\n    }\n    ul,\n    li {\n      list-style: none;\n    }\n    ul li {\n      margin-bottom: 10px;\n    }\n    &:before {\n      overflow: hidden;\n      position: absolute;\n      top: 0;\n      left: 0;\n      width: 100%;\n      height: 100%;\n    }\n    .action {\n      button {\n        cursor: pointer;\n        width: auto;\n        height: 60px;\n        background: none;\n        color: white;\n        outline: none;\n        border: none;\n        font-size: 16px;\n        font-weight: 400;\n        text-decoration: underline;\n        margin: 0 20px;\n      }\n    }\n  }\n\n  button.cancel {\n    cursor: pointer;\n    bottom: 10px;\n    background: none;\n    outline: none;\n    color: inherit;\n    border: none;\n    font-size: 16px;\n    text-decoration: underline;\n    font-weight: 500;\n    width: 140px;\n    height: 60px;\n  }\n\n  &:before {\n    z-index: -1;\n    overflow: hidden;\n    position: absolute;\n    top: 0;\n    content: \'\';\n    width: 100%;\n    height: 100%;\n    background: url(',');\n    background-position: center;\n    background-size: cover;\n    background-repeat: no-repeat;\n    transition: background-size 0.25s ease-out, filter 0.25s ease-out;\n  }\n'],['\n  width: 100%;\n  height: 100%;\n  color: white;\n  div.guide,\n  h4.hint,\n  button.cancel {\n    position: absolute;\n    right: 0;\n    left: 0;\n    margin: auto;\n  }\n  div.guide {\n    top: 150px;\n    width: 65%;\n    height: 60%;\n    border: 1px dashed rgba(255, 255, 255, 0.5);\n    border-radius: 30px;\n\n    ','\n  }\n  h4.hint {\n    font-size: 18px;\n    font-weight: 300;\n    bottom: 60px;\n    text-align: center;\n    max-width: 230px;\n    line-height: 1.4;\n    ','\n  }\n\n  div.warning {\n    position: absolute;\n    width: 100%;\n    bottom: 60px;\n    font-size: 18px;\n    text-align: center;\n    line-height: 1.4;\n    font-weight: 300;\n    ul {\n      padding: 0 30px;\n    }\n    ul,\n    li {\n      list-style: none;\n    }\n    ul li {\n      margin-bottom: 10px;\n    }\n    &:before {\n      overflow: hidden;\n      position: absolute;\n      top: 0;\n      left: 0;\n      width: 100%;\n      height: 100%;\n    }\n    .action {\n      button {\n        cursor: pointer;\n        width: auto;\n        height: 60px;\n        background: none;\n        color: white;\n        outline: none;\n        border: none;\n        font-size: 16px;\n        font-weight: 400;\n        text-decoration: underline;\n        margin: 0 20px;\n      }\n    }\n  }\n\n  button.cancel {\n    cursor: pointer;\n    bottom: 10px;\n    background: none;\n    outline: none;\n    color: inherit;\n    border: none;\n    font-size: 16px;\n    text-decoration: underline;\n    font-weight: 500;\n    width: 140px;\n    height: 60px;\n  }\n\n  &:before {\n    z-index: -1;\n    overflow: hidden;\n    position: absolute;\n    top: 0;\n    content: \'\';\n    width: 100%;\n    height: 100%;\n    background: url(',');\n    background-position: center;\n    background-size: cover;\n    background-repeat: no-repeat;\n    transition: background-size 0.25s ease-out, filter 0.25s ease-out;\n  }\n']),_templateObject2=_taggedTemplateLiteral(['\n      border: none;\n      background-image: url(',');\n      background-size: contain;\n      background-position: center center;\n      background-repeat: no-repeat;\n      top: 100px;\n      width: 90%;\n      height: 60%;\n    '],['\n      border: none;\n      background-image: url(',');\n      background-size: contain;\n      background-position: center center;\n      background-repeat: no-repeat;\n      top: 100px;\n      width: 90%;\n      height: 60%;\n    ']),_templateObject3=_taggedTemplateLiteral(['\n      font-size: 11px;\n    '],['\n      font-size: 11px;\n    ']),_templateObject4=_taggedTemplateLiteral(['\n  position: absolute;\n  width: 50px;\n  height: 50px;\n  border: 2px solid white;\n  border-radius: 50%;\n  left: 0;\n  right: 0;\n  margin: 0 auto;\n  top: -60px;\n  box-shadow: rgba(255, 255, 255, 0.4);\n  @keyframes pulse {\n    0% {\n      box-shadow: 0 0 0 0 white;\n    }\n    70% {\n      box-shadow: 0 0 0 80px white;\n    }\n    100% {\n      box-shadow: 0 0 0 0 white;\n    }\n  }\n  @keyframes op {\n    0% {\n      opacity: 0.4;\n    }\n    70% {\n      opacity: 0;\n    }\n    100% {\n      opacity: 0;\n    }\n  }\n  animation: pulse 2s infinite, op 2s infinite;\n'],['\n  position: absolute;\n  width: 50px;\n  height: 50px;\n  border: 2px solid white;\n  border-radius: 50%;\n  left: 0;\n  right: 0;\n  margin: 0 auto;\n  top: -60px;\n  box-shadow: rgba(255, 255, 255, 0.4);\n  @keyframes pulse {\n    0% {\n      box-shadow: 0 0 0 0 white;\n    }\n    70% {\n      box-shadow: 0 0 0 80px white;\n    }\n    100% {\n      box-shadow: 0 0 0 0 white;\n    }\n  }\n  @keyframes op {\n    0% {\n      opacity: 0.4;\n    }\n    70% {\n      opacity: 0;\n    }\n    100% {\n      opacity: 0;\n    }\n  }\n  animation: pulse 2s infinite, op 2s infinite;\n']),_templateObject5=_taggedTemplateLiteral(['\n  font-size: 24px;\n  font-weight: 300;\n  position: absolute;\n  left: 0;\n  right: 0;\n  margin: 0 auto;\n  top: 80px;\n  text-align: center;\n  z-index: 1;\n\n  ','\n'],['\n  font-size: 24px;\n  font-weight: 300;\n  position: absolute;\n  left: 0;\n  right: 0;\n  margin: 0 auto;\n  top: 80px;\n  text-align: center;\n  z-index: 1;\n\n  ','\n']),_templateObject6=_taggedTemplateLiteral(['\n    top: 40px;\n  '],['\n    top: 40px;\n  ']),_templateObject7=_taggedTemplateLiteral(['\n  font-size: 18px;\n  font-weight: 300;\n  position: absolute;\n  left: 0;\n  right: 0;\n  margin: 0 auto;\n  top: 120px;\n  text-align: center;\n  z-index: 1;\n  list-style: none;\n\n  ','\n  max-height: 40px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n'],['\n  font-size: 18px;\n  font-weight: 300;\n  position: absolute;\n  left: 0;\n  right: 0;\n  margin: 0 auto;\n  top: 120px;\n  text-align: center;\n  z-index: 1;\n  list-style: none;\n\n  ','\n  max-height: 40px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n']),_templateObject8=_taggedTemplateLiteral(['\n    top: 80px;\n  '],['\n    top: 80px;\n  ']),_templateObject9=_taggedTemplateLiteral(['\n  margin: 0 2vw;\n'],['\n  margin: 0 2vw;\n']),_templateObject10=_taggedTemplateLiteral(['\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  margin: auto;\n  z-index: -1;\n  display: flex;\n  justify-content: center;\n  video {\n    width: ',';\n    height: 100%;\n    transition: all 1s ease-in;\n    object-fit: cover;\n    z-index: -1;\n  }\n  video.revieve-camera-loading {\n    filter: blur(40px);\n    opacity: 0.01;\n  }\n  video.revieve-camera-ready {\n    filter: blur(0px);\n    opacity: 1;\n  }\n  video.revieve-camera-error {\n    filter: blur(0px);\n    background-color: red;\n    opacity: 1;\n  }\n'],['\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  margin: auto;\n  z-index: -1;\n  display: flex;\n  justify-content: center;\n  video {\n    width: ',';\n    height: 100%;\n    transition: all 1s ease-in;\n    object-fit: cover;\n    z-index: -1;\n  }\n  video.revieve-camera-loading {\n    filter: blur(40px);\n    opacity: 0.01;\n  }\n  video.revieve-camera-ready {\n    filter: blur(0px);\n    opacity: 1;\n  }\n  video.revieve-camera-error {\n    filter: blur(0px);\n    background-color: red;\n    opacity: 1;\n  }\n']),_templateObject11=_taggedTemplateLiteral(['\n  font-size: 12px;\n  width: 60%;\n  background-color: rgba(0, 0, 0, 0.5);\n  padding: 20px;\n  border-radius: 8px;\n  position: absolute;\n  left: 20%;\n  bottom: 120px;\n  ','\n\n  h1 {\n    font-size: 14px;\n    margin-bottom: 8px;\n  }\n\n  li {\n    list-style-type: none;\n  }\n\n  .closeTips {\n    float: right;\n    cursor: pointer;\n    font-weight: bolder;\n  }\n'],['\n  font-size: 12px;\n  width: 60%;\n  background-color: rgba(0, 0, 0, 0.5);\n  padding: 20px;\n  border-radius: 8px;\n  position: absolute;\n  left: 20%;\n  bottom: 120px;\n  ','\n\n  h1 {\n    font-size: 14px;\n    margin-bottom: 8px;\n  }\n\n  li {\n    list-style-type: none;\n  }\n\n  .closeTips {\n    float: right;\n    cursor: pointer;\n    font-weight: bolder;\n  }\n']),_templateObject12=_taggedTemplateLiteral(['\n    width: 80%;\n    left: 10%;\n    bottom: 85px;\n    padding: 10px;\n  '],['\n    width: 80%;\n    left: 10%;\n    bottom: 85px;\n    padding: 10px;\n  ']);function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}//import RevieveActions from '../../store/RevieveActions';
var StyledSelfieWrapper=__WEBPACK_IMPORTED_MODULE_1_styled_components__["b" /* default */].div(_templateObject,__WEBPACK_IMPORTED_MODULE_6__MediaQueries__["a" /* default */].phone(_templateObject2,__WEBPACK_IMPORTED_MODULE_9__images_instore_capture_bg_png___default.a),__WEBPACK_IMPORTED_MODULE_6__MediaQueries__["a" /* default */].phone(_templateObject3),function(props){return props.img;});var StyledPulse=__WEBPACK_IMPORTED_MODULE_1_styled_components__["b" /* default */].div(_templateObject4);var StyledHeading=__WEBPACK_IMPORTED_MODULE_1_styled_components__["b" /* default */].h1(_templateObject5,__WEBPACK_IMPORTED_MODULE_6__MediaQueries__["a" /* default */].phone(_templateObject6));var StyledInstructions=__WEBPACK_IMPORTED_MODULE_1_styled_components__["b" /* default */].div(_templateObject7,__WEBPACK_IMPORTED_MODULE_6__MediaQueries__["a" /* default */].phone(_templateObject8));var StyledInstruction=__WEBPACK_IMPORTED_MODULE_1_styled_components__["b" /* default */].div(_templateObject9);var StyledWebcam=__WEBPACK_IMPORTED_MODULE_1_styled_components__["b" /* default */].div(_templateObject10,function(props){if(props.userAgent&&(props.userAgent.indexOf('MSIE ')>=0||props.userAgent.indexOf('Edge/')>=0)){return'auto';}else{return'100%';}});var StyledTips=__WEBPACK_IMPORTED_MODULE_1_styled_components__["b" /* default */].div(_templateObject11,__WEBPACK_IMPORTED_MODULE_6__MediaQueries__["a" /* default */].phone(_templateObject12));var Selfie=function(_Component){_inherits(Selfie,_Component);function Selfie(props){_classCallCheck(this,Selfie);var _this=_possibleConstructorReturn(this,(Selfie.__proto__||Object.getPrototypeOf(Selfie)).call(this,props));_initialiseProps.call(_this);_this.state=_this.initState(props);return _this;}_createClass(Selfie,[{key:'initState',value:function initState(props){return{cameraOpen:true,image:null,cameraClass:'revieve-camera-loading',cameraError:false,cvResults:null,showTips:props.options&&props.options.showTips};}},{key:'componentDidMount',value:function componentDidMount(){//we need to check it there is some image loaded in the SDK. If yes, we need to trigger the retake callback
var _props=this.props,sdk=_props.sdk,triggerCallback=_props.triggerCallback;if(sdk&&sdk.CV&&sdk.CV.getImage())triggerCallback({callback:'retakeSelfie'});}},{key:'getSkinToneInt',value:function getSkinToneInt(){var skintone=1;var skintones=['light_tone','fair_tone','medium_tone','olive_tone','brown_tone','dark_brown_tone'];if(this.props.filters.requiredTags&&_typeof(this.props.filters.requiredTags)==='object'){var _iteratorNormalCompletion=true;var _didIteratorError=false;var _iteratorError=undefined;try{for(var _iterator=Object.keys(this.props.filters.requiredTags)[Symbol.iterator](),_step;!(_iteratorNormalCompletion=(_step=_iterator.next()).done);_iteratorNormalCompletion=true){var rt=_step.value;var i=skintones.indexOf(rt);if(i>-1){skintone=i+1;}}}catch(err){_didIteratorError=true;_iteratorError=err;}finally{try{if(!_iteratorNormalCompletion&&_iterator.return){_iterator.return();}}finally{if(_didIteratorError){throw _iteratorError;}}}}return skintone;}},{key:'devInput',value:function devInput(){var _this2=this;var isBackground=this.props.isBackground;if(!isBackground&&("production"==='development'||Object(__WEBPACK_IMPORTED_MODULE_8__shared_urlFunctions__["a" /* getParameterByName */])('inputFile'))){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'file',id:'fileinput',ref:function ref(input){_this2.fileInput=input;},style:{position:'absolute',top:30,left:10,zIndex:10},onChange:function onChange(e){e.preventDefault();_this2.handleImageChange(e);}});}}},{key:'render',value:function render(){var _this3=this;var _state=this.state,cameraOpen=_state.cameraOpen,image=_state.image,cameraClass=_state.cameraClass,cameraError=_state.cameraError,cvResults=_state.cvResults,showTips=_state.showTips;var _props2=this.props,isBackground=_props2.isBackground,t=_props2.t,options=_props2.options;if(cameraOpen&&!cvResults){// initial state: Camera is open, no image taken yet.
return _jsx('div',{},void 0,!isBackground&&this.devInput(),_jsx(StyledSelfieWrapper,{onClick:function onClick(e){e.preventDefault();_this3.capture();}},void 0,!isBackground&&_jsx('div',{},void 0,_jsx(StyledPulse,{}),_jsx(StyledHeading,{},void 0,t('look_at_the_camera')),options&&options.instructions&&_jsx(StyledInstructions,{},void 0,options.instructions.map(function(instruction,i){return _jsx(StyledInstruction,{},'instruction'+i,' ',t(instruction),' ');})),_jsx('div',{className:'guide'}),_jsx(__WEBPACK_IMPORTED_MODULE_3_react_addons_css_transition_group___default.a,{transitionName:'footerSlide',transitionAppear:true,transitionEnter:true,transitionLeave:true,transitionAppearTimeout:900,transitionLeaveTimeout:900,transitionEnterTimeout:900},void 0,showTips&&_jsx(StyledTips,{},void 0,_jsx('div',{className:'closeTips',onClick:function onClick(e){e.stopPropagation();_this3.setState({showTips:false});}},void 0,'X'),options&&options.tipsTitle&&_jsx('h1',{},void 0,t(options.tipsTitle)),_jsx('ul',{},void 0,options&&options.tips&&options.tips.map(function(tip,i){return _jsx('li',{},'tip'+i,t(tip));})))),_jsx('h4',{className:'hint'},void 0,t('tap_take_picture')),_jsx('button',{className:'cancel',onClick:function onClick(e){e.preventDefault();_this3.props.prevPage();}},void 0,t('cancel'))),!isBackground&&cameraClass==='revieve-camera-loading'?_jsx(__WEBPACK_IMPORTED_MODULE_5__Processing__["a" /* default */],{label:t('activating_camera')}):null,_jsx(StyledWebcam,{userAgent:window.navigator.userAgent},void 0,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__lib_react_webcam__["a" /* default */],{className:cameraClass,screenshotFormat:'image/jpeg',width:1280,height:1280,ref:function ref(webcam){_this3.webcam=webcam;},audio:false,onUserMedia:function onUserMedia(){setTimeout(function(){_this3.setState({cameraClass:'revieve-camera-ready'});},2500);},onUserMediaError:function onUserMediaError(e){console.log('camera error');setTimeout(function(){_this3.setState({cameraClass:'revieve-camera-error'});},500);setTimeout(function(){_this3.setState({cameraError:e,cameraOpen:false});},1200);}}))));}else if(image&&!cvResults){// User took an image, show it back. Upload and processing progress goes here
return _jsx(StyledSelfieWrapper,{img:image},void 0,_jsx(__WEBPACK_IMPORTED_MODULE_5__Processing__["a" /* default */],{label:t('uploading_selfie')}));}else if(cvResults){// Image was processed. Show possible errors and warnings, ask to retry.
return _jsx(StyledSelfieWrapper,{img:image},void 0,this.devInput(),_jsx(StyledHeading,{},void 0,cvResults.message),_jsx('div',{className:'warning'},void 0,_jsx('ul',{},void 0,cvResults.status&&cvResults.status.map(function(status,si){return _jsx('li',{},si,status.description);})),_jsx('div',{className:'action'},void 0,_jsx('button',{onClick:this.reset},void 0,t('retake_selfie')),cvResults.error?null:_jsx('button',{onClick:this.props.nextPage},void 0,t('continue')))));}else if(cameraError){// camera error.
return _jsx(StyledSelfieWrapper,{onClick:function onClick(e){e.preventDefault();}},void 0,this.devInput(),_jsx(StyledPulse,{}),_jsx(StyledHeading,{},void 0,t('error_opening_camera')),_jsx('h4',{className:'hint'},void 0,cameraError.message?cameraError.message:null),_jsx('button',{className:'cancel',onClick:this.props.prevPage},void 0,t('back')), false?_jsx('button',{className:'',onClick:this.props.nextPage},void 0,'Skip (only for devmode)'):null,_jsx(StyledWebcam,{userAgent:window.navigator.userAgent},void 0,_jsx('video',{className:cameraClass,style:{width:1280,height:1280}})));}}}]);return Selfie;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var _initialiseProps=function _initialiseProps(){var _this4=this;this.reset=function(){var triggerCallback=_this4.props.triggerCallback;triggerCallback({callback:'retakeSelfie'});_this4.setState(_this4.initState(_this4.props));};this.capture=function(){var isBackground=_this4.props.isBackground;if(isBackground){return;}//RevieveActions.removeImageData();
// capture
var im=_this4.webcam.getScreenshot();if(!im){return;}var image_blob=function(){var binary=atob(im.split(',')[1]);var array=[];for(var i=0;i<binary.length;i++){array.push(binary.charCodeAt(i));}return new Blob([new Uint8Array(array)],{type:'image/jpeg'});}();_this4.props.analyzeImage(im,_this4.getSkinToneInt());_this4.setState({image:im,imageBlob:image_blob,cameraOpen:false});};this.handleImageChange=function(e){e.preventDefault();var file=e.target.files[0];__WEBPACK_IMPORTED_MODULE_2_blueimp_load_image___default()(file,function(canvas){var base64data=canvas.toDataURL('image/jpeg');_this4.props.analyzeImage(base64data,_this4.getSkinToneInt());_this4.setState({image:base64data,imageBlob:file,cameraOpen:false,cameraError:null});},{canvas:true,orientation:true});};this.componentWillReceiveProps=function(props){try{if(!_this4.state.cameraOpen&&props.cvResults){_this4.setState({cvResults:props.cvResults});if(!props.cvResults.error){props.nextPage();}}}catch(e){console.log(e);}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_7_react_polyglot__["translate"])()(Selfie));

/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

/* global module, require */

module.exports = __webpack_require__(7)

__webpack_require__(47)
__webpack_require__(12)
__webpack_require__(173)
__webpack_require__(48)
__webpack_require__(174)
__webpack_require__(49)
__webpack_require__(175)
__webpack_require__(176)


/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*
 * JavaScript Load Image Fetch
 * https://github.com/blueimp/JavaScript-Load-Image
 *
 * Copyright 2017, Sebastian Tschan
 * https://blueimp.net
 *
 * Licensed under the MIT license:
 * https://opensource.org/licenses/MIT
 */

/* global define, module, require */

;(function(factory) {
  'use strict'
  if (true) {
    // Register as an anonymous AMD module:
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(7), __webpack_require__(12)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
  } else if (typeof module === 'object' && module.exports) {
    factory(require('./load-image'), require('./load-image-meta'))
  } else {
    // Browser globals:
    factory(window.loadImage)
  }
})(function(loadImage) {
  'use strict'

  if (typeof fetch !== 'undefined' && typeof Request !== 'undefined') {
    loadImage.fetchBlob = function(url, callback, options) {
      if (loadImage.hasMetaOption(options)) {
        return fetch(new Request(url, options))
          .then(function(response) {
            return response.blob()
          })
          .then(callback)
          .catch(function(err) {
            console.log(err) // eslint-disable-line no-console
            callback()
          })
      }
      callback()
    }
  }
})


/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*
 * JavaScript Load Image Exif Map
 * https://github.com/blueimp/JavaScript-Load-Image
 *
 * Copyright 2013, Sebastian Tschan
 * https://blueimp.net
 *
 * Exif tags mapping based on
 * https://github.com/jseidelin/exif-js
 *
 * Licensed under the MIT license:
 * https://opensource.org/licenses/MIT
 */

/* global define, module, require */

;(function(factory) {
  'use strict'
  if (true) {
    // Register as an anonymous AMD module:
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(7), __webpack_require__(48)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
  } else if (typeof module === 'object' && module.exports) {
    factory(require('./load-image'), require('./load-image-exif'))
  } else {
    // Browser globals:
    factory(window.loadImage)
  }
})(function(loadImage) {
  'use strict'

  loadImage.ExifMap.prototype.tags = {
    // =================
    // TIFF tags (IFD0):
    // =================
    0x0100: 'ImageWidth',
    0x0101: 'ImageHeight',
    0x8769: 'ExifIFDPointer',
    0x8825: 'GPSInfoIFDPointer',
    0xa005: 'InteroperabilityIFDPointer',
    0x0102: 'BitsPerSample',
    0x0103: 'Compression',
    0x0106: 'PhotometricInterpretation',
    0x0112: 'Orientation',
    0x0115: 'SamplesPerPixel',
    0x011c: 'PlanarConfiguration',
    0x0212: 'YCbCrSubSampling',
    0x0213: 'YCbCrPositioning',
    0x011a: 'XResolution',
    0x011b: 'YResolution',
    0x0128: 'ResolutionUnit',
    0x0111: 'StripOffsets',
    0x0116: 'RowsPerStrip',
    0x0117: 'StripByteCounts',
    0x0201: 'JPEGInterchangeFormat',
    0x0202: 'JPEGInterchangeFormatLength',
    0x012d: 'TransferFunction',
    0x013e: 'WhitePoint',
    0x013f: 'PrimaryChromaticities',
    0x0211: 'YCbCrCoefficients',
    0x0214: 'ReferenceBlackWhite',
    0x0132: 'DateTime',
    0x010e: 'ImageDescription',
    0x010f: 'Make',
    0x0110: 'Model',
    0x0131: 'Software',
    0x013b: 'Artist',
    0x8298: 'Copyright',
    // ==================
    // Exif Sub IFD tags:
    // ==================
    0x9000: 'ExifVersion', // EXIF version
    0xa000: 'FlashpixVersion', // Flashpix format version
    0xa001: 'ColorSpace', // Color space information tag
    0xa002: 'PixelXDimension', // Valid width of meaningful image
    0xa003: 'PixelYDimension', // Valid height of meaningful image
    0xa500: 'Gamma',
    0x9101: 'ComponentsConfiguration', // Information about channels
    0x9102: 'CompressedBitsPerPixel', // Compressed bits per pixel
    0x927c: 'MakerNote', // Any desired information written by the manufacturer
    0x9286: 'UserComment', // Comments by user
    0xa004: 'RelatedSoundFile', // Name of related sound file
    0x9003: 'DateTimeOriginal', // Date and time when the original image was generated
    0x9004: 'DateTimeDigitized', // Date and time when the image was stored digitally
    0x9290: 'SubSecTime', // Fractions of seconds for DateTime
    0x9291: 'SubSecTimeOriginal', // Fractions of seconds for DateTimeOriginal
    0x9292: 'SubSecTimeDigitized', // Fractions of seconds for DateTimeDigitized
    0x829a: 'ExposureTime', // Exposure time (in seconds)
    0x829d: 'FNumber',
    0x8822: 'ExposureProgram', // Exposure program
    0x8824: 'SpectralSensitivity', // Spectral sensitivity
    0x8827: 'PhotographicSensitivity', // EXIF 2.3, ISOSpeedRatings in EXIF 2.2
    0x8828: 'OECF', // Optoelectric conversion factor
    0x8830: 'SensitivityType',
    0x8831: 'StandardOutputSensitivity',
    0x8832: 'RecommendedExposureIndex',
    0x8833: 'ISOSpeed',
    0x8834: 'ISOSpeedLatitudeyyy',
    0x8835: 'ISOSpeedLatitudezzz',
    0x9201: 'ShutterSpeedValue', // Shutter speed
    0x9202: 'ApertureValue', // Lens aperture
    0x9203: 'BrightnessValue', // Value of brightness
    0x9204: 'ExposureBias', // Exposure bias
    0x9205: 'MaxApertureValue', // Smallest F number of lens
    0x9206: 'SubjectDistance', // Distance to subject in meters
    0x9207: 'MeteringMode', // Metering mode
    0x9208: 'LightSource', // Kind of light source
    0x9209: 'Flash', // Flash status
    0x9214: 'SubjectArea', // Location and area of main subject
    0x920a: 'FocalLength', // Focal length of the lens in mm
    0xa20b: 'FlashEnergy', // Strobe energy in BCPS
    0xa20c: 'SpatialFrequencyResponse',
    0xa20e: 'FocalPlaneXResolution', // Number of pixels in width direction per FPRUnit
    0xa20f: 'FocalPlaneYResolution', // Number of pixels in height direction per FPRUnit
    0xa210: 'FocalPlaneResolutionUnit', // Unit for measuring the focal plane resolution
    0xa214: 'SubjectLocation', // Location of subject in image
    0xa215: 'ExposureIndex', // Exposure index selected on camera
    0xa217: 'SensingMethod', // Image sensor type
    0xa300: 'FileSource', // Image source (3 == DSC)
    0xa301: 'SceneType', // Scene type (1 == directly photographed)
    0xa302: 'CFAPattern', // Color filter array geometric pattern
    0xa401: 'CustomRendered', // Special processing
    0xa402: 'ExposureMode', // Exposure mode
    0xa403: 'WhiteBalance', // 1 = auto white balance, 2 = manual
    0xa404: 'DigitalZoomRatio', // Digital zoom ratio
    0xa405: 'FocalLengthIn35mmFilm',
    0xa406: 'SceneCaptureType', // Type of scene
    0xa407: 'GainControl', // Degree of overall image gain adjustment
    0xa408: 'Contrast', // Direction of contrast processing applied by camera
    0xa409: 'Saturation', // Direction of saturation processing applied by camera
    0xa40a: 'Sharpness', // Direction of sharpness processing applied by camera
    0xa40b: 'DeviceSettingDescription',
    0xa40c: 'SubjectDistanceRange', // Distance to subject
    0xa420: 'ImageUniqueID', // Identifier assigned uniquely to each image
    0xa430: 'CameraOwnerName',
    0xa431: 'BodySerialNumber',
    0xa432: 'LensSpecification',
    0xa433: 'LensMake',
    0xa434: 'LensModel',
    0xa435: 'LensSerialNumber',
    // ==============
    // GPS Info tags:
    // ==============
    0x0000: 'GPSVersionID',
    0x0001: 'GPSLatitudeRef',
    0x0002: 'GPSLatitude',
    0x0003: 'GPSLongitudeRef',
    0x0004: 'GPSLongitude',
    0x0005: 'GPSAltitudeRef',
    0x0006: 'GPSAltitude',
    0x0007: 'GPSTimeStamp',
    0x0008: 'GPSSatellites',
    0x0009: 'GPSStatus',
    0x000a: 'GPSMeasureMode',
    0x000b: 'GPSDOP',
    0x000c: 'GPSSpeedRef',
    0x000d: 'GPSSpeed',
    0x000e: 'GPSTrackRef',
    0x000f: 'GPSTrack',
    0x0010: 'GPSImgDirectionRef',
    0x0011: 'GPSImgDirection',
    0x0012: 'GPSMapDatum',
    0x0013: 'GPSDestLatitudeRef',
    0x0014: 'GPSDestLatitude',
    0x0015: 'GPSDestLongitudeRef',
    0x0016: 'GPSDestLongitude',
    0x0017: 'GPSDestBearingRef',
    0x0018: 'GPSDestBearing',
    0x0019: 'GPSDestDistanceRef',
    0x001a: 'GPSDestDistance',
    0x001b: 'GPSProcessingMethod',
    0x001c: 'GPSAreaInformation',
    0x001d: 'GPSDateStamp',
    0x001e: 'GPSDifferential',
    0x001f: 'GPSHPositioningError'
  }

  loadImage.ExifMap.prototype.stringValues = {
    ExposureProgram: {
      0: 'Undefined',
      1: 'Manual',
      2: 'Normal program',
      3: 'Aperture priority',
      4: 'Shutter priority',
      5: 'Creative program',
      6: 'Action program',
      7: 'Portrait mode',
      8: 'Landscape mode'
    },
    MeteringMode: {
      0: 'Unknown',
      1: 'Average',
      2: 'CenterWeightedAverage',
      3: 'Spot',
      4: 'MultiSpot',
      5: 'Pattern',
      6: 'Partial',
      255: 'Other'
    },
    LightSource: {
      0: 'Unknown',
      1: 'Daylight',
      2: 'Fluorescent',
      3: 'Tungsten (incandescent light)',
      4: 'Flash',
      9: 'Fine weather',
      10: 'Cloudy weather',
      11: 'Shade',
      12: 'Daylight fluorescent (D 5700 - 7100K)',
      13: 'Day white fluorescent (N 4600 - 5400K)',
      14: 'Cool white fluorescent (W 3900 - 4500K)',
      15: 'White fluorescent (WW 3200 - 3700K)',
      17: 'Standard light A',
      18: 'Standard light B',
      19: 'Standard light C',
      20: 'D55',
      21: 'D65',
      22: 'D75',
      23: 'D50',
      24: 'ISO studio tungsten',
      255: 'Other'
    },
    Flash: {
      0x0000: 'Flash did not fire',
      0x0001: 'Flash fired',
      0x0005: 'Strobe return light not detected',
      0x0007: 'Strobe return light detected',
      0x0009: 'Flash fired, compulsory flash mode',
      0x000d: 'Flash fired, compulsory flash mode, return light not detected',
      0x000f: 'Flash fired, compulsory flash mode, return light detected',
      0x0010: 'Flash did not fire, compulsory flash mode',
      0x0018: 'Flash did not fire, auto mode',
      0x0019: 'Flash fired, auto mode',
      0x001d: 'Flash fired, auto mode, return light not detected',
      0x001f: 'Flash fired, auto mode, return light detected',
      0x0020: 'No flash function',
      0x0041: 'Flash fired, red-eye reduction mode',
      0x0045: 'Flash fired, red-eye reduction mode, return light not detected',
      0x0047: 'Flash fired, red-eye reduction mode, return light detected',
      0x0049: 'Flash fired, compulsory flash mode, red-eye reduction mode',
      0x004d: 'Flash fired, compulsory flash mode, red-eye reduction mode, return light not detected',
      0x004f: 'Flash fired, compulsory flash mode, red-eye reduction mode, return light detected',
      0x0059: 'Flash fired, auto mode, red-eye reduction mode',
      0x005d: 'Flash fired, auto mode, return light not detected, red-eye reduction mode',
      0x005f: 'Flash fired, auto mode, return light detected, red-eye reduction mode'
    },
    SensingMethod: {
      1: 'Undefined',
      2: 'One-chip color area sensor',
      3: 'Two-chip color area sensor',
      4: 'Three-chip color area sensor',
      5: 'Color sequential area sensor',
      7: 'Trilinear sensor',
      8: 'Color sequential linear sensor'
    },
    SceneCaptureType: {
      0: 'Standard',
      1: 'Landscape',
      2: 'Portrait',
      3: 'Night scene'
    },
    SceneType: {
      1: 'Directly photographed'
    },
    CustomRendered: {
      0: 'Normal process',
      1: 'Custom process'
    },
    WhiteBalance: {
      0: 'Auto white balance',
      1: 'Manual white balance'
    },
    GainControl: {
      0: 'None',
      1: 'Low gain up',
      2: 'High gain up',
      3: 'Low gain down',
      4: 'High gain down'
    },
    Contrast: {
      0: 'Normal',
      1: 'Soft',
      2: 'Hard'
    },
    Saturation: {
      0: 'Normal',
      1: 'Low saturation',
      2: 'High saturation'
    },
    Sharpness: {
      0: 'Normal',
      1: 'Soft',
      2: 'Hard'
    },
    SubjectDistanceRange: {
      0: 'Unknown',
      1: 'Macro',
      2: 'Close view',
      3: 'Distant view'
    },
    FileSource: {
      3: 'DSC'
    },
    ComponentsConfiguration: {
      0: '',
      1: 'Y',
      2: 'Cb',
      3: 'Cr',
      4: 'R',
      5: 'G',
      6: 'B'
    },
    Orientation: {
      1: 'top-left',
      2: 'top-right',
      3: 'bottom-right',
      4: 'bottom-left',
      5: 'left-top',
      6: 'right-top',
      7: 'right-bottom',
      8: 'left-bottom'
    }
  }

  loadImage.ExifMap.prototype.getText = function(id) {
    var value = this.get(id)
    switch (id) {
      case 'LightSource':
      case 'Flash':
      case 'MeteringMode':
      case 'ExposureProgram':
      case 'SensingMethod':
      case 'SceneCaptureType':
      case 'SceneType':
      case 'CustomRendered':
      case 'WhiteBalance':
      case 'GainControl':
      case 'Contrast':
      case 'Saturation':
      case 'Sharpness':
      case 'SubjectDistanceRange':
      case 'FileSource':
      case 'Orientation':
        return this.stringValues[id][value]
      case 'ExifVersion':
      case 'FlashpixVersion':
        if (!value) return
        return String.fromCharCode(value[0], value[1], value[2], value[3])
      case 'ComponentsConfiguration':
        if (!value) return
        return (
          this.stringValues[id][value[0]] +
          this.stringValues[id][value[1]] +
          this.stringValues[id][value[2]] +
          this.stringValues[id][value[3]]
        )
      case 'GPSVersionID':
        if (!value) return
        return value[0] + '.' + value[1] + '.' + value[2] + '.' + value[3]
    }
    return String(value)
  }
  ;(function(exifMapPrototype) {
    var tags = exifMapPrototype.tags
    var map = exifMapPrototype.map
    var prop
    // Map the tag names to tags:
    for (prop in tags) {
      if (Object.prototype.hasOwnProperty.call(tags, prop)) {
        map[tags[prop]] = prop
      }
    }
  })(loadImage.ExifMap.prototype)

  loadImage.ExifMap.prototype.getAll = function() {
    var map = {}
    var prop
    var id
    for (prop in this) {
      if (Object.prototype.hasOwnProperty.call(this, prop)) {
        id = this.tags[prop]
        if (id) {
          map[id] = this.getText(id)
        }
      }
    }
    return map
  }
})


/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*
 * JavaScript Load Image IPTC Map
 * https://github.com/blueimp/JavaScript-Load-Image
 *
 * Copyright 2013, Sebastian Tschan
 * Copyright 2018, Dave Bevan
 *
 * IPTC tags mapping based on
 * https://github.com/jseidelin/exif-js
 * https://iptc.org/standards/photo-metadata
 * http://www.iptc.org/std/IIM/4.1/specification/IIMV4.1.pdf
 *
 * Licensed under the MIT license:
 * https://opensource.org/licenses/MIT
 */

/* global define, module, require */

;(function(factory) {
  'use strict'
  if (true) {
    // Register as an anonymous AMD module:
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(7), __webpack_require__(49)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
  } else if (typeof module === 'object' && module.exports) {
    factory(require('./load-image'), require('./load-image-iptc'))
  } else {
    // Browser globals:
    factory(window.loadImage)
  }
})(function(loadImage) {
  'use strict'

  loadImage.IptcMap.prototype.tags = {
    // ==========
    // IPTC tags:
    // ==========
    0x03: 'ObjectType',
    0x04: 'ObjectAttribute',
    0x05: 'ObjectName',
    0x07: 'EditStatus',
    0x08: 'EditorialUpdate',
    0x0a: 'Urgency',
    0x0c: 'SubjectRef',
    0x0f: 'Category',
    0x14: 'SupplCategory',
    0x16: 'FixtureID',
    0x19: 'Keywords',
    0x1a: 'ContentLocCode',
    0x1b: 'ContentLocName',
    0x1e: 'ReleaseDate',
    0x23: 'ReleaseTime',
    0x25: 'ExpirationDate',
    0x26: 'ExpirationTime',
    0x28: 'SpecialInstructions',
    0x2a: 'ActionAdvised',
    0x2d: 'RefService',
    0x2f: 'RefDate',
    0x32: 'RefNumber',
    0x37: 'DateCreated',
    0x3c: 'TimeCreated',
    0x3e: 'DigitalCreationDate',
    0x3f: 'DigitalCreationTime',
    0x41: 'OriginatingProgram',
    0x46: 'ProgramVersion',
    0x4b: 'ObjectCycle',
    0x50: 'Byline',
    0x55: 'BylineTitle',
    0x5a: 'City',
    0x5c: 'Sublocation',
    0x5f: 'State',
    0x64: 'CountryCode',
    0x65: 'CountryName',
    0x67: 'OrigTransRef',
    0x69: 'Headline',
    0x6e: 'Credit',
    0x73: 'Source',
    0x74: 'CopyrightNotice',
    0x76: 'Contact',
    0x78: 'Caption',
    0x7a: 'WriterEditor',
    0x82: 'ImageType',
    0x83: 'ImageOrientation',
    0x87: 'LanguageID'

    // We don't record these tags:
    //
    // 0x00: 'RecordVersion',
    // 0x7d: 'RasterizedCaption',
    // 0x96: 'AudioType',
    // 0x97: 'AudioSamplingRate',
    // 0x98: 'AudioSamplingRes',
    // 0x99: 'AudioDuration',
    // 0x9a: 'AudioOutcue',
    // 0xc8: 'PreviewFileFormat',
    // 0xc9: 'PreviewFileFormatVer',
    // 0xca: 'PreviewData'
  }

  loadImage.IptcMap.prototype.getText = function(id) {
    var value = this.get(id)
    return String(value)
  }
  ;(function(iptcMapPrototype) {
    var tags = iptcMapPrototype.tags
    var map = iptcMapPrototype.map || {}
    var prop
    // Map the tag names to tags:
    for (prop in tags) {
      if (Object.prototype.hasOwnProperty.call(tags, prop)) {
        map[tags[prop]] = prop
      }
    }
  })(loadImage.IptcMap.prototype)

  loadImage.IptcMap.prototype.getAll = function() {
    var map = {}
    var prop
    var id
    for (prop in this) {
      if (Object.prototype.hasOwnProperty.call(this, prop)) {
        id = this.tags[prop]
        if (id) {
          map[id] = this.getText(id)
        }
      }
    }
    return map
  }
})


/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*
 * JavaScript Load Image Orientation
 * https://github.com/blueimp/JavaScript-Load-Image
 *
 * Copyright 2013, Sebastian Tschan
 * https://blueimp.net
 *
 * Licensed under the MIT license:
 * https://opensource.org/licenses/MIT
 */

/* global define, module, require */

;(function(factory) {
  'use strict'
  if (true) {
    // Register as an anonymous AMD module:
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(7), __webpack_require__(47), __webpack_require__(12)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
  } else if (typeof module === 'object' && module.exports) {
    factory(
      require('./load-image'),
      require('./load-image-scale'),
      require('./load-image-meta')
    )
  } else {
    // Browser globals:
    factory(window.loadImage)
  }
})(function(loadImage) {
  'use strict'

  var originalHasCanvasOption = loadImage.hasCanvasOption
  var originalHasMetaOption = loadImage.hasMetaOption
  var originalTransformCoordinates = loadImage.transformCoordinates
  var originalGetTransformedOptions = loadImage.getTransformedOptions

  // Determines if the target image should be a canvas element:
  loadImage.hasCanvasOption = function(options) {
    return (
      !!options.orientation || originalHasCanvasOption.call(loadImage, options)
    )
  }

  // Determines if meta data should be loaded automatically:
  loadImage.hasMetaOption = function(options) {
    return (
      (options && options.orientation === true) ||
      originalHasMetaOption.call(loadImage, options)
    )
  }

  // Transform image orientation based on
  // the given EXIF orientation option:
  loadImage.transformCoordinates = function(canvas, options) {
    originalTransformCoordinates.call(loadImage, canvas, options)
    var ctx = canvas.getContext('2d')
    var width = canvas.width
    var height = canvas.height
    var styleWidth = canvas.style.width
    var styleHeight = canvas.style.height
    var orientation = options.orientation
    if (!orientation || orientation > 8) {
      return
    }
    if (orientation > 4) {
      canvas.width = height
      canvas.height = width
      canvas.style.width = styleHeight
      canvas.style.height = styleWidth
    }
    switch (orientation) {
      case 2:
        // horizontal flip
        ctx.translate(width, 0)
        ctx.scale(-1, 1)
        break
      case 3:
        // 180° rotate left
        ctx.translate(width, height)
        ctx.rotate(Math.PI)
        break
      case 4:
        // vertical flip
        ctx.translate(0, height)
        ctx.scale(1, -1)
        break
      case 5:
        // vertical flip + 90 rotate right
        ctx.rotate(0.5 * Math.PI)
        ctx.scale(1, -1)
        break
      case 6:
        // 90° rotate right
        ctx.rotate(0.5 * Math.PI)
        ctx.translate(0, -height)
        break
      case 7:
        // horizontal flip + 90 rotate right
        ctx.rotate(0.5 * Math.PI)
        ctx.translate(width, -height)
        ctx.scale(-1, 1)
        break
      case 8:
        // 90° rotate left
        ctx.rotate(-0.5 * Math.PI)
        ctx.translate(-width, 0)
        break
    }
  }

  // Transforms coordinate and dimension options
  // based on the given orientation option:
  loadImage.getTransformedOptions = function(img, opts, data) {
    var options = originalGetTransformedOptions.call(loadImage, img, opts)
    var orientation = options.orientation
    var newOptions
    var i
    if (orientation === true && data && data.exif) {
      orientation = data.exif.get('Orientation')
    }
    if (!orientation || orientation > 8 || orientation === 1) {
      return options
    }
    newOptions = {}
    for (i in options) {
      if (Object.prototype.hasOwnProperty.call(options, i)) {
        newOptions[i] = options[i]
      }
    }
    newOptions.orientation = orientation
    switch (orientation) {
      case 2:
        // horizontal flip
        newOptions.left = options.right
        newOptions.right = options.left
        break
      case 3:
        // 180° rotate left
        newOptions.left = options.right
        newOptions.top = options.bottom
        newOptions.right = options.left
        newOptions.bottom = options.top
        break
      case 4:
        // vertical flip
        newOptions.top = options.bottom
        newOptions.bottom = options.top
        break
      case 5:
        // vertical flip + 90 rotate right
        newOptions.left = options.top
        newOptions.top = options.left
        newOptions.right = options.bottom
        newOptions.bottom = options.right
        break
      case 6:
        // 90° rotate right
        newOptions.left = options.top
        newOptions.top = options.right
        newOptions.right = options.bottom
        newOptions.bottom = options.left
        break
      case 7:
        // horizontal flip + 90 rotate right
        newOptions.left = options.bottom
        newOptions.top = options.right
        newOptions.right = options.top
        newOptions.bottom = options.left
        break
      case 8:
        // 90° rotate left
        newOptions.left = options.bottom
        newOptions.top = options.left
        newOptions.right = options.top
        newOptions.bottom = options.right
        break
    }
    if (newOptions.orientation > 4) {
      newOptions.maxWidth = options.maxHeight
      newOptions.maxHeight = options.maxWidth
      newOptions.minWidth = options.minHeight
      newOptions.minHeight = options.minWidth
      newOptions.sourceWidth = options.sourceHeight
      newOptions.sourceHeight = options.sourceWidth
    }
    return newOptions
  }
})


/***/ }),
/* 177 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function hasGetUserMedia(){return!!(navigator.mediaDevices.getUserMedia||navigator.webkitGetUserMedia||navigator.mozGetUserMedia||navigator.msGetUserMedia);}var Webcam=function(_Component){_inherits(Webcam,_Component);function Webcam(){_classCallCheck(this,Webcam);var _this=_possibleConstructorReturn(this,(Webcam.__proto__||Object.getPrototypeOf(Webcam)).call(this));_this.state={hasUserMedia:false};return _this;}_createClass(Webcam,[{key:'componentDidMount',value:function componentDidMount(){if(!hasGetUserMedia())return;Webcam.mountedInstances.push(this);if(!this.state.hasUserMedia&&!Webcam.userMediaRequested){this.requestUserMedia();}}},{key:'componentWillUpdate',value:function componentWillUpdate(nextProps){if(nextProps.videoSource!==this.props.videoSource||nextProps.audioSource!==this.props.audioSource){this.requestUserMedia();}}},{key:'componentWillUnmount',value:function componentWillUnmount(){var index=Webcam.mountedInstances.indexOf(this);Webcam.mountedInstances.splice(index,1);if(Webcam.mountedInstances.length===0&&this.state.hasUserMedia){if(this.stream.stop){this.stream.stop();}else{if(this.stream.getVideoTracks){this.stream.getVideoTracks().map(function(track){return track.stop();});}if(this.stream.getAudioTracks){this.stream.getAudioTracks().map(function(track){return track.stop();});}}Webcam.userMediaRequested=false;window.URL.revokeObjectURL(this.state.src);}}},{key:'getScreenshot',value:function getScreenshot(){if(!this.state.hasUserMedia)return null;var canvas=this.getCanvas();return canvas&&canvas.toDataURL(this.props.screenshotFormat);}},{key:'getCanvas',value:function getCanvas(){if(!this.state.hasUserMedia||!this.video.videoHeight)return null;if(!this.ctx){var _canvas=document.createElement('canvas');var aspectRatio=this.video.videoWidth/this.video.videoHeight;_canvas.width=this.props.width;_canvas.height=this.props.width/aspectRatio;this.canvas=_canvas;this.ctx=_canvas.getContext('2d');}var ctx=this.ctx,canvas=this.canvas;ctx.translate(this.props.width,0);ctx.scale(-1,1);ctx.drawImage(this.video,0,0,canvas.width,canvas.height);return canvas;}},{key:'requestUserMedia',value:function requestUserMedia(){var _this2=this;var sourceSelected=function sourceSelected(audioSource,videoSource){var constraints={};var isIEorEdge=/MSIE 10/i.test(navigator.userAgent)||/MSIE 9/i.test(navigator.userAgent)||/rv:11.0/i.test(navigator.userAgent)||/Edge\/\d./i.test(navigator.userAgent);if(isIEorEdge){constraints={video:{sourceId:videoSource,width:{ideal:1920,min:720,max:2160},height:{ideal:1080,min:720,max:2160}}};}else{constraints={video:{sourceId:videoSource}};}if(_this2.props.audio){constraints.audio={optional:[{sourceId:audioSource}]};}navigator.mediaDevices.getUserMedia(constraints).then(function(stream){Webcam.mountedInstances.forEach(function(instance){return instance.handleUserMedia(null,stream);});}).catch(function(e){Webcam.mountedInstances.forEach(function(instance){return instance.handleUserMedia(e);});});};if(this.props.audioSource&&this.props.videoSource){sourceSelected(this.props.audioSource,this.props.videoSource);}else if('mediaDevices'in navigator){navigator.mediaDevices.enumerateDevices().then(function(devices){var audioSource=null;var videoSource=null;devices.forEach(function(device){if(device.kind==='audioinput'){audioSource=device.id;}else if(device.kind==='videoinput'){videoSource=device.id;}});if(_this2.props.audioSource){audioSource=_this2.props.audioSource;}if(_this2.props.videoSource){videoSource=_this2.props.videoSource;}sourceSelected(audioSource,videoSource);}).catch(function(error){console.log(error.name+': '+error.message);// eslint-disable-line no-console
});}else{MediaStreamTrack.getSources(function(sources){var audioSource=null;var videoSource=null;sources.forEach(function(source){if(source.kind==='audio'){audioSource=source.id;}else if(source.kind==='video'){videoSource=source.id;}});if(_this2.props.audioSource){audioSource=_this2.props.audioSource;}if(_this2.props.videoSource){videoSource=_this2.props.videoSource;}sourceSelected(audioSource,videoSource);});}Webcam.userMediaRequested=true;}},{key:'handleUserMedia',value:function handleUserMedia(error,stream){if(error){this.setState({hasUserMedia:false});this.props.onUserMediaError(error);return;}try{var src=window.URL.createObjectURL(stream);this.stream=stream;this.setState({hasUserMedia:true,src:src});}catch(err){this.stream=stream;this.video.srcObject=stream;this.setState({hasUserMedia:true});}this.props.onUserMedia();}},{key:'render',value:function render(){var _this3=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('video',{autoPlay:true,width:this.props.width,height:this.props.height,src:this.state.src,muted:this.props.audio,className:this.props.className,playsInline:true,style:Object.assign({transform:'scaleX(-1)'},this.props.style),ref:function ref(_ref){_this3.video=_ref;}});}}]);return Webcam;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);Webcam.defaultProps={audio:true,className:'',onUserMedia:function onUserMedia(){},onUserMediaError:function onUserMediaError(){},screenshotFormat:'image/webp',height:1280,width:1280};Webcam.propTypes={audio:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,onUserMedia:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,onUserMediaError:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,height:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),width:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),screenshotFormat:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['image/webp','image/png','image/jpeg']),style:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,className:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,audioSource:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,videoSource:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string};Webcam.mountedInstances=[];Webcam.userMediaRequested=false;/* harmony default export */ __webpack_exports__["a"] = (Webcam);

/***/ }),
/* 178 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getParameterByName;
function getParameterByName(name,url){if(!url)url=window.location.href;name=name.replace(/[\[\]]/g,'\\$&');var regex=new RegExp('[?&]'+name+'(=([^&#]*)|&|#|$)'),results=regex.exec(url);if(!results)return null;if(!results[2])return'';return decodeURIComponent(results[2].replace(/\+/g,' '));}

/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/capture-bg.ef1e6649.png";

/***/ }),
/* 180 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SdkRenderContainer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SdkRenderContainerForAnalysis; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
var _jsx=function(){var REACT_ELEMENT_TYPE=typeof Symbol==="function"&&Symbol.for&&Symbol.for("react.element")||0xeac7;return function createRawReactElement(type,props,key,children){var defaultProps=type&&type.defaultProps;var childrenLength=arguments.length-3;if(!props&&childrenLength!==0){props={};}if(props&&defaultProps){for(var propName in defaultProps){if(props[propName]===void 0){props[propName]=defaultProps[propName];}}}else if(!props){props=defaultProps||{};}if(childrenLength===1){props.children=children;}else if(childrenLength>1){var childArray=Array(childrenLength);for(var i=0;i<childrenLength;i++){childArray[i]=arguments[i+3];}props.children=childArray;}return{$$typeof:REACT_ELEMENT_TYPE,type:type,key:key===undefined?null:''+key,ref:null,props:props,_owner:null};};}();var _templateObject=_taggedTemplateLiteral(['\n  width: 100%;\n  height: 100%;\n  color: white;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  overflow: hidden;\n  &:before {\n    z-index: 1;\n    pointer-events: none;\n    overflow: hidden;\n    position: absolute;\n    top: 0; left: 0;\n    content: \'\';\n    width: 100%; height: 100%;\n    background: linear-gradient(to bottom, rgba(0,0,0,.25) 0%, rgba(0,0,0,0) 40%);\n  }\n'],['\n  width: 100%;\n  height: 100%;\n  color: white;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  overflow: hidden;\n  &:before {\n    z-index: 1;\n    pointer-events: none;\n    overflow: hidden;\n    position: absolute;\n    top: 0; left: 0;\n    content: \'\';\n    width: 100%; height: 100%;\n    background: linear-gradient(to bottom, rgba(0,0,0,.25) 0%, rgba(0,0,0,0) 40%);\n  }\n']);function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var StyledSdkContainerWrapper=__WEBPACK_IMPORTED_MODULE_1_styled_components__["b" /* default */].div(_templateObject);var containerId='sdkEffectContainerWrapper';var SdkRenderContainer=function(_Component){_inherits(SdkRenderContainer,_Component);function SdkRenderContainer(){var _ref;var _temp,_this,_ret;_classCallCheck(this,SdkRenderContainer);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=SdkRenderContainer.__proto__||Object.getPrototypeOf(SdkRenderContainer)).call.apply(_ref,[this].concat(args))),_this),_this.componentDidMount=function(){var ARMethods=_this.props.ARMethods;ARMethods.renderInitialImage(containerId);},_this.onClickHandler=function(){var focusOnSkinFinding=_this.props.focusOnSkinFinding;focusOnSkinFinding('reset');},_this.render=function(){var _this$props=_this.props,ARAnimation=_this$props.ARAnimation,onClickEnabled=_this$props.onClickEnabled,animationEnabled=_this$props.animationEnabled;return _jsx(StyledSdkContainerWrapper,{id:containerId,style:animationEnabled?ARAnimation:{},onClick:onClickEnabled?_this.onClickHandler:function(){}},void 0);},_temp),_possibleConstructorReturn(_this,_ret);}return SdkRenderContainer;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var SdkRenderContainerForAnalysis=function(_Component2){_inherits(SdkRenderContainerForAnalysis,_Component2);function SdkRenderContainerForAnalysis(){var _ref2;var _temp2,_this2,_ret2;_classCallCheck(this,SdkRenderContainerForAnalysis);for(var _len2=arguments.length,args=Array(_len2),_key2=0;_key2<_len2;_key2++){args[_key2]=arguments[_key2];}return _ret2=(_temp2=(_this2=_possibleConstructorReturn(this,(_ref2=SdkRenderContainerForAnalysis.__proto__||Object.getPrototypeOf(SdkRenderContainerForAnalysis)).call.apply(_ref2,[this].concat(args))),_this2),_this2.render=function(){return _jsx(SdkRenderContainer,{animationEnabled:true,onClickEnabled:true,ARMethods:_this2.props.ARMethods,ARAnimation:_this2.props.ARAnimation,focusOnSkinFinding:_this2.props.focusOnSkinFinding});},_temp2),_possibleConstructorReturn(_this2,_ret2);}return SdkRenderContainerForAnalysis;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/***/ }),
/* 181 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
var _jsx=function(){var REACT_ELEMENT_TYPE=typeof Symbol==="function"&&Symbol.for&&Symbol.for("react.element")||0xeac7;return function createRawReactElement(type,props,key,children){var defaultProps=type&&type.defaultProps;var childrenLength=arguments.length-3;if(!props&&childrenLength!==0){props={};}if(props&&defaultProps){for(var propName in defaultProps){if(props[propName]===void 0){props[propName]=defaultProps[propName];}}}else if(!props){props=defaultProps||{};}if(childrenLength===1){props.children=children;}else if(childrenLength>1){var childArray=Array(childrenLength);for(var i=0;i<childrenLength;i++){childArray[i]=arguments[i+3];}props.children=childArray;}return{$$typeof:REACT_ELEMENT_TYPE,type:type,key:key===undefined?null:''+key,ref:null,props:props,_owner:null};};}();var _templateObject=_taggedTemplateLiteral(['\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  position: absolute;\n  bottom: 15px;\n  ul,\n  li {\n    list-style: none;\n  }\n  ul {\n    display: flex;\n    justify-content: space-between;\n    min-width: auto;\n  }\n  li {\n    width: 20px;\n    height: 3px;\n    border-radius: 1.5px;\n    background: rgba(255, 255, 255, 0.3);\n    transition: background 0.5s ease-in;\n    margin: 0 2.5px;\n  }\n  .activePage {\n    background: rgba(255, 255, 255, 1);\n  }\n'],['\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  position: absolute;\n  bottom: 15px;\n  ul,\n  li {\n    list-style: none;\n  }\n  ul {\n    display: flex;\n    justify-content: space-between;\n    min-width: auto;\n  }\n  li {\n    width: 20px;\n    height: 3px;\n    border-radius: 1.5px;\n    background: rgba(255, 255, 255, 0.3);\n    transition: background 0.5s ease-in;\n    margin: 0 2.5px;\n  }\n  .activePage {\n    background: rgba(255, 255, 255, 1);\n  }\n']);function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var StyledProgressbar=__WEBPACK_IMPORTED_MODULE_1_styled_components__["b" /* default */].div(_templateObject);var Progressbar=function(_Component){_inherits(Progressbar,_Component);function Progressbar(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Progressbar);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Progressbar.__proto__||Object.getPrototypeOf(Progressbar)).call.apply(_ref,[this].concat(args))),_this),_this.render=function(){var _this$props=_this.props,activePage=_this$props.activePage,pageCount=_this$props.pageCount;return _jsx(StyledProgressbar,{className:'revieve-progess-bar'},void 0,pageCount&&activePage>-1?_jsx('ul',{},void 0,[].concat(_toConsumableArray(Array(pageCount-1).fill().map(function(e,i){return _jsx('li',{className:i<=activePage?'activePage':''},i);})))):null);},_temp),_possibleConstructorReturn(_this,_ret);}return Progressbar;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);Progressbar.propTypes={activePage:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,pageCount:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number};/* harmony default export */ __webpack_exports__["a"] = (Progressbar);

/***/ }),
/* 182 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ProductCard__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_addons_css_transition_group__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_addons_css_transition_group___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_addons_css_transition_group__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Processing__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__MediaQueries__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_polyglot__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_polyglot___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_polyglot__);
var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _jsx=function(){var REACT_ELEMENT_TYPE=typeof Symbol==="function"&&Symbol.for&&Symbol.for("react.element")||0xeac7;return function createRawReactElement(type,props,key,children){var defaultProps=type&&type.defaultProps;var childrenLength=arguments.length-3;if(!props&&childrenLength!==0){props={};}if(props&&defaultProps){for(var propName in defaultProps){if(props[propName]===void 0){props[propName]=defaultProps[propName];}}}else if(!props){props=defaultProps||{};}if(childrenLength===1){props.children=children;}else if(childrenLength>1){var childArray=Array(childrenLength);for(var i=0;i<childrenLength;i++){childArray[i]=arguments[i+3];}props.children=childArray;}return{$$typeof:REACT_ELEMENT_TYPE,type:type,key:key===undefined?null:''+key,ref:null,props:props,_owner:null};};}();var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n  width: 100%;\n  height: 120px;\n  ul,\n  li {\n    list-style: none;\n  }\n  ul {\n    width: auto;\n    display: flex;\n    position: absolute;\n    left: 0;\n    top: -80px;\n    ','\n  }\n'],['\n  width: 100%;\n  height: 120px;\n  ul,\n  li {\n    list-style: none;\n  }\n  ul {\n    width: auto;\n    display: flex;\n    position: absolute;\n    left: 0;\n    top: -80px;\n    ','\n  }\n']),_templateObject2=_taggedTemplateLiteral(['\n      top: auto;\n    '],['\n      top: auto;\n    ']),_templateObject3=_taggedTemplateLiteral(['\n  width: 100%;\n  text-align: center;\n  font-size: 18px;\n  color: white;\n  margin: auto;\n'],['\n  width: 100%;\n  text-align: center;\n  font-size: 18px;\n  color: white;\n  margin: auto;\n']),_templateObject4=_taggedTemplateLiteral(['\n  position: relative;\n  top: -130px;\n  left: 0px;\n  cursor: pointer;\n  background: ',';\n  padding: 10px;\n  border-radius: 4px;\n  color: white;\n  font-style: italic;\n  font-size: 14px;\n  font-weight: 700;\n  width: 170px;\n  text-align: center;\n  ','\n'],['\n  position: relative;\n  top: -130px;\n  left: 0px;\n  cursor: pointer;\n  background: ',';\n  padding: 10px;\n  border-radius: 4px;\n  color: white;\n  font-style: italic;\n  font-size: 14px;\n  font-weight: 700;\n  width: 170px;\n  text-align: center;\n  ','\n']),_templateObject5=_taggedTemplateLiteral(['\n    top: -50px;\n  '],['\n    top: -50px;\n  ']);function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var StyledProductWrapper=__WEBPACK_IMPORTED_MODULE_1_styled_components__["b" /* default */].div(_templateObject,__WEBPACK_IMPORTED_MODULE_5__MediaQueries__["a" /* default */].phone(_templateObject2));var StyledHintContainer=__WEBPACK_IMPORTED_MODULE_1_styled_components__["b" /* default */].div(_templateObject3);var StyledAddAllButton=__WEBPACK_IMPORTED_MODULE_1_styled_components__["b" /* default */].div(_templateObject4,function(props){return props.clicked?'#64a05d':'#bbb';},__WEBPACK_IMPORTED_MODULE_5__MediaQueries__["a" /* default */].phone(_templateObject5));var Products=function(_Component){_inherits(Products,_Component);function Products(props){_classCallCheck(this,Products);var _this=_possibleConstructorReturn(this,(Products.__proto__||Object.getPrototypeOf(Products)).call(this,props));_this.handleAddAllToCart=function(){var configOptions=_this.props.configOptions;if(configOptions.results.addAllToCartButton.callback){eval(configOptions.results.addAllToCartButton.callback);}_this.setState({addAllClicked:true});};_this.mapRegimen=function(_ref){var regimens=_ref.regimens,_ref$filters=_ref.filters,filters=_ref$filters===undefined?{}:_ref$filters;var _ref2=Object.entries(regimens).find(function(_ref4){var _ref5=_slicedToArray(_ref4,2),key=_ref5[0],value=_ref5[1];return filters[key]||filters[key+'_ui'];})||[],_ref3=_slicedToArray(_ref2,2),regimen=_ref3[1];if(regimen&&(typeof regimen==='undefined'?'undefined':_typeof(regimen))==='object'&&!Array.isArray(regimen))return _this.mapRegimen({regimens:regimen,filters:filters});return regimen;};_this.loadProds=function(){var _this$props=_this.props,configOptions=_this$props.configOptions,loadingProducts=_this$props.loadingProducts,filters=_this$props.filters,triggerCallback=_this$props.triggerCallback;var _this$state=_this.state,pricegroup=_this$state.pricegroup,products=_this$state.products;var prods=[];if(products){if(configOptions.results.priceGroups){if(pricegroup&&products.hasOwnProperty(pricegroup)){prods=Object.keys(products[pricegroup]).map(function(cat){return products[pricegroup][cat];});}else if(!pricegroup){Object.keys(products).map(function(pricegroup){Object.keys(products[pricegroup]).map(function(cat){prods.push(products[pricegroup][cat]);return true;});return true;});}}else{prods=Object.keys(products).map(function(productKey){return products[productKey];});}}var regimen=_this.mapRegimen({regimens:configOptions.categories.regimen,filters:filters})||[];prods.sort(function(a,b){return regimen.indexOf(a.category)-regimen.indexOf(b.category);});_this.setState({loading:loadingProducts,prods:prods,addAllClicked:false});if(prods&&prods.length>0)triggerCallback({callback:'displayProducts',payload:prods});};_this.render=function(){var _this$state2=_this.state,prods=_this$state2.prods,loading=_this$state2.loading,addAllClicked=_this$state2.addAllClicked;var _this$props2=_this.props,configOptions=_this$props2.configOptions,t=_this$props2.t;var withProductsAndAddAllToCartButton=prods.length>0&&configOptions.results.addAllToCartButton&&configOptions.results.addAllToCartButton.show;return _jsx(StyledProductWrapper,{className:'revieveProductWrapper'},void 0,loading?_jsx(__WEBPACK_IMPORTED_MODULE_4__Processing__["a" /* default */],{label:t('loading_products')},2):_jsx(__WEBPACK_IMPORTED_MODULE_3_react_addons_css_transition_group___default.a,{transitionName:'footerSlide',transitionAppear:true,transitionEnter:true,transitionLeave:true,transitionAppearTimeout:900,transitionLeaveTimeout:900,transitionEnterTimeout:900},void 0,prods.length>0?_jsx('ul',{},1,prods.map(function(product){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__ProductCard__["a" /* default */],_extends({key:product.id,product:product,configOptions:configOptions},_this.props));})):_jsx(StyledHintContainer,{},void 0,t('no_products')),withProductsAndAddAllToCartButton&&_jsx(StyledAddAllButton,{clicked:addAllClicked,className:'addAllToCart',onClick:_this.handleAddAllToCart},void 0,configOptions.results.addAllToCartButton.text)));};_this.state={loading:true,prods:[],products:props.products,pricegroup:props.pricegroup,addAllClicked:false};return _this;}_createClass(Products,[{key:'componentDidMount',value:function componentDidMount(){this.loadProds();}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(newProps){var _this2=this;var _state=this.state,products=_state.products,pricegroup=_state.pricegroup;if(JSON.stringify(products)!==JSON.stringify(newProps.products)){this.setState({loading:true,products:newProps.products},function(){return _this2.loadProds();});}if(pricegroup!==newProps.pricegroup){this.setState({loading:true,pricegroup:newProps.pricegroup},function(){return _this2.loadProds();});}}}]);return Products;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6_react_polyglot__["translate"])()(Products));

/***/ }),
/* 183 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ProductCard_style__ = __webpack_require__(184);
var _jsx=function(){var REACT_ELEMENT_TYPE=typeof Symbol==="function"&&Symbol.for&&Symbol.for("react.element")||0xeac7;return function createRawReactElement(type,props,key,children){var defaultProps=type&&type.defaultProps;var childrenLength=arguments.length-3;if(!props&&childrenLength!==0){props={};}if(props&&defaultProps){for(var propName in defaultProps){if(props[propName]===void 0){props[propName]=defaultProps[propName];}}}else if(!props){props=defaultProps||{};}if(childrenLength===1){props.children=children;}else if(childrenLength>1){var childArray=Array(childrenLength);for(var i=0;i<childrenLength;i++){childArray[i]=arguments[i+3];}props.children=childArray;}return{$$typeof:REACT_ELEMENT_TYPE,type:type,key:key===undefined?null:''+key,ref:null,props:props,_owner:null};};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ProductCard=function(_Component){_inherits(ProductCard,_Component);function ProductCard(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ProductCard);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ProductCard.__proto__||Object.getPrototypeOf(ProductCard)).call.apply(_ref,[this].concat(args))),_this),_this.render=function(){var _this$props=_this.props,product=_this$props.product,showProductDetails=_this$props.showProductDetails,showTryOn=_this$props.showTryOn,currency=_this$props.currency,ARMethods=_this$props.ARMethods,selectedProductsForTryOn=_this$props.selectedProductsForTryOn,configOptions=_this$props.configOptions;var trimmedName=product.name.substring(0,44);var trimmedDesc=product.description.substring(0,60);var hexcode=void 0;if(product.hasOwnProperty('filter_match')&&Array.isArray(product.filter_match)){var colorattribute=product.filter_match.find(function(a){return typeof a==='string'&&a.startsWith('color_hex_');});if(colorattribute){var colorValue=colorattribute.split('_')[2];colorValue=colorValue.replace('0x','');colorValue=colorValue.replace('#','');hexcode='#'+colorValue;}}var tryOnAvailable=ARMethods.canVisualizeProduct(product);var tryOnActive=selectedProductsForTryOn&&selectedProductsForTryOn.hasOwnProperty(product.category)&&selectedProductsForTryOn[product.category].id===product.id;var price=null;if(product.price&&currency){price=product.price.toLocaleString('en-US',{style:'currency',currency:currency});}var showSeeAllButton=configOptions.results.seeAllButton&&configOptions.results.seeAllButton.show;var showBuyNowButton=configOptions.results.buyNowButton&&configOptions.results.buyNowButton.show;return _jsx(__WEBPACK_IMPORTED_MODULE_1__ProductCard_style__["a" /* default */],{onClick:function onClick(){return showProductDetails(product);}},void 0,_jsx('div',{className:'label'},void 0,product.category,product.custom_data&&product.custom_data.subcategory&&' '+product.custom_data.subcategory),product.custom_data&&product.custom_data.rating&&_jsx('div',{className:'ratingSection'},void 0,_jsx('div',{className:'ratingValue'},void 0,product.custom_data.rating,' / 5'),_jsx('div',{className:'reviewCountValue'},void 0,product.custom_data.reviewCount,' reviews')),tryOnAvailable&&_jsx('button',{className:tryOnActive?'tryon active':'tryon',onClick:function onClick(e){e.stopPropagation();showTryOn(product);}},void 0,'Try On'),_jsx('div',{className:showBuyNowButton||showSeeAllButton?'infobox infoboxSmall':'infobox'},void 0,_jsx('img',{src:product.image,alt:''}),_jsx('div',{className:'details'},void 0,_jsx('div',{className:'name'},void 0,trimmedName),_jsx('div',{className:'desc'},void 0,trimmedDesc+'...'),_jsx('div',{className:'price'},void 0,price))),(showSeeAllButton||showBuyNowButton)&&_jsx('div',{className:'infobox infoboxBottom'},void 0,showBuyNowButton&&_jsx('button',{disabled:!configOptions.results.buyNowButton.callback,onClick:configOptions.results.buyNowButton.callback?eval(configOptions.results.buyNowButton.callback):null},void 0,configOptions.results.buyNowButton.text),showSeeAllButton&&_jsx('button',{},void 0,configOptions.results.seeAllButton.text)),hexcode&&_jsx('div',{className:'color',style:{backgroundColor:hexcode}}));},_temp),_possibleConstructorReturn(_this,_ret);}return ProductCard;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (ProductCard);

/***/ }),
/* 184 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MediaQueries__ = __webpack_require__(3);
var _templateObject=_taggedTemplateLiteral(['\n  cursor: pointer;\n  position: relative;\n  width: 300px;\n  height: 200px;\n  background-color: white;\n  border-radius: 6px;\n  margin-right: 20px;\n  box-shadow: 0 0 18px 0 rgba(0, 0, 0, 0.2);\n  line-height: 1.4;\n  overflow: hidden;\n  ','\n  .color {\n    position: absolute;\n    bottom: 20px;\n    left: 20px;\n    border-radius: 50%;\n    width: 24px;\n    height: 24px;\n    border: 2px solid #f3f3f3;\n  }\n  .label {\n    position: absolute;\n    left: 20px;\n    top: 20px;\n    ','\n  }\n  .ratingSection {\n    position: absolute;\n    right: 0;\n    padding: 20px 20px 0px 0px;\n    font-size: 13px;\n    text-align: right;\n    ','\n  }\n  .reviewCountValue {\n    font-size: 10px;\n    color: gray;\n  }\n  .tryon {\n    cursor: pointer;\n    position: absolute;\n    right: 20px;\n    top: 20px;\n    background: transparent;\n    width: 44px;\n    height: 25px;\n    border: 2px solid #0091ff;\n    border-radius: 4px;\n    color: #0091ff;\n    font-style: italic;\n    font-size: 10px;\n    font-weight: 700;\n    ','\n  }\n  .active {\n    color: white;\n    background: #0091ff;\n  }\n  .infoboxBottom {\n    top: auto !important;\n    justify-content: space-around;\n    width: 100%;\n    left: 10px !important;\n    button {\n      cursor: pointer;\n      background: #bbb;\n      border: 2px solid #bbb;\n      padding: 4px;\n      border-radius: 4px;\n      color: white;\n      font-style: italic;\n      font-size: 10px;\n      font-weight: 700;\n      width: 40%;\n    }\n    button:disabled {\n      background: #eee;\n      border: 2px solid #eee;\n    }\n  }\n  .infoboxSmall {\n    height: 90px !important;\n    img {\n      height: 90px !important;\n    }\n    .name {\n      font-size: 13px !important;\n    }\n    .desc {\n      font-size: 11px !important;\n    }\n  }\n  .infobox {\n    position: absolute;\n    left: 20px;\n    top: 60px;\n    bottom: 20px;\n    padding-right: 20px;\n    display: flex;\n    ','\n    img {\n      pointer-events: none;\n      height: 120px;\n      min-width: 85px;\n      object-fit: contain;\n      ','\n    }\n    .details {\n      margin-left: 10px;\n      display: flex;\n      flex-direction: column;\n      justify-content: space-between;\n      .name {\n        font-size: 14px;\n        font-weight: 500;\n        color: #4a4a4a;\n        ','\n      }\n      .desc {\n        color: #9b9b9b;\n        font-size: 12px;\n        font-weight: 700;\n        ','\n      }\n      .price {\n        font-size: 16px;\n        font-weight: 700;\n      }\n    }\n  }\n'],['\n  cursor: pointer;\n  position: relative;\n  width: 300px;\n  height: 200px;\n  background-color: white;\n  border-radius: 6px;\n  margin-right: 20px;\n  box-shadow: 0 0 18px 0 rgba(0, 0, 0, 0.2);\n  line-height: 1.4;\n  overflow: hidden;\n  ','\n  .color {\n    position: absolute;\n    bottom: 20px;\n    left: 20px;\n    border-radius: 50%;\n    width: 24px;\n    height: 24px;\n    border: 2px solid #f3f3f3;\n  }\n  .label {\n    position: absolute;\n    left: 20px;\n    top: 20px;\n    ','\n  }\n  .ratingSection {\n    position: absolute;\n    right: 0;\n    padding: 20px 20px 0px 0px;\n    font-size: 13px;\n    text-align: right;\n    ','\n  }\n  .reviewCountValue {\n    font-size: 10px;\n    color: gray;\n  }\n  .tryon {\n    cursor: pointer;\n    position: absolute;\n    right: 20px;\n    top: 20px;\n    background: transparent;\n    width: 44px;\n    height: 25px;\n    border: 2px solid #0091ff;\n    border-radius: 4px;\n    color: #0091ff;\n    font-style: italic;\n    font-size: 10px;\n    font-weight: 700;\n    ','\n  }\n  .active {\n    color: white;\n    background: #0091ff;\n  }\n  .infoboxBottom {\n    top: auto !important;\n    justify-content: space-around;\n    width: 100%;\n    left: 10px !important;\n    button {\n      cursor: pointer;\n      background: #bbb;\n      border: 2px solid #bbb;\n      padding: 4px;\n      border-radius: 4px;\n      color: white;\n      font-style: italic;\n      font-size: 10px;\n      font-weight: 700;\n      width: 40%;\n    }\n    button:disabled {\n      background: #eee;\n      border: 2px solid #eee;\n    }\n  }\n  .infoboxSmall {\n    height: 90px !important;\n    img {\n      height: 90px !important;\n    }\n    .name {\n      font-size: 13px !important;\n    }\n    .desc {\n      font-size: 11px !important;\n    }\n  }\n  .infobox {\n    position: absolute;\n    left: 20px;\n    top: 60px;\n    bottom: 20px;\n    padding-right: 20px;\n    display: flex;\n    ','\n    img {\n      pointer-events: none;\n      height: 120px;\n      min-width: 85px;\n      object-fit: contain;\n      ','\n    }\n    .details {\n      margin-left: 10px;\n      display: flex;\n      flex-direction: column;\n      justify-content: space-between;\n      .name {\n        font-size: 14px;\n        font-weight: 500;\n        color: #4a4a4a;\n        ','\n      }\n      .desc {\n        color: #9b9b9b;\n        font-size: 12px;\n        font-weight: 700;\n        ','\n      }\n      .price {\n        font-size: 16px;\n        font-weight: 700;\n      }\n    }\n  }\n']),_templateObject2=_taggedTemplateLiteral(['\n    width: 250px;\n    height: 120px;\n  '],['\n    width: 250px;\n    height: 120px;\n  ']),_templateObject3=_taggedTemplateLiteral(['\n      font-size: 14px;\n      text-align: right;\n      left: initial;\n      right: 20px;\n      top: 10px;\n    '],['\n      font-size: 14px;\n      text-align: right;\n      left: initial;\n      right: 20px;\n      top: 10px;\n    ']),_templateObject4=_taggedTemplateLiteral(['\n      display: none;\n    '],['\n      display: none;\n    ']),_templateObject5=_taggedTemplateLiteral(['\n      bottom: 15px;\n      top: auto;\n      z-index: 2;\n    '],['\n      bottom: 15px;\n      top: auto;\n      z-index: 2;\n    ']),_templateObject6=_taggedTemplateLiteral(['\n      left: 10px;\n      top: 0;\n    '],['\n      left: 10px;\n      top: 0;\n    ']),_templateObject7=_taggedTemplateLiteral(['\n        width: 85px;\n      '],['\n        width: 85px;\n      ']),_templateObject8=_taggedTemplateLiteral(['\n          font-size:12px;\n          margin-top: 40px;\n        '],['\n          font-size:12px;\n          margin-top: 40px;\n        ']),_templateObject9=_taggedTemplateLiteral(['\n          display: none;\n        '],['\n          display: none;\n        ']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var StyledProduct=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* default */].li(_templateObject,__WEBPACK_IMPORTED_MODULE_1__MediaQueries__["a" /* default */].phone(_templateObject2),__WEBPACK_IMPORTED_MODULE_1__MediaQueries__["a" /* default */].phone(_templateObject3),__WEBPACK_IMPORTED_MODULE_1__MediaQueries__["a" /* default */].phone(_templateObject4),__WEBPACK_IMPORTED_MODULE_1__MediaQueries__["a" /* default */].phone(_templateObject5),__WEBPACK_IMPORTED_MODULE_1__MediaQueries__["a" /* default */].phone(_templateObject6),__WEBPACK_IMPORTED_MODULE_1__MediaQueries__["a" /* default */].phone(_templateObject7),__WEBPACK_IMPORTED_MODULE_1__MediaQueries__["a" /* default */].phone(_templateObject8),__WEBPACK_IMPORTED_MODULE_1__MediaQueries__["a" /* default */].phone(_templateObject9));/* harmony default export */ __webpack_exports__["a"] = (StyledProduct);

/***/ }),
/* 185 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
var _jsx=function(){var REACT_ELEMENT_TYPE=typeof Symbol==="function"&&Symbol.for&&Symbol.for("react.element")||0xeac7;return function createRawReactElement(type,props,key,children){var defaultProps=type&&type.defaultProps;var childrenLength=arguments.length-3;if(!props&&childrenLength!==0){props={};}if(props&&defaultProps){for(var propName in defaultProps){if(props[propName]===void 0){props[propName]=defaultProps[propName];}}}else if(!props){props=defaultProps||{};}if(childrenLength===1){props.children=children;}else if(childrenLength>1){var childArray=Array(childrenLength);for(var i=0;i<childrenLength;i++){childArray[i]=arguments[i+3];}props.children=childArray;}return{$$typeof:REACT_ELEMENT_TYPE,type:type,key:key===undefined?null:''+key,ref:null,props:props,_owner:null};};}();var _templateObject=_taggedTemplateLiteral(['\n  position: absolute;\n  width: calc(100% - 60px);\n  height: 44px;\n  display: flex;\n  justify-content: space-between;\n  bottom: 260px;\n'],['\n  position: absolute;\n  width: calc(100% - 60px);\n  height: 44px;\n  display: flex;\n  justify-content: space-between;\n  bottom: 260px;\n']);function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var StyledSecondaryNav=__WEBPACK_IMPORTED_MODULE_1_styled_components__["b" /* default */].div(_templateObject);var SecondaryNav=function(_Component){_inherits(SecondaryNav,_Component);function SecondaryNav(){var _ref;var _temp,_this,_ret;_classCallCheck(this,SecondaryNav);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=SecondaryNav.__proto__||Object.getPrototypeOf(SecondaryNav)).call.apply(_ref,[this].concat(args))),_this),_this.render=function(){return _jsx(StyledSecondaryNav,{},void 0);},_temp),_possibleConstructorReturn(_this,_ret);}return SecondaryNav;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (SecondaryNav);

/***/ }),
/* 186 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ProductDetails_style__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Modal__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_polyglot__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_polyglot___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_polyglot__);
var _jsx=function(){var REACT_ELEMENT_TYPE=typeof Symbol==="function"&&Symbol.for&&Symbol.for("react.element")||0xeac7;return function createRawReactElement(type,props,key,children){var defaultProps=type&&type.defaultProps;var childrenLength=arguments.length-3;if(!props&&childrenLength!==0){props={};}if(props&&defaultProps){for(var propName in defaultProps){if(props[propName]===void 0){props[propName]=defaultProps[propName];}}}else if(!props){props=defaultProps||{};}if(childrenLength===1){props.children=children;}else if(childrenLength>1){var childArray=Array(childrenLength);for(var i=0;i<childrenLength;i++){childArray[i]=arguments[i+3];}props.children=childArray;}return{$$typeof:REACT_ELEMENT_TYPE,type:type,key:key===undefined?null:''+key,ref:null,props:props,_owner:null};};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ProductDetails=function(_Component){_inherits(ProductDetails,_Component);function ProductDetails(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ProductDetails);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ProductDetails.__proto__||Object.getPrototypeOf(ProductDetails)).call.apply(_ref,[this].concat(args))),_this),_this.render=function(){var _this$props=_this.props,selectedProduct=_this$props.selectedProduct,configOptions=_this$props.configOptions,t=_this$props.t;return _jsx(__WEBPACK_IMPORTED_MODULE_2__Modal__["a" /* default */],{onClick:_this.props.closeProductDetails,open:selectedProduct},void 0,_jsx(__WEBPACK_IMPORTED_MODULE_1__ProductDetails_style__["a" /* default */],{},void 0,_jsx('h2',{className:'title'},void 0,selectedProduct?selectedProduct.name:null),_jsx('span',{className:'location'},void 0,t('product_location')),_jsx('div',{className:'productDesc'},void 0,_jsx('img',{src:selectedProduct?selectedProduct.image:null,alt:''}),_jsx('div',{className:'desc'},void 0,_jsx('p',{},void 0,selectedProduct?selectedProduct.description:null),selectedProduct&&selectedProduct.custom_data&&selectedProduct.custom_data.rating&&_jsx('div',{className:'ratingSection'},void 0,_jsx('div',{className:'ratingValue'},void 0,'User rate: ',selectedProduct.custom_data.rating,' / 5'),_jsx('div',{className:'reviewCountValue'},void 0,'Based on ',selectedProduct.custom_data.reviewCount,' reviews')))),_jsx('div',{className:'actions'},void 0,configOptions.results.buyNowButton&&configOptions.results.buyNowButton.show&&_jsx('button',{disabled:!configOptions.results.buyNowButton.callback,onClick:configOptions.results.buyNowButton.callback?eval(configOptions.results.buyNowButton.callback):null},void 0,configOptions.results.buyNowButton.text))));},_temp),_possibleConstructorReturn(_this,_ret);}return ProductDetails;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_polyglot__["translate"])()(ProductDetails));

/***/ }),
/* 187 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MediaQueries__ = __webpack_require__(3);
var _templateObject=_taggedTemplateLiteral(['\n  overflow-y: auto;\n  -webkit-overflow-scrolling: touch;\n  h2.title {\n    font-size: 20px;\n    font-weight: 300;\n    text-transform: capitalize;\n  }\n\n  span.location {\n    margin-top: 20px;\n    font-size: 14px;\n    font-weight: 700;\n    color: #0091ff;\n  }\n\n  .productDesc {\n    margin-top: 40px;\n    display: flex;\n    ','\n    img {\n      width: 30%;\n      height: 200px;\n      object-fit: contain;\n      ','\n    }\n    .desc {\n      display: flex;\n      flex-direction: column;\n      padding-left: 5%;\n      h3.benefits {\n        font-size: 16px;\n        font-weight: 400;\n      }\n      p {\n        margin-top: 20px;\n        font-size: 14px;\n      }\n      span.quantity {\n        margin-top: 20px;\n      }\n    }\n  }\n\n  .ratingSection {\n    margin-top: 20px;\n  }\n  .reviewCountValue {\n    font-size: 10px;\n    color: gray;\n  }\n\n  .actions {\n    margin-top: 20px;\n    display: flex;\n    justify-content: flex-end;\n    position: absolute;\n    bottom: 40px;\n    width: 100%;\n    left: -5%;\n    button {\n      cursor: pointer;\n      background: #bbb;\n      border: 2px solid #bbb;\n      padding: 8px;\n      border-radius: 4px;\n      color: white;\n      font-style: italic;\n      font-size: 14px;\n      font-weight: 700;\n      width: 30%;\n    }\n    button:disabled {\n      background: #eee;\n      border: 2px solid #eee;\n    }\n  }\n'],['\n  overflow-y: auto;\n  -webkit-overflow-scrolling: touch;\n  h2.title {\n    font-size: 20px;\n    font-weight: 300;\n    text-transform: capitalize;\n  }\n\n  span.location {\n    margin-top: 20px;\n    font-size: 14px;\n    font-weight: 700;\n    color: #0091ff;\n  }\n\n  .productDesc {\n    margin-top: 40px;\n    display: flex;\n    ','\n    img {\n      width: 30%;\n      height: 200px;\n      object-fit: contain;\n      ','\n    }\n    .desc {\n      display: flex;\n      flex-direction: column;\n      padding-left: 5%;\n      h3.benefits {\n        font-size: 16px;\n        font-weight: 400;\n      }\n      p {\n        margin-top: 20px;\n        font-size: 14px;\n      }\n      span.quantity {\n        margin-top: 20px;\n      }\n    }\n  }\n\n  .ratingSection {\n    margin-top: 20px;\n  }\n  .reviewCountValue {\n    font-size: 10px;\n    color: gray;\n  }\n\n  .actions {\n    margin-top: 20px;\n    display: flex;\n    justify-content: flex-end;\n    position: absolute;\n    bottom: 40px;\n    width: 100%;\n    left: -5%;\n    button {\n      cursor: pointer;\n      background: #bbb;\n      border: 2px solid #bbb;\n      padding: 8px;\n      border-radius: 4px;\n      color: white;\n      font-style: italic;\n      font-size: 14px;\n      font-weight: 700;\n      width: 30%;\n    }\n    button:disabled {\n      background: #eee;\n      border: 2px solid #eee;\n    }\n  }\n']),_templateObject2=_taggedTemplateLiteral(['\n      flex-direction: column;\n    '],['\n      flex-direction: column;\n    ']),_templateObject3=_taggedTemplateLiteral(['\n        width: 100%;\n      '],['\n        width: 100%;\n      ']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var StyledDetails=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* default */].div(_templateObject,__WEBPACK_IMPORTED_MODULE_1__MediaQueries__["a" /* default */].phone(_templateObject2),__WEBPACK_IMPORTED_MODULE_1__MediaQueries__["a" /* default */].phone(_templateObject3));/* harmony default export */ __webpack_exports__["a"] = (StyledDetails);

/***/ }),
/* 188 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__images_instore_icons_close_svg__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__images_instore_icons_close_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__images_instore_icons_close_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MediaQueries__ = __webpack_require__(3);
var _jsx=function(){var REACT_ELEMENT_TYPE=typeof Symbol==="function"&&Symbol.for&&Symbol.for("react.element")||0xeac7;return function createRawReactElement(type,props,key,children){var defaultProps=type&&type.defaultProps;var childrenLength=arguments.length-3;if(!props&&childrenLength!==0){props={};}if(props&&defaultProps){for(var propName in defaultProps){if(props[propName]===void 0){props[propName]=defaultProps[propName];}}}else if(!props){props=defaultProps||{};}if(childrenLength===1){props.children=children;}else if(childrenLength>1){var childArray=Array(childrenLength);for(var i=0;i<childrenLength;i++){childArray[i]=arguments[i+3];}props.children=childArray;}return{$$typeof:REACT_ELEMENT_TYPE,type:type,key:key===undefined?null:''+key,ref:null,props:props,_owner:null};};}();var _templateObject=_taggedTemplateLiteral(['\n  z-index: 11;\n  position: absolute;\n  top: 0; left: 0; right: 0; bottom: 0; margin: auto;\n  display: flex;\n  flex-direction: column;\n  background: white;\n  width: 80%;\n  height: 70%;\n  border-radius: 6px;\n  overflow: hidden;\n  padding: 60px 40px 40px 40px;\n  box-shadow: 0 0 30px 6px rgba(0,0,0,.3);\n  transition: transform .5s cubic-bezier(.5,0,0,1.2), opacity .5s cubic-bezier(.5,0,0,1.2);\n  transform: ',';\n  opacity: ',';\n  ','\n  .close {\n    cursor: pointer;\n    width: 18px;\n    height: 18px;\n    position: absolute;\n    background:url(',');\n    background-repeat: no-repeat;\n    background-size: contain;\n    top: 40px;\n    right: 40px;\n  }\n  .saveSelection {\n    cursor: pointer;\n    position: absolute;\n    bottom: 0;\n    left: 0; right: 0;\n    width: 100%; height: 60px;\n    background: #0091FF;\n    color: white;\n    font-size: 16px;\n    border: none;\n    outline: none;\n  }\n'],['\n  z-index: 11;\n  position: absolute;\n  top: 0; left: 0; right: 0; bottom: 0; margin: auto;\n  display: flex;\n  flex-direction: column;\n  background: white;\n  width: 80%;\n  height: 70%;\n  border-radius: 6px;\n  overflow: hidden;\n  padding: 60px 40px 40px 40px;\n  box-shadow: 0 0 30px 6px rgba(0,0,0,.3);\n  transition: transform .5s cubic-bezier(.5,0,0,1.2), opacity .5s cubic-bezier(.5,0,0,1.2);\n  transform: ',';\n  opacity: ',';\n  ','\n  .close {\n    cursor: pointer;\n    width: 18px;\n    height: 18px;\n    position: absolute;\n    background:url(',');\n    background-repeat: no-repeat;\n    background-size: contain;\n    top: 40px;\n    right: 40px;\n  }\n  .saveSelection {\n    cursor: pointer;\n    position: absolute;\n    bottom: 0;\n    left: 0; right: 0;\n    width: 100%; height: 60px;\n    background: #0091FF;\n    color: white;\n    font-size: 16px;\n    border: none;\n    outline: none;\n  }\n']),_templateObject2=_taggedTemplateLiteral(['\n    border-radius: 0;\n    width: 100%;\n    height: 100%;\n  '],['\n    border-radius: 0;\n    width: 100%;\n    height: 100%;\n  ']);function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var StyledModal=__WEBPACK_IMPORTED_MODULE_1_styled_components__["b" /* default */].div(_templateObject,function(props){return props.open?'scale:(1)':'scale(0)';},function(props){return props.open?'1':'0';},__WEBPACK_IMPORTED_MODULE_3__MediaQueries__["a" /* default */].phone(_templateObject2),__WEBPACK_IMPORTED_MODULE_2__images_instore_icons_close_svg___default.a);var Modal=function(_Component){_inherits(Modal,_Component);function Modal(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Modal);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Modal.__proto__||Object.getPrototypeOf(Modal)).call.apply(_ref,[this].concat(args))),_this),_this.render=function(){return _jsx(StyledModal,{open:_this.props.open},void 0,_jsx('div',{className:'close',onClick:_this.props.onClick}),_this.props.children);},_temp),_possibleConstructorReturn(_this,_ret);}return Modal;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Modal);

/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/close.6a934549.svg";

/***/ }),
/* 190 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MediaQueries__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_polyglot__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_polyglot___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_polyglot__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__images_instore_icons_filter_svg__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__images_instore_icons_filter_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__images_instore_icons_filter_svg__);
var _jsx=function(){var REACT_ELEMENT_TYPE=typeof Symbol==="function"&&Symbol.for&&Symbol.for("react.element")||0xeac7;return function createRawReactElement(type,props,key,children){var defaultProps=type&&type.defaultProps;var childrenLength=arguments.length-3;if(!props&&childrenLength!==0){props={};}if(props&&defaultProps){for(var propName in defaultProps){if(props[propName]===void 0){props[propName]=defaultProps[propName];}}}else if(!props){props=defaultProps||{};}if(childrenLength===1){props.children=children;}else if(childrenLength>1){var childArray=Array(childrenLength);for(var i=0;i<childrenLength;i++){childArray[i]=arguments[i+3];}props.children=childArray;}return{$$typeof:REACT_ELEMENT_TYPE,type:type,key:key===undefined?null:''+key,ref:null,props:props,_owner:null};};}();var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n  position: absolute;\n  display: flex;\n  justify-content: space-between;\n  padding: 0 30px;\n  width: 100%;\n  top: 120px;\n  z-index: 1;\n  ','\n  .filterIcon {\n    display: none;\n    & + label {\n      display: none;\n      ','\n    }\n    &:checked ~ ul {\n      ','\n    }\n  }\n  ul, li {\n    list-style: none;\n  }\n  ul {\n    display: flex;\n    transition: transform .25s ease-in, opacity .25s ease-in;\n    ','\n    .routine {\n      max-width: calc(120px * 2);\n    }\n    .category {\n      max-width: calc(120px * 3);\n    }\n    li {\n      ','\n    }\n  }\n'],['\n  position: absolute;\n  display: flex;\n  justify-content: space-between;\n  padding: 0 30px;\n  width: 100%;\n  top: 120px;\n  z-index: 1;\n  ','\n  .filterIcon {\n    display: none;\n    & + label {\n      display: none;\n      ','\n    }\n    &:checked ~ ul {\n      ','\n    }\n  }\n  ul, li {\n    list-style: none;\n  }\n  ul {\n    display: flex;\n    transition: transform .25s ease-in, opacity .25s ease-in;\n    ','\n    .routine {\n      max-width: calc(120px * 2);\n    }\n    .category {\n      max-width: calc(120px * 3);\n    }\n    li {\n      ','\n    }\n  }\n']),_templateObject2=_taggedTemplateLiteral(['\n    flex-direction: column;\n    top: 60px;\n    justify-content: flex-start;\n    z-index: 5;\n  '],['\n    flex-direction: column;\n    top: 60px;\n    justify-content: flex-start;\n    z-index: 5;\n  ']),_templateObject3=_taggedTemplateLiteral(['\n        display: inline;\n        cursor: pointer;\n        position: relative;\n        background-image: url(',');\n        height: 24px; width: 24px;\n      '],['\n        display: inline;\n        cursor: pointer;\n        position: relative;\n        background-image: url(',');\n        height: 24px; width: 24px;\n      ']),_templateObject4=_taggedTemplateLiteral(['\n        opacity: 1;\n        transform: translate3d(0, 0, 0);\n      '],['\n        opacity: 1;\n        transform: translate3d(0, 0, 0);\n      ']),_templateObject5=_taggedTemplateLiteral(['\n      margin-top: 20px;\n      opacity: 0;\n      transform: translate3d(0, -20px, 0);\n    '],['\n      margin-top: 20px;\n      opacity: 0;\n      transform: translate3d(0, -20px, 0);\n    ']),_templateObject6=_taggedTemplateLiteral(['\n        width: 100%;\n        height: 44px;\n      '],['\n        width: 100%;\n        height: 44px;\n      ']),_templateObject7=_taggedTemplateLiteral(['\n  cursor: pointer;\n  display: flex; justify-content: center; align-items: center;\n  width: 120px;\n  height: 44px;\n  background-color: ',';\n  border: 1px solid rgba(0,0,0,0.12);\n  color: white;\n  text-align: center;\n  font-size: 14px;\n  font-weight: ',';\n  text-transform: capitalize;\n  &:first-child {\n    border-top-left-radius: 4px;\n    border-bottom-left-radius: 4px;\n  }\n  &:last-child {\n    border-top-right-radius: 4px;\n    border-bottom-right-radius: 4px;\n  }\n'],['\n  cursor: pointer;\n  display: flex; justify-content: center; align-items: center;\n  width: 120px;\n  height: 44px;\n  background-color: ',';\n  border: 1px solid rgba(0,0,0,0.12);\n  color: white;\n  text-align: center;\n  font-size: 14px;\n  font-weight: ',';\n  text-transform: capitalize;\n  &:first-child {\n    border-top-left-radius: 4px;\n    border-bottom-left-radius: 4px;\n  }\n  &:last-child {\n    border-top-right-radius: 4px;\n    border-bottom-right-radius: 4px;\n  }\n']);function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var StyledFilterWrapper=__WEBPACK_IMPORTED_MODULE_1_styled_components__["b" /* default */].div(_templateObject,__WEBPACK_IMPORTED_MODULE_2__MediaQueries__["a" /* default */].phone(_templateObject2),__WEBPACK_IMPORTED_MODULE_2__MediaQueries__["a" /* default */].phone(_templateObject3,__WEBPACK_IMPORTED_MODULE_4__images_instore_icons_filter_svg___default.a),__WEBPACK_IMPORTED_MODULE_2__MediaQueries__["a" /* default */].phone(_templateObject4),__WEBPACK_IMPORTED_MODULE_2__MediaQueries__["a" /* default */].phone(_templateObject5),__WEBPACK_IMPORTED_MODULE_2__MediaQueries__["a" /* default */].phone(_templateObject6));var StyledLi=__WEBPACK_IMPORTED_MODULE_1_styled_components__["b" /* default */].li(_templateObject7,function(props){return props.active?'rgba(30,144,255,0.30)':'rgba(0,0,0,0.30)';},function(props){return props.active?800:500;});var FilterButtons=function(_Component){_inherits(FilterButtons,_Component);function FilterButtons(props){_classCallCheck(this,FilterButtons);var _this=_possibleConstructorReturn(this,(FilterButtons.__proto__||Object.getPrototypeOf(FilterButtons)).call(this,props));_this.isChoiceActive=function(choice){var filters=_this.props.filters;var inRequestProperty=_this.props.options.inRequestProperty;var found=false;if(inRequestProperty){found=filters.hasOwnProperty(inRequestProperty)&&filters[inRequestProperty].hasOwnProperty(choice)&&filters[inRequestProperty][choice]>0;}else{found=filters[choice]>0;}return found;};_this.render=function(){var _this$props=_this.props,setPriceGroup=_this$props.setPriceGroup,pricegroup=_this$props.pricegroup,toggleFilter=_this$props.toggleFilter,regimen=_this$props.regimen,configOptions=_this$props.configOptions,t=_this$props.t;var products=_this.state.products;var _this$props$options=_this.props.options,choices=_this$props$options.choices,inRequestProperty=_this$props$options.inRequestProperty;return _jsx(StyledFilterWrapper,{},void 0,_jsx('input',{type:'checkbox',className:'filterIcon',id:'filterIcon'}),_jsx('label',{htmlFor:'filterIcon'}),_jsx('ul',{className:'routine'},void 0,regimen&&choices&&choices.map(function(choice,i){return _jsx(StyledLi,{active:_this.isChoiceActive(choice),onClick:function onClick(){toggleFilter(choice,1,choices,false,false,null,inRequestProperty,true);}},i,t(choice));})),products&&configOptions.results.priceGroups&&_jsx('ul',{className:'category'},void 0,Object.keys(configOptions.results.priceGroups.default).map(function(pg,i){var count=0;if(products.hasOwnProperty(pg)){count=Object.keys(products[pg]).length;}return _jsx(StyledLi,{active:pg===pricegroup,onClick:function onClick(){setPriceGroup(pg);}},i,pg+' ('+count+')');})));};_this.state={products:props.products};return _this;}_createClass(FilterButtons,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var products=this.state.products;if(JSON.stringify(nextProps.products)!==JSON.stringify(products)){this.setState({products:nextProps.products});}}},{key:'componentWillMount',value:function componentWillMount(){var _this2=this;var _props=this.props,toggleFilter=_props.toggleFilter,fetchProducts=_props.fetchProducts;var _props$options=this.props.options,choices=_props$options.choices,defaultChoice=_props$options.defaultChoice,inRequestProperty=_props$options.inRequestProperty;var considerDefaultChoice=true;choices.map(function(choice){if(_this2.isChoiceActive(choice,false)){considerDefaultChoice=false;}return null;});if(considerDefaultChoice){toggleFilter(defaultChoice,1,choices,false,false,null,inRequestProperty,true);}else{fetchProducts();}}}]);return FilterButtons;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_polyglot__["translate"])()(FilterButtons));

/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/filter.9684400c.svg";

/***/ }),
/* 192 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__images_instore_icons_horizontalswipe_svg__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__images_instore_icons_horizontalswipe_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__images_instore_icons_horizontalswipe_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_addons_css_transition_group__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_addons_css_transition_group___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_addons_css_transition_group__);
var _jsx=function(){var REACT_ELEMENT_TYPE=typeof Symbol==="function"&&Symbol.for&&Symbol.for("react.element")||0xeac7;return function createRawReactElement(type,props,key,children){var defaultProps=type&&type.defaultProps;var childrenLength=arguments.length-3;if(!props&&childrenLength!==0){props={};}if(props&&defaultProps){for(var propName in defaultProps){if(props[propName]===void 0){props[propName]=defaultProps[propName];}}}else if(!props){props=defaultProps||{};}if(childrenLength===1){props.children=children;}else if(childrenLength>1){var childArray=Array(childrenLength);for(var i=0;i<childrenLength;i++){childArray[i]=arguments[i+3];}props.children=childArray;}return{$$typeof:REACT_ELEMENT_TYPE,type:type,key:key===undefined?null:''+key,ref:null,props:props,_owner:null};};}();var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n  width: 120px;\n  height: 120px;\n  position: absolute;\n  left: 0; right: 0; margin: 0 auto;\n  top: 0;\n  z-index: 20;\n  border: 3px solid rgba(255,255,255,.5);\n  border-radius: 12px;\n  background: url(',') no-repeat, rgba(0,0,0,1);\n  background-position: 45% center;\n  pointer-events: none;\n  \n  @keyframes move {\n    0% {\n      transform: translate3d(0,0,0);\n    }\n    25% {\n      transform: translate3d(-10px,0,0);\n    }\n    50% {\n      transform: translate3d(10px,0,0);\n    }\n    75% {\n      transform: translate3d(0,0,0);\n    }\n  }\n\n  animation: move 1s 1s ease-in-out;\n'],['\n  width: 120px;\n  height: 120px;\n  position: absolute;\n  left: 0; right: 0; margin: 0 auto;\n  top: 0;\n  z-index: 20;\n  border: 3px solid rgba(255,255,255,.5);\n  border-radius: 12px;\n  background: url(',') no-repeat, rgba(0,0,0,1);\n  background-position: 45% center;\n  pointer-events: none;\n  \n  @keyframes move {\n    0% {\n      transform: translate3d(0,0,0);\n    }\n    25% {\n      transform: translate3d(-10px,0,0);\n    }\n    50% {\n      transform: translate3d(10px,0,0);\n    }\n    75% {\n      transform: translate3d(0,0,0);\n    }\n  }\n\n  animation: move 1s 1s ease-in-out;\n']);function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var StyledHorizontalSwipe=__WEBPACK_IMPORTED_MODULE_1_styled_components__["b" /* default */].div(_templateObject,__WEBPACK_IMPORTED_MODULE_2__images_instore_icons_horizontalswipe_svg___default.a);var HorizontalSwipe=function(_Component){_inherits(HorizontalSwipe,_Component);function HorizontalSwipe(props){_classCallCheck(this,HorizontalSwipe);var _this=_possibleConstructorReturn(this,(HorizontalSwipe.__proto__||Object.getPrototypeOf(HorizontalSwipe)).call(this,props));_this.render=function(){return _jsx(__WEBPACK_IMPORTED_MODULE_3_react_addons_css_transition_group___default.a,{transitionName:'swipeGesture',transitionAppear:true,transitionEnter:true,transitionLeave:true,transitionAppearTimeout:3000,transitionLeaveTimeout:3000,transitionEnterTimeout:3000},void 0,_this.state.visible?_jsx(StyledHorizontalSwipe,{},'swipeicon'):null);};_this.state={visible:false};return _this;}_createClass(HorizontalSwipe,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;setTimeout(function(){_this2.setState({visible:true});},200);setTimeout(function(){_this2.setState({visible:false});},2200);}}]);return HorizontalSwipe;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (HorizontalSwipe);

/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/horizontalswipe.202ec80b.svg";

/***/ }),
/* 194 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_addons_css_transition_group__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_addons_css_transition_group___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_addons_css_transition_group__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MediaQueries__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_polyglot__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_polyglot___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_polyglot__);
var _jsx=function(){var REACT_ELEMENT_TYPE=typeof Symbol==="function"&&Symbol.for&&Symbol.for("react.element")||0xeac7;return function createRawReactElement(type,props,key,children){var defaultProps=type&&type.defaultProps;var childrenLength=arguments.length-3;if(!props&&childrenLength!==0){props={};}if(props&&defaultProps){for(var propName in defaultProps){if(props[propName]===void 0){props[propName]=defaultProps[propName];}}}else if(!props){props=defaultProps||{};}if(childrenLength===1){props.children=children;}else if(childrenLength>1){var childArray=Array(childrenLength);for(var i=0;i<childrenLength;i++){childArray[i]=arguments[i+3];}props.children=childArray;}return{$$typeof:REACT_ELEMENT_TYPE,type:type,key:key===undefined?null:''+key,ref:null,props:props,_owner:null};};}();var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n  position: absolute;\n  padding: 10px;\n  top: ',';\n  right: 30px;\n  z-index: 1;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  ','\n  cursor: pointer;\n  border-radius: 4px;\n  width: 140px;\n  height: 44px;\n  background-color: ',';\n  border: 1px solid rgba(255, 255, 255, 0.12);\n  color: white;\n  text-align: center;\n  font-size: 14px;\n  font-weight: 500;\n  text-transform: capitalize;\n'],['\n  position: absolute;\n  padding: 10px;\n  top: ',';\n  right: 30px;\n  z-index: 1;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  ','\n  cursor: pointer;\n  border-radius: 4px;\n  width: 140px;\n  height: 44px;\n  background-color: ',';\n  border: 1px solid rgba(255, 255, 255, 0.12);\n  color: white;\n  text-align: center;\n  font-size: 14px;\n  font-weight: 500;\n  text-transform: capitalize;\n']),_templateObject2=_taggedTemplateLiteral(['\n    flex-direction: column;\n    top: 60px;\n    justify-content: center;\n    z-index: 5;\n  '],['\n    flex-direction: column;\n    top: 60px;\n    justify-content: center;\n    z-index: 5;\n  ']),_templateObject3=_taggedTemplateLiteral(['\n  position: absolute;\n  width: 140px;\n  height: 45vh;\n  overflow: auto;\n  top: ',';\n  right: 30px;\n  z-index: 1;\n  ','\n  ul, li {\n    list-style: none;\n  }\n  ul {\n    display: flex;\n    flex-direction: column;\n    transition: transform 0.25s ease-in, opacity 0.25s ease-in;\n    ','\n    li {\n      ','\n    }\n  }\n'],['\n  position: absolute;\n  width: 140px;\n  height: 45vh;\n  overflow: auto;\n  top: ',';\n  right: 30px;\n  z-index: 1;\n  ','\n  ul, li {\n    list-style: none;\n  }\n  ul {\n    display: flex;\n    flex-direction: column;\n    transition: transform 0.25s ease-in, opacity 0.25s ease-in;\n    ','\n    li {\n      ','\n    }\n  }\n']),_templateObject4=_taggedTemplateLiteral(['\n    top: 105px;\n    z-index: 5;\n  '],['\n    top: 105px;\n    z-index: 5;\n  ']),_templateObject5=_taggedTemplateLiteral(['\n      opacity: 1;\n      transform: translate3d(0, -20px, 0);\n      margin-top: 20px;\n    '],['\n      opacity: 1;\n      transform: translate3d(0, -20px, 0);\n      margin-top: 20px;\n    ']),_templateObject6=_taggedTemplateLiteral(['\n        width: 100%;\n        height: 32px;\n        font-size: 10px;\n      '],['\n        width: 100%;\n        height: 32px;\n        font-size: 10px;\n      ']),_templateObject7=_taggedTemplateLiteral(['\n  cursor: pointer;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 140px;\n  height: 44px;\n  background-color: ',';\n  border: 1px solid rgba(255, 255, 255, 0.12);\n  color: white;\n  text-align: center;\n  font-size: 12px;\n  font-weight: ',';\n  text-transform: capitalize;\n  &:first-child {\n    border-top-left-radius: 4px;\n    border-top-right-radius: 4px;\n  }\n  &:last-child {\n    border-bottom-left-radius: 4px;\n    border-bottom-right-radius: 4px;\n  }\n'],['\n  cursor: pointer;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 140px;\n  height: 44px;\n  background-color: ',';\n  border: 1px solid rgba(255, 255, 255, 0.12);\n  color: white;\n  text-align: center;\n  font-size: 12px;\n  font-weight: ',';\n  text-transform: capitalize;\n  &:first-child {\n    border-top-left-radius: 4px;\n    border-top-right-radius: 4px;\n  }\n  &:last-child {\n    border-bottom-left-radius: 4px;\n    border-bottom-right-radius: 4px;\n  }\n']),_templateObject8=_taggedTemplateLiteral(['\n  position: absolute;\n  top: ',';\n  right: 20px;\n  width: 20px;\n  height: 20px;\n  border-radius: 10px;\n  background-color: red;\n  color: white;\n  font-size: 15px;\n  text-align: center;\n  z-index: 10;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  ','\n'],['\n  position: absolute;\n  top: ',';\n  right: 20px;\n  width: 20px;\n  height: 20px;\n  border-radius: 10px;\n  background-color: red;\n  color: white;\n  font-size: 15px;\n  text-align: center;\n  z-index: 10;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  ','\n']),_templateObject9=_taggedTemplateLiteral(['\n    top: 55px;\n  '],['\n    top: 55px;\n  ']);function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var MainButton=__WEBPACK_IMPORTED_MODULE_2_styled_components__["b" /* default */].div(_templateObject,function(props){return props.priceGroupsDisplayed?'172px':'120px';},__WEBPACK_IMPORTED_MODULE_3__MediaQueries__["a" /* default */].phone(_templateObject2),function(props){return props.opened?'rgba(30,144,255,0.30)':'rgba(0,0,0,0.30)';});var FilterButtonsContainer=__WEBPACK_IMPORTED_MODULE_2_styled_components__["b" /* default */].div(_templateObject3,function(props){return props.priceGroupsDisplayed?'224px':'172px';},__WEBPACK_IMPORTED_MODULE_3__MediaQueries__["a" /* default */].phone(_templateObject4),__WEBPACK_IMPORTED_MODULE_3__MediaQueries__["a" /* default */].phone(_templateObject5),__WEBPACK_IMPORTED_MODULE_3__MediaQueries__["a" /* default */].phone(_templateObject6));var StyledLi=__WEBPACK_IMPORTED_MODULE_2_styled_components__["b" /* default */].li(_templateObject7,function(props){return props.active?'rgba(30,144,255,0.30)':'rgba(0,0,0,0.30)';},function(props){return props.active?800:500;});var Budget=__WEBPACK_IMPORTED_MODULE_2_styled_components__["b" /* default */].div(_templateObject8,function(props){return props.priceGroupsDisplayed?'167px':'115px';},__WEBPACK_IMPORTED_MODULE_3__MediaQueries__["a" /* default */].phone(_templateObject9));var ProductFilters=function(_React$Component){_inherits(ProductFilters,_React$Component);function ProductFilters(props){_classCallCheck(this,ProductFilters);var _this=_possibleConstructorReturn(this,(ProductFilters.__proto__||Object.getPrototypeOf(ProductFilters)).call(this,props));_this.openFiltersHandler=function(){var opened=_this.state.opened;_this.setState({opened:!opened});};_this.selectFilterHandler=function(filter,inRequestProperty){var filtersSelected=_this.state.filtersSelected;var _this$props=_this.props,toggleFilter=_this$props.toggleFilter,options=_this$props.options,triggerCallback=_this$props.triggerCallback;var newFilters=filtersSelected.slice(0);var filterSelected=false;if(options.type==='radio'){// It can be only one option selected
// se we need to deselect all the previous filters
if(newFilters.indexOf(filter)>=0){filterSelected=false;}else{filterSelected=true;}var _iteratorNormalCompletion=true;var _didIteratorError=false;var _iteratorError=undefined;try{for(var _iterator=filtersSelected[Symbol.iterator](),_step;!(_iteratorNormalCompletion=(_step=_iterator.next()).done);_iteratorNormalCompletion=true){var previousFilter=_step.value;toggleFilter(previousFilter,0,[],false,false,null,inRequestProperty,false);}}catch(err){_didIteratorError=true;_iteratorError=err;}finally{try{if(!_iteratorNormalCompletion&&_iterator.return){_iterator.return();}}finally{if(_didIteratorError){throw _iteratorError;}}}newFilters=[];if(filterSelected){newFilters.push(filter);}}else{if(newFilters.indexOf(filter)>=0){newFilters.splice(newFilters.indexOf(filter),1);}else{newFilters.push(filter);filterSelected=true;}}_this.setState({filtersSelected:newFilters},function(){toggleFilter(filter,filterSelected?1:0,[],false,false,null,inRequestProperty,true);});triggerCallback({callback:'changeFilter',payload:filter});};var productFilters=props.options.filters.filter(function(filter){return filter.inRequestProperty?props.filters[filter.inRequestProperty]&&props.filters[filter.inRequestProperty][filter.attribute]:props.filters[filter.attribute];});_this.state={opened:false,filtersSelected:productFilters.map(function(filter){return filter.attribute;})};return _this;}_createClass(ProductFilters,[{key:'render',value:function render(){var _this2=this;var _state=this.state,opened=_state.opened,filtersSelected=_state.filtersSelected;var _props=this.props,options=_props.options,t=_props.t,configOptions=_props.configOptions;return _jsx('div',{},void 0,_jsx(MainButton,{className:'revieve-filter-products-button',opened:opened,priceGroupsDisplayed:configOptions.results.priceGroups?true:false,onClick:this.openFiltersHandler},void 0,options.label?options.label:'Filter products'),filtersSelected.length>0&&_jsx(Budget,{className:'revieve-filter-products-budget',priceGroupsDisplayed:configOptions.results.priceGroups?true:false},void 0,filtersSelected.length>9?'+':filtersSelected.length),_jsx(__WEBPACK_IMPORTED_MODULE_1_react_addons_css_transition_group___default.a,{transitionName:'rightSide',transitionAppear:true,transitionEnter:true,transitionLeave:true,transitionAppearTimeout:900,transitionLeaveTimeout:900,transitionEnterTimeout:900},void 0,opened&&_jsx(FilterButtonsContainer,{className:'revieve-filter-products-options',priceGroupsDisplayed:configOptions.results.priceGroups?true:false},void 0,_jsx('ul',{},void 0,options.filters&&options.filters.map(function(filter,i){if(filter.type==='subheading'){return _jsx(StyledLi,{style:{backgroundColor:'rgba(0,0,0,0.5)',cursor:'auto',textTransform:'uppercase'}},i,filter.label);}else{var active=false;if(filtersSelected.indexOf(filter.attribute)>=0){active=true;}return _jsx(StyledLi,{className:active?'revieve-filter-products-option-active':null,active:active,onClick:function onClick(){return _this2.selectFilterHandler(filter.attribute,filter.inRequestProperty);}},i,' ',t(filter.label),' ');}})))));}}]);return ProductFilters;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4_react_polyglot__["translate"])()(ProductFilters));

/***/ }),
/* 195 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MediaQueries__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_addons_css_transition_group__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_addons_css_transition_group___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_addons_css_transition_group__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_polyglot__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_polyglot___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_polyglot__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shareModules_csvDownload__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__images_instore_icons_share_svg__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__images_instore_icons_share_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__images_instore_icons_share_svg__);
var _jsx=function(){var REACT_ELEMENT_TYPE=typeof Symbol==="function"&&Symbol.for&&Symbol.for("react.element")||0xeac7;return function createRawReactElement(type,props,key,children){var defaultProps=type&&type.defaultProps;var childrenLength=arguments.length-3;if(!props&&childrenLength!==0){props={};}if(props&&defaultProps){for(var propName in defaultProps){if(props[propName]===void 0){props[propName]=defaultProps[propName];}}}else if(!props){props=defaultProps||{};}if(childrenLength===1){props.children=children;}else if(childrenLength>1){var childArray=Array(childrenLength);for(var i=0;i<childrenLength;i++){childArray[i]=arguments[i+3];}props.children=childArray;}return{$$typeof:REACT_ELEMENT_TYPE,type:type,key:key===undefined?null:''+key,ref:null,props:props,_owner:null};};}();var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n  cursor: pointer;\n  width: 140px;\n  height: 44px;\n  background-color: rgba(0, 0, 0, 0.3);\n  border: 1px solid rgba(255, 255, 255, 0.12);\n  border-radius: 4px;\n  color: white;\n  font-size: 14px;\n  font-weight: 500;\n  transition: background-color 0.35s ease-in;\n  left: 30px;\n  z-index: 1;\n  &:active {\n    background-color: rgba(30, 144, 255, 0.3);\n  }\n  position: absolute;\n  bottom: 160px;\n  ','\n\n  .shareIcon {\n    width: 50%;\n    height: 26px;\n    float: left;\n    background-image: url(',');\n    background-size: contain;\n    background-repeat: no-repeat;\n    background-position: center center;\n    ','\n  }\n  .shareText {\n    float: right;\n    width: 50%;\n    text-align: left;\n    line-height: 26px;\n    ','\n  }\n'],['\n  cursor: pointer;\n  width: 140px;\n  height: 44px;\n  background-color: rgba(0, 0, 0, 0.3);\n  border: 1px solid rgba(255, 255, 255, 0.12);\n  border-radius: 4px;\n  color: white;\n  font-size: 14px;\n  font-weight: 500;\n  transition: background-color 0.35s ease-in;\n  left: 30px;\n  z-index: 1;\n  &:active {\n    background-color: rgba(30, 144, 255, 0.3);\n  }\n  position: absolute;\n  bottom: 160px;\n  ','\n\n  .shareIcon {\n    width: 50%;\n    height: 26px;\n    float: left;\n    background-image: url(',');\n    background-size: contain;\n    background-repeat: no-repeat;\n    background-position: center center;\n    ','\n  }\n  .shareText {\n    float: right;\n    width: 50%;\n    text-align: left;\n    line-height: 26px;\n    ','\n  }\n']),_templateObject2=_taggedTemplateLiteral(['\n    top: 60px;\n    width: 50px;\n  '],['\n    top: 60px;\n    width: 50px;\n  ']),_templateObject3=_taggedTemplateLiteral(['\n      width: 100%;\n    '],['\n      width: 100%;\n    ']),_templateObject4=_taggedTemplateLiteral(['\n      display:none;\n    '],['\n      display:none;\n    ']),_templateObject5=_taggedTemplateLiteral(['\n  font-size: 12px;\n  width: 50%;\n  background-color: rgba(0, 0, 0, 0.5);\n  padding: 20px;\n  border-radius: 8px;\n  position: absolute;\n  left: 25%;\n  bottom: 160px;\n  color: white;\n  ','\n\n  h1 {\n    font-size: 14px;\n    margin-bottom: 8px;\n  }\n\n  li {\n    list-style-type: none;\n  }\n\n  .closeModal {\n    float: right;\n    cursor: pointer;\n    font-weight: bolder;\n  }\n\n  .moduleLink {\n    cursor: pointer;\n    font-size: 14px;\n  }\n'],['\n  font-size: 12px;\n  width: 50%;\n  background-color: rgba(0, 0, 0, 0.5);\n  padding: 20px;\n  border-radius: 8px;\n  position: absolute;\n  left: 25%;\n  bottom: 160px;\n  color: white;\n  ','\n\n  h1 {\n    font-size: 14px;\n    margin-bottom: 8px;\n  }\n\n  li {\n    list-style-type: none;\n  }\n\n  .closeModal {\n    float: right;\n    cursor: pointer;\n    font-weight: bolder;\n  }\n\n  .moduleLink {\n    cursor: pointer;\n    font-size: 14px;\n  }\n']),_templateObject6=_taggedTemplateLiteral(['\n    width: 80%;\n    left: 10%;\n    top: 120px;\n    bottom: auto;\n    padding: 10px;\n  '],['\n    width: 80%;\n    left: 10%;\n    top: 120px;\n    bottom: auto;\n    padding: 10px;\n  ']);function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var StyledShareButton=__WEBPACK_IMPORTED_MODULE_1_styled_components__["b" /* default */].button(_templateObject,__WEBPACK_IMPORTED_MODULE_2__MediaQueries__["a" /* default */].phone(_templateObject2),__WEBPACK_IMPORTED_MODULE_6__images_instore_icons_share_svg___default.a,__WEBPACK_IMPORTED_MODULE_2__MediaQueries__["a" /* default */].phone(_templateObject3),__WEBPACK_IMPORTED_MODULE_2__MediaQueries__["a" /* default */].phone(_templateObject4));var StyledModulesModal=__WEBPACK_IMPORTED_MODULE_1_styled_components__["b" /* default */].div(_templateObject5,__WEBPACK_IMPORTED_MODULE_2__MediaQueries__["a" /* default */].phone(_templateObject6));var shareModules={isw_cvsDownload:__WEBPACK_IMPORTED_MODULE_5__shareModules_csvDownload__["a" /* default */]};var ShareButton=function(_Component){_inherits(ShareButton,_Component);function ShareButton(props){_classCallCheck(this,ShareButton);var _this=_possibleConstructorReturn(this,(ShareButton.__proto__||Object.getPrototypeOf(ShareButton)).call(this,props));_this.executeModule=function(module){var cvResults=_this.props.cvResults;shareModules[module](cvResults);};_this.state={showModules:false};return _this;}_createClass(ShareButton,[{key:'render',value:function render(){var _this2=this;var showModules=this.state.showModules;var _props=this.props,options=_props.options,t=_props.t;return _jsx('div',{},void 0,_jsx(__WEBPACK_IMPORTED_MODULE_3_react_addons_css_transition_group___default.a,{transitionName:'footerSlide',transitionAppear:true,transitionEnter:true,transitionLeave:true,transitionAppearTimeout:900,transitionLeaveTimeout:900,transitionEnterTimeout:900},void 0,showModules&&_jsx(StyledModulesModal,{className:'revieve-modules-modal'},void 0,_jsx('div',{className:'closeModal',onClick:function onClick(e){e.stopPropagation();_this2.setState({showModules:false});}},void 0,' ','X',' '),options.modules&&options.modules.map(function(module,i){return _jsx('div',{className:'moduleLink',onClick:function onClick(){return _this2.executeModule(module.name);}},'shareModule'+i,t(module.text));}))),_jsx(StyledShareButton,{onClick:function onClick(){_this2.setState({showModules:!showModules});}},void 0,_jsx('div',{className:'shareIcon'}),_jsx('div',{className:'shareText'},void 0,this.props.options.title)));}}]);return ShareButton;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4_react_polyglot__["translate"])()(ShareButton));

/***/ }),
/* 196 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = csvDownload;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shared_dataConversion__ = __webpack_require__(197);
function csvDownload(cvResults){var dataJson=[];//warnings
var warnings=[];if(cvResults.status){warnings=cvResults.status.map(function(warning){return warning.description;});}dataJson.push({element:'Warnings',value:'\''+warnings+'\''});//findings
if(cvResults.results){cvResults.results.map(function(result){if(result.description==='Makeup'){return null;}dataJson.push({element:result.description+' overall value',value:result.value});result.measurement_locations.map(function(location){return dataJson.push({element:result.description+' '+location.description,value:location.value});});return null;});}var dataStr='data:text/csv;charset=utf-8,'+Object(__WEBPACK_IMPORTED_MODULE_0__shared_dataConversion__["a" /* converJsonToCsv */])(dataJson);var downloadAnchorNode=document.createElement('a');downloadAnchorNode.setAttribute('href',encodeURI(dataStr));downloadAnchorNode.setAttribute('target','_blank');downloadAnchorNode.setAttribute('download','revieveData.csv');document.body.appendChild(downloadAnchorNode);// required for firefox
downloadAnchorNode.click();downloadAnchorNode.remove();}

/***/ }),
/* 197 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = converJsonToCsv;
function converJsonToCsv(jsonArray){var replacer=function replacer(key,value){return value===null?'':value;};var header=Object.keys(jsonArray[0]);var csv=jsonArray.map(function(row){return header.map(function(fieldName){return JSON.stringify(row[fieldName],replacer);}).join(',');});csv.unshift(header.join(','));csv=csv.join('\r\n');return csv;}

/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/share.bca00c12.svg";

/***/ }),
/* 199 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MediaQueries__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_polyglot__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_polyglot___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_polyglot__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_addons_css_transition_group__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_addons_css_transition_group___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_addons_css_transition_group__);
var _jsx=function(){var REACT_ELEMENT_TYPE=typeof Symbol==="function"&&Symbol.for&&Symbol.for("react.element")||0xeac7;return function createRawReactElement(type,props,key,children){var defaultProps=type&&type.defaultProps;var childrenLength=arguments.length-3;if(!props&&childrenLength!==0){props={};}if(props&&defaultProps){for(var propName in defaultProps){if(props[propName]===void 0){props[propName]=defaultProps[propName];}}}else if(!props){props=defaultProps||{};}if(childrenLength===1){props.children=children;}else if(childrenLength>1){var childArray=Array(childrenLength);for(var i=0;i<childrenLength;i++){childArray[i]=arguments[i+3];}props.children=childArray;}return{$$typeof:REACT_ELEMENT_TYPE,type:type,key:key===undefined?null:''+key,ref:null,props:props,_owner:null};};}();var _templateObject=_taggedTemplateLiteral(['\n  color: white;\n  background-color: red;\n  width: 40px;\n  height: 40px;\n  border-radius: 30px;\n  font-size: 18px;\n  font-weight: bold;\n  text-align: center;\n  position: fixed;\n  bottom: 100px;\n  left: -15px;\n  line-height: 40px;\n  cursor: pointer;\n'],['\n  color: white;\n  background-color: red;\n  width: 40px;\n  height: 40px;\n  border-radius: 30px;\n  font-size: 18px;\n  font-weight: bold;\n  text-align: center;\n  position: fixed;\n  bottom: 100px;\n  left: -15px;\n  line-height: 40px;\n  cursor: pointer;\n']),_templateObject2=_taggedTemplateLiteral(['\n  font-size: 14px;\n  width: 60%;\n  background-color: rgba(0, 0, 0, 0.5);\n  padding: 20px;\n  border-radius: 8px;\n  position: absolute;\n  left: 20%;\n  bottom: 147px;\n  color: white;\n  max-height: 344px;\n  overflow: auto;\n\n  ','\n\n  h1 {\n    font-size: 18px;\n    margin-bottom: 20px;\n    ','\n  }\n\n  li {\n    margin-left: 18px;\n  }\n\n  .closeModal {\n    float: right;\n    cursor: pointer;\n    font-weight: bolder;\n    position: absolute;\n    top: 20px;\n    right: 20px;\n    text-align: right;\n    width: 50px;\n    height: 50px;\n  }\n\n  .warningText {\n    margin-bottom: 10px;\n  }\n'],['\n  font-size: 14px;\n  width: 60%;\n  background-color: rgba(0, 0, 0, 0.5);\n  padding: 20px;\n  border-radius: 8px;\n  position: absolute;\n  left: 20%;\n  bottom: 147px;\n  color: white;\n  max-height: 344px;\n  overflow: auto;\n\n  ','\n\n  h1 {\n    font-size: 18px;\n    margin-bottom: 20px;\n    ','\n  }\n\n  li {\n    margin-left: 18px;\n  }\n\n  .closeModal {\n    float: right;\n    cursor: pointer;\n    font-weight: bolder;\n    position: absolute;\n    top: 20px;\n    right: 20px;\n    text-align: right;\n    width: 50px;\n    height: 50px;\n  }\n\n  .warningText {\n    margin-bottom: 10px;\n  }\n']),_templateObject3=_taggedTemplateLiteral(['\n    width: 90%;\n    left: 6%;\n    bottom: 145px;\n    padding: 40px 20px;\n    font-size: 12px;\n    border-radius: 20px 20px 20px 0px;\n  '],['\n    width: 90%;\n    left: 6%;\n    bottom: 145px;\n    padding: 40px 20px;\n    font-size: 12px;\n    border-radius: 20px 20px 20px 0px;\n  ']),_templateObject4=_taggedTemplateLiteral(['\n      font-size: 14px;\n    '],['\n      font-size: 14px;\n    ']);function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var StyledSkinAnalysisWarningsBudget=__WEBPACK_IMPORTED_MODULE_1_styled_components__["b" /* default */].div(_templateObject);var StyledWarningsModal=__WEBPACK_IMPORTED_MODULE_1_styled_components__["b" /* default */].div(_templateObject2,__WEBPACK_IMPORTED_MODULE_2__MediaQueries__["a" /* default */].phone(_templateObject3),__WEBPACK_IMPORTED_MODULE_2__MediaQueries__["a" /* default */].phone(_templateObject4));var SkinAnalysisWarningsWidget=function(_Component){_inherits(SkinAnalysisWarningsWidget,_Component);function SkinAnalysisWarningsWidget(props){_classCallCheck(this,SkinAnalysisWarningsWidget);var _this=_possibleConstructorReturn(this,(SkinAnalysisWarningsWidget.__proto__||Object.getPrototypeOf(SkinAnalysisWarningsWidget)).call(this,props));_this.render=function(){var _this$props=_this.props,cvResults=_this$props.cvResults,t=_this$props.t;var showWarnings=_this.state.showWarnings;return _jsx('div',{},void 0,cvResults&&cvResults.status&&cvResults.status.length>0&&_jsx(__WEBPACK_IMPORTED_MODULE_4_react_addons_css_transition_group___default.a,{transitionName:'footerSlide',transitionAppear:true,transitionEnter:true,transitionLeave:true,transitionAppearTimeout:900,transitionLeaveTimeout:900,transitionEnterTimeout:900},void 0,showWarnings&&_jsx(StyledWarningsModal,{className:'revieve-selfie-warnings-modal'},void 0,_jsx('h1',{},void 0,t('CV_MESSAGE_Warning_heading')),_jsx('div',{className:'warningText'},void 0,t('CV_MESSAGE_Warning')),_jsx('div',{className:'closeModal',onClick:function onClick(e){e.stopPropagation();_this.setState({showWarnings:false});}},void 0,'X'),_jsx('ul',{},void 0,cvResults.status.map(function(warning,i){return _jsx('li',{className:'warningText'},'warning'+i,t('CV_CODE_'+warning.idx));})))),cvResults&&cvResults.status&&cvResults.status.length>0&&_jsx(StyledSkinAnalysisWarningsBudget,{className:'revieve-selfie-warnings-budget',onClick:function onClick(){_this.setState({showWarnings:!showWarnings});}},void 0,'!'));};_this.state={showWarnings:true};return _this;}return SkinAnalysisWarningsWidget;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_polyglot__["translate"])()(SkinAnalysisWarningsWidget));

/***/ }),
/* 200 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__LiveAR__ = __webpack_require__(201);
/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__LiveAR__["a" /* default */]);

/***/ }),
/* 201 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__style_js__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__images_instore_loading_gif__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__images_instore_loading_gif___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__images_instore_loading_gif__);
var _jsx=function(){var REACT_ELEMENT_TYPE=typeof Symbol==="function"&&Symbol.for&&Symbol.for("react.element")||0xeac7;return function createRawReactElement(type,props,key,children){var defaultProps=type&&type.defaultProps;var childrenLength=arguments.length-3;if(!props&&childrenLength!==0){props={};}if(props&&defaultProps){for(var propName in defaultProps){if(props[propName]===void 0){props[propName]=defaultProps[propName];}}}else if(!props){props=defaultProps||{};}if(childrenLength===1){props.children=children;}else if(childrenLength>1){var childArray=Array(childrenLength);for(var i=0;i<childrenLength;i++){childArray[i]=arguments[i+3];}props.children=childArray;}return{$$typeof:REACT_ELEMENT_TYPE,type:type,key:key===undefined?null:''+key,ref:null,props:props,_owner:null};};}();var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var LiveAR=function LiveAR(props){var _useState=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState2=_slicedToArray(_useState,2),liveARModuleLoaded=_useState2[0],setLiveARModuleLoaded=_useState2[1];Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){var sdk=props.sdk;if(!sdk.liveAR.mounted){sdk.liveAR.initialize({renderToSelector:'#liveARContainer',eventHandler:liveAREventHandler});}return function(){sdk.liveAR.release();};},[]);var liveAREventHandler=function liveAREventHandler(_ref){var type=_ref.type,state=_ref.state;if(type==='statusChanged'&&state==='renderingEffects'){setLiveARModuleLoaded(true);}};return _jsx(__WEBPACK_IMPORTED_MODULE_2__style_js__["a" /* default */].container,{},void 0,!liveARModuleLoaded&&_jsx(__WEBPACK_IMPORTED_MODULE_2__style_js__["a" /* default */].loading,{},void 0,_jsx(__WEBPACK_IMPORTED_MODULE_2__style_js__["a" /* default */].image,{src:__WEBPACK_IMPORTED_MODULE_3__images_instore_loading_gif___default.a,alt:'loading'}),_jsx('br',{}),'Starting Virtual Tryon'),_jsx(__WEBPACK_IMPORTED_MODULE_2__style_js__["a" /* default */].canvas,{id:'liveARContainer'}));};LiveAR.propTypes={sdk:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired};/* harmony default export */ __webpack_exports__["a"] = (LiveAR);

/***/ }),
/* 202 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(1);
var _templateObject=_taggedTemplateLiteral(['\n  overflow: hidden;\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: -2;\n'],['\n  overflow: hidden;\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: -2;\n']),_templateObject2=_taggedTemplateLiteral(['\n  overflow: hidden;\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n'],['\n  overflow: hidden;\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n']),_templateObject3=_taggedTemplateLiteral(['\n  overflow: hidden;\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  font-size: 20px;\n  color: darkgray;\n  text-align: center;\n  padding: 30%;\n'],['\n  overflow: hidden;\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  font-size: 20px;\n  color: darkgray;\n  text-align: center;\n  padding: 30%;\n']),_templateObject4=_taggedTemplateLiteral(['\n  width: 30%;\n  min-width: 100px;\n'],['\n  width: 30%;\n  min-width: 100px;\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var container=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* default */].div(_templateObject);var canvas=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* default */].div(_templateObject2);var loading=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* default */].div(_templateObject3);var image=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* default */].img(_templateObject4);/* harmony default export */ __webpack_exports__["a"] = ({container:container,canvas:canvas,loading:loading,image:image});

/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/loading.be0d9fd5.gif";

/***/ }),
/* 204 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MediaQueries__ = __webpack_require__(3);
var _jsx=function(){var REACT_ELEMENT_TYPE=typeof Symbol==="function"&&Symbol.for&&Symbol.for("react.element")||0xeac7;return function createRawReactElement(type,props,key,children){var defaultProps=type&&type.defaultProps;var childrenLength=arguments.length-3;if(!props&&childrenLength!==0){props={};}if(props&&defaultProps){for(var propName in defaultProps){if(props[propName]===void 0){props[propName]=defaultProps[propName];}}}else if(!props){props=defaultProps||{};}if(childrenLength===1){props.children=children;}else if(childrenLength>1){var childArray=Array(childrenLength);for(var i=0;i<childrenLength;i++){childArray[i]=arguments[i+3];}props.children=childArray;}return{$$typeof:REACT_ELEMENT_TYPE,type:type,key:key===undefined?null:''+key,ref:null,props:props,_owner:null};};}();var _templateObject=_taggedTemplateLiteral(['\n  width: 100%;\n  max-width: 60%;\n  display: flex;\n  flex-direction: column;\n  cursor: pointer;\n  position: absolute;\n  bottom: 0;\n  z-index: 10;\n  font-size: 14px;\n  ','\n'],['\n  width: 100%;\n  max-width: 60%;\n  display: flex;\n  flex-direction: column;\n  cursor: pointer;\n  position: absolute;\n  bottom: 0;\n  z-index: 10;\n  font-size: 14px;\n  ','\n']),_templateObject2=_taggedTemplateLiteral(['\n    max-width: 100%;\n  '],['\n    max-width: 100%;\n  ']),_templateObject3=_taggedTemplateLiteral(['\n  display: flex;\n  align-items: stretch;\n'],['\n  display: flex;\n  align-items: stretch;\n']),_templateObject4=_taggedTemplateLiteral(['\n  flex: 1;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 50px;\n  background-color: white;\n  color: black;\n  &:hover {\n    background-color: darkgray;\n    color: white;\n  }\n  .active {\n    background-color: black;\n    color: white;\n  }\n  transition: all 300ms ease-in-out;\n'],['\n  flex: 1;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 50px;\n  background-color: white;\n  color: black;\n  &:hover {\n    background-color: darkgray;\n    color: white;\n  }\n  .active {\n    background-color: black;\n    color: white;\n  }\n  transition: all 300ms ease-in-out;\n']),_templateObject5=_taggedTemplateLiteral(['\n  flex: 1;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 50px;\n  background-color: black;\n  color: white;\n  &:hover {\n    background-color: darkgray;\n  }\n  &:active {\n    background-color: darkgray;\n  }\n  transition: all 300ms ease-in-out;\n'],['\n  flex: 1;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 50px;\n  background-color: black;\n  color: white;\n  &:hover {\n    background-color: darkgray;\n  }\n  &:active {\n    background-color: darkgray;\n  }\n  transition: all 300ms ease-in-out;\n']),_templateObject6=_taggedTemplateLiteral(['\n  min-height: 50px;\n  font-size: 10px;\n  padding: 5px;\n  background-color: white;\n  ul li {\n    list-style: none;\n  }\n'],['\n  min-height: 50px;\n  font-size: 10px;\n  padding: 5px;\n  background-color: white;\n  ul li {\n    list-style: none;\n  }\n']),_templateObject7=_taggedTemplateLiteral(['\n  background-color: black;\n  color: white;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 50px;\n  font-size: 14px;\n  &:hover {\n    background-color: darkgray;\n  }\n  transition: all 300ms ease-in-out;\n  ','\n'],['\n  background-color: black;\n  color: white;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 50px;\n  font-size: 14px;\n  &:hover {\n    background-color: darkgray;\n  }\n  transition: all 300ms ease-in-out;\n  ','\n']);function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var ActionsWrapper=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["b" /* default */])('div')(_templateObject,__WEBPACK_IMPORTED_MODULE_2__MediaQueries__["a" /* default */].phone(_templateObject2));var Actions=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["b" /* default */])('div')(_templateObject3);var Action=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["b" /* default */])('div')(_templateObject4);var MainAction=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["b" /* default */])('div')(_templateObject5);var AdditionInfo=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["b" /* default */])('div')(_templateObject6);var BackButton=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["b" /* default */])('div')(_templateObject7,__WEBPACK_IMPORTED_MODULE_2__MediaQueries__["a" /* default */].phone(_templateObject2));var ActionsWidget=function(_Component){_inherits(ActionsWidget,_Component);function ActionsWidget(props){_classCallCheck(this,ActionsWidget);var _this=_possibleConstructorReturn(this,(ActionsWidget.__proto__||Object.getPrototypeOf(ActionsWidget)).call(this,props));_this.handleOnClick=function(_ref){var _ref$method=_ref.method,sdkMethod=_ref$method.sdk,module=_ref$method.module,method=_ref$method.method,parameters=_ref$method.parameters,deactivate=_ref$method.deactivate,actionIndex=_ref.actionIndex;var _this$props=_this.props,sdk=_this$props.sdk,triggerCallback=_this$props.triggerCallback,options=_this$props.options;var activeAction=_this.state.activeAction;if(!sdkMethod){_this[method]();}else{if(deactivate&&actionIndex===activeAction){try{var _sdk$deactivate$modul;(_sdk$deactivate$modul=sdk[deactivate.module])[deactivate.method].apply(_sdk$deactivate$modul,_toConsumableArray(deactivate.parameters));}catch(e){console.error('Invalid SDK method');console.log(e.message);}_this.setState({activeAction:null});}else{try{var _sdk$module;(_sdk$module=sdk[module])[method].apply(_sdk$module,_toConsumableArray(parameters));}catch(e){console.error('Invalid SDK method');console.log(e.message);}if(typeof activeAction!=='undefined')_this.setState({activeAction:actionIndex});}}if(actionIndex===undefined){triggerCallback({callback:'action',payload:options.mainAction.label});}else{triggerCallback({callback:'action',payload:options.actions[actionIndex].label});}};_this.handleProductsBack=function(){var setFooterVisible=_this.props.setFooterVisible;setFooterVisible(false);setTimeout(function(){return _this.setState({showProducts:false});},500);};_this.showProducts=function(){var setFooterVisible=_this.props.setFooterVisible;setFooterVisible(true);_this.setState({showProducts:true});};_this.handleHyperpigmentationBack=function(){var sdk=_this.props.sdk;sdk.AR.dehighlightAll();_this.setState({showHyperpigmentation:false});};_this.showHyperpigmentation=function(){var sdk=_this.props.sdk;sdk.AR.highlightHyperpigmentationIndividually();_this.setState({showHyperpigmentation:true});};_this.render=function(){var _this$props$options=_this.props.options,actions=_this$props$options.actions,mainAction=_this$props$options.mainAction,additionalInfo=_this$props$options.additionalInfo;var _this$state=_this.state,showProducts=_this$state.showProducts,showHyperpigmentation=_this$state.showHyperpigmentation,activeAction=_this$state.activeAction;return _jsx(ActionsWrapper,{className:'revieveActionsWrapper'},void 0,showProducts?_jsx(BackButton,{className:'revieveActionsBack',onClick:_this.handleProductsBack},void 0,'Back'):showHyperpigmentation?_jsx(BackButton,{className:'revieveActionsBack',onClick:_this.handleHyperpigmentationBack},void 0,'Hide hyperpigmentation spots'):_jsx('div',{},void 0,_jsx(Actions,{className:'revieveActions'},void 0,actions.map(function(action,index){return _jsx(Action,{className:'revieveAction '+(activeAction===index?'active':null),onClick:function onClick(){return _this.handleOnClick({method:action.onClick,actionIndex:index});}},'action'+index,action.label);})),mainAction&&_jsx(MainAction,{className:'revieveMainAction',onClick:function onClick(){return _this.handleOnClick({method:mainAction.onClick});}},void 0,mainAction.label)),additionalInfo&&_jsx(AdditionInfo,{className:'revieveAdditionalInfo'},void 0,_jsx('ul',{},void 0,additionalInfo.map(function(info,index){return _jsx('li',{},'additionaInfo-'+index,info);}))));};_this.state={showProducts:false,showHyperpigmentation:false,activeAction:null};props.setFooterVisible(false);return _this;}return ActionsWidget;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (ActionsWidget);

/***/ }),
/* 205 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BrowserRouter__ = __webpack_require__(206);
/* unused harmony reexport BrowserRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__HashRouter__ = __webpack_require__(212);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__HashRouter__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Link__ = __webpack_require__(51);
/* unused harmony reexport Link */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MemoryRouter__ = __webpack_require__(213);
/* unused harmony reexport MemoryRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__NavLink__ = __webpack_require__(215);
/* unused harmony reexport NavLink */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Prompt__ = __webpack_require__(217);
/* unused harmony reexport Prompt */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Redirect__ = __webpack_require__(219);
/* unused harmony reexport Redirect */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Route__ = __webpack_require__(52);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_7__Route__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Router__ = __webpack_require__(29);
/* unused harmony reexport Router */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__StaticRouter__ = __webpack_require__(221);
/* unused harmony reexport StaticRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Switch__ = __webpack_require__(223);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_10__Switch__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__generatePath__ = __webpack_require__(225);
/* unused harmony reexport generatePath */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__matchPath__ = __webpack_require__(226);
/* unused harmony reexport matchPath */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__withRouter__ = __webpack_require__(227);
/* unused harmony reexport withRouter */





























/***/ }),
/* 206 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(29);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that uses HTML5 history.
 */

var BrowserRouter = function (_React$Component) {
  _inherits(BrowserRouter, _React$Component);

  function BrowserRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, BrowserRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = Object(__WEBPACK_IMPORTED_MODULE_3_history__["a" /* createBrowserHistory */])(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  BrowserRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, "<BrowserRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { BrowserRouter as Router }`.");
  };

  BrowserRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return BrowserRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

BrowserRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  forceRefresh: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  keyLength: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};


/* unused harmony default export */ var _unused_webpack_default_export = (BrowserRouter);

/***/ }),
/* 207 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _extends;
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

/***/ }),
/* 208 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function isAbsolute(pathname) {
  return pathname.charAt(0) === '/';
}

// About 1.5x faster than the two-arg version of Array#splice()
function spliceOne(list, index) {
  for (var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1) {
    list[i] = list[k];
  }

  list.pop();
}

// This implementation is based heavily on node's url.parse
function resolvePathname(to) {
  var from = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

  var toParts = to && to.split('/') || [];
  var fromParts = from && from.split('/') || [];

  var isToAbs = to && isAbsolute(to);
  var isFromAbs = from && isAbsolute(from);
  var mustEndAbs = isToAbs || isFromAbs;

  if (to && isAbsolute(to)) {
    // to is absolute
    fromParts = toParts;
  } else if (toParts.length) {
    // to is relative, drop the filename
    fromParts.pop();
    fromParts = fromParts.concat(toParts);
  }

  if (!fromParts.length) return '/';

  var hasTrailingSlash = void 0;
  if (fromParts.length) {
    var last = fromParts[fromParts.length - 1];
    hasTrailingSlash = last === '.' || last === '..' || last === '';
  } else {
    hasTrailingSlash = false;
  }

  var up = 0;
  for (var i = fromParts.length; i >= 0; i--) {
    var part = fromParts[i];

    if (part === '.') {
      spliceOne(fromParts, i);
    } else if (part === '..') {
      spliceOne(fromParts, i);
      up++;
    } else if (up) {
      spliceOne(fromParts, i);
      up--;
    }
  }

  if (!mustEndAbs) for (; up--; up) {
    fromParts.unshift('..');
  }if (mustEndAbs && fromParts[0] !== '' && (!fromParts[0] || !isAbsolute(fromParts[0]))) fromParts.unshift('');

  var result = fromParts.join('/');

  if (hasTrailingSlash && result.substr(-1) !== '/') result += '/';

  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (resolvePathname);

/***/ }),
/* 209 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function valueEqual(a, b) {
  if (a === b) return true;

  if (a == null || b == null) return false;

  if (Array.isArray(a)) {
    return Array.isArray(b) && a.length === b.length && a.every(function (item, index) {
      return valueEqual(item, b[index]);
    });
  }

  var aType = typeof a === 'undefined' ? 'undefined' : _typeof(a);
  var bType = typeof b === 'undefined' ? 'undefined' : _typeof(b);

  if (aType !== bType) return false;

  if (aType === 'object') {
    var aValue = a.valueOf();
    var bValue = b.valueOf();

    if (aValue !== a || bValue !== b) return valueEqual(aValue, bValue);

    var aKeys = Object.keys(a);
    var bKeys = Object.keys(b);

    if (aKeys.length !== bKeys.length) return false;

    return aKeys.every(function (key) {
      return valueEqual(a[key], b[key]);
    });
  }

  return false;
}

/* harmony default export */ __webpack_exports__["a"] = (valueEqual);

/***/ }),
/* 210 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var isProduction = "production" === 'production';
function warning(condition, message) {
  if (!isProduction) {
    if (condition) {
      return;
    }

    var text = "Warning: " + message;

    if (typeof console !== 'undefined') {
      console.warn(text);
    }

    try {
      throw Error(text);
    } catch (x) {}
  }
}

/* unused harmony default export */ var _unused_webpack_default_export = (warning);


/***/ }),
/* 211 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var isProduction = "production" === 'production';
var prefix = 'Invariant failed';
function invariant(condition, message) {
  if (condition) {
    return;
  }

  if (isProduction) {
    throw new Error(prefix);
  } else {
    throw new Error(prefix + ": " + (message || ''));
  }
}

/* harmony default export */ __webpack_exports__["a"] = (invariant);


/***/ }),
/* 212 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(29);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that uses window.location.hash.
 */

var HashRouter = function (_React$Component) {
  _inherits(HashRouter, _React$Component);

  function HashRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, HashRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = Object(__WEBPACK_IMPORTED_MODULE_3_history__["b" /* createHashHistory */])(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  HashRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, "<HashRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { HashRouter as Router }`.");
  };

  HashRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return HashRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

HashRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  hashType: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOf(["hashbang", "noslash", "slash"]),
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};


/* harmony default export */ __webpack_exports__["a"] = (HashRouter);

/***/ }),
/* 213 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_MemoryRouter__ = __webpack_require__(214);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_MemoryRouter__["a" /* default */]);

/***/ }),
/* 214 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(30);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that stores location in memory.
 */

var MemoryRouter = function (_React$Component) {
  _inherits(MemoryRouter, _React$Component);

  function MemoryRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, MemoryRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = Object(__WEBPACK_IMPORTED_MODULE_3_history__["d" /* createMemoryHistory */])(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  MemoryRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, "<MemoryRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { MemoryRouter as Router }`.");
  };

  MemoryRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return MemoryRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

MemoryRouter.propTypes = {
  initialEntries: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,
  initialIndex: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  keyLength: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};


/* harmony default export */ __webpack_exports__["a"] = (MemoryRouter);

/***/ }),
/* 215 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Route__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Link__ = __webpack_require__(51);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






/**
 * A <Link> wrapper that knows if it's "active" or not.
 */
var NavLink = function NavLink(_ref) {
  var to = _ref.to,
      exact = _ref.exact,
      strict = _ref.strict,
      location = _ref.location,
      activeClassName = _ref.activeClassName,
      className = _ref.className,
      activeStyle = _ref.activeStyle,
      style = _ref.style,
      getIsActive = _ref.isActive,
      ariaCurrent = _ref["aria-current"],
      rest = _objectWithoutProperties(_ref, ["to", "exact", "strict", "location", "activeClassName", "className", "activeStyle", "style", "isActive", "aria-current"]);

  var path = (typeof to === "undefined" ? "undefined" : _typeof(to)) === "object" ? to.pathname : to;

  // Regex taken from: https://github.com/pillarjs/path-to-regexp/blob/master/index.js#L202
  var escapedPath = path && path.replace(/([.+*?=^!:${}()[\]|/\\])/g, "\\$1");

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Route__["a" /* default */], {
    path: escapedPath,
    exact: exact,
    strict: strict,
    location: location,
    children: function children(_ref2) {
      var location = _ref2.location,
          match = _ref2.match;

      var isActive = !!(getIsActive ? getIsActive(match, location) : match);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Link__["a" /* default */], _extends({
        to: to,
        className: isActive ? [className, activeClassName].filter(function (i) {
          return i;
        }).join(" ") : className,
        style: isActive ? _extends({}, style, activeStyle) : style,
        "aria-current": isActive && ariaCurrent || null
      }, rest));
    }
  });
};

NavLink.propTypes = {
  to: __WEBPACK_IMPORTED_MODULE_3__Link__["a" /* default */].propTypes.to,
  exact: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  strict: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  location: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  activeClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  activeStyle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  style: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  isActive: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  "aria-current": __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["page", "step", "location", "date", "time", "true"])
};

NavLink.defaultProps = {
  activeClassName: "active",
  "aria-current": "page"
};

/* unused harmony default export */ var _unused_webpack_default_export = (NavLink);

/***/ }),
/* 216 */
/***/ (function(module, exports) {

module.exports = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};


/***/ }),
/* 217 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Prompt__ = __webpack_require__(218);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Prompt__["a" /* default */]);

/***/ }),
/* 218 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_invariant__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





/**
 * The public API for prompting the user before navigating away
 * from a screen with a component.
 */

var Prompt = function (_React$Component) {
  _inherits(Prompt, _React$Component);

  function Prompt() {
    _classCallCheck(this, Prompt);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Prompt.prototype.enable = function enable(message) {
    if (this.unblock) this.unblock();

    this.unblock = this.context.router.history.block(message);
  };

  Prompt.prototype.disable = function disable() {
    if (this.unblock) {
      this.unblock();
      this.unblock = null;
    }
  };

  Prompt.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_2_invariant___default()(this.context.router, "You should not use <Prompt> outside a <Router>");

    if (this.props.when) this.enable(this.props.message);
  };

  Prompt.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (nextProps.when) {
      if (!this.props.when || this.props.message !== nextProps.message) this.enable(nextProps.message);
    } else {
      this.disable();
    }
  };

  Prompt.prototype.componentWillUnmount = function componentWillUnmount() {
    this.disable();
  };

  Prompt.prototype.render = function render() {
    return null;
  };

  return Prompt;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Prompt.propTypes = {
  when: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  message: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]).isRequired
};
Prompt.defaultProps = {
  when: true
};
Prompt.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      block: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Prompt);

/***/ }),
/* 219 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Redirect__ = __webpack_require__(220);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Redirect__["a" /* default */]);

/***/ }),
/* 220 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_history__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__generatePath__ = __webpack_require__(55);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








/**
 * The public API for updating the location programmatically
 * with a component.
 */

var Redirect = function (_React$Component) {
  _inherits(Redirect, _React$Component);

  function Redirect() {
    _classCallCheck(this, Redirect);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Redirect.prototype.isStatic = function isStatic() {
    return this.context.router && this.context.router.staticContext;
  };

  Redirect.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_3_invariant___default()(this.context.router, "You should not use <Redirect> outside a <Router>");

    if (this.isStatic()) this.perform();
  };

  Redirect.prototype.componentDidMount = function componentDidMount() {
    if (!this.isStatic()) this.perform();
  };

  Redirect.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    var prevTo = Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(prevProps.to);
    var nextTo = Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(this.props.to);

    if (Object(__WEBPACK_IMPORTED_MODULE_4_history__["f" /* locationsAreEqual */])(prevTo, nextTo)) {
      __WEBPACK_IMPORTED_MODULE_2_warning___default()(false, "You tried to redirect to the same route you're currently on: " + ("\"" + nextTo.pathname + nextTo.search + "\""));
      return;
    }

    this.perform();
  };

  Redirect.prototype.computeTo = function computeTo(_ref) {
    var computedMatch = _ref.computedMatch,
        to = _ref.to;

    if (computedMatch) {
      if (typeof to === "string") {
        return Object(__WEBPACK_IMPORTED_MODULE_5__generatePath__["a" /* default */])(to, computedMatch.params);
      } else {
        return _extends({}, to, {
          pathname: Object(__WEBPACK_IMPORTED_MODULE_5__generatePath__["a" /* default */])(to.pathname, computedMatch.params)
        });
      }
    }

    return to;
  };

  Redirect.prototype.perform = function perform() {
    var history = this.context.router.history;
    var push = this.props.push;

    var to = this.computeTo(this.props);

    if (push) {
      history.push(to);
    } else {
      history.replace(to);
    }
  };

  Redirect.prototype.render = function render() {
    return null;
  };

  return Redirect;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Redirect.propTypes = {
  computedMatch: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object, // private, from <Switch>
  push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  from: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  to: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object]).isRequired
};
Redirect.defaultProps = {
  push: false
};
Redirect.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired,
    staticContext: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Redirect);

/***/ }),
/* 221 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_StaticRouter__ = __webpack_require__(222);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_StaticRouter__["a" /* default */]);

/***/ }),
/* 222 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_history__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Router__ = __webpack_require__(30);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var addLeadingSlash = function addLeadingSlash(path) {
  return path.charAt(0) === "/" ? path : "/" + path;
};

var addBasename = function addBasename(basename, location) {
  if (!basename) return location;

  return _extends({}, location, {
    pathname: addLeadingSlash(basename) + location.pathname
  });
};

var stripBasename = function stripBasename(basename, location) {
  if (!basename) return location;

  var base = addLeadingSlash(basename);

  if (location.pathname.indexOf(base) !== 0) return location;

  return _extends({}, location, {
    pathname: location.pathname.substr(base.length)
  });
};

var createURL = function createURL(location) {
  return typeof location === "string" ? location : Object(__WEBPACK_IMPORTED_MODULE_4_history__["e" /* createPath */])(location);
};

var staticHandler = function staticHandler(methodName) {
  return function () {
    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(false, "You cannot %s with <StaticRouter>", methodName);
  };
};

var noop = function noop() {};

/**
 * The public top-level API for a "static" <Router>, so-called because it
 * can't actually change the current location. Instead, it just records
 * location changes in a context object. Useful mainly in testing and
 * server-rendering scenarios.
 */

var StaticRouter = function (_React$Component) {
  _inherits(StaticRouter, _React$Component);

  function StaticRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, StaticRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.createHref = function (path) {
      return addLeadingSlash(_this.props.basename + createURL(path));
    }, _this.handlePush = function (location) {
      var _this$props = _this.props,
          basename = _this$props.basename,
          context = _this$props.context;

      context.action = "PUSH";
      context.location = addBasename(basename, Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(location));
      context.url = createURL(context.location);
    }, _this.handleReplace = function (location) {
      var _this$props2 = _this.props,
          basename = _this$props2.basename,
          context = _this$props2.context;

      context.action = "REPLACE";
      context.location = addBasename(basename, Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(location));
      context.url = createURL(context.location);
    }, _this.handleListen = function () {
      return noop;
    }, _this.handleBlock = function () {
      return noop;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  StaticRouter.prototype.getChildContext = function getChildContext() {
    return {
      router: {
        staticContext: this.props.context
      }
    };
  };

  StaticRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, "<StaticRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { StaticRouter as Router }`.");
  };

  StaticRouter.prototype.render = function render() {
    var _props = this.props,
        basename = _props.basename,
        context = _props.context,
        location = _props.location,
        props = _objectWithoutProperties(_props, ["basename", "context", "location"]);

    var history = {
      createHref: this.createHref,
      action: "POP",
      location: stripBasename(basename, Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(location)),
      push: this.handlePush,
      replace: this.handleReplace,
      go: staticHandler("go"),
      goBack: staticHandler("goBack"),
      goForward: staticHandler("goForward"),
      listen: this.handleListen,
      block: this.handleBlock
    };

    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Router__["a" /* default */], _extends({}, props, { history: history }));
  };

  return StaticRouter;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

StaticRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  context: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
  location: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object])
};
StaticRouter.defaultProps = {
  basename: "",
  location: "/"
};
StaticRouter.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (StaticRouter);

/***/ }),
/* 223 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Switch__ = __webpack_require__(224);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Switch__["a" /* default */]);

/***/ }),
/* 224 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__matchPath__ = __webpack_require__(31);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for rendering the first <Route> that matches.
 */

var Switch = function (_React$Component) {
  _inherits(Switch, _React$Component);

  function Switch() {
    _classCallCheck(this, Switch);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Switch.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_3_invariant___default()(this.context.router, "You should not use <Switch> outside a <Router>");
  };

  Switch.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    __WEBPACK_IMPORTED_MODULE_2_warning___default()(!(nextProps.location && !this.props.location), '<Switch> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');

    __WEBPACK_IMPORTED_MODULE_2_warning___default()(!(!nextProps.location && this.props.location), '<Switch> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');
  };

  Switch.prototype.render = function render() {
    var route = this.context.router.route;
    var children = this.props.children;

    var location = this.props.location || route.location;

    var match = void 0,
        child = void 0;
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.forEach(children, function (element) {
      if (match == null && __WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(element)) {
        var _element$props = element.props,
            pathProp = _element$props.path,
            exact = _element$props.exact,
            strict = _element$props.strict,
            sensitive = _element$props.sensitive,
            from = _element$props.from;

        var path = pathProp || from;

        child = element;
        match = Object(__WEBPACK_IMPORTED_MODULE_4__matchPath__["a" /* default */])(location.pathname, { path: path, exact: exact, strict: strict, sensitive: sensitive }, route.match);
      }
    });

    return match ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(child, { location: location, computedMatch: match }) : null;
  };

  return Switch;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Switch.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    route: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
  }).isRequired
};
Switch.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  location: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};


/* harmony default export */ __webpack_exports__["a"] = (Switch);

/***/ }),
/* 225 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_generatePath__ = __webpack_require__(55);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_generatePath__["a" /* default */]);

/***/ }),
/* 226 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_matchPath__ = __webpack_require__(31);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_matchPath__["a" /* default */]);

/***/ }),
/* 227 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_withRouter__ = __webpack_require__(228);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_withRouter__["a" /* default */]);

/***/ }),
/* 228 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Route__ = __webpack_require__(53);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






/**
 * A public higher-order component to access the imperative API
 */
var withRouter = function withRouter(Component) {
  var C = function C(props) {
    var wrappedComponentRef = props.wrappedComponentRef,
        remainingProps = _objectWithoutProperties(props, ["wrappedComponentRef"]);

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Route__["a" /* default */], {
      children: function children(routeComponentProps) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Component, _extends({}, remainingProps, routeComponentProps, {
          ref: wrappedComponentRef
        }));
      }
    });
  };

  C.displayName = "withRouter(" + (Component.displayName || Component.name) + ")";
  C.WrappedComponent = Component;
  C.propTypes = {
    wrappedComponentRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
  };

  return __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default()(C, Component);
};

/* harmony default export */ __webpack_exports__["a"] = (withRouter);

/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

!function(t,e){if(true)module.exports=e();else if("function"==typeof define&&define.amd)define([],e);else{var n=e();for(var r in n)("object"==typeof exports?exports:t)[r]=n[r]}}(window,function(){return function(t){var e={};function n(r){if(e[r])return e[r].exports;var i=e[r]={i:r,l:!1,exports:{}};return t[r].call(i.exports,i,i.exports,n),i.l=!0,i.exports}return n.m=t,n.c=e,n.d=function(t,e,r){n.o(t,e)||Object.defineProperty(t,e,{enumerable:!0,get:r})},n.r=function(t){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(t,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(t,"__esModule",{value:!0})},n.t=function(t,e){if(1&e&&(t=n(t)),8&e)return t;if(4&e&&"object"==typeof t&&t&&t.__esModule)return t;var r=Object.create(null);if(n.r(r),Object.defineProperty(r,"default",{enumerable:!0,value:t}),2&e&&"string"!=typeof t)for(var i in t)n.d(r,i,function(e){return t[e]}.bind(null,i));return r},n.n=function(t){var e=t&&t.__esModule?function(){return t.default}:function(){return t};return n.d(e,"a",e),e},n.o=function(t,e){return Object.prototype.hasOwnProperty.call(t,e)},n.p="/",n(n.s=146)}([function(t,e,n){var r=n(2),i=n(18),a=n(11),o=n(12),s=n(19),u=function(t,e,n){var c,l,f,h,d=t&u.F,p=t&u.G,v=t&u.S,g=t&u.P,m=t&u.B,y=p?r:v?r[e]||(r[e]={}):(r[e]||{}).prototype,b=p?i:i[e]||(i[e]={}),w=b.prototype||(b.prototype={});for(c in p&&(n=e),n)f=((l=!d&&y&&void 0!==y[c])?y:n)[c],h=m&&l?s(f,r):g&&"function"==typeof f?s(Function.call,f):f,y&&o(y,c,f,t&u.U),b[c]!=f&&a(b,c,h),g&&w[c]!=f&&(w[c]=f)};r.core=i,u.F=1,u.G=2,u.S=4,u.P=8,u.B=16,u.W=32,u.U=64,u.R=128,t.exports=u},function(t,e,n){var r=n(4);t.exports=function(t){if(!r(t))throw TypeError(t+" is not an object!");return t}},function(t,e){var n=t.exports="undefined"!=typeof window&&window.Math==Math?window:"undefined"!=typeof self&&self.Math==Math?self:Function("return this")();"number"==typeof __g&&(__g=n)},function(t,e){t.exports=function(t){try{return!!t()}catch(t){return!0}}},function(t,e){t.exports=function(t){return"object"==typeof t?null!==t:"function"==typeof t}},function(t,e,n){var r=n(51)("wks"),i=n(34),a=n(2).Symbol,o="function"==typeof a;(t.exports=function(t){return r[t]||(r[t]=o&&a[t]||(o?a:i)("Symbol."+t))}).store=r},function(t,e,n){var r=n(21),i=Math.min;t.exports=function(t){return t>0?i(r(t),9007199254740991):0}},function(t,e,n){t.exports=!n(3)(function(){return 7!=Object.defineProperty({},"a",{get:function(){return 7}}).a})},function(t,e,n){var r=n(1),i=n(109),a=n(23),o=Object.defineProperty;e.f=n(7)?Object.defineProperty:function(t,e,n){if(r(t),e=a(e,!0),r(n),i)try{return o(t,e,n)}catch(t){}if("get"in n||"set"in n)throw TypeError("Accessors not supported!");return"value"in n&&(t[e]=n.value),t}},function(t,e,n){var r=n(24);t.exports=function(t){return Object(r(t))}},function(t,e){t.exports=function(t){if("function"!=typeof t)throw TypeError(t+" is not a function!");return t}},function(t,e,n){var r=n(8),i=n(33);t.exports=n(7)?function(t,e,n){return r.f(t,e,i(1,n))}:function(t,e,n){return t[e]=n,t}},function(t,e,n){var r=n(2),i=n(11),a=n(14),o=n(34)("src"),s=n(174),u=(""+s).split("toString");n(18).inspectSource=function(t){return s.call(t)},(t.exports=function(t,e,n,s){var c="function"==typeof n;c&&(a(n,"name")||i(n,"name",e)),t[e]!==n&&(c&&(a(n,o)||i(n,o,t[e]?""+t[e]:u.join(String(e)))),t===r?t[e]=n:s?t[e]?t[e]=n:i(t,e,n):(delete t[e],i(t,e,n)))})(Function.prototype,"toString",function(){return"function"==typeof this&&this[o]||s.call(this)})},function(t,e,n){var r=n(0),i=n(3),a=n(24),o=/"/g,s=function(t,e,n,r){var i=String(a(t)),s="<"+e;return""!==n&&(s+=" "+n+'="'+String(r).replace(o,"&quot;")+'"'),s+">"+i+"</"+e+">"};t.exports=function(t,e){var n={};n[t]=e(s),r(r.P+r.F*i(function(){var e=""[t]('"');return e!==e.toLowerCase()||e.split('"').length>3}),"String",n)}},function(t,e){var n={}.hasOwnProperty;t.exports=function(t,e){return n.call(t,e)}},function(t,e,n){var r=n(52),i=n(24);t.exports=function(t){return r(i(t))}},function(t,e,n){var r=n(53),i=n(33),a=n(15),o=n(23),s=n(14),u=n(109),c=Object.getOwnPropertyDescriptor;e.f=n(7)?c:function(t,e){if(t=a(t),e=o(e,!0),u)try{return c(t,e)}catch(t){}if(s(t,e))return i(!r.f.call(t,e),t[e])}},function(t,e,n){var r=n(14),i=n(9),a=n(76)("IE_PROTO"),o=Object.prototype;t.exports=Object.getPrototypeOf||function(t){return t=i(t),r(t,a)?t[a]:"function"==typeof t.constructor&&t instanceof t.constructor?t.constructor.prototype:t instanceof Object?o:null}},function(t,e){var n=t.exports={version:"2.6.9"};"number"==typeof __e&&(__e=n)},function(t,e,n){var r=n(10);t.exports=function(t,e,n){if(r(t),void 0===e)return t;switch(n){case 1:return function(n){return t.call(e,n)};case 2:return function(n,r){return t.call(e,n,r)};case 3:return function(n,r,i){return t.call(e,n,r,i)}}return function(){return t.apply(e,arguments)}}},function(t,e){var n={}.toString;t.exports=function(t){return n.call(t).slice(8,-1)}},function(t,e){var n=Math.ceil,r=Math.floor;t.exports=function(t){return isNaN(t=+t)?0:(t>0?r:n)(t)}},function(t,e,n){"use strict";var r=n(3);t.exports=function(t,e){return!!t&&r(function(){e?t.call(null,function(){},1):t.call(null)})}},function(t,e,n){var r=n(4);t.exports=function(t,e){if(!r(t))return t;var n,i;if(e&&"function"==typeof(n=t.toString)&&!r(i=n.call(t)))return i;if("function"==typeof(n=t.valueOf)&&!r(i=n.call(t)))return i;if(!e&&"function"==typeof(n=t.toString)&&!r(i=n.call(t)))return i;throw TypeError("Can't convert object to primitive value")}},function(t,e){t.exports=function(t){if(null==t)throw TypeError("Can't call method on  "+t);return t}},function(t,e,n){var r=n(0),i=n(18),a=n(3);t.exports=function(t,e){var n=(i.Object||{})[t]||Object[t],o={};o[t]=e(n),r(r.S+r.F*a(function(){n(1)}),"Object",o)}},function(t,e,n){var r=n(19),i=n(52),a=n(9),o=n(6),s=n(92);t.exports=function(t,e){var n=1==t,u=2==t,c=3==t,l=4==t,f=6==t,h=5==t||f,d=e||s;return function(e,s,p){for(var v,g,m=a(e),y=i(m),b=r(s,p,3),w=o(y.length),x=0,E=n?d(e,w):u?d(e,0):void 0;w>x;x++)if((h||x in y)&&(g=b(v=y[x],x,m),t))if(n)E[x]=g;else if(g)switch(t){case 3:return!0;case 5:return v;case 6:return x;case 2:E.push(v)}else if(l)return!1;return f?-1:c||l?l:E}}},function(t,e,n){var r;!function(i){"use strict";function a(t,e,n){var r,i=document.createElement("img");return i.onerror=function(r){return a.onerror(i,r,t,e,n)},i.onload=function(r){return a.onload(i,r,t,e,n)},"string"==typeof t?(a.fetchBlob(t,function(e){e?(t=e,r=a.createObjectURL(t)):(r=t,n&&n.crossOrigin&&(i.crossOrigin=n.crossOrigin)),i.src=r},n),i):a.isInstanceOf("Blob",t)||a.isInstanceOf("File",t)?(r=i._objectURL=a.createObjectURL(t))?(i.src=r,i):a.readFile(t,function(t){var n=t.target;n&&n.result?i.src=n.result:e&&e(t)}):void 0}var o=i.createObjectURL&&i||i.URL&&URL.revokeObjectURL&&URL||i.webkitURL&&webkitURL;function s(t,e){!t._objectURL||e&&e.noRevoke||(a.revokeObjectURL(t._objectURL),delete t._objectURL)}a.fetchBlob=function(t,e,n){e()},a.isInstanceOf=function(t,e){return Object.prototype.toString.call(e)==="[object "+t+"]"},a.transform=function(t,e,n,r,i){n(t,i)},a.onerror=function(t,e,n,r,i){s(t,i),r&&r.call(t,e)},a.onload=function(t,e,n,r,i){s(t,i),r&&a.transform(t,i,r,n,{originalWidth:t.naturalWidth||t.width,originalHeight:t.naturalHeight||t.height})},a.createObjectURL=function(t){return!!o&&o.createObjectURL(t)},a.revokeObjectURL=function(t){return!!o&&o.revokeObjectURL(t)},a.readFile=function(t,e,n){if(i.FileReader){var r=new FileReader;if(r.onload=r.onerror=e,r[n=n||"readAsDataURL"])return r[n](t),r}return!1},void 0===(r=function(){return a}.call(e,n,e,t))||(t.exports=r)}("undefined"!=typeof window&&window||this)},function(t,e,n){"use strict";if(n(7)){var r=n(30),i=n(2),a=n(3),o=n(0),s=n(67),u=n(100),c=n(19),l=n(40),f=n(33),h=n(11),d=n(42),p=n(21),v=n(6),g=n(137),m=n(36),y=n(23),b=n(14),w=n(47),x=n(4),E=n(9),_=n(89),S=n(37),k=n(17),P=n(38).f,R=n(91),A=n(34),C=n(5),I=n(26),F=n(57),O=n(55),T=n(94),M=n(49),D=n(62),j=n(39),L=n(93),B=n(126),N=n(8),V=n(16),U=N.f,z=V.f,W=i.RangeError,H=i.TypeError,G=i.Uint8Array,q=Array.prototype,K=u.ArrayBuffer,Y=u.DataView,J=I(0),$=I(2),X=I(3),Z=I(4),Q=I(5),tt=I(6),et=F(!0),nt=F(!1),rt=T.values,it=T.keys,at=T.entries,ot=q.lastIndexOf,st=q.reduce,ut=q.reduceRight,ct=q.join,lt=q.sort,ft=q.slice,ht=q.toString,dt=q.toLocaleString,pt=C("iterator"),vt=C("toStringTag"),gt=A("typed_constructor"),mt=A("def_constructor"),yt=s.CONSTR,bt=s.TYPED,wt=s.VIEW,xt=I(1,function(t,e){return Pt(O(t,t[mt]),e)}),Et=a(function(){return 1===new G(new Uint16Array([1]).buffer)[0]}),_t=!!G&&!!G.prototype.set&&a(function(){new G(1).set({})}),St=function(t,e){var n=p(t);if(n<0||n%e)throw W("Wrong offset!");return n},kt=function(t){if(x(t)&&bt in t)return t;throw H(t+" is not a typed array!")},Pt=function(t,e){if(!(x(t)&&gt in t))throw H("It is not a typed array constructor!");return new t(e)},Rt=function(t,e){return At(O(t,t[mt]),e)},At=function(t,e){for(var n=0,r=e.length,i=Pt(t,r);r>n;)i[n]=e[n++];return i},Ct=function(t,e,n){U(t,e,{get:function(){return this._d[n]}})},It=function(t){var e,n,r,i,a,o,s=E(t),u=arguments.length,l=u>1?arguments[1]:void 0,f=void 0!==l,h=R(s);if(null!=h&&!_(h)){for(o=h.call(s),r=[],e=0;!(a=o.next()).done;e++)r.push(a.value);s=r}for(f&&u>2&&(l=c(l,arguments[2],2)),e=0,n=v(s.length),i=Pt(this,n);n>e;e++)i[e]=f?l(s[e],e):s[e];return i},Ft=function(){for(var t=0,e=arguments.length,n=Pt(this,e);e>t;)n[t]=arguments[t++];return n},Ot=!!G&&a(function(){dt.call(new G(1))}),Tt=function(){return dt.apply(Ot?ft.call(kt(this)):kt(this),arguments)},Mt={copyWithin:function(t,e){return B.call(kt(this),t,e,arguments.length>2?arguments[2]:void 0)},every:function(t){return Z(kt(this),t,arguments.length>1?arguments[1]:void 0)},fill:function(t){return L.apply(kt(this),arguments)},filter:function(t){return Rt(this,$(kt(this),t,arguments.length>1?arguments[1]:void 0))},find:function(t){return Q(kt(this),t,arguments.length>1?arguments[1]:void 0)},findIndex:function(t){return tt(kt(this),t,arguments.length>1?arguments[1]:void 0)},forEach:function(t){J(kt(this),t,arguments.length>1?arguments[1]:void 0)},indexOf:function(t){return nt(kt(this),t,arguments.length>1?arguments[1]:void 0)},includes:function(t){return et(kt(this),t,arguments.length>1?arguments[1]:void 0)},join:function(t){return ct.apply(kt(this),arguments)},lastIndexOf:function(t){return ot.apply(kt(this),arguments)},map:function(t){return xt(kt(this),t,arguments.length>1?arguments[1]:void 0)},reduce:function(t){return st.apply(kt(this),arguments)},reduceRight:function(t){return ut.apply(kt(this),arguments)},reverse:function(){for(var t,e=kt(this).length,n=Math.floor(e/2),r=0;r<n;)t=this[r],this[r++]=this[--e],this[e]=t;return this},some:function(t){return X(kt(this),t,arguments.length>1?arguments[1]:void 0)},sort:function(t){return lt.call(kt(this),t)},subarray:function(t,e){var n=kt(this),r=n.length,i=m(t,r);return new(O(n,n[mt]))(n.buffer,n.byteOffset+i*n.BYTES_PER_ELEMENT,v((void 0===e?r:m(e,r))-i))}},Dt=function(t,e){return Rt(this,ft.call(kt(this),t,e))},jt=function(t){kt(this);var e=St(arguments[1],1),n=this.length,r=E(t),i=v(r.length),a=0;if(i+e>n)throw W("Wrong length!");for(;a<i;)this[e+a]=r[a++]},Lt={entries:function(){return at.call(kt(this))},keys:function(){return it.call(kt(this))},values:function(){return rt.call(kt(this))}},Bt=function(t,e){return x(t)&&t[bt]&&"symbol"!=typeof e&&e in t&&String(+e)==String(e)},Nt=function(t,e){return Bt(t,e=y(e,!0))?f(2,t[e]):z(t,e)},Vt=function(t,e,n){return!(Bt(t,e=y(e,!0))&&x(n)&&b(n,"value"))||b(n,"get")||b(n,"set")||n.configurable||b(n,"writable")&&!n.writable||b(n,"enumerable")&&!n.enumerable?U(t,e,n):(t[e]=n.value,t)};yt||(V.f=Nt,N.f=Vt),o(o.S+o.F*!yt,"Object",{getOwnPropertyDescriptor:Nt,defineProperty:Vt}),a(function(){ht.call({})})&&(ht=dt=function(){return ct.call(this)});var Ut=d({},Mt);d(Ut,Lt),h(Ut,pt,Lt.values),d(Ut,{slice:Dt,set:jt,constructor:function(){},toString:ht,toLocaleString:Tt}),Ct(Ut,"buffer","b"),Ct(Ut,"byteOffset","o"),Ct(Ut,"byteLength","l"),Ct(Ut,"length","e"),U(Ut,vt,{get:function(){return this[bt]}}),t.exports=function(t,e,n,u){var c=t+((u=!!u)?"Clamped":"")+"Array",f="get"+t,d="set"+t,p=i[c],m=p||{},y=p&&k(p),b=!p||!s.ABV,E={},_=p&&p.prototype,R=function(t,n){U(t,n,{get:function(){return function(t,n){var r=t._d;return r.v[f](n*e+r.o,Et)}(this,n)},set:function(t){return function(t,n,r){var i=t._d;u&&(r=(r=Math.round(r))<0?0:r>255?255:255&r),i.v[d](n*e+i.o,r,Et)}(this,n,t)},enumerable:!0})};b?(p=n(function(t,n,r,i){l(t,p,c,"_d");var a,o,s,u,f=0,d=0;if(x(n)){if(!(n instanceof K||"ArrayBuffer"==(u=w(n))||"SharedArrayBuffer"==u))return bt in n?At(p,n):It.call(p,n);a=n,d=St(r,e);var m=n.byteLength;if(void 0===i){if(m%e)throw W("Wrong length!");if((o=m-d)<0)throw W("Wrong length!")}else if((o=v(i)*e)+d>m)throw W("Wrong length!");s=o/e}else s=g(n),a=new K(o=s*e);for(h(t,"_d",{b:a,o:d,l:o,e:s,v:new Y(a)});f<s;)R(t,f++)}),_=p.prototype=S(Ut),h(_,"constructor",p)):a(function(){p(1)})&&a(function(){new p(-1)})&&D(function(t){new p,new p(null),new p(1.5),new p(t)},!0)||(p=n(function(t,n,r,i){var a;return l(t,p,c),x(n)?n instanceof K||"ArrayBuffer"==(a=w(n))||"SharedArrayBuffer"==a?void 0!==i?new m(n,St(r,e),i):void 0!==r?new m(n,St(r,e)):new m(n):bt in n?At(p,n):It.call(p,n):new m(g(n))}),J(y!==Function.prototype?P(m).concat(P(y)):P(m),function(t){t in p||h(p,t,m[t])}),p.prototype=_,r||(_.constructor=p));var A=_[pt],C=!!A&&("values"==A.name||null==A.name),I=Lt.values;h(p,gt,!0),h(_,bt,c),h(_,wt,!0),h(_,mt,p),(u?new p(1)[vt]==c:vt in _)||U(_,vt,{get:function(){return c}}),E[c]=p,o(o.G+o.W+o.F*(p!=m),E),o(o.S,c,{BYTES_PER_ELEMENT:e}),o(o.S+o.F*a(function(){m.of.call(p,1)}),c,{from:It,of:Ft}),"BYTES_PER_ELEMENT"in _||h(_,"BYTES_PER_ELEMENT",e),o(o.P,c,Mt),j(c),o(o.P+o.F*_t,c,{set:jt}),o(o.P+o.F*!C,c,Lt),r||_.toString==ht||(_.toString=ht),o(o.P+o.F*a(function(){new p(1).slice()}),c,{slice:Dt}),o(o.P+o.F*(a(function(){return[1,2].toLocaleString()!=new p([1,2]).toLocaleString()})||!a(function(){_.toLocaleString.call([1,2])})),c,{toLocaleString:Tt}),M[c]=C?A:I,r||C||h(_,pt,I)}}else t.exports=function(){}},function(t,e,n){var r=n(132),i=n(0),a=n(51)("metadata"),o=a.store||(a.store=new(n(135))),s=function(t,e,n){var i=o.get(t);if(!i){if(!n)return;o.set(t,i=new r)}var a=i.get(e);if(!a){if(!n)return;i.set(e,a=new r)}return a};t.exports={store:o,map:s,has:function(t,e,n){var r=s(e,n,!1);return void 0!==r&&r.has(t)},get:function(t,e,n){var r=s(e,n,!1);return void 0===r?void 0:r.get(t)},set:function(t,e,n,r){s(n,r,!0).set(t,e)},keys:function(t,e){var n=s(t,e,!1),r=[];return n&&n.forEach(function(t,e){r.push(e)}),r},key:function(t){return void 0===t||"symbol"==typeof t?t:String(t)},exp:function(t){i(i.S,"Reflect",t)}}},function(t,e){t.exports=!1},function(t,e,n){var r=n(34)("meta"),i=n(4),a=n(14),o=n(8).f,s=0,u=Object.isExtensible||function(){return!0},c=!n(3)(function(){return u(Object.preventExtensions({}))}),l=function(t){o(t,r,{value:{i:"O"+ ++s,w:{}}})},f=t.exports={KEY:r,NEED:!1,fastKey:function(t,e){if(!i(t))return"symbol"==typeof t?t:("string"==typeof t?"S":"P")+t;if(!a(t,r)){if(!u(t))return"F";if(!e)return"E";l(t)}return t[r].i},getWeak:function(t,e){if(!a(t,r)){if(!u(t))return!0;if(!e)return!1;l(t)}return t[r].w},onFreeze:function(t){return c&&f.NEED&&u(t)&&!a(t,r)&&l(t),t}}},function(t,e,n){var r=n(5)("unscopables"),i=Array.prototype;null==i[r]&&n(11)(i,r,{}),t.exports=function(t){i[r][t]=!0}},function(t,e){t.exports=function(t,e){return{enumerable:!(1&t),configurable:!(2&t),writable:!(4&t),value:e}}},function(t,e){var n=0,r=Math.random();t.exports=function(t){return"Symbol(".concat(void 0===t?"":t,")_",(++n+r).toString(36))}},function(t,e,n){var r=n(111),i=n(77);t.exports=Object.keys||function(t){return r(t,i)}},function(t,e,n){var r=n(21),i=Math.max,a=Math.min;t.exports=function(t,e){return(t=r(t))<0?i(t+e,0):a(t,e)}},function(t,e,n){var r=n(1),i=n(112),a=n(77),o=n(76)("IE_PROTO"),s=function(){},u=function(){var t,e=n(74)("iframe"),r=a.length;for(e.style.display="none",n(78).appendChild(e),e.src="javascript:",(t=e.contentWindow.document).open(),t.write("<script>document.F=Object<\/script>"),t.close(),u=t.F;r--;)delete u.prototype[a[r]];return u()};t.exports=Object.create||function(t,e){var n;return null!==t?(s.prototype=r(t),n=new s,s.prototype=null,n[o]=t):n=u(),void 0===e?n:i(n,e)}},function(t,e,n){var r=n(111),i=n(77).concat("length","prototype");e.f=Object.getOwnPropertyNames||function(t){return r(t,i)}},function(t,e,n){"use strict";var r=n(2),i=n(8),a=n(7),o=n(5)("species");t.exports=function(t){var e=r[t];a&&e&&!e[o]&&i.f(e,o,{configurable:!0,get:function(){return this}})}},function(t,e){t.exports=function(t,e,n,r){if(!(t instanceof e)||void 0!==r&&r in t)throw TypeError(n+": incorrect invocation!");return t}},function(t,e,n){var r=n(19),i=n(124),a=n(89),o=n(1),s=n(6),u=n(91),c={},l={};(e=t.exports=function(t,e,n,f,h){var d,p,v,g,m=h?function(){return t}:u(t),y=r(n,f,e?2:1),b=0;if("function"!=typeof m)throw TypeError(t+" is not iterable!");if(a(m)){for(d=s(t.length);d>b;b++)if((g=e?y(o(p=t[b])[0],p[1]):y(t[b]))===c||g===l)return g}else for(v=m.call(t);!(p=v.next()).done;)if((g=i(v,y,p.value,e))===c||g===l)return g}).BREAK=c,e.RETURN=l},function(t,e,n){var r=n(12);t.exports=function(t,e,n){for(var i in e)r(t,i,e[i],n);return t}},function(t,e,n){var r=n(4);t.exports=function(t,e){if(!r(t)||t._t!==e)throw TypeError("Incompatible receiver, "+e+" required!");return t}},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.getServerUrl=function(){var t=arguments.length>0&&void 0!==arguments[0]&&arguments[0],e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:"test";return t||"test"===e?r.test.server:r[e]?r[e].server:e},e.getApiVersion=function(){var t=arguments.length>0&&void 0!==arguments[0]&&arguments[0],e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:"test";return t||"test"===e?r.test.apiVersion:r[e]?r[e].apiVersion:"3"},e.getUaAccount=function(){var t=arguments.length>0&&void 0!==arguments[0]&&arguments[0],e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:"test";return t||"test"===e?r.test.uaAccount:r[e]&&r[e].uaAccount};var r={prod:{server:"https://partner.revieve.com/",apiVersion:"3",uaAccount:"UA-80711182-6"},test:{server:"https://partner-test.revieve.com/",apiVersion:"3",uaAccount:"UA-80711182-7"},cn:{server:"https://partner.revieve.cn/",apiVersion:"3"},CITest:{server:"https://partner-test.revieve.com/",apiVersion:"3"}};e.apiVersionsAvailable=["2","3"];e.highlightColor="rgb(0,0,0)",e.defaultStrength="0.7",e.makeupMeasures={faceShape:{1:"Diamond",2:"Heart",3:"Long",4:"Oval",5:"Round",6:"Square"},eyeColor:{1:"Brown",2:"Blue",3:"Green"},skinUndertone:{"-1":"Cool",0:"Neutral",1:"Warm"}}},function(t,e,n){"use strict";var r=n(72),i=e.ValidationError=function(t,e,n,r,i,a){r&&(this.property=r),t&&(this.message=t),n&&(n.id?this.schema=n.id:this.schema=n),e&&(this.instance=e),this.name=i,this.argument=a,this.stack=this.toString()};i.prototype.toString=function(){return this.property+" "+this.message};var a=e.ValidatorResult=function(t,e,n,r){this.instance=t,this.schema=e,this.propertyPath=r.propertyPath,this.errors=[],this.throwError=n&&n.throwError,this.disableFormat=n&&!0===n.disableFormat};function o(t,e){return e+": "+t.toString()+"\n"}a.prototype.addError=function(t){var e;if("string"==typeof t)e=new i(t,this.instance,this.schema,this.propertyPath);else{if(!t)throw new Error("Missing error detail");if(!t.message)throw new Error("Missing error message");if(!t.name)throw new Error("Missing validator type");e=new i(t.message,this.instance,this.schema,this.propertyPath,t.name,t.argument)}if(this.throwError)throw e;return this.errors.push(e),e},a.prototype.importErrors=function(t){"string"==typeof t||t&&t.validatorType?this.addError(t):t&&t.errors&&Array.prototype.push.apply(this.errors,t.errors)},a.prototype.toString=function(t){return this.errors.map(o).join("")},Object.defineProperty(a.prototype,"valid",{get:function(){return!this.errors.length}});var s=e.SchemaError=function t(e,n){this.message=e,this.schema=n,Error.call(this,e),Error.captureStackTrace(this,t)};s.prototype=Object.create(Error.prototype,{constructor:{value:s,enumerable:!1},name:{value:"SchemaError",enumerable:!1}});var u=e.SchemaContext=function(t,e,n,r,i){this.schema=t,this.options=e,this.propertyPath=n,this.base=r,this.schemas=i};u.prototype.resolve=function(t){return r.resolve(this.base,t)},u.prototype.makeChild=function(t,e){var n=void 0===e?this.propertyPath:this.propertyPath+l(e),i=r.resolve(this.base,t.id||""),a=new u(t,this.options,n,i,Object.create(this.schemas));return t.id&&!a.schemas[i]&&(a.schemas[i]=t),a};var c=e.FORMAT_REGEXPS={"date-time":/^\d{4}-(?:0[0-9]{1}|1[0-2]{1})-(3[01]|0[1-9]|[12][0-9])[tT ](2[0-4]|[01][0-9]):([0-5][0-9]):(60|[0-5][0-9])(\.\d+)?([zZ]|[+-]([0-5][0-9]):(60|[0-5][0-9]))$/,date:/^\d{4}-(?:0[0-9]{1}|1[0-2]{1})-(3[01]|0[1-9]|[12][0-9])$/,time:/^(2[0-4]|[01][0-9]):([0-5][0-9]):(60|[0-5][0-9])$/,email:/^(?:[\w\!\#\$\%\&\'\*\+\-\/\=\?\^\`\{\|\}\~]+\.)*[\w\!\#\$\%\&\'\*\+\-\/\=\?\^\`\{\|\}\~]+@(?:(?:(?:[a-zA-Z0-9](?:[a-zA-Z0-9\-](?!\.)){0,61}[a-zA-Z0-9]?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9\-](?!$)){0,61}[a-zA-Z0-9]?)|(?:\[(?:(?:[01]?\d{1,2}|2[0-4]\d|25[0-5])\.){3}(?:[01]?\d{1,2}|2[0-4]\d|25[0-5])\]))$/,"ip-address":/^(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/,ipv6:/^\s*((([0-9A-Fa-f]{1,4}:){7}([0-9A-Fa-f]{1,4}|:))|(([0-9A-Fa-f]{1,4}:){6}(:[0-9A-Fa-f]{1,4}|((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9A-Fa-f]{1,4}:){5}(((:[0-9A-Fa-f]{1,4}){1,2})|:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9A-Fa-f]{1,4}:){4}(((:[0-9A-Fa-f]{1,4}){1,3})|((:[0-9A-Fa-f]{1,4})?:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){3}(((:[0-9A-Fa-f]{1,4}){1,4})|((:[0-9A-Fa-f]{1,4}){0,2}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){2}(((:[0-9A-Fa-f]{1,4}){1,5})|((:[0-9A-Fa-f]{1,4}){0,3}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){1}(((:[0-9A-Fa-f]{1,4}){1,6})|((:[0-9A-Fa-f]{1,4}){0,4}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(:(((:[0-9A-Fa-f]{1,4}){1,7})|((:[0-9A-Fa-f]{1,4}){0,5}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:)))(%.+)?\s*$/,uri:/^[a-zA-Z][a-zA-Z0-9+-.]*:[^\s]*$/,color:/^(#?([0-9A-Fa-f]{3}){1,2}\b|aqua|black|blue|fuchsia|gray|green|lime|maroon|navy|olive|orange|purple|red|silver|teal|white|yellow|(rgb\(\s*\b([0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5])\b\s*,\s*\b([0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5])\b\s*,\s*\b([0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5])\b\s*\))|(rgb\(\s*(\d?\d%|100%)+\s*,\s*(\d?\d%|100%)+\s*,\s*(\d?\d%|100%)+\s*\)))$/,hostname:/^(?=.{1,255}$)[0-9A-Za-z](?:(?:[0-9A-Za-z]|-){0,61}[0-9A-Za-z])?(?:\.[0-9A-Za-z](?:(?:[0-9A-Za-z]|-){0,61}[0-9A-Za-z])?)*\.?$/,"host-name":/^(?=.{1,255}$)[0-9A-Za-z](?:(?:[0-9A-Za-z]|-){0,61}[0-9A-Za-z])?(?:\.[0-9A-Za-z](?:(?:[0-9A-Za-z]|-){0,61}[0-9A-Za-z])?)*\.?$/,alpha:/^[a-zA-Z]+$/,alphanumeric:/^[a-zA-Z0-9]+$/,"utc-millisec":function(t){return"string"==typeof t&&parseFloat(t)===parseInt(t,10)&&!isNaN(t)},regex:function(t){var e=!0;try{new RegExp(t)}catch(t){e=!1}return e},style:/\s*(.+?):\s*([^;]+);?/g,phone:/^\+(?:[0-9] ?){6,14}[0-9]$/};c.regexp=c.regex,c.pattern=c.regex,c.ipv4=c["ip-address"],e.isFormat=function(t,e,n){if("string"==typeof t&&void 0!==c[e]){if(c[e]instanceof RegExp)return c[e].test(t);if("function"==typeof c[e])return c[e](t)}else if(n&&n.customFormats&&"function"==typeof n.customFormats[e])return n.customFormats[e](t);return!0};var l=e.makeSuffix=function(t){return(t=t.toString()).match(/[.\s\[\]]/)||t.match(/^[\d]/)?t.match(/^\d+$/)?"["+t+"]":"["+JSON.stringify(t)+"]":"."+t};function f(t,e){var n=Array.isArray(e),r=n&&[]||{};return n?(t=t||[],r=r.concat(t),e.forEach(function(t,e,n,r){"object"==typeof n?e[r]=f(t[r],n):-1===t.indexOf(n)&&e.push(n)}.bind(null,t,r))):(t&&"object"==typeof t&&Object.keys(t).forEach(function(t,e,n){e[n]=t[n]}.bind(null,t,r)),Object.keys(e).forEach(function(t,e,n,r){"object"==typeof e[r]&&e[r]&&t[r]?n[r]=f(t[r],e[r]):n[r]=e[r]}.bind(null,t,e,r))),r}function h(t){return"/"+encodeURIComponent(t).replace(/~/g,"%7E")}e.deepCompareStrict=function t(e,n){if(typeof e!=typeof n)return!1;if(e instanceof Array)return n instanceof Array&&(e.length===n.length&&e.every(function(r,i){return t(e[i],n[i])}));if("object"==typeof e){if(!e||!n)return e===n;var r=Object.keys(e),i=Object.keys(n);return r.length===i.length&&r.every(function(r){return t(e[r],n[r])})}return e===n},t.exports.deepMerge=f,e.objectGetPath=function(t,e){for(var n,r=e.split("/").slice(1);"string"==typeof(n=r.shift());){var i=decodeURIComponent(n.replace(/~0/,"~").replace(/~1/g,"/"));if(!(i in t))return;t=t[i]}return t},e.encodePath=function(t){return t.map(h).join("")},e.getDecimalPlaces=function(t){var e=0;if(isNaN(t))return e;"number"!=typeof t&&(t=Number(t));var n=t.toString().split("e");if(2===n.length){if("-"!==n[1][0])return e;e=Number(n[1].slice(1))}var r=n[0].split(".");return 2===r.length&&(e+=r[1].length),e}},function(t,e,n){var r=n(8).f,i=n(14),a=n(5)("toStringTag");t.exports=function(t,e,n){t&&!i(t=n?t:t.prototype,a)&&r(t,a,{configurable:!0,value:e})}},function(t,e,n){var r=n(20),i=n(5)("toStringTag"),a="Arguments"==r(function(){return arguments}());t.exports=function(t){var e,n,o;return void 0===t?"Undefined":null===t?"Null":"string"==typeof(n=function(t,e){try{return t[e]}catch(t){}}(e=Object(t),i))?n:a?r(e):"Object"==(o=r(e))&&"function"==typeof e.callee?"Arguments":o}},function(t,e,n){var r=n(0),i=n(24),a=n(3),o=n(80),s="["+o+"]",u=RegExp("^"+s+s+"*"),c=RegExp(s+s+"*$"),l=function(t,e,n){var i={},s=a(function(){return!!o[t]()||"​"!="​"[t]()}),u=i[t]=s?e(f):o[t];n&&(i[n]=u),r(r.P+r.F*s,"String",i)},f=l.trim=function(t,e){return t=String(i(t)),1&e&&(t=t.replace(u,"")),2&e&&(t=t.replace(c,"")),t};t.exports=l},function(t,e){t.exports={}},function(t,e,n){var r,i,a;!function(o){"use strict";i=[n(27)],void 0===(a="function"==typeof(r=function(t){var e="undefined"!=typeof Blob&&(Blob.prototype.slice||Blob.prototype.webkitSlice||Blob.prototype.mozSlice);t.blobSlice=e&&function(){var t=this.slice||this.webkitSlice||this.mozSlice;return t.apply(this,arguments)},t.metaDataParsers={jpeg:{65505:[],65517:[]}},t.parseMetaData=function(e,n,r,i){i=i||{};var a=this,o=(r=r||{}).maxMetaDataSize||262144,s=!("undefined"!=typeof DataView&&e&&e.size>=12&&"image/jpeg"===e.type&&t.blobSlice);!s&&t.readFile(t.blobSlice.call(e,0,o),function(e){if(e.target.error)return console.log(e.target.error),void n(i);var o,s,u,c,l=e.target.result,f=new DataView(l),h=2,d=f.byteLength-4,p=h;if(65496===f.getUint16(0)){for(;h<d&&((o=f.getUint16(h))>=65504&&o<=65519||65534===o);){if(s=f.getUint16(h+2)+2,h+s>f.byteLength){console.log("Invalid meta data: Invalid segment size.");break}if(u=t.metaDataParsers.jpeg[o])for(c=0;c<u.length;c+=1)u[c].call(a,f,h,s,i,r);p=h+=s}!r.disableImageHead&&p>6&&(l.slice?i.imageHead=l.slice(0,p):i.imageHead=new Uint8Array(l).subarray(0,p))}else console.log("Invalid JPEG file: Missing JPEG marker.");n(i)},"readAsArrayBuffer")||n(i)},t.hasMetaOption=function(t){return t&&t.meta};var n=t.transform;t.transform=function(e,r,i,a,o){t.hasMetaOption(r)?t.parseMetaData(a,function(o){n.call(t,e,r,i,a,o)},r,o):n.apply(t,arguments)}})?r.apply(e,i):r)||(t.exports=a)}()},function(t,e,n){var r=n(18),i=n(2),a=i["__core-js_shared__"]||(i["__core-js_shared__"]={});(t.exports=function(t,e){return a[t]||(a[t]=void 0!==e?e:{})})("versions",[]).push({version:r.version,mode:n(30)?"pure":"global",copyright:"© 2019 Denis Pushkarev (zloirock.ru)"})},function(t,e,n){var r=n(20);t.exports=Object("z").propertyIsEnumerable(0)?Object:function(t){return"String"==r(t)?t.split(""):Object(t)}},function(t,e){e.f={}.propertyIsEnumerable},function(t,e,n){"use strict";var r=n(1);t.exports=function(){var t=r(this),e="";return t.global&&(e+="g"),t.ignoreCase&&(e+="i"),t.multiline&&(e+="m"),t.unicode&&(e+="u"),t.sticky&&(e+="y"),e}},function(t,e,n){var r=n(1),i=n(10),a=n(5)("species");t.exports=function(t,e){var n,o=r(t).constructor;return void 0===o||null==(n=r(o)[a])?e:i(n)}},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.anonymizeImage=void 0,e.convertFileToBase64=function(t){return new Promise(function(e){if(t){var n=new FileReader;n.addEventListener("load",function(){e(n.result)},!1),n.readAsDataURL(t)}})},e.base64MimeType=s,e.converImageToBitmap=function(t){var e=s(t);return(0,a.default)(t.replace("data:"+e+";base64,",""),e)},e.findMasks=function(t){var e=[];if(!t)return[];var n=!0,r=!1,i=void 0;try{for(var a,o=t[Symbol.iterator]();!(n=(a=o.next()).done);n=!0){var s=a.value;if(s.measurement_locations){var u=!0,c=!1,l=void 0;try{for(var f,h=s.measurement_locations[Symbol.iterator]();!(u=(f=h.next()).done);u=!0){var d=f.value;d.mask_shapes&&(d.mask_shapes.section=s.description,d.mask_shapes.name=d.description,e.push(d.mask_shapes))}}catch(t){c=!0,l=t}finally{try{!u&&h.return&&h.return()}finally{if(c)throw l}}}}}catch(t){r=!0,i=t}finally{try{!n&&o.return&&o.return()}finally{if(r)throw i}}return e},e.checkStatus=function(t){if(t.status>=200&&t.status<300)return t;var e=new Error(t.statusText);throw e.requestResponse=t,e},e.getImageDimensions=function(t){return new Promise(function(e){var n=document.createElement("img");n.onload=function(){e({width:n.width,height:n.height})},n.src=t})},e.calculateAspectRatioFit=function(t,e,n,r,i){var a=u({srcWidth:t,srcHeight:e,maxWidth:n,maxHeight:r,orientation:i});return{width:Math.round(t*a),height:Math.round(e*a),ratio:a}},e.getPropertyInPath=function t(e,n,r){if(!e||!n||!r)return null;var i=n.slice();if(0===i.length)return e[r];var a=i.shift();if("member"===a.type)return t(e[a.member],i,r);if("array"===a.type){if("root"!==a.member&&!Array.isArray(e[a.member]))return null;var o=("root"!==a.member?e[a.member]:e).find(function(t){return t[a.filter.member]===a.filter.value});if(o)return t(o,i,r)}return null},e.getOrientation=function(t){return(t.msMatchMedia||t.MozMatchMedia||t.WebkitMatchMedia||t.matchMedia)("(orientation: portrait)").matches?"portrait":"landscape"},e.rgbToHex=function(t){if(!t||t.length<=0)return null;var e="#",n=!0,r=!1,i=void 0;try{for(var a,o=t[Symbol.iterator]();!(n=(a=o.next()).done);n=!0){var s=a.value;e+=c(s).toUpperCase()}}catch(t){r=!0,i=t}finally{try{!n&&o.return&&o.return()}finally{if(r)throw i}}return e},e.hexToRgb=function(t){t=t.replace(/^#?([a-f\d])([a-f\d])([a-f\d])$/i,function(t,e,n,r){return e+e+n+n+r+r});var e=/^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(t);return e?[parseInt(e[1],16),parseInt(e[2],16),parseInt(e[3],16)]:null},e.colourNameToHex=function(t){var e={aliceblue:"#f0f8ff",antiquewhite:"#faebd7",aqua:"#00ffff",aquamarine:"#7fffd4",azure:"#f0ffff",beige:"#f5f5dc",bisque:"#ffe4c4",black:"#000000",blanchedalmond:"#ffebcd",blue:"#0000ff",blueviolet:"#8a2be2",brown:"#a52a2a",burlywood:"#deb887",cadetblue:"#5f9ea0",chartreuse:"#7fff00",chocolate:"#d2691e",coral:"#ff7f50",cornflowerblue:"#6495ed",cornsilk:"#fff8dc",crimson:"#dc143c",cyan:"#00ffff",darkblue:"#00008b",darkcyan:"#008b8b",darkgoldenrod:"#b8860b",darkgray:"#a9a9a9",darkgreen:"#006400",darkkhaki:"#bdb76b",darkmagenta:"#8b008b",darkolivegreen:"#556b2f",darkorange:"#ff8c00",darkorchid:"#9932cc",darkred:"#8b0000",darksalmon:"#e9967a",darkseagreen:"#8fbc8f",darkslateblue:"#483d8b",darkslategray:"#2f4f4f",darkturquoise:"#00ced1",darkviolet:"#9400d3",deeppink:"#ff1493",deepskyblue:"#00bfff",dimgray:"#696969",dodgerblue:"#1e90ff",firebrick:"#b22222",floralwhite:"#fffaf0",forestgreen:"#228b22",fuchsia:"#ff00ff",gainsboro:"#dcdcdc",ghostwhite:"#f8f8ff",gold:"#ffd700",goldenrod:"#daa520",gray:"#808080",green:"#008000",greenyellow:"#adff2f",honeydew:"#f0fff0",hotpink:"#ff69b4","indianred ":"#cd5c5c",indigo:"#4b0082",ivory:"#fffff0",khaki:"#f0e68c",lavender:"#e6e6fa",lavenderblush:"#fff0f5",lawngreen:"#7cfc00",lemonchiffon:"#fffacd",lightblue:"#add8e6",lightcoral:"#f08080",lightcyan:"#e0ffff",lightgoldenrodyellow:"#fafad2",lightgrey:"#d3d3d3",lightgreen:"#90ee90",lightpink:"#ffb6c1",lightsalmon:"#ffa07a",lightseagreen:"#20b2aa",lightskyblue:"#87cefa",lightslategray:"#778899",lightsteelblue:"#b0c4de",lightyellow:"#ffffe0",lime:"#00ff00",limegreen:"#32cd32",linen:"#faf0e6",magenta:"#ff00ff",maroon:"#800000",mediumaquamarine:"#66cdaa",mediumblue:"#0000cd",mediumorchid:"#ba55d3",mediumpurple:"#9370d8",mediumseagreen:"#3cb371",mediumslateblue:"#7b68ee",mediumspringgreen:"#00fa9a",mediumturquoise:"#48d1cc",mediumvioletred:"#c71585",midnightblue:"#191970",mintcream:"#f5fffa",mistyrose:"#ffe4e1",moccasin:"#ffe4b5",navajowhite:"#ffdead",navy:"#000080",oldlace:"#fdf5e6",olive:"#808000",olivedrab:"#6b8e23",orange:"#ffa500",orangered:"#ff4500",orchid:"#da70d6",palegoldenrod:"#eee8aa",palegreen:"#98fb98",paleturquoise:"#afeeee",palevioletred:"#d87093",papayawhip:"#ffefd5",peachpuff:"#ffdab9",peru:"#cd853f",pink:"#ffc0cb",plum:"#dda0dd",powderblue:"#b0e0e6",purple:"#800080",rebeccapurple:"#663399",red:"#ff0000",rosybrown:"#bc8f8f",royalblue:"#4169e1",saddlebrown:"#8b4513",salmon:"#fa8072",sandybrown:"#f4a460",seagreen:"#2e8b57",seashell:"#fff5ee",sienna:"#a0522d",silver:"#c0c0c0",skyblue:"#87ceeb",slateblue:"#6a5acd",slategray:"#708090",snow:"#fffafa",springgreen:"#00ff7f",steelblue:"#4682b4",tan:"#d2b48c",teal:"#008080",thistle:"#d8bfd8",tomato:"#ff6347",turquoise:"#40e0d0",violet:"#ee82ee",wheat:"#f5deb3",white:"#ffffff",whitesmoke:"#f5f5f5",yellow:"#ffff00",yellowgreen:"#9acd32"};if(void 0!==e[t.toLowerCase()])return e[t.toLowerCase()];return t},e.normalizeRgbColor=function(t){return t.map(function(t){return t>255?255:t})},e.getRangeColor=function(t,e){var n=e.filter(function(e){return t>=e.minValue&&t<e.maxValue});return n&&n.length>0?n[0].color:"rgb(44, 192, 205)"};var r,i=n(155),a=(r=i)&&r.__esModule?r:{default:r},o=n(106);function s(t){var e=null;if("string"!=typeof t)return e;var n=t.match(/data:([a-zA-Z0-9]+\/[a-zA-Z0-9-.+]+).*,.*/);return n&&n.length&&(e=n[1]),e}var u=function(t){var e=t.srcWidth,n=t.srcHeight,r=t.maxWidth,i=t.maxHeight/n,a=r/e;switch(t.orientation){case"landscape":return a;case"portrait":return i;default:return Math.max(i,a)}};function c(t){var e=Number(t).toString(16);return e.length<2&&(e="0"+e),e}e.anonymizeImage=function(t){var e=t.image,n=t.dimensions,r=t.results;return new Promise(function(t){var i=r.find(function(t){return"eyes"===t.description}).measurement_locations.reduce(function(t,e){return t.push(e.mask_shapes.shapes.find(function(t){return 0===t.color&&"ellipse"===t.type}).params),t},[]),a=document.createElement("canvas");a.setAttribute("id","anonymizeCanvas"),a.setAttribute("width",n.width),a.setAttribute("height",n.height),a.style.position="absolute",a.style.top="0px",a.style.left="0px",a.style.transformOrigin="top left";var s=a.getContext("2d"),u=document.createElement("img");u.src=e,u.onload=function(){s.drawImage(u,0,0),i.forEach(function(t){var e=t[0],n=t[1],r=t[2],i=t[3],a=[[e-r,n-i],[e+r,n-i],[e+r,n+i],[e-r,n+i]];(0,o.drawPolygon)(s,a,1,"rgb(0,0,0)",!1)}),t(a.toDataURL())}})}},function(t,e,n){var r=n(15),i=n(6),a=n(36);t.exports=function(t){return function(e,n,o){var s,u=r(e),c=i(u.length),l=a(o,c);if(t&&n!=n){for(;c>l;)if((s=u[l++])!=s)return!0}else for(;c>l;l++)if((t||l in u)&&u[l]===n)return t||l||0;return!t&&-1}}},function(t,e){e.f=Object.getOwnPropertySymbols},function(t,e,n){var r=n(20);t.exports=Array.isArray||function(t){return"Array"==r(t)}},function(t,e,n){var r=n(21),i=n(24);t.exports=function(t){return function(e,n){var a,o,s=String(i(e)),u=r(n),c=s.length;return u<0||u>=c?t?"":void 0:(a=s.charCodeAt(u))<55296||a>56319||u+1===c||(o=s.charCodeAt(u+1))<56320||o>57343?t?s.charAt(u):a:t?s.slice(u,u+2):o-56320+(a-55296<<10)+65536}}},function(t,e,n){var r=n(4),i=n(20),a=n(5)("match");t.exports=function(t){var e;return r(t)&&(void 0!==(e=t[a])?!!e:"RegExp"==i(t))}},function(t,e,n){var r=n(5)("iterator"),i=!1;try{var a=[7][r]();a.return=function(){i=!0},Array.from(a,function(){throw 2})}catch(t){}t.exports=function(t,e){if(!e&&!i)return!1;var n=!1;try{var a=[7],o=a[r]();o.next=function(){return{done:n=!0}},a[r]=function(){return o},t(a)}catch(t){}return n}},function(t,e,n){"use strict";var r=n(47),i=RegExp.prototype.exec;t.exports=function(t,e){var n=t.exec;if("function"==typeof n){var a=n.call(t,e);if("object"!=typeof a)throw new TypeError("RegExp exec method returned something other than an Object or null");return a}if("RegExp"!==r(t))throw new TypeError("RegExp#exec called on incompatible receiver");return i.call(t,e)}},function(t,e,n){"use strict";n(128);var r=n(12),i=n(11),a=n(3),o=n(24),s=n(5),u=n(95),c=s("species"),l=!a(function(){var t=/./;return t.exec=function(){var t=[];return t.groups={a:"7"},t},"7"!=="".replace(t,"$<a>")}),f=function(){var t=/(?:)/,e=t.exec;t.exec=function(){return e.apply(this,arguments)};var n="ab".split(t);return 2===n.length&&"a"===n[0]&&"b"===n[1]}();t.exports=function(t,e,n){var h=s(t),d=!a(function(){var e={};return e[h]=function(){return 7},7!=""[t](e)}),p=d?!a(function(){var e=!1,n=/a/;return n.exec=function(){return e=!0,null},"split"===t&&(n.constructor={},n.constructor[c]=function(){return n}),n[h](""),!e}):void 0;if(!d||!p||"replace"===t&&!l||"split"===t&&!f){var v=/./[h],g=n(o,h,""[t],function(t,e,n,r,i){return e.exec===u?d&&!i?{done:!0,value:v.call(e,n,r)}:{done:!0,value:t.call(n,e,r)}:{done:!1}}),m=g[0],y=g[1];r(String.prototype,t,m),i(RegExp.prototype,h,2==e?function(t,e){return y.call(t,this,e)}:function(t){return y.call(t,this)})}}},function(t,e,n){var r=n(2).navigator;t.exports=r&&r.userAgent||""},function(t,e,n){"use strict";var r=n(2),i=n(0),a=n(12),o=n(42),s=n(31),u=n(41),c=n(40),l=n(4),f=n(3),h=n(62),d=n(46),p=n(81);t.exports=function(t,e,n,v,g,m){var y=r[t],b=y,w=g?"set":"add",x=b&&b.prototype,E={},_=function(t){var e=x[t];a(x,t,"delete"==t?function(t){return!(m&&!l(t))&&e.call(this,0===t?0:t)}:"has"==t?function(t){return!(m&&!l(t))&&e.call(this,0===t?0:t)}:"get"==t?function(t){return m&&!l(t)?void 0:e.call(this,0===t?0:t)}:"add"==t?function(t){return e.call(this,0===t?0:t),this}:function(t,n){return e.call(this,0===t?0:t,n),this})};if("function"==typeof b&&(m||x.forEach&&!f(function(){(new b).entries().next()}))){var S=new b,k=S[w](m?{}:-0,1)!=S,P=f(function(){S.has(1)}),R=h(function(t){new b(t)}),A=!m&&f(function(){for(var t=new b,e=5;e--;)t[w](e,e);return!t.has(-0)});R||((b=e(function(e,n){c(e,b,t);var r=p(new y,e,b);return null!=n&&u(n,g,r[w],r),r})).prototype=x,x.constructor=b),(P||A)&&(_("delete"),_("has"),g&&_("get")),(A||k)&&_(w),m&&x.clear&&delete x.clear}else b=v.getConstructor(e,t,g,w),o(b.prototype,n),s.NEED=!0;return d(b,t),E[t]=b,i(i.G+i.W+i.F*(b!=y),E),m||v.setStrong(b,t,g),b}},function(t,e,n){for(var r,i=n(2),a=n(11),o=n(34),s=o("typed_array"),u=o("view"),c=!(!i.ArrayBuffer||!i.DataView),l=c,f=0,h="Int8Array,Uint8Array,Uint8ClampedArray,Int16Array,Uint16Array,Int32Array,Uint32Array,Float32Array,Float64Array".split(",");f<9;)(r=i[h[f++]])?(a(r.prototype,s,!0),a(r.prototype,u,!0)):l=!1;t.exports={ABV:c,CONSTR:l,TYPED:s,VIEW:u}},function(t,e,n){"use strict";t.exports=n(30)||!n(3)(function(){var t=Math.random();__defineSetter__.call(null,t,function(){}),delete n(2)[t]})},function(t,e,n){"use strict";var r=n(0);t.exports=function(t){r(r.S,t,{of:function(){for(var t=arguments.length,e=new Array(t);t--;)e[t]=arguments[t];return new this(e)}})}},function(t,e,n){"use strict";var r=n(0),i=n(10),a=n(19),o=n(41);t.exports=function(t){r(r.S,t,{from:function(t){var e,n,r,s,u=arguments[1];return i(this),(e=void 0!==u)&&i(u),null==t?new this:(n=[],e?(r=0,s=a(u,arguments[2],2),o(t,!1,function(t){n.push(s(t,r++))})):o(t,!1,n.push,n),new this(n))}})}},function(t,e){var n;n=function(){return this}();try{n=n||new Function("return this")()}catch(t){"object"==typeof window&&(n=window)}t.exports=n},function(t,e,n){"use strict";var r=n(164),i=n(166);function a(){this.protocol=null,this.slashes=null,this.auth=null,this.host=null,this.port=null,this.hostname=null,this.hash=null,this.search=null,this.query=null,this.pathname=null,this.path=null,this.href=null}e.parse=b,e.resolve=function(t,e){return b(t,!1,!0).resolve(e)},e.resolveObject=function(t,e){return t?b(t,!1,!0).resolveObject(e):e},e.format=function(t){i.isString(t)&&(t=b(t));return t instanceof a?t.format():a.prototype.format.call(t)},e.Url=a;var o=/^([a-z0-9.+-]+:)/i,s=/:[0-9]*$/,u=/^(\/\/?(?!\/)[^\?\s]*)(\?[^\s]*)?$/,c=["{","}","|","\\","^","`"].concat(["<",">",'"',"`"," ","\r","\n","\t"]),l=["'"].concat(c),f=["%","/","?",";","#"].concat(l),h=["/","?","#"],d=/^[+a-z0-9A-Z_-]{0,63}$/,p=/^([+a-z0-9A-Z_-]{0,63})(.*)$/,v={javascript:!0,"javascript:":!0},g={javascript:!0,"javascript:":!0},m={http:!0,https:!0,ftp:!0,gopher:!0,file:!0,"http:":!0,"https:":!0,"ftp:":!0,"gopher:":!0,"file:":!0},y=n(167);function b(t,e,n){if(t&&i.isObject(t)&&t instanceof a)return t;var r=new a;return r.parse(t,e,n),r}a.prototype.parse=function(t,e,n){if(!i.isString(t))throw new TypeError("Parameter 'url' must be a string, not "+typeof t);var a=t.indexOf("?"),s=-1!==a&&a<t.indexOf("#")?"?":"#",c=t.split(s);c[0]=c[0].replace(/\\/g,"/");var b=t=c.join(s);if(b=b.trim(),!n&&1===t.split("#").length){var w=u.exec(b);if(w)return this.path=b,this.href=b,this.pathname=w[1],w[2]?(this.search=w[2],this.query=e?y.parse(this.search.substr(1)):this.search.substr(1)):e&&(this.search="",this.query={}),this}var x=o.exec(b);if(x){var E=(x=x[0]).toLowerCase();this.protocol=E,b=b.substr(x.length)}if(n||x||b.match(/^\/\/[^@\/]+@[^@\/]+/)){var _="//"===b.substr(0,2);!_||x&&g[x]||(b=b.substr(2),this.slashes=!0)}if(!g[x]&&(_||x&&!m[x])){for(var S,k,P=-1,R=0;R<h.length;R++){-1!==(A=b.indexOf(h[R]))&&(-1===P||A<P)&&(P=A)}-1!==(k=-1===P?b.lastIndexOf("@"):b.lastIndexOf("@",P))&&(S=b.slice(0,k),b=b.slice(k+1),this.auth=decodeURIComponent(S)),P=-1;for(R=0;R<f.length;R++){var A;-1!==(A=b.indexOf(f[R]))&&(-1===P||A<P)&&(P=A)}-1===P&&(P=b.length),this.host=b.slice(0,P),b=b.slice(P),this.parseHost(),this.hostname=this.hostname||"";var C="["===this.hostname[0]&&"]"===this.hostname[this.hostname.length-1];if(!C)for(var I=this.hostname.split(/\./),F=(R=0,I.length);R<F;R++){var O=I[R];if(O&&!O.match(d)){for(var T="",M=0,D=O.length;M<D;M++)O.charCodeAt(M)>127?T+="x":T+=O[M];if(!T.match(d)){var j=I.slice(0,R),L=I.slice(R+1),B=O.match(p);B&&(j.push(B[1]),L.unshift(B[2])),L.length&&(b="/"+L.join(".")+b),this.hostname=j.join(".");break}}}this.hostname.length>255?this.hostname="":this.hostname=this.hostname.toLowerCase(),C||(this.hostname=r.toASCII(this.hostname));var N=this.port?":"+this.port:"",V=this.hostname||"";this.host=V+N,this.href+=this.host,C&&(this.hostname=this.hostname.substr(1,this.hostname.length-2),"/"!==b[0]&&(b="/"+b))}if(!v[E])for(R=0,F=l.length;R<F;R++){var U=l[R];if(-1!==b.indexOf(U)){var z=encodeURIComponent(U);z===U&&(z=escape(U)),b=b.split(U).join(z)}}var W=b.indexOf("#");-1!==W&&(this.hash=b.substr(W),b=b.slice(0,W));var H=b.indexOf("?");if(-1!==H?(this.search=b.substr(H),this.query=b.substr(H+1),e&&(this.query=y.parse(this.query)),b=b.slice(0,H)):e&&(this.search="",this.query={}),b&&(this.pathname=b),m[E]&&this.hostname&&!this.pathname&&(this.pathname="/"),this.pathname||this.search){N=this.pathname||"";var G=this.search||"";this.path=N+G}return this.href=this.format(),this},a.prototype.format=function(){var t=this.auth||"";t&&(t=(t=encodeURIComponent(t)).replace(/%3A/i,":"),t+="@");var e=this.protocol||"",n=this.pathname||"",r=this.hash||"",a=!1,o="";this.host?a=t+this.host:this.hostname&&(a=t+(-1===this.hostname.indexOf(":")?this.hostname:"["+this.hostname+"]"),this.port&&(a+=":"+this.port)),this.query&&i.isObject(this.query)&&Object.keys(this.query).length&&(o=y.stringify(this.query));var s=this.search||o&&"?"+o||"";return e&&":"!==e.substr(-1)&&(e+=":"),this.slashes||(!e||m[e])&&!1!==a?(a="//"+(a||""),n&&"/"!==n.charAt(0)&&(n="/"+n)):a||(a=""),r&&"#"!==r.charAt(0)&&(r="#"+r),s&&"?"!==s.charAt(0)&&(s="?"+s),e+a+(n=n.replace(/[?#]/g,function(t){return encodeURIComponent(t)}))+(s=s.replace("#","%23"))+r},a.prototype.resolve=function(t){return this.resolveObject(b(t,!1,!0)).format()},a.prototype.resolveObject=function(t){if(i.isString(t)){var e=new a;e.parse(t,!1,!0),t=e}for(var n=new a,r=Object.keys(this),o=0;o<r.length;o++){var s=r[o];n[s]=this[s]}if(n.hash=t.hash,""===t.href)return n.href=n.format(),n;if(t.slashes&&!t.protocol){for(var u=Object.keys(t),c=0;c<u.length;c++){var l=u[c];"protocol"!==l&&(n[l]=t[l])}return m[n.protocol]&&n.hostname&&!n.pathname&&(n.path=n.pathname="/"),n.href=n.format(),n}if(t.protocol&&t.protocol!==n.protocol){if(!m[t.protocol]){for(var f=Object.keys(t),h=0;h<f.length;h++){var d=f[h];n[d]=t[d]}return n.href=n.format(),n}if(n.protocol=t.protocol,t.host||g[t.protocol])n.pathname=t.pathname;else{for(var p=(t.pathname||"").split("/");p.length&&!(t.host=p.shift()););t.host||(t.host=""),t.hostname||(t.hostname=""),""!==p[0]&&p.unshift(""),p.length<2&&p.unshift(""),n.pathname=p.join("/")}if(n.search=t.search,n.query=t.query,n.host=t.host||"",n.auth=t.auth,n.hostname=t.hostname||t.host,n.port=t.port,n.pathname||n.search){var v=n.pathname||"",y=n.search||"";n.path=v+y}return n.slashes=n.slashes||t.slashes,n.href=n.format(),n}var b=n.pathname&&"/"===n.pathname.charAt(0),w=t.host||t.pathname&&"/"===t.pathname.charAt(0),x=w||b||n.host&&t.pathname,E=x,_=n.pathname&&n.pathname.split("/")||[],S=(p=t.pathname&&t.pathname.split("/")||[],n.protocol&&!m[n.protocol]);if(S&&(n.hostname="",n.port=null,n.host&&(""===_[0]?_[0]=n.host:_.unshift(n.host)),n.host="",t.protocol&&(t.hostname=null,t.port=null,t.host&&(""===p[0]?p[0]=t.host:p.unshift(t.host)),t.host=null),x=x&&(""===p[0]||""===_[0])),w)n.host=t.host||""===t.host?t.host:n.host,n.hostname=t.hostname||""===t.hostname?t.hostname:n.hostname,n.search=t.search,n.query=t.query,_=p;else if(p.length)_||(_=[]),_.pop(),_=_.concat(p),n.search=t.search,n.query=t.query;else if(!i.isNullOrUndefined(t.search)){if(S)n.hostname=n.host=_.shift(),(C=!!(n.host&&n.host.indexOf("@")>0)&&n.host.split("@"))&&(n.auth=C.shift(),n.host=n.hostname=C.shift());return n.search=t.search,n.query=t.query,i.isNull(n.pathname)&&i.isNull(n.search)||(n.path=(n.pathname?n.pathname:"")+(n.search?n.search:"")),n.href=n.format(),n}if(!_.length)return n.pathname=null,n.search?n.path="/"+n.search:n.path=null,n.href=n.format(),n;for(var k=_.slice(-1)[0],P=(n.host||t.host||_.length>1)&&("."===k||".."===k)||""===k,R=0,A=_.length;A>=0;A--)"."===(k=_[A])?_.splice(A,1):".."===k?(_.splice(A,1),R++):R&&(_.splice(A,1),R--);if(!x&&!E)for(;R--;R)_.unshift("..");!x||""===_[0]||_[0]&&"/"===_[0].charAt(0)||_.unshift(""),P&&"/"!==_.join("/").substr(-1)&&_.push("");var C,I=""===_[0]||_[0]&&"/"===_[0].charAt(0);S&&(n.hostname=n.host=I?"":_.length?_.shift():"",(C=!!(n.host&&n.host.indexOf("@")>0)&&n.host.split("@"))&&(n.auth=C.shift(),n.host=n.hostname=C.shift()));return(x=x||n.host&&_.length)&&!I&&_.unshift(""),_.length?n.pathname=_.join("/"):(n.pathname=null,n.path=null),i.isNull(n.pathname)&&i.isNull(n.search)||(n.path=(n.pathname?n.pathname:"")+(n.search?n.search:"")),n.auth=t.auth||n.auth,n.slashes=n.slashes||t.slashes,n.href=n.format(),n},a.prototype.parseHost=function(){var t=this.host,e=s.exec(t);e&&(":"!==(e=e[0])&&(this.port=e.substr(1)),t=t.substr(0,t.length-e.length)),t&&(this.hostname=t)}},function(t,e,n){var r=n(72),i=n(45);function a(t,e){this.id=t,this.ref=e}t.exports.SchemaScanResult=a,t.exports.scan=function(t,e){function n(t,e){if(e&&"object"==typeof e)if(e.$ref){var a=r.resolve(t,e.$ref);c[a]=c[a]?c[a]+1:0}else{var l=e.id?r.resolve(t,e.id):t;if(l){if(l.indexOf("#")<0&&(l+="#"),u[l]){if(!i.deepCompareStrict(u[l],e))throw new Error("Schema <"+e+"> already exists with different definition");return u[l]}u[l]=e,"#"==l[l.length-1]&&(u[l.substring(0,l.length-1)]=e)}o(l+"/items",e.items instanceof Array?e.items:[e.items]),o(l+"/extends",e.extends instanceof Array?e.extends:[e.extends]),n(l+"/additionalItems",e.additionalItems),s(l+"/properties",e.properties),n(l+"/additionalProperties",e.additionalProperties),s(l+"/definitions",e.definitions),s(l+"/patternProperties",e.patternProperties),s(l+"/dependencies",e.dependencies),o(l+"/disallow",e.disallow),o(l+"/allOf",e.allOf),o(l+"/anyOf",e.anyOf),o(l+"/oneOf",e.oneOf),n(l+"/not",e.not)}}function o(t,e){if(e instanceof Array)for(var r=0;r<e.length;r++)n(t+"/"+r,e[r])}function s(t,e){if(e&&"object"==typeof e)for(var r in e)n(t+"/"+r,e[r])}var u={},c={};return n(t,e),new a(u,c)}},function(t,e,n){var r=n(4),i=n(2).document,a=r(i)&&r(i.createElement);t.exports=function(t){return a?i.createElement(t):{}}},function(t,e,n){var r=n(2),i=n(18),a=n(30),o=n(110),s=n(8).f;t.exports=function(t){var e=i.Symbol||(i.Symbol=a?{}:r.Symbol||{});"_"==t.charAt(0)||t in e||s(e,t,{value:o.f(t)})}},function(t,e,n){var r=n(51)("keys"),i=n(34);t.exports=function(t){return r[t]||(r[t]=i(t))}},function(t,e){t.exports="constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf".split(",")},function(t,e,n){var r=n(2).document;t.exports=r&&r.documentElement},function(t,e,n){var r=n(4),i=n(1),a=function(t,e){if(i(t),!r(e)&&null!==e)throw TypeError(e+": can't set as prototype!")};t.exports={set:Object.setPrototypeOf||("__proto__"in{}?function(t,e,r){try{(r=n(19)(Function.call,n(16).f(Object.prototype,"__proto__").set,2))(t,[]),e=!(t instanceof Array)}catch(t){e=!0}return function(t,n){return a(t,n),e?t.__proto__=n:r(t,n),t}}({},!1):void 0),check:a}},function(t,e){t.exports="\t\n\v\f\r   ᠎             　\u2028\u2029\ufeff"},function(t,e,n){var r=n(4),i=n(79).set;t.exports=function(t,e,n){var a,o=e.constructor;return o!==n&&"function"==typeof o&&(a=o.prototype)!==n.prototype&&r(a)&&i&&i(t,a),t}},function(t,e,n){"use strict";var r=n(21),i=n(24);t.exports=function(t){var e=String(i(this)),n="",a=r(t);if(a<0||a==1/0)throw RangeError("Count can't be negative");for(;a>0;(a>>>=1)&&(e+=e))1&a&&(n+=e);return n}},function(t,e){t.exports=Math.sign||function(t){return 0==(t=+t)||t!=t?t:t<0?-1:1}},function(t,e){var n=Math.expm1;t.exports=!n||n(10)>22025.465794806718||n(10)<22025.465794806718||-2e-17!=n(-2e-17)?function(t){return 0==(t=+t)?t:t>-1e-6&&t<1e-6?t+t*t/2:Math.exp(t)-1}:n},function(t,e,n){"use strict";var r=n(30),i=n(0),a=n(12),o=n(11),s=n(49),u=n(86),c=n(46),l=n(17),f=n(5)("iterator"),h=!([].keys&&"next"in[].keys()),d=function(){return this};t.exports=function(t,e,n,p,v,g,m){u(n,e,p);var y,b,w,x=function(t){if(!h&&t in k)return k[t];switch(t){case"keys":case"values":return function(){return new n(this,t)}}return function(){return new n(this,t)}},E=e+" Iterator",_="values"==v,S=!1,k=t.prototype,P=k[f]||k["@@iterator"]||v&&k[v],R=P||x(v),A=v?_?x("entries"):R:void 0,C="Array"==e&&k.entries||P;if(C&&(w=l(C.call(new t)))!==Object.prototype&&w.next&&(c(w,E,!0),r||"function"==typeof w[f]||o(w,f,d)),_&&P&&"values"!==P.name&&(S=!0,R=function(){return P.call(this)}),r&&!m||!h&&!S&&k[f]||o(k,f,R),s[e]=R,s[E]=d,v)if(y={values:_?R:x("values"),keys:g?R:x("keys"),entries:A},m)for(b in y)b in k||a(k,b,y[b]);else i(i.P+i.F*(h||S),e,y);return y}},function(t,e,n){"use strict";var r=n(37),i=n(33),a=n(46),o={};n(11)(o,n(5)("iterator"),function(){return this}),t.exports=function(t,e,n){t.prototype=r(o,{next:i(1,n)}),a(t,e+" Iterator")}},function(t,e,n){var r=n(61),i=n(24);t.exports=function(t,e,n){if(r(e))throw TypeError("String#"+n+" doesn't accept regex!");return String(i(t))}},function(t,e,n){var r=n(5)("match");t.exports=function(t){var e=/./;try{"/./"[t](e)}catch(n){try{return e[r]=!1,!"/./"[t](e)}catch(t){}}return!0}},function(t,e,n){var r=n(49),i=n(5)("iterator"),a=Array.prototype;t.exports=function(t){return void 0!==t&&(r.Array===t||a[i]===t)}},function(t,e,n){"use strict";var r=n(8),i=n(33);t.exports=function(t,e,n){e in t?r.f(t,e,i(0,n)):t[e]=n}},function(t,e,n){var r=n(47),i=n(5)("iterator"),a=n(49);t.exports=n(18).getIteratorMethod=function(t){if(null!=t)return t[i]||t["@@iterator"]||a[r(t)]}},function(t,e,n){var r=n(263);t.exports=function(t,e){return new(r(t))(e)}},function(t,e,n){"use strict";var r=n(9),i=n(36),a=n(6);t.exports=function(t){for(var e=r(this),n=a(e.length),o=arguments.length,s=i(o>1?arguments[1]:void 0,n),u=o>2?arguments[2]:void 0,c=void 0===u?n:i(u,n);c>s;)e[s++]=t;return e}},function(t,e,n){"use strict";var r=n(32),i=n(127),a=n(49),o=n(15);t.exports=n(85)(Array,"Array",function(t,e){this._t=o(t),this._i=0,this._k=e},function(){var t=this._t,e=this._k,n=this._i++;return!t||n>=t.length?(this._t=void 0,i(1)):i(0,"keys"==e?n:"values"==e?t[n]:[n,t[n]])},"values"),a.Arguments=a.Array,r("keys"),r("values"),r("entries")},function(t,e,n){"use strict";var r,i,a=n(54),o=RegExp.prototype.exec,s=String.prototype.replace,u=o,c=(r=/a/,i=/b*/g,o.call(r,"a"),o.call(i,"a"),0!==r.lastIndex||0!==i.lastIndex),l=void 0!==/()??/.exec("")[1];(c||l)&&(u=function(t){var e,n,r,i,u=this;return l&&(n=new RegExp("^"+u.source+"$(?!\\s)",a.call(u))),c&&(e=u.lastIndex),r=o.call(u,t),c&&r&&(u.lastIndex=u.global?r.index+r[0].length:e),l&&r&&r.length>1&&s.call(r[0],n,function(){for(i=1;i<arguments.length-2;i++)void 0===arguments[i]&&(r[i]=void 0)}),r}),t.exports=u},function(t,e,n){"use strict";var r=n(60)(!0);t.exports=function(t,e,n){return e+(n?r(t,e).length:1)}},function(t,e,n){var r,i,a,o=n(19),s=n(117),u=n(78),c=n(74),l=n(2),f=l.process,h=l.setImmediate,d=l.clearImmediate,p=l.MessageChannel,v=l.Dispatch,g=0,m={},y=function(){var t=+this;if(m.hasOwnProperty(t)){var e=m[t];delete m[t],e()}},b=function(t){y.call(t.data)};h&&d||(h=function(t){for(var e=[],n=1;arguments.length>n;)e.push(arguments[n++]);return m[++g]=function(){s("function"==typeof t?t:Function(t),e)},r(g),g},d=function(t){delete m[t]},"process"==n(20)(f)?r=function(t){f.nextTick(o(y,t,1))}:v&&v.now?r=function(t){v.now(o(y,t,1))}:p?(a=(i=new p).port2,i.port1.onmessage=b,r=o(a.postMessage,a,1)):l.addEventListener&&"function"==typeof postMessage&&!l.importScripts?(r=function(t){l.postMessage(t+"","*")},l.addEventListener("message",b,!1)):r="onreadystatechange"in c("script")?function(t){u.appendChild(c("script")).onreadystatechange=function(){u.removeChild(this),y.call(t)}}:function(t){setTimeout(o(y,t,1),0)}),t.exports={set:h,clear:d}},function(t,e,n){var r=n(2),i=n(97).set,a=r.MutationObserver||r.WebKitMutationObserver,o=r.process,s=r.Promise,u="process"==n(20)(o);t.exports=function(){var t,e,n,c=function(){var r,i;for(u&&(r=o.domain)&&r.exit();t;){i=t.fn,t=t.next;try{i()}catch(r){throw t?n():e=void 0,r}}e=void 0,r&&r.enter()};if(u)n=function(){o.nextTick(c)};else if(!a||r.navigator&&r.navigator.standalone)if(s&&s.resolve){var l=s.resolve(void 0);n=function(){l.then(c)}}else n=function(){i.call(r,c)};else{var f=!0,h=document.createTextNode("");new a(c).observe(h,{characterData:!0}),n=function(){h.data=f=!f}}return function(r){var i={fn:r,next:void 0};e&&(e.next=i),t||(t=i,n()),e=i}}},function(t,e,n){"use strict";var r=n(10);function i(t){var e,n;this.promise=new t(function(t,r){if(void 0!==e||void 0!==n)throw TypeError("Bad Promise constructor");e=t,n=r}),this.resolve=r(e),this.reject=r(n)}t.exports.f=function(t){return new i(t)}},function(t,e,n){"use strict";var r=n(2),i=n(7),a=n(30),o=n(67),s=n(11),u=n(42),c=n(3),l=n(40),f=n(21),h=n(6),d=n(137),p=n(38).f,v=n(8).f,g=n(93),m=n(46),y="prototype",b="Wrong index!",w=r.ArrayBuffer,x=r.DataView,E=r.Math,_=r.RangeError,S=r.Infinity,k=w,P=E.abs,R=E.pow,A=E.floor,C=E.log,I=E.LN2,F=i?"_b":"buffer",O=i?"_l":"byteLength",T=i?"_o":"byteOffset";function M(t,e,n){var r,i,a,o=new Array(n),s=8*n-e-1,u=(1<<s)-1,c=u>>1,l=23===e?R(2,-24)-R(2,-77):0,f=0,h=t<0||0===t&&1/t<0?1:0;for((t=P(t))!=t||t===S?(i=t!=t?1:0,r=u):(r=A(C(t)/I),t*(a=R(2,-r))<1&&(r--,a*=2),(t+=r+c>=1?l/a:l*R(2,1-c))*a>=2&&(r++,a/=2),r+c>=u?(i=0,r=u):r+c>=1?(i=(t*a-1)*R(2,e),r+=c):(i=t*R(2,c-1)*R(2,e),r=0));e>=8;o[f++]=255&i,i/=256,e-=8);for(r=r<<e|i,s+=e;s>0;o[f++]=255&r,r/=256,s-=8);return o[--f]|=128*h,o}function D(t,e,n){var r,i=8*n-e-1,a=(1<<i)-1,o=a>>1,s=i-7,u=n-1,c=t[u--],l=127&c;for(c>>=7;s>0;l=256*l+t[u],u--,s-=8);for(r=l&(1<<-s)-1,l>>=-s,s+=e;s>0;r=256*r+t[u],u--,s-=8);if(0===l)l=1-o;else{if(l===a)return r?NaN:c?-S:S;r+=R(2,e),l-=o}return(c?-1:1)*r*R(2,l-e)}function j(t){return t[3]<<24|t[2]<<16|t[1]<<8|t[0]}function L(t){return[255&t]}function B(t){return[255&t,t>>8&255]}function N(t){return[255&t,t>>8&255,t>>16&255,t>>24&255]}function V(t){return M(t,52,8)}function U(t){return M(t,23,4)}function z(t,e,n){v(t[y],e,{get:function(){return this[n]}})}function W(t,e,n,r){var i=d(+n);if(i+e>t[O])throw _(b);var a=t[F]._b,o=i+t[T],s=a.slice(o,o+e);return r?s:s.reverse()}function H(t,e,n,r,i,a){var o=d(+n);if(o+e>t[O])throw _(b);for(var s=t[F]._b,u=o+t[T],c=r(+i),l=0;l<e;l++)s[u+l]=c[a?l:e-l-1]}if(o.ABV){if(!c(function(){w(1)})||!c(function(){new w(-1)})||c(function(){return new w,new w(1.5),new w(NaN),"ArrayBuffer"!=w.name})){for(var G,q=(w=function(t){return l(this,w),new k(d(t))})[y]=k[y],K=p(k),Y=0;K.length>Y;)(G=K[Y++])in w||s(w,G,k[G]);a||(q.constructor=w)}var J=new x(new w(2)),$=x[y].setInt8;J.setInt8(0,2147483648),J.setInt8(1,2147483649),!J.getInt8(0)&&J.getInt8(1)||u(x[y],{setInt8:function(t,e){$.call(this,t,e<<24>>24)},setUint8:function(t,e){$.call(this,t,e<<24>>24)}},!0)}else w=function(t){l(this,w,"ArrayBuffer");var e=d(t);this._b=g.call(new Array(e),0),this[O]=e},x=function(t,e,n){l(this,x,"DataView"),l(t,w,"DataView");var r=t[O],i=f(e);if(i<0||i>r)throw _("Wrong offset!");if(i+(n=void 0===n?r-i:h(n))>r)throw _("Wrong length!");this[F]=t,this[T]=i,this[O]=n},i&&(z(w,"byteLength","_l"),z(x,"buffer","_b"),z(x,"byteLength","_l"),z(x,"byteOffset","_o")),u(x[y],{getInt8:function(t){return W(this,1,t)[0]<<24>>24},getUint8:function(t){return W(this,1,t)[0]},getInt16:function(t){var e=W(this,2,t,arguments[1]);return(e[1]<<8|e[0])<<16>>16},getUint16:function(t){var e=W(this,2,t,arguments[1]);return e[1]<<8|e[0]},getInt32:function(t){return j(W(this,4,t,arguments[1]))},getUint32:function(t){return j(W(this,4,t,arguments[1]))>>>0},getFloat32:function(t){return D(W(this,4,t,arguments[1]),23,4)},getFloat64:function(t){return D(W(this,8,t,arguments[1]),52,8)},setInt8:function(t,e){H(this,1,t,L,e)},setUint8:function(t,e){H(this,1,t,L,e)},setInt16:function(t,e){H(this,2,t,B,e,arguments[2])},setUint16:function(t,e){H(this,2,t,B,e,arguments[2])},setInt32:function(t,e){H(this,4,t,N,e,arguments[2])},setUint32:function(t,e){H(this,4,t,N,e,arguments[2])},setFloat32:function(t,e){H(this,4,t,U,e,arguments[2])},setFloat64:function(t,e){H(this,8,t,V,e,arguments[2])}});m(w,"ArrayBuffer"),m(x,"DataView"),s(x[y],o.VIEW,!0),e.ArrayBuffer=w,e.DataView=x},,,function(t,e,n){var r,i,a;!function(o){"use strict";i=[n(27)],void 0===(a="function"==typeof(r=function(t){var e=t.transform;t.transform=function(n,r,i,a,o){e.call(t,t.scale(n,r,o),r,i,a,o)},t.transformCoordinates=function(){},t.getTransformedOptions=function(t,e){var n,r,i,a,o=e.aspectRatio;if(!o)return e;for(r in n={},e)e.hasOwnProperty(r)&&(n[r]=e[r]);return n.crop=!0,i=t.naturalWidth||t.width,a=t.naturalHeight||t.height,i/a>o?(n.maxWidth=a*o,n.maxHeight=a):(n.maxWidth=i,n.maxHeight=i/o),n},t.renderImageToCanvas=function(t,e,n,r,i,a,o,s,u,c){return t.getContext("2d").drawImage(e,n,r,i,a,o,s,u,c),t},t.hasCanvasOption=function(t){return t.canvas||t.crop||!!t.aspectRatio},t.scale=function(e,n,r){n=n||{};var i,a,o,s,u,c,l,f,h,d,p,v=document.createElement("canvas"),g=e.getContext||t.hasCanvasOption(n)&&v.getContext,m=e.naturalWidth||e.width,y=e.naturalHeight||e.height,b=m,w=y;function x(){var t=Math.max((o||b)/b,(s||w)/w);t>1&&(b*=t,w*=t)}function E(){var t=Math.min((i||b)/b,(a||w)/w);t<1&&(b*=t,w*=t)}if(g&&(n=t.getTransformedOptions(e,n,r),l=n.left||0,f=n.top||0,n.sourceWidth?(u=n.sourceWidth,void 0!==n.right&&void 0===n.left&&(l=m-u-n.right)):u=m-l-(n.right||0),n.sourceHeight?(c=n.sourceHeight,void 0!==n.bottom&&void 0===n.top&&(f=y-c-n.bottom)):c=y-f-(n.bottom||0),b=u,w=c),i=n.maxWidth,a=n.maxHeight,o=n.minWidth,s=n.minHeight,g&&i&&a&&n.crop?(b=i,w=a,(p=u/c-i/a)<0?(c=a*u/i,void 0===n.top&&void 0===n.bottom&&(f=(y-c)/2)):p>0&&(u=i*c/a,void 0===n.left&&void 0===n.right&&(l=(m-u)/2))):((n.contain||n.cover)&&(o=i=i||o,s=a=a||s),n.cover?(E(),x()):(x(),E())),g){if((h=n.pixelRatio)>1&&(v.style.width=b+"px",v.style.height=w+"px",b*=h,w*=h,v.getContext("2d").scale(h,h)),(d=n.downsamplingRatio)>0&&d<1&&b<u&&w<c)for(;u*d>b;)v.width=u*d,v.height=c*d,t.renderImageToCanvas(v,e,l,f,u,c,0,0,v.width,v.height),l=0,f=0,u=v.width,c=v.height,(e=document.createElement("canvas")).width=u,e.height=c,t.renderImageToCanvas(e,v,0,0,u,c,0,0,u,c);return v.width=b,v.height=w,t.transformCoordinates(v,n),t.renderImageToCanvas(v,e,l,f,u,c,0,0,b,w)}return e.width=b,e.height=w,e}})?r.apply(e,i):r)||(t.exports=a)}()},function(t,e,n){var r,i,a;!function(o){"use strict";i=[n(27),n(50)],void 0===(a="function"==typeof(r=function(t){t.ExifMap=function(){return this},t.ExifMap.prototype.map={Orientation:274},t.ExifMap.prototype.get=function(t){return this[t]||this[this.map[t]]},t.getExifThumbnail=function(e,n,r){if(r&&!(n+r>e.byteLength))return t.createObjectURL(new Blob([e.buffer.slice(n,n+r)]));console.log("Invalid Exif data: Invalid thumbnail data.")},t.exifTagTypes={1:{getValue:function(t,e){return t.getUint8(e)},size:1},2:{getValue:function(t,e){return String.fromCharCode(t.getUint8(e))},size:1,ascii:!0},3:{getValue:function(t,e,n){return t.getUint16(e,n)},size:2},4:{getValue:function(t,e,n){return t.getUint32(e,n)},size:4},5:{getValue:function(t,e,n){return t.getUint32(e,n)/t.getUint32(e+4,n)},size:8},9:{getValue:function(t,e,n){return t.getInt32(e,n)},size:4},10:{getValue:function(t,e,n){return t.getInt32(e,n)/t.getInt32(e+4,n)},size:8}},t.exifTagTypes[7]=t.exifTagTypes[1],t.getExifValue=function(e,n,r,i,a,o){var s,u,c,l,f,h,d=t.exifTagTypes[i];if(d){if(s=d.size*a,!((u=s>4?n+e.getUint32(r+8,o):r+8)+s>e.byteLength)){if(1===a)return d.getValue(e,u,o);for(c=[],l=0;l<a;l+=1)c[l]=d.getValue(e,u+l*d.size,o);if(d.ascii){for(f="",l=0;l<c.length&&"\0"!==(h=c[l]);l+=1)f+=h;return f}return c}console.log("Invalid Exif data: Invalid data offset.")}else console.log("Invalid Exif data: Invalid tag type.")},t.parseExifTag=function(e,n,r,i,a){var o=e.getUint16(r,i);a.exif[o]=t.getExifValue(e,n,r,e.getUint16(r+2,i),e.getUint32(r+4,i),i)},t.parseExifTags=function(t,e,n,r,i){var a,o,s;if(n+6>t.byteLength)console.log("Invalid Exif data: Invalid directory offset.");else{if(a=t.getUint16(n,r),!((o=n+2+12*a)+4>t.byteLength)){for(s=0;s<a;s+=1)this.parseExifTag(t,e,n+2+12*s,r,i);return t.getUint32(o,r)}console.log("Invalid Exif data: Invalid directory size.")}},t.parseExifData=function(e,n,r,i,a){if(!a.disableExif){var o,s,u,c=n+10;if(1165519206===e.getUint32(n+4))if(c+8>e.byteLength)console.log("Invalid Exif data: Invalid segment size.");else if(0===e.getUint16(n+8)){switch(e.getUint16(c)){case 18761:o=!0;break;case 19789:o=!1;break;default:return void console.log("Invalid Exif data: Invalid byte alignment marker.")}42===e.getUint16(c+2,o)?(s=e.getUint32(c+4,o),i.exif=new t.ExifMap,(s=t.parseExifTags(e,c,c+s,o,i))&&!a.disableExifThumbnail&&(u={exif:{}},s=t.parseExifTags(e,c,c+s,o,u),u.exif[513]&&(i.exif.Thumbnail=t.getExifThumbnail(e,c+u.exif[513],u.exif[514]))),i.exif[34665]&&!a.disableExifSub&&t.parseExifTags(e,c,c+i.exif[34665],o,i),i.exif[34853]&&!a.disableExifGps&&t.parseExifTags(e,c,c+i.exif[34853],o,i)):console.log("Invalid Exif data: Missing TIFF marker.")}else console.log("Invalid Exif data: Missing byte alignment offset.")}},t.metaDataParsers.jpeg[65505].push(t.parseExifData)})?r.apply(e,i):r)||(t.exports=a)}()},function(t,e,n){var r,i,a;!function(o){"use strict";i=[n(27),n(50)],void 0===(a="function"==typeof(r=function(t){t.IptcMap=function(){return this},t.IptcMap.prototype.map={ObjectName:5},t.IptcMap.prototype.get=function(t){return this[t]||this[this.map[t]]},t.parseIptcTags=function(t,e,n,r){function i(t,e,n){for(var r="",i=e;i<e+n;i++)r+=String.fromCharCode(t.getUint8(i));return r}for(var a,o,s,u=e;u<e+n;)28===t.getUint8(u)&&2===t.getUint8(u+1)&&(s=t.getUint8(u+2))in r.iptc.tags&&(o=t.getInt16(u+3),a=i(t,u+5,o),r.iptc.hasOwnProperty(s)?r.iptc[s]instanceof Array?r.iptc[s].push(a):r.iptc[s]=[r.iptc[s],a]:r.iptc[s]=a),u++},t.parseIptcData=function(e,n,r,i,a){if(!a.disableIptc){for(var o=n+r,s=function(t,e){return 943868237===t.getUint32(e)&&1028===t.getUint16(e+4)};n+8<o;){if(s(e,n)){var u=e.getUint8(n+7);u%2!=0&&(u+=1),0===u&&(u=4);var c=n+8+u;if(c>o){console.log("Invalid IPTC data: Invalid segment offset.");break}var l=e.getUint16(n+6+u);if(n+l>o){console.log("Invalid IPTC data: Invalid segment size.");break}return i.iptc=new t.IptcMap,t.parseIptcTags(e,c,l,i)}n++}console.log("No IPTC data at this offset - could be XMP")}},t.metaDataParsers.jpeg[65517].push(t.parseIptcData)})?r.apply(e,i):r)||(t.exports=a)}()},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.draw=function(t,e){var n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:null,r=arguments.length>3&&void 0!==arguments[3]?arguments[3]:null,u=arguments.length>4&&void 0!==arguments[4]&&arguments[4],c=arguments[5];return new Promise(function(l,f){t&&e||(console.error("Draw function: canvas and mask are mandatory"),f());var h=t.getContext("2d");if(c&&c.length>0){var d=.008*Math.min(t.width,t.height);c.forEach(function(e){"point"===e.type&&s(t,e.params[0],e.params[1],d,r,null,!1)})}else{var p=e.shapes;e.mask&&(e.mask.color=2,p.push(e.mask));var v=t.width<=700||t.height<=700?1.5:3;!function(t,e){var n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:null,r=arguments.length>3&&void 0!==arguments[3]&&arguments[3],s=arguments[4],u=!0,c=!1,l=void 0;try{for(var f,h=e[Symbol.iterator]();!(u=(f=h.next()).done);u=!0){var d=f.value;if(!r||0!==d.color){t.save();var p=d.params.slice(0);"ellipse"===d.type&&a(t,p,d.color,n,r),"polygon"!==d.type&&"unrestricted_polygon"!==d.type||i(t,p,d.color,n,r),"polyline"===d.type&&o(t,p,n,r,s),t.restore()}}}catch(t){c=!0,l=t}finally{try{!u&&h.return&&h.return()}finally{if(c)throw l}}t.save()}(h,p,r,u,v)}if(n){var g=document.createElement("img");g.src=n,g.onload=function(){var t,e,n;e=g,n=(t=h).globalCompositeOperation,t.globalCompositeOperation="source-in",t.drawImage(e,0,0),t.globalCompositeOperation=n,l()}}else l()})},e.drawPolygon=i,e.drawLine=o,e.drawPoint=function(t,e,n){var r=arguments.length>3&&void 0!==arguments[3]?arguments[3]:5;t.fillStyle=n||"rgb(0, 0, 0)",t.fillRect(e[0],e[1],r,r)},e.highlightArea=function(t,e){if(!t)return void console.error("Draw function: canvas and mask are mandatory");var n=t.getContext("2d"),i=n.globalCompositeOperation;n.globalCompositeOperation="source-out",n.fillStyle=e||r.highlightColor,n.beginPath(),n.rect(0,0,t.width,t.height),n.closePath(),n.fill(),n.globalCompositeOperation=i},e.drawCircle=s;var r=n(44);function i(t,e,n,r){var i=arguments.length>4&&void 0!==arguments[4]&&arguments[4];t.fillStyle=r||"rgb(255, 255, 255)";var a=t.globalCompositeOperation;0===n&&(t.globalCompositeOperation="destination-out",t.fillStyle="rgb(255, 255, 255)"),2===n&&(t.globalCompositeOperation="destination-in",t.fillStyle="rgb(255, 255, 255)"),i&&(t.strokeStyle=r||"rgb(44,192,205)",t.lineCap="round",t.lineWidth=15),t.beginPath();var o=e.shift();t.moveTo(o[0],o[1]);var s=!0,u=!1,c=void 0;try{for(var l,f=e[Symbol.iterator]();!(s=(l=f.next()).done);s=!0){var h=l.value;t.lineTo(h[0],h[1])}}catch(t){u=!0,c=t}finally{try{!s&&f.return&&f.return()}finally{if(u)throw c}}t.lineTo(o[0],o[1]),t.closePath(),i?t.stroke():t.fill(),t.globalCompositeOperation=a}function a(t,e,n,r,i){7!==e.length&&(console.error("incorrect param length for ellipse"),console.log(e)),t.fillStyle=r||"rgb(255, 255, 255)";var a=t.globalCompositeOperation;0===n&&(t.globalCompositeOperation="destination-out",t.fillStyle="rgb(255, 255, 255)"),2===n&&(t.globalCompositeOperation="destination-in",t.fillStyle="rgb(255, 255, 255)"),i&&(t.strokeStyle=r||"rgb(44,192,205)",t.lineCap="round",t.lineWidth=15),t.beginPath(),t.ellipse(e[0],e[1],e[2],e[3],e[4]*Math.PI/180,e[5]*Math.PI/180,e[6]*Math.PI/180),t.closePath(),i?t.stroke():t.fill(),t.globalCompositeOperation=a}function o(t,e,n,r,i){t.strokeStyle=n||(r?"rgb(44,192,205)":"rgb(0, 0, 0)"),t.lineCap="round",t.lineWidth=i,r&&(t.lineWidth=15),t.beginPath();var a=e.shift();t.moveTo(a[0],a[1]);var o=!0,s=!1,u=void 0;try{for(var c,l=e[Symbol.iterator]();!(o=(c=l.next()).done);o=!0){var f=c.value;t.lineTo(f[0],f[1])}}catch(t){s=!0,u=t}finally{try{!o&&l.return&&l.return()}finally{if(s)throw u}}t.stroke()}function s(t,e,n,r,i,a,o){var s=arguments.length>7&&void 0!==arguments[7]?arguments[7]:2,u=t.getContext("2d");u.beginPath(),u.arc(e,n,r,0,2*Math.PI,!1),u.fillStyle=i,o&&(u.shadowColor="#111",u.shadowBlur=20,u.shadowOffsetX=0,u.shadowOffsetY=5),u.fill(),a&&(u.lineWidth=s,u.strokeStyle=a,u.stroke())}},function(t,e){!function(t){"use strict";if(!t.fetch){var e={searchParams:"URLSearchParams"in t,iterable:"Symbol"in t&&"iterator"in Symbol,blob:"FileReader"in t&&"Blob"in t&&function(){try{return new Blob,!0}catch(t){return!1}}(),formData:"FormData"in t,arrayBuffer:"ArrayBuffer"in t};if(e.arrayBuffer)var n=["[object Int8Array]","[object Uint8Array]","[object Uint8ClampedArray]","[object Int16Array]","[object Uint16Array]","[object Int32Array]","[object Uint32Array]","[object Float32Array]","[object Float64Array]"],r=function(t){return t&&DataView.prototype.isPrototypeOf(t)},i=ArrayBuffer.isView||function(t){return t&&n.indexOf(Object.prototype.toString.call(t))>-1};l.prototype.append=function(t,e){t=s(t),e=u(e);var n=this.map[t];this.map[t]=n?n+","+e:e},l.prototype.delete=function(t){delete this.map[s(t)]},l.prototype.get=function(t){return t=s(t),this.has(t)?this.map[t]:null},l.prototype.has=function(t){return this.map.hasOwnProperty(s(t))},l.prototype.set=function(t,e){this.map[s(t)]=u(e)},l.prototype.forEach=function(t,e){for(var n in this.map)this.map.hasOwnProperty(n)&&t.call(e,this.map[n],n,this)},l.prototype.keys=function(){var t=[];return this.forEach(function(e,n){t.push(n)}),c(t)},l.prototype.values=function(){var t=[];return this.forEach(function(e){t.push(e)}),c(t)},l.prototype.entries=function(){var t=[];return this.forEach(function(e,n){t.push([n,e])}),c(t)},e.iterable&&(l.prototype[Symbol.iterator]=l.prototype.entries);var a=["DELETE","GET","HEAD","OPTIONS","POST","PUT"];g.prototype.clone=function(){return new g(this,{body:this._bodyInit})},v.call(g.prototype),v.call(y.prototype),y.prototype.clone=function(){return new y(this._bodyInit,{status:this.status,statusText:this.statusText,headers:new l(this.headers),url:this.url})},y.error=function(){var t=new y(null,{status:0,statusText:""});return t.type="error",t};var o=[301,302,303,307,308];y.redirect=function(t,e){if(-1===o.indexOf(e))throw new RangeError("Invalid status code");return new y(null,{status:e,headers:{location:t}})},t.Headers=l,t.Request=g,t.Response=y,t.fetch=function(t,n){return new Promise(function(r,i){var a=new g(t,n),o=new XMLHttpRequest;o.onload=function(){var t,e,n={status:o.status,statusText:o.statusText,headers:(t=o.getAllResponseHeaders()||"",e=new l,t.replace(/\r?\n[\t ]+/g," ").split(/\r?\n/).forEach(function(t){var n=t.split(":"),r=n.shift().trim();if(r){var i=n.join(":").trim();e.append(r,i)}}),e)};n.url="responseURL"in o?o.responseURL:n.headers.get("X-Request-URL");var i="response"in o?o.response:o.responseText;r(new y(i,n))},o.onerror=function(){i(new TypeError("Network request failed"))},o.ontimeout=function(){i(new TypeError("Network request failed"))},o.open(a.method,a.url,!0),"include"===a.credentials?o.withCredentials=!0:"omit"===a.credentials&&(o.withCredentials=!1),"responseType"in o&&e.blob&&(o.responseType="blob"),a.headers.forEach(function(t,e){o.setRequestHeader(e,t)}),o.send(void 0===a._bodyInit?null:a._bodyInit)})},t.fetch.polyfill=!0}function s(t){if("string"!=typeof t&&(t=String(t)),/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(t))throw new TypeError("Invalid character in header field name");return t.toLowerCase()}function u(t){return"string"!=typeof t&&(t=String(t)),t}function c(t){var n={next:function(){var e=t.shift();return{done:void 0===e,value:e}}};return e.iterable&&(n[Symbol.iterator]=function(){return n}),n}function l(t){this.map={},t instanceof l?t.forEach(function(t,e){this.append(e,t)},this):Array.isArray(t)?t.forEach(function(t){this.append(t[0],t[1])},this):t&&Object.getOwnPropertyNames(t).forEach(function(e){this.append(e,t[e])},this)}function f(t){if(t.bodyUsed)return Promise.reject(new TypeError("Already read"));t.bodyUsed=!0}function h(t){return new Promise(function(e,n){t.onload=function(){e(t.result)},t.onerror=function(){n(t.error)}})}function d(t){var e=new FileReader,n=h(e);return e.readAsArrayBuffer(t),n}function p(t){if(t.slice)return t.slice(0);var e=new Uint8Array(t.byteLength);return e.set(new Uint8Array(t)),e.buffer}function v(){return this.bodyUsed=!1,this._initBody=function(t){if(this._bodyInit=t,t)if("string"==typeof t)this._bodyText=t;else if(e.blob&&Blob.prototype.isPrototypeOf(t))this._bodyBlob=t;else if(e.formData&&FormData.prototype.isPrototypeOf(t))this._bodyFormData=t;else if(e.searchParams&&URLSearchParams.prototype.isPrototypeOf(t))this._bodyText=t.toString();else if(e.arrayBuffer&&e.blob&&r(t))this._bodyArrayBuffer=p(t.buffer),this._bodyInit=new Blob([this._bodyArrayBuffer]);else{if(!e.arrayBuffer||!ArrayBuffer.prototype.isPrototypeOf(t)&&!i(t))throw new Error("unsupported BodyInit type");this._bodyArrayBuffer=p(t)}else this._bodyText="";this.headers.get("content-type")||("string"==typeof t?this.headers.set("content-type","text/plain;charset=UTF-8"):this._bodyBlob&&this._bodyBlob.type?this.headers.set("content-type",this._bodyBlob.type):e.searchParams&&URLSearchParams.prototype.isPrototypeOf(t)&&this.headers.set("content-type","application/x-www-form-urlencoded;charset=UTF-8"))},e.blob&&(this.blob=function(){var t=f(this);if(t)return t;if(this._bodyBlob)return Promise.resolve(this._bodyBlob);if(this._bodyArrayBuffer)return Promise.resolve(new Blob([this._bodyArrayBuffer]));if(this._bodyFormData)throw new Error("could not read FormData body as blob");return Promise.resolve(new Blob([this._bodyText]))},this.arrayBuffer=function(){return this._bodyArrayBuffer?f(this)||Promise.resolve(this._bodyArrayBuffer):this.blob().then(d)}),this.text=function(){var t,e,n,r=f(this);if(r)return r;if(this._bodyBlob)return t=this._bodyBlob,e=new FileReader,n=h(e),e.readAsText(t),n;if(this._bodyArrayBuffer)return Promise.resolve(function(t){for(var e=new Uint8Array(t),n=new Array(e.length),r=0;r<e.length;r++)n[r]=String.fromCharCode(e[r]);return n.join("")}(this._bodyArrayBuffer));if(this._bodyFormData)throw new Error("could not read FormData body as text");return Promise.resolve(this._bodyText)},e.formData&&(this.formData=function(){return this.text().then(m)}),this.json=function(){return this.text().then(JSON.parse)},this}function g(t,e){var n,r,i=(e=e||{}).body;if(t instanceof g){if(t.bodyUsed)throw new TypeError("Already read");this.url=t.url,this.credentials=t.credentials,e.headers||(this.headers=new l(t.headers)),this.method=t.method,this.mode=t.mode,i||null==t._bodyInit||(i=t._bodyInit,t.bodyUsed=!0)}else this.url=String(t);if(this.credentials=e.credentials||this.credentials||"omit",!e.headers&&this.headers||(this.headers=new l(e.headers)),this.method=(n=e.method||this.method||"GET",r=n.toUpperCase(),a.indexOf(r)>-1?r:n),this.mode=e.mode||this.mode||null,this.referrer=null,("GET"===this.method||"HEAD"===this.method)&&i)throw new TypeError("Body not allowed for GET or HEAD requests");this._initBody(i)}function m(t){var e=new FormData;return t.trim().split("&").forEach(function(t){if(t){var n=t.split("="),r=n.shift().replace(/\+/g," "),i=n.join("=").replace(/\+/g," ");e.append(decodeURIComponent(r),decodeURIComponent(i))}}),e}function y(t,e){e||(e={}),this.type="default",this.status=void 0===e.status?200:e.status,this.ok=this.status>=200&&this.status<300,this.statusText="statusText"in e?e.statusText:"OK",this.headers=new l(e.headers),this.url=e.url||"",this._initBody(t)}}("undefined"!=typeof self?self:this)},function(t,e,n){"use strict";var r=t.exports.Validator=n(163);t.exports.ValidatorResult=n(45).ValidatorResult,t.exports.ValidationError=n(45).ValidationError,t.exports.SchemaError=n(45).SchemaError,t.exports.SchemaScanResult=n(73).SchemaScanResult,t.exports.scan=n(73).scan,t.exports.validate=function(t,e,n){return(new r).validate(t,e,n)}},function(t,e,n){t.exports=!n(7)&&!n(3)(function(){return 7!=Object.defineProperty(n(74)("div"),"a",{get:function(){return 7}}).a})},function(t,e,n){e.f=n(5)},function(t,e,n){var r=n(14),i=n(15),a=n(57)(!1),o=n(76)("IE_PROTO");t.exports=function(t,e){var n,s=i(t),u=0,c=[];for(n in s)n!=o&&r(s,n)&&c.push(n);for(;e.length>u;)r(s,n=e[u++])&&(~a(c,n)||c.push(n));return c}},function(t,e,n){var r=n(8),i=n(1),a=n(35);t.exports=n(7)?Object.defineProperties:function(t,e){i(t);for(var n,o=a(e),s=o.length,u=0;s>u;)r.f(t,n=o[u++],e[n]);return t}},function(t,e,n){var r=n(15),i=n(38).f,a={}.toString,o="object"==typeof window&&window&&Object.getOwnPropertyNames?Object.getOwnPropertyNames(window):[];t.exports.f=function(t){return o&&"[object Window]"==a.call(t)?function(t){try{return i(t)}catch(t){return o.slice()}}(t):i(r(t))}},function(t,e,n){"use strict";var r=n(7),i=n(35),a=n(58),o=n(53),s=n(9),u=n(52),c=Object.assign;t.exports=!c||n(3)(function(){var t={},e={},n=Symbol(),r="abcdefghijklmnopqrst";return t[n]=7,r.split("").forEach(function(t){e[t]=t}),7!=c({},t)[n]||Object.keys(c({},e)).join("")!=r})?function(t,e){for(var n=s(t),c=arguments.length,l=1,f=a.f,h=o.f;c>l;)for(var d,p=u(arguments[l++]),v=f?i(p).concat(f(p)):i(p),g=v.length,m=0;g>m;)d=v[m++],r&&!h.call(p,d)||(n[d]=p[d]);return n}:c},function(t,e){t.exports=Object.is||function(t,e){return t===e?0!==t||1/t==1/e:t!=t&&e!=e}},function(t,e,n){"use strict";var r=n(10),i=n(4),a=n(117),o=[].slice,s={},u=function(t,e,n){if(!(e in s)){for(var r=[],i=0;i<e;i++)r[i]="a["+i+"]";s[e]=Function("F,a","return new F("+r.join(",")+")")}return s[e](t,n)};t.exports=Function.bind||function(t){var e=r(this),n=o.call(arguments,1),s=function(){var r=n.concat(o.call(arguments));return this instanceof s?u(e,r.length,r):a(e,r,t)};return i(e.prototype)&&(s.prototype=e.prototype),s}},function(t,e){t.exports=function(t,e,n){var r=void 0===n;switch(e.length){case 0:return r?t():t.call(n);case 1:return r?t(e[0]):t.call(n,e[0]);case 2:return r?t(e[0],e[1]):t.call(n,e[0],e[1]);case 3:return r?t(e[0],e[1],e[2]):t.call(n,e[0],e[1],e[2]);case 4:return r?t(e[0],e[1],e[2],e[3]):t.call(n,e[0],e[1],e[2],e[3])}return t.apply(n,e)}},function(t,e,n){var r=n(2).parseInt,i=n(48).trim,a=n(80),o=/^[-+]?0[xX]/;t.exports=8!==r(a+"08")||22!==r(a+"0x16")?function(t,e){var n=i(String(t),3);return r(n,e>>>0||(o.test(n)?16:10))}:r},function(t,e,n){var r=n(2).parseFloat,i=n(48).trim;t.exports=1/r(n(80)+"-0")!=-1/0?function(t){var e=i(String(t),3),n=r(e);return 0===n&&"-"==e.charAt(0)?-0:n}:r},function(t,e,n){var r=n(20);t.exports=function(t,e){if("number"!=typeof t&&"Number"!=r(t))throw TypeError(e);return+t}},function(t,e,n){var r=n(4),i=Math.floor;t.exports=function(t){return!r(t)&&isFinite(t)&&i(t)===t}},function(t,e){t.exports=Math.log1p||function(t){return(t=+t)>-1e-8&&t<1e-8?t-t*t/2:Math.log(1+t)}},function(t,e,n){var r=n(83),i=Math.pow,a=i(2,-52),o=i(2,-23),s=i(2,127)*(2-o),u=i(2,-126);t.exports=Math.fround||function(t){var e,n,i=Math.abs(t),c=r(t);return i<u?c*(i/u/o+1/a-1/a)*u*o:(n=(e=(1+o/a)*i)-(e-i))>s||n!=n?c*(1/0):c*n}},function(t,e,n){var r=n(1);t.exports=function(t,e,n,i){try{return i?e(r(n)[0],n[1]):e(n)}catch(e){var a=t.return;throw void 0!==a&&r(a.call(t)),e}}},function(t,e,n){var r=n(10),i=n(9),a=n(52),o=n(6);t.exports=function(t,e,n,s,u){r(e);var c=i(t),l=a(c),f=o(c.length),h=u?f-1:0,d=u?-1:1;if(n<2)for(;;){if(h in l){s=l[h],h+=d;break}if(h+=d,u?h<0:f<=h)throw TypeError("Reduce of empty array with no initial value")}for(;u?h>=0:f>h;h+=d)h in l&&(s=e(s,l[h],h,c));return s}},function(t,e,n){"use strict";var r=n(9),i=n(36),a=n(6);t.exports=[].copyWithin||function(t,e){var n=r(this),o=a(n.length),s=i(t,o),u=i(e,o),c=arguments.length>2?arguments[2]:void 0,l=Math.min((void 0===c?o:i(c,o))-u,o-s),f=1;for(u<s&&s<u+l&&(f=-1,u+=l-1,s+=l-1);l-- >0;)u in n?n[s]=n[u]:delete n[s],s+=f,u+=f;return n}},function(t,e){t.exports=function(t,e){return{value:e,done:!!t}}},function(t,e,n){"use strict";var r=n(95);n(0)({target:"RegExp",proto:!0,forced:r!==/./.exec},{exec:r})},function(t,e,n){n(7)&&"g"!=/./g.flags&&n(8).f(RegExp.prototype,"flags",{configurable:!0,get:n(54)})},function(t,e){t.exports=function(t){try{return{e:!1,v:t()}}catch(t){return{e:!0,v:t}}}},function(t,e,n){var r=n(1),i=n(4),a=n(99);t.exports=function(t,e){if(r(t),i(e)&&e.constructor===t)return e;var n=a.f(t);return(0,n.resolve)(e),n.promise}},function(t,e,n){"use strict";var r=n(133),i=n(43);t.exports=n(66)("Map",function(t){return function(){return t(this,arguments.length>0?arguments[0]:void 0)}},{get:function(t){var e=r.getEntry(i(this,"Map"),t);return e&&e.v},set:function(t,e){return r.def(i(this,"Map"),0===t?0:t,e)}},r,!0)},function(t,e,n){"use strict";var r=n(8).f,i=n(37),a=n(42),o=n(19),s=n(40),u=n(41),c=n(85),l=n(127),f=n(39),h=n(7),d=n(31).fastKey,p=n(43),v=h?"_s":"size",g=function(t,e){var n,r=d(e);if("F"!==r)return t._i[r];for(n=t._f;n;n=n.n)if(n.k==e)return n};t.exports={getConstructor:function(t,e,n,c){var l=t(function(t,r){s(t,l,e,"_i"),t._t=e,t._i=i(null),t._f=void 0,t._l=void 0,t[v]=0,null!=r&&u(r,n,t[c],t)});return a(l.prototype,{clear:function(){for(var t=p(this,e),n=t._i,r=t._f;r;r=r.n)r.r=!0,r.p&&(r.p=r.p.n=void 0),delete n[r.i];t._f=t._l=void 0,t[v]=0},delete:function(t){var n=p(this,e),r=g(n,t);if(r){var i=r.n,a=r.p;delete n._i[r.i],r.r=!0,a&&(a.n=i),i&&(i.p=a),n._f==r&&(n._f=i),n._l==r&&(n._l=a),n[v]--}return!!r},forEach:function(t){p(this,e);for(var n,r=o(t,arguments.length>1?arguments[1]:void 0,3);n=n?n.n:this._f;)for(r(n.v,n.k,this);n&&n.r;)n=n.p},has:function(t){return!!g(p(this,e),t)}}),h&&r(l.prototype,"size",{get:function(){return p(this,e)[v]}}),l},def:function(t,e,n){var r,i,a=g(t,e);return a?a.v=n:(t._l=a={i:i=d(e,!0),k:e,v:n,p:r=t._l,n:void 0,r:!1},t._f||(t._f=a),r&&(r.n=a),t[v]++,"F"!==i&&(t._i[i]=a)),t},getEntry:g,setStrong:function(t,e,n){c(t,e,function(t,n){this._t=p(t,e),this._k=n,this._l=void 0},function(){for(var t=this._k,e=this._l;e&&e.r;)e=e.p;return this._t&&(this._l=e=e?e.n:this._t._f)?l(0,"keys"==t?e.k:"values"==t?e.v:[e.k,e.v]):(this._t=void 0,l(1))},n?"entries":"values",!n,!0),f(e)}}},function(t,e,n){"use strict";var r=n(133),i=n(43);t.exports=n(66)("Set",function(t){return function(){return t(this,arguments.length>0?arguments[0]:void 0)}},{add:function(t){return r.def(i(this,"Set"),t=0===t?0:t,t)}},r)},function(t,e,n){"use strict";var r,i=n(2),a=n(26)(0),o=n(12),s=n(31),u=n(114),c=n(136),l=n(4),f=n(43),h=n(43),d=!i.ActiveXObject&&"ActiveXObject"in i,p=s.getWeak,v=Object.isExtensible,g=c.ufstore,m=function(t){return function(){return t(this,arguments.length>0?arguments[0]:void 0)}},y={get:function(t){if(l(t)){var e=p(t);return!0===e?g(f(this,"WeakMap")).get(t):e?e[this._i]:void 0}},set:function(t,e){return c.def(f(this,"WeakMap"),t,e)}},b=t.exports=n(66)("WeakMap",m,y,c,!0,!0);h&&d&&(u((r=c.getConstructor(m,"WeakMap")).prototype,y),s.NEED=!0,a(["delete","has","get","set"],function(t){var e=b.prototype,n=e[t];o(e,t,function(e,i){if(l(e)&&!v(e)){this._f||(this._f=new r);var a=this._f[t](e,i);return"set"==t?this:a}return n.call(this,e,i)})}))},function(t,e,n){"use strict";var r=n(42),i=n(31).getWeak,a=n(1),o=n(4),s=n(40),u=n(41),c=n(26),l=n(14),f=n(43),h=c(5),d=c(6),p=0,v=function(t){return t._l||(t._l=new g)},g=function(){this.a=[]},m=function(t,e){return h(t.a,function(t){return t[0]===e})};g.prototype={get:function(t){var e=m(this,t);if(e)return e[1]},has:function(t){return!!m(this,t)},set:function(t,e){var n=m(this,t);n?n[1]=e:this.a.push([t,e])},delete:function(t){var e=d(this.a,function(e){return e[0]===t});return~e&&this.a.splice(e,1),!!~e}},t.exports={getConstructor:function(t,e,n,a){var c=t(function(t,r){s(t,c,e,"_i"),t._t=e,t._i=p++,t._l=void 0,null!=r&&u(r,n,t[a],t)});return r(c.prototype,{delete:function(t){if(!o(t))return!1;var n=i(t);return!0===n?v(f(this,e)).delete(t):n&&l(n,this._i)&&delete n[this._i]},has:function(t){if(!o(t))return!1;var n=i(t);return!0===n?v(f(this,e)).has(t):n&&l(n,this._i)}}),c},def:function(t,e,n){var r=i(a(e),!0);return!0===r?v(t).set(e,n):r[t._i]=n,t},ufstore:v}},function(t,e,n){var r=n(21),i=n(6);t.exports=function(t){if(void 0===t)return 0;var e=r(t),n=i(e);if(e!==n)throw RangeError("Wrong length!");return n}},function(t,e,n){var r=n(38),i=n(58),a=n(1),o=n(2).Reflect;t.exports=o&&o.ownKeys||function(t){var e=r.f(a(t)),n=i.f;return n?e.concat(n(t)):e}},function(t,e,n){"use strict";var r=n(59),i=n(4),a=n(6),o=n(19),s=n(5)("isConcatSpreadable");t.exports=function t(e,n,u,c,l,f,h,d){for(var p,v,g=l,m=0,y=!!h&&o(h,d,3);m<c;){if(m in u){if(p=y?y(u[m],m,n):u[m],v=!1,i(p)&&(v=void 0!==(v=p[s])?!!v:r(p)),v&&f>0)g=t(e,n,p,a(p.length),g,f-1)-1;else{if(g>=9007199254740991)throw TypeError();e[g]=p}g++}m++}return g}},function(t,e,n){var r=n(6),i=n(82),a=n(24);t.exports=function(t,e,n,o){var s=String(a(t)),u=s.length,c=void 0===n?" ":String(n),l=r(e);if(l<=u||""==c)return s;var f=l-u,h=i.call(c,Math.ceil(f/c.length));return h.length>f&&(h=h.slice(0,f)),o?h+s:s+h}},function(t,e,n){var r=n(7),i=n(35),a=n(15),o=n(53).f;t.exports=function(t){return function(e){for(var n,s=a(e),u=i(s),c=u.length,l=0,f=[];c>l;)n=u[l++],r&&!o.call(s,n)||f.push(t?[n,s[n]]:s[n]);return f}}},function(t,e,n){var r=n(47),i=n(143);t.exports=function(t){return function(){if(r(this)!=t)throw TypeError(t+"#toJSON isn't generic");return i(this)}}},function(t,e,n){var r=n(41);t.exports=function(t,e){var n=[];return r(t,!1,n.push,n,e),n}},function(t,e){t.exports=Math.scale||function(t,e,n,r,i){return 0===arguments.length||t!=t||e!=e||n!=n||r!=r||i!=i?NaN:t===1/0||t===-1/0?t:(t-e)*(i-r)/(n-e)+r}},,function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var r=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}(),i=l(n(147)),a=l(n(148)),o=l(n(156)),s=l(n(159)),u=n(44),c=l(n(161));function l(t){return t&&t.__esModule?t:{default:t}}if(n(171),document.currentScript&&document.currentScript.src){var f=new URL(document.currentScript.src).href,h=f.substring(0,f.lastIndexOf("/"));n.p=h+n.p}var d=n(108).Validator,p=function(){function t(e){var n=this,r=!(arguments.length>1&&void 0!==arguments[1])||arguments[1],l=arguments.length>2&&void 0!==arguments[2]?arguments[2]:"test";if(function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,t),!e||void 0===e||"string"!=typeof e)return console.error("partnerID is mandatory and it must be string typed"),Object.create(null);this._state={partnerID:e,testing:r,environment:r?"test":l},this._state.apiVersion=(0,u.getApiVersion)(r,l),t.masks=o.default.masks[(0,u.getApiVersion)(r,l)],this._state.configuration={},this.analytics=new c.default;var f=(0,u.getUaAccount)(r,l);f&&(this.analytics.addTrackers([{provider:"ga",prefix:"RevieveSDK",account:f}]),this.analytics.setCustomDimensionToGaTracker(0,1,this._state.partnerID)),this.CV=new a.default(this),this.AR=new o.default(this),this.PR=new s.default(this);var h=function(t,e){n[t]=e},d={mounted:!1,initialize:function(){var t,e=(t=regeneratorRuntime.mark(function t(e){return regeneratorRuntime.wrap(function(t){for(;;)switch(t.prev=t.next){case 0:return t.abrupt("return",new Promise(function(t){e.partnerID=n._state.partnerID,(0,i.default)(e).then(function(e){var r=Object.assign(e,{mounted:!0,release:function(){n.liveAR.unmount(),h("liveAR",d)}});h("liveAR",r),t(r)})}));case 1:case"end":return t.stop()}},t,n)}),function(){var e=t.apply(this,arguments);return new Promise(function(t,n){return function r(i,a){try{var o=e[i](a),s=o.value}catch(t){return void n(t)}if(!o.done)return Promise.resolve(s).then(function(t){r("next",t)},function(t){r("throw",t)});t(s)}("next")})});return function(t){return e.apply(this,arguments)}}()};this.liveAR=d}return r(t,[{key:"getPartnerId",value:function(){return this._state.partnerID}},{key:"setUserId",value:function(t){this._state.userID=t}},{key:"getUserId",value:function(){return this._state.userID}},{key:"setApiVersion",value:function(t){u.apiVersionsAvailable.indexOf(t)>=0?this._state.apiVersion=t:(console.error("API version not supported"),console.log("API versions available are: "+JSON.stringify(u.apiVersionsAvailable)))}},{key:"getApiVersion",value:function(){return this._state.apiVersion}},{key:"isTesting",value:function(){return this._state.testing}},{key:"getEnvironment",value:function(){return this._state.environment}},{key:"setAnalytics",value:function(t){return this.analytics.setTrackers(t)}},{key:"getConfiguration",value:function(){return this._state.configuration}},{key:"getSeralizableState",value:function(){return{configuration:Object.assign({},this._state.configuration)}}},{key:"hydrateState",value:function(e){(new d).validate(e.configuration,t.stateConfigurationSchema).valid&&(this._state.configuration=Object.assign({},e.configuration))}},{key:"setConfiguration",value:function(e){return e?((new d).validate(e,t.stateConfigurationSchema).valid&&(this._state.configuration=Object.assign(this._state.configuration,e)),this._state.configuration):this._state.configuration}},{key:"getVariations",value:function(){return this._state.configuration.variations}},{key:"setVariations",value:function(t){this._state.configuration.variations=t}},{key:"getVariationByName",value:function(t){return this._state.configuration.variations?this._state.configuration.variations.filter(function(e){return e.variantName===t}):null}},{key:"getRequiredTags",value:function(){return this._state.configuration.requiredTags}},{key:"setRequiredTags",value:function(t){this._state.configuration.requiredTags=t}},{key:"addVariationAndRequiredTag",value:function(t,e,n,r){if(r){var i=this.getVariationByName(r);i&&0!==i.length||(i={variantName:r},e&&(this._state.configuration.variations||(this._state.configuration.variations=[]),this._state.configuration.variations.push(i))),!e&&this._state.configuration.variations?(this._state.configuration.variations=this._state.configuration.variations.filter(function(t){return t.variantName!==r}),0===this._state.configuration.variations.length&&delete this._state.configuration.variations):n&&(i.requiredTag||(i.required_tags=[]),i.required_tags.indexOf(t)<0?e&&i.required_tags.push(t):e||(i.required_tags=i.required_tags.filter(function(e){return e!==t}),0===i.required_tags.length&&(i.required_tags=null)))}else n&&(this._state.configuration.requiredTags||(this._state.configuration.requiredTags=[]),t.indexOf("_hair")>=0&&(this._state.configuration.requiredTags=this._state.configuration.requiredTags.filter(function(t){return t.indexOf("_hair")<0})),t.indexOf("_eyes")>=0&&(this._state.configuration.requiredTags=this._state.configuration.requiredTags.filter(function(t){return t.indexOf("_eyes")<0})),t.indexOf("_tone")>=0&&(this._state.configuration.requiredTags=this._state.configuration.requiredTags.filter(function(t){return t.indexOf("_tone")<0})),this._state.configuration.requiredTags.indexOf(t)<0?e&&this._state.configuration.requiredTags.push(t):e||(this._state.configuration.requiredTags=this._state.configuration.requiredTags.filter(function(e){return e!==t})),0===this._state.configuration.requiredTags.length&&delete this._state.configuration.requiredTags)}},{key:"setGender",value:function(t){this.isCorrectInEnumeration("gender",t)?(this._state.configuration.gender_ui=t,this.analytics.sendEvent("RevieveSDK.setGender",t)):console.error("Incorrect value for gender")}},{key:"setEyeColor",value:function(t){var e=arguments.length>1&&void 0!==arguments[1]&&arguments[1],n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:null;this.isCorrectInEnumeration("eyeColor",t)?(this._state.configuration.eye_color_ui=t,this.addVariationAndRequiredTag(t+"_eyes",t,e,n),this.analytics.sendEvent("RevieveSDK.setEyeColor",t)):console.error("Incorrect value for eyeColor")}},{key:"setHairColor",value:function(t){var e=arguments.length>1&&void 0!==arguments[1]&&arguments[1],n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:null;this.isCorrectInEnumeration("hairColor",t)?(this._state.configuration.hair_color_ui=t,this.addVariationAndRequiredTag(t+"_hair",t,e,n),this.analytics.sendEvent("RevieveSDK.setHairColor",t)):console.error("Incorrect value for hairColor")}},{key:"isCorrectInEnumeration",value:function(e,n){return void 0===n||Object.values(t[e]).indexOf(n)>=0}},{key:"setCategories",value:function(t){this._state.configuration.categories=t,this.analytics.sendEvent("RevieveSDK.setCategories",t)}},{key:"setMatchToSkintoneCategories",value:function(t){this._state.configuration.match_to_skintone=t,this.analytics.sendEvent("RevieveSDK.setMatchToSkintoneCategories",t)}},{key:"setAge",value:function(t){this._state.configuration.age_ui=t,this.analytics.sendEvent("RevieveSDK.setAge",t)}},{key:"setLat",value:function(t){this._state.configuration.lat=t,this.analytics.sendEvent("RevieveSDK.setLat",t)}},{key:"setLon",value:function(t){this._state.configuration.lon=t,this.analytics.sendEvent("RevieveSDK.setLon",t)}},{key:"setWrinkles",value:function(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:"ui";g("wrinkles",t)?(this._state.configuration["wrinkles_"+(e||"ui")]=t,"ui"===e&&this.analytics.sendEvent("RevieveSDK.setWrinkles",t)):console.error("Incorrect value for wrinkles")}},{key:"setEyebags",value:function(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:"ui";g("eyebags",t)?(this._state.configuration["eyebags_"+(e||"ui")]=t,"ui"===e&&this.analytics.sendEvent("RevieveSDK.setEyebags",t)):console.error("Incorrect value for eyebags")}},{key:"setRedness",value:function(t){g("redness",t)?this._state.configuration.redness_cv=t:console.error("Incorrect value for redness")}},{key:"setDarkSpots",value:function(t){g("darkSpots",t)?(this._state.configuration.dark_spots_ui=t,this.analytics.sendEvent("RevieveSDK.setDarkSpots",t)):console.error("Incorrect value for dark_spots")}},{key:"setSkintone",value:function(e){var n=arguments.length>1&&void 0!==arguments[1]&&arguments[1],r=this,i=arguments.length>2&&void 0!==arguments[2]?arguments[2]:null,a=!(arguments.length>3&&void 0!==arguments[3])||arguments[3];return new Promise(function(o,s){if(g("skintone",e)){if(r._state.configuration.skintone=e,r.addVariationAndRequiredTag(t.skintone[e]+"_tone",e,n,i),r.analytics.sendEvent("RevieveSDK.setSkintone",e),e>=1&&a)return r.CV.analyzeImage();o()}else console.error("Incorrect value for skintone"),s();return!0})}},{key:"getSkintone",value:function(){return this._state.configuration.skintone}},{key:"setSkintoneColor",value:function(t){if(this._state.configuration.skintone_color_cv=t,void 0!==t){this.AR._setSkintoneColor(t);var e=this.CV.detectSkintoneFromSkinColor(t);e&&this.setSkintone(parseInt(e,10),!1,null,!1),this.analytics.sendEvent("RevieveSDK.setSkintoneColor",t)}}},{key:"clearUIConfiguration",value:function(){var t=this;Object.keys(this._state.configuration).forEach(function(e){e.endsWith("_ui")&&delete t._state.configuration[e]})}},{key:"setCuperose",value:function(t){var e=arguments.length>1&&void 0!==arguments[1]&&arguments[1],n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:null;this._state.configuration.cuperose_ui=t?1:0,this.addVariationAndRequiredTag("cuperose",t,e,n),this.analytics.sendEvent("RevieveSDK.setCuperose",t)}},{key:"setRocasea",value:function(t){var e=arguments.length>1&&void 0!==arguments[1]&&arguments[1],n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:null;this._state.configuration.rocasea_ui=t?1:0,this.addVariationAndRequiredTag("rocasea",t,e,n),this.analytics.sendEvent("RevieveSDK.setRocasea",t)}},{key:"setAcne",value:function(t){var e=arguments.length>1&&void 0!==arguments[1]&&arguments[1],n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:null;this._state.configuration.acne_ui=t?1:0,this.addVariationAndRequiredTag("acne",t,e,n),this.analytics.sendEvent("RevieveSDK.setAcne",t)}},{key:"setEczema",value:function(t){var e=arguments.length>1&&void 0!==arguments[1]&&arguments[1],n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:null;this._state.configuration.eczema_ui=t?1:0,this.addVariationAndRequiredTag("eczema",t,e,n),this.analytics.sendEvent("RevieveSDK.setEczema",t)}},{key:"setHyperpigmentation",value:function(t){var e=arguments.length>1&&void 0!==arguments[1]&&arguments[1],n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:null;this._state.configuration.hyperpigmentation_ui=t?1:0,this.addVariationAndRequiredTag("hyperpigmentation",t,e,n),this.analytics.sendEvent("RevieveSDK.setHyperpigmentation",t)}},{key:"setOilyness",value:function(t){var e=arguments.length>1&&void 0!==arguments[1]&&arguments[1],n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:null;this._state.configuration.oilyness_ui=t?1:0,this.addVariationAndRequiredTag("oilyness",t,e,n),this.analytics.sendEvent("RevieveSDK.setOilyness",t)}},{key:"setDullTired",value:function(t){var e=arguments.length>1&&void 0!==arguments[1]&&arguments[1],n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:null;this._state.configuration.dull_tired_ui=t?1:0,this.addVariationAndRequiredTag("dull_tired",t,e,n),this.analytics.sendEvent("RevieveSDK.setDullTired",t)}},{key:"setPsoriasis",value:function(t){var e=arguments.length>1&&void 0!==arguments[1]&&arguments[1],n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:null;this._state.configuration.psoriasis_ui=t?1:0,this.addVariationAndRequiredTag("psoriasis",t,e,n),this.analytics.sendEvent("RevieveSDK.setPsoriasis",t)}},{key:"setOrganic",value:function(t){var e=arguments.length>1&&void 0!==arguments[1]&&arguments[1],n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:null;this._state.configuration.organic_ui=t?1:0,this.addVariationAndRequiredTag("organic",t,e,n),this.analytics.sendEvent("RevieveSDK.setOrganic",t)}},{key:"setAntiAge",value:function(t){var e=arguments.length>1&&void 0!==arguments[1]&&arguments[1],n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:null;this._state.configuration.anti_age_ui=t?1:0,this.addVariationAndRequiredTag("anti_age",t,e,n),this.analytics.sendEvent("RevieveSDK.setAntiAge",t)}},{key:"setFragranceFree",value:function(t){var e=arguments.length>1&&void 0!==arguments[1]&&arguments[1],n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:null;this._state.configuration.fragrance_free_ui=t?1:0,this.addVariationAndRequiredTag("fragrance_free",t,e,n),this.analytics.sendEvent("RevieveSDK.setFragranceFree",t)}},{key:"setParabenFree",value:function(t){var e=arguments.length>1&&void 0!==arguments[1]&&arguments[1],n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:null;this._state.configuration.paraben_free_ui=t?1:0,this.addVariationAndRequiredTag("paraben_free",t,e,n),this.analytics.sendEvent("RevieveSDK.setParabenFree",t)}},{key:"setSunProtection",value:function(t){var e=arguments.length>1&&void 0!==arguments[1]&&arguments[1],n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:null;this._state.configuration.sun_protection_ui=t?1:0,this.addVariationAndRequiredTag("sun_protection",t,e,n),this.analytics.sendEvent("RevieveSDK.setSunProtection",t)}},{key:"setSkinBrightening",value:function(t){var e=arguments.length>1&&void 0!==arguments[1]&&arguments[1],n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:null;this._state.configuration.skin_brightening_ui=t?1:0,this.addVariationAndRequiredTag("skin_brightening",t,e,n),this.analytics.sendEvent("RevieveSDK.setSkinBrightening",t)}},{key:"setSkinFirming",value:function(t){var e=arguments.length>1&&void 0!==arguments[1]&&arguments[1],n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:null;this._state.configuration.skin_firming_ui=t?1:0,this.addVariationAndRequiredTag("skin_firming",t,e,n),this.analytics.sendEvent("RevieveSDK.setSkinFirming",t)}},{key:"setCustomAttribute",value:function(t,e){var n=arguments.length>2&&void 0!==arguments[2]&&arguments[2],r=arguments.length>3&&void 0!==arguments[3]?arguments[3]:null;this._state.configuration[t]=e,this.addVariationAndRequiredTag(t,e,n,r),this.analytics.sendEvent("RevieveSDK.setCustomAttribute",t+"_"+e)}},{key:"setSkintype",value:function(e){var n=this;Object.values(t.skinTypes).forEach(function(t){n._state.configuration[t]=t===e?1:0}),this.analytics.sendEvent("RevieveSDK.setSkintype",e)}},{key:"getState",value:function(){return this._state}}]),t}(),v={wrinkles:{min:0,max:1},eyebags:{min:0,max:1},redness:{min:0,max:1},darkSpots:{min:0,max:1},skintone:{min:0,max:6}};function g(t,e){if(void 0===e)return!0;var n=v[t];return!!n&&(e>=n.min&&e<=n.max)}p.gender={FEMALE:"female",MALE:"male"},p.skinTypes={NORMAL:"normal",DRY:"dry",COMBINATION:"combination",OILY:"oily",SENSITIVE:"sensitive"},p.eyeColor={BLUE:"blue",BROWN:"brown",GREEN:"green",HAZEL:"hazel"},p.hairColor={BLACK:"black",BLONDE:"blonde",BROWN:"brown",RED:"red",SILVER:"silver"},p.skintone={0:"",1:"light",2:"fair",3:"medium",4:"olive",5:"tan",6:"dark"},p.masks=o.default.masks[(0,u.getApiVersion)(!1)],p.defaultStrength=o.default.defaultStrength,p.makeupMeasures=o.default.makeupMeasures,p.stateConfigurationSchema={id:"/stateConfiguration",type:"object",properties:{gender_ui:{type:"string",enum:["male","female"]},categories:{type:"array",items:{type:"string"}},age_ui:{type:"number",minimum:1900},lat:{type:"number"},lon:{type:"number"},wrinkles_ui:{type:"number",minimum:0,maximun:1,description:"wrinkles"},eyebags_ui:{type:"number",minimum:0,maximun:1,description:"eyebags"},dark_spots_ui:{type:"number",minimum:0,maximun:1,description:"dark spots"},wrinkles_cv:{type:"number",minimum:0,maximun:1,description:"wrinkles propossed"},eyebags_cv:{type:"number",minimum:0,maximun:1,description:"eyebags propossed"},redness_cv:{type:"number",minimum:0,maximun:1,description:"redness propossed"},cuperose_ui:{type:"number",minimum:0,maximun:1,description:"cuperose"},rocasea_ui:{type:"number",minimum:0,maximun:1,description:"rocasea"},acne_ui:{type:"number",minimum:0,maximun:1,description:"acne"},eczema_ui:{type:"number",minimum:0,maximun:1,description:"eczema"},hyperpigmentation_ui:{type:"number",minimum:0,maximun:1,description:"hyperpigmentation"},oilyness_ui:{type:"number",minimum:0,maximun:1,description:"oilyness skin"},dull_tired_ui:{type:"number",minimum:0,maximun:1,description:"dull and tired skin"},psoriasis_ui:{type:"number",minimum:0,maximun:1,description:"psoriasis"},normal_skin_ui:{type:"number",minimum:0,maximun:1,description:"normal skin"},dry_skin_ui:{type:"number",minimum:0,maximun:1,description:"dry skin"},combination_skin_ui:{type:"number",minimum:0,maximun:1,description:"combination skin"},oily_skin_ui:{type:"number",minimum:0,maximun:1,description:"oily skin"},sensitive_skin_ui:{type:"number",minimum:0,maximun:1,description:"sensitive skin"},organic_ui:{type:"number",minimum:0,maximun:1,description:"organic products"},anti_age_ui:{type:"number",minimum:0,maximun:1,description:"anti age products"},fragrance_free_ui:{type:"number",minimum:0,maximun:1,description:"fragrance free products"},paraben_free_ui:{type:"number",minimum:0,maximun:1,description:"paraben free products"},sun_protection_ui:{type:"number",minimum:0,maximun:1,description:"sun protection products"},skin_brightening_ui:{type:"number",minimum:0,maximun:1,description:"skin brightening products"},skin_firming_ui:{type:"number",minimum:0,maximun:1,description:"skin firming products"},makeup_day:{type:"number",minimum:0,maximun:1,description:"Makeup for day"},makeup_night:{type:"number",minimum:0,maximun:1,description:"Makeup for night"},components:{type:"array",items:{type:"string",enum:["eyes","wrinkles","redness","hyperpigmentation","texture","smoothness","makeup","masks","wrinkles_visualization","hyperpigmentation_visualization","ar_landmarks","ar_coordinates","shine","shine_visualization","acne","acne_visualization"]}}}},p.effectsCatalog=Object.keys(o.default.effectBundles).map(function(t){return{method:t,type:o.default.effectBundles[t].type,description:o.default.effectBundles[t].description,parameters:o.default.effectBundles[t].parameters}}),p.analyticsProvidersAvailable=c.default.providersAvailable,window.RevieveSDK=p,e.default=p},function(t,e,n){window,t.exports=function(t){function e(e){for(var n,i,a=e[0],o=e[1],s=0,c=[];s<a.length;s++)i=a[s],r[i]&&c.push(r[i][0]),r[i]=0;for(n in o)Object.prototype.hasOwnProperty.call(o,n)&&(t[n]=o[n]);for(u&&u(e);c.length;)c.shift()()}var n={},r={2:0};function i(e){if(n[e])return n[e].exports;var r=n[e]={i:e,l:!1,exports:{}};return t[e].call(r.exports,r,r.exports,i),r.l=!0,r.exports}i.e=function(t){var e=[],n=r[t];if(0!==n)if(n)e.push(n[2]);else{var a=new Promise(function(e,i){n=r[t]=[e,i]});e.push(n[2]=a);var o,s=document.createElement("script");s.charset="utf-8",s.timeout=120,i.nc&&s.setAttribute("nonce",i.nc),s.src=function(t){return i.p+"dependencies/"+({0:"js-1",1:"js-2",3:"wasm-1",4:"wasm-2"}[t]||t)+".js"}(t),o=function(e){s.onerror=s.onload=null,clearTimeout(u);var n=r[t];if(0!==n){if(n){var i=e&&("load"===e.type?"missing":e.type),a=e&&e.target&&e.target.src,o=new Error("Loading chunk "+t+" failed.\n("+i+": "+a+")");o.type=i,o.request=a,n[1](o)}r[t]=void 0}};var u=setTimeout(function(){o({type:"timeout",target:s})},12e4);s.onerror=s.onload=o,document.head.appendChild(s)}return Promise.all(e)},i.m=t,i.c=n,i.d=function(t,e,n){i.o(t,e)||Object.defineProperty(t,e,{enumerable:!0,get:n})},i.r=function(t){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(t,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(t,"__esModule",{value:!0})},i.t=function(t,e){if(1&e&&(t=i(t)),8&e)return t;if(4&e&&"object"==typeof t&&t&&t.__esModule)return t;var n=Object.create(null);if(i.r(n),Object.defineProperty(n,"default",{enumerable:!0,value:t}),2&e&&"string"!=typeof t)for(var r in t)i.d(n,r,function(e){return t[e]}.bind(null,r));return n},i.n=function(t){var e=t&&t.__esModule?function(){return t.default}:function(){return t};return i.d(e,"a",e),e},i.o=function(t,e){return Object.prototype.hasOwnProperty.call(t,e)},i.p="/",i.oe=function(t){throw console.error(t),t};var a=window.webpackJsonp=window.webpackJsonp||[],o=a.push.bind(a);a.push=e,a=a.slice();for(var s=0;s<a.length;s++)e(a[s]);var u=o;return i(i.s=37)}([function(t,e,n){var r=n(20),i=n(21),a=n(22);t.exports=function(t){return r(t)||i(t)||a()}},function(t,e,n){t.exports=n(18)},function(t,e){t.exports=function(t,e,n){return e in t?Object.defineProperty(t,e,{value:n,enumerable:!0,configurable:!0,writable:!0}):t[e]=n,t}},function(t,e,n){var r=n(2);t.exports=function(t){for(var e=1;e<arguments.length;e++){var n=null!=arguments[e]?arguments[e]:{},i=Object.keys(n);"function"==typeof Object.getOwnPropertySymbols&&(i=i.concat(Object.getOwnPropertySymbols(n).filter(function(t){return Object.getOwnPropertyDescriptor(n,t).enumerable}))),i.forEach(function(e){r(t,e,n[e])})}return t}},function(t,e,n){var r=n(15),i=n(16),a=n(17);t.exports=function(t,e){return r(t)||i(t,e)||a()}},function(t,e){function n(t,e,n,r,i,a,o){try{var s=t[a](o),u=s.value}catch(t){return void n(t)}s.done?e(u):Promise.resolve(u).then(r,i)}t.exports=function(t){return function(){var e=this,r=arguments;return new Promise(function(i,a){var o=t.apply(e,r);function s(t){n(o,i,a,s,u,"next",t)}function u(t){n(o,i,a,s,u,"throw",t)}s(void 0)})}}},function(t,e,n){t.exports=function(){"use strict";var t=function(){var e=0,n=document.createElement("div");function r(t){return n.appendChild(t.dom),t}function i(t){for(var r=0;r<n.children.length;r++)n.children[r].style.display=r===t?"block":"none";e=t}n.style.cssText="position:fixed;top:0;left:0;cursor:pointer;opacity:0.9;z-index:10000",n.addEventListener("click",function(t){t.preventDefault(),i(++e%n.children.length)},!1);var a=(performance||Date).now(),o=a,s=0,u=r(new t.Panel("FPS","#0ff","#002")),c=r(new t.Panel("MS","#0f0","#020"));if(self.performance&&self.performance.memory)var l=r(new t.Panel("MB","#f08","#201"));return i(0),{REVISION:16,dom:n,addPanel:r,showPanel:i,begin:function(){a=(performance||Date).now()},end:function(){s++;var t=(performance||Date).now();if(c.update(t-a,200),o+1e3<=t&&(u.update(1e3*s/(t-o),100),o=t,s=0,l)){var e=performance.memory;l.update(e.usedJSHeapSize/1048576,e.jsHeapSizeLimit/1048576)}return t},update:function(){a=this.end()},domElement:n,setMode:i}};return t.Panel=function(t,e,n){var r=1/0,i=0,a=Math.round,o=a(window.devicePixelRatio||1),s=80*o,u=48*o,c=3*o,l=2*o,f=3*o,h=15*o,d=74*o,p=30*o,v=document.createElement("canvas");v.width=s,v.height=u,v.style.cssText="width:80px;height:48px";var g=v.getContext("2d");return g.font="bold "+9*o+"px Helvetica,Arial,sans-serif",g.textBaseline="top",g.fillStyle=n,g.fillRect(0,0,s,u),g.fillStyle=e,g.fillText(t,c,l),g.fillRect(f,h,d,p),g.fillStyle=n,g.globalAlpha=.9,g.fillRect(f,h,d,p),{dom:v,update:function(u,m){r=Math.min(r,u),i=Math.max(i,u),g.fillStyle=n,g.globalAlpha=1,g.fillRect(0,0,s,h),g.fillStyle=e,g.fillText(a(u)+" "+t+" ("+a(r)+"-"+a(i)+")",c,l),g.drawImage(v,f+o,h,d-o,p,f,h,d-o,p),g.fillRect(f+d-o,h,o,p),g.fillStyle=n,g.globalAlpha=.9,g.fillRect(f+d-o,h,o,a((1-u/m)*p))}}},t}()},function(t,e){t.exports=function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}},function(t,e,n){"use strict";t.exports=function(t,e,n){var i=t*e,a=r*t,o=a-(a-t),s=t-o,u=r*e,c=u-(u-e),l=e-c,f=s*l-(i-o*c-s*c-o*l);return n?(n[0]=f,n[1]=i,n):[f,i]};var r=+(Math.pow(2,27)+1)},function(t,e){function n(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}t.exports=function(t,e,r){return e&&n(t.prototype,e),r&&n(t,r),t}},function(t,e){function n(t){return(n="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function r(e){return"function"==typeof Symbol&&"symbol"===n(Symbol.iterator)?t.exports=r=function(t){return n(t)}:t.exports=r=function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":n(t)},r(e)}t.exports=r},function(t,e,n){"use strict";var r=n(23),i=n(32);function a(t,e){this.point=t,this.index=e}function o(t,e){for(var n=t.point,r=e.point,i=n.length,a=0;a<i;++a){var o=r[a]-n[a];if(o)return o}return 0}t.exports=function(t,e){var n=t.length;if(0===n)return[];var s=t[0].length;if(s<1)return[];if(1===s)return function(t,e,n){if(1===t)return n?[[-1,0]]:[];var r=e.map(function(t,e){return[t[0],e]});r.sort(function(t,e){return t[0]-e[0]});for(var i=new Array(t-1),a=1;a<t;++a){var o=r[a-1],s=r[a];i[a-1]=[o[1],s[1]]}return n&&i.push([-1,i[0][1]],[i[t-1][1],-1]),i}(n,t,e);for(var u=new Array(n),c=1,l=0;l<n;++l){for(var f=t[l],h=new Array(s+1),d=0,p=0;p<s;++p){var v=f[p];h[p]=v,d+=v*v}h[s]=d,u[l]=new a(h,l),c=Math.max(d,c)}i(u,o),n=u.length;for(var g=new Array(n+s+1),m=new Array(n+s+1),y=(s+1)*(s+1)*c,b=new Array(s+1),l=0;l<=s;++l)b[l]=0;b[s]=y,g[0]=b.slice(),m[0]=-1;for(var l=0;l<=s;++l){var h=b.slice();h[l]=1,g[l+1]=h,m[l+1]=-1}for(var l=0;l<n;++l){var w=u[l];g[l+s+1]=w.point,m[l+s+1]=w.index}var x=r(g,!1);if(x=e?x.filter(function(t){for(var e=0,n=0;n<=s;++n){var r=m[t[n]];if(r<0&&++e>=2)return!1;t[n]=r}return!0}):x.filter(function(t){for(var e=0;e<=s;++e){var n=m[t[e]];if(n<0)return!1;t[e]=n}return!0}),1&s)for(var l=0;l<x.length;++l){var w=x[l],h=w[0];w[0]=w[1],w[1]=h}return x}},function(t,e,n){var r,i,a;i=[],void 0===(a="function"==typeof(r=function(){"use strict";return function(t,e,n){e=e||"",n=n||512;for(var r=atob(t),i=[],a=0;a<r.length;a+=n){for(var o=r.slice(a,a+n),s=new Array(o.length),u=0;u<o.length;u++)s[u]=o.charCodeAt(u);var c=new Uint8Array(s);i.push(c)}var l=new Blob(i,{type:e});return l}})?r.apply(e,i):r)||(t.exports=a)},function(t,e,n){var r,i,a;i=[e],void 0===(a="function"==typeof(r=function(t){"use strict";function e(t){if(Array.isArray(t)){for(var e=0,n=Array(t.length);e<t.length;e++)n[e]=t[e];return n}return Array.from(t)}Object.defineProperty(t,"__esModule",{value:!0});var n=!1;if("undefined"!=typeof window){var r={get passive(){n=!0}};window.addEventListener("testPassive",null,r),window.removeEventListener("testPassive",null,r)}var i="undefined"!=typeof window&&window.navigator&&window.navigator.platform&&/iP(ad|hone|od)/.test(window.navigator.platform),a=[],o=!1,s=-1,u=void 0,c=void 0,l=function(t){return a.some(function(e){return!(!e.options.allowTouchMove||!e.options.allowTouchMove(t))})},f=function(t){var e=t||window.event;return!!l(e.target)||1<e.touches.length||(e.preventDefault&&e.preventDefault(),!1)},h=function(){setTimeout(function(){void 0!==c&&(document.body.style.paddingRight=c,c=void 0),void 0!==u&&(document.body.style.overflow=u,u=void 0)})};t.disableBodyScroll=function(t,r){if(i){if(!t)return void console.error("disableBodyScroll unsuccessful - targetElement must be provided when calling disableBodyScroll on IOS devices.");if(t&&!a.some(function(e){return e.targetElement===t})){var h={targetElement:t,options:r||{}};a=[].concat(e(a),[h]),t.ontouchstart=function(t){1===t.targetTouches.length&&(s=t.targetTouches[0].clientY)},t.ontouchmove=function(e){var n,r,i,a;1===e.targetTouches.length&&(r=t,a=(n=e).targetTouches[0].clientY-s,!l(n.target)&&(r&&0===r.scrollTop&&0<a?f(n):(i=r)&&i.scrollHeight-i.scrollTop<=i.clientHeight&&a<0?f(n):n.stopPropagation()))},o||(document.addEventListener("touchmove",f,n?{passive:!1}:void 0),o=!0)}}else{p=r,setTimeout(function(){if(void 0===c){var t=!!p&&!0===p.reserveScrollBarGap,e=window.innerWidth-document.documentElement.clientWidth;t&&0<e&&(c=document.body.style.paddingRight,document.body.style.paddingRight=e+"px")}void 0===u&&(u=document.body.style.overflow,document.body.style.overflow="hidden")});var d={targetElement:t,options:r||{}};a=[].concat(e(a),[d])}var p},t.clearAllBodyScrollLocks=function(){i?(a.forEach(function(t){t.targetElement.ontouchstart=null,t.targetElement.ontouchmove=null}),o&&(document.removeEventListener("touchmove",f,n?{passive:!1}:void 0),o=!1),a=[],s=-1):(h(),a=[])},t.enableBodyScroll=function(t){if(i){if(!t)return void console.error("enableBodyScroll unsuccessful - targetElement must be provided when calling enableBodyScroll on IOS devices.");t.ontouchstart=null,t.ontouchmove=null,a=a.filter(function(e){return e.targetElement!==t}),o&&0===a.length&&(document.removeEventListener("touchmove",f,n?{passive:!1}:void 0),o=!1)}else 1===a.length&&a[0].targetElement===t?(h(),a=[]):a=a.filter(function(e){return e.targetElement!==t})}})?r.apply(e,i):r)||(t.exports=a)},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.default=function(t,e,n){return(0,i.default)(t).then((0,r.default)(e,n))};var r=a(n(33)),i=a(n(34));function a(t){return t&&t.__esModule?t:{default:t}}},function(t,e){t.exports=function(t){if(Array.isArray(t))return t}},function(t,e){t.exports=function(t,e){var n=[],r=!0,i=!1,a=void 0;try{for(var o,s=t[Symbol.iterator]();!(r=(o=s.next()).done)&&(n.push(o.value),!e||n.length!==e);r=!0);}catch(t){i=!0,a=t}finally{try{r||null==s.return||s.return()}finally{if(i)throw a}}return n}},function(t,e){t.exports=function(){throw new TypeError("Invalid attempt to destructure non-iterable instance")}},function(t,e,n){var r=function(){return this||"object"==typeof self&&self}()||Function("return this")(),i=r.regeneratorRuntime&&Object.getOwnPropertyNames(r).indexOf("regeneratorRuntime")>=0,a=i&&r.regeneratorRuntime;if(r.regeneratorRuntime=void 0,t.exports=n(19),i)r.regeneratorRuntime=a;else try{delete r.regeneratorRuntime}catch(t){r.regeneratorRuntime=void 0}},function(t,e){!function(e){"use strict";var n,r=Object.prototype,i=r.hasOwnProperty,a="function"==typeof Symbol?Symbol:{},o=a.iterator||"@@iterator",s=a.asyncIterator||"@@asyncIterator",u=a.toStringTag||"@@toStringTag",c="object"==typeof t,l=e.regeneratorRuntime;if(l)c&&(t.exports=l);else{(l=e.regeneratorRuntime=c?t.exports:{}).wrap=w;var f="suspendedStart",h="suspendedYield",d="executing",p="completed",v={},g={};g[o]=function(){return this};var m=Object.getPrototypeOf,y=m&&m(m(F([])));y&&y!==r&&i.call(y,o)&&(g=y);var b=S.prototype=E.prototype=Object.create(g);_.prototype=b.constructor=S,S.constructor=_,S[u]=_.displayName="GeneratorFunction",l.isGeneratorFunction=function(t){var e="function"==typeof t&&t.constructor;return!!e&&(e===_||"GeneratorFunction"===(e.displayName||e.name))},l.mark=function(t){return Object.setPrototypeOf?Object.setPrototypeOf(t,S):(t.__proto__=S,u in t||(t[u]="GeneratorFunction")),t.prototype=Object.create(b),t},l.awrap=function(t){return{__await:t}},k(P.prototype),P.prototype[s]=function(){return this},l.AsyncIterator=P,l.async=function(t,e,n,r){var i=new P(w(t,e,n,r));return l.isGeneratorFunction(e)?i:i.next().then(function(t){return t.done?t.value:i.next()})},k(b),b[u]="Generator",b[o]=function(){return this},b.toString=function(){return"[object Generator]"},l.keys=function(t){var e=[];for(var n in t)e.push(n);return e.reverse(),function n(){for(;e.length;){var r=e.pop();if(r in t)return n.value=r,n.done=!1,n}return n.done=!0,n}},l.values=F,I.prototype={constructor:I,reset:function(t){if(this.prev=0,this.next=0,this.sent=this._sent=n,this.done=!1,this.delegate=null,this.method="next",this.arg=n,this.tryEntries.forEach(C),!t)for(var e in this)"t"===e.charAt(0)&&i.call(this,e)&&!isNaN(+e.slice(1))&&(this[e]=n)},stop:function(){this.done=!0;var t=this.tryEntries[0].completion;if("throw"===t.type)throw t.arg;return this.rval},dispatchException:function(t){if(this.done)throw t;var e=this;function r(r,i){return s.type="throw",s.arg=t,e.next=r,i&&(e.method="next",e.arg=n),!!i}for(var a=this.tryEntries.length-1;a>=0;--a){var o=this.tryEntries[a],s=o.completion;if("root"===o.tryLoc)return r("end");if(o.tryLoc<=this.prev){var u=i.call(o,"catchLoc"),c=i.call(o,"finallyLoc");if(u&&c){if(this.prev<o.catchLoc)return r(o.catchLoc,!0);if(this.prev<o.finallyLoc)return r(o.finallyLoc)}else if(u){if(this.prev<o.catchLoc)return r(o.catchLoc,!0)}else{if(!c)throw new Error("try statement without catch or finally");if(this.prev<o.finallyLoc)return r(o.finallyLoc)}}}},abrupt:function(t,e){for(var n=this.tryEntries.length-1;n>=0;--n){var r=this.tryEntries[n];if(r.tryLoc<=this.prev&&i.call(r,"finallyLoc")&&this.prev<r.finallyLoc){var a=r;break}}a&&("break"===t||"continue"===t)&&a.tryLoc<=e&&e<=a.finallyLoc&&(a=null);var o=a?a.completion:{};return o.type=t,o.arg=e,a?(this.method="next",this.next=a.finallyLoc,v):this.complete(o)},complete:function(t,e){if("throw"===t.type)throw t.arg;return"break"===t.type||"continue"===t.type?this.next=t.arg:"return"===t.type?(this.rval=this.arg=t.arg,this.method="return",this.next="end"):"normal"===t.type&&e&&(this.next=e),v},finish:function(t){for(var e=this.tryEntries.length-1;e>=0;--e){var n=this.tryEntries[e];if(n.finallyLoc===t)return this.complete(n.completion,n.afterLoc),C(n),v}},catch:function(t){for(var e=this.tryEntries.length-1;e>=0;--e){var n=this.tryEntries[e];if(n.tryLoc===t){var r=n.completion;if("throw"===r.type){var i=r.arg;C(n)}return i}}throw new Error("illegal catch attempt")},delegateYield:function(t,e,r){return this.delegate={iterator:F(t),resultName:e,nextLoc:r},"next"===this.method&&(this.arg=n),v}}}function w(t,e,n,r){var i=e&&e.prototype instanceof E?e:E,a=Object.create(i.prototype),o=new I(r||[]);return a._invoke=function(t,e,n){var r=f;return function(i,a){if(r===d)throw new Error("Generator is already running");if(r===p){if("throw"===i)throw a;return O()}for(n.method=i,n.arg=a;;){var o=n.delegate;if(o){var s=R(o,n);if(s){if(s===v)continue;return s}}if("next"===n.method)n.sent=n._sent=n.arg;else if("throw"===n.method){if(r===f)throw r=p,n.arg;n.dispatchException(n.arg)}else"return"===n.method&&n.abrupt("return",n.arg);r=d;var u=x(t,e,n);if("normal"===u.type){if(r=n.done?p:h,u.arg===v)continue;return{value:u.arg,done:n.done}}"throw"===u.type&&(r=p,n.method="throw",n.arg=u.arg)}}}(t,n,o),a}function x(t,e,n){try{return{type:"normal",arg:t.call(e,n)}}catch(t){return{type:"throw",arg:t}}}function E(){}function _(){}function S(){}function k(t){["next","throw","return"].forEach(function(e){t[e]=function(t){return this._invoke(e,t)}})}function P(t){var e;this._invoke=function(n,r){function a(){return new Promise(function(e,a){!function e(n,r,a,o){var s=x(t[n],t,r);if("throw"!==s.type){var u=s.arg,c=u.value;return c&&"object"==typeof c&&i.call(c,"__await")?Promise.resolve(c.__await).then(function(t){e("next",t,a,o)},function(t){e("throw",t,a,o)}):Promise.resolve(c).then(function(t){u.value=t,a(u)},function(t){return e("throw",t,a,o)})}o(s.arg)}(n,r,e,a)})}return e=e?e.then(a,a):a()}}function R(t,e){var r=t.iterator[e.method];if(r===n){if(e.delegate=null,"throw"===e.method){if(t.iterator.return&&(e.method="return",e.arg=n,R(t,e),"throw"===e.method))return v;e.method="throw",e.arg=new TypeError("The iterator does not provide a 'throw' method")}return v}var i=x(r,t.iterator,e.arg);if("throw"===i.type)return e.method="throw",e.arg=i.arg,e.delegate=null,v;var a=i.arg;return a?a.done?(e[t.resultName]=a.value,e.next=t.nextLoc,"return"!==e.method&&(e.method="next",e.arg=n),e.delegate=null,v):a:(e.method="throw",e.arg=new TypeError("iterator result is not an object"),e.delegate=null,v)}function A(t){var e={tryLoc:t[0]};1 in t&&(e.catchLoc=t[1]),2 in t&&(e.finallyLoc=t[2],e.afterLoc=t[3]),this.tryEntries.push(e)}function C(t){var e=t.completion||{};e.type="normal",delete e.arg,t.completion=e}function I(t){this.tryEntries=[{tryLoc:"root"}],t.forEach(A,this),this.reset(!0)}function F(t){if(t){var e=t[o];if(e)return e.call(t);if("function"==typeof t.next)return t;if(!isNaN(t.length)){var r=-1,a=function e(){for(;++r<t.length;)if(i.call(t,r))return e.value=t[r],e.done=!1,e;return e.value=n,e.done=!0,e};return a.next=a}}return{next:O}}function O(){return{value:n,done:!0}}}(function(){return this||"object"==typeof self&&self}()||Function("return this")())},function(t,e){t.exports=function(t){if(Array.isArray(t)){for(var e=0,n=new Array(t.length);e<t.length;e++)n[e]=t[e];return n}}},function(t,e){t.exports=function(t){if(Symbol.iterator in Object(t)||"[object Arguments]"===Object.prototype.toString.call(t))return Array.from(t)}},function(t,e){t.exports=function(){throw new TypeError("Invalid attempt to spread non-iterable instance")}},function(t,e,n){"use strict";t.exports=function(t,e){var n=t.length;if(0===n)throw new Error("Must have at least d+1 points");var i=t[0].length;if(n<=i)throw new Error("Must input at least d+1 points");var o=t.slice(0,i+1),s=r.apply(void 0,o);if(0===s)throw new Error("Input not in general position");for(var u=new Array(i+1),l=0;l<=i;++l)u[l]=l;s<0&&(u[0]=1,u[1]=0);for(var f=new a(u,new Array(i+1),!1),h=f.adjacent,d=new Array(i+2),l=0;l<=i;++l){for(var p=u.slice(),v=0;v<=i;++v)v===l&&(p[v]=-1);var g=p[0];p[0]=p[1],p[1]=g;var m=new a(p,new Array(i+1),!0);h[l]=m,d[l]=m}d[i+1]=f;for(var l=0;l<=i;++l)for(var p=h[l].vertices,y=h[l].adjacent,v=0;v<=i;++v){var b=p[v];if(b<0)y[v]=f;else for(var w=0;w<=i;++w)h[w].vertices.indexOf(b)<0&&(y[v]=h[w])}for(var x=new c(i,o,d),E=!!e,l=i+1;l<n;++l)x.insert(t[l],E);return x.boundary()};var r=n(24),i=n(29).compareCells;function a(t,e,n){this.vertices=t,this.adjacent=e,this.boundary=n,this.lastVisited=-1}function o(t,e,n){this.vertices=t,this.cell=e,this.index=n}function s(t,e){return i(t.vertices,e.vertices)}a.prototype.flip=function(){var t=this.vertices[0];this.vertices[0]=this.vertices[1],this.vertices[1]=t;var e=this.adjacent[0];this.adjacent[0]=this.adjacent[1],this.adjacent[1]=e};var u=[];function c(t,e,n){this.dimension=t,this.vertices=e,this.simplices=n,this.interior=n.filter(function(t){return!t.boundary}),this.tuple=new Array(t+1);for(var i=0;i<=t;++i)this.tuple[i]=this.vertices[i];var a=u[t];a||(a=u[t]=function(t){for(var e=["function orient(){var tuple=this.tuple;return test("],n=0;n<=t;++n)n>0&&e.push(","),e.push("tuple[",n,"]");e.push(")}return orient");var i=new Function("test",e.join("")),a=r[t+1];return a||(a=r),i(a)}(t)),this.orient=a}var l=c.prototype;l.handleBoundaryDegeneracy=function(t,e){var n=this.dimension,r=this.vertices.length-1,i=this.tuple,a=this.vertices,o=[t];for(t.lastVisited=-r;o.length>0;){(t=o.pop()).vertices;for(var s=t.adjacent,u=0;u<=n;++u){var c=s[u];if(c.boundary&&!(c.lastVisited<=-r)){for(var l=c.vertices,f=0;f<=n;++f){var h=l[f];i[f]=h<0?e:a[h]}var d=this.orient();if(d>0)return c;c.lastVisited=-r,0===d&&o.push(c)}}}return null},l.walk=function(t,e){var n=this.vertices.length-1,r=this.dimension,i=this.vertices,a=this.tuple,o=e?this.interior.length*Math.random()|0:this.interior.length-1,s=this.interior[o];t:for(;!s.boundary;){for(var u=s.vertices,c=s.adjacent,l=0;l<=r;++l)a[l]=i[u[l]];for(s.lastVisited=n,l=0;l<=r;++l){var f=c[l];if(!(f.lastVisited>=n)){var h=a[l];a[l]=t;var d=this.orient();if(a[l]=h,d<0){s=f;continue t}f.boundary?f.lastVisited=-n:f.lastVisited=n}}return}return s},l.addPeaks=function(t,e){var n=this.vertices.length-1,r=this.dimension,i=this.vertices,u=this.tuple,c=this.interior,l=this.simplices,f=[e];e.lastVisited=n,e.vertices[e.vertices.indexOf(-1)]=n,e.boundary=!1,c.push(e);for(var h=[];f.length>0;){var d=(e=f.pop()).vertices,p=e.adjacent,v=d.indexOf(n);if(!(v<0))for(var g=0;g<=r;++g)if(g!==v){var m=p[g];if(m.boundary&&!(m.lastVisited>=n)){var y=m.vertices;if(m.lastVisited!==-n){for(var b=0,w=0;w<=r;++w)y[w]<0?(b=w,u[w]=t):u[w]=i[y[w]];if(this.orient()>0){y[b]=n,m.boundary=!1,c.push(m),f.push(m),m.lastVisited=n;continue}m.lastVisited=-n}var x=m.adjacent,E=d.slice(),_=p.slice(),S=new a(E,_,!0);l.push(S);var k=x.indexOf(e);if(!(k<0))for(x[k]=S,_[v]=m,E[g]=-1,_[g]=e,p[g]=S,S.flip(),w=0;w<=r;++w){var P=E[w];if(!(P<0||P===n)){for(var R=new Array(r-1),A=0,C=0;C<=r;++C){var I=E[C];I<0||C===w||(R[A++]=I)}h.push(new o(R,S,w))}}}}}for(h.sort(s),g=0;g+1<h.length;g+=2){var F=h[g],O=h[g+1],T=F.index,M=O.index;T<0||M<0||(F.cell.adjacent[F.index]=O.cell,O.cell.adjacent[O.index]=F.cell)}},l.insert=function(t,e){var n=this.vertices;n.push(t);var r=this.walk(t,e);if(r){for(var i=this.dimension,a=this.tuple,o=0;o<=i;++o){var s=r.vertices[o];a[o]=s<0?t:n[s]}var u=this.orient(a);u<0||(0!==u||(r=this.handleBoundaryDegeneracy(r,t)))&&this.addPeaks(t,r)}},l.boundary=function(){for(var t=this.dimension,e=[],n=this.simplices,r=n.length,i=0;i<r;++i){var a=n[i];if(a.boundary){for(var o=new Array(t),s=a.vertices,u=0,c=0,l=0;l<=t;++l)s[l]>=0?o[u++]=s[l]:c=1&l;if(c===(1&t)){var f=o[0];o[0]=o[1],o[1]=f}e.push(o)}}return e}},function(t,e,n){"use strict";var r=n(8),i=n(25),a=n(26),o=n(28);function s(t,e){for(var n=new Array(t.length-1),r=1;r<t.length;++r)for(var i=n[r-1]=new Array(t.length-1),a=0,o=0;a<t.length;++a)a!==e&&(i[o++]=t[r][a]);return n}function u(t){if(1===t.length)return t[0];if(2===t.length)return["sum(",t[0],",",t[1],")"].join("");var e=t.length>>1;return["sum(",u(t.slice(0,e)),",",u(t.slice(e)),")"].join("")}function c(t){if(2===t.length)return[["sum(prod(",t[0][0],",",t[1][1],"),prod(-",t[0][1],",",t[1][0],"))"].join("")];for(var e=[],n=0;n<t.length;++n)e.push(["scale(",u(c(s(t,n))),",",(r=n,1&r?"-":""),t[0][n],")"].join(""));return e;var r}function l(t){for(var e=[],n=[],l=function(t){for(var e=new Array(t),n=0;n<t;++n){e[n]=new Array(t);for(var r=0;r<t;++r)e[n][r]=["m",r,"[",t-n-1,"]"].join("")}return e}(t),f=[],h=0;h<t;++h)0==(1&h)?e.push.apply(e,c(s(l,h))):n.push.apply(n,c(s(l,h))),f.push("m"+h);var d=u(e),p=u(n),v="orientation"+t+"Exact",g=["function ",v,"(",f.join(),"){var p=",d,",n=",p,",d=sub(p,n);return d[d.length-1];};return ",v].join("");return new Function("sum","prod","scale","sub",g)(i,r,a,o)}var f=l(3),h=l(4),d=[function(){return 0},function(){return 0},function(t,e){return e[0]-t[0]},function(t,e,n){var r,i=(t[1]-n[1])*(e[0]-n[0]),a=(t[0]-n[0])*(e[1]-n[1]),o=i-a;if(i>0){if(a<=0)return o;r=i+a}else{if(!(i<0))return o;if(a>=0)return o;r=-(i+a)}var s=3.3306690738754716e-16*r;return o>=s||o<=-s?o:f(t,e,n)},function(t,e,n,r){var i=t[0]-r[0],a=e[0]-r[0],o=n[0]-r[0],s=t[1]-r[1],u=e[1]-r[1],c=n[1]-r[1],l=t[2]-r[2],f=e[2]-r[2],d=n[2]-r[2],p=a*c,v=o*u,g=o*s,m=i*c,y=i*u,b=a*s,w=l*(p-v)+f*(g-m)+d*(y-b),x=7.771561172376103e-16*((Math.abs(p)+Math.abs(v))*Math.abs(l)+(Math.abs(g)+Math.abs(m))*Math.abs(f)+(Math.abs(y)+Math.abs(b))*Math.abs(d));return w>x||-w>x?w:h(t,e,n,r)}];function p(t){var e=d[t.length];return e||(e=d[t.length]=l(t.length)),e.apply(void 0,t)}!function(){for(;d.length<=5;)d.push(l(d.length));for(var e=[],n=["slow"],r=0;r<=5;++r)e.push("a"+r),n.push("o"+r);var i=["function getOrientation(",e.join(),"){switch(arguments.length){case 0:case 1:return 0;"];for(r=2;r<=5;++r)i.push("case ",r,":return o",r,"(",e.slice(0,r).join(),");");i.push("}var s=new Array(arguments.length);for(var i=0;i<arguments.length;++i){s[i]=arguments[i]};return slow(s);}return getOrientation"),n.push(i.join(""));var a=Function.apply(void 0,n);for(t.exports=a.apply(void 0,[p].concat(d)),r=0;r<=5;++r)t.exports[r]=d[r]}()},function(t,e,n){"use strict";t.exports=function(t,e){var n=0|t.length,r=0|e.length;if(1===n&&1===r)return function(t,e){var n=t+e,r=n-t,i=t-(n-r)+(e-r);return i?[i,n]:[n]}(t[0],e[0]);var i,a,o=new Array(n+r),s=0,u=0,c=0,l=Math.abs,f=t[u],h=l(f),d=e[c],p=l(d);h<p?(a=f,(u+=1)<n&&(f=t[u],h=l(f))):(a=d,(c+=1)<r&&(d=e[c],p=l(d))),u<n&&h<p||c>=r?(i=f,(u+=1)<n&&(f=t[u],h=l(f))):(i=d,(c+=1)<r&&(d=e[c],p=l(d)));for(var v,g,m=i+a,y=m-i,b=a-y,w=b,x=m;u<n&&c<r;)h<p?(i=f,(u+=1)<n&&(f=t[u],h=l(f))):(i=d,(c+=1)<r&&(d=e[c],p=l(d))),(b=(a=w)-(y=(m=i+a)-i))&&(o[s++]=b),w=x-((v=x+m)-(g=v-x))+(m-g),x=v;for(;u<n;)(b=(a=w)-(y=(m=(i=f)+a)-i))&&(o[s++]=b),w=x-((v=x+m)-(g=v-x))+(m-g),x=v,(u+=1)<n&&(f=t[u]);for(;c<r;)(b=(a=w)-(y=(m=(i=d)+a)-i))&&(o[s++]=b),w=x-((v=x+m)-(g=v-x))+(m-g),x=v,(c+=1)<r&&(d=e[c]);return w&&(o[s++]=w),x&&(o[s++]=x),s||(o[s++]=0),o.length=s,o}},function(t,e,n){"use strict";var r=n(8),i=n(27);t.exports=function(t,e){var n=t.length;if(1===n){var a=r(t[0],e);return a[0]?a:[a[1]]}var o=new Array(2*n),s=[.1,.1],u=[.1,.1],c=0;r(t[0],e,s),s[0]&&(o[c++]=s[0]);for(var l=1;l<n;++l){r(t[l],e,u);var f=s[1];i(f,u[0],s),s[0]&&(o[c++]=s[0]);var h=u[1],d=s[1],p=h+d,v=p-h,g=d-v;s[1]=p,g&&(o[c++]=g)}return s[1]&&(o[c++]=s[1]),0===c&&(o[c++]=0),o.length=c,o}},function(t,e,n){"use strict";t.exports=function(t,e,n){var r=t+e,i=r-t,a=e-i,o=t-(r-i);return n?(n[0]=o+a,n[1]=r,n):[o+a,r]}},function(t,e,n){"use strict";t.exports=function(t,e){var n=0|t.length,r=0|e.length;if(1===n&&1===r)return function(t,e){var n=t+e,r=n-t,i=t-(n-r)+(e-r);return i?[i,n]:[n]}(t[0],-e[0]);var i,a,o=new Array(n+r),s=0,u=0,c=0,l=Math.abs,f=t[u],h=l(f),d=-e[c],p=l(d);h<p?(a=f,(u+=1)<n&&(f=t[u],h=l(f))):(a=d,(c+=1)<r&&(d=-e[c],p=l(d))),u<n&&h<p||c>=r?(i=f,(u+=1)<n&&(f=t[u],h=l(f))):(i=d,(c+=1)<r&&(d=-e[c],p=l(d)));for(var v,g,m=i+a,y=m-i,b=a-y,w=b,x=m;u<n&&c<r;)h<p?(i=f,(u+=1)<n&&(f=t[u],h=l(f))):(i=d,(c+=1)<r&&(d=-e[c],p=l(d))),(b=(a=w)-(y=(m=i+a)-i))&&(o[s++]=b),w=x-((v=x+m)-(g=v-x))+(m-g),x=v;for(;u<n;)(b=(a=w)-(y=(m=(i=f)+a)-i))&&(o[s++]=b),w=x-((v=x+m)-(g=v-x))+(m-g),x=v,(u+=1)<n&&(f=t[u]);for(;c<r;)(b=(a=w)-(y=(m=(i=d)+a)-i))&&(o[s++]=b),w=x-((v=x+m)-(g=v-x))+(m-g),x=v,(c+=1)<r&&(d=-e[c]);return w&&(o[s++]=w),x&&(o[s++]=x),s||(o[s++]=0),o.length=s,o}},function(t,e,n){"use strict";var r=n(30),i=n(31);function a(t,e){var n=t.length,r=t.length-e.length,i=Math.min;if(r)return r;switch(n){case 0:return 0;case 1:return t[0]-e[0];case 2:return(s=t[0]+t[1]-e[0]-e[1])||i(t[0],t[1])-i(e[0],e[1]);case 3:var a=t[0]+t[1],o=e[0]+e[1];if(s=a+t[2]-(o+e[2]))return s;var s,u=i(t[0],t[1]),c=i(e[0],e[1]);return(s=i(u,t[2])-i(c,e[2]))||i(u+t[2],a)-i(c+e[2],o);default:var l=t.slice(0);l.sort();var f=e.slice(0);f.sort();for(var h=0;h<n;++h)if(r=l[h]-f[h])return r;return 0}}function o(t,e){return a(t[0],e[0])}function s(t,e){if(e){for(var n=t.length,r=new Array(n),i=0;i<n;++i)r[i]=[t[i],e[i]];for(r.sort(o),i=0;i<n;++i)t[i]=r[i][0],e[i]=r[i][1];return t}return t.sort(a),t}function u(t){if(0===t.length)return[];for(var e=1,n=t.length,r=1;r<n;++r){var i=t[r];if(a(i,t[r-1])){if(r===e){e++;continue}t[e++]=i}}return t.length=e,t}function c(t,e){for(var n=0,r=t.length-1,i=-1;n<=r;){var o=n+r>>1,s=a(t[o],e);s<=0?(0===s&&(i=o),n=o+1):s>0&&(r=o-1)}return i}function l(t,e){for(var n=new Array(t.length),i=0,o=n.length;i<o;++i)n[i]=[];for(var s=[],u=(i=0,e.length);i<u;++i)for(var l=e[i],f=l.length,h=1,d=1<<f;h<d;++h){s.length=r.popCount(h);for(var p=0,v=0;v<f;++v)h&1<<v&&(s[p++]=l[v]);var g=c(t,s);if(!(g<0))for(;n[g++].push(i),!(g>=t.length||0!==a(t[g],s)););}return n}function f(t,e){if(e<0)return[];for(var n=[],i=(1<<e+1)-1,a=0;a<t.length;++a)for(var o=t[a],u=i;u<1<<o.length;u=r.nextCombination(u)){for(var c=new Array(e+1),l=0,f=0;f<o.length;++f)u&1<<f&&(c[l++]=o[f]);n.push(c)}return s(n)}e.dimension=function(t){for(var e=0,n=Math.max,r=0,i=t.length;r<i;++r)e=n(e,t[r].length);return e-1},e.countVertices=function(t){for(var e=-1,n=Math.max,r=0,i=t.length;r<i;++r)for(var a=t[r],o=0,s=a.length;o<s;++o)e=n(e,a[o]);return e+1},e.cloneCells=function(t){for(var e=new Array(t.length),n=0,r=t.length;n<r;++n)e[n]=t[n].slice(0);return e},e.compareCells=a,e.normalize=s,e.unique=u,e.findCell=c,e.incidence=l,e.dual=function(t,e){if(!e)return l(u(f(t,0)),t);for(var n=new Array(e),r=0;r<e;++r)n[r]=[];r=0;for(var i=t.length;r<i;++r)for(var a=t[r],o=0,s=a.length;o<s;++o)n[a[o]].push(r);return n},e.explode=function(t){for(var e=[],n=0,r=t.length;n<r;++n)for(var i=t[n],a=0|i.length,o=1,u=1<<a;o<u;++o){for(var c=[],l=0;l<a;++l)o>>>l&1&&c.push(i[l]);e.push(c)}return s(e)},e.skeleton=f,e.boundary=function(t){for(var e=[],n=0,r=t.length;n<r;++n)for(var i=t[n],a=0,o=i.length;a<o;++a){for(var u=new Array(i.length-1),c=0,l=0;c<o;++c)c!==a&&(u[l++]=i[c]);e.push(u)}return s(e)},e.connectedComponents=function(t,e){return e?function(t,e){for(var n=new i(e),r=0;r<t.length;++r)for(var a=t[r],o=0;o<a.length;++o)for(var s=o+1;s<a.length;++s)n.link(a[o],a[s]);var u=[],c=n.ranks;for(r=0;r<c.length;++r)c[r]=-1;for(r=0;r<t.length;++r){var l=n.find(t[r][0]);c[l]<0?(c[l]=u.length,u.push([t[r].slice(0)])):u[c[l]].push(t[r].slice(0))}return u}(t,e):function(t){for(var e=u(s(f(t,0))),n=new i(e.length),r=0;r<t.length;++r)for(var a=t[r],o=0;o<a.length;++o)for(var l=c(e,[a[o]]),h=o+1;h<a.length;++h)n.link(l,c(e,[a[h]]));var d=[],p=n.ranks;for(r=0;r<p.length;++r)p[r]=-1;for(r=0;r<t.length;++r){var v=n.find(c(e,[t[r][0]]));p[v]<0?(p[v]=d.length,d.push([t[r].slice(0)])):d[p[v]].push(t[r].slice(0))}return d}(t)}},function(t,e,n){"use strict";function r(t){var e=32;return(t&=-t)&&e--,65535&t&&(e-=16),16711935&t&&(e-=8),252645135&t&&(e-=4),858993459&t&&(e-=2),1431655765&t&&(e-=1),e}e.INT_BITS=32,e.INT_MAX=2147483647,e.INT_MIN=-1<<31,e.sign=function(t){return(t>0)-(t<0)},e.abs=function(t){var e=t>>31;return(t^e)-e},e.min=function(t,e){return e^(t^e)&-(t<e)},e.max=function(t,e){return t^(t^e)&-(t<e)},e.isPow2=function(t){return!(t&t-1||!t)},e.log2=function(t){var e,n;return e=(t>65535)<<4,e|=n=((t>>>=e)>255)<<3,e|=n=((t>>>=n)>15)<<2,(e|=n=((t>>>=n)>3)<<1)|(t>>>=n)>>1},e.log10=function(t){return t>=1e9?9:t>=1e8?8:t>=1e7?7:t>=1e6?6:t>=1e5?5:t>=1e4?4:t>=1e3?3:t>=100?2:t>=10?1:0},e.popCount=function(t){return 16843009*((t=(858993459&(t-=t>>>1&1431655765))+(t>>>2&858993459))+(t>>>4)&252645135)>>>24},e.countTrailingZeros=r,e.nextPow2=function(t){return t+=0===t,--t,t|=t>>>1,t|=t>>>2,t|=t>>>4,t|=t>>>8,1+(t|=t>>>16)},e.prevPow2=function(t){return t|=t>>>1,t|=t>>>2,t|=t>>>4,t|=t>>>8,(t|=t>>>16)-(t>>>1)},e.parity=function(t){return t^=t>>>16,t^=t>>>8,t^=t>>>4,27030>>>(t&=15)&1};var i=new Array(256);!function(t){for(var e=0;e<256;++e){var n=e,r=e,i=7;for(n>>>=1;n;n>>>=1)r<<=1,r|=1&n,--i;t[e]=r<<i&255}}(i),e.reverse=function(t){return i[255&t]<<24|i[t>>>8&255]<<16|i[t>>>16&255]<<8|i[t>>>24&255]},e.interleave2=function(t,e){return(t=1431655765&((t=858993459&((t=252645135&((t=16711935&((t&=65535)|t<<8))|t<<4))|t<<2))|t<<1))|(e=1431655765&((e=858993459&((e=252645135&((e=16711935&((e&=65535)|e<<8))|e<<4))|e<<2))|e<<1))<<1},e.deinterleave2=function(t,e){return(t=65535&((t=16711935&((t=252645135&((t=858993459&((t=t>>>e&1431655765)|t>>>1))|t>>>2))|t>>>4))|t>>>16))<<16>>16},e.interleave3=function(t,e,n){return t=1227133513&((t=3272356035&((t=251719695&((t=4278190335&((t&=1023)|t<<16))|t<<8))|t<<4))|t<<2),(t|=(e=1227133513&((e=3272356035&((e=251719695&((e=4278190335&((e&=1023)|e<<16))|e<<8))|e<<4))|e<<2))<<1)|(n=1227133513&((n=3272356035&((n=251719695&((n=4278190335&((n&=1023)|n<<16))|n<<8))|n<<4))|n<<2))<<2},e.deinterleave3=function(t,e){return(t=1023&((t=4278190335&((t=251719695&((t=3272356035&((t=t>>>e&1227133513)|t>>>2))|t>>>4))|t>>>8))|t>>>16))<<22>>22},e.nextCombination=function(t){var e=t|t-1;return e+1|(~e&-~e)-1>>>r(t)+1}},function(t,e,n){"use strict";function r(t){this.roots=new Array(t),this.ranks=new Array(t);for(var e=0;e<t;++e)this.roots[e]=e,this.ranks[e]=0}t.exports=r;var i=r.prototype;Object.defineProperty(i,"length",{get:function(){return this.roots.length}}),i.makeSet=function(){var t=this.roots.length;return this.roots.push(t),this.ranks.push(0),t},i.find=function(t){for(var e=t,n=this.roots;n[t]!==t;)t=n[t];for(;n[e]!==t;){var r=n[e];n[e]=t,e=r}return t},i.link=function(t,e){var n=this.find(t),r=this.find(e);if(n!==r){var i=this.ranks,a=this.roots,o=i[n],s=i[r];o<s?a[n]=r:s<o?a[r]=n:(a[r]=n,++i[n])}}},function(t,e,n){"use strict";t.exports=function(t,e,n){return 0===t.length?t:e?(n||t.sort(e),function(t,e){for(var n=1,r=t.length,i=t[0],a=t[0],o=1;o<r;++o)if(a=i,e(i=t[o],a)){if(o===n){n++;continue}t[n++]=i}return t.length=n,t}(t,e)):(n||t.sort(),function(t){for(var e=1,n=t.length,r=t[0],i=t[0],a=1;a<n;++a,i=r)if(i=r,(r=t[a])!==i){if(a===e){e++;continue}t[e++]=r}return t.length=e,t}(t))}},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.default=function(t,e){return function(n){return n.reduce(function(e,r,i){return e.then(function(e){return t(e,r,i,n)})},Promise.resolve(e))}}},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.default=function(t){var e=!(arguments.length>1&&void 0!==arguments[1])||arguments[1];return function(t){return Array.isArray(t)?Promise.all(t):Promise.resolve(t)}(t).then(function(t){return e&&!(0,i.isIterable)(t)?Promise.reject((0,r.IterableError)(t)):t})};var r=n(35),i=n(36)},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var r="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t};function i(t,e){function n(){var e=n.__proto__.apply(this,arguments);return Object.assign(e,t.apply(null,arguments)),e}return e=e||Error,Object.setPrototypeOf(n,e),n}e.SubError=i(function(t){return{name:"SubError",message:"SubError "+t.reduce(function(t,e){return t+="\n\n"+e.stack},""),errors:t}},Error),e.IterableError=i(function(t){return{name:"IterableError",message:"expecting an array or an iterable object but got "+(null===t?"null":void 0===t?"undefined":r(t))}},TypeError)},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.size=function(t){return Array.isArray(t)?t.length:Object.keys(t).length},e.repeat=function(t,e){for(var n=0;n<t;n++)e(n)},e.toArray=function(t){return Object.keys(t).map(function(e){return t[e]})},e.toBoolean=function(t){return!!t},e.identity=function(t){return t},e.defaults=function(t,e){var n=Object.assign({},e);return Object.keys(t).reduce(function(n,r){return n[r]=void 0===t[r]?e[r]:t[r],n},n)},e.isIterable=function(t){return t&&"function"==typeof t.entries},e.noop=function(){},e.isDefined=function(t){return void 0!==t}},function(t,e,n){"use strict";n.r(e);var r,i,a,o,s,u,c=n(4),l=n.n(c),f=n(1),h=n.n(f),d=n(5),p=n.n(d),v=n(3),g=n.n(v),m=n(7),y=n.n(m),b=n(9),w=n.n(b),x=n(2),E=n.n(x),_=n(0),S=n.n(_),k=n(6),P=n.n(k),R=n(14),A=n.n(R),C=n(10),I=n.n(C),F=function(){var t,e,n="object"===("undefined"==typeof WebAssembly?"undefined":I()(WebAssembly));return n&&(t=new Uint8Array([0,97,115,109,1,0,0,0,1,6,1,96,1,127,1,127,3,2,1,0,5,3,1,0,1,7,8,1,4,116,101,115,116,0,0,10,16,1,14,0,32,0,65,1,54,2,0,32,0,40,2,0,11]),e=new WebAssembly.Module(t),0===new WebAssembly.Instance(e,{}).exports.test(4))&&(n=!1),n},O={headers:{"Content-Type":"application/wasm"}},T=function(t){return fetch(t.default,O).then(function(t){return t.arrayBuffer()})},M=function t(){var e=this,r=arguments.length>0&&void 0!==arguments[0]?arguments[0]:function(){};y()(this,t),E()(this,"brfv4",void 0),E()(this,"log",void 0),E()(this,"getInstance",function(){return e.brfv4}),E()(this,"loadLibrary",p()(h.a.mark(function t(){var r,i,a,o,s,u;return h.a.wrap(function(t){for(;;)switch(t.prev=t.next){case 0:return r=F(),i=r?[n.e(3).then(n.t.bind(null,38,7)),n.e(4).then(n.t.bind(null,39,7)).then(T)]:[n.e(0).then(n.t.bind(null,40,7)),n.e(1).then(n.t.bind(null,41,7)).then(T)],e.log("Importing BFR ".concat(r?"wasm":"js"," version")),t.next=5,Promise.all(i);case 5:return a=t.sent,o=l()(a,2),s=o[0],u=o[1],e.log("BFR loaded"),t.abrupt("return",{isWasm:r,initializeBRF:s.default,binary:u});case 11:case"end":return t.stop()}},t)}))),E()(this,"waitUntilGetsInitialized",p()(h.a.mark(function t(){var n;return h.a.wrap(function(t){for(;;)switch(t.prev=t.next){case 0:return n=function t(n){e.log("...waiting for BFR initialization"),e.brfv4.sdkReady?n():setTimeout(function(){return t(n)},250)},t.abrupt("return",new Promise(n));case 2:case"end":return t.stop()}},t)}))),E()(this,"initialize",p()(h.a.mark(function t(){var n,r,i,a,o;return h.a.wrap(function(t){for(;;)switch(t.prev=t.next){case 0:return t.next=2,e.loadLibrary();case 2:return n=t.sent,r=n.initializeBRF,i=n.isWasm,a=n.binary,o=i?{wasmBinary:a}:{memoryInitializerRequest:{response:a,status:200}},e.brfv4=r(o),t.next=10,e.waitUntilGetsInitialized();case 10:case"end":return t.stop()}},t)}))),this.log=r},D={},j=!1,L=function(t){var e=t.width,n=t.height;i=new r.Rectangle(0,0,e,n),(o=new r.BRFManager).init(i,i,"com.tastenkunst.brfv4.js.examples.minimal.webcam"),o.setMode(r.BRFMode.FACE_TRACKING),o.setNumFacesToTrack(1),o.setFaceDetectionRoi(i);var s,u=Math.min(e,n);return o.setFaceDetectionParams(.4*u,.8*u,12,8),o.setFaceTrackingStartParams(.4*u,.8*u,22,26,22),o.setFaceTrackingResetParams(.35*u,.8*u,40,55,32),(s=r).BRFv4PointUtils={setPoint:function(t,e,n){n.x=t[2*e],n.y=t[2*e+1]},applyMovementVector:function(t,e,n,r){t.x=e.x+n.x*r,t.y=e.y+n.y*r},interpolatePoint:function(t,e,n,r){t.x=e.x+r*(n.x-e.x),t.y=e.y+r*(n.y-e.y)},getAveragePoint:function(t,e){t.x=0,t.y=0;for(var n=e.length,r=0;r<n;r+=1)t.x+=e[r].x,t.y+=e[r].y;t.x/=n,t.y/=n},calcMovementVector:function(t,e,n,r){t.x=r*(n.x-e.x),t.y=r*(n.y-e.y)},calcMovementVectorOrthogonalCW:function(t,e,n,r){s.BRFv4PointUtils.calcMovementVector(t,e,n,r);var i=t.x,a=t.y;t.x=-a,t.y=i},calcMovementVectorOrthogonalCCW:function(t,e,n,r){s.BRFv4PointUtils.calcMovementVector(t,e,n,r);var i=t.x,a=t.y;t.x=a,t.y=-i},calcIntersectionPoint:function(t,e,n,r,i){var a=n.x-e.x;0===a&&(a=.01);var o=n.y-e.y;0===o&&(o=.01);var s=i.x-r.x;0===s&&(s=.01);var u=i.y-r.y;0===u&&(u=.01);var c=o/a,l=n.y-c*n.x,f=u/s,h=c-f;0===h&&(h=.01);var d=i.y-f*i.x-l;0===d&&(d=.01);var p=d/h,v=c*p+l;t.x=p,t.y=v},calcDistance:function(t,e){return Math.sqrt((e.x-t.x)*(e.x-t.x)+(e.y-t.y)*(e.y-t.y))},calcAngle:function(t,e){return Math.atan2(e.y-t.y,e.x-t.x)},toDegree:function(t){return 180*t/Math.PI},toRadian:function(t){return t*Math.PI/180}},function(t){t.BRFv4ExtendedFace=function(){this.vertices=[],this.triangles=[],this.points=[],this.bounds=new t.Rectangle(0,0,0,0),this.eyeshadowHeight=.75,this.eyelinerThickness=1,this.eyelinerOffset={inner:0,offset:0},this.tmpPoint0=new t.Point,this.tmpPoint1=new t.Point,this.tmpPoint2=new t.Point,this.tmpPoint3=new t.Point,this.tmpPoint4=new t.Point,this.tmpPoint5=new t.Point},t.BRFv4ExtendedFace.prototype.setEyeshadowHeight=function(t){this.eyeshadowHeight=t},t.BRFv4ExtendedFace.prototype.setEyelinerThickness=function(t){this.eyelinerThickness=t},t.BRFv4ExtendedFace.prototype.setEyelinerOffset=function(t){this.eyelinerOffset=t},t.BRFv4ExtendedFace.prototype.addCustomPoint=function(t){var e=t.namespace,n=void 0===e?"default":e,r=t.point;D[n]||(D[n]=[]);var i=this.vertices.length/2;D[n].push(i),this.addToExtendedVertices(r)},t.BRFv4ExtendedFace.prototype.update=function(e,n){var r,i;for(D={},r=this.points.length,i=e.points.length+6+5+5;r<i;r+=1)this.points[r]=new t.Point(0,0);return this.generateExtendedVertices(e,n),this.generateExtendedTriangles(e),this.updateBounds(),this.updatePoints(),D},t.BRFv4ExtendedFace.prototype.generateExtendedVertices=function(t,e){var n,r,i=t.vertices;for(this.vertices.length=0,n=0,r=i.length;n<r;n+=1)this.vertices[n]=i[n];this.addUpperForeheadPoints(this.vertices),this.addUpperEyeshadowPoints(this.vertices),this.addUpperEyelinerPoints(this.vertices),this.addUnderEyesPoints(this.vertices),this.addEyebrowsGRPoints(this.vertices),this.addExtendedPointsFromBack(this.vertices,e),this.addUnderEyebrows(this.vertices,e)},t.BRFv4ExtendedFace.prototype.generateExtendedTriangles=function(t){0===this.triangles.length&&(this.triangles=t.triangles.concat(),this.triangles.push(0,17,68,17,18,68,18,19,69,18,68,69,19,20,69,20,23,71,20,69,70,20,70,71,23,24,72,23,71,72,24,25,72,25,26,73,25,72,73,16,26,73,36,74,75,36,75,37,37,75,76,37,76,38,38,76,77,38,77,39,39,77,78,42,79,80,42,80,43,43,80,81,43,81,44,44,81,82,44,82,45,45,82,83,74,75,84,74,75,85,32,33,86,79,80,87,79,80,88,33,34,89))},t.BRFv4ExtendedFace.prototype.updateBounds=function(){this.bounds=function(t){var e,n,r,i=9999,a=9999,o=0,s=0;for(e=0,n=t.length;e<n;e+=1)r=t[e],e%2==0?(r<i&&(i=r),r>o&&(o=r)):(r<a&&(a=r),r>s&&(s=r));return{x:i,y:a,width:Math.ceil(o-i),height:Math.ceil(s-a)}}(this.vertices)},t.BRFv4ExtendedFace.prototype.updatePoints=function(){var t,e,n,r,i;for(t=0,e=0,n=this.points.length;t<n;t+=1)r=this.vertices[e],e+=1,i=this.vertices[e],e+=1,this.points[t].x=r,this.points[t].y=i},t.BRFv4ExtendedFace.prototype.addUpperForeheadPoints=function(t){var e=this.tmpPoint0,n=this.tmpPoint1,r=this.tmpPoint2,i=this.tmpPoint3,a=this.tmpPoint4,o=this.tmpPoint5;this.setPoint(t,33,e),this.setPoint(t,27,n);var s=1.5*this.calcDistance(e,n);this.setPoint(t,39,e),this.setPoint(t,42,n);var u=this.calcDistance(e,n);this.calcMovementVectorOrthogonalCCW(a,e,n,s/u),this.setPoint(t,27,r),this.applyMovementVector(i,r,a,10.95),this.applyMovementVector(r,r,a,-10.95),this.calcIntersectionPoint(o,r,i,e,n);var c=.5-this.calcDistance(e,o)/u;this.setPoint(t,0,o);var l=.75*this.calcDistance(e,o);this.interpolatePoint(r,e,n,l/-u),this.applyMovementVector(i,r,a,.75),this.addCustomPoint({namespace:"frontHead",point:i}),this.interpolatePoint(r,e,n,c-.65),this.applyMovementVector(i,r,a,1.02),this.addCustomPoint({namespace:"frontHead",point:i}),this.interpolatePoint(r,e,n,c),this.applyMovementVector(i,r,a,1.1),this.addCustomPoint({namespace:"frontHead",point:i}),this.interpolatePoint(r,e,n,c+1),this.applyMovementVector(i,r,a,1.1),this.addCustomPoint({namespace:"frontHead",point:i}),this.interpolatePoint(r,e,n,c+1.65),this.applyMovementVector(i,r,a,1.02),this.addCustomPoint({namespace:"frontHead",point:i}),this.setPoint(t,16,o),l=.75*this.calcDistance(n,o),this.interpolatePoint(r,n,e,l/-u),this.applyMovementVector(i,r,a,.75),this.addCustomPoint({namespace:"frontHead",point:i})},t.BRFv4ExtendedFace.prototype.addUpperEyeshadowPoints=function(t){var e=this.tmpPoint0,n=this.tmpPoint1,r=this.tmpPoint2;this.setPoint(t,36,e),this.setPoint(t,17,n),this.interpolatePoint(r,e,n,.5*this.eyeshadowHeight),this.addCustomPoint({namespace:"leftEyeShadow",point:r}),this.setPoint(t,37,e),this.setPoint(t,18,n),this.interpolatePoint(r,e,n,.5*this.eyeshadowHeight),this.addCustomPoint({namespace:"leftEyeShadow",point:r}),this.setPoint(t,38,e),this.setPoint(t,19,n),this.interpolatePoint(r,e,n,.5*this.eyeshadowHeight),this.addCustomPoint({namespace:"leftEyeShadow",point:r}),this.setPoint(t,39,e),this.setPoint(t,20,n),this.interpolatePoint(r,e,n,.5*this.eyeshadowHeight),this.addCustomPoint({namespace:"leftEyeShadow",point:r}),this.setPoint(t,39,e),this.setPoint(t,21,n),this.interpolatePoint(r,e,n,.5*this.eyeshadowHeight),this.addCustomPoint({namespace:"leftEyeShadow",point:r}),this.setPoint(t,42,e),this.setPoint(t,22,n),this.interpolatePoint(r,e,n,.5*this.eyeshadowHeight),this.addCustomPoint({namespace:"rightEyeShadow",point:r}),this.setPoint(t,43,e),this.setPoint(t,23,n),this.interpolatePoint(r,e,n,.5*this.eyeshadowHeight),this.addCustomPoint({namespace:"rightEyeShadow",point:r}),this.setPoint(t,44,e),this.setPoint(t,24,n),this.interpolatePoint(r,e,n,.5*this.eyeshadowHeight),this.addCustomPoint({namespace:"rightEyeShadow",point:r}),this.setPoint(t,45,e),this.setPoint(t,25,n),this.interpolatePoint(r,e,n,.5*this.eyeshadowHeight),this.addCustomPoint({namespace:"rightEyeShadow",point:r}),this.setPoint(t,45,e),this.setPoint(t,26,n),this.interpolatePoint(r,e,n,.5*this.eyeshadowHeight),this.addCustomPoint({namespace:"rightEyeShadow",point:r})},t.BRFv4ExtendedFace.prototype.addUpperEyelinerPoints=function(t){var e=this.tmpPoint0,n=this.tmpPoint1,r=this.tmpPoint2,i=this.tmpPoint3,a=this.tmpPoint4;this.setPoint(t,36,e),this.setPoint(t,17,n),this.interpolatePoint(r,e,n,.1*this.eyelinerThickness),this.addCustomPoint({namespace:"leftEyeliner",point:r}),this.setPoint(t,37,e),this.setPoint(t,18,n),this.interpolatePoint(r,e,n,.1*this.eyelinerThickness),this.addCustomPoint({namespace:"leftEyeliner",point:r}),this.setPoint(t,38,e),this.setPoint(t,19,n),this.interpolatePoint(r,e,n,.1*this.eyelinerThickness),this.addCustomPoint({namespace:"leftEyeliner",point:r}),this.setPoint(t,39,e),this.setPoint(t,20,n),this.interpolatePoint(r,e,n,.1*this.eyelinerThickness),this.addCustomPoint({namespace:"leftEyeliner",point:r}),this.setPoint(t,39,e),this.setPoint(t,21,n),this.interpolatePoint(r,e,n,.1*this.eyelinerThickness),this.addCustomPoint({namespace:"leftEyeliner",point:r}),this.setPoint(t,17,e),this.setPoint(t,4,n),this.interpolatePoint(r,e,n,.15),this.setPoint(t,36,i),this.interpolatePoint(a,i,r,this.eyelinerOffset.outter),this.addCustomPoint({namespace:"leftEyelinerOutterPoint",point:a}),this.setPoint(t,39,e),this.setPoint(t,27,n),this.interpolatePoint(r,e,n,.5*this.eyelinerOffset.inner),this.addCustomPoint({namespace:"leftEyelinerInnerPoint",point:r}),this.setPoint(t,42,e),this.setPoint(t,22,n),this.interpolatePoint(r,e,n,.1*this.eyelinerThickness),this.addCustomPoint({namespace:"rightEyeliner",point:r}),this.setPoint(t,43,e),this.setPoint(t,23,n),this.interpolatePoint(r,e,n,.1*this.eyelinerThickness),this.addCustomPoint({namespace:"rightEyeliner",point:r}),this.setPoint(t,44,e),this.setPoint(t,24,n),this.interpolatePoint(r,e,n,.1*this.eyelinerThickness),this.addCustomPoint({namespace:"rightEyeliner",point:r}),this.setPoint(t,45,e),this.setPoint(t,25,n),this.interpolatePoint(r,e,n,.1*this.eyelinerThickness),this.addCustomPoint({namespace:"rightEyeliner",point:r}),this.setPoint(t,45,e),this.setPoint(t,26,n),this.interpolatePoint(r,e,n,.1*this.eyelinerThickness),this.addCustomPoint({namespace:"rightEyeliner",point:r}),this.setPoint(t,26,e),this.setPoint(t,12,n),this.interpolatePoint(r,e,n,.15),this.setPoint(t,45,i),this.interpolatePoint(a,i,r,this.eyelinerOffset.outter),this.addCustomPoint({namespace:"rightEyelinerOutterPoint",point:a}),this.setPoint(t,42,e),this.setPoint(t,27,n),this.interpolatePoint(r,e,n,.5*this.eyelinerOffset.inner),this.addCustomPoint({namespace:"rightEyelinerInnerPoint",point:r})},t.BRFv4ExtendedFace.prototype.addUnderEyesPoints=function(t){var e=this,n=this.tmpPoint0,r=this.tmpPoint1,i=this.tmpPoint2,a=this.tmpPoint3,o=this.tmpPoint4;this.setPoint(t,37,n),this.setPoint(t,36,r);var s=this.calcDistance(n,r),u=function(n){var r=n.from,s=n.to,u=n.distance,c=n.namespace;e.setPoint(t,r,a),e.setPoint(t,s,o);var l=e.calcDistance(a,o);e.interpolatePoint(i,a,o,u/l),e.addCustomPoint({namespace:c,point:i})};u({from:39,to:27,distance:s,namespace:"underLeftEye"}),u({from:39,to:28,distance:s,namespace:"underLeftEye"}),u({from:40,to:31,distance:s,namespace:"underLeftEye"}),u({from:41,to:31,distance:s,namespace:"underLeftEye"}),u({from:41,to:2,distance:s,namespace:"underLeftEye"}),u({from:36,to:1,distance:s,namespace:"underLeftEye"}),u({from:36,to:0,distance:s,namespace:"underLeftEye"}),u({from:45,to:16,distance:s,namespace:"underRightEye"}),u({from:45,to:15,distance:s,namespace:"underRightEye"}),u({from:46,to:14,distance:s,namespace:"underRightEye"}),u({from:46,to:35,distance:s,namespace:"underRightEye"}),u({from:47,to:35,distance:s,namespace:"underRightEye"}),u({from:42,to:28,distance:s,namespace:"underRightEye"}),u({from:42,to:27,distance:s,namespace:"underRightEye"})},t.BRFv4ExtendedFace.prototype.addUnderEyebrows=function(t){var e=this,n=this.tmpPoint0,r=this.tmpPoint1,i=this.tmpPoint2,a=this.tmpPoint3,o=this.tmpPoint4,s=function(n){var r=n.from,s=n.to,u=n.distance,c=n.namespace;e.setPoint(t,r,a),e.setPoint(t,s,o);var l=e.calcDistance(a,o);e.interpolatePoint(i,a,o,u/l),e.addCustomPoint({namespace:c,point:i})};this.setPoint(t,20,n),this.setPoint(t,39,r);var u=.3*this.calcDistance(n,r);s({from:21,to:39,distance:u,namespace:"underLeftEyebrows"}),s({from:20,to:38,distance:u,namespace:"underLeftEyebrows"}),s({from:19,to:37,distance:u,namespace:"underLeftEyebrows"}),s({from:18,to:36,distance:u,namespace:"underLeftEyebrows"});var c=.45*this.calcDistance(n,r);s({from:21,to:39,distance:c,namespace:"leftEyelid"}),s({from:20,to:38,distance:c,namespace:"leftEyelid"}),s({from:19,to:37,distance:c,namespace:"leftEyelid"}),s({from:18,to:36,distance:c,namespace:"leftEyelid"}),this.setPoint(t,23,n),this.setPoint(t,42,r);var l=.3*this.calcDistance(n,r);s({from:22,to:43,distance:l,namespace:"underRightEyebrows"}),s({from:23,to:43,distance:l,namespace:"underRightEyebrows"}),s({from:24,to:44,distance:l,namespace:"underRightEyebrows"}),s({from:25,to:45,distance:l,namespace:"underRightEyebrows"});var f=.45*this.calcDistance(n,r);s({from:22,to:43,distance:f,namespace:"rightEyelid"}),s({from:23,to:43,distance:f,namespace:"rightEyelid"}),s({from:24,to:44,distance:f,namespace:"rightEyelid"}),s({from:25,to:45,distance:f,namespace:"rightEyelid"})},t.BRFv4ExtendedFace.prototype.addEyebrowsGRPoints=function(t){var e=this.tmpPoint0,n=this.tmpPoint1,r=this.tmpPoint2,i=this.tmpPoint3,a=this.tmpPoint4;this.setPoint(t,31,e),this.setPoint(t,36,n),this.interpolatePoint(r,e,n,1.75),this.addCustomPoint({namespace:"leftEyebrow",point:r}),this.setPoint(t,40,e),this.setPoint(t,37,n),this.interpolatePoint(r,e,n,.5),this.setPoint(t,30,i),this.interpolatePoint(a,i,r,1.9),this.addCustomPoint({namespace:"leftEyebrow",point:a}),this.setPoint(t,27,e),this.setPoint(t,21,n),this.calcMovementVector(i,e,n,1),this.setPoint(t,33,a),a.x+=i.x,a.y+=i.y,this.addCustomPoint({namespace:"leftEyebrow",point:a}),this.setPoint(t,35,e),this.setPoint(t,45,n),this.interpolatePoint(r,e,n,1.75),this.addCustomPoint({namespace:"rightEyebrow",point:r}),this.setPoint(t,47,e),this.setPoint(t,44,n),this.interpolatePoint(r,e,n,.5),this.setPoint(t,30,i),this.interpolatePoint(a,i,r,1.9),this.addCustomPoint({namespace:"rightEyebrow",point:a}),this.setPoint(t,27,e),this.setPoint(t,22,n),this.calcMovementVector(i,e,n,1),this.setPoint(t,33,a),a.x+=i.x,a.y+=i.y,this.addCustomPoint({namespace:"rightEyebrow",point:a})},t.BRFv4ExtendedFace.prototype.addExtendedPointsFromBack=function(t,e){var n=this;if(e&&e.idx&&e.idx_start&&e.idx_end&&e.x_bias&&e.y_bias){var r=this.tmpPoint0,i=this.tmpPoint1,a=this.tmpPoint2,o=this.tmpPoint3,s=this.tmpPoint4,u=this.tmpPoint5;this.setPoint(t,40,r),this.setPoint(t,37,i),this.interpolatePoint(a,r,i,.5),this.setPoint(t,47,o),this.setPoint(t,44,s),this.interpolatePoint(u,o,s,.5);var c=this.calcDistance(a,u);e.idx.map(function(o,s){return n.setPoint(t,e.idx_start[s],r),n.setPoint(t,e.idx_end[s],i),n.interpolatePoint(a,r,i,e.interpolation[s]),a.x+=parseFloat(e.x_bias[s])*c/1e3,a.y+=parseFloat(e.y_bias[s])*c/1e3,n.addCustomPoint({namespace:"backend",point:a})})}},t.BRFv4ExtendedFace.prototype.addToExtendedVertices=function(t){this.vertices.push(t.x),this.vertices.push(t.y)},t.BRFv4ExtendedFace.prototype.setPoint=t.BRFv4PointUtils.setPoint,t.BRFv4ExtendedFace.prototype.applyMovementVector=t.BRFv4PointUtils.applyMovementVector,t.BRFv4ExtendedFace.prototype.interpolatePoint=t.BRFv4PointUtils.interpolatePoint,t.BRFv4ExtendedFace.prototype.calcMovementVector=t.BRFv4PointUtils.calcMovementVector,t.BRFv4ExtendedFace.prototype.calcMovementVectorOrthogonalCW=t.BRFv4PointUtils.calcMovementVectorOrthogonalCW,t.BRFv4ExtendedFace.prototype.calcMovementVectorOrthogonalCCW=t.BRFv4PointUtils.calcMovementVectorOrthogonalCCW,t.BRFv4ExtendedFace.prototype.calcIntersectionPoint=t.BRFv4PointUtils.calcIntersectionPoint,t.BRFv4ExtendedFace.prototype.calcDistance=t.BRFv4PointUtils.calcDistance}(r),a=new r.BRFv4ExtendedFace,{resolution:i,extFace:a,BRFManager:o,BRF:r}},B={initialize:function(){var t=p()(h.a.mark(function t(e){var n,s,u,c;return h.a.wrap(function(t){for(;;)switch(t.prev=t.next){case 0:if(n=e.width,s=e.height,u=e.log,!j){t.next=3;break}return t.abrupt("return",{resolution:i,extFace:a,BRFManager:o,BRF:r});case 3:return c=new M(u),t.next=6,c.initialize();case 6:return r=c.getInstance(),j=!0,t.abrupt("return",L({width:n,height:s}));case 9:case"end":return t.stop()}},t)}));return function(e){return t.apply(this,arguments)}}()},N=function(t){var e=t.id,n=t.alpha,r=t.blur,i=t.smoothEdges,a=t.compositeMode,o=t.gradient,s=t.color,u=t.border,c=t.shapePoints,l=t.ellipses,f=t.clipPoints,h=t.zIndex,d=t.clip;return g()({id:e,type:"polygon",alpha:n,blur:r,smoothEdges:i,compositeMode:a},function(t){var e=t.gradient,n=t.color;return e?{gradient:e}:{color:n}}({gradient:o,color:s}),{border:u,points:c,ellipses:l,clipPoints:f,zIndex:h,clip:d})},V=function(t){var e=t.id,n=t.compositeMode,r=t.alpha,i=t.blur,a=t.filters;return{id:e,type:"image",source:t.source,compositeMode:n,alpha:r,filters:a,clip:t.clip,from:t.from,blur:i,zIndex:t.zIndex}},U=function(t,e,n,r){var i,a,o,u,c,f,h,d=parseInt,p=Math.round,v="string"==typeof n;return"number"!=typeof t||t<-1||t>1||"string"!=typeof e||"r"!=e[0]&&"#"!=e[0]||n&&!v?null:(s||(s=function(t){var e=t.length,n={};if(e>9){var r,s;if(r=t=t.split(","),s=l()(r,4),i=s[0],a=s[1],o=s[2],v=s[3],(e=t.length)<3||e>4)return null;n.r=d("a"==i[3]?i.slice(5):i.slice(4)),n.g=d(a),n.b=d(o),n.a=v?parseFloat(v):-1}else{if(8==e||6==e||e<4)return null;e<6&&(t="#".concat(t[1]).concat(t[1]).concat(t[2]).concat(t[2]).concat(t[3]).concat(t[3]).concat(e>4?t[4]+t[4]:"")),t=d(t.slice(1),16),9==e||5==e?(n.r=t>>24&255,n.g=t>>16&255,n.b=t>>8&255,n.a=p((255&t)/.255)/1e3):(n.r=t>>16,n.g=t>>8&255,n.b=255&t,n.a=-1)}return n}),h=e.length>9,h=v?n.length>9||"c"==n&&!h:h,c=s(e),u=t<0,f=n&&"c"!=n?s(n):u?{r:0,g:0,b:0,a:-1}:{r:255,g:255,b:255,a:-1},u=1-(t=u?-1*t:t),c&&f?(r?(i=p(u*c.r+t*f.r),a=p(u*c.g+t*f.g),o=p(u*c.b+t*f.b)):(i=p(Math.pow(u*Math.pow(c.r,2)+t*Math.pow(f.r,2),.5)),a=p(Math.pow(u*Math.pow(c.g,2)+t*Math.pow(f.g,2),.5)),o=p(Math.pow(u*Math.pow(c.b,2)+t*Math.pow(f.b,2),.5))),v=c.a,f=f.a,v=(c=v>=0||f>=0)?v<0?f:f<0?v:v*u+f*t:0,[i,a,o]):null)},z=function(t){var e=l()(t.color,3),n=e[0],r=e[1],i=e[2],a=t.factor,o="rgba(".concat(n,",").concat(r,",").concat(i,")");return U(-1*a,o)},W=function(t){var e=l()(t.color,3),n=e[0],r=e[1],i=e[2],a=t.factor,o="rgba(".concat(n,",").concat(r,",").concat(i,")");return U(a,o)},H=function(t){var e=t.color,n=t.referenceCenter,r=t.isLeftEye,i=t.eyeRadius,a=e.offset,o=a.horizontal,s=a.vertical,u=e.radius,c=e.steps,l=r?-o:o;return{gradient:{type:"radial",center:{x:n.x+l*i,y:n.y+s*i},radius:i*u,steps:c}}},G=function(t){var e=t.shapePoints,n=t.color,r=t.whiteBalance,i=K(n,{whiteBalance:r}),a=z({color:i,factor:.75});return{gradient:{type:"linear",from:e[0],to:e[e.length/2-2],steps:[{offset:0,color:a},{offset:.4,color:i},{offset:.6,color:i},{offset:1,color:a}]}}},q=function(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},n=e.min,r=e.max,i=e.defaultValue;if("number"!=typeof t)return void 0===i?0:i;var a=t;return void 0!==n&&(a=Math.max(n,a)),void 0!==r&&(a=Math.min(r,a)),a},K=function(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},n=e.defaultValue,r=void 0===n?[255,255,255]:n,i=e.whiteBalance;if(!Array.isArray(t))return r;var a,o,s,u,c,f,h,d,p,v=l()(t,3),g=v[0],m=v[1],y=v[2],b={min:0,max:255,defaultValue:255},w=[q(g,b),q(m,b),q(y,b)];return i?(a={color:w,whiteBalance:i},o=l()(a.color,3),s=o[0],u=o[1],c=o[2],f=l()(a.whiteBalance,3),h=f[0],d=f[1],p=f[2],[parseInt(s*h*p,10),parseInt(u*p,10),parseInt(c*d*p,10)]):w},Y=function(t,e){var n=e.min;return n+t*(e.max-n)},J=function(t){var e=t.origin,n=t.destination,r=function(t){return{x:e.x+(n.x-e.x)*t,y:e.y+(n.y-e.y)*t}},i=function(){return Math.hypot(e.x-n.x,e.y-n.y)};return{interpolate:r,translate:function(t){return r(t/i())},getDistance:i}},$=[[1,8],[2,7],[3,6],[4,5]],X=function(t){var e;return e=Y((t+1)/2,{min:.4,max:-.4}),q(e,{min:-.4,max:.4,defaultValue:0})},Z=function(t){var e;return e=Y((t+1)/2,{min:-.8,max:.8}),q(e,{min:-.8,max:.8,defaultValue:0})},Q=function(t){var e=t.from,n=t.to;return{x:(e.x+n.x)/2,y:(e.y+n.y)/2}},tt=function(t){var e=t.from,n=t.to;return Math.sqrt(Math.pow(e.x-n.x,2)+Math.pow(e.x-n.x,2))},et={},nt=function(t){var e=t.id,n=t.name,r=t.value,i=et[e]&&et[e][n]||r;return function(){switch(n){case"eyeCenter":return et[e]||(et[e]={}),!(Math.abs(i.x-r.x)<=.01||Math.abs(i.y-r.y)<=.01);default:return!(Math.abs(i-r)<=.01)}}()?(et[e][n]=r,r):(et[e][n]=i,i)},rt=function(t){var e=t.shapesPoints,n=t.alpha,r=t.whiteBalance,i=t.ellipses,a=t.clipPoints,o=Object.keys(e).reduce(function(t,o,s){var u=e[o];return[].concat(S()(t),S()(Object.keys(u).map(function(t,e){var c,l,f,h,d,p,v,m,y=u[t],b=y[y.length-1],w=y[y.length-4],x=Q({from:b,to:w}),E=tt({from:x,to:w}),_=(l=(c={point1:b,point2:w}).point1,f=c.point2,h=l.x,d=l.y,p=f.x,v=f.y-d,m=p-h,Math.atan2(v,m)),S="complexEyeshadow-".concat(s,"-").concat(e);return N(g()({id:S,shapePoints:y,clip:a.face,alpha:n,blur:4,zIndex:-20,compositeMode:"hard-light"},function(t){var e=t.shapePoints,n=t.isTopArea,r=t.isLeftEye,i=t.ellipses,a=t.whiteBalance,o=t.referenceCenter,s=t.eyeRadius,u=t.faceRotation;return{ellipses:i.filter(function(t){var e=t.area;return n&&"top"===e||!n&&"bottom"===e}).map(function(t){var n=t.offset,i=n.horizontal,c=n.vertical,l=t.radius,f=l.horizontal,h=l.vertical,d=t.rotation,p=t.color,v=r?-i:i,m={x:o.x+v*s,y:o.y+c*s},y=s*f,b=y*h,w=Array.isArray(p)?G({shapePoints:e,color:p,whiteBalance:a}):H({color:p,referenceCenter:m,isLeftEye:r,eyeRadius:s}),x=(r?1:-1)*function(t){return t.deg*(Math.PI/180)}({deg:d})||0;return g()({center:m,radiusX:y,radiusY:b,rotation:u+x},w)})}}({shapePoints:y,isTopArea:"top"===t,isLeftEye:"left"===o,ellipses:i,whiteBalance:r,referenceCenter:nt({id:S,name:"eyeCenter",value:x}),eyeRadius:nt({id:S,name:"eyeRadius",value:E}),faceRotation:_})))})))},[]);return{shapes:[].concat(S()(o),[V({id:"complexEyeshadowClearEyes",clip:a.eyes,compositeMode:"source-over",alpha:1,zIndex:-10})])}},it={foundation:function(t){var e=t.shapesPoints,n=t.coverage,r=t.color,i=t.whiteBalance,a=q(n,{min:0,max:1,defaultValue:1}),o=Y(a,{min:.8,max:1}),s=Y(a,{min:0,max:.4}),u=K(r,{whiteBalance:i}),c=z({color:u,factor:.2});return{shapes:[V({id:"foundation-blur-skin",clip:e,compositeMode:"source-over",from:"lastEffectImage",alpha:o,blur:1}),N({id:"foundation-color",compositeMode:"overlay",alpha:s,blur:1,smoothEdges:10,shapePoints:e,color:c})]}},lipstick:function(t){var e=t.shapesPoints,n=t.finish,r=void 0===n?"natural":n,i=t.strength,a=t.finishStrength,o=t.color,s=t.whiteBalance,u=q(i,{min:0,max:1,defaultValue:1}),c=q(a,{min:0,max:1,defaultValue:1}),l=K(o,{whiteBalance:s});return{shapes:e.reduce(function(t,e,n){var i=function(t){var e=t.shapePoints,n=t.index,r=t.color,i=t.strength;return[N({id:"lip-".concat(n,"-remove-color"),compositeMode:"color",alpha:i,blur:1,shapePoints:e,color:[0,0,0]}),N({id:"lip-".concat(n,"-apply-color"),compositeMode:"overlay",alpha:i,blur:1,shapePoints:e,color:r})]}({shapePoints:e,index:n,color:l,strength:u});return"matte"===r?[].concat(S()(t),S()(i),S()(function(t){var e=t.shapePoints,n=t.index,r=t.color,i=t.strength,a=t.finishStrength*Y(i,{min:.3,max:.7});return[N({id:"lip-".concat(n,"-matte-finish"),compositeMode:"darken",alpha:a,shapePoints:e,color:W({color:r,factor:.2})})]}({shapePoints:e,index:n,color:l,strength:u,finishStrength:c}))):"gloss"===r?[].concat(S()(t),S()(i),S()(function(t){var e=t.shapePoints,n=t.index,r=t.strength,i=t.finishStrength,a=q(Y(r,{min:0,max:.2}),{min:0,max:1,defaultValue:1}),o=parseInt(Y(1-i,{min:170,max:220}),10);return[V({id:"lip-".concat(n,"-gloss-finish"),clip:e,compositeMode:"lighter",from:"originalImage",alpha:a,filters:{curve:{points:[{offset:o,value:0},{offset:o,value:255},{offset:255,value:255}],channel:"brightness"}}})]}({shapePoints:e,index:n,strength:u,finishStrength:c}))):"metallic"===r?[].concat(S()(t),S()(i),S()(function(t){var e=t.shapePoints,n=t.index,r=t.strength,i=t.finishStrength,a=i*Y(r,{min:.3,max:.7}),o=window.min2||100,s=window.max2||200,u=parseInt(Y(1-i,{min:o,max:s}),10);return[V({id:"lip-".concat(n,"-background"),clip:e,compositeMode:"source-over",from:"lastEffectImage",alpha:a,filters:{curve:{points:[{offset:u,value:u},{offset:u+50,value:255},{offset:255,value:255}],channel:"brightness"}}})]}({shapePoints:e,index:n,strength:u,finishStrength:a}))):[].concat(S()(t),S()(i))},[])}},lipliner:function(t){var e=t.shapesPoints,n=t.color,r=t.strength,i=t.thickness,a=t.whiteBalance,o=q(r,{min:0,max:1,defaultValue:1}),s={color:K(n,{whiteBalance:a}),width:q(i,{min:1,max:10,defaultValue:1})};return{shapes:[N({id:"lipliner",shapePoints:e,border:s,compositeMode:"overlay",alpha:o,blur:1})]}},eyeliner:function(t){var e=t.type,n=t.shapesPoints,r=t.color,i=t.strength,a=t.thickness,o=t.whiteBalance,s=q(i,{min:0,max:1,defaultValue:1});switch(e){case"polygon":return function(t){var e=t.shapesPoints,n=t.color,r=t.alpha,i=t.whiteBalance;return{shapes:e.map(function(t,e){return N({id:"polygonEyeliner-".concat(e),shapePoints:t,alpha:r,blur:1,color:K(n,{whiteBalance:i})})})}}({shapesPoints:n.polygon,color:r,alpha:s,whiteBalance:o});default:return function(t){var e=t.shapesPoints,n=t.color,r=t.alpha,i=t.thickness,a=t.whiteBalance,o=q(i,{min:1,max:10,defaultValue:1});return{shapes:e.map(function(t,e){return{id:(i={id:"lineEyeliner-".concat(e),shapePoints:t,color:K(n,{whiteBalance:a}),width:o,compositeMode:"overlay",lineJoin:"round",lineCap:"round",alpha:r,blur:1}).id,type:"line",compositeMode:i.compositeMode,alpha:i.alpha,blur:i.blur,lineJoin:i.lineJoin,lineCap:i.lineCap,color:i.color,width:i.width,points:i.shapePoints,zIndex:i.zIndex};var i})}}({shapesPoints:n.line,color:r,alpha:s,thickness:a,whiteBalance:o})}},blush:function(t){var e=t.shapesPoints,n=t.color,r=t.strength,i=t.whiteBalance,a=q(r,{min:0,max:1,defaultValue:1});return{shapes:e.map(function(t,e){return N({id:"blush-".concat(e),shapePoints:t,color:K(n,{whiteBalance:i}),compositeMode:"overlay",alpha:a,blur:20})})}},eyeshadow:function(t){var e=t.type,n=t.shapesPoints,r=t.color,i=t.strength,a=t.whiteBalance,o=t.ellipses,s=q(i,{min:0,max:1,defaultValue:1});switch(e){case"radial":return function(t){var e=t.shapesPoints,n=t.color,r=t.alpha;return{shapes:Object.keys(e).map(function(t,i){var a=e[t],o=a[a.length-1],s=a[a.length-4],u=Q({from:o,to:s}),c=tt({from:u,to:s}),l="radialEyeshadow-".concat(i);return N(g()({id:l,shapePoints:a,alpha:r,blur:4,zIndex:-10,compositeMode:"hard-light"},H({color:n,isLeftEye:"left"===t,referenceCenter:nt({id:l,name:"eyeCenter",value:u}),eyeRadius:nt({id:l,name:"eyeRadius",value:c})})))})}}({shapesPoints:n.basic,color:r,alpha:s});case"complex":return rt({shapesPoints:n.extended,clipPoints:n.clip,alpha:s,whiteBalance:a,ellipses:o});default:return function(t){var e=t.shapesPoints,n=t.color,r=t.alpha,i=t.whiteBalance;return{shapes:Object.keys(e).map(function(t,a){var o=e[t];return N(g()({id:"simpleEyeshadow-".concat(a),shapePoints:o,alpha:r,blur:4,zIndex:-10,compositeMode:"hard-light"},G({shapePoints:o,color:n,whiteBalance:i})))})}}({shapesPoints:n.basic,color:r,alpha:s,whiteBalance:a})}},eyebrows:function(t){var e=t.shapesPoints,n=t.color,r=t.strength,i=t.whiteBalance,a=q(r,{min:0,max:.2,defaultValue:0});return{shapes:e.map(function(t,e){return N({id:"eyebrow-".concat(e),shapePoints:t,color:K(n,{whiteBalance:i}),compositeMode:"overlay",alpha:a,blur:2})})}},eyebrowsTransform:function(t){var e,n=t.shapesPoints,r=t.arc,i=t.height,a=function(t){var e=t.height,n=t.arc;return function(t){var r,i;return i=t,r=function(t){var e=t.height;return function(t){var n=S()(t);return $.forEach(function(r){var i=l()(r,2),a=i[0],o=i[1];n[a]=J({origin:t[a],destination:t[o]}).interpolate(e/2),n[o]=J({origin:t[o],destination:t[a]}).interpolate(e/2)}),n}}({height:e})(i),function(t){var e=t.arc;return function(t){var n=S()(t),r=J({origin:t[$[2][0]],destination:t[$[2][1]]}).getDistance();return[{pair:$[0],distance:e*r},{pair:$[1],distance:e*r*.7},{pair:$[2],distance:e*r*.3}].forEach(function(e){var r=e.distance,i=l()(e.pair,2),a=i[0],o=i[1];n[a]=J({origin:t[a],destination:t[o]}).translate(-r),n[o]=J({origin:t[o],destination:t[a]}).translate(r)}),n}}({arc:n})(r)}}({height:X(i),arc:Z(r)}),o=l()(n,3),s=o[0],u=o[1],c=o[2];return{shapes:[(e={id:"eyebrows-transform",from:[].concat(S()(s),S()(u),S()(c)),to:[].concat(S()(s),S()(a(u)),S()(a(c)))},{id:e.id,type:"warping",from:e.from,to:e.to,compositeMode:"source-over"})]}}},at=function t(e){var n=e.vertices;return e.trackingPoints.map(function(e){return Array.isArray(e)?t({vertices:n,trackingPoints:e}):{x:n[2*e],y:n[2*e+1]}})},ot=function(t){var e=t.vertices,n=t.shapes,r=t.effects,i=t.whiteBalance;return Object.keys(it).map(function(t){var a=r[t];if(a&&a.enabled){var o=it[t],s=n[t],u=Array.isArray(s)?at({vertices:e,trackingPoints:s}):function t(e){var n=e.vertices,r=e.trackingPoints;return Object.keys(r).reduce(function(e,i){return g()({},e,E()({},i,Array.isArray(r[i])?at({vertices:n,trackingPoints:r[i]}):t({vertices:n,trackingPoints:r[i]})))},{})}({vertices:e,trackingPoints:s});return g()({},o(g()({},a,{shapesPoints:u,whiteBalance:i})),{id:t})}return null}).filter(Boolean)},st=function(t){var e=t.id,n=t.width,r=t.height,i=document.createElement("canvas");return i.id=e,i.width=n,i.height=r,i},ut=function(t){var e=t.canvas,n=t.source,r=t.resizeCanvas,i=n.mirrored,a=n.image,o=n.width,s=n.height;r&&(e.width=o,e.height=s);var u=e.getContext("2d");i&&u.setTransform(-1,0,0,1,o,0),u.drawImage(a,0,0,o,s),i&&u.setTransform(1,0,0,1,0,0)},ct=function(t){var e=t.reduce(function(t,e){var n=t.minX,r=t.minY,i=t.maxX,a=t.maxY,o=e.x,s=e.y;return{minX:null!==n?Math.min(n,o):o,minY:null!==r?Math.min(r,s):s,maxX:null!==i?Math.max(i,o):o,maxY:null!==a?Math.max(a,s):s}},{minX:null,minY:null,maxX:null,maxY:null}),n=e.minX,r=e.minY,i=e.maxX,a=e.maxY;return{x:n,y:r,width:Math.ceil(i-n),height:Math.ceil(a-r)}},lt=function(t){var e=t.value,n=t.min,r=t.max;return e<=n?n:e>=r?r:e},ft=function(t){var e=t.alpha,n=t.canvas,r=t.blur,i=t.points,a=n.getContext("2d"),o=ct(i);return void 0!==e&&(a.globalAlpha=Math.max(0,.6*e)),function(t){var e=t.blur,n=t.canvas,r=e>1?1.5*e:1,i=e>1?1.5*e:e,a=n.getContext("2d"),o=n.width,s=n.height;u||(u=st({width:o,height:s,id:"blurCanvas"}));var c=u.getContext("2d");c.clearRect(0,0,o,s);for(var l=i,f=0,h=1/(2*Math.PI*r*r),d=l<3?1:2,p=-l;p<=l;p+=d)for(var v=-l;v<=l;v+=d)f+=h*Math.exp(-(v*v+p*p)/(2*r*r));for(var g=-l;g<=l;g+=d)for(var m=-l;m<=l;m+=d)c.globalAlpha=h*Math.exp(-(m*m+g*g)/(2*r*r))/f*l,c.drawImage(n,m,g);c.globalAlpha=1,a.clearRect(0,0,o,s),a.drawImage(c.canvas,0,0,o,s)}({canvas:n,blur:r,bounds:o}),!0},ht=function(t){var e=t.blur;return(!!window.safari||!!navigator.platform&&/iPad|iPhone|iPod/.test(navigator.platform)||"MacIntel"===navigator.platform&&navigator.maxTouchPoints>1)&&void 0!==e},dt=function(t){var e=l()(t.color,3),n=e[0],r=e[1],i=e[2];return"rgb(".concat(n,",").concat(r,",").concat(i,")")},pt=st({id:"maskCanvas"}),vt=pt.getContext("2d");vt.save();var gt=st({id:"invertedMaskCanvas"}),mt=gt.getContext("2d");mt.save();var yt=null,bt=function(t){var e=t.canvasCtx,n=t.gradient;switch(n.type){case"radial":var r=n.center,i=n.radius,a=n.steps,o=e.createRadialGradient(r.x,r.y,0,r.x,r.y,i);return a.forEach(function(t){o.addColorStop(t.offset,dt({color:t.color}))}),o;default:var s=e.createLinearGradient(n.from.x,n.from.y,n.to.x,n.to.y);return n.steps.forEach(function(t){s.addColorStop(t.offset,dt({color:t.color}))}),s}},wt=function(t){var e=t.canvas,n=t.color,r=t.gradient,i=t.border,a=t.shape,o=a.type,s=a.points,u=a.x,c=a.y,l=a.width,f=a.height,h=e.getContext("2d");if("path"===o&&(h.beginPath(),s.forEach(function(t,e){var n=t.x,r=t.y;return 0===e?h.moveTo(n,r):h.lineTo(n,r)}),h.closePath()),n&&(h.fillStyle=dt({color:n}),"rect"===o?h.fillRect(u,c,l,f):h.fill()),r){var d=bt({canvasCtx:h,gradient:r});h.fillStyle=d,"rect"===o?h.fillRect(u,c,l,f):h.fill()}i&&(h.strokeStyle=dt({color:i.color}),h.lineWidth=i.width,h.stroke())},xt=function(t){var e=t.canvas,n=t.points,r=t.color,i=t.gradient,a=t.blur,o=t.smoothEdges,s=t.ellipses,u=t.clip,c=2*(o||a),l=e.getContext("2d"),f=JSON.stringify(n),h=ct(n),d=2*c,p=parseInt(h.x-d,10),v=parseInt(h.y-d,10),m=parseInt(h.width+2*d,10),y=parseInt(h.height+2*d,10);yt!==f&&(yt=f,pt.width=m,pt.height=y,vt.restore(),vt.clearRect(p,v,m,y),vt.translate(-pt.width,0),vt.shadowOffsetX=pt.width,vt.shadowOffsetY=0,vt.shadowColor="#000",vt.shadowBlur=c,vt.beginPath(),n.forEach(function(t,e){var n=t.x,r=t.y;return 0===e?vt.moveTo(n-p,r-v):vt.lineTo(n-p,r-v)}),vt.closePath(),vt.fillStyle="#000",vt.fill(),gt.width=m,gt.height=y,mt.restore(),mt.clearRect(p,v,m,y),mt.fillStyle="#000",mt.fillRect(0,0,m,e.height),mt.globalCompositeOperation="destination-out",mt.drawImage(pt,0,0)),s?function(t){var e=t.canvas,n=t.ellipses,r=t.clip,i=t.bounds,a=e.getContext("2d");a.save(),a.beginPath(),r.forEach(function(t,e){var n=function(t){var e=t.point,n=t.bounds,r=e.x,i=e.y;return{x:lt({value:r,min:n.x,max:n.x+n.width}),y:lt({value:i,min:n.y,max:n.y+n.height})}}({point:{x:t.x,y:t.y},bounds:i}),r=n.x,o=n.y;return 0===e?a.moveTo(r,o):a.lineTo(r,o)}),a.closePath(),a.clip(),n.forEach(function(t){var e=t.center,n=t.radiusX,r=t.radiusY,i=t.rotation,o=t.gradient;a.beginPath(),a.ellipse(e.x,e.y,n,r,i,0,365),a.fillStyle=bt({canvasCtx:a,gradient:o}),a.fill(),a.closePath()}),a.restore()}({canvas:e,ellipses:s,clip:u,bounds:g()({},h,{height:h.height+.5*d})}):wt({canvas:e,color:r,gradient:i,shape:{type:"rect",x:p+c,y:v+c,width:m-(c+2),height:y-c}}),l.save(),l.globalAlpha=1,l.globalCompositeOperation="destination-out",l.drawImage(gt,p,v),l.restore()},Et=function(t,e,n){return t<e?e:t>n?n:t};function _t(t,e,n,r){this.r=t,this.g=e,this.b=n,this.a=r}function St(t,e,n){this.type="RGBAImage",this.w=t,this.h=e,this.data=new Uint8Array(t*e*4),n&&this.data.set(n)}_t.RED=new _t(255,0,0,255),_t.GREEN=new _t(0,255,0,255),_t.BLUE=new _t(0,0,255,255),_t.YELLOW=new _t(255,255,0,255),_t.PURPLE=new _t(255,0,255,255),_t.CYAN=new _t(0,255,255,255),_t.WHITE=new _t(255,255,255,255),_t.BLACK=new _t(0,0,0,255),_t.GRAY=new _t(128,128,128,255),_t.prototype.setColor=function(t){return null!=t&&t.constructor===_t?(this.r=t.r,this.g=t.g,this.b=t.b,this.a=t.a,this):null},_t.prototype.distance=function(t){var e=this.r-t.r,n=this.g-t.g,r=this.b-t.b;return e*e+n*n+r*r},_t.prototype.equal=function(t){return this.r==t.r&&this.g==t.g&&this.b==t.b},_t.prototype.add=function(t){return new _t(this.r+t.r,this.g+t.g,this.b+t.b,this.a+t.a)},_t.prototype.addc=function(t){return new _t(this.r+t.r,this.g+t.g,this.b+t.b,this.a)},_t.prototype.sub=function(t){return new _t(this.r-t.r,this.g-t.g,this.b-t.b,this.a-t.a)},_t.prototype.subc=function(t){return new _t(this.r-t.r,this.g-t.g,this.b-t.b,this.a)},_t.prototype.mul=function(t){return new _t(this.r*t,this.g*t,this.b*t,this.a*t)},_t.prototype.mulc=function(t){return new _t(this.r*t,this.g*t,this.b*t,this.a)},_t.prototype.div=function(t){var e=1/t;return this.mul(e)},_t.prototype.divc=function(t){var e=1/t;return this.mulc(e)},_t.prototype.normalize=function(){var t=1/this.a;return this.r*=t,this.g*=t,this.b*=t,this},_t.prototype.clamp=function(){return this.r=Et(this.r,0,255),this.g=Et(this.g,0,255),this.b=Et(this.b,0,255),this.a=Et(this.a,0,255),this},_t.prototype.round=function(){return this.r=Math.round(this.r),this.g=Math.round(this.g),this.b=Math.round(this.b),this.a=Math.round(this.a),this},_t.interpolate=function(t,e,n){return t.mul(n).add(e.mul(1-n))},_t.rand=function(){return new _t(255*Math.random(),255*Math.random(),255*Math.random(),255*Math.random())},_t.zero=function(){return new _t(0,0,0,0)},St.prototype.getPixel=function(t,e){var n=4*(e*this.w+t);return new _t(this.data[n+0],this.data[n+1],this.data[n+2],this.data[n+3])},St.prototype.sample=function(t,e){var n=Math.floor(e),r=Math.ceil(e),i=Math.floor(t),a=Math.ceil(t),o=t-i,s=e-n,u=this.getPixel(i,n).mul((1-s)*(1-o)).add(this.getPixel(i,r).mul(s*(1-o))).add(this.getPixel(a,n).mul((1-s)*o)).add(this.getPixel(a,r).mul(s*o));return u.clamp(),u},St.prototype.setPixel=function(t,e,n){var r=4*(e*this.w+t);this.data[r]=n.r,this.data[r+1]=n.g,this.data[r+2]=n.b,this.data[r+3]=n.a},St.prototype.apply=function(t){for(var e=0;e<this.h;e++)for(var n=0;n<this.w;n++)this.setPixel(n,e,t(this.getPixel(n,e)));return this},St.prototype.map=function(t){for(var e=0,n=0;e<this.h;++e)for(var r=0;r<this.w;++r,++n)this.setPixel(r,e,t(this.data[n],this.data[++n],this.data[++n],this.data[++n],r,e,this.w,this.h));return this},St.prototype.resize=function(t,e){for(var n=new St(t,e),r=1/(e-1),i=1/(t-1),a=0;a<e;a++)for(var o=a*r,s=0;s<t;s++){var u=s*i;n.setPixel(s,a,this.sample(u*(this.w-1),o*(this.h-1)))}return n},St.prototype.resize_longedge=function(t){var e,n;return this.w>this.h&&this.w>t?(e=t,n=Math.round(t/this.w*this.h),this.resize(e,n)):this.h>t?(n=t,e=Math.round(t/this.h*this.w),this.resize(e,n)):this},St.prototype.uploadTexture=function(t,e){t.bindTexture(t.TEXTURE_2D,e),t.texParameteri(t.TEXTURE_2D,t.TEXTURE_MIN_FILTER,t.NEAREST),t.texParameteri(t.TEXTURE_2D,t.TEXTURE_MAG_FILTER,t.NEAREST),t.texParameteri(t.TEXTURE_2D,t.TEXTURE_WRAP_S,t.CLAMP_TO_EDGE),t.texParameteri(t.TEXTURE_2D,t.TEXTURE_WRAP_T,t.CLAMP_TO_EDGE),t.texImage2D(t.TEXTURE_2D,0,t.RGBA,this.w,this.h,0,t.RGBA,t.UNSIGNED_BYTE,this.data)},St.prototype.toImageData=function(t){var e=t.createImageData(this.w,this.h);return e.data.set(this.data),e},St.prototype.render=function(t){t.width=this.w,t.height=this.h;var e=t.getContext("2d");e.putImageData(this.toImageData(e),0,0)},St.fromImage=function(t,e){var n=t.width,r=t.height;e.width=n,e.height=r;var i=e.getContext("2d");i.drawImage(t,0,0);var a=i.getImageData(0,0,n,r),o=new St(n,r,a.data);return a=null,i.clearRect(0,0,n,r),o};var kt,Pt,Rt={grayscale:function(t){return t.map(function(t,e,n,r){var i=Math.round((299*t+587*e+114*n)/1e3);return new _t(i,i,i,r)})},invert:function(t){return t.map(function(t,e,n,r){return new _t(255-t,255-e,255-n,r)})},brightness:function(t,e){var n=new _t(0,0,0,0);return t.map(function(t,r,i,a){return n.r=t+e,n.g=r+e,n.b=i+e,n.a=a,n.clamp()})},contrast:function(t,e){var n=new _t(0,0,0,0),r=Math.max((128+e)/128,0);return t.map(function(t,e,i,a){return n.r=t*r,n.g=e*r,n.b=i*r,n.a=a,n.clamp()})},brightnesscontrast:function(t,e,n){var r=Math.max((128+e)/128,0),i=new _t(0,0,0,0);return t.map(function(t,e,a,o){return i.r=t*r+n,i.g=e*r+n,i.b=a*r+n,i.a=o,i.clamp()})},histogram:function(t){function e(e){return t.apply(this,arguments)}return e.toString=function(){return t.toString()},e}(function(t){var e=t.h,n=t.w,r=Rt.grayscale(t),i=histogram(r,0,0,n,e),a=buildcdf(i),o=normalizecdf(a,255);return t.map(function(t,e,n,i,a,s){var u=r.getPixel(a,s).r,c=o[u]/u;return new _t(t*c,e*c,n*c,i).clamp().round()})}),ahe:function(t){for(var e=t.h,n=t.w,r=[64,64],i=Math.ceil(n/r[0]),a=Math.ceil(e/r[1]),o=new Array(a),s=0;s<a;s++)o[s]=new Array(i);var u=[1/r[0],1/r[1]],c=Rt.grayscale(t);for(s=0;s<a;s++)for(var l=s*r[1],f=Math.min(l+r[1],e),h=0;h<i;h++){var d=h*r[0],p=Math.min(d+r[0],n),v=histogram(c,d,l,p,f,256),g=buildcdf(v);g=normalizecdf(g,255),o[s][h]=g}for(var m=new St(n,e),y=t.data,b=0,w=0;b<e;++b)for(var x=0;x<n;++x,w+=4){var E=c.getPixel(x,b).r,_=Math.floor(E/1),S=x*u[0]-.5,k=b*u[1]-.5,P=Math.max(Math.floor(S),0),R=Math.min(P+1,i-1),A=Math.max(Math.floor(k),0),C=Math.min(A+1,a-1),I=S-P,F=k-A,O=((1-I)*(1-F)*o[A][P][_]+(1-I)*F*o[C][P][_]+I*(1-F)*o[A][R][_]+I*F*o[C][R][_])/E,T=new _t(y[w]*O,y[w+1]*O,y[w+2]*O,y[w+3]);m.setPixel(x,b,T.clamp())}return m},curve:function(t,e,n){var r=arguments.length>3&&void 0!==arguments[3]?arguments[3]:1;switch(n){case"red":return t.map(function(t,n,r,i){return new _t(e[t],n,r,i)});case"green":return t.map(function(t,n,r,i){return new _t(t,e[n],r,i)});case"blue":return t.map(function(t,n,r,i){return new _t(t,n,e[r],i)});case"brightness":default:var i=new _t(0,0,0,0);return t.map(function(t,n,a,o){var s=Math.round((299*t+587*n+114*a)/1e3),u=e[s]/(s+1e-6);return i.r=Math.round(t*u),i.g=Math.round(n*u),i.b=Math.round(a*u),i.a=Math.round(o*r),i.clamp()})}},reduction:function(t,e,n){switch(e){case"uniform":var r=Math.ceil(Math.pow(n,1/3)),i=Math.round;return t.map(function(t,e,n,a){return new _t(t=i(i(t/255*r)/r*255),e=i(i(e/255*r)/r*255),n=i(i(n/255*r)/r*255),a)});case"population":var a=colorHistogram(t,0,0,t.w,t.h),o=normalizecdf(buildcdf(a[0])),s=normalizecdf(buildcdf(a[1])),u=normalizecdf(buildcdf(a[2])),c=Math.ceil(Math.pow(n,1/3)),l=function(t){for(var e=[],n=(1-t[0])/c,r=0;r<=c;r++)for(var i=n*r+t[0],a=1;a<256;a++)if(t[a-1]<=i&&t[a]>=i){e.push(a);break}return e},f=l(o),h=l(s),d=l(u);return t.map(function(t,e,n,r){return new _t(t=findClosest(t,f),e=findClosest(e,h),n=findClosest(n,d),r)});case"mediancut":var p=algorithms.mediancut(t,n);return t.map(function(t,e,n,r){var i=findClosestColor(new _t(t,e,n,r),p);return new _t(i.r,i.g,i.b,r)});case"knn":return p=algorithms.kmeans(t,n),t.map(function(t,e,n,r){var i=findClosestColor(new _t(t,e,n,r),p);return new _t(i.r,i.g,i.b,r)});case"ann":return p=algorithms.neuralnetwork(t,n),t.map(function(t,e,n,r){var i=findClosestColor(new _t(t,e,n,r),p);return new _t(i.r,i.g,i.b,r)})}},spatialfilter:function(t,e){for(var n=t.w,r=t.h,i=Math.floor((e.width-1)/2),a=Math.floor((e.height-1)/2),o=e.weights,s=e.bias,u=1/e.factor,c=new St(n,r),l=t.data,f=Math.round,h=0,d=3;h<r;++h)for(var p=0;p<n;++p,d+=4){for(var v=0,g=0,m=0,y=-a,b=0,w=0;y<=a;++y,++b)for(var x=Ct(y+h,0,r-1),E=-i;E<=i;++E,++w){var _=4*(x*n+Ct(E+p,0,n-1)),S=o[w];v+=l[_]*S,g+=l[++_]*S,m+=l[++_]*S}v=f(Ct(v*u+s,0,255)),g=f(Ct(g*u+s,0,255)),m=f(Ct(m*u+s,0,255)),c.setPixel(p,h,new _t(v,g,m,l[d]))}return c},spatial:{gaussianfilter:function(t,e){for(var n=new Float32Array(t*t),r=.5*(t-1),i=.5*(t-1),a=2*e*e,o=0,s=0,u=0;s<t;s++)for(var c=s-i,l=0;l<t;l++,u++){var f=l-r;n[u]=Math.exp(-(f*f+c*c)/a),o+=n[u]}return{width:t,height:t,factor:o,bias:0,weights:n}},hsobel:function(){return{width:3,height:3,factor:1,bias:0,weights:[-1,0,1,-2,0,2,-1,0,1]}},vsobel:function(){return{width:3,height:3,factor:1,bias:0,weights:[-1,-2,-1,0,0,0,1,2,1]}},laplacian:function(){return{width:3,height:3,factor:1,bias:0,weights:[-1,-1,-1,-1,8,-1,-1,-1,-1]}},sharpenfilter:function(t,e,n){for(var r=Rt.spatial.gaussianfilter(t,e),i=0;i<r.weights.length;i++)r.weights[i]*=-1;var a=Math.floor((t*t-1)/2);return r.weights[a]=r.factor+r.weights[a]+n,r.factor=n,r}}},At=Rt,Ct=function(t,e,n){return Math.max(e,Math.min(t,n))},It=st({width:0,height:0,id:"imageTmpCanvas"}),Ft=n(11),Ot=n.n(Ft),Tt=function(t,e){return function(n){return{x:t.x+(e.x-t.x)*n,y:t.y+(e.y-t.y)*n}}},Mt=function(t){return Array.from(Array(t),function(t,e){return e})},Dt=function(t){var e=t.row,n=t.column,r=t.lerp,i=t.tiles,a=function(t,e){return r(e/i,t/i)};return[[a(e-1,n-2),a(e-1,n+1+1),a(e+1+2,n+1+1)]]},jt=function(t){return[t[0],{x:t[1].x-t[0].x,y:t[1].y-t[0].y},{x:t[2].x-t[0].x,y:t[2].y-t[0].y}]},Lt=function(t){var e=Tt(t[0],t[1]);return function(n,r){return Tt(e(n),t[2])(r)}},Bt=function(t){var e=t.canvasContext,n=t.origin,r=t.destination,i=Lt(n),a=Lt(r),o=function(t){var e,n=t.pixels,r=t.triangle,i=(e=r).reduce(function(t,n){var r=n.x,i=n.y;return{x:t.x+r/e.length,y:t.y+i/e.length}},{x:0,y:0});return r.map(function(t){return(e={origin:t,destination:i},r=e.origin,a=e.destination,o=function(t){return{x:r.x+(a.x-r.x)*t,y:r.y+(a.y-r.y)*t}},s=function(){return Math.hypot(r.x-a.x,r.y-a.y)},{interpolate:o,translate:function(t){return o(t/s())},getDistance:s}).translate(-n);var e,r,a,o,s})}({pixels:1,triangle:r});e.save(),e.beginPath(),o.forEach(function(t){var n=t.x,r=t.y;return e.lineTo(n,r)}),e.closePath(),e.clip();var s=Mt(1);Mt(1).forEach(function(t){s.forEach(function(n){var r=Dt({row:t,column:n,lerp:i,tiles:1}),o=l()(r,1)[0],s=Dt({row:t,column:n,lerp:a,tiles:1}),u=l()(s,1)[0];!function(t){var e=t.canvasContext,n=t.origin,r=t.destination;e.beginPath(),r.forEach(function(t){var n=t.x,r=t.y;return e.lineTo(n,r)}),e.closePath();var i=jt(n),a=jt(r),o=i[1].x*i[2].y-i[2].x*i[1].y;if(0!==o){var s=1/o,u=(i[2].y*a[1].x-i[1].y*a[2].x)*s,c=(i[1].x*a[2].y-i[2].x*a[1].y)*s,l=(i[1].x*a[2].x-i[2].x*a[1].x)*s,f=(i[2].y*a[1].y-i[1].y*a[2].y)*s,h=a[0].x-u*i[0].x-l*i[0].y,d=a[0].y-f*i[0].x-c*i[0].y;e.save(),e.transform(u,f,l,c,h,d),e.fill(),e.restore()}}({canvasContext:e,origin:o,destination:u})})}),e.restore()},Nt=function(t){var e=t.shape,n=t.canvas,r=t.lastEffectCanvas,i=t.image,a=e.type,o=e.lineJoin,s=e.lineCap,u=e.blur;!function(t){var e=t.canvas,n=t.lineJoin,r=t.lineCap,i=t.blur,a=t.alpha,o=void 0===a?1:a,s=e.getContext("2d");s.save(),void 0!==n&&(s.lineJoin=n),void 0!==r&&(s.lineCap=r),void 0!==o&&(s.globalAlpha=o),void 0===i||ht({blur:i})||(s.filter="blur(".concat(i,"px)"))}({canvas:n,lineJoin:o,lineCap:s,blur:u,alpha:e.alpha});var c,l=!1;switch(a){case"line":l=function(t){var e,n=t.canvas,r=t.points,i=t.color,a=t.width,o=t.alpha,s=t.blur,u=n.getContext("2d"),c=dt({color:i});return u.beginPath(),u.strokeStyle=c,u.lineWidth=a,r.forEach(function(t){if(e){var n=t.x,r=t.y,i=e,a=i.x,o=i.y;u.moveTo(a,o),u.lineTo(n,r)}e=t}),u.stroke(),!!ht({blur:s})&&(ft({canvas:n,blur:s,alpha:o,points:r}),!0)}(g()({},e,{canvas:n}));break;case"polygon":l=function(t){var e=t.alpha,n=t.canvas,r=t.points,i=t.color,a=t.gradient,o=t.border,s=t.blur,u=t.smoothEdges,c=t.ellipses,l=t.clip;return c?(xt({canvas:n,points:r,color:i,gradient:a,blur:s,ellipses:c,clip:l}),ht({blur:s})&&ft({canvas:n,blur:s,alpha:e,points:r}),!0):ht({blur:s})&&!o||u?(xt({canvas:n,points:r,color:i,gradient:a,blur:s,smoothEdges:u}),!0):(wt({canvas:n,color:i,gradient:a,border:o,shape:{type:"path",points:r}}),!!ht({blur:s})&&(ft({canvas:n,blur:s,alpha:e,points:r}),!0))}(g()({},e,{canvas:n,blur:u}));break;case"image":l=function(t){var e=t.canvas,n=t.clip,r=t.filters,i=void 0===r?{}:r,a=t.lastEffectCanvas,o=t.from,s=t.blur,u=t.alpha,c=t.originalImage,l=e.getContext("2d"),f=n?ct(n):{x:0,y:0,width:e.width,height:e.height},h=parseInt(f.x,10),d=parseInt(f.y,10),p=parseInt(f.width,10),v=parseInt(f.height,10),g="lastEffectImage"===o?function(t){var e=t.lastEffectCanvas,n=t.x,r=t.y,i=t.width,a=t.height;return new St(i,a,e.getContext("2d").getImageData(n,r,i,a).data)}({lastEffectCanvas:a,x:h,y:d,width:p,height:v}):function(t){var e=t.originalImage,n=t.x,r=t.y,i=t.width,a=t.height;It.width=i,It.height=a;var o=It.getContext("2d");return o.putImageData(e,-n,-r),new St(i,a,o.getImageData(0,0,i,a).data)}({originalImage:c,x:h,y:d,width:p,height:v});return function(t){var e=t.image,n=t.filters,r=t.canvas;Object.keys(n).reduce(function(t,e){var r,i,a=n[e];switch(e){case"curve":return At.curve(t,(r={curvePoints:a.points},i=0,r.curvePoints.reduce(function(t,e){var n=e.offset,r=e.value,a=n-(0===t.length?0:t.length-1),o=parseInt((r-i)/a,10),s=Array(a).fill(0).map(function(){return i+=o});return[].concat(S()(t),S()(s))},[])),a.channel);default:return t}},e).render(r)}({image:g,filters:i,canvas:It}),l.save(),n&&(l.beginPath(),n.forEach(function(t,e){var n=t.x,r=t.y;return 0===e?l.moveTo(n,r):l.lineTo(n,r)}),l.closePath(),l.clip()),l.drawImage(It,h,d,p,v),l.restore(),!!ht({blur:s})&&(ft({canvas:e,blur:s,alpha:u,points:n}),!0)}(g()({},e,{canvas:n,lastEffectCanvas:r,originalImage:i}));break;case"warping":l=function(t){var e=t.canvas,n=t.lastEffectCanvas,r=t.from,i=t.to,a=Ot()(r.map(function(t){return[t.x,t.y]})).filter(function(t){return t.some(function(t){return function(t){var e,n,r=t.point,i=t.from,a=t.to;return e=i[r],n=a[r],!(e.x===n.x&&e.y===n.y)}({point:t,from:r,to:i})})}),o=e.getContext("2d");o.save();var s=o.createPattern(n,"no-repeat");return o.fillStyle=s,a.forEach(function(t){var e=t.map(function(t){return r[t]}),a=t.map(function(t){return i[t]});Bt({canvasContext:o,lastEffectCanvas:n,origin:e,destination:a})}),o.restore(),!0}(g()({},e,{canvas:n,lastEffectCanvas:r}))}return(c={canvas:n}.canvas.getContext("2d")).restore(),c.filter="none",{drawIsNeeded:l}},Vt={line:1,polygon:2,image:3,warping:4},Ut={color:1,overlay:2,lighter:3},zt=function(t){var e=t.effectsToRender,n=t.canvas,r=t.image,i=e.reduce(function(t,e){var n=e.shapes;return[].concat(S()(t),S()(n))},[]).sort(function(t,e){var n=t.zIndex||0,r=e.zIndex||0;if(n!==r)return n-r;var i=Vt[t.type]-Vt[e.type];if(i)return i;var a=Ut[t.compositeMode]-Ut[e.compositeMode];if(a)return a;var o=t.blur-e.blur;return o||0});i.forEach(function(t,e){var a=function(t){var e=t.canvas;if(!kt){var n=e.width,r=e.height;kt=st({id:"effectCanvas",width:n,height:r})}return kt}({canvas:n}),o=Nt({shape:t,canvas:a,lastEffectCanvas:n,image:r}).drawIsNeeded,s=e<i.length?i[e+1]:null;if(!s||o||function(t){var e=t.shape,n=t.nextShape;return e.compositeMode!==n.compositeMode||"image"===n.type&&"lastEffectImage"===n.from||"warping"===n.type}({shape:t,nextShape:s})){var u=t.compositeMode;!function(t,e){var n=e.effectCanvas,r=e.compositeMode,i=t.getContext("2d");i.save(),r&&(i.globalCompositeOperation=r),i.drawImage(n,0,0,n.width,n.height),i.restore()}(n,{effectCanvas:a,compositeMode:u}),function(t){var e=t.canvas;e.getContext("2d").clearRect(0,0,e.width,e.height)}({canvas:a})}})},Wt=n(12),Ht=n.n(Wt),Gt=function(t){if(t.status<200||t.status>=300){var e=new Error(t.statusText);throw e.requestResponse=t,e}return t},qt={test:"https://partner-test.revieve.com/api",prod:"https://partner.revieve.com/api"},Kt=(/iPad|iPhone|iPod/.test(window.navigator.userAgent)&&window.MSStream,window.innerWidth,!!window.safari||!!navigator.platform&&/iPad|iPhone|iPod/.test(navigator.platform),function(t,e,n){return new Promise(function(r,i){var a=new FormData;a.append("partner_id",t),a.append("image",function(t){var e=function(t){var e=null;if("string"!=typeof t)return e;var n=t.match(/data:([a-zA-Z0-9]+\/[a-zA-Z0-9-.+]+).*,.*/);return n&&n.length&&(e=n[1]),e}(t);return Ht()(t.replace("data:".concat(e,";base64,"),""),e)}(n));var o=qt[e]+"/analyzeImage/3/?skintone=0&gender=female&components=ar_landmarks,makeup";return o||i(),fetch(encodeURI(o),{method:"POST",body:a}).then(Gt).then(function(t){return r(t.json())}).catch(function(t){console.error("Request failed",t),i()})})}),Yt=function(){var t=p()(h.a.mark(function t(e){var n,r,i,a,o,s,u;return h.a.wrap(function(t){for(;;)switch(t.prev=t.next){case 0:return n=e.cloudFunction,r=e.environment,i=e.options,a=void 0===i?{}:i,o="".concat(qt[r],"/functions/").concat(n),t.next=4,fetch(o,{method:"POST",body:JSON.stringify(a),headers:{"Content-Type":"application/json","X-Parse-Application-Id":"Revieve API"}});case 4:return s=t.sent,t.next=7,s.json();case 7:return u=t.sent,t.abrupt("return",Gt(u));case 9:case"end":return t.stop()}},t)}));return function(e){return t.apply(this,arguments)}}(),Jt=function(){var t=p()(h.a.mark(function t(e){var n,r,i;return h.a.wrap(function(t){for(;;)switch(t.prev=t.next){case 0:if(n=e.partnerID,r=e.environment,!Pt){t.next=3;break}return t.abrupt("return",Pt);case 3:return t.next=5,Yt({cloudFunction:"getLiveARModules",environment:r,options:{partner_id:n}});case 5:if(!(i=t.sent).result||!i.result.modules){t.next=9;break}return Pt=i.result.modules,t.abrupt("return",Pt);case 9:throw new Error("Response has not result.modules data");case 10:case"end":return t.stop()}},t)}));return function(e){return t.apply(this,arguments)}}(),$t=function(){var t=p()(h.a.mark(function t(e){var n,r,i,a;return h.a.wrap(function(t){for(;;)switch(t.prev=t.next){case 0:return n=e.effectName,r=e.partnerID,i=e.environment,t.next=3,Jt({partnerID:r,environment:i});case 3:return a=t.sent,t.abrupt("return",a.includes(n));case 5:case"end":return t.stop()}},t)}));return function(e){return t.apply(this,arguments)}}(),Xt=n(13),Zt=function(t){return function(){return t.srcObject.getVideoTracks()[0].getSettings()}},Qt=function(){var t=p()(h.a.mark(function t(e){var n,r,i;return h.a.wrap(function(t){for(;;)switch(t.prev=t.next){case 0:return n=e.rootElement,(r=document.createElement("video")).id="_webcam",r.playsInline=!0,r.muted=!0,Object(Xt.disableBodyScroll)(r),r.style.width="0px",r.style.height="0px",r.style.position="absolute",n.appendChild(r),t.next=12,window.navigator.mediaDevices.getUserMedia({video:{width:640,height:480,frameRate:30,facingMode:{ideal:"user"}}});case 12:return i=t.sent,r.srcObject=i,t.next=16,r.play();case 16:return t.abrupt("return",[r,Zt(r)]);case 17:case"end":return t.stop()}},t)}));return function(e){return t.apply(this,arguments)}}(),te=function(t){var e=t.id,n=t.width,r=t.height,i=document.createElement("canvas");return i.id=e,i.width=n,i.height=r,i},ee=function(t){var e=t.width,n=t.height,r=t.canvas,i=te({width:e,height:n}),a=i.getContext("2d");return[r,function(){return a.clearRect(0,0,e,n),a.drawImage(r,0,0,e,n),i.toDataURL("image/jpeg")}]};if(document.currentScript&&document.currentScript.src){var ne=new URL(document.currentScript.src).href,re=ne.substring(0,ne.lastIndexOf("/"));n.p=re+n.p}var ie={initializing:"initializing",activatingAdvanceTracking:"activatingAdvanceTracking",renderingEffects:"renderingEffects",unmount:"unmount"},ae={statusChanged:"statusChanged",advanceTracking:"advanceTracking"},oe={waitingUserFace:"waitingUserFace",waitingResponse:"waitingResponse"},se=function(t){for(var e=t.rootElement;e.firstChild;)e.removeChild(e.firstChild)},ue=function(t){var e=t.rootElement,n=t.width,r=t.height,i=te({width:n,height:r,id:"_imageData"}),a=document.createElement("div");return a.style.width="100%",a.style.height="100%",a.style.overflow="hidden",a.className="canvasContainer",a.appendChild(i),e.appendChild(a),i},ce=function(t){var e=t.customPoints,n=e.frontHead,r=e.leftEyeShadow,i=e.rightEyeShadow,a=e.leftEyeliner,o=e.rightEyeliner,s=e.rightEyelinerOutterPoint,u=e.rightEyelinerInnerPoint,c=e.leftEyelinerOutterPoint,l=e.leftEyelinerInnerPoint,f=e.backend,h=e.underLeftEye,d=e.underRightEye,p=e.underLeftEyebrows,v=e.underRightEyebrows,g=e.leftEyelid,m=e.rightEyelid,y=t.advanceTrackingReady,b=S()(n).reverse(),w=[0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16].concat(S()(d),[27,28,29,30,33,51,53,54,55,56,57,58,48,49,50,51,33,30,29,28,27],S()(h),[17,18,19,20,21,h[0],27,d[6],22,23,24,25,26,d[0],16],S()(b));return y?{lipstick:[[].concat(S()(f.slice(0,25)),[64,63,62,61,60]),[].concat(S()(f.slice(24,49)),[60,67,66,65,64])],lipliner:f.slice(0,49),eyeliner:{line:[f.slice(49,99),f.slice(149,199)],polygon:[[].concat(S()(s),[f.slice(49,99)],S()(u),S()(o),S()(s)),[].concat(S()(l),[f.slice(149,199)],S()(c),S()(a),S()(l))]},blush:[[1,3,48,31],[54,35,15,13]],eyeshadow:{clip:{eyes:[36,37,38,39,27,42,43,44,45,46,47,42,27,39,40,41,36],face:[0,17,18,19,20,21,22,23,24,25,26,16,15,14,2,1,0]},basic:{left:[36].concat(S()(r),[39,38,37,36]),right:[42].concat(S()(i),[45,44,43,42])},extended:{left:{top:[27].concat(S()(p),[0,36,37,38,39]),bottom:[0,1,2,31,30,29,28,27,39,40,41,36]},right:{top:[27].concat(S()(v),[16,45,44,43,42]),bottom:[27,28,29,30,35,14,15,16,45,46,47,42]}}},foundation:w,eyebrows:[[17,18,19,20,21].concat(S()(p)),[26,25,24,23,22].concat(S()(v))],eyebrowsTransform:[[0,n[0],n[5],16].concat(S()(m),[27],S()(g)),[17,18,19,20,21].concat(S()(p)),[26,25,24,23,22].concat(S()(v))]}:{lipstick:[[48,49,50,51,52,53,54,64,63,62,61,60],[48,60,67,66,65,64,54,55,56,57,58,59]],lipliner:[48,49,50,51,52,53,54,55,56,57,58,59],eyeliner:{line:[[42,43,44,45],[36,37,38,39]],polygon:[[].concat(S()(s),[45,44,43,42],S()(u),S()(o),S()(s)),[].concat(S()(l),[39,38,37,36],S()(c),S()(a),S()(l))]},blush:[[1,3,48,31],[54,35,15,13]],eyeshadow:{clip:{eyes:[36,37,38,39,27,42,43,44,45,46,47,42,27,39,40,41,36],face:[0,17,18,19,20,21,22,23,24,25,26,16,15,14,2,1,0]},basic:{left:[36].concat(S()(r),[39,38,37,36]),right:[42].concat(S()(i),[45,44,43,42])},extended:{left:{top:[27].concat(S()(p),[0,36,37,38,39]),bottom:[0,1,2,31,30,29,28,27,39,40,41,36]},right:{top:[27].concat(S()(v),[16,45,44,43,42]),bottom:[27,28,29,30,35,14,15,16,45,46,47,42]}}},foundation:w,eyebrows:[[17,18,19,20,21].concat(S()(p)),[26,25,24,23,22].concat(S()(v))],eyebrowsTransform:[[0,n[0],n[5],16].concat(S()(m),[27],S()(g)),[17,18,19,20,21].concat(S()(p)),[26,25,24,23,22].concat(S()(v))]}},le=function(){function t(e){var n=this,r=e.renderToSelector,i=e.partnerID,a=e.environment,o=void 0===a?"test":a,s=e.debug,u=void 0!==s&&s,c=e.advanceTracking,f=void 0!==c&&c,d=e.eventHandler,v=void 0===d?function(){}:d;if(y()(this,t),E()(this,"imageCanvas",null),E()(this,"webcamElement",null),E()(this,"rootElement",null),E()(this,"stats",null),E()(this,"initialState",{eventHandler:null,debug:null,status:null,partnerID:null,environment:null,BRF:null,BRFManager:null,resolution:null,extFace:null,whiteBalance:[1,1,1],advanceTracking:{enabled:!1,ready:!1,maxRetries:3,currentRetry:1,retryFrameCounter:0,framesWithFace:30,retryState:oe.waitingUserFace,extendedPoints:null},effects:{lipstick:{enabled:!1,color:[190,6,6],strength:.7,finish:"natural",finishStrength:.7},lipliner:{enabled:!1,color:[255,20,30],strength:1,thickness:1},blush:{enabled:!1,color:[183,10,10],strength:.1},eyeliner:{enabled:!1,color:[20,20,30],strength:1,thickness:2},eyeshadow:{enabled:!1,color:[143,57,102],strength:.6,height:1},foundation:{enabled:!1,color:[0,0,0],coverage:.1},eyebrows:{enabled:!1,color:[0,0,0],strength:.7},eyebrowsTransform:{enabled:!1,height:.5,arc:.5}}}),E()(this,"state",g()({},this.initialState)),E()(this,"initializeStats",function(){n.stats=new P.a,n.stats.events={},n.stats.renderFramePanel=n.stats.addPanel(new P.a.Panel("rdrFrame","#ff8","#221")),n.stats.BRFTracking=n.stats.addPanel(new P.a.Panel("BRF","#d632ff","#221")),n.stats.calcEffects=n.stats.addPanel(new P.a.Panel("calcFX","#4c9fff","#221")),n.stats.renderEffects=n.stats.addPanel(new P.a.Panel("rdrFX","#3abf35","#221")),n.stats.dom.style.right="0px",n.stats.dom.style.left="auto",n.stats.showPanel(0),document.body.appendChild(n.stats.dom)}),E()(this,"registerStatsStep",function(t){if(n.state.debug)switch(t){case"init":n.stats.lastEvent=(performance||Date).now(),n.stats.begin();break;case"end":n.stats.end();break;case"renderFrameIntoCanvas":var e=(performance||Date).now(),r=e-n.stats.lastEvent,i=Math.max(n.stats.maxRenderFramePanel||3,r);n.stats.renderFramePanel.update(r,1.1*i),n.stats.maxRenderFramePanel=i,n.stats.lastEvent=e;break;case"BRFTracking":var a=(performance||Date).now(),o=a-n.stats.lastEvent,s=Math.max(n.stats.maxBRFTracking||3,o);n.stats.BRFTracking.update(o,1.1*s),n.stats.maxBRFTracking=s,n.stats.lastEvent=a;break;case"calcEffects":var u=(performance||Date).now(),c=u-n.stats.lastEvent,l=Math.max(n.stats.maxCalcEffects||3,c);n.stats.calcEffects.update(c,1.1*l),n.stats.maxCalcEffects=l,n.stats.lastEvent=u;break;case"renderEffects":var f=(performance||Date).now(),h=f-n.stats.lastEvent,d=Math.max(n.stats.maxRenderEffects||3,h);n.stats.renderEffects.update(h,1.1*d),n.stats.maxRenderEffects=d,n.stats.lastEvent=f}}),E()(this,"unmount",function(){for(n.webcamElement.srcObject.getTracks().forEach(function(t){return t.stop()}),n.state=g()({},n.initialState,{status:ie.unmount});n.rootElement.firstChild;)n.rootElement.removeChild(n.rootElement.firstChild);n.rootElement=null}),E()(this,"sendEvent",function(){}),E()(this,"changeStatus",function(t){var e=t.newStatus;n.state.status=e,n.sendEvent({type:ae.statusChanged,state:e})}),E()(this,"changeAdvanceTrackingRetryStatus",function(t){var e=t.newStatus,r=t.isError,i=void 0!==r&&r,a=t.errorMessage,o=void 0===a?"":a,s=n.state.advanceTracking,u=s.maxRetries,c=s.currentRetry;n.state.advanceTracking.retryState=e,n.sendEvent({type:ae.advanceTracking,state:e,isError:i,currentRetry:c,maxRetries:u,errorMessage:o})}),E()(this,"changeEffects",p()(h.a.mark(function t(){var e,r,i,a,o,s,u=arguments;return h.a.wrap(function(t){for(;;)switch(t.prev=t.next){case 0:return e=u.length>0&&void 0!==u[0]?u[0]:{},r=n.state,i=r.effects,a=r.partnerID,o=r.environment,t.next=4,A()(Object.keys(i),function(){var t=p()(h.a.mark(function t(n,r){return h.a.wrap(function(t){for(;;)switch(t.prev=t.next){case 0:if(!e[r]||!e[r].enabled){t.next=6;break}return t.next=3,$t({effectName:r,partnerID:a,environment:o});case 3:if(t.sent){t.next=6;break}throw new Error("No license for ".concat(r," effect"));case 6:return t.abrupt("return",g()({},n,E()({},r,g()({},i[r],e[r]))));case 7:case"end":return t.stop()}},t)}));return function(e,n){return t.apply(this,arguments)}}(),{});case 4:s=t.sent,n.debug({message:"effectsChanged",changeEffects:e,newEffects:s}),n.state.effects=s;case 7:case"end":return t.stop()}},t)}))),E()(this,"debug",function(t,e){if(n.state.debug)if(e){var r="\n          display: block !important;\n          margin: 10px 0;\n          padding: ".concat(Math.floor(100),"px ").concat(Math.floor(100),"px;\n          background: url('").concat(e,"');\n          background-size: ").concat(200,"px ").concat(200,"px;\n          background-repeat: no-repeat;\n          background-position: center;\n          background-size: contain;\n        ");console.log("".concat(t," %c "),r)}else console.log(t)}),E()(this,"init",p()(h.a.mark(function t(){var e,r,i,a,o,s,u,c,f,d,p,v;return h.a.wrap(function(t){for(;;)switch(t.prev=t.next){case 0:return t.prev=0,n.debug("Start initialization"),e=n.rootElement,se({rootElement:e}),n.debug("Starting webcam"),t.next=7,Qt({rootElement:e});case 7:return r=t.sent,i=l()(r,1),a=i[0],n.debug("Webcam started"),o=a.videoWidth,s=a.videoHeight,u=ue({rootElement:e,width:o,height:s}),n.debug("Canvas created and injected"),n.debug("Initializing BRF"),t.next=17,B.initialize({width:o,height:s,log:n.debug});case 17:return c=t.sent,f=c.BRF,d=c.resolution,p=c.extFace,v=c.BRFManager,n.imageCanvas=u,n.webcamElement=a,n.state=g()({},n.state,{resolution:d,extFace:p,BRF:f,BRFManager:v}),n.debug("Resize the canvas"),n.onResize(),window.addEventListener("resize",n.onResize.bind(n)),n.debug("Start tracking"),n.changeStatus({newStatus:n.state.advanceTracking.enabled?ie.activatingAdvanceTracking:ie.renderingEffects}),n.state.debug&&n.initializeStats(),t.next=33,n.onFrame();case 33:t.next=39;break;case 35:throw t.prev=35,t.t0=t.catch(0),alert("No camera available."),t.t0;case 39:case"end":return t.stop()}},t,null,[[0,35]])}))),E()(this,"renderWebcamImageTic",function(){var t=n.imageCanvas,e=n.webcamElement,r=n.state.resolution,i=r.width,a=r.height;ut({source:{width:i,height:a,image:e,mirrored:!0},canvas:t})}),E()(this,"advanceTrackingTic",p()(h.a.mark(function t(){var e,r,i,a,o,s,u,c,f,d,p,v,g,m,y,b,w,x,E,_,S,k,P,R,A,C;return h.a.wrap(function(t){for(;;)switch(t.prev=t.next){case 0:if(e=n.imageCanvas,r=n.state,i=r.BRF,a=r.BRFManager,o=r.resolution,s=o.width,u=o.height,c=r.partnerID,f=r.environment,d=r.advanceTracking,p=d.retryState,v=d.framesWithFace,g=d.retryFrameCounter,m=e.getContext("2d"),p!==oe.waitingUserFace){t.next=43;break}if(a.update(m.getImageData(0,0,s,u).data),(y=a.getFaces()).length>0&&(y[0].state===i.BRFState.FACE_TRACKING_START||y[0].state===i.BRFState.FACE_TRACKING)){t.next=12;break}n.state.advanceTracking.retryFrameCounter=0,t.next=43;break;case 12:if(!(g<v)){t.next=15;break}return n.state.advanceTracking.retryFrameCounter+=1,t.abrupt("return",!1);case 15:return n.changeAdvanceTrackingRetryStatus({newStatus:oe.waitingResponse}),b=ee({canvas:e,width:800,height:600}),w=l()(b,2),x=w[1],t.prev=17,E=x(),n.debug("extendedPoint: Call to server",E),t.next=22,Kt(c,f,E);case 22:if(_=t.sent,S=_.message,k=_.results,P=_.status,"Error"!==S&&k){t.next=26;break}throw new Error(P[0].description);case 26:if(R=k.filter(function(t){return"LandmarkData"===t.description}),A=l()(R,1),C=A[0]){t.next=29;break}throw new Error("Extended points not received from backend");case 29:return n.state.advanceTracking.ready=!0,n.state.advanceTracking.extendedPoints=C,t.abrupt("return",!0);case 34:if(t.prev=34,t.t0=t.catch(17),n.debug("extendedPoint: Call failed: ".concat(t.t0.message)),!(d.currentRetry<d.maxRetries)){t.next=42;break}return n.state.advanceTracking.currentRetry+=1,n.changeAdvanceTrackingRetryStatus({newStatus:oe.waitingUserFace,isError:!0,errorMessage:t.t0.message}),n.state.advanceTracking.retryFrameCounter=0,t.abrupt("return",!1);case 42:return t.abrupt("return",!0);case 43:return t.abrupt("return",!1);case 44:case"end":return t.stop()}},t,null,[[17,34]])}))),E()(this,"renderEffectsTic",function(){var t=n.imageCanvas,e=n.state,r=e.BRF,i=e.BRFManager,a=e.resolution,o=a.width,s=a.height,u=e.extFace,c=e.effects,l=e.advanceTracking,f=e.whiteBalance,h=t.getContext("2d").getImageData(0,0,o,s);i.update(h.data);var d=i.getFaces();n.registerStatsStep("BRFTracking"),d.forEach(function(e){if(e.state===r.BRFState.FACE_TRACKING_START||e.state===r.BRFState.FACE_TRACKING){var i=c.eyeshadow.height||1;u.setEyeshadowHeight(i);var a=c.eyeliner.thickness||1,o=c.eyeliner.offset||{inner:0,outer:0};u.setEyelinerThickness(a),u.setEyelinerOffset(o);var s=u.update(e,l.extendedPoints),d=ce({customPoints:s,advanceTrackingReady:l.ready}),p=ot({vertices:u.vertices,shapes:d,effects:c,whiteBalance:f});n.registerStatsStep("calcEffects"),zt({effectsToRender:p,canvas:t,image:h}),n.registerStatsStep("renderEffects")}})}),E()(this,"onFrame",p()(h.a.mark(function t(){var e;return h.a.wrap(function(t){for(;;)switch(t.prev=t.next){case 0:if((e=n.state.status)!==ie.unmount){t.next=3;break}return t.abrupt("return");case 3:n.registerStatsStep("init"),n.renderWebcamImageTic(),n.registerStatsStep("renderFrameIntoCanvas"),t.t0=e,t.next=t.t0===ie.activatingAdvanceTracking?9:t.t0===ie.renderingEffects?11:13;break;case 9:return n.advanceTrackingTic().then(function(t){t&&n.changeStatus({newStatus:ie.renderingEffects})}),t.abrupt("break",14);case 11:return n.renderEffectsTic(),t.abrupt("break",14);case 13:return t.abrupt("break",14);case 14:requestAnimationFrame(n.onFrame),n.registerStatsStep("end");case 16:case"end":return t.stop()}},t)}))),"string"!=typeof i||!i)throw new Error("partnerID is mandatory and it must be string typed");if("string"!=typeof r||!r)throw new Error("renderToSelector is mandatory and it must be string typed");var m=document.querySelector(r);if(!m)throw new Error("renderToSelector must define a valid object");var b=ie.initializing;this.rootElement=m,this.state=g()({},this.state,{debug:u,partnerID:i,environment:o,status:b,eventHandler:v,advanceTracking:g()({},this.state.advanceTracking,{enabled:f})}),this.sendEvent=v,this.sendEvent({type:ae.statusChanged,state:ie.initializing})}return w()(t,[{key:"onResize",value:function(){var t=this.imageCanvas,e=this.rootElement;!function(t){var e=t.canvas,n=t.width,r=t.height,i=e.height,a=e.width,o=e.style,s=r/i,u=n/a,c=Math.max(u,s),l=c,f=c,h=Math.min(0,(n-a*c)/2),d=Math.min(0,(r-i*c)/2);o.transformOrigin="0% 0%",o.transform="matrix(".concat(l,", ").concat(0,", ").concat(0,", ").concat(f,", ").concat(h,", ").concat(d,")")}({canvas:t,width:e.clientWidth,height:e.clientHeight})}}]),t}();E()(le,"states",ie),E()(le,"eventTypes",ae);var fe=function(){var t=p()(h.a.mark(function t(e){var n,r,i,a,o,s,u;return h.a.wrap(function(t){for(;;)switch(t.prev=t.next){case 0:return n=e.renderToSelector,r=e.partnerID,i=e.debug,a=e.effects,o=e.advanceTracking,s=e.eventHandler,u=new le({renderToSelector:n,partnerID:r,debug:i,advanceTracking:o,eventHandler:s}),t.next=4,u.init();case 4:return u.changeEffects(a),t.abrupt("return",{changeEffects:u.changeEffects.bind(void 0),unmount:u.unmount.bind(void 0)});case 6:case"end":return t.stop()}},t)}));return function(e){return t.apply(this,arguments)}}();window.RevieveLiveAR=fe,e.default=fe}])},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var r=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}(),i=u(n(149)),a=u(n(154)),o=n(56),s=n(44);function u(t){return t&&t.__esModule?t:{default:t}}var c=function(t,e,n){var r=(t-e)/(n-e);return Math.round(100*r+0)},l=function(){function t(e){if(function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,t),!e)return console.error("RevieveCV: Constructor needs an SDK instance"),Object.create(null);this._sdk=e,this._state={}}return r(t,[{key:"setImage",value:function(t){var e=this;return new Promise(function(n){"string"!=typeof t?(0,i.default)(t,function(t){var r=t.toDataURL("image/jpeg");e._state.image=r,e._sdk.analytics.sendEvent("RevieveCV.setImage"),(0,o.getImageDimensions)(r).then(function(t){e._state.imageDimensions=t,n(t)})},{canvas:!0,orientation:!0}):(e._state.image=t,(0,o.getImageDimensions)(t).then(function(t){e._state.imageDimensions=t,n(t)})),e._sdk.AR._state.needsReset=!0})}},{key:"analyzeImage",value:function(){var t=this;return new Promise(function(e,n){t._state.image||e(),t._sdk.analytics.sendEvent("RevieveCV.analyzeImage"),(0,a.default)(t._sdk.getApiVersion(),t._sdk.getPartnerId(),t._state.image,t._sdk.getConfiguration().skintone,t._sdk.getConfiguration().gender_ui,t._sdk.isTesting(),t._sdk.getEnvironment(),t._sdk.getConfiguration().components).then(function(r){if(!r||r&&"Error"===r.message){t._state.error=!0;var i=r.status[0].description;console.error(i),r&&r.status&&(t._state.status=r.status),r&&r.message&&(t._state.message=r.message),n(new Error(i))}else{if(r.status){t._state.status=r.status;var a=!0,s=!1,u=void 0;try{for(var c,l=t._state.status[Symbol.iterator]();!(a=(c=l.next()).done);a=!0){c.value.isError&&(t._state.error=!0)}}catch(t){s=!0,u=t}finally{try{!a&&l.return&&l.return()}finally{if(s)throw u}}}if(t._state.message=r.message,"Error"===t._state.message)t._sdk.analytics.sendEvent("RevieveCV.analyzeImageError");else if("OK"===t._state.message)t._sdk.analytics.sendEvent("RevieveCV.analyzeImageSuccess");else if("Warning"===t._state.message){var f=!0,h=!1,d=void 0;try{for(var p,v=t._state.status[Symbol.iterator]();!(f=(p=v.next()).done);f=!0){var g=p.value;t._sdk.analytics.sendEvent("RevieveCV.analyzeImageWarning",g.description)}}catch(t){h=!0,d=t}finally{try{!f&&v.return&&v.return()}finally{if(h)throw d}}}t._state.results=r.results,t._state.faceArea=r.face_area,t._state.masks=(0,o.findMasks)(t._state.results),t._state.error=!1,t._sdk.AR._state.whiteBalanceValue=r.inverse_color_balance_rb,t._sdk.setWrinkles(t.getWrinkles(),"cv"),t._sdk.setRedness(t.getRedness()),t._sdk.setEyebags(t.getEyebags(),"cv");var m=t.getSkinFoundation();m&&(t._sdk.setSkintoneColor(m.hex),t._sdk.setSkintone(m.skintone,!1,null,!1)),e()}}).catch(function(t){n(t)})})}},{key:"getState",value:function(){return this._state}},{key:"hasError",value:function(){return this._state.error}},{key:"getStatus",value:function(){return this._state.status}},{key:"getResults",value:function(){return this._state.results}},{key:"getFaceArea",value:function(){return this._state.faceArea}},{key:"getMasks",value:function(){return this._state.masks}},{key:"getImage",value:function(){return this._state.image}},{key:"getAnonymizeImage",value:function(){return this._sdk.getConfiguration().components&&this._sdk.getConfiguration().components.includes("eyes")?this._state.results?(0,o.anonymizeImage)({image:this._state.image,dimensions:this._state.imageDimensions,results:this._state.results}):(console.error("You need analyze the image before"),null):(console.error("You need eyes component active in CV module to apply this effect"),null)}},{key:"getElementFromResults",value:function(t){return this._state.results?(0,o.getPropertyInPath)(this._state.results,f[t],"value"):null}},{key:"getWrinkles",value:function(){var t=arguments.length>0&&void 0!==arguments[0]&&arguments[0],e=this.getElementFromResults("wrinkles");return t?c(e,0,1):e}},{key:"getRedness",value:function(){var t=arguments.length>0&&void 0!==arguments[0]&&arguments[0],e=this.getElementFromResults("redness");return t?c(e,0,1):e}},{key:"getHyperpigmentation",value:function(){var t=arguments.length>0&&void 0!==arguments[0]&&arguments[0],e=this.getElementFromResults("hyperpigmentation");return t?c(e,0,1):e}},{key:"getSmoothness",value:function(){var t=arguments.length>0&&void 0!==arguments[0]&&arguments[0],e=this.getElementFromResults("smoothness");return t?c(e,0,1):e}},{key:"getEyebags",value:function(){var t=arguments.length>0&&void 0!==arguments[0]&&arguments[0],e=this.getElementFromResults("eyebags");return t?c(e,0,1):e}},{key:"getDarkcircles",value:function(){var t=arguments.length>0&&void 0!==arguments[0]&&arguments[0],e=this.getElementFromResults("darkcircles");return t?c(e,0,1):e}},{key:"getTexture",value:function(){var t=arguments.length>0&&void 0!==arguments[0]&&arguments[0],e=this.getElementFromResults("texture");return t?c(e,0,1):e}},{key:"getSkinShine",value:function(){var t=arguments.length>0&&void 0!==arguments[0]&&arguments[0],e=this.getElementFromResults("skinShine");return t?c(e,0,1):e}},{key:"getAcne",value:function(){var t=arguments.length>0&&void 0!==arguments[0]&&arguments[0],e=this.getElementFromResults("acne");return t?c(e,0,1):e}},{key:"getFaceShape",value:function(){var t=this.getElementFromResults("faceShape");return s.makeupMeasures.faceShape[t]}},{key:"getEyeColor",value:function(){var t=this.getElementFromResults("eyeColor");return s.makeupMeasures.eyeColor[t]}},{key:"getSkinUndertone",value:function(){var t=this.getElementFromResults("skinUndertone");return s.makeupMeasures.skinUndertone[t]}},{key:"getSkinFoundation",value:function(){var t=this.getElementFromResults("skinFoundation"),e=null;if(t&&t.length>0){var n=t[0],r=this.getElementFromResults("skinFitzpatrick");e={rgb:n,hex:(0,o.rgbToHex)(n),skintone:parseInt(r,10)}}return e}},{key:"detectSkintoneFromSkinColor",value:function(t){var e=t;"string"==typeof t&&(e=(0,o.hexToRgb)(t));var n=null,r=null;for(var i in h)if(h[i]){var a=h[i],s=e[1]-a;s<0&&(s*=-1),(!r||s<r)&&(r=s,n=i)}return n}},{key:"getFindings",value:function(){var t=arguments.length>0&&void 0!==arguments[0]&&arguments[0];return this._state.results?{hyperpigmentation:{value:this.getHyperpigmentation(t),masks:this._state.masks.filter(function(t){return"hyperpigmentation"===t.section}).map(function(t){return t.name})},wrinkles:{value:this.getWrinkles(t),masks:this._state.masks.filter(function(t){return"wrinkles"===t.section}).map(function(t){return t.name})},redness:{value:this.getRedness(t),masks:this._state.masks.filter(function(t){return"redness"===t.section}).map(function(t){return t.name})},texture:{value:this.getTexture(t),masks:this._state.masks.filter(function(t){return"texture"===t.section}).map(function(t){return t.name})},skinShine:{value:this.getSkinShine(t),masks:this._state.masks.filter(function(t){return"Skin shine"===t.section}).map(function(t){return t.name})},acne:{value:this.getAcne(t),masks:this._state.masks.filter(function(t){return"acne"===t.section}).map(function(t){return t.name})},smoothness:{value:this.getSmoothness(t),masks:this._state.masks.filter(function(t){return"smoothness"===t.section}).map(function(t){return t.name})},eyebags:{value:this.getEyebags(t),masks:this._state.masks.filter(function(t){return"eyes"===t.section}).map(function(t){return t.name})},darkcircles:{value:this.getDarkcircles(t),masks:this._state.masks.filter(function(t){return"eyes"===t.section}).map(function(t){return t.name})},faceShape:{value:this.getFaceShape()},eyeColor:{value:this.getEyeColor()},skinUndertone:{value:this.getSkinUndertone()}}:null}}]),t}(),f={wrinkles:[{member:"root",type:"array",filter:{member:"description",value:"wrinkles"}}],redness:[{member:"root",type:"array",filter:{member:"description",value:"redness"}}],hyperpigmentation:[{member:"root",type:"array",filter:{member:"description",value:"hyperpigmentation"}}],smoothness:[{member:"root",type:"array",filter:{member:"description",value:"smoothness"}}],eyebags:[{member:"root",type:"array",filter:{member:"description",value:"eyes"}},{member:"sum_measures",type:"array",filter:{member:"description",value:"eyebags"}}],darkcircles:[{member:"root",type:"array",filter:{member:"description",value:"eyes"}},{member:"sum_measures",type:"array",filter:{member:"description",value:"dark circles"}}],texture:[{member:"root",type:"array",filter:{member:"description",value:"texture"}}],skinShine:[{member:"root",type:"array",filter:{member:"description",value:"Skin shine"}}],acne:[{member:"root",type:"array",filter:{member:"description",value:"acne"}}],faceShape:[{member:"root",type:"array",filter:{member:"description",value:"Makeup"}},{member:"sum_measures",type:"array",filter:{member:"description",value:"Face shape"}}],eyeColor:[{member:"root",type:"array",filter:{member:"description",value:"Makeup"}},{member:"sum_measures",type:"array",filter:{member:"description",value:"Eye color"}}],skinUndertone:[{member:"root",type:"array",filter:{member:"description",value:"Makeup"}},{member:"sum_measures",type:"array",filter:{member:"description",value:"Skin undertone"}}],skinFoundation:[{member:"root",type:"array",filter:{member:"description",value:"Makeup"}},{member:"sum_measures",type:"array",filter:{member:"description",value:"Skin foundation RGB"}}],skinFitzpatrick:[{member:"root",type:"array",filter:{member:"description",value:"Makeup"}},{member:"sum_measures",type:"array",filter:{member:"description",value:"Skin Fitzpatrick type"}}]},h={1:217,2:179,3:141,4:100,5:50,6:0};e.default=l},function(t,e,n){t.exports=n(27),n(103),n(50),n(150),n(104),n(151),n(105),n(152),n(153)},function(t,e,n){var r,i,a;!function(o){"use strict";i=[n(27),n(50)],void 0===(a="function"==typeof(r=function(t){"undefined"!=typeof fetch&&"undefined"!=typeof Request&&(t.fetchBlob=function(e,n,r){if(t.hasMetaOption(r))return fetch(new Request(e,r)).then(function(t){return t.blob()}).then(n).catch(function(t){console.log(t),n()});n()})})?r.apply(e,i):r)||(t.exports=a)}()},function(t,e,n){var r,i,a;!function(o){"use strict";i=[n(27),n(104)],void 0===(a="function"==typeof(r=function(t){t.ExifMap.prototype.tags={256:"ImageWidth",257:"ImageHeight",34665:"ExifIFDPointer",34853:"GPSInfoIFDPointer",40965:"InteroperabilityIFDPointer",258:"BitsPerSample",259:"Compression",262:"PhotometricInterpretation",274:"Orientation",277:"SamplesPerPixel",284:"PlanarConfiguration",530:"YCbCrSubSampling",531:"YCbCrPositioning",282:"XResolution",283:"YResolution",296:"ResolutionUnit",273:"StripOffsets",278:"RowsPerStrip",279:"StripByteCounts",513:"JPEGInterchangeFormat",514:"JPEGInterchangeFormatLength",301:"TransferFunction",318:"WhitePoint",319:"PrimaryChromaticities",529:"YCbCrCoefficients",532:"ReferenceBlackWhite",306:"DateTime",270:"ImageDescription",271:"Make",272:"Model",305:"Software",315:"Artist",33432:"Copyright",36864:"ExifVersion",40960:"FlashpixVersion",40961:"ColorSpace",40962:"PixelXDimension",40963:"PixelYDimension",42240:"Gamma",37121:"ComponentsConfiguration",37122:"CompressedBitsPerPixel",37500:"MakerNote",37510:"UserComment",40964:"RelatedSoundFile",36867:"DateTimeOriginal",36868:"DateTimeDigitized",37520:"SubSecTime",37521:"SubSecTimeOriginal",37522:"SubSecTimeDigitized",33434:"ExposureTime",33437:"FNumber",34850:"ExposureProgram",34852:"SpectralSensitivity",34855:"PhotographicSensitivity",34856:"OECF",34864:"SensitivityType",34865:"StandardOutputSensitivity",34866:"RecommendedExposureIndex",34867:"ISOSpeed",34868:"ISOSpeedLatitudeyyy",34869:"ISOSpeedLatitudezzz",37377:"ShutterSpeedValue",37378:"ApertureValue",37379:"BrightnessValue",37380:"ExposureBias",37381:"MaxApertureValue",37382:"SubjectDistance",37383:"MeteringMode",37384:"LightSource",37385:"Flash",37396:"SubjectArea",37386:"FocalLength",41483:"FlashEnergy",41484:"SpatialFrequencyResponse",41486:"FocalPlaneXResolution",41487:"FocalPlaneYResolution",41488:"FocalPlaneResolutionUnit",41492:"SubjectLocation",41493:"ExposureIndex",41495:"SensingMethod",41728:"FileSource",41729:"SceneType",41730:"CFAPattern",41985:"CustomRendered",41986:"ExposureMode",41987:"WhiteBalance",41988:"DigitalZoomRatio",41989:"FocalLengthIn35mmFilm",41990:"SceneCaptureType",41991:"GainControl",41992:"Contrast",41993:"Saturation",41994:"Sharpness",41995:"DeviceSettingDescription",41996:"SubjectDistanceRange",42016:"ImageUniqueID",42032:"CameraOwnerName",42033:"BodySerialNumber",42034:"LensSpecification",42035:"LensMake",42036:"LensModel",42037:"LensSerialNumber",0:"GPSVersionID",1:"GPSLatitudeRef",2:"GPSLatitude",3:"GPSLongitudeRef",4:"GPSLongitude",5:"GPSAltitudeRef",6:"GPSAltitude",7:"GPSTimeStamp",8:"GPSSatellites",9:"GPSStatus",10:"GPSMeasureMode",11:"GPSDOP",12:"GPSSpeedRef",13:"GPSSpeed",14:"GPSTrackRef",15:"GPSTrack",16:"GPSImgDirectionRef",17:"GPSImgDirection",18:"GPSMapDatum",19:"GPSDestLatitudeRef",20:"GPSDestLatitude",21:"GPSDestLongitudeRef",22:"GPSDestLongitude",23:"GPSDestBearingRef",24:"GPSDestBearing",25:"GPSDestDistanceRef",26:"GPSDestDistance",27:"GPSProcessingMethod",28:"GPSAreaInformation",29:"GPSDateStamp",30:"GPSDifferential",31:"GPSHPositioningError"},t.ExifMap.prototype.stringValues={ExposureProgram:{0:"Undefined",1:"Manual",2:"Normal program",3:"Aperture priority",4:"Shutter priority",5:"Creative program",6:"Action program",7:"Portrait mode",8:"Landscape mode"},MeteringMode:{0:"Unknown",1:"Average",2:"CenterWeightedAverage",3:"Spot",4:"MultiSpot",5:"Pattern",6:"Partial",255:"Other"},LightSource:{0:"Unknown",1:"Daylight",2:"Fluorescent",3:"Tungsten (incandescent light)",4:"Flash",9:"Fine weather",10:"Cloudy weather",11:"Shade",12:"Daylight fluorescent (D 5700 - 7100K)",13:"Day white fluorescent (N 4600 - 5400K)",14:"Cool white fluorescent (W 3900 - 4500K)",15:"White fluorescent (WW 3200 - 3700K)",17:"Standard light A",18:"Standard light B",19:"Standard light C",20:"D55",21:"D65",22:"D75",23:"D50",24:"ISO studio tungsten",255:"Other"},Flash:{0:"Flash did not fire",1:"Flash fired",5:"Strobe return light not detected",7:"Strobe return light detected",9:"Flash fired, compulsory flash mode",13:"Flash fired, compulsory flash mode, return light not detected",15:"Flash fired, compulsory flash mode, return light detected",16:"Flash did not fire, compulsory flash mode",24:"Flash did not fire, auto mode",25:"Flash fired, auto mode",29:"Flash fired, auto mode, return light not detected",31:"Flash fired, auto mode, return light detected",32:"No flash function",65:"Flash fired, red-eye reduction mode",69:"Flash fired, red-eye reduction mode, return light not detected",71:"Flash fired, red-eye reduction mode, return light detected",73:"Flash fired, compulsory flash mode, red-eye reduction mode",77:"Flash fired, compulsory flash mode, red-eye reduction mode, return light not detected",79:"Flash fired, compulsory flash mode, red-eye reduction mode, return light detected",89:"Flash fired, auto mode, red-eye reduction mode",93:"Flash fired, auto mode, return light not detected, red-eye reduction mode",95:"Flash fired, auto mode, return light detected, red-eye reduction mode"},SensingMethod:{1:"Undefined",2:"One-chip color area sensor",3:"Two-chip color area sensor",4:"Three-chip color area sensor",5:"Color sequential area sensor",7:"Trilinear sensor",8:"Color sequential linear sensor"},SceneCaptureType:{0:"Standard",1:"Landscape",2:"Portrait",3:"Night scene"},SceneType:{1:"Directly photographed"},CustomRendered:{0:"Normal process",1:"Custom process"},WhiteBalance:{0:"Auto white balance",1:"Manual white balance"},GainControl:{0:"None",1:"Low gain up",2:"High gain up",3:"Low gain down",4:"High gain down"},Contrast:{0:"Normal",1:"Soft",2:"Hard"},Saturation:{0:"Normal",1:"Low saturation",2:"High saturation"},Sharpness:{0:"Normal",1:"Soft",2:"Hard"},SubjectDistanceRange:{0:"Unknown",1:"Macro",2:"Close view",3:"Distant view"},FileSource:{3:"DSC"},ComponentsConfiguration:{0:"",1:"Y",2:"Cb",3:"Cr",4:"R",5:"G",6:"B"},Orientation:{1:"top-left",2:"top-right",3:"bottom-right",4:"bottom-left",5:"left-top",6:"right-top",7:"right-bottom",8:"left-bottom"}},t.ExifMap.prototype.getText=function(t){var e=this.get(t);switch(t){case"LightSource":case"Flash":case"MeteringMode":case"ExposureProgram":case"SensingMethod":case"SceneCaptureType":case"SceneType":case"CustomRendered":case"WhiteBalance":case"GainControl":case"Contrast":case"Saturation":case"Sharpness":case"SubjectDistanceRange":case"FileSource":case"Orientation":return this.stringValues[t][e];case"ExifVersion":case"FlashpixVersion":if(!e)return;return String.fromCharCode(e[0],e[1],e[2],e[3]);case"ComponentsConfiguration":if(!e)return;return this.stringValues[t][e[0]]+this.stringValues[t][e[1]]+this.stringValues[t][e[2]]+this.stringValues[t][e[3]];case"GPSVersionID":if(!e)return;return e[0]+"."+e[1]+"."+e[2]+"."+e[3]}return String(e)},function(t){var e,n=t.tags,r=t.map;for(e in n)n.hasOwnProperty(e)&&(r[n[e]]=e)}(t.ExifMap.prototype),t.ExifMap.prototype.getAll=function(){var t,e,n={};for(t in this)this.hasOwnProperty(t)&&(e=this.tags[t])&&(n[e]=this.getText(e));return n}})?r.apply(e,i):r)||(t.exports=a)}()},function(t,e,n){var r,i,a;!function(o){"use strict";i=[n(27),n(105)],void 0===(a="function"==typeof(r=function(t){t.IptcMap.prototype.tags={3:"ObjectType",4:"ObjectAttribute",5:"ObjectName",7:"EditStatus",8:"EditorialUpdate",10:"Urgency",12:"SubjectRef",15:"Category",20:"SupplCategory",22:"FixtureID",25:"Keywords",26:"ContentLocCode",27:"ContentLocName",30:"ReleaseDate",35:"ReleaseTime",37:"ExpirationDate",38:"ExpirationTime",40:"SpecialInstructions",42:"ActionAdvised",45:"RefService",47:"RefDate",50:"RefNumber",55:"DateCreated",60:"TimeCreated",62:"DigitalCreationDate",63:"DigitalCreationTime",65:"OriginatingProgram",70:"ProgramVersion",75:"ObjectCycle",80:"Byline",85:"BylineTitle",90:"City",92:"Sublocation",95:"State",100:"CountryCode",101:"CountryName",103:"OrigTransRef",105:"Headline",110:"Credit",115:"Source",116:"CopyrightNotice",118:"Contact",120:"Caption",122:"WriterEditor",130:"ImageType",131:"ImageOrientation",135:"LanguageID"},t.IptcMap.prototype.getText=function(t){var e=this.get(t);return String(e)},function(t){var e,n=t.tags,r=t.map||{};for(e in n)n.hasOwnProperty(e)&&(r[n[e]]=e)}(t.IptcMap.prototype),t.IptcMap.prototype.getAll=function(){var t,e,n={};for(t in this)this.hasOwnProperty(t)&&(e=this.tags[t])&&(n[e]=this.getText(e));return n}})?r.apply(e,i):r)||(t.exports=a)}()},function(t,e,n){var r,i,a;!function(o){"use strict";i=[n(27),n(103),n(50)],void 0===(a="function"==typeof(r=function(t){var e=t.hasCanvasOption,n=t.hasMetaOption,r=t.transformCoordinates,i=t.getTransformedOptions;t.hasCanvasOption=function(n){return!!n.orientation||e.call(t,n)},t.hasMetaOption=function(e){return e&&!0===e.orientation||n.call(t,e)},t.transformCoordinates=function(e,n){r.call(t,e,n);var i=e.getContext("2d"),a=e.width,o=e.height,s=e.style.width,u=e.style.height,c=n.orientation;if(c&&!(c>8))switch(c>4&&(e.width=o,e.height=a,e.style.width=u,e.style.height=s),c){case 2:i.translate(a,0),i.scale(-1,1);break;case 3:i.translate(a,o),i.rotate(Math.PI);break;case 4:i.translate(0,o),i.scale(1,-1);break;case 5:i.rotate(.5*Math.PI),i.scale(1,-1);break;case 6:i.rotate(.5*Math.PI),i.translate(0,-o);break;case 7:i.rotate(.5*Math.PI),i.translate(a,-o),i.scale(-1,1);break;case 8:i.rotate(-.5*Math.PI),i.translate(-a,0)}},t.getTransformedOptions=function(e,n,r){var a,o,s=i.call(t,e,n),u=s.orientation;if(!0===u&&r&&r.exif&&(u=r.exif.get("Orientation")),!u||u>8||1===u)return s;for(o in a={},s)s.hasOwnProperty(o)&&(a[o]=s[o]);switch(a.orientation=u,u){case 2:a.left=s.right,a.right=s.left;break;case 3:a.left=s.right,a.top=s.bottom,a.right=s.left,a.bottom=s.top;break;case 4:a.top=s.bottom,a.bottom=s.top;break;case 5:a.left=s.top,a.top=s.left,a.right=s.bottom,a.bottom=s.right;break;case 6:a.left=s.top,a.top=s.right,a.right=s.bottom,a.bottom=s.left;break;case 7:a.left=s.bottom,a.top=s.right,a.right=s.top,a.bottom=s.left;break;case 8:a.left=s.bottom,a.top=s.left,a.right=s.top,a.bottom=s.right}return a.orientation>4&&(a.maxWidth=s.maxHeight,a.maxHeight=s.maxWidth,a.minWidth=s.minHeight,a.minHeight=s.minWidth,a.sourceWidth=s.sourceHeight,a.sourceHeight=s.sourceWidth),a}})?r.apply(e,i):r)||(t.exports=a)}()},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.default=function(t,e,n){var a=arguments.length>3&&void 0!==arguments[3]?arguments[3]:0,o=arguments.length>4&&void 0!==arguments[4]?arguments[4]:"female",s=arguments.length>5&&void 0!==arguments[5]&&arguments[5],u=arguments.length>6&&void 0!==arguments[6]?arguments[6]:"test",c=arguments[7],l=(0,r.getServerUrl)(s,u)+"api/analyzeImage/"+t+"/";l+="?skintone="+a+"&gender="+o,c&&(l+="&components="+c);var f=new FormData;return f.append("image",(0,i.converImageToBitmap)(n)),f.append("partner_id",e),fetch(l,{method:"POST",body:f}).then(i.checkStatus).then(function(t){return t.json()}).catch(function(t){return console.error("Request failed",t),new Error(t)})};var r=n(44),i=n(56);n(107)},function(t,e,n){var r,i,a;i=[],void 0===(a="function"==typeof(r=function(){"use strict";return function(t,e,n){e=e||"",n=n||512;for(var r=atob(t),i=[],a=0;a<r.length;a+=n){for(var o=r.slice(a,a+n),s=new Array(o.length),u=0;u<o.length;u++)s[u]=o.charCodeAt(u);var c=new Uint8Array(s);i.push(c)}var l=new Blob(i,{type:e});return l}})?r.apply(e,i):r)||(t.exports=a)},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var r="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t},i=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}(),a=n(106),o=n(56),s=n(157),u=n(44),c=n(158);function l(t){if(Array.isArray(t)){for(var e=0,n=Array(t.length);e<t.length;e++)n[e]=t[e];return n}return Array.from(t)}var f=function(){function t(e){if(function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,t),!e)return console.error("RevieveAR: Constructor needs an SDK instance"),Object.create(null);this._sdk=e,this._state={orientation:"auto",needsReset:!1,scaleFactor:1},this._state.layers={},this._state.effectHistory=[],this._state.image={},this._state.defaultStrength=u.defaultStrength,this._state.whiteBalanceCorrection=!0,this._state.whiteBalanceValue=null,this.methods={configuration:{setContainer:this.setContainer.bind(this),setDefaultStrength:this.setDefaultStrength.bind(this),getDefaultStrength:this.getDefaultStrength.bind(this),setWhiteBalanceCorrection:this.setWhiteBalanceCorrection.bind(this),setOrientation:this.setOrientation.bind(this),setScaleFactor:this.setScaleFactor.bind(this)},control:{redrawEffects:this.redrawEffects.bind(this),reset:this.reset.bind(this),testImages:this.testImages.bind(this),getResultsDiv:this.getResultsDiv.bind(this)},highlight:{highlightFaceShape:this.highlightFaceShape.bind(this),highlightDarkcircles:this.highlightDarkcircles.bind(this),highlightEyebags:this.highlightEyebags.bind(this),highlightHyperpigmentation:this.highlightHyperpigmentation.bind(this),highlightHyperpigmentationIndividually:this.highlightHyperpigmentationIndividually.bind(this),highlightRedness:this.highlightRedness.bind(this),highlightTexture:this.highlightTexture.bind(this),highlightWrinkles:this.highlightWrinkles.bind(this),highlightWrinklesIndividually:this.highlightWrinklesIndividually.bind(this),highlightSmoothness:this.highlightSmoothness.bind(this),highlightEyeColor:this.highlightEyeColor.bind(this),highlightEyesArea:this.highlightEyesArea.bind(this),highlightCheekArea:this.highlightCheekArea.bind(this),highlightSkinUndertone:this.highlightSkinUndertone.bind(this),highlightSkinFoundation:this.highlightSkinFoundation.bind(this),highlightSkinShine:this.highlightSkinShine.bind(this),highlightAcne:this.highlightAcne.bind(this),highlightAcneIndividually:this.highlightAcneIndividually.bind(this),dehighlightAll:this.dehighlightAll.bind(this)},skincare:{reduceEyebags:this.reduceEyebags.bind(this),reduceCrowsFeet:this.reduceCrowsFeet.bind(this),reduceDarkcircles:this.reduceDarkcircles.bind(this),reduceRedness:this.reduceRedness.bind(this),reduceHyperpigmentation:this.reduceHyperpigmentation.bind(this),reduceWrinkles:this.reduceWrinkles.bind(this),brightenSkin:this.brightenSkin.bind(this)},makup:{applyLipstick:this.applyLipstick.bind(this),applyLipliner:this.applyLipliner.bind(this),applyEyeliner:this.applyEyeliner.bind(this),applyEyeshadow:this.applyEyeshadow.bind(this),applyBlush:this.applyBlush.bind(this),applyFoundation:this.applyFoundation.bind(this)},product:{visualizeProduct:this.visualizeProduct.bind(this),canVisualizeProduct:this.canVisualizeProduct.bind(this),getColorInfoFromProduct:this.getColorInfoFromProduct.bind(this),getDefaultStregthFromProduct:this.getDefaultStregthFromProduct.bind(this)}}}return i(t,[{key:"setContainer",value:function(t){var e=this,n=arguments.length>1&&void 0!==arguments[1]&&arguments[1],i="object"===(void 0===t?"undefined":r(t))?t:document.getElementById(t);i?(this._state.container=i,window&&!n&&(window.onresize=function(){e._state.containerWidth!==i.offsetWidth&&(e._state.containerWidth=i.offsetWidth,e.redrawEffects())})):console.error("You must set a valid container ID")}},{key:"setDefaultStrength",value:function(t){this._state.defaultStrength=t}},{key:"getDefaultStrength",value:function(){return this._state.defaultStrength}},{key:"setScaleFactor",value:function(t){this._state.scaleFactor=t}},{key:"setWhiteBalanceCorrection",value:function(t){this._state.whiteBalanceCorrection=t}},{key:"redrawEffects",value:function(){var t=this;if(this._state.effectHistory&&this._state.effectHistory.length>0){if(this._resultDiv){var e=!0,n=!1,r=void 0;try{for(var i,a=this._resultDiv.children[Symbol.iterator]();!(e=(i=a.next()).done);e=!0){var o=i.value;this._resultDiv.removeChild(o)}}catch(t){n=!0,r=t}finally{try{!e&&a.return&&a.return()}finally{if(n)throw r}}this._resultDiv.parentNode.removeChild(this._resultDiv),this._resultDiv=null}this._state.effectHistory.map(function(e){return t.setEffectByName(e.effectName,e.masks,e.strength,e.fillColorOriginal,e.highlight,e.highlightShape,e.ranges),!0})}else this.reset()}},{key:"setOrientation",value:function(t){this._state.orientation=t}},{key:"reduceEyebags",value:function(t){return this._sdk.analytics.sendEvent("RevieveAR.reduceEyebags",t),this.setEffectByName("reduceEyebags",null,t)}},{key:"reduceCrowsFeet",value:function(t){return this._sdk.analytics.sendEvent("RevieveAR.reduceCrowsFeet",t),this.setEffectByName("reduceCrowsFeet",null,t)}},{key:"reduceDarkcircles",value:function(t){return this._sdk.analytics.sendEvent("RevieveAR.reduceDarkcircles",t),this.setEffectByName("reduceDarkcircles",null,t)}},{key:"reduceRedness",value:function(t,e){return this._sdk.analytics.sendEvent("RevieveAR.reduceRedness",t+"_"+JSON.stringify(e)),this.setEffectByName("reduceRedness",e,t)}},{key:"reduceHyperpigmentation",value:function(t,e){var n=this;return this._sdk.getConfiguration().components&&this._sdk.getConfiguration().components.includes("hyperpigmentation_visualization")?(this._sdk.analytics.sendEvent("RevieveAR.reduceHyperpigmentation",t+"_"+JSON.stringify(e)),this.setEffectByName("reduceHyperpigmentation",e,t)):new Promise(function(t,e){n._state.error=!0;var r="You need hyperpigmentation_visualization component active in CV module to apply this effect";console.error(r),e(new Error(r))})}},{key:"reduceWrinkles",value:function(t,e){return this._sdk.analytics.sendEvent("RevieveAR.reduceWrinkles",t+"_"+JSON.stringify(e)),this.setEffectByName("reduceWrinkles",e,t)}},{key:"brightenSkin",value:function(t,e){return this._sdk.analytics.sendEvent("RevieveAR.brightenSkin",t+"_"+JSON.stringify(e)),this.setEffectByName("brightenSkin",e,t)}},{key:"applyLipstick",value:function(t,e){return this._sdk.analytics.sendEvent("RevieveAR.applyLipstick",t+"_"+e),this.setEffectByName("applyLipstick",null,t,e)}},{key:"applyLipliner",value:function(t,e){return this._sdk.analytics.sendEvent("RevieveAR.applyLipliner",t+"_"+e),this.setEffectByName("applyLipliner",null,t,e)}},{key:"applyEyeliner",value:function(t,e){return this._sdk.analytics.sendEvent("RevieveAR.applyEyeliner",t+"_"+e),this.setEffectByName("applyEyeliner",null,t,e)}},{key:"applyEyeshadow",value:function(t,e){return this._sdk.analytics.sendEvent("RevieveAR.applyEyeshadow",t+"_"+e),this.setEffectByName("applyEyeshadow",null,t,e)}},{key:"applyBlush",value:function(t,e){return this._sdk.analytics.sendEvent("RevieveAR.applyBlush",t+"_"+e),this.setEffectByName("applyBlush",null,t,e)}},{key:"applyFoundation",value:function(t,e){return this._sdk.analytics.sendEvent("RevieveAR.applyFoundation",t+"_"+e),this.setEffectByName("applyFoundation",null,t,e)}},{key:"highlightFinding",value:function(t,e,n){var r=this,i={hyperpigmentation:function(){return r.highlightHyperpigmentation()},wrinkles:function(){return r.highlightWrinkles()},redness:function(){return r.highlightRedness()},texture:function(){return r.highlightTexture()},skinShine:function(){return r.highlightSkinShine()},acne:function(){return r.highlightAcne()},smoothness:function(){return r.highlightSmoothness()},eyebags:function(){return r.highlightEyebags()},darkcircles:function(){return r.highlightDarkcircles()},faceShape:function(){return r.highlightFaceShape()},eyeColor:function(){return r.highlightEyeColor()},skinUndertone:function(){return r.highlightSkinUndertone()}}[t];return i?i(e,n):null}},{key:"highlightDarkcircles",value:function(t,e){return this._sdk.analytics.sendEvent("RevieveAR.highlightDarkcircles",JSON.stringify(t)),this.highlightMasksForSection("darkcircles",t,e)}},{key:"highlightEyebags",value:function(t,e){return this._sdk.analytics.sendEvent("RevieveAR.highlightEyebags",JSON.stringify(t)),this.highlightMasksForSection("eyebags",t,e)}},{key:"highlightHyperpigmentation",value:function(t,e){return this._sdk.analytics.sendEvent("RevieveAR.highlightHyperpigmentation",JSON.stringify(t)),this.highlightMasksForSection("hyperpigmentation",t,e)}},{key:"highlightAcne",value:function(t,e){return this._sdk.analytics.sendEvent("RevieveAR.highlightAcne",JSON.stringify(t)),this.highlightMasksForSection("acne",t,e)}},{key:"highlightRedness",value:function(t,e){return this._sdk.analytics.sendEvent("RevieveAR.highlightRedness",JSON.stringify(t)),this.highlightMasksForSection("redness",t,e)}},{key:"highlightTexture",value:function(t,e){return this._sdk.analytics.sendEvent("RevieveAR.highlightTexture",JSON.stringify(t)),this.highlightMasksForSection("texture",t,e)}},{key:"highlightWrinkles",value:function(t,e){return this._sdk.analytics.sendEvent("RevieveAR.highlightWrinkles",JSON.stringify(t)),this.highlightMasksForSection("wrinkles",t,e)}},{key:"highlightWrinklesIndividually",value:function(t,e){return this._sdk.analytics.sendEvent("RevieveAR.highlightWrinklesIndividually",t),this.setEffectByName("wrinklesIndividually",e,.7,null,!1,!1,t||[{minValue:0,maxValue:.2,color:"rgba(44, 192, 205,0.3)"},{minValue:.2,maxValue:.4,color:"rgba(253, 164, 98, 0.7)"},{minValue:.4,maxValue:1,color:"rgba(205, 44, 66, 1)"}])}},{key:"highlightHyperpigmentationIndividually",value:function(t,e){return this._sdk.analytics.sendEvent("RevieveAR.highlightHyperpigmentationIndividually",t),this.setEffectByName("hyperpigmentationIndividually",e,.7,null,!1,!1,t||[{minValue:0,maxValue:1,color:"rgba(44, 192, 205,0.3)"},{minValue:1,maxValue:2,color:"rgba(253, 164, 98, 0.7)"},{minValue:2,maxValue:9,color:"rgba(205, 44, 66, 1)"}])}},{key:"highlightAcneIndividually",value:function(t,e){return this._sdk.analytics.sendEvent("RevieveAR.highlightAcneIndividually",t),this.setEffectByName("acneIndividually",e,.7,null,!1,!1,t||[{minValue:0,maxValue:80,color:"rgba(0, 0, 0,0)"},{minValue:80,maxValue:300,color:"rgba(44, 192, 205, 0.3)"},{minValue:300,maxValue:1e3,color:"rgba(253, 164, 98, 0.7)"},{minValue:1e3,maxValue:2500,color:"rgba(205, 44, 66, 1)"}])}},{key:"highlightSkinShine",value:function(t){return this._sdk.analytics.sendEvent("RevieveAR.highlightSkinShine",t),this.setEffectByName("highlightSkinShine",null,.7,null,!1,!1,t||[{minValue:0,maxValue:2,color:"rgba(255,255,255, 0.5)"},{minValue:2,maxValue:4,color:"rgba(44, 192, 205, 0.2)"},{minValue:4,maxValue:9,color:"rgb(255, 255, 255)"}])}},{key:"highlightSmoothness",value:function(t,e){return this._sdk.analytics.sendEvent("RevieveAR.highlightSmoothness",JSON.stringify(t)),this.highlightMasksForSection("smoothness",t,e)}},{key:"highlightFaceShape",value:function(t){return this._sdk.analytics.sendEvent("RevieveAR.highlightFaceShape"),this.setEffectByName("faceShape",["Skin"],1,t,!1,!0)}},{key:"highlightEyeColor",value:function(){var t=this;return this._sdk.analytics.sendEvent("RevieveAR.highlightEyeColor"),new Promise(function(e){t.setEffectByName("leftEye",["Skin"],0,null,!1,!0).then(function(n){var r=t._sdk.getConfiguration().eye_color_ui;r||(r=t._sdk.CV.getFindings().eyeColor.value);r&&(r=v[r.toLowerCase()],t.renderHighlightInformation("leftEye",r,"center")),e(n)})})}},{key:"highlightEyesArea",value:function(){return this._sdk.analytics.sendEvent("RevieveAR.highlightEyesShape"),this.setEffectByName("leftEye",["Skin"],0,null,!1,!0)}},{key:"highlightCheekArea",value:function(){return this._sdk.analytics.sendEvent("RevieveAR.highlightCheekArea"),this.setEffectByName("leftCheek",["Skin"],0,null,!1,!0)}},{key:"highlightSkinUndertone",value:function(){var t=this;return this._sdk.analytics.sendEvent("RevieveAR.highlightSkinUndertone"),new Promise(function(e){t.setEffectByName("leftCheek",["Skin"],0,null,!1,!0).then(function(n){var r=t._sdk.CV.getFindings().skinUndertone.value;r&&(r=g[r.toLowerCase()],t.renderHighlightInformation("leftCheek",r)),e(n)})})}},{key:"highlightSkinFoundation",value:function(){var t=this;return this._sdk.analytics.sendEvent("RevieveAR.highlightSkinFoundation"),new Promise(function(e){t.setEffectByName("leftCheek",["Skin"],0,null,!1,!0).then(function(n){var r=t._sdk.getConfiguration().skintone_color_cv;r&&t.renderHighlightInformation("leftCheek",r),e(n)})})}},{key:"renderHighlightInformation",value:function(t,e){var n=h("highlightInfo",this._state.image.width,this._state.image.height);n.style.transform="scale("+this._state.image.ratio+")",this._state.layers.highlightInfo=n,this._resultDiv.appendChild(n);for(var r=this._state.container;r.firstChild;)r.removeChild(r.firstChild);r.appendChild(this._resultDiv);var i=this._sdk.CV.getFaceArea().bounding_box,o=parseInt((i[2]-i[0])/10,10),s=parseInt((i[3]-i[1])/10,10),u=i[0]+o,c=i[1]+4*s;"leftCheek"===t&&(u=i[0]+2*o,c=i[1]+7*s),(0,a.drawCircle)(n,u,c,this._state.image.width<this._state.image.height?.04*this._state.image.width:.03*this._state.image.height,e,"white",!0)}},{key:"dehighlightAll",value:function(){var t=this;return this._state.effectHistory=this._state.effectHistory.filter(function(t){return!t.highlight&&!t.highlightShape&&"hyperpigmentationIndividually"!==t.effectName&&"wrinklesIndividually"!==t.effectName&&"highlightSkinShine"!==t.effectName&&"acneIndividually"!==t.effectName}),new Promise(function(e){var n={in:{},out:{}};if(t._resultDiv||e(n),t._state.layers.wrinklesIndividually){var r=!0,i=!1,a=void 0;try{for(var o,s=t._resultDiv.children[Symbol.iterator]();!(r=(o=s.next()).done);r=!0){var u=o.value;"wrinklesIndividually"===u.id&&t._resultDiv.removeChild(u)}}catch(t){i=!0,a=t}finally{try{!r&&s.return&&s.return()}finally{if(i)throw a}}}if(t._state.layers.hyperpigmentationIndividually){var l=!0,f=!1,h=void 0;try{for(var d,p=t._resultDiv.children[Symbol.iterator]();!(l=(d=p.next()).done);l=!0){var v=d.value;"hyperpigmentationIndividually"===v.id&&t._resultDiv.removeChild(v)}}catch(t){f=!0,h=t}finally{try{!l&&p.return&&p.return()}finally{if(f)throw h}}}if(t._state.layers.acneIndividually){var g=!0,m=!1,y=void 0;try{for(var b,w=t._resultDiv.children[Symbol.iterator]();!(g=(b=w.next()).done);g=!0){var x=b.value;"acneIndividually"===x.id&&t._resultDiv.removeChild(x)}}catch(t){m=!0,y=t}finally{try{!g&&w.return&&w.return()}finally{if(m)throw y}}}if(t._state.layers.highlightSkinShine){var E=!0,_=!1,S=void 0;try{for(var k,P=t._resultDiv.children[Symbol.iterator]();!(E=(k=P.next()).done);E=!0){var R=k.value;"highlightSkinShine"===R.id&&t._resultDiv.removeChild(R)}}catch(t){_=!0,S=t}finally{try{!E&&P.return&&P.return()}finally{if(_)throw S}}}var A=t._state.layers.highlight;if(A){var C=!0,I=!1,F=void 0;try{for(var O,T=t._resultDiv.children[Symbol.iterator]();!(C=(O=T.next()).done);C=!0){var M=O.value;"highlight"!==M.id&&"highlightInfo"!==M.id||t._resultDiv.removeChild(M)}}catch(t){I=!0,F=t}finally{try{!C&&T.return&&T.return()}finally{if(I)throw F}}for(var D=t._state.container;D.firstChild;)D.removeChild(D.firstChild);D.appendChild(t._resultDiv),e((0,c.getAnimationStyle)(A,t._sdk.CV.getFaceArea(),t._state.image.ratio,"highlight",t._state.scaleFactor))}else e(n)})}},{key:"highlightMasksForSection",value:function(t,e,n){var r=this._sdk.CV.getResults();if(!r){this._state.error=!0;console.error("RevieveAR needs an image analyzed by CV module before")}var i=t;if("eyebags"!==t&&"darkcircles"!==t||(i="eyes"),!e||0===e.length){var a=!0,o=!1,s=void 0;try{for(var u,c=r[Symbol.iterator]();!(a=(u=c.next()).done);a=!0){var l=u.value;if(l.description===i){var f=0,h=!0,d=!1,p=void 0;try{for(var v,g=l.measurement_locations[Symbol.iterator]();!(h=(v=g.next()).done);h=!0){var m=v.value;m.value>f&&(f=m.value,(e=[]).push(m.description))}}catch(t){d=!0,p=t}finally{try{!h&&g.return&&g.return()}finally{if(d)throw p}}break}}}catch(t){o=!0,s=t}finally{try{!a&&c.return&&c.return()}finally{if(o)throw s}}}return this.setEffectByName(t,e,.7,n,!0,!0)}},{key:"canVisualizeProduct",value:function(t){return!!t&&(!(!t.custom_data||!t.custom_data.custom_visualization)||!!this.getColorInfoFromProduct(t))}},{key:"visualizeProduct",value:function(t,e){if(this._sdk.analytics.sendEvent("RevieveAR.visualizeProduct",t.id),!this.canVisualizeProduct(t))return null;if(t.custom_data&&t.custom_data.custom_visualization){var n=t.custom_data.custom_visualization;if(0===e){var r=[0].concat(l(n.parameters.slice(1)));return this[n.method](r)}return this[n.method].apply(this,l(n.parameters))}var i=p.find(function(e){return e.category===t.category.toLowerCase().replace(" ","")}),a=this.getColorInfoFromProduct(t);return this[i.method](void 0===e?i.strength:e,a)}},{key:"getColorInfoFromProduct",value:function(t){if(!t.category||!t.filter_match)return null;var e=p.find(function(e){return e.category===t.category.toLowerCase().replace(" ","")});if(!e)return null;var n=t.filter_match.find(function(t){return 0===t.indexOf(e.colorExpression)});return n?"#"+(n=(n=(n=n.replace(e.colorExpression,"")).replace("#","")).replace("0x","")):null}},{key:"getDefaultStregthFromProduct",value:function(t){var e=p.find(function(e){return e.category===t.category.toLowerCase().replace(" ","")});return e?e.strength:null}},{key:"setEffectByName",value:function(t,e){var n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:this._state.defaultStrength,r=arguments[3],i=arguments.length>4&&void 0!==arguments[4]&&arguments[4],a=this,s=arguments.length>5&&void 0!==arguments[5]&&arguments[5],u=arguments[6];return new Promise(function(l,f){if(!a._sdk.CV.getResults()){a._state.error=!0;var h="RevieveAR needs an image analyzed by CV module before";console.error(h),f(new Error(h))}a._state.needsReset&&(a.reset(),a._resultDiv=null,a._state.needsReset=!1),(0,o.getImageDimensions)(a._sdk.CV.getImage()).then(function(h){a._state.image.width=h.width,a._state.image.height=h.height,a._state.finalDimensions=null,a._state.container&&(a._state.finalDimensions=(0,o.calculateAspectRatioFit)(h.width,h.height,a._state.container.offsetWidth,a._state.container.offsetHeight,a._state.orientation),a._state.finalDimensions&&(a._state.image.ratio=a._state.finalDimensions.ratio));var d=r;if(r&&a._state.whiteBalanceCorrection&&a._state.whiteBalanceValue){var p=[];if(r.startsWith("rgb"))p=(r=r.replace("rgb(","")).split(",");else if(r.startsWith("#"))p=(0,o.hexToRgb)(r);else{var v=(0,o.colourNameToHex)(r);v.startsWith("#")&&(p=(0,o.hexToRgb)(v))}p[0]=parseInt(parseFloat(p[0])*a._state.whiteBalanceValue[0]*a._state.whiteBalanceValue[2],10),p[1]=parseInt(parseFloat(p[1])*a._state.whiteBalanceValue[2],10),p[2]=parseInt(parseFloat(p[2])*a._state.whiteBalanceValue[1]*a._state.whiteBalanceValue[2],10),p=(0,o.normalizeRgbColor)(p),r=(0,o.rgbToHex)(p)}a.drawEffect(t,e,n||a._state.defaultStrength,r,i,s,u).then(function(){if(a._state.error=!1,!a._resultDiv){a._resultDiv=document.createElement("div"),a._resultDiv.style.position="relative";var r=document.createElement("img");r.src=a._sdk.CV.getImage(),r.width=a._state.finalDimensions?a._state.finalDimensions.width:a._state.image.width,r.height=a._state.finalDimensions?a._state.finalDimensions.height:a._state.image.height,a._resultDiv.appendChild(r)}for(var o=0;o<a._state.effectHistory.length;o++)if(a._state.effectHistory[o].effectName===t){a._state.effectHistory.splice(o);break}a._state.effectHistory.push({effectName:t,masks:e,strength:n,fillColorOriginal:d,highlight:i,highlightShape:s,ranges:u});var f=a._state.layers[i||s?"highlight":t],h=!0,p=!1,v=void 0;try{for(var g,m=a._resultDiv.children[Symbol.iterator]();!(h=(g=m.next()).done);h=!0){var y=g.value;if(y.id===f.id){a._resultDiv.removeChild(y);break}}}catch(t){p=!0,v=t}finally{try{!h&&m.return&&m.return()}finally{if(p)throw v}}parseFloat(n)>0&&a._resultDiv.appendChild(f);for(var b=a._state.container;b.firstChild;)b.removeChild(b.firstChild);b.appendChild(a._resultDiv);var w=(0,c.convertMaskToArea)(e),x=(0,c.getAnimationStyle)(f,a._sdk.CV.getFaceArea(),a._state.image.ratio,e&&e.length>1?"face":w,a._state.scaleFactor);l(x)}).catch(function(t){a._error=!0,t&&console.error(t),console.error("Error applying effects"),f(t)})})})}},{key:"getPolylineFindingInformation",value:function(t){var e=t.ranges,n=t.finding,r=t.masks;if(!e)return null;var i=this._sdk.CV.getResults();if(!i)return null;var a=i.find(function(t){return t.description===n});if(!a)return null;var s=[],u=a.measurement_locations;return r&&r.length>0&&(u=a.measurement_locations.filter(function(t){return r.includes(t.description)})),u.forEach(function(t){t.visualization_data&&t.visualization_data.forEach(function(t){for(var n=[],r=0;r<t.length;r++)n.push([t.x[r],t.y[r]]);var i={color:(0,o.getRangeColor)(t.mean_intensity,e),params:n,type:"polyline",intensity:t.mean_intensity};s.push(i)})}),{shapes:s}}},{key:"getIndividualFindingInformation",value:function(t){var e=t.ranges,n=t.finding,r=t.masks,i=this._sdk.CV.getResults();if(!i)return null;var a=i.find(function(t){return t.description===n});if(!a)return null;var s=[],u=a.measurement_locations;return r&&r.length>0&&(u=a.measurement_locations.filter(function(t){return r.includes(t.description)})),0===u.length&&(u=a.measurement_locations),u.forEach(function(t){t.visualization_data&&t.visualization_data.forEach(function(t){var n=[t.x[0],t.y[0]],r={color:e?(0,o.getRangeColor)(t.mean_intensity,e):null,params:n,type:"point",intensity:t.mean_intensity};s.push(r)})}),{points:s}}},{key:"getEffectConfiguration",value:function(e,n){var r=arguments.length>2&&void 0!==arguments[2]&&arguments[2],i=arguments.length>3&&void 0!==arguments[3]&&arguments[3],a=arguments[4];if(!e)return console.error("Effect name and masks are mandatory"),null;var o=n,s=e;if(r?s="highlight":i&&(s="highlightShape"),!o&&t.effectBundles[s].masks&&(o=t.effectBundles[s].masks[this._sdk.getApiVersion()]),"wrinklesIndividually"===e)return{wrinkles:this.getPolylineFindingInformation({ranges:a,finding:"wrinkles",masks:o})};if("hyperpigmentationIndividually"===e)return{hyperpigmentatedPoints:this.getIndividualFindingInformation({ranges:a,finding:"hyperpigmentation",masks:o})};if("acneIndividually"===e)return{acnePoints:this.getIndividualFindingInformation({ranges:a,finding:"acne",masks:o})};if("highlightSkinShine"===e)return{skinShine:this.getPolylineFindingInformation({ranges:a,finding:"Skin shine"})};if(o){var u=[],c=!0,l=!1,f=void 0;try{for(var h,d=o[Symbol.iterator]();!(c=(h=d.next()).done);c=!0){var p=h.value,v=!0,g=!1,m=void 0;try{for(var y,b=this._sdk.CV.getMasks()[Symbol.iterator]();!(v=(y=b.next()).done);v=!0){var w=y.value;w.name===p&&u.push(w)}}catch(t){g=!0,m=t}finally{try{!v&&b.return&&b.return()}finally{if(g)throw m}}}}catch(t){l=!0,f=t}finally{try{!c&&d.return&&d.return()}finally{if(l)throw f}}u=this.findBestFitMasksForEffect(e,u);var x={};return t.effectActions[s]&&t.effectActions[s].needsIndividualFindingsInfo&&(x={individualFindingsInfo:this.getIndividualFindingInformation({finding:t.effectActions[s].individualFindingsInfo,masks:o})}),Object.assign({effects:t.effectBundles[s].effects,masks:u},x)}return null}},{key:"drawEffect",value:function(t,e,n,r){var i=arguments.length>4&&void 0!==arguments[4]&&arguments[4],o=this,s=arguments.length>5&&void 0!==arguments[5]&&arguments[5],u=arguments[6];return new Promise(function(c,l){parseFloat(n)<=0&&c();var f=r;i&&(f="rgb(255,255,255)");var p=o.getEffectConfiguration(t,e,i,s,u);p||l();var v=0,g=!0,m=t;if((i||s)&&(m="highlight"),p.wrinkles){var y=o._state.layers[m];y||(y=h(m,o._state.image.width,o._state.image.height),o._state.layers[m]=y);var b=y.getContext("2d");b.clearRect(0,0,o._state.image.width,o._state.image.height);var w=Math.min(o._state.image.width,o._state.image.height),x=parseInt(.005*w,10);p.wrinkles.shapes.forEach(function(t){(0,a.drawLine)(b,t.params,t.color,!1,x)}),y.style.transform="scale("+o._state.image.ratio+")",c()}else if(p.hyperpigmentatedPoints){var E=o._state.layers[m];E||(E=h(m,o._state.image.width,o._state.image.height),o._state.layers[m]=E),E.getContext("2d").clearRect(0,0,o._state.image.width,o._state.image.height);var _=Math.min(o._state.image.width,o._state.image.height),S=parseInt(.005*_,10);p.hyperpigmentatedPoints.points.forEach(function(t){(0,a.drawCircle)(E,t.params[0],t.params[1],S,t.color,null,!1)}),E.style.transform="scale("+o._state.image.ratio+")",c()}else if(p.acnePoints){var k=o._state.layers[m];k||(k=h(m,o._state.image.width,o._state.image.height),o._state.layers[m]=k),k.getContext("2d").clearRect(0,0,o._state.image.width,o._state.image.height);var P=Math.min(o._state.image.width,o._state.image.height),R=parseInt(.01*P,10);p.acnePoints.points.forEach(function(t){(0,a.drawCircle)(k,t.params[0],t.params[1],R,"rgba(0,0,0,0)",t.color,!1,parseInt(.5*R,10))}),k.style.transform="scale("+o._state.image.ratio+")",c()}else if(p.skinShine){var A=o._state.layers[m];A||(A=h(m,o._state.image.width,o._state.image.height),o._state.layers[m]=A);var C=A.getContext("2d");C.clearRect(0,0,o._state.image.width,o._state.image.height),p.skinShine.shapes.forEach(function(t){(0,a.drawPolygon)(C,t.params,null,t.color)}),A.style.transform="scale("+o._state.image.ratio+")",c()}else if(p.masks){var I=function(t){var e=h(m,o._state.image.width,o._state.image.height),s=function(s){v++,(0,a.draw)(e,t,s.needsSkinTexture?o._sdk.CV.getImage():null,s.needsSkintoneColor?o._state.skintoneColor:f,s.useStroke,s.needsIndividualFindingsInfo?p.individualFindingsInfo.points:null).then(function(){(d(s,n,e,o._state.image.ratio,o._state.image.width,o._state.image.height),o._state.layers[m]||(o._state.layers[m]={}),g)?(o._state.layers[m]=e,g=!1):(o._state.layers[m].getContext("2d").drawImage(e,0,0),e.remove());0===--v&&(i&&(0,a.highlightArea)(o._state.layers[m],r),c())}).catch(function(t){console.error(t)})},u=!0,l=!1,y=void 0;try{for(var b,w=p.effects[Symbol.iterator]();!(u=(b=w.next()).done);u=!0){s(b.value)}}catch(t){l=!0,y=t}finally{try{!u&&w.return&&w.return()}finally{if(l)throw y}}},F=!0,O=!1,T=void 0;try{for(var M,D=p.masks[Symbol.iterator]();!(F=(M=D.next()).done);F=!0){I(M.value)}}catch(t){O=!0,T=t}finally{try{!F&&D.return&&D.return()}finally{if(O)throw T}}}})}},{key:"findBestFitMasksForEffect",value:function(t,e){var n=e.filter(function(e){return(0,s.levenshteinDistance)(e.section,t)<=7});return n&&0!==n.length||(n=e),n}},{key:"reset",value:function(){if(this._resultDiv){for(;this._resultDiv.firstChild;)this._resultDiv.removeChild(this._resultDiv.firstChild);this._state.finalDimensions=null;var t=this._state.container;if(t){this._state.finalDimensions=(0,o.calculateAspectRatioFit)(this._state.image.width,this._state.image.height,t.offsetWidth,t.offsetHeight,this._state.orientation);var e=document.createElement("img");e.src=this._sdk.CV.getImage(),e.width=this._state.finalDimensions?this._state.finalDimensions.width:this._state.image.width,e.height=this._state.finalDimensions?this._state.finalDimensions.height:this._state.image.height,this._resultDiv.appendChild(e)}}this._state.layers={},this._state.effectHistory=[]}},{key:"testImages",value:function(){if(!document.getElementById("originalImage")){var t=document.createElement("img");t.id="originalImage",t.src=this._sdk.CV.getImage(),document.body.appendChild(t)}this._resultDiv&&document.body.appendChild(this._resultDiv)}},{key:"_setSkintoneColor",value:function(t){this._state.skintoneColor=t}},{key:"getResultsDiv",value:function(){return this._resultDiv}}]),t}();function h(t,e,n){var r=document.createElement("canvas");return r.setAttribute("id",t),r.setAttribute("width",e),r.setAttribute("height",n),r.style.position="absolute",r.style.top="0px",r.style.left="0px",r.style.transformOrigin="top left",r.getContext("2d").clearRect(0,0,e,n),r}function d(t,e,n,r,i,a){if(t){var o=!1;for(var s in t)if("opacity"===s){var u=parseFloat(e)*parseFloat(t[s]);n.style.opacity=u,o=!0,n.style.opacity=u}else if("filter"===s&&t.blurResolutionDependent){var c=Math.min(i,a),l=void 0;l="highlight"===t.id?t[s].replace("blur("+t.blurResolutionDependent+"px)","blur("+parseInt(.004*c,10)+"px)"):t[s].replace("blur("+t.blurResolutionDependent+"px)","blur("+parseInt(t.blurResolutionDependent*c*(t.blurResolutionDependentFactor||.001),10)+"px)"),n.style[s]=l}else n.style[s]=t[s];r&&(n.style.transform="scale("+r+")"),!o&&e&&(n.style.opacity=parseFloat(e))}}var p=[{category:"blush",method:"applyBlush",colorExpression:"color_hex_",strength:.7},{category:"lipstick",method:"applyLipstick",colorExpression:"color_hex_",strength:.45},{category:"foundation",method:"applyFoundation",colorExpression:"color_hex_",strength:.4},{category:"eyeliner",method:"applyEyeliner",colorExpression:"color_hex_",strength:.5},{category:"lipliner",method:"applyLipliner",colorExpression:"color_hex_",strength:.5},{category:"eyeshadow",method:"applyEyeshadow",colorExpression:"color_hex_",strength:.4}],v={brown:"#573823",blue:"#176F9C",green:"#5CAD82",hazel:"#979C17"},g={cool:"#F0E4E4",neutral:"#EECDBA",warm:"#D6B1A1"};f.makeupMeasures=u.makeupMeasures,f.defaultStrength=u.defaultStrength,f.masks={2:{SKIN:"Skin",FOREHEAD:"forehead",FOREHEAD_WORRY_LINES:"forehead worry lines",BETWEEN_BROWS_FROWN_LINES:"between-brows frown lines",NOSELINE_BUNNY_LINES:"noseline bunny lines",LEFT_SIDE_EYE_CROWS_FEET:"left side eye crow's feet",RIGHT_SIDE_EYE_CROWS_FEET:"right side eye crow's feet",LEFT_SIDE_TEARLINE:"left side tearline",RIGHT_SIDE_TEARLINE:"right side tearline",LEFT_EYEBAG:"left eye",RIGHT_EYEBAG:"right eye",EYEBROWS:"Eyebrows",LEFT_CHEEK:"left cheek",RIGHT_CHEEK:"right cheek",LIPS:"Lips"},3:{skincare:{SKIN:"Skin",FOREHEAD:"forehead",FOREHEAD_WORRY_LINES:"forehead worry lines",BETWEEN_BROWS_FROWN_LINES:"between-brows frown lines",LEFT_SIDE_EYE:"left side around the eye",RIGHT_SIDE_EYE:"right side around the eye",LEFT_SIDE_EYE_CROWS_FEET:"left side eye crow's feet",RIGHT_SIDE_EYE_CROWS_FEET:"right side eye crow's feet",LEFT_EYEBAG:"left eye",RIGHT_EYEBAG:"right eye",LEFT_UNDER_EYE:"left under-the-eye region",RIGHT_UNDER_EYE:"right under-the-eye region",LEFT_SIDE_TEARLINE:"left side tearline",RIGHT_SIDE_TEARLINE:"right side tearline",LEFT_CHEEK:"left cheek",RIGHT_CHEEK:"right cheek",NOSE:"nose",NOSELINE_BUNNY_LINES:"noseline bunny lines",LEFT_SIDE_MOUTH:"left side around mouth",RIGHT_SIDE_MOUTH:"right side around mouth",CHIN:"chin",LEFT_SIDE_NASOLABIAL:"left side nasolabial line",RIGHT_SIDE_NASOLABIAL:"right side nasolabial line",LEFT_SIDE_MARIONETTE:"left side marionette line",RIGHT_SIDE_MARIONETTE:"right side marionette line",VERTICAL_LIP_LINES:"vertical lip lines",RIGHT_LOWER_FACE:"right lower face",LEFT_LOWER_FACE:"left lower face"},makeup:{SKIN:"Skin",EYEBROWS:"Eyebrows",LEFT_CHEEK:"Left cheek",RIGHT_CHEEK:"Right cheek",NOSE:"Nose",LIPS:"Lips",EYELINER:"Eyelines",LIPLINER:"Liplines",EYESHADOW:"Eyeshadow"}}},f.effectActions={reduceRedness:{id:"reduceRedness",filter:"blur(15px) saturate(85%) brightness(110%)",mixBlendMode:"lighten",opacity:.2,needsSkintoneColor:!0,needsSkinTexture:!1},reduceHyperpigmentation:{id:"reduceHyperpigmentation",filter:"blur(5px) saturate(75%) brightness(110%)",mixBlendMode:"lighten",opacity:1,needsSkinTexture:!0,needsSkintoneColor:!1,needsIndividualFindingsInfo:!0,individualFindingsInfo:"hyperpigmentation",blurResolutionDependent:5,blurResolutionDependentFactor:.002},reduceWrinkles:{id:"reduceWrinkles",filter:"blur(7px) saturate(85%) brightness(110%)",opacity:.4,needsSkinTexture:!0},brightenSkin:{id:"brightenSkin",filter:"blur(15px) saturate(85%) brightness(110%)",mixBlendMode:"screen",opacity:.2,needsSkintoneColor:!0,needsSkinTexture:!1},reduceEyebags:{id:"reduceEyebags",filter:"blur(5px) brightness(105%)",opacity:.75,needsSkinTexture:!0},reduceDarkcircles:{id:"reduceDarkcircles",filter:"blur(15px) saturate(85%) brightness(125%)",mixBlendMode:"lighten",opacity:.15,needsSkintoneColor:!0,needsSkinTexture:!1},colorizeHard:{id:"colorizeHard",filter:"blur(3px)",opacity:.9,needsSkinTexture:!1,blurResolutionDependent:3},colorizeMedium:{id:"colorizeMedium",filter:"blur(3px)",opacity:.5,needsSkinTexture:!1,blurResolutionDependent:3},colorizeSoft:{id:"colorizeSoft",filter:"blur(40px)",opacity:.35,needsSkinTexture:!1,blurResolutionDependent:40},foundation:{id:"foundation",filter:"blur(20px) brightness(110%)",opacity:.2,needsSkinTexture:!1,blurResolutionDependent:20},highlight:{id:"highlight",filter:"blur(10px)",opacity:.5,needsSkinTexture:!1,blurResolutionDependent:10},highlightShape:{id:"highlightShape",filter:"blur(5px)",opacity:.5,needsSkinTexture:!1,useStroke:!0}},f.effectBundles={reduceEyebags:{masks:{2:[f.masks[2].LEFT_EYEBAG,f.masks[2].RIGHT_EYEBAG],3:[f.masks[3].skincare.LEFT_EYEBAG,f.masks[3].skincare.RIGHT_EYEBAG]},effects:[f.effectActions.reduceEyebags],description:"Reduce Eyebags",parameters:[{name:"strength",type:"number"}],type:"Skincare"},reduceCrowsFeet:{masks:{2:[f.masks[2].LEFT_SIDE_EYE_CROWS_FEET,f.masks[2].RIGHT_SIDE_EYE_CROWS_FEET],3:[f.masks[3].skincare.LEFT_SIDE_EYE_CROWS_FEET,f.masks[3].skincare.RIGHT_SIDE_EYE_CROWS_FEET]},effects:[f.effectActions.reduceWrinkles],description:"Reduce Crows Feet",parameters:[{name:"strength",type:"number"}],type:"Skincare"},reduceDarkcircles:{masks:{2:[f.masks[2].LEFT_EYEBAG,f.masks[2].RIGHT_EYEBAG],3:[f.masks[3].skincare.LEFT_EYEBAG,f.masks[3].skincare.RIGHT_EYEBAG]},effects:[f.effectActions.reduceDarkcircles],description:"Reduce Darkcircles",parameters:[{name:"strength",type:"number"}],type:"Skincare"},reduceRedness:{reactParameterType:"object",effects:[f.effectActions.reduceRedness],description:"Reduce Redness",parameters:[{name:"strength",type:"number"},{name:"masks",type:"array"}],type:"Skincare"},reduceHyperpigmentation:{reactParameterType:"object",effects:[f.effectActions.reduceHyperpigmentation],description:"Reduce Hyperpigmentation",parameters:[{name:"strength",type:"number"},{name:"masks",type:"array"}],type:"Skincare"},reduceWrinkles:{reactParameterType:"object",effects:[f.effectActions.reduceWrinkles],description:"Reduce Wrinkles",parameters:[{name:"strength",type:"number"},{name:"masks",type:"array"}],type:"Skincare"},brightenSkin:{reactParameterType:"object",effects:[f.effectActions.brightenSkin],description:"Brighten Skin",parameters:[{name:"strength",type:"number"},{name:"masks",type:"array"}],type:"Skincare"},applyLipstick:{reactParameterType:"object",masks:{2:[f.masks[2].LIPS],3:[f.masks[3].makeup.LIPS]},effects:[f.effectActions.colorizeMedium],description:"Apply Lipstick",parameters:[{name:"strength",type:"number"},{name:"color",type:"string"}],type:"Makeup"},applyBlush:{reactParameterType:"object",masks:{2:[f.masks[2].LEFT_CHEEK,f.masks[2].RIGHT_CHEEK],3:[f.masks[3].makeup.LEFT_CHEEK,f.masks[3].makeup.RIGHT_CHEEK]},effects:[f.effectActions.colorizeSoft],description:"Apply Blush",parameters:[{name:"strength",type:"number"},{name:"color",type:"string"}],type:"Makeup"},applyEyeliner:{reactParameterType:"object",masks:{3:[f.masks[3].makeup.EYELINER]},effects:[f.effectActions.colorizeHard],description:"Apply Eyeliner",parameters:[{name:"strength",type:"number"},{name:"color",type:"string"}],type:"Makeup"},applyLipliner:{reactParameterType:"object",masks:{3:[f.masks[3].makeup.LIPLINER]},effects:[f.effectActions.colorizeHard],description:"Apply Lipliner",parameters:[{name:"strength",type:"number"},{name:"color",type:"string"}],type:"Makeup"},applyEyeshadow:{reactParameterType:"object",masks:{3:[f.masks[3].makeup.EYESHADOW]},effects:[f.effectActions.colorizeMedium],description:"Apply Eyeshadow",parameters:[{name:"strength",type:"number"},{name:"color",type:"string"}],type:"Makeup"},applyFoundation:{reactParameterType:"number",masks:{2:[f.masks[2].SKIN],3:[f.masks[3].makeup.SKIN]},effects:[f.effectActions.foundation],description:"Apply Foundation",parameters:[{name:"strength",type:"number"},{name:"color",type:"string"}],type:"Makeup"},highlight:{reactParameterType:"object",effects:[f.effectActions.highlight],description:"Highlight",parameters:[{name:"masks",type:"array"},{name:"color",type:"string"}],type:"Skincare"},wrinklesIndividually:{reactParameterType:"object",description:"Highlight wrinkles individually",parameters:[{name:"masks",type:"array"},{name:"color",type:"string"}],type:"Skincare"},hyperpigmentationIndividually:{reactParameterType:"object",description:"Highlight hyperpygmentation individually",parameters:[{name:"ranges",type:"array"}],type:"Skincare"},highlightSkinShine:{reactParameterType:"object",description:"Highlight skin shine areas",parameters:[{name:"ranges",type:"array"}],type:"Skincare"},acneIndividually:{reactParameterType:"object",description:"Highlight acne individually",parameters:[{name:"ranges",type:"array"}],type:"Skincare"},highlightShape:{reactParameterType:"object",effects:[f.effectActions.highlightShape],description:"Highlight",parameters:[{name:"masks",type:"array"},{name:"color",type:"string"}],type:"Skincare / Makeup"}},e.default=f},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.levenshteinDistance=function(t,e){for(var n=Array(e.length+1).fill(null).map(function(){return Array(t.length+1).fill(null)}),r=0;r<=t.length;r+=1)n[0][r]=r;for(var i=0;i<=e.length;i+=1)n[i][0]=i;for(var a=1;a<=e.length;a+=1)for(var o=1;o<=t.length;o+=1){var s=t[o-1]===e[a-1]?0:1;n[a][o]=Math.min(n[a][o-1]+1,n[a-1][o]+1,n[a-1][o-1]+s)}return n[e.length][t.length]},e.euclideanDistance=function(t,e){for(var n=0,r=0;r<t.length;r++)n+=(t[r]-e[r])*(t[r]-e[r]);return Math.sqrt(n)}},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.getAnimationStyle=function(t,e,n,r,i){if(!t)return null;var a=function(t){var e=t.canvas,n=t.faceArea,r=t.areaName,i=t.ratio,a=t.scaleFactor,o=n.bounding_box[0]+(n.bounding_box[2]-n.bounding_box[0])/2,s=n.bounding_box[1]+(n.bounding_box[3]-n.bounding_box[1])/2,u=e.width/2,c=e.height/2,l=u-o,f=c-s,h=e.width/(n.bounding_box[2]-n.bounding_box[0]),d=e.height/(n.bounding_box[3]-n.bounding_box[1]),p="skin"===r||"face"===r||"faceShape"===r,v=Math.min(h,d),g="forehead"===r?1.4:1.5,m=p?1:a*g,y=Math.max(v*m,1),b=function(t){var e=t.faceArea,n=t.areaName,r=e.bounding_box,i=parseInt((r[2]-r[0])/10,10),a=parseInt((r[3]-r[1])/10,10);switch(n){case"forehead":return{x:0,y:3*a};case"betweenEyes":return{x:0,y:a};case"leftEye":return{x:3*i,y:0};case"rightEye":return{x:-3*i,y:0};case"leftCheek":return{x:3*i,y:-2*a};case"rightCheek":return{x:-3*i,y:-2*a};case"chin":return{x:0,y:-4*a};case"lips":return{x:0,y:-2*a};case"leftLips":return{x:2*i,y:-2*a};case"rightLips":return{x:-2*i,y:-2*a};default:return{x:0,y:0}}}({faceArea:n,areaName:r});return{x:(l+b.x)*i,y:(f+b.y)*i,rotation:n.rotation,scale:y}}({canvas:t,faceArea:e,areaName:r,ratio:n,scaleFactor:i});if(!a)return null;return{in:{transform:"rotate("+-a.rotation+"deg) scale("+a.scale+") translate3d("+a.x+"px, "+a.y+"px, 0px)",transformOrigin:"center center",transition:"all 1s ease-in-out"},out:{transform:"rotate(0deg) scale(1) translate3d(0px, 0px, 0px)",transformOrigin:"center center",transition:"all 1s ease-in-out"}}},e.convertMaskToArea=function(t){if(!t||t.length<=0)return null;var e=t[0];return r[e]};var r={Skin:"skin",forehead:"forehead","forehead worry lines":"forehead","between-brows frown lines":"betweenEyes","noseline bunny lines":"betweenEyes","left side eye crow's feet":"leftEye","right side eye crow's feet":"rightEye","left side tearline":"leftEye","right side tearline":"rightEye","left eye":"leftEye","right eye":"rightEye",Eyebrows:"forehead","left cheek":"leftCheek","right cheek":"rightCheek",Lips:"lips","left side around the eye":"leftEye","right side around the eye":"rightEye","left under-the-eye region":"leftEye","right under-the-eye region":"rightEye",nose:"nose","left side around mouth":"leftCheek","right side around mouth":"rightCheek",chin:"chin","left side nasolabial line":"leftLips","right side nasolabial line":"rightLips","left side marionette line":"leftLips","right side marionette line":"rightLips","vertical lip lines":"lips","right lower face":"rightLips","left lower face":"leftLips"}},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var r,i=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}(),a=n(160),o=(r=a)&&r.__esModule?r:{default:r};var s=function(){function t(e){if(function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,t),!e)return console.error("RevieveCV: Constructor needs an SDK instance"),Object.create(null);this._sdk=e,this._state={}}return i(t,[{key:"getRecommendedProducts",value:function(){var t=this;return new Promise(function(e,n){if(!t._sdk.getUserId()){var r="You must set UserId to get recommended products";console.error(r),n(new Error(r))}t._sdk.analytics.sendEvent("RevievePR.getRecommendedProducts"),(0,o.default)(t._sdk.getPartnerId(),t._sdk.getUserId(),t._sdk.getConfiguration(),t._sdk.isTesting(),t._sdk.getEnvironment()).then(function(r){if(!r){var i="Error retrieving recommended products from server";console.error(i),n(new Error(i))}r.result.products&&(t._state.recommendedProducts=r.result.products),r.result.variations&&(t._state.recommendedProducts=r.result.variations.map(function(t){return{products:t.products,variantName:t.variantName}})),t._state.historyId=r.result.history_id,e(t._state.recommendedProducts)}).catch(function(t){t&&console.error(t),n(t)})})}},{key:"getLastRecommendedProducts",value:function(){return this._state.recommendedProducts}},{key:"getHistoryId",value:function(){return this._state.historyId}}]),t}();e.default=s},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.default=function(t,e,n){var a=arguments.length>3&&void 0!==arguments[3]&&arguments[3],o=arguments.length>4&&void 0!==arguments[4]?arguments[4]:"test",s=(0,r.getServerUrl)(a,o);if(!t)return console.error("ParnterID is mandatory to get recommended products"),null;if(!e)return console.error("userID is mandatory to get recommended products"),null;return n.partner_id=t,n.user_id=e,fetch(s+"api/functions/getRecommendedProducts/",{method:"POST",body:JSON.stringify(n),headers:{"Content-Type":"application/json","X-Parse-Application-Id":"Revieve API"}}).then(i.checkStatus).then(function(t){return t.json()}).catch(function(t){return console.error("Request failed",t),new Error(t)})};var r=n(44),i=n(56);n(107)},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var r,i=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}(),a=n(162),o=(r=a)&&r.__esModule?r:{default:r};var s=n(108).Validator,u=function(){function t(){!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,t),this._trackers=[],this.gaInitialized=!1}return i(t,[{key:"getTrackers",value:function(){return this._trackers}},{key:"addTrackers",value:function(e){var n=this,r=new s;return!(!e||!r.validate(e,t.trackerInfoSchema))&&(e.map(function(t,e){var r=null;switch(t.provider){case"ga":n.gaInitialized?(r="tracker"+e,o.default.create(t.account,r)):(o.default.initialize(t.account),n.gaInitialized=!0)}return n._trackers.push({info:t,name:r}),!0}),!0)}},{key:"setCustomDimensionToGaTracker",value:function(t,e,n){return this._setCustomParameter(t,"dimension",e,n)}},{key:"setCustomMetricToGaTracker",value:function(t,e,n){return this._setCustomParameter(t,"metric",e,n)}},{key:"_setCustomParameter",value:function(t,e,n,r){if(this._trackers&&this._trackers[t]&&"ga"===this._trackers[t].info.provider){var i=this._trackers[t];i.name?o.default.name(i.name).custom(e+n,r):o.default.custom(e+n,r)}}},{key:"sendEvent",value:function(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:null;t&&this._trackers.map(function(n){var r=c[n.info.provider][t];if(!r)return!1;switch(n.info.provider){case"ga":n.name?o.default.name(n.name).event(n.info.prefix+"_"+r.category,r.action,r.label?{eventLabel:r.label+e}:null):o.default.event(n.info.prefix+"_"+r.category,r.action,r.label?{eventLabel:r.label+e}:null)}return!0})}}]),t}(),c={ga:{"RevieveSDK.setGender":{category:"SDK",action:"setConfiguration",label:"gender_"},"RevieveSDK.setCategories":{category:"SDK",action:"setConfiguration",label:"categories"},"RevieveSDK.setAge":{category:"SDK",action:"setConfiguration",label:"age_"},"RevieveSDK.setLat":{category:"SDK",action:"setConfiguration",label:"lat_"},"RevieveSDK.setLon":{category:"SDK",action:"setConfiguration",label:"lon_"},"RevieveSDK.setWrinkles":{category:"SDK",action:"setConfiguration",label:"wrinkles_"},"RevieveSDK.setEyebags":{category:"SDK",action:"setConfiguration",label:"eyebags_"},"RevieveSDK.setDarkSpots":{category:"SDK",action:"setConfiguration",label:"darkspots_"},"RevieveSDK.setSkintone":{category:"SDK",action:"setConfiguration",label:"skintone_"},"RevieveSDK.setCuperose":{category:"SDK",action:"setConfiguration",label:"cuperose_"},"RevieveSDK.setRocasea":{category:"SDK",action:"setConfiguration",label:"rocasea_"},"RevieveSDK.setAcne":{category:"SDK",action:"setConfiguration",label:"acne_"},"RevieveSDK.setEczema":{category:"SDK",action:"setConfiguration",label:"ezcema_"},"RevieveSDK.setHyperpigmentation":{category:"SDK",action:"setConfiguration",label:"hyperpigmentation_"},"RevieveSDK.setOilyness":{category:"SDK",action:"setConfiguration",label:"oilyness_"},"RevieveSDK.setDullTired":{category:"SDK",action:"setConfiguration",label:"dulltired_"},"RevieveSDK.setPsoriasis":{category:"SDK",action:"setConfiguration",label:"psoriasis_"},"RevieveSDK.setOrganic":{category:"SDK",action:"setConfiguration",label:"organic_"},"RevieveSDK.setAntiAge":{category:"SDK",action:"setConfiguration",label:"antiage_"},"RevieveSDK.setFragranceFree":{category:"SDK",action:"setConfiguration",label:"fragranceFree_"},"RevieveSDK.setParabenFree":{category:"SDK",action:"setConfiguration",label:"parabenFree_"},"RevieveSDK.setSunProtection":{category:"SDK",action:"setConfiguration",label:"sunProtection_"},"RevieveSDK.setSkinBrightening":{category:"SDK",action:"setConfiguration",label:"skinBrightening_"},"RevieveSDK.setSkinFirming":{category:"SDK",action:"setConfiguration",label:"skinFirming_"},"RevieveSDK.setCustomAttribute":{category:"SDK",action:"setConfiguration",label:"customAttribute_"},"RevieveSDK.setSkintype":{category:"SDK",action:"setConfiguration",label:"skintype_"},"RevieveAR.reduceEyebags":{category:"AR",action:"reduceEyebags",label:"strength_"},"RevieveAR.reduceCrowsFeet":{category:"AR",action:"reduceCrowsFeet",label:"strength_"},"RevieveAR.reduceDarkcircles":{category:"AR",action:"reduceDarkcircles",label:"strength_masks_"},"RevieveAR.reduceRedness":{category:"AR",action:"reduceRedness",label:"strength_masks_"},"RevieveAR.reduceWrinkles":{category:"AR",action:"reduceWrinkles",label:"strength_masks_"},"RevieveAR.applyLipstick":{category:"AR",action:"applyLipstick",label:"strength_color_"},"RevieveAR.applyLipliner":{category:"AR",action:"applyLipliner",label:"strength_color_"},"RevieveAR.applyEyeliner":{category:"AR",action:"applyEyeliner",label:"strength_color_"},"RevieveAR.applyEyeshadow":{category:"AR",action:"applyEyeshadow",label:"strength_color_"},"RevieveAR.applyBlush":{category:"AR",action:"applyBlush",label:"strength_color_"},"RevieveAR.applyFoundation":{category:"AR",action:"applyFoundation",label:"strength_color_"},"RevieveAR.highlightDarkcircles":{category:"AR",action:"highlightDarkcircles",label:"masks_"},"RevieveAR.highlightEyebags":{category:"AR",action:"highlightEyebags",label:"masks_"},"RevieveAR.highlightHyperpigmentation":{category:"AR",action:"highlightHyperpigmentation",label:"masks_"},"RevieveAR.highlightRedness":{category:"AR",action:"highlightRedness",label:"masks_"},"RevieveAR.highlightTexture":{category:"AR",action:"highlightTexture",label:"masks_"},"RevieveAR.highlightWrinkles":{category:"AR",action:"highlightWrinkles",label:"masks_"},"RevieveAR.highlightSmoothness":{category:"AR",action:"highlightSmoothness",label:"masks_"},"RevieveAR.visualizeProduct":{category:"AR",action:"visualizeProduct",label:"productId_"},"RevieveCV.setImage":{category:"CV",action:"setImage"},"RevieveCV.analyzeImage":{category:"CV",action:"analyzeImage"},"RevieveCV.analyzeImageSuccess":{category:"CV",action:"analyzeImageSuccess"},"RevieveCV.analyzeImageError":{category:"CV",action:"analyzeImageError"},"RevieveCV.analyzeImageWarning":{category:"CV",action:"analyzeImageWarning",label:"_"},"RevievePR.getRecommendedProducts":{category:"PR",action:"getRecommendedProducts"}}};u.providersAvailable=["ga"],u.trackerInfoSchema={id:"/trackerInfoSchema",type:"array",items:{type:"object",properties:{provider:{type:"string",enum:u.providersAvailable},prefix:{type:"string"},account:{type:"string"}},required:["provider","prefix","account"]}},e.default=u},function(t,e,n){var r;
/*!
 * universal-ga v1.2.0
 * https://github.com/daxko/universal-ga 
 *
 * Copyright (c) 2017 Daxko
 * MIT License
 */
/*!
 * universal-ga v1.2.0
 * https://github.com/daxko/universal-ga 
 *
 * Copyright (c) 2017 Daxko
 * MIT License
 */
!function(n){"use strict";function i(t){console.warn("[analytics]",t)}function a(){for(var t=[],e=arguments.length,n=0;n<e;n++)t.push(arguments[n]);for(;void 0===t[t.length-1];)t.pop();this._namespace&&(t[0]=this._namespace+"."+t[0],this._namespace=null),window&&"function"==typeof window.ga&&window.ga.apply(void 0,t)}var o=function(){return this};o.prototype={initialize:function(t,e){var n,r,i,a,o,s,u,c="https://www.google-analytics.com/";"object"==typeof t&&(e=t),(e=e||{}).debug?(c+="analytics_debug.js",delete e.debug):c+="analytics.js",n=window,r=document,i="script",a=c,o="ga",n.GoogleAnalyticsObject=o,n.ga=n.ga||function(){(n.ga.q=n.ga.q||[]).push(arguments)},n.ga.l=1*new Date,s=r.createElement(i),u=r.getElementsByTagName(i)[0],s.async=1,s.src=a,u.parentNode.insertBefore(s,u),t&&(e="{}"===JSON.stringify(e)?void 0:e,this.create(t,e))},create:function(t,e){t?a.call(this,"create",t,"auto",e):i("tracking id is required to initialize.")},name:function(t){var e=new o;return e._namespace=t,e},set:function(t,e){if(t&&t.length)return a.call(this,"set",t,e),this;i("set: `key` is required.")},plugin:function(t,e){if(t&&t.length)return a.call(this,"require",t,e),this;i("plugin: `name` is required.")},pageview:function(t,e){return a.call(this,"send","pageview",t,e),this},screenview:function(t,e){if(t)return(e=e||{}).screenName=t,a.call(this,"send","screenview",e),this;i("screenview: `screenName` is required.")},event:function(t,e,n){if(t&&e)return n&&void 0!==n.eventValue&&"number"!=typeof n.eventValue&&(i("event: expected `options.eventValue` to be a Number."),n.eventValue=void 0),n&&n.nonInteraction&&"boolean"!=typeof n.nonInteraction&&(i("event: expected `options.nonInteraction` to be a boolean."),n.nonInteraction=!1),a.call(this,"send","event",t,e,n),this;i("event: both `category` and `action` are required.")},timing:function(t,e,n,r){return t&&e&&void 0!==n?"number"!=typeof n?i("event: expected `timingValue` to be a Number."):a.call(this,"send","timing",t,e,n,r):i("timing: `timingCategory`, `timingVar`, and `timingValue` are required."),this},exception:function(t,e){return a.call(this,"send","exception",{exDescription:t,exFatal:!!e}),this},custom:function(t,e){if(/(dimension|metric)[0-9]+/i.test(t))return a.call(this,"set",t,e),this;i("custom: key must match dimension[0-9]+ or metric[0-9]+")},initializeEcommerce:function(){this.plugin("ecommerce")},ecAddTransaction:function(t){if(t&&t.id)return a.call(this,"ecommerce:addTransaction",t),this;i("addTransaction: `transaction` is required and needs an `id`.")},ecAddItem:function(t){if(t&&t.id&&t.name)return a.call(this,"ecommerce:addItem",t),this;i("addItem: `productItem` is required and needs an `id` and a `name`.")},ecSend:function(){a.call(this,"ecommerce:send")},ecClear:function(){a.call(this,"ecommerce:clear")}};var s=new o;void 0===(r=function(){return s}.apply(e,[]))||(t.exports=r)}()},function(t,e,n){"use strict";var r=n(72),i=n(170),a=n(45),o=n(73).scan,s=a.ValidatorResult,u=a.SchemaError,c=a.SchemaContext,l=function t(){this.customFormats=Object.create(t.prototype.customFormats),this.schemas={},this.unresolvedRefs=[],this.types=Object.create(h),this.attributes=Object.create(i.validators)};function f(t){var e="string"==typeof t?t:t.$ref;return"string"==typeof e&&e}l.prototype.customFormats={},l.prototype.schemas=null,l.prototype.types=null,l.prototype.attributes=null,l.prototype.unresolvedRefs=null,l.prototype.addSchema=function(t,e){var n=this;if(!t)return null;var r=o(e||"/",t),i=e||t.id;for(var a in r.id)this.schemas[a]=r.id[a];for(var a in r.ref)this.unresolvedRefs.push(a);return this.unresolvedRefs=this.unresolvedRefs.filter(function(t){return void 0===n.schemas[t]}),this.schemas[i]},l.prototype.addSubSchemaArray=function(t,e){if(e instanceof Array)for(var n=0;n<e.length;n++)this.addSubSchema(t,e[n])},l.prototype.addSubSchemaObject=function(t,e){if(e&&"object"==typeof e)for(var n in e)this.addSubSchema(t,e[n])},l.prototype.setSchemas=function(t){this.schemas=t},l.prototype.getSchema=function(t){return this.schemas[t]},l.prototype.validate=function(t,e,n,i){n||(n={});var a=n.propertyName||"instance",s=r.resolve(n.base||"/",e.id||"");if(!i){(i=new c(e,n,a,s,Object.create(this.schemas))).schemas[s]||(i.schemas[s]=e);var l=o(s,e);for(var f in l.id){var h=l.id[f];i.schemas[f]=h}}if(e){var d=this.validateSchema(t,e,n,i);if(!d)throw new Error("Result undefined");return d}throw new u("no schema specified",e)},l.prototype.validateSchema=function(t,e,n,r){var o,l=new s(t,e,n,r);if("boolean"==typeof e)!0===e?e={}:!1===e&&(e={type:[]});else if(!e)throw new Error("schema is undefined");if(e.extends)if(e.extends instanceof Array){var h={schema:e,ctx:r};e.extends.forEach(this.schemaTraverser.bind(this,h)),e=h.schema,h.schema=null,h.ctx=null,h=null}else e=a.deepMerge(e,this.superResolve(e.extends,r));if(o=f(e)){var d=this.resolve(e,o,r),p=new c(d.subschema,n,r.propertyPath,d.switchSchema,r.schemas);return this.validateSchema(t,d.subschema,n,p)}var v=n&&n.skipAttributes||[];for(var g in e)if(!i.ignoreProperties[g]&&v.indexOf(g)<0){var m=null,y=this.attributes[g];if(y)m=y.call(this,t,e,n,r);else if(!1===n.allowUnknownAttributes)throw new u("Unsupported attribute: "+g,e);m&&l.importErrors(m)}if("function"==typeof n.rewrite){var b=n.rewrite.call(this,t,e,n,r);l.instance=b}return l},l.prototype.schemaTraverser=function(t,e){t.schema=a.deepMerge(t.schema,this.superResolve(e,t.ctx))},l.prototype.superResolve=function(t,e){var n;return(n=f(t))?this.resolve(t,n,e).subschema:t},l.prototype.resolve=function(t,e,n){if(e=n.resolve(e),n.schemas[e])return{subschema:n.schemas[e],switchSchema:e};var i=r.parse(e),o=i&&i.hash,s=o&&o.length&&e.substr(0,e.length-o.length);if(!s||!n.schemas[s])throw new u("no such schema <"+e+">",t);var c=a.objectGetPath(n.schemas[s],o.substr(1));if(void 0===c)throw new u("no such schema "+o+" located in <"+s+">",t);return{subschema:c,switchSchema:e}},l.prototype.testType=function(t,e,n,r,i){if("function"==typeof this.types[i])return this.types[i].call(this,t);if(i&&"object"==typeof i){var a=this.validateSchema(t,i,n,r);return void 0===a||!(a&&a.errors.length)}return!0};var h=l.prototype.types={};h.string=function(t){return"string"==typeof t},h.number=function(t){return"number"==typeof t&&isFinite(t)},h.integer=function(t){return"number"==typeof t&&t%1==0},h.boolean=function(t){return"boolean"==typeof t},h.array=function(t){return Array.isArray(t)},h.null=function(t){return null===t},h.date=function(t){return t instanceof Date},h.any=function(t){return!0},h.object=function(t){return t&&"object"==typeof t&&!(t instanceof Array)&&!(t instanceof Date)},t.exports=l},function(t,e,n){(function(t,r){var i;/*! https://mths.be/punycode v1.4.1 by @mathias */!function(a){e&&e.nodeType,t&&t.nodeType;var o="object"==typeof r&&r;o.global!==o&&o.window!==o&&o.self;var s,u=2147483647,c=36,l=1,f=26,h=38,d=700,p=72,v=128,g="-",m=/^xn--/,y=/[^\x20-\x7E]/,b=/[\x2E\u3002\uFF0E\uFF61]/g,w={overflow:"Overflow: input needs wider integers to process","not-basic":"Illegal input >= 0x80 (not a basic code point)","invalid-input":"Invalid input"},x=c-l,E=Math.floor,_=String.fromCharCode;function S(t){throw new RangeError(w[t])}function k(t,e){for(var n=t.length,r=[];n--;)r[n]=e(t[n]);return r}function P(t,e){var n=t.split("@"),r="";return n.length>1&&(r=n[0]+"@",t=n[1]),r+k((t=t.replace(b,".")).split("."),e).join(".")}function R(t){for(var e,n,r=[],i=0,a=t.length;i<a;)(e=t.charCodeAt(i++))>=55296&&e<=56319&&i<a?56320==(64512&(n=t.charCodeAt(i++)))?r.push(((1023&e)<<10)+(1023&n)+65536):(r.push(e),i--):r.push(e);return r}function A(t){return k(t,function(t){var e="";return t>65535&&(e+=_((t-=65536)>>>10&1023|55296),t=56320|1023&t),e+=_(t)}).join("")}function C(t,e){return t+22+75*(t<26)-((0!=e)<<5)}function I(t,e,n){var r=0;for(t=n?E(t/d):t>>1,t+=E(t/e);t>x*f>>1;r+=c)t=E(t/x);return E(r+(x+1)*t/(t+h))}function F(t){var e,n,r,i,a,o,s,h,d,m,y,b=[],w=t.length,x=0,_=v,k=p;for((n=t.lastIndexOf(g))<0&&(n=0),r=0;r<n;++r)t.charCodeAt(r)>=128&&S("not-basic"),b.push(t.charCodeAt(r));for(i=n>0?n+1:0;i<w;){for(a=x,o=1,s=c;i>=w&&S("invalid-input"),((h=(y=t.charCodeAt(i++))-48<10?y-22:y-65<26?y-65:y-97<26?y-97:c)>=c||h>E((u-x)/o))&&S("overflow"),x+=h*o,!(h<(d=s<=k?l:s>=k+f?f:s-k));s+=c)o>E(u/(m=c-d))&&S("overflow"),o*=m;k=I(x-a,e=b.length+1,0==a),E(x/e)>u-_&&S("overflow"),_+=E(x/e),x%=e,b.splice(x++,0,_)}return A(b)}function O(t){var e,n,r,i,a,o,s,h,d,m,y,b,w,x,k,P=[];for(b=(t=R(t)).length,e=v,n=0,a=p,o=0;o<b;++o)(y=t[o])<128&&P.push(_(y));for(r=i=P.length,i&&P.push(g);r<b;){for(s=u,o=0;o<b;++o)(y=t[o])>=e&&y<s&&(s=y);for(s-e>E((u-n)/(w=r+1))&&S("overflow"),n+=(s-e)*w,e=s,o=0;o<b;++o)if((y=t[o])<e&&++n>u&&S("overflow"),y==e){for(h=n,d=c;!(h<(m=d<=a?l:d>=a+f?f:d-a));d+=c)k=h-m,x=c-m,P.push(_(C(m+k%x,0))),h=E(k/x);P.push(_(C(h,0))),a=I(n,w,r==i),n=0,++r}++n,++e}return P.join("")}s={version:"1.4.1",ucs2:{decode:R,encode:A},decode:F,encode:O,toASCII:function(t){return P(t,function(t){return y.test(t)?"xn--"+O(t):t})},toUnicode:function(t){return P(t,function(t){return m.test(t)?F(t.slice(4).toLowerCase()):t})}},void 0===(i=function(){return s}.call(e,n,e,t))||(t.exports=i)}()}).call(this,n(165)(t),n(71))},function(t,e){t.exports=function(t){return t.webpackPolyfill||(t.deprecate=function(){},t.paths=[],t.children||(t.children=[]),Object.defineProperty(t,"loaded",{enumerable:!0,get:function(){return t.l}}),Object.defineProperty(t,"id",{enumerable:!0,get:function(){return t.i}}),t.webpackPolyfill=1),t}},function(t,e,n){"use strict";t.exports={isString:function(t){return"string"==typeof t},isObject:function(t){return"object"==typeof t&&null!==t},isNull:function(t){return null===t},isNullOrUndefined:function(t){return null==t}}},function(t,e,n){"use strict";e.decode=e.parse=n(168),e.encode=e.stringify=n(169)},function(t,e,n){"use strict";function r(t,e){return Object.prototype.hasOwnProperty.call(t,e)}t.exports=function(t,e,n,a){e=e||"&",n=n||"=";var o={};if("string"!=typeof t||0===t.length)return o;var s=/\+/g;t=t.split(e);var u=1e3;a&&"number"==typeof a.maxKeys&&(u=a.maxKeys);var c=t.length;u>0&&c>u&&(c=u);for(var l=0;l<c;++l){var f,h,d,p,v=t[l].replace(s,"%20"),g=v.indexOf(n);g>=0?(f=v.substr(0,g),h=v.substr(g+1)):(f=v,h=""),d=decodeURIComponent(f),p=decodeURIComponent(h),r(o,d)?i(o[d])?o[d].push(p):o[d]=[o[d],p]:o[d]=p}return o};var i=Array.isArray||function(t){return"[object Array]"===Object.prototype.toString.call(t)}},function(t,e,n){"use strict";var r=function(t){switch(typeof t){case"string":return t;case"boolean":return t?"true":"false";case"number":return isFinite(t)?t:"";default:return""}};t.exports=function(t,e,n,s){return e=e||"&",n=n||"=",null===t&&(t=void 0),"object"==typeof t?a(o(t),function(o){var s=encodeURIComponent(r(o))+n;return i(t[o])?a(t[o],function(t){return s+encodeURIComponent(r(t))}).join(e):s+encodeURIComponent(r(t[o]))}).join(e):s?encodeURIComponent(r(s))+n+encodeURIComponent(r(t)):""};var i=Array.isArray||function(t){return"[object Array]"===Object.prototype.toString.call(t)};function a(t,e){if(t.map)return t.map(e);for(var n=[],r=0;r<t.length;r++)n.push(e(t[r],r));return n}var o=Object.keys||function(t){var e=[];for(var n in t)Object.prototype.hasOwnProperty.call(t,n)&&e.push(n);return e}},function(t,e,n){"use strict";var r=n(45),i=r.ValidatorResult,a=r.SchemaError,o={ignoreProperties:{id:!0,default:!0,description:!0,title:!0,exclusiveMinimum:!0,exclusiveMaximum:!0,additionalItems:!0,$schema:!0,$ref:!0,extends:!0}},s=o.validators={};function u(t,e,n,r,i){var a=e.throwError;e.throwError=!1;var o=this.validateSchema(t,i,e,n);return e.throwError=a,!o.valid&&r instanceof Function&&r(o),o.valid}function c(t,e,n,r,i,a){if(this.types.object(t)&&(!e.properties||void 0===e.properties[i]))if(!1===e.additionalProperties)a.addError({name:"additionalProperties",argument:i,message:"additionalProperty "+JSON.stringify(i)+" exists in instance when not allowed"});else{var o=e.additionalProperties||{};"function"==typeof n.preValidateProperty&&n.preValidateProperty(t,i,o,n,r);var s=this.validateSchema(t[i],o,n,r.makeChild(o,i));s.instance!==a.instance[i]&&(a.instance[i]=s.instance),a.importErrors(s)}}s.type=function(t,e,n,r){if(void 0===t)return null;var a=new i(t,e,n,r),o=Array.isArray(e.type)?e.type:[e.type];if(!o.some(this.testType.bind(this,t,e,n,r))){var s=o.map(function(t){return t.id&&"<"+t.id+">"||t+""});a.addError({name:"type",argument:s,message:"is not of a type(s) "+s})}return a},s.anyOf=function(t,e,n,r){if(void 0===t)return null;var o=new i(t,e,n,r),s=new i(t,e,n,r);if(!Array.isArray(e.anyOf))throw new a("anyOf must be an array");if(!e.anyOf.some(u.bind(this,t,n,r,function(t){s.importErrors(t)}))){var c=e.anyOf.map(function(t,e){return t.id&&"<"+t.id+">"||t.title&&JSON.stringify(t.title)||t.$ref&&"<"+t.$ref+">"||"[subschema "+e+"]"});n.nestedErrors&&o.importErrors(s),o.addError({name:"anyOf",argument:c,message:"is not any of "+c.join(",")})}return o},s.allOf=function(t,e,n,r){if(void 0===t)return null;if(!Array.isArray(e.allOf))throw new a("allOf must be an array");var o=new i(t,e,n,r),s=this;return e.allOf.forEach(function(e,i){var a=s.validateSchema(t,e,n,r);if(!a.valid){var u=e.id&&"<"+e.id+">"||e.title&&JSON.stringify(e.title)||e.$ref&&"<"+e.$ref+">"||"[subschema "+i+"]";o.addError({name:"allOf",argument:{id:u,length:a.errors.length,valid:a},message:"does not match allOf schema "+u+" with "+a.errors.length+" error[s]:"}),o.importErrors(a)}}),o},s.oneOf=function(t,e,n,r){if(void 0===t)return null;if(!Array.isArray(e.oneOf))throw new a("oneOf must be an array");var o=new i(t,e,n,r),s=new i(t,e,n,r),c=e.oneOf.filter(u.bind(this,t,n,r,function(t){s.importErrors(t)})).length,l=e.oneOf.map(function(t,e){return t.id&&"<"+t.id+">"||t.title&&JSON.stringify(t.title)||t.$ref&&"<"+t.$ref+">"||"[subschema "+e+"]"});return 1!==c&&(n.nestedErrors&&o.importErrors(s),o.addError({name:"oneOf",argument:l,message:"is not exactly one from "+l.join(",")})),o},s.properties=function(t,e,n,r){if(this.types.object(t)){var a=new i(t,e,n,r),o=e.properties||{};for(var s in o){"function"==typeof n.preValidateProperty&&n.preValidateProperty(t,s,o[s],n,r);var u=Object.hasOwnProperty.call(t,s)?t[s]:void 0,c=this.validateSchema(u,o[s],n,r.makeChild(o[s],s));c.instance!==a.instance[s]&&(a.instance[s]=c.instance),a.importErrors(c)}return a}},s.patternProperties=function(t,e,n,r){if(this.types.object(t)){var a=new i(t,e,n,r),o=e.patternProperties||{};for(var s in t){var u=!0;for(var l in o){if(new RegExp(l).test(s)){u=!1,"function"==typeof n.preValidateProperty&&n.preValidateProperty(t,s,o[l],n,r);var f=this.validateSchema(t[s],o[l],n,r.makeChild(o[l],s));f.instance!==a.instance[s]&&(a.instance[s]=f.instance),a.importErrors(f)}}u&&c.call(this,t,e,n,r,s,a)}return a}},s.additionalProperties=function(t,e,n,r){if(this.types.object(t)){if(e.patternProperties)return null;var a=new i(t,e,n,r);for(var o in t)c.call(this,t,e,n,r,o,a);return a}},s.minProperties=function(t,e,n,r){if(this.types.object(t)){var a=new i(t,e,n,r);return Object.keys(t).length>=e.minProperties||a.addError({name:"minProperties",argument:e.minProperties,message:"does not meet minimum property length of "+e.minProperties}),a}},s.maxProperties=function(t,e,n,r){if(this.types.object(t)){var a=new i(t,e,n,r);return Object.keys(t).length<=e.maxProperties||a.addError({name:"maxProperties",argument:e.maxProperties,message:"does not meet maximum property length of "+e.maxProperties}),a}},s.items=function(t,e,n,r){var a=this;if(this.types.array(t)&&e.items){var o=new i(t,e,n,r);return t.every(function(t,i){var s=Array.isArray(e.items)?e.items[i]||e.additionalItems:e.items;if(void 0===s)return!0;if(!1===s)return o.addError({name:"items",message:"additionalItems not permitted"}),!1;var u=a.validateSchema(t,s,n,r.makeChild(s,i));return u.instance!==o.instance[i]&&(o.instance[i]=u.instance),o.importErrors(u),!0}),o}},s.minimum=function(t,e,n,r){if(this.types.number(t)){var a=new i(t,e,n,r);return(e.exclusiveMinimum&&!0===e.exclusiveMinimum?t>e.minimum:t>=e.minimum)||a.addError({name:"minimum",argument:e.minimum,message:"must have a minimum value of "+e.minimum}),a}},s.maximum=function(t,e,n,r){if(this.types.number(t)){var a=new i(t,e,n,r);return(e.exclusiveMaximum&&!0===e.exclusiveMaximum?t<e.maximum:t<=e.maximum)||a.addError({name:"maximum",argument:e.maximum,message:"must have a maximum value of "+e.maximum}),a}};var l=function(t,e,n,o,s,u){if(this.types.number(t)){var c=e[s];if(0==c)throw new a(s+" cannot be zero");var l=new i(t,e,n,o),f=r.getDecimalPlaces(t),h=r.getDecimalPlaces(c),d=Math.max(f,h),p=Math.pow(10,d);return Math.round(t*p)%Math.round(c*p)!=0&&l.addError({name:s,argument:c,message:u+JSON.stringify(c)}),l}};function f(t,e,n){var i,a=n.length;for(i=e+1;i<a;i++)if(r.deepCompareStrict(t,n[i]))return!1;return!0}s.multipleOf=function(t,e,n,r){return l.call(this,t,e,n,r,"multipleOf","is not a multiple of (divisible by) ")},s.divisibleBy=function(t,e,n,r){return l.call(this,t,e,n,r,"divisibleBy","is not divisible by (multiple of) ")},s.required=function(t,e,n,r){var a=new i(t,e,n,r);return void 0===t&&!0===e.required?a.addError({name:"required",message:"is required"}):this.types.object(t)&&Array.isArray(e.required)&&e.required.forEach(function(e){void 0===t[e]&&a.addError({name:"required",argument:e,message:"requires property "+JSON.stringify(e)})}),a},s.pattern=function(t,e,n,r){if(this.types.string(t)){var a=new i(t,e,n,r);return t.match(e.pattern)||a.addError({name:"pattern",argument:e.pattern,message:"does not match pattern "+JSON.stringify(e.pattern)}),a}},s.format=function(t,e,n,a){if(void 0!==t){var o=new i(t,e,n,a);return o.disableFormat||r.isFormat(t,e.format,this)||o.addError({name:"format",argument:e.format,message:"does not conform to the "+JSON.stringify(e.format)+" format"}),o}},s.minLength=function(t,e,n,r){if(this.types.string(t)){var a=new i(t,e,n,r),o=t.match(/[\uDC00-\uDFFF]/g);return t.length-(o?o.length:0)>=e.minLength||a.addError({name:"minLength",argument:e.minLength,message:"does not meet minimum length of "+e.minLength}),a}},s.maxLength=function(t,e,n,r){if(this.types.string(t)){var a=new i(t,e,n,r),o=t.match(/[\uDC00-\uDFFF]/g);return t.length-(o?o.length:0)<=e.maxLength||a.addError({name:"maxLength",argument:e.maxLength,message:"does not meet maximum length of "+e.maxLength}),a}},s.minItems=function(t,e,n,r){if(this.types.array(t)){var a=new i(t,e,n,r);return t.length>=e.minItems||a.addError({name:"minItems",argument:e.minItems,message:"does not meet minimum length of "+e.minItems}),a}},s.maxItems=function(t,e,n,r){if(this.types.array(t)){var a=new i(t,e,n,r);return t.length<=e.maxItems||a.addError({name:"maxItems",argument:e.maxItems,message:"does not meet maximum length of "+e.maxItems}),a}},s.uniqueItems=function(t,e,n,a){if(this.types.array(t)){var o=new i(t,e,n,a);return t.every(function(t,e,n){for(var i=e+1;i<n.length;i++)if(r.deepCompareStrict(t,n[i]))return!1;return!0})||o.addError({name:"uniqueItems",message:"contains duplicate item"}),o}},s.uniqueItems=function(t,e,n,r){if(this.types.array(t)){var a=new i(t,e,n,r);return t.every(f)||a.addError({name:"uniqueItems",message:"contains duplicate item"}),a}},s.dependencies=function(t,e,n,r){if(this.types.object(t)){var a=new i(t,e,n,r);for(var o in e.dependencies)if(void 0!==t[o]){var s=e.dependencies[o],u=r.makeChild(s,o);if("string"==typeof s&&(s=[s]),Array.isArray(s))s.forEach(function(e){void 0===t[e]&&a.addError({name:"dependencies",argument:u.propertyPath,message:"property "+e+" not found, required by "+u.propertyPath})});else{var c=this.validateSchema(t,s,n,u);a.instance!==c.instance&&(a.instance=c.instance),c&&c.errors.length&&(a.addError({name:"dependencies",argument:u.propertyPath,message:"does not meet dependency required by "+u.propertyPath}),a.importErrors(c))}}return a}},s.enum=function(t,e,n,o){if(void 0===t)return null;if(!Array.isArray(e.enum))throw new a("enum expects an array",e);var s=new i(t,e,n,o);return e.enum.some(r.deepCompareStrict.bind(null,t))||s.addError({name:"enum",argument:e.enum,message:"is not one of enum values: "+e.enum.map(String).join(",")}),s},s.const=function(t,e,n,a){if(void 0===t)return null;var o=new i(t,e,n,a);return r.deepCompareStrict(e.const,t)||o.addError({name:"const",argument:e.const,message:"does not exactly match expected constant: "+e.const}),o},s.not=s.disallow=function(t,e,n,r){var a=this;if(void 0===t)return null;var o=new i(t,e,n,r),s=e.not||e.disallow;return s?(Array.isArray(s)||(s=[s]),s.forEach(function(i){if(a.testType(t,e,n,r,i)){var s=i&&i.id&&"<"+i.id+">"||i;o.addError({name:"not",argument:s,message:"is of prohibited type "+s})}}),o):null},t.exports=o},function(t,e,n){"use strict";(function(t){if(n(172),n(369),n(370),t._babelPolyfill)throw new Error("only one instance of babel-polyfill is allowed");t._babelPolyfill=!0;var e="defineProperty";function r(t,n,r){t[n]||Object[e](t,n,{writable:!0,configurable:!0,value:r})}r(String.prototype,"padLeft","".padStart),r(String.prototype,"padRight","".padEnd),"pop,reverse,shift,keys,values,entries,indexOf,every,some,forEach,map,filter,find,findIndex,includes,join,slice,concat,push,splice,unshift,sort,lastIndexOf,reduce,reduceRight,copyWithin,fill".split(",").forEach(function(t){[][t]&&r(Array,t,Function.call.bind([][t]))})}).call(this,n(71))},function(t,e,n){n(173),n(176),n(177),n(178),n(179),n(180),n(181),n(182),n(183),n(184),n(185),n(186),n(187),n(188),n(189),n(190),n(191),n(192),n(193),n(194),n(195),n(196),n(197),n(198),n(199),n(200),n(201),n(202),n(203),n(204),n(205),n(206),n(207),n(208),n(209),n(210),n(211),n(212),n(213),n(214),n(215),n(216),n(217),n(218),n(219),n(220),n(221),n(222),n(223),n(224),n(225),n(226),n(227),n(228),n(229),n(230),n(231),n(232),n(233),n(234),n(235),n(236),n(237),n(238),n(239),n(240),n(241),n(242),n(243),n(244),n(245),n(246),n(247),n(248),n(249),n(250),n(251),n(253),n(254),n(256),n(257),n(258),n(259),n(260),n(261),n(262),n(264),n(265),n(266),n(267),n(268),n(269),n(270),n(271),n(272),n(273),n(274),n(275),n(276),n(94),n(277),n(128),n(278),n(129),n(279),n(280),n(281),n(282),n(283),n(132),n(134),n(135),n(284),n(285),n(286),n(287),n(288),n(289),n(290),n(291),n(292),n(293),n(294),n(295),n(296),n(297),n(298),n(299),n(300),n(301),n(302),n(303),n(304),n(305),n(306),n(307),n(308),n(309),n(310),n(311),n(312),n(313),n(314),n(315),n(316),n(317),n(318),n(319),n(320),n(321),n(322),n(323),n(324),n(325),n(326),n(327),n(328),n(329),n(330),n(331),n(332),n(333),n(334),n(335),n(336),n(337),n(338),n(339),n(340),n(341),n(342),n(343),n(344),n(345),n(346),n(347),n(348),n(349),n(350),n(351),n(352),n(353),n(354),n(355),n(356),n(357),n(358),n(359),n(360),n(361),n(362),n(363),n(364),n(365),n(366),n(367),n(368),t.exports=n(18)},function(t,e,n){"use strict";var r=n(2),i=n(14),a=n(7),o=n(0),s=n(12),u=n(31).KEY,c=n(3),l=n(51),f=n(46),h=n(34),d=n(5),p=n(110),v=n(75),g=n(175),m=n(59),y=n(1),b=n(4),w=n(9),x=n(15),E=n(23),_=n(33),S=n(37),k=n(113),P=n(16),R=n(58),A=n(8),C=n(35),I=P.f,F=A.f,O=k.f,T=r.Symbol,M=r.JSON,D=M&&M.stringify,j=d("_hidden"),L=d("toPrimitive"),B={}.propertyIsEnumerable,N=l("symbol-registry"),V=l("symbols"),U=l("op-symbols"),z=Object.prototype,W="function"==typeof T&&!!R.f,H=r.QObject,G=!H||!H.prototype||!H.prototype.findChild,q=a&&c(function(){return 7!=S(F({},"a",{get:function(){return F(this,"a",{value:7}).a}})).a})?function(t,e,n){var r=I(z,e);r&&delete z[e],F(t,e,n),r&&t!==z&&F(z,e,r)}:F,K=function(t){var e=V[t]=S(T.prototype);return e._k=t,e},Y=W&&"symbol"==typeof T.iterator?function(t){return"symbol"==typeof t}:function(t){return t instanceof T},J=function(t,e,n){return t===z&&J(U,e,n),y(t),e=E(e,!0),y(n),i(V,e)?(n.enumerable?(i(t,j)&&t[j][e]&&(t[j][e]=!1),n=S(n,{enumerable:_(0,!1)})):(i(t,j)||F(t,j,_(1,{})),t[j][e]=!0),q(t,e,n)):F(t,e,n)},$=function(t,e){y(t);for(var n,r=g(e=x(e)),i=0,a=r.length;a>i;)J(t,n=r[i++],e[n]);return t},X=function(t){var e=B.call(this,t=E(t,!0));return!(this===z&&i(V,t)&&!i(U,t))&&(!(e||!i(this,t)||!i(V,t)||i(this,j)&&this[j][t])||e)},Z=function(t,e){if(t=x(t),e=E(e,!0),t!==z||!i(V,e)||i(U,e)){var n=I(t,e);return!n||!i(V,e)||i(t,j)&&t[j][e]||(n.enumerable=!0),n}},Q=function(t){for(var e,n=O(x(t)),r=[],a=0;n.length>a;)i(V,e=n[a++])||e==j||e==u||r.push(e);return r},tt=function(t){for(var e,n=t===z,r=O(n?U:x(t)),a=[],o=0;r.length>o;)!i(V,e=r[o++])||n&&!i(z,e)||a.push(V[e]);return a};W||(s((T=function(){if(this instanceof T)throw TypeError("Symbol is not a constructor!");var t=h(arguments.length>0?arguments[0]:void 0),e=function(n){this===z&&e.call(U,n),i(this,j)&&i(this[j],t)&&(this[j][t]=!1),q(this,t,_(1,n))};return a&&G&&q(z,t,{configurable:!0,set:e}),K(t)}).prototype,"toString",function(){return this._k}),P.f=Z,A.f=J,n(38).f=k.f=Q,n(53).f=X,R.f=tt,a&&!n(30)&&s(z,"propertyIsEnumerable",X,!0),p.f=function(t){return K(d(t))}),o(o.G+o.W+o.F*!W,{Symbol:T});for(var et="hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables".split(","),nt=0;et.length>nt;)d(et[nt++]);for(var rt=C(d.store),it=0;rt.length>it;)v(rt[it++]);o(o.S+o.F*!W,"Symbol",{for:function(t){return i(N,t+="")?N[t]:N[t]=T(t)},keyFor:function(t){if(!Y(t))throw TypeError(t+" is not a symbol!");for(var e in N)if(N[e]===t)return e},useSetter:function(){G=!0},useSimple:function(){G=!1}}),o(o.S+o.F*!W,"Object",{create:function(t,e){return void 0===e?S(t):$(S(t),e)},defineProperty:J,defineProperties:$,getOwnPropertyDescriptor:Z,getOwnPropertyNames:Q,getOwnPropertySymbols:tt});var at=c(function(){R.f(1)});o(o.S+o.F*at,"Object",{getOwnPropertySymbols:function(t){return R.f(w(t))}}),M&&o(o.S+o.F*(!W||c(function(){var t=T();return"[null]"!=D([t])||"{}"!=D({a:t})||"{}"!=D(Object(t))})),"JSON",{stringify:function(t){for(var e,n,r=[t],i=1;arguments.length>i;)r.push(arguments[i++]);if(n=e=r[1],(b(e)||void 0!==t)&&!Y(t))return m(e)||(e=function(t,e){if("function"==typeof n&&(e=n.call(this,t,e)),!Y(e))return e}),r[1]=e,D.apply(M,r)}}),T.prototype[L]||n(11)(T.prototype,L,T.prototype.valueOf),f(T,"Symbol"),f(Math,"Math",!0),f(r.JSON,"JSON",!0)},function(t,e,n){t.exports=n(51)("native-function-to-string",Function.toString)},function(t,e,n){var r=n(35),i=n(58),a=n(53);t.exports=function(t){var e=r(t),n=i.f;if(n)for(var o,s=n(t),u=a.f,c=0;s.length>c;)u.call(t,o=s[c++])&&e.push(o);return e}},function(t,e,n){var r=n(0);r(r.S,"Object",{create:n(37)})},function(t,e,n){var r=n(0);r(r.S+r.F*!n(7),"Object",{defineProperty:n(8).f})},function(t,e,n){var r=n(0);r(r.S+r.F*!n(7),"Object",{defineProperties:n(112)})},function(t,e,n){var r=n(15),i=n(16).f;n(25)("getOwnPropertyDescriptor",function(){return function(t,e){return i(r(t),e)}})},function(t,e,n){var r=n(9),i=n(17);n(25)("getPrototypeOf",function(){return function(t){return i(r(t))}})},function(t,e,n){var r=n(9),i=n(35);n(25)("keys",function(){return function(t){return i(r(t))}})},function(t,e,n){n(25)("getOwnPropertyNames",function(){return n(113).f})},function(t,e,n){var r=n(4),i=n(31).onFreeze;n(25)("freeze",function(t){return function(e){return t&&r(e)?t(i(e)):e}})},function(t,e,n){var r=n(4),i=n(31).onFreeze;n(25)("seal",function(t){return function(e){return t&&r(e)?t(i(e)):e}})},function(t,e,n){var r=n(4),i=n(31).onFreeze;n(25)("preventExtensions",function(t){return function(e){return t&&r(e)?t(i(e)):e}})},function(t,e,n){var r=n(4);n(25)("isFrozen",function(t){return function(e){return!r(e)||!!t&&t(e)}})},function(t,e,n){var r=n(4);n(25)("isSealed",function(t){return function(e){return!r(e)||!!t&&t(e)}})},function(t,e,n){var r=n(4);n(25)("isExtensible",function(t){return function(e){return!!r(e)&&(!t||t(e))}})},function(t,e,n){var r=n(0);r(r.S+r.F,"Object",{assign:n(114)})},function(t,e,n){var r=n(0);r(r.S,"Object",{is:n(115)})},function(t,e,n){var r=n(0);r(r.S,"Object",{setPrototypeOf:n(79).set})},function(t,e,n){"use strict";var r=n(47),i={};i[n(5)("toStringTag")]="z",i+""!="[object z]"&&n(12)(Object.prototype,"toString",function(){return"[object "+r(this)+"]"},!0)},function(t,e,n){var r=n(0);r(r.P,"Function",{bind:n(116)})},function(t,e,n){var r=n(8).f,i=Function.prototype,a=/^\s*function ([^ (]*)/;"name"in i||n(7)&&r(i,"name",{configurable:!0,get:function(){try{return(""+this).match(a)[1]}catch(t){return""}}})},function(t,e,n){"use strict";var r=n(4),i=n(17),a=n(5)("hasInstance"),o=Function.prototype;a in o||n(8).f(o,a,{value:function(t){if("function"!=typeof this||!r(t))return!1;if(!r(this.prototype))return t instanceof this;for(;t=i(t);)if(this.prototype===t)return!0;return!1}})},function(t,e,n){var r=n(0),i=n(118);r(r.G+r.F*(parseInt!=i),{parseInt:i})},function(t,e,n){var r=n(0),i=n(119);r(r.G+r.F*(parseFloat!=i),{parseFloat:i})},function(t,e,n){"use strict";var r=n(2),i=n(14),a=n(20),o=n(81),s=n(23),u=n(3),c=n(38).f,l=n(16).f,f=n(8).f,h=n(48).trim,d=r.Number,p=d,v=d.prototype,g="Number"==a(n(37)(v)),m="trim"in String.prototype,y=function(t){var e=s(t,!1);if("string"==typeof e&&e.length>2){var n,r,i,a=(e=m?e.trim():h(e,3)).charCodeAt(0);if(43===a||45===a){if(88===(n=e.charCodeAt(2))||120===n)return NaN}else if(48===a){switch(e.charCodeAt(1)){case 66:case 98:r=2,i=49;break;case 79:case 111:r=8,i=55;break;default:return+e}for(var o,u=e.slice(2),c=0,l=u.length;c<l;c++)if((o=u.charCodeAt(c))<48||o>i)return NaN;return parseInt(u,r)}}return+e};if(!d(" 0o1")||!d("0b1")||d("+0x1")){d=function(t){var e=arguments.length<1?0:t,n=this;return n instanceof d&&(g?u(function(){v.valueOf.call(n)}):"Number"!=a(n))?o(new p(y(e)),n,d):y(e)};for(var b,w=n(7)?c(p):"MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger".split(","),x=0;w.length>x;x++)i(p,b=w[x])&&!i(d,b)&&f(d,b,l(p,b));d.prototype=v,v.constructor=d,n(12)(r,"Number",d)}},function(t,e,n){"use strict";var r=n(0),i=n(21),a=n(120),o=n(82),s=1..toFixed,u=Math.floor,c=[0,0,0,0,0,0],l="Number.toFixed: incorrect invocation!",f=function(t,e){for(var n=-1,r=e;++n<6;)r+=t*c[n],c[n]=r%1e7,r=u(r/1e7)},h=function(t){for(var e=6,n=0;--e>=0;)n+=c[e],c[e]=u(n/t),n=n%t*1e7},d=function(){for(var t=6,e="";--t>=0;)if(""!==e||0===t||0!==c[t]){var n=String(c[t]);e=""===e?n:e+o.call("0",7-n.length)+n}return e},p=function(t,e,n){return 0===e?n:e%2==1?p(t,e-1,n*t):p(t*t,e/2,n)};r(r.P+r.F*(!!s&&("0.000"!==8e-5.toFixed(3)||"1"!==.9.toFixed(0)||"1.25"!==1.255.toFixed(2)||"1000000000000000128"!==(0xde0b6b3a7640080).toFixed(0))||!n(3)(function(){s.call({})})),"Number",{toFixed:function(t){var e,n,r,s,u=a(this,l),c=i(t),v="",g="0";if(c<0||c>20)throw RangeError(l);if(u!=u)return"NaN";if(u<=-1e21||u>=1e21)return String(u);if(u<0&&(v="-",u=-u),u>1e-21)if(n=(e=function(t){for(var e=0,n=t;n>=4096;)e+=12,n/=4096;for(;n>=2;)e+=1,n/=2;return e}(u*p(2,69,1))-69)<0?u*p(2,-e,1):u/p(2,e,1),n*=4503599627370496,(e=52-e)>0){for(f(0,n),r=c;r>=7;)f(1e7,0),r-=7;for(f(p(10,r,1),0),r=e-1;r>=23;)h(1<<23),r-=23;h(1<<r),f(1,1),h(2),g=d()}else f(0,n),f(1<<-e,0),g=d()+o.call("0",c);return g=c>0?v+((s=g.length)<=c?"0."+o.call("0",c-s)+g:g.slice(0,s-c)+"."+g.slice(s-c)):v+g}})},function(t,e,n){"use strict";var r=n(0),i=n(3),a=n(120),o=1..toPrecision;r(r.P+r.F*(i(function(){return"1"!==o.call(1,void 0)})||!i(function(){o.call({})})),"Number",{toPrecision:function(t){var e=a(this,"Number#toPrecision: incorrect invocation!");return void 0===t?o.call(e):o.call(e,t)}})},function(t,e,n){var r=n(0);r(r.S,"Number",{EPSILON:Math.pow(2,-52)})},function(t,e,n){var r=n(0),i=n(2).isFinite;r(r.S,"Number",{isFinite:function(t){return"number"==typeof t&&i(t)}})},function(t,e,n){var r=n(0);r(r.S,"Number",{isInteger:n(121)})},function(t,e,n){var r=n(0);r(r.S,"Number",{isNaN:function(t){return t!=t}})},function(t,e,n){var r=n(0),i=n(121),a=Math.abs;r(r.S,"Number",{isSafeInteger:function(t){return i(t)&&a(t)<=9007199254740991}})},function(t,e,n){var r=n(0);r(r.S,"Number",{MAX_SAFE_INTEGER:9007199254740991})},function(t,e,n){var r=n(0);r(r.S,"Number",{MIN_SAFE_INTEGER:-9007199254740991})},function(t,e,n){var r=n(0),i=n(119);r(r.S+r.F*(Number.parseFloat!=i),"Number",{parseFloat:i})},function(t,e,n){var r=n(0),i=n(118);r(r.S+r.F*(Number.parseInt!=i),"Number",{parseInt:i})},function(t,e,n){var r=n(0),i=n(122),a=Math.sqrt,o=Math.acosh;r(r.S+r.F*!(o&&710==Math.floor(o(Number.MAX_VALUE))&&o(1/0)==1/0),"Math",{acosh:function(t){return(t=+t)<1?NaN:t>94906265.62425156?Math.log(t)+Math.LN2:i(t-1+a(t-1)*a(t+1))}})},function(t,e,n){var r=n(0),i=Math.asinh;r(r.S+r.F*!(i&&1/i(0)>0),"Math",{asinh:function t(e){return isFinite(e=+e)&&0!=e?e<0?-t(-e):Math.log(e+Math.sqrt(e*e+1)):e}})},function(t,e,n){var r=n(0),i=Math.atanh;r(r.S+r.F*!(i&&1/i(-0)<0),"Math",{atanh:function(t){return 0==(t=+t)?t:Math.log((1+t)/(1-t))/2}})},function(t,e,n){var r=n(0),i=n(83);r(r.S,"Math",{cbrt:function(t){return i(t=+t)*Math.pow(Math.abs(t),1/3)}})},function(t,e,n){var r=n(0);r(r.S,"Math",{clz32:function(t){return(t>>>=0)?31-Math.floor(Math.log(t+.5)*Math.LOG2E):32}})},function(t,e,n){var r=n(0),i=Math.exp;r(r.S,"Math",{cosh:function(t){return(i(t=+t)+i(-t))/2}})},function(t,e,n){var r=n(0),i=n(84);r(r.S+r.F*(i!=Math.expm1),"Math",{expm1:i})},function(t,e,n){var r=n(0);r(r.S,"Math",{fround:n(123)})},function(t,e,n){var r=n(0),i=Math.abs;r(r.S,"Math",{hypot:function(t,e){for(var n,r,a=0,o=0,s=arguments.length,u=0;o<s;)u<(n=i(arguments[o++]))?(a=a*(r=u/n)*r+1,u=n):a+=n>0?(r=n/u)*r:n;return u===1/0?1/0:u*Math.sqrt(a)}})},function(t,e,n){var r=n(0),i=Math.imul;r(r.S+r.F*n(3)(function(){return-5!=i(4294967295,5)||2!=i.length}),"Math",{imul:function(t,e){var n=+t,r=+e,i=65535&n,a=65535&r;return 0|i*a+((65535&n>>>16)*a+i*(65535&r>>>16)<<16>>>0)}})},function(t,e,n){var r=n(0);r(r.S,"Math",{log10:function(t){return Math.log(t)*Math.LOG10E}})},function(t,e,n){var r=n(0);r(r.S,"Math",{log1p:n(122)})},function(t,e,n){var r=n(0);r(r.S,"Math",{log2:function(t){return Math.log(t)/Math.LN2}})},function(t,e,n){var r=n(0);r(r.S,"Math",{sign:n(83)})},function(t,e,n){var r=n(0),i=n(84),a=Math.exp;r(r.S+r.F*n(3)(function(){return-2e-17!=!Math.sinh(-2e-17)}),"Math",{sinh:function(t){return Math.abs(t=+t)<1?(i(t)-i(-t))/2:(a(t-1)-a(-t-1))*(Math.E/2)}})},function(t,e,n){var r=n(0),i=n(84),a=Math.exp;r(r.S,"Math",{tanh:function(t){var e=i(t=+t),n=i(-t);return e==1/0?1:n==1/0?-1:(e-n)/(a(t)+a(-t))}})},function(t,e,n){var r=n(0);r(r.S,"Math",{trunc:function(t){return(t>0?Math.floor:Math.ceil)(t)}})},function(t,e,n){var r=n(0),i=n(36),a=String.fromCharCode,o=String.fromCodePoint;r(r.S+r.F*(!!o&&1!=o.length),"String",{fromCodePoint:function(t){for(var e,n=[],r=arguments.length,o=0;r>o;){if(e=+arguments[o++],i(e,1114111)!==e)throw RangeError(e+" is not a valid code point");n.push(e<65536?a(e):a(55296+((e-=65536)>>10),e%1024+56320))}return n.join("")}})},function(t,e,n){var r=n(0),i=n(15),a=n(6);r(r.S,"String",{raw:function(t){for(var e=i(t.raw),n=a(e.length),r=arguments.length,o=[],s=0;n>s;)o.push(String(e[s++])),s<r&&o.push(String(arguments[s]));return o.join("")}})},function(t,e,n){"use strict";n(48)("trim",function(t){return function(){return t(this,3)}})},function(t,e,n){"use strict";var r=n(60)(!0);n(85)(String,"String",function(t){this._t=String(t),this._i=0},function(){var t,e=this._t,n=this._i;return n>=e.length?{value:void 0,done:!0}:(t=r(e,n),this._i+=t.length,{value:t,done:!1})})},function(t,e,n){"use strict";var r=n(0),i=n(60)(!1);r(r.P,"String",{codePointAt:function(t){return i(this,t)}})},function(t,e,n){"use strict";var r=n(0),i=n(6),a=n(87),o="".endsWith;r(r.P+r.F*n(88)("endsWith"),"String",{endsWith:function(t){var e=a(this,t,"endsWith"),n=arguments.length>1?arguments[1]:void 0,r=i(e.length),s=void 0===n?r:Math.min(i(n),r),u=String(t);return o?o.call(e,u,s):e.slice(s-u.length,s)===u}})},function(t,e,n){"use strict";var r=n(0),i=n(87);r(r.P+r.F*n(88)("includes"),"String",{includes:function(t){return!!~i(this,t,"includes").indexOf(t,arguments.length>1?arguments[1]:void 0)}})},function(t,e,n){var r=n(0);r(r.P,"String",{repeat:n(82)})},function(t,e,n){"use strict";var r=n(0),i=n(6),a=n(87),o="".startsWith;r(r.P+r.F*n(88)("startsWith"),"String",{startsWith:function(t){var e=a(this,t,"startsWith"),n=i(Math.min(arguments.length>1?arguments[1]:void 0,e.length)),r=String(t);return o?o.call(e,r,n):e.slice(n,n+r.length)===r}})},function(t,e,n){"use strict";n(13)("anchor",function(t){return function(e){return t(this,"a","name",e)}})},function(t,e,n){"use strict";n(13)("big",function(t){return function(){return t(this,"big","","")}})},function(t,e,n){"use strict";n(13)("blink",function(t){return function(){return t(this,"blink","","")}})},function(t,e,n){"use strict";n(13)("bold",function(t){return function(){return t(this,"b","","")}})},function(t,e,n){"use strict";n(13)("fixed",function(t){return function(){return t(this,"tt","","")}})},function(t,e,n){"use strict";n(13)("fontcolor",function(t){return function(e){return t(this,"font","color",e)}})},function(t,e,n){"use strict";n(13)("fontsize",function(t){return function(e){return t(this,"font","size",e)}})},function(t,e,n){"use strict";n(13)("italics",function(t){return function(){return t(this,"i","","")}})},function(t,e,n){"use strict";n(13)("link",function(t){return function(e){return t(this,"a","href",e)}})},function(t,e,n){"use strict";n(13)("small",function(t){return function(){return t(this,"small","","")}})},function(t,e,n){"use strict";n(13)("strike",function(t){return function(){return t(this,"strike","","")}})},function(t,e,n){"use strict";n(13)("sub",function(t){return function(){return t(this,"sub","","")}})},function(t,e,n){"use strict";n(13)("sup",function(t){return function(){return t(this,"sup","","")}})},function(t,e,n){var r=n(0);r(r.S,"Date",{now:function(){return(new Date).getTime()}})},function(t,e,n){"use strict";var r=n(0),i=n(9),a=n(23);r(r.P+r.F*n(3)(function(){return null!==new Date(NaN).toJSON()||1!==Date.prototype.toJSON.call({toISOString:function(){return 1}})}),"Date",{toJSON:function(t){var e=i(this),n=a(e);return"number"!=typeof n||isFinite(n)?e.toISOString():null}})},function(t,e,n){var r=n(0),i=n(252);r(r.P+r.F*(Date.prototype.toISOString!==i),"Date",{toISOString:i})},function(t,e,n){"use strict";var r=n(3),i=Date.prototype.getTime,a=Date.prototype.toISOString,o=function(t){return t>9?t:"0"+t};t.exports=r(function(){return"0385-07-25T07:06:39.999Z"!=a.call(new Date(-5e13-1))})||!r(function(){a.call(new Date(NaN))})?function(){if(!isFinite(i.call(this)))throw RangeError("Invalid time value");var t=this,e=t.getUTCFullYear(),n=t.getUTCMilliseconds(),r=e<0?"-":e>9999?"+":"";return r+("00000"+Math.abs(e)).slice(r?-6:-4)+"-"+o(t.getUTCMonth()+1)+"-"+o(t.getUTCDate())+"T"+o(t.getUTCHours())+":"+o(t.getUTCMinutes())+":"+o(t.getUTCSeconds())+"."+(n>99?n:"0"+o(n))+"Z"}:a},function(t,e,n){var r=Date.prototype,i=r.toString,a=r.getTime;new Date(NaN)+""!="Invalid Date"&&n(12)(r,"toString",function(){var t=a.call(this);return t==t?i.call(this):"Invalid Date"})},function(t,e,n){var r=n(5)("toPrimitive"),i=Date.prototype;r in i||n(11)(i,r,n(255))},function(t,e,n){"use strict";var r=n(1),i=n(23);t.exports=function(t){if("string"!==t&&"number"!==t&&"default"!==t)throw TypeError("Incorrect hint");return i(r(this),"number"!=t)}},function(t,e,n){var r=n(0);r(r.S,"Array",{isArray:n(59)})},function(t,e,n){"use strict";var r=n(19),i=n(0),a=n(9),o=n(124),s=n(89),u=n(6),c=n(90),l=n(91);i(i.S+i.F*!n(62)(function(t){Array.from(t)}),"Array",{from:function(t){var e,n,i,f,h=a(t),d="function"==typeof this?this:Array,p=arguments.length,v=p>1?arguments[1]:void 0,g=void 0!==v,m=0,y=l(h);if(g&&(v=r(v,p>2?arguments[2]:void 0,2)),null==y||d==Array&&s(y))for(n=new d(e=u(h.length));e>m;m++)c(n,m,g?v(h[m],m):h[m]);else for(f=y.call(h),n=new d;!(i=f.next()).done;m++)c(n,m,g?o(f,v,[i.value,m],!0):i.value);return n.length=m,n}})},function(t,e,n){"use strict";var r=n(0),i=n(90);r(r.S+r.F*n(3)(function(){function t(){}return!(Array.of.call(t)instanceof t)}),"Array",{of:function(){for(var t=0,e=arguments.length,n=new("function"==typeof this?this:Array)(e);e>t;)i(n,t,arguments[t++]);return n.length=e,n}})},function(t,e,n){"use strict";var r=n(0),i=n(15),a=[].join;r(r.P+r.F*(n(52)!=Object||!n(22)(a)),"Array",{join:function(t){return a.call(i(this),void 0===t?",":t)}})},function(t,e,n){"use strict";var r=n(0),i=n(78),a=n(20),o=n(36),s=n(6),u=[].slice;r(r.P+r.F*n(3)(function(){i&&u.call(i)}),"Array",{slice:function(t,e){var n=s(this.length),r=a(this);if(e=void 0===e?n:e,"Array"==r)return u.call(this,t,e);for(var i=o(t,n),c=o(e,n),l=s(c-i),f=new Array(l),h=0;h<l;h++)f[h]="String"==r?this.charAt(i+h):this[i+h];return f}})},function(t,e,n){"use strict";var r=n(0),i=n(10),a=n(9),o=n(3),s=[].sort,u=[1,2,3];r(r.P+r.F*(o(function(){u.sort(void 0)})||!o(function(){u.sort(null)})||!n(22)(s)),"Array",{sort:function(t){return void 0===t?s.call(a(this)):s.call(a(this),i(t))}})},function(t,e,n){"use strict";var r=n(0),i=n(26)(0),a=n(22)([].forEach,!0);r(r.P+r.F*!a,"Array",{forEach:function(t){return i(this,t,arguments[1])}})},function(t,e,n){var r=n(4),i=n(59),a=n(5)("species");t.exports=function(t){var e;return i(t)&&("function"!=typeof(e=t.constructor)||e!==Array&&!i(e.prototype)||(e=void 0),r(e)&&null===(e=e[a])&&(e=void 0)),void 0===e?Array:e}},function(t,e,n){"use strict";var r=n(0),i=n(26)(1);r(r.P+r.F*!n(22)([].map,!0),"Array",{map:function(t){return i(this,t,arguments[1])}})},function(t,e,n){"use strict";var r=n(0),i=n(26)(2);r(r.P+r.F*!n(22)([].filter,!0),"Array",{filter:function(t){return i(this,t,arguments[1])}})},function(t,e,n){"use strict";var r=n(0),i=n(26)(3);r(r.P+r.F*!n(22)([].some,!0),"Array",{some:function(t){return i(this,t,arguments[1])}})},function(t,e,n){"use strict";var r=n(0),i=n(26)(4);r(r.P+r.F*!n(22)([].every,!0),"Array",{every:function(t){return i(this,t,arguments[1])}})},function(t,e,n){"use strict";var r=n(0),i=n(125);r(r.P+r.F*!n(22)([].reduce,!0),"Array",{reduce:function(t){return i(this,t,arguments.length,arguments[1],!1)}})},function(t,e,n){"use strict";var r=n(0),i=n(125);r(r.P+r.F*!n(22)([].reduceRight,!0),"Array",{reduceRight:function(t){return i(this,t,arguments.length,arguments[1],!0)}})},function(t,e,n){"use strict";var r=n(0),i=n(57)(!1),a=[].indexOf,o=!!a&&1/[1].indexOf(1,-0)<0;r(r.P+r.F*(o||!n(22)(a)),"Array",{indexOf:function(t){return o?a.apply(this,arguments)||0:i(this,t,arguments[1])}})},function(t,e,n){"use strict";var r=n(0),i=n(15),a=n(21),o=n(6),s=[].lastIndexOf,u=!!s&&1/[1].lastIndexOf(1,-0)<0;r(r.P+r.F*(u||!n(22)(s)),"Array",{lastIndexOf:function(t){if(u)return s.apply(this,arguments)||0;var e=i(this),n=o(e.length),r=n-1;for(arguments.length>1&&(r=Math.min(r,a(arguments[1]))),r<0&&(r=n+r);r>=0;r--)if(r in e&&e[r]===t)return r||0;return-1}})},function(t,e,n){var r=n(0);r(r.P,"Array",{copyWithin:n(126)}),n(32)("copyWithin")},function(t,e,n){var r=n(0);r(r.P,"Array",{fill:n(93)}),n(32)("fill")},function(t,e,n){"use strict";var r=n(0),i=n(26)(5),a=!0;"find"in[]&&Array(1).find(function(){a=!1}),r(r.P+r.F*a,"Array",{find:function(t){return i(this,t,arguments.length>1?arguments[1]:void 0)}}),n(32)("find")},function(t,e,n){"use strict";var r=n(0),i=n(26)(6),a="findIndex",o=!0;a in[]&&Array(1)[a](function(){o=!1}),r(r.P+r.F*o,"Array",{findIndex:function(t){return i(this,t,arguments.length>1?arguments[1]:void 0)}}),n(32)(a)},function(t,e,n){n(39)("Array")},function(t,e,n){var r=n(2),i=n(81),a=n(8).f,o=n(38).f,s=n(61),u=n(54),c=r.RegExp,l=c,f=c.prototype,h=/a/g,d=/a/g,p=new c(h)!==h;if(n(7)&&(!p||n(3)(function(){return d[n(5)("match")]=!1,c(h)!=h||c(d)==d||"/a/i"!=c(h,"i")}))){c=function(t,e){var n=this instanceof c,r=s(t),a=void 0===e;return!n&&r&&t.constructor===c&&a?t:i(p?new l(r&&!a?t.source:t,e):l((r=t instanceof c)?t.source:t,r&&a?u.call(t):e),n?this:f,c)};for(var v=function(t){t in c||a(c,t,{configurable:!0,get:function(){return l[t]},set:function(e){l[t]=e}})},g=o(l),m=0;g.length>m;)v(g[m++]);f.constructor=c,c.prototype=f,n(12)(r,"RegExp",c)}n(39)("RegExp")},function(t,e,n){"use strict";n(129);var r=n(1),i=n(54),a=n(7),o=/./.toString,s=function(t){n(12)(RegExp.prototype,"toString",t,!0)};n(3)(function(){return"/a/b"!=o.call({source:"a",flags:"b"})})?s(function(){var t=r(this);return"/".concat(t.source,"/","flags"in t?t.flags:!a&&t instanceof RegExp?i.call(t):void 0)}):"toString"!=o.name&&s(function(){return o.call(this)})},function(t,e,n){"use strict";var r=n(1),i=n(6),a=n(96),o=n(63);n(64)("match",1,function(t,e,n,s){return[function(n){var r=t(this),i=null==n?void 0:n[e];return void 0!==i?i.call(n,r):new RegExp(n)[e](String(r))},function(t){var e=s(n,t,this);if(e.done)return e.value;var u=r(t),c=String(this);if(!u.global)return o(u,c);var l=u.unicode;u.lastIndex=0;for(var f,h=[],d=0;null!==(f=o(u,c));){var p=String(f[0]);h[d]=p,""===p&&(u.lastIndex=a(c,i(u.lastIndex),l)),d++}return 0===d?null:h}]})},function(t,e,n){"use strict";var r=n(1),i=n(9),a=n(6),o=n(21),s=n(96),u=n(63),c=Math.max,l=Math.min,f=Math.floor,h=/\$([$&`']|\d\d?|<[^>]*>)/g,d=/\$([$&`']|\d\d?)/g;n(64)("replace",2,function(t,e,n,p){return[function(r,i){var a=t(this),o=null==r?void 0:r[e];return void 0!==o?o.call(r,a,i):n.call(String(a),r,i)},function(t,e){var i=p(n,t,this,e);if(i.done)return i.value;var f=r(t),h=String(this),d="function"==typeof e;d||(e=String(e));var g=f.global;if(g){var m=f.unicode;f.lastIndex=0}for(var y=[];;){var b=u(f,h);if(null===b)break;if(y.push(b),!g)break;""===String(b[0])&&(f.lastIndex=s(h,a(f.lastIndex),m))}for(var w,x="",E=0,_=0;_<y.length;_++){b=y[_];for(var S=String(b[0]),k=c(l(o(b.index),h.length),0),P=[],R=1;R<b.length;R++)P.push(void 0===(w=b[R])?w:String(w));var A=b.groups;if(d){var C=[S].concat(P,k,h);void 0!==A&&C.push(A);var I=String(e.apply(void 0,C))}else I=v(S,h,k,P,A,e);k>=E&&(x+=h.slice(E,k)+I,E=k+S.length)}return x+h.slice(E)}];function v(t,e,r,a,o,s){var u=r+t.length,c=a.length,l=d;return void 0!==o&&(o=i(o),l=h),n.call(s,l,function(n,i){var s;switch(i.charAt(0)){case"$":return"$";case"&":return t;case"`":return e.slice(0,r);case"'":return e.slice(u);case"<":s=o[i.slice(1,-1)];break;default:var l=+i;if(0===l)return n;if(l>c){var h=f(l/10);return 0===h?n:h<=c?void 0===a[h-1]?i.charAt(1):a[h-1]+i.charAt(1):n}s=a[l-1]}return void 0===s?"":s})}})},function(t,e,n){"use strict";var r=n(1),i=n(115),a=n(63);n(64)("search",1,function(t,e,n,o){return[function(n){var r=t(this),i=null==n?void 0:n[e];return void 0!==i?i.call(n,r):new RegExp(n)[e](String(r))},function(t){var e=o(n,t,this);if(e.done)return e.value;var s=r(t),u=String(this),c=s.lastIndex;i(c,0)||(s.lastIndex=0);var l=a(s,u);return i(s.lastIndex,c)||(s.lastIndex=c),null===l?-1:l.index}]})},function(t,e,n){"use strict";var r=n(61),i=n(1),a=n(55),o=n(96),s=n(6),u=n(63),c=n(95),l=n(3),f=Math.min,h=[].push,d=!l(function(){RegExp(4294967295,"y")});n(64)("split",2,function(t,e,n,l){var p;return p="c"=="abbc".split(/(b)*/)[1]||4!="test".split(/(?:)/,-1).length||2!="ab".split(/(?:ab)*/).length||4!=".".split(/(.?)(.?)/).length||".".split(/()()/).length>1||"".split(/.?/).length?function(t,e){var i=String(this);if(void 0===t&&0===e)return[];if(!r(t))return n.call(i,t,e);for(var a,o,s,u=[],l=(t.ignoreCase?"i":"")+(t.multiline?"m":"")+(t.unicode?"u":"")+(t.sticky?"y":""),f=0,d=void 0===e?4294967295:e>>>0,p=new RegExp(t.source,l+"g");(a=c.call(p,i))&&!((o=p.lastIndex)>f&&(u.push(i.slice(f,a.index)),a.length>1&&a.index<i.length&&h.apply(u,a.slice(1)),s=a[0].length,f=o,u.length>=d));)p.lastIndex===a.index&&p.lastIndex++;return f===i.length?!s&&p.test("")||u.push(""):u.push(i.slice(f)),u.length>d?u.slice(0,d):u}:"0".split(void 0,0).length?function(t,e){return void 0===t&&0===e?[]:n.call(this,t,e)}:n,[function(n,r){var i=t(this),a=null==n?void 0:n[e];return void 0!==a?a.call(n,i,r):p.call(String(i),n,r)},function(t,e){var r=l(p,t,this,e,p!==n);if(r.done)return r.value;var c=i(t),h=String(this),v=a(c,RegExp),g=c.unicode,m=(c.ignoreCase?"i":"")+(c.multiline?"m":"")+(c.unicode?"u":"")+(d?"y":"g"),y=new v(d?c:"^(?:"+c.source+")",m),b=void 0===e?4294967295:e>>>0;if(0===b)return[];if(0===h.length)return null===u(y,h)?[h]:[];for(var w=0,x=0,E=[];x<h.length;){y.lastIndex=d?x:0;var _,S=u(y,d?h:h.slice(x));if(null===S||(_=f(s(y.lastIndex+(d?0:x)),h.length))===w)x=o(h,x,g);else{if(E.push(h.slice(w,x)),E.length===b)return E;for(var k=1;k<=S.length-1;k++)if(E.push(S[k]),E.length===b)return E;x=w=_}}return E.push(h.slice(w)),E}]})},function(t,e,n){"use strict";var r,i,a,o,s=n(30),u=n(2),c=n(19),l=n(47),f=n(0),h=n(4),d=n(10),p=n(40),v=n(41),g=n(55),m=n(97).set,y=n(98)(),b=n(99),w=n(130),x=n(65),E=n(131),_=u.TypeError,S=u.process,k=S&&S.versions,P=k&&k.v8||"",R=u.Promise,A="process"==l(S),C=function(){},I=i=b.f,F=!!function(){try{var t=R.resolve(1),e=(t.constructor={})[n(5)("species")]=function(t){t(C,C)};return(A||"function"==typeof PromiseRejectionEvent)&&t.then(C)instanceof e&&0!==P.indexOf("6.6")&&-1===x.indexOf("Chrome/66")}catch(t){}}(),O=function(t){var e;return!(!h(t)||"function"!=typeof(e=t.then))&&e},T=function(t,e){if(!t._n){t._n=!0;var n=t._c;y(function(){for(var r=t._v,i=1==t._s,a=0,o=function(e){var n,a,o,s=i?e.ok:e.fail,u=e.resolve,c=e.reject,l=e.domain;try{s?(i||(2==t._h&&j(t),t._h=1),!0===s?n=r:(l&&l.enter(),n=s(r),l&&(l.exit(),o=!0)),n===e.promise?c(_("Promise-chain cycle")):(a=O(n))?a.call(n,u,c):u(n)):c(r)}catch(t){l&&!o&&l.exit(),c(t)}};n.length>a;)o(n[a++]);t._c=[],t._n=!1,e&&!t._h&&M(t)})}},M=function(t){m.call(u,function(){var e,n,r,i=t._v,a=D(t);if(a&&(e=w(function(){A?S.emit("unhandledRejection",i,t):(n=u.onunhandledrejection)?n({promise:t,reason:i}):(r=u.console)&&r.error&&r.error("Unhandled promise rejection",i)}),t._h=A||D(t)?2:1),t._a=void 0,a&&e.e)throw e.v})},D=function(t){return 1!==t._h&&0===(t._a||t._c).length},j=function(t){m.call(u,function(){var e;A?S.emit("rejectionHandled",t):(e=u.onrejectionhandled)&&e({promise:t,reason:t._v})})},L=function(t){var e=this;e._d||(e._d=!0,(e=e._w||e)._v=t,e._s=2,e._a||(e._a=e._c.slice()),T(e,!0))},B=function(t){var e,n=this;if(!n._d){n._d=!0,n=n._w||n;try{if(n===t)throw _("Promise can't be resolved itself");(e=O(t))?y(function(){var r={_w:n,_d:!1};try{e.call(t,c(B,r,1),c(L,r,1))}catch(t){L.call(r,t)}}):(n._v=t,n._s=1,T(n,!1))}catch(t){L.call({_w:n,_d:!1},t)}}};F||(R=function(t){p(this,R,"Promise","_h"),d(t),r.call(this);try{t(c(B,this,1),c(L,this,1))}catch(t){L.call(this,t)}},(r=function(t){this._c=[],this._a=void 0,this._s=0,this._d=!1,this._v=void 0,this._h=0,this._n=!1}).prototype=n(42)(R.prototype,{then:function(t,e){var n=I(g(this,R));return n.ok="function"!=typeof t||t,n.fail="function"==typeof e&&e,n.domain=A?S.domain:void 0,this._c.push(n),this._a&&this._a.push(n),this._s&&T(this,!1),n.promise},catch:function(t){return this.then(void 0,t)}}),a=function(){var t=new r;this.promise=t,this.resolve=c(B,t,1),this.reject=c(L,t,1)},b.f=I=function(t){return t===R||t===o?new a(t):i(t)}),f(f.G+f.W+f.F*!F,{Promise:R}),n(46)(R,"Promise"),n(39)("Promise"),o=n(18).Promise,f(f.S+f.F*!F,"Promise",{reject:function(t){var e=I(this);return(0,e.reject)(t),e.promise}}),f(f.S+f.F*(s||!F),"Promise",{resolve:function(t){return E(s&&this===o?R:this,t)}}),f(f.S+f.F*!(F&&n(62)(function(t){R.all(t).catch(C)})),"Promise",{all:function(t){var e=this,n=I(e),r=n.resolve,i=n.reject,a=w(function(){var n=[],a=0,o=1;v(t,!1,function(t){var s=a++,u=!1;n.push(void 0),o++,e.resolve(t).then(function(t){u||(u=!0,n[s]=t,--o||r(n))},i)}),--o||r(n)});return a.e&&i(a.v),n.promise},race:function(t){var e=this,n=I(e),r=n.reject,i=w(function(){v(t,!1,function(t){e.resolve(t).then(n.resolve,r)})});return i.e&&r(i.v),n.promise}})},function(t,e,n){"use strict";var r=n(136),i=n(43);n(66)("WeakSet",function(t){return function(){return t(this,arguments.length>0?arguments[0]:void 0)}},{add:function(t){return r.def(i(this,"WeakSet"),t,!0)}},r,!1,!0)},function(t,e,n){"use strict";var r=n(0),i=n(67),a=n(100),o=n(1),s=n(36),u=n(6),c=n(4),l=n(2).ArrayBuffer,f=n(55),h=a.ArrayBuffer,d=a.DataView,p=i.ABV&&l.isView,v=h.prototype.slice,g=i.VIEW;r(r.G+r.W+r.F*(l!==h),{ArrayBuffer:h}),r(r.S+r.F*!i.CONSTR,"ArrayBuffer",{isView:function(t){return p&&p(t)||c(t)&&g in t}}),r(r.P+r.U+r.F*n(3)(function(){return!new h(2).slice(1,void 0).byteLength}),"ArrayBuffer",{slice:function(t,e){if(void 0!==v&&void 0===e)return v.call(o(this),t);for(var n=o(this).byteLength,r=s(t,n),i=s(void 0===e?n:e,n),a=new(f(this,h))(u(i-r)),c=new d(this),l=new d(a),p=0;r<i;)l.setUint8(p++,c.getUint8(r++));return a}}),n(39)("ArrayBuffer")},function(t,e,n){var r=n(0);r(r.G+r.W+r.F*!n(67).ABV,{DataView:n(100).DataView})},function(t,e,n){n(28)("Int8",1,function(t){return function(e,n,r){return t(this,e,n,r)}})},function(t,e,n){n(28)("Uint8",1,function(t){return function(e,n,r){return t(this,e,n,r)}})},function(t,e,n){n(28)("Uint8",1,function(t){return function(e,n,r){return t(this,e,n,r)}},!0)},function(t,e,n){n(28)("Int16",2,function(t){return function(e,n,r){return t(this,e,n,r)}})},function(t,e,n){n(28)("Uint16",2,function(t){return function(e,n,r){return t(this,e,n,r)}})},function(t,e,n){n(28)("Int32",4,function(t){return function(e,n,r){return t(this,e,n,r)}})},function(t,e,n){n(28)("Uint32",4,function(t){return function(e,n,r){return t(this,e,n,r)}})},function(t,e,n){n(28)("Float32",4,function(t){return function(e,n,r){return t(this,e,n,r)}})},function(t,e,n){n(28)("Float64",8,function(t){return function(e,n,r){return t(this,e,n,r)}})},function(t,e,n){var r=n(0),i=n(10),a=n(1),o=(n(2).Reflect||{}).apply,s=Function.apply;r(r.S+r.F*!n(3)(function(){o(function(){})}),"Reflect",{apply:function(t,e,n){var r=i(t),u=a(n);return o?o(r,e,u):s.call(r,e,u)}})},function(t,e,n){var r=n(0),i=n(37),a=n(10),o=n(1),s=n(4),u=n(3),c=n(116),l=(n(2).Reflect||{}).construct,f=u(function(){function t(){}return!(l(function(){},[],t)instanceof t)}),h=!u(function(){l(function(){})});r(r.S+r.F*(f||h),"Reflect",{construct:function(t,e){a(t),o(e);var n=arguments.length<3?t:a(arguments[2]);if(h&&!f)return l(t,e,n);if(t==n){switch(e.length){case 0:return new t;case 1:return new t(e[0]);case 2:return new t(e[0],e[1]);case 3:return new t(e[0],e[1],e[2]);case 4:return new t(e[0],e[1],e[2],e[3])}var r=[null];return r.push.apply(r,e),new(c.apply(t,r))}var u=n.prototype,d=i(s(u)?u:Object.prototype),p=Function.apply.call(t,d,e);return s(p)?p:d}})},function(t,e,n){var r=n(8),i=n(0),a=n(1),o=n(23);i(i.S+i.F*n(3)(function(){Reflect.defineProperty(r.f({},1,{value:1}),1,{value:2})}),"Reflect",{defineProperty:function(t,e,n){a(t),e=o(e,!0),a(n);try{return r.f(t,e,n),!0}catch(t){return!1}}})},function(t,e,n){var r=n(0),i=n(16).f,a=n(1);r(r.S,"Reflect",{deleteProperty:function(t,e){var n=i(a(t),e);return!(n&&!n.configurable)&&delete t[e]}})},function(t,e,n){"use strict";var r=n(0),i=n(1),a=function(t){this._t=i(t),this._i=0;var e,n=this._k=[];for(e in t)n.push(e)};n(86)(a,"Object",function(){var t,e=this._k;do{if(this._i>=e.length)return{value:void 0,done:!0}}while(!((t=e[this._i++])in this._t));return{value:t,done:!1}}),r(r.S,"Reflect",{enumerate:function(t){return new a(t)}})},function(t,e,n){var r=n(16),i=n(17),a=n(14),o=n(0),s=n(4),u=n(1);o(o.S,"Reflect",{get:function t(e,n){var o,c,l=arguments.length<3?e:arguments[2];return u(e)===l?e[n]:(o=r.f(e,n))?a(o,"value")?o.value:void 0!==o.get?o.get.call(l):void 0:s(c=i(e))?t(c,n,l):void 0}})},function(t,e,n){var r=n(16),i=n(0),a=n(1);i(i.S,"Reflect",{getOwnPropertyDescriptor:function(t,e){return r.f(a(t),e)}})},function(t,e,n){var r=n(0),i=n(17),a=n(1);r(r.S,"Reflect",{getPrototypeOf:function(t){return i(a(t))}})},function(t,e,n){var r=n(0);r(r.S,"Reflect",{has:function(t,e){return e in t}})},function(t,e,n){var r=n(0),i=n(1),a=Object.isExtensible;r(r.S,"Reflect",{isExtensible:function(t){return i(t),!a||a(t)}})},function(t,e,n){var r=n(0);r(r.S,"Reflect",{ownKeys:n(138)})},function(t,e,n){var r=n(0),i=n(1),a=Object.preventExtensions;r(r.S,"Reflect",{preventExtensions:function(t){i(t);try{return a&&a(t),!0}catch(t){return!1}}})},function(t,e,n){var r=n(8),i=n(16),a=n(17),o=n(14),s=n(0),u=n(33),c=n(1),l=n(4);s(s.S,"Reflect",{set:function t(e,n,s){var f,h,d=arguments.length<4?e:arguments[3],p=i.f(c(e),n);if(!p){if(l(h=a(e)))return t(h,n,s,d);p=u(0)}if(o(p,"value")){if(!1===p.writable||!l(d))return!1;if(f=i.f(d,n)){if(f.get||f.set||!1===f.writable)return!1;f.value=s,r.f(d,n,f)}else r.f(d,n,u(0,s));return!0}return void 0!==p.set&&(p.set.call(d,s),!0)}})},function(t,e,n){var r=n(0),i=n(79);i&&r(r.S,"Reflect",{setPrototypeOf:function(t,e){i.check(t,e);try{return i.set(t,e),!0}catch(t){return!1}}})},function(t,e,n){"use strict";var r=n(0),i=n(57)(!0);r(r.P,"Array",{includes:function(t){return i(this,t,arguments.length>1?arguments[1]:void 0)}}),n(32)("includes")},function(t,e,n){"use strict";var r=n(0),i=n(139),a=n(9),o=n(6),s=n(10),u=n(92);r(r.P,"Array",{flatMap:function(t){var e,n,r=a(this);return s(t),e=o(r.length),n=u(r,0),i(n,r,r,e,0,1,t,arguments[1]),n}}),n(32)("flatMap")},function(t,e,n){"use strict";var r=n(0),i=n(139),a=n(9),o=n(6),s=n(21),u=n(92);r(r.P,"Array",{flatten:function(){var t=arguments[0],e=a(this),n=o(e.length),r=u(e,0);return i(r,e,e,n,0,void 0===t?1:s(t)),r}}),n(32)("flatten")},function(t,e,n){"use strict";var r=n(0),i=n(60)(!0);r(r.P,"String",{at:function(t){return i(this,t)}})},function(t,e,n){"use strict";var r=n(0),i=n(140),a=n(65),o=/Version\/10\.\d+(\.\d+)?( Mobile\/\w+)? Safari\//.test(a);r(r.P+r.F*o,"String",{padStart:function(t){return i(this,t,arguments.length>1?arguments[1]:void 0,!0)}})},function(t,e,n){"use strict";var r=n(0),i=n(140),a=n(65),o=/Version\/10\.\d+(\.\d+)?( Mobile\/\w+)? Safari\//.test(a);r(r.P+r.F*o,"String",{padEnd:function(t){return i(this,t,arguments.length>1?arguments[1]:void 0,!1)}})},function(t,e,n){"use strict";n(48)("trimLeft",function(t){return function(){return t(this,1)}},"trimStart")},function(t,e,n){"use strict";n(48)("trimRight",function(t){return function(){return t(this,2)}},"trimEnd")},function(t,e,n){"use strict";var r=n(0),i=n(24),a=n(6),o=n(61),s=n(54),u=RegExp.prototype,c=function(t,e){this._r=t,this._s=e};n(86)(c,"RegExp String",function(){var t=this._r.exec(this._s);return{value:t,done:null===t}}),r(r.P,"String",{matchAll:function(t){if(i(this),!o(t))throw TypeError(t+" is not a regexp!");var e=String(this),n="flags"in u?String(t.flags):s.call(t),r=new RegExp(t.source,~n.indexOf("g")?n:"g"+n);return r.lastIndex=a(t.lastIndex),new c(r,e)}})},function(t,e,n){n(75)("asyncIterator")},function(t,e,n){n(75)("observable")},function(t,e,n){var r=n(0),i=n(138),a=n(15),o=n(16),s=n(90);r(r.S,"Object",{getOwnPropertyDescriptors:function(t){for(var e,n,r=a(t),u=o.f,c=i(r),l={},f=0;c.length>f;)void 0!==(n=u(r,e=c[f++]))&&s(l,e,n);return l}})},function(t,e,n){var r=n(0),i=n(141)(!1);r(r.S,"Object",{values:function(t){return i(t)}})},function(t,e,n){var r=n(0),i=n(141)(!0);r(r.S,"Object",{entries:function(t){return i(t)}})},function(t,e,n){"use strict";var r=n(0),i=n(9),a=n(10),o=n(8);n(7)&&r(r.P+n(68),"Object",{__defineGetter__:function(t,e){o.f(i(this),t,{get:a(e),enumerable:!0,configurable:!0})}})},function(t,e,n){"use strict";var r=n(0),i=n(9),a=n(10),o=n(8);n(7)&&r(r.P+n(68),"Object",{__defineSetter__:function(t,e){o.f(i(this),t,{set:a(e),enumerable:!0,configurable:!0})}})},function(t,e,n){"use strict";var r=n(0),i=n(9),a=n(23),o=n(17),s=n(16).f;n(7)&&r(r.P+n(68),"Object",{__lookupGetter__:function(t){var e,n=i(this),r=a(t,!0);do{if(e=s(n,r))return e.get}while(n=o(n))}})},function(t,e,n){"use strict";var r=n(0),i=n(9),a=n(23),o=n(17),s=n(16).f;n(7)&&r(r.P+n(68),"Object",{__lookupSetter__:function(t){var e,n=i(this),r=a(t,!0);do{if(e=s(n,r))return e.set}while(n=o(n))}})},function(t,e,n){var r=n(0);r(r.P+r.R,"Map",{toJSON:n(142)("Map")})},function(t,e,n){var r=n(0);r(r.P+r.R,"Set",{toJSON:n(142)("Set")})},function(t,e,n){n(69)("Map")},function(t,e,n){n(69)("Set")},function(t,e,n){n(69)("WeakMap")},function(t,e,n){n(69)("WeakSet")},function(t,e,n){n(70)("Map")},function(t,e,n){n(70)("Set")},function(t,e,n){n(70)("WeakMap")},function(t,e,n){n(70)("WeakSet")},function(t,e,n){var r=n(0);r(r.G,{global:n(2)})},function(t,e,n){var r=n(0);r(r.S,"System",{global:n(2)})},function(t,e,n){var r=n(0),i=n(20);r(r.S,"Error",{isError:function(t){return"Error"===i(t)}})},function(t,e,n){var r=n(0);r(r.S,"Math",{clamp:function(t,e,n){return Math.min(n,Math.max(e,t))}})},function(t,e,n){var r=n(0);r(r.S,"Math",{DEG_PER_RAD:Math.PI/180})},function(t,e,n){var r=n(0),i=180/Math.PI;r(r.S,"Math",{degrees:function(t){return t*i}})},function(t,e,n){var r=n(0),i=n(144),a=n(123);r(r.S,"Math",{fscale:function(t,e,n,r,o){return a(i(t,e,n,r,o))}})},function(t,e,n){var r=n(0);r(r.S,"Math",{iaddh:function(t,e,n,r){var i=t>>>0,a=n>>>0;return(e>>>0)+(r>>>0)+((i&a|(i|a)&~(i+a>>>0))>>>31)|0}})},function(t,e,n){var r=n(0);r(r.S,"Math",{isubh:function(t,e,n,r){var i=t>>>0,a=n>>>0;return(e>>>0)-(r>>>0)-((~i&a|~(i^a)&i-a>>>0)>>>31)|0}})},function(t,e,n){var r=n(0);r(r.S,"Math",{imulh:function(t,e){var n=+t,r=+e,i=65535&n,a=65535&r,o=n>>16,s=r>>16,u=(o*a>>>0)+(i*a>>>16);return o*s+(u>>16)+((i*s>>>0)+(65535&u)>>16)}})},function(t,e,n){var r=n(0);r(r.S,"Math",{RAD_PER_DEG:180/Math.PI})},function(t,e,n){var r=n(0),i=Math.PI/180;r(r.S,"Math",{radians:function(t){return t*i}})},function(t,e,n){var r=n(0);r(r.S,"Math",{scale:n(144)})},function(t,e,n){var r=n(0);r(r.S,"Math",{umulh:function(t,e){var n=+t,r=+e,i=65535&n,a=65535&r,o=n>>>16,s=r>>>16,u=(o*a>>>0)+(i*a>>>16);return o*s+(u>>>16)+((i*s>>>0)+(65535&u)>>>16)}})},function(t,e,n){var r=n(0);r(r.S,"Math",{signbit:function(t){return(t=+t)!=t?t:0==t?1/t==1/0:t>0}})},function(t,e,n){"use strict";var r=n(0),i=n(18),a=n(2),o=n(55),s=n(131);r(r.P+r.R,"Promise",{finally:function(t){var e=o(this,i.Promise||a.Promise),n="function"==typeof t;return this.then(n?function(n){return s(e,t()).then(function(){return n})}:t,n?function(n){return s(e,t()).then(function(){throw n})}:t)}})},function(t,e,n){"use strict";var r=n(0),i=n(99),a=n(130);r(r.S,"Promise",{try:function(t){var e=i.f(this),n=a(t);return(n.e?e.reject:e.resolve)(n.v),e.promise}})},function(t,e,n){var r=n(29),i=n(1),a=r.key,o=r.set;r.exp({defineMetadata:function(t,e,n,r){o(t,e,i(n),a(r))}})},function(t,e,n){var r=n(29),i=n(1),a=r.key,o=r.map,s=r.store;r.exp({deleteMetadata:function(t,e){var n=arguments.length<3?void 0:a(arguments[2]),r=o(i(e),n,!1);if(void 0===r||!r.delete(t))return!1;if(r.size)return!0;var u=s.get(e);return u.delete(n),!!u.size||s.delete(e)}})},function(t,e,n){var r=n(29),i=n(1),a=n(17),o=r.has,s=r.get,u=r.key,c=function(t,e,n){if(o(t,e,n))return s(t,e,n);var r=a(e);return null!==r?c(t,r,n):void 0};r.exp({getMetadata:function(t,e){return c(t,i(e),arguments.length<3?void 0:u(arguments[2]))}})},function(t,e,n){var r=n(134),i=n(143),a=n(29),o=n(1),s=n(17),u=a.keys,c=a.key,l=function(t,e){var n=u(t,e),a=s(t);if(null===a)return n;var o=l(a,e);return o.length?n.length?i(new r(n.concat(o))):o:n};a.exp({getMetadataKeys:function(t){return l(o(t),arguments.length<2?void 0:c(arguments[1]))}})},function(t,e,n){var r=n(29),i=n(1),a=r.get,o=r.key;r.exp({getOwnMetadata:function(t,e){return a(t,i(e),arguments.length<3?void 0:o(arguments[2]))}})},function(t,e,n){var r=n(29),i=n(1),a=r.keys,o=r.key;r.exp({getOwnMetadataKeys:function(t){return a(i(t),arguments.length<2?void 0:o(arguments[1]))}})},function(t,e,n){var r=n(29),i=n(1),a=n(17),o=r.has,s=r.key,u=function(t,e,n){if(o(t,e,n))return!0;var r=a(e);return null!==r&&u(t,r,n)};r.exp({hasMetadata:function(t,e){return u(t,i(e),arguments.length<3?void 0:s(arguments[2]))}})},function(t,e,n){var r=n(29),i=n(1),a=r.has,o=r.key;r.exp({hasOwnMetadata:function(t,e){return a(t,i(e),arguments.length<3?void 0:o(arguments[2]))}})},function(t,e,n){var r=n(29),i=n(1),a=n(10),o=r.key,s=r.set;r.exp({metadata:function(t,e){return function(n,r){s(t,e,(void 0!==r?i:a)(n),o(r))}}})},function(t,e,n){var r=n(0),i=n(98)(),a=n(2).process,o="process"==n(20)(a);r(r.G,{asap:function(t){var e=o&&a.domain;i(e?e.bind(t):t)}})},function(t,e,n){"use strict";var r=n(0),i=n(2),a=n(18),o=n(98)(),s=n(5)("observable"),u=n(10),c=n(1),l=n(40),f=n(42),h=n(11),d=n(41),p=d.RETURN,v=function(t){return null==t?void 0:u(t)},g=function(t){var e=t._c;e&&(t._c=void 0,e())},m=function(t){return void 0===t._o},y=function(t){m(t)||(t._o=void 0,g(t))},b=function(t,e){c(t),this._c=void 0,this._o=t,t=new w(this);try{var n=e(t),r=n;null!=n&&("function"==typeof n.unsubscribe?n=function(){r.unsubscribe()}:u(n),this._c=n)}catch(e){return void t.error(e)}m(this)&&g(this)};b.prototype=f({},{unsubscribe:function(){y(this)}});var w=function(t){this._s=t};w.prototype=f({},{next:function(t){var e=this._s;if(!m(e)){var n=e._o;try{var r=v(n.next);if(r)return r.call(n,t)}catch(t){try{y(e)}finally{throw t}}}},error:function(t){var e=this._s;if(m(e))throw t;var n=e._o;e._o=void 0;try{var r=v(n.error);if(!r)throw t;t=r.call(n,t)}catch(t){try{g(e)}finally{throw t}}return g(e),t},complete:function(t){var e=this._s;if(!m(e)){var n=e._o;e._o=void 0;try{var r=v(n.complete);t=r?r.call(n,t):void 0}catch(t){try{g(e)}finally{throw t}}return g(e),t}}});var x=function(t){l(this,x,"Observable","_f")._f=u(t)};f(x.prototype,{subscribe:function(t){return new b(t,this._f)},forEach:function(t){var e=this;return new(a.Promise||i.Promise)(function(n,r){u(t);var i=e.subscribe({next:function(e){try{return t(e)}catch(t){r(t),i.unsubscribe()}},error:r,complete:n})})}}),f(x,{from:function(t){var e="function"==typeof this?this:x,n=v(c(t)[s]);if(n){var r=c(n.call(t));return r.constructor===e?r:new e(function(t){return r.subscribe(t)})}return new e(function(e){var n=!1;return o(function(){if(!n){try{if(d(t,!1,function(t){if(e.next(t),n)return p})===p)return}catch(t){if(n)throw t;return void e.error(t)}e.complete()}}),function(){n=!0}})},of:function(){for(var t=0,e=arguments.length,n=new Array(e);t<e;)n[t]=arguments[t++];return new("function"==typeof this?this:x)(function(t){var e=!1;return o(function(){if(!e){for(var r=0;r<n.length;++r)if(t.next(n[r]),e)return;t.complete()}}),function(){e=!0}})}}),h(x.prototype,s,function(){return this}),r(r.G,{Observable:x}),n(39)("Observable")},function(t,e,n){var r=n(2),i=n(0),a=n(65),o=[].slice,s=/MSIE .\./.test(a),u=function(t){return function(e,n){var r=arguments.length>2,i=!!r&&o.call(arguments,2);return t(r?function(){("function"==typeof e?e:Function(e)).apply(this,i)}:e,n)}};i(i.G+i.B+i.F*s,{setTimeout:u(r.setTimeout),setInterval:u(r.setInterval)})},function(t,e,n){var r=n(0),i=n(97);r(r.G+r.B,{setImmediate:i.set,clearImmediate:i.clear})},function(t,e,n){for(var r=n(94),i=n(35),a=n(12),o=n(2),s=n(11),u=n(49),c=n(5),l=c("iterator"),f=c("toStringTag"),h=u.Array,d={CSSRuleList:!0,CSSStyleDeclaration:!1,CSSValueList:!1,ClientRectList:!1,DOMRectList:!1,DOMStringList:!1,DOMTokenList:!0,DataTransferItemList:!1,FileList:!1,HTMLAllCollection:!1,HTMLCollection:!1,HTMLFormElement:!1,HTMLSelectElement:!1,MediaList:!0,MimeTypeArray:!1,NamedNodeMap:!1,NodeList:!0,PaintRequestList:!1,Plugin:!1,PluginArray:!1,SVGLengthList:!1,SVGNumberList:!1,SVGPathSegList:!1,SVGPointList:!1,SVGStringList:!1,SVGTransformList:!1,SourceBufferList:!1,StyleSheetList:!0,TextTrackCueList:!1,TextTrackList:!1,TouchList:!1},p=i(d),v=0;v<p.length;v++){var g,m=p[v],y=d[m],b=o[m],w=b&&b.prototype;if(w&&(w[l]||s(w,l,h),w[f]||s(w,f,m),u[m]=h,y))for(g in r)w[g]||a(w,g,r[g],!0)}},function(t,e,n){(function(e){!function(e){"use strict";var n,r=Object.prototype,i=r.hasOwnProperty,a="function"==typeof Symbol?Symbol:{},o=a.iterator||"@@iterator",s=a.asyncIterator||"@@asyncIterator",u=a.toStringTag||"@@toStringTag",c="object"==typeof t,l=e.regeneratorRuntime;if(l)c&&(t.exports=l);else{(l=e.regeneratorRuntime=c?t.exports:{}).wrap=w;var f="suspendedStart",h="suspendedYield",d="executing",p="completed",v={},g={};g[o]=function(){return this};var m=Object.getPrototypeOf,y=m&&m(m(F([])));y&&y!==r&&i.call(y,o)&&(g=y);var b=S.prototype=E.prototype=Object.create(g);_.prototype=b.constructor=S,S.constructor=_,S[u]=_.displayName="GeneratorFunction",l.isGeneratorFunction=function(t){var e="function"==typeof t&&t.constructor;return!!e&&(e===_||"GeneratorFunction"===(e.displayName||e.name))},l.mark=function(t){return Object.setPrototypeOf?Object.setPrototypeOf(t,S):(t.__proto__=S,u in t||(t[u]="GeneratorFunction")),t.prototype=Object.create(b),t},l.awrap=function(t){return{__await:t}},k(P.prototype),P.prototype[s]=function(){return this},l.AsyncIterator=P,l.async=function(t,e,n,r){var i=new P(w(t,e,n,r));return l.isGeneratorFunction(e)?i:i.next().then(function(t){return t.done?t.value:i.next()})},k(b),b[u]="Generator",b[o]=function(){return this},b.toString=function(){return"[object Generator]"},l.keys=function(t){var e=[];for(var n in t)e.push(n);return e.reverse(),function n(){for(;e.length;){var r=e.pop();if(r in t)return n.value=r,n.done=!1,n}return n.done=!0,n}},l.values=F,I.prototype={constructor:I,reset:function(t){if(this.prev=0,this.next=0,this.sent=this._sent=n,this.done=!1,this.delegate=null,this.method="next",this.arg=n,this.tryEntries.forEach(C),!t)for(var e in this)"t"===e.charAt(0)&&i.call(this,e)&&!isNaN(+e.slice(1))&&(this[e]=n)},stop:function(){this.done=!0;var t=this.tryEntries[0].completion;if("throw"===t.type)throw t.arg;return this.rval},dispatchException:function(t){if(this.done)throw t;var e=this;function r(r,i){return s.type="throw",s.arg=t,e.next=r,i&&(e.method="next",e.arg=n),!!i}for(var a=this.tryEntries.length-1;a>=0;--a){var o=this.tryEntries[a],s=o.completion;if("root"===o.tryLoc)return r("end");if(o.tryLoc<=this.prev){var u=i.call(o,"catchLoc"),c=i.call(o,"finallyLoc");if(u&&c){if(this.prev<o.catchLoc)return r(o.catchLoc,!0);if(this.prev<o.finallyLoc)return r(o.finallyLoc)}else if(u){if(this.prev<o.catchLoc)return r(o.catchLoc,!0)}else{if(!c)throw new Error("try statement without catch or finally");if(this.prev<o.finallyLoc)return r(o.finallyLoc)}}}},abrupt:function(t,e){for(var n=this.tryEntries.length-1;n>=0;--n){var r=this.tryEntries[n];if(r.tryLoc<=this.prev&&i.call(r,"finallyLoc")&&this.prev<r.finallyLoc){var a=r;break}}a&&("break"===t||"continue"===t)&&a.tryLoc<=e&&e<=a.finallyLoc&&(a=null);var o=a?a.completion:{};return o.type=t,o.arg=e,a?(this.method="next",this.next=a.finallyLoc,v):this.complete(o)},complete:function(t,e){if("throw"===t.type)throw t.arg;return"break"===t.type||"continue"===t.type?this.next=t.arg:"return"===t.type?(this.rval=this.arg=t.arg,this.method="return",this.next="end"):"normal"===t.type&&e&&(this.next=e),v},finish:function(t){for(var e=this.tryEntries.length-1;e>=0;--e){var n=this.tryEntries[e];if(n.finallyLoc===t)return this.complete(n.completion,n.afterLoc),C(n),v}},catch:function(t){for(var e=this.tryEntries.length-1;e>=0;--e){var n=this.tryEntries[e];if(n.tryLoc===t){var r=n.completion;if("throw"===r.type){var i=r.arg;C(n)}return i}}throw new Error("illegal catch attempt")},delegateYield:function(t,e,r){return this.delegate={iterator:F(t),resultName:e,nextLoc:r},"next"===this.method&&(this.arg=n),v}}}function w(t,e,n,r){var i=e&&e.prototype instanceof E?e:E,a=Object.create(i.prototype),o=new I(r||[]);return a._invoke=function(t,e,n){var r=f;return function(i,a){if(r===d)throw new Error("Generator is already running");if(r===p){if("throw"===i)throw a;return O()}for(n.method=i,n.arg=a;;){var o=n.delegate;if(o){var s=R(o,n);if(s){if(s===v)continue;return s}}if("next"===n.method)n.sent=n._sent=n.arg;else if("throw"===n.method){if(r===f)throw r=p,n.arg;n.dispatchException(n.arg)}else"return"===n.method&&n.abrupt("return",n.arg);r=d;var u=x(t,e,n);if("normal"===u.type){if(r=n.done?p:h,u.arg===v)continue;return{value:u.arg,done:n.done}}"throw"===u.type&&(r=p,n.method="throw",n.arg=u.arg)}}}(t,n,o),a}function x(t,e,n){try{return{type:"normal",arg:t.call(e,n)}}catch(t){return{type:"throw",arg:t}}}function E(){}function _(){}function S(){}function k(t){["next","throw","return"].forEach(function(e){t[e]=function(t){return this._invoke(e,t)}})}function P(t){function n(e,r,a,o){var s=x(t[e],t,r);if("throw"!==s.type){var u=s.arg,c=u.value;return c&&"object"==typeof c&&i.call(c,"__await")?Promise.resolve(c.__await).then(function(t){n("next",t,a,o)},function(t){n("throw",t,a,o)}):Promise.resolve(c).then(function(t){u.value=t,a(u)},o)}o(s.arg)}var r;"object"==typeof e.process&&e.process.domain&&(n=e.process.domain.bind(n)),this._invoke=function(t,e){function i(){return new Promise(function(r,i){n(t,e,r,i)})}return r=r?r.then(i,i):i()}}function R(t,e){var r=t.iterator[e.method];if(r===n){if(e.delegate=null,"throw"===e.method){if(t.iterator.return&&(e.method="return",e.arg=n,R(t,e),"throw"===e.method))return v;e.method="throw",e.arg=new TypeError("The iterator does not provide a 'throw' method")}return v}var i=x(r,t.iterator,e.arg);if("throw"===i.type)return e.method="throw",e.arg=i.arg,e.delegate=null,v;var a=i.arg;return a?a.done?(e[t.resultName]=a.value,e.next=t.nextLoc,"return"!==e.method&&(e.method="next",e.arg=n),e.delegate=null,v):a:(e.method="throw",e.arg=new TypeError("iterator result is not an object"),e.delegate=null,v)}function A(t){var e={tryLoc:t[0]};1 in t&&(e.catchLoc=t[1]),2 in t&&(e.finallyLoc=t[2],e.afterLoc=t[3]),this.tryEntries.push(e)}function C(t){var e=t.completion||{};e.type="normal",delete e.arg,t.completion=e}function I(t){this.tryEntries=[{tryLoc:"root"}],t.forEach(A,this),this.reset(!0)}function F(t){if(t){var e=t[o];if(e)return e.call(t);if("function"==typeof t.next)return t;if(!isNaN(t.length)){var r=-1,a=function e(){for(;++r<t.length;)if(i.call(t,r))return e.value=t[r],e.done=!1,e;return e.value=n,e.done=!0,e};return a.next=a}}return{next:O}}function O(){return{value:n,done:!0}}}("object"==typeof e?e:"object"==typeof window?window:"object"==typeof self?self:this)}).call(this,n(71))},function(t,e,n){n(371),t.exports=n(18).RegExp.escape},function(t,e,n){var r=n(0),i=n(372)(/[\\^$*+?.()|[\]{}]/g,"\\$&");r(r.S,"RegExp",{escape:function(t){return i(t)}})},function(t,e){t.exports=function(t,e){var n=e===Object(e)?function(t){return e[t]}:e;return function(e){return String(e).replace(t,n)}}}])});
//# sourceMappingURL=revieve-sdk.min.js.map

/***/ }),
/* 230 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AppConf__ = __webpack_require__(28);
function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}__webpack_require__(16);var ApiCom=function ApiCom(){var _this=this;_classCallCheck(this,ApiCom);this.getState=function(){return _this._state;};this.getPluginConfig=function(partner_id){var environment=arguments.length>1&&arguments[1]!==undefined?arguments[1]:__WEBPACK_IMPORTED_MODULE_0__AppConf__["b" /* default_environment */];return new Promise(function(resolve,reject){fetch(__WEBPACK_IMPORTED_MODULE_0__AppConf__["a" /* api_host */][environment||__WEBPACK_IMPORTED_MODULE_0__AppConf__["b" /* default_environment */]]+'/api/config/'+partner_id,{method:'GET',headers:{'Content-Type':'application/json','X-Parse-Application-Id':'Revieve API'}}).then(function(response){if(response.status<200||response.status>=300){reject(response.statusText);}return response.json();}).then(function(response){_this._state.config=response.config;resolve(response.config);}).catch(function(error){reject(error);});});};this._state={};};/* harmony default export */ __webpack_exports__["a"] = (ApiCom);

/***/ }),
/* 231 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = register;
/* unused harmony export unregister */
// In production, we register a service worker to serve assets from local cache.
// This lets the app load faster on subsequent visits in production, and gives
// it offline capabilities. However, it also means that developers (and users)
// will only see deployed updates on the "N+1" visit to a page, since previously
// cached resources are updated in the background.
// To learn more about the benefits of this model, read https://goo.gl/KwvDNy.
// This link also includes instructions on opting out of this behavior.
var isLocalhost=Boolean(window.location.hostname==='localhost'||// [::1] is the IPv6 localhost address.
window.location.hostname==='[::1]'||// 127.0.0.1/8 is considered localhost for IPv4.
window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/));function register(){if("production"==='production'&&'serviceWorker'in navigator){// The URL constructor is available in all browsers that support SW.
var publicUrl=new URL("",window.location);if(publicUrl.origin!==window.location.origin){// Our service worker won't work if PUBLIC_URL is on a different origin
// from what our page is served on. This might happen if a CDN is used to
// serve assets; see https://github.com/facebookincubator/create-react-app/issues/2374
return;}window.addEventListener('load',function(){var swUrl=""+'/service-worker.js';if(isLocalhost){// This is running on localhost. Lets check if a service worker still exists or not.
checkValidServiceWorker(swUrl);// Add some additional logging to localhost, pointing developers to the
// service worker/PWA documentation.
navigator.serviceWorker.ready.then(function(){console.log('This web app is being served cache-first by a service '+'worker. To learn more, visit https://goo.gl/SC7cgQ');});}else{// Is not local host. Just register service worker
registerValidSW(swUrl);}});}}function registerValidSW(swUrl){navigator.serviceWorker.register(swUrl).then(function(registration){registration.onupdatefound=function(){var installingWorker=registration.installing;installingWorker.onstatechange=function(){if(installingWorker.state==='installed'){if(navigator.serviceWorker.controller){// At this point, the old content will have been purged and
// the fresh content will have been added to the cache.
// It's the perfect time to display a "New content is
// available; please refresh." message in your web app.
console.log('New content is available; please refresh.');}else{// At this point, everything has been precached.
// It's the perfect time to display a
// "Content is cached for offline use." message.
console.log('Content is cached for offline use.');}}};};}).catch(function(error){console.error('Error during service worker registration:',error);});}function checkValidServiceWorker(swUrl){// Check if the service worker can be found. If it can't reload the page.
fetch(swUrl).then(function(response){// Ensure service worker exists, and that we really are getting a JS file.
if(response.status===404||response.headers.get('content-type').indexOf('javascript')===-1){// No service worker found. Probably a different app. Reload the page.
navigator.serviceWorker.ready.then(function(registration){registration.unregister().then(function(){window.location.reload();});});}else{// Service worker found. Proceed as normal.
registerValidSW(swUrl);}}).catch(function(){console.log('No internet connection found. App is running in offline mode.');});}function unregister(){if('serviceWorker'in navigator){navigator.serviceWorker.ready.then(function(registration){registration.unregister();});}}

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// static/js/main.js